var _defineProperty2 = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _classCallCheck2 = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _inherits2 = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _createSuper = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");
!function webpackUniversalModuleDefinition(e, i) {
  if ("object" === typeof exports && "object" === typeof module) module.exports = i(require("react"), require("@driftt/tide-core"), require("ramda"), require("@driftt/tide-icons"), require("react-dom"), require("@driftt/tide-selects"), require("@driftt/tide-file-upload"));else if ("function" === typeof define && define.amd) define(["react", "@driftt/tide-core", "ramda", "@driftt/tide-icons", "react-dom", "@driftt/tide-selects", "@driftt/tide-file-upload"], i);else {
    var t = "object" === typeof exports ? i(require("react"), require("@driftt/tide-core"), require("ramda"), require("@driftt/tide-icons"), require("react-dom"), require("@driftt/tide-selects"), require("@driftt/tide-file-upload")) : i(e.react, e["@driftt/tide-core"], e.ramda, e["@driftt/tide-icons"], e["react-dom"], e["@driftt/tide-selects"], e["@driftt/tide-file-upload"]);
    for (var a in t) {
      ("object" === typeof exports ? exports : e)[a] = t[a];
    }
  }
}(window, function (e, i, t, a, n, o, r) {
  return function (e) {
    var i = {};
    function __webpack_require__(t) {
      if (i[t]) return i[t].exports;
      var a = i[t] = {
        i: t,
        l: !1,
        exports: {}
      };
      return e[t].call(a.exports, a, a.exports, __webpack_require__), a.l = !0, a.exports;
    }
    return __webpack_require__.m = e, __webpack_require__.c = i, __webpack_require__.d = function (e, i, t) {
      __webpack_require__.o(e, i) || Object.defineProperty(e, i, {
        enumerable: !0,
        get: t
      });
    }, __webpack_require__.r = function (e) {
      "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, __webpack_require__.t = function (e, i) {
      if (1 & i && (e = __webpack_require__(e)), 8 & i) return e;
      if (4 & i && "object" === typeof e && e && e.__esModule) return e;
      var t = Object.create(null);
      if (__webpack_require__.r(t), Object.defineProperty(t, "default", {
        enumerable: !0,
        value: e
      }), 2 & i && "string" != typeof e) for (var a in e) {
        __webpack_require__.d(t, a, function (i) {
          return e[i];
        }.bind(null, a));
      }
      return t;
    }, __webpack_require__.n = function (e) {
      var i = e && e.__esModule ? function getDefault() {
        return e.default;
      } : function getModuleExports() {
        return e;
      };
      return __webpack_require__.d(i, "a", i), i;
    }, __webpack_require__.o = function (e, i) {
      return Object.prototype.hasOwnProperty.call(e, i);
    }, __webpack_require__.p = "/", __webpack_require__(__webpack_require__.s = 129);
  }([function (i, t) {
    i.exports = e;
  }, function (e, i, t) {
    e.exports = t(131)();
  }, function (e, i, t) {
    e.exports = function () {
      "use strict";

      var e = Array.prototype.slice;
      function createClass(e, i) {
        i && (e.prototype = Object.create(i.prototype)), e.prototype.constructor = e;
      }
      function Iterable(e) {
        return isIterable(e) ? e : Seq(e);
      }
      function KeyedIterable(e) {
        return isKeyed(e) ? e : KeyedSeq(e);
      }
      function IndexedIterable(e) {
        return isIndexed(e) ? e : IndexedSeq(e);
      }
      function SetIterable(e) {
        return isIterable(e) && !isAssociative(e) ? e : SetSeq(e);
      }
      function isIterable(e) {
        return !(!e || !e[i]);
      }
      function isKeyed(e) {
        return !(!e || !e[t]);
      }
      function isIndexed(e) {
        return !(!e || !e[a]);
      }
      function isAssociative(e) {
        return isKeyed(e) || isIndexed(e);
      }
      function isOrdered(e) {
        return !(!e || !e[n]);
      }
      createClass(KeyedIterable, Iterable), createClass(IndexedIterable, Iterable), createClass(SetIterable, Iterable), Iterable.isIterable = isIterable, Iterable.isKeyed = isKeyed, Iterable.isIndexed = isIndexed, Iterable.isAssociative = isAssociative, Iterable.isOrdered = isOrdered, Iterable.Keyed = KeyedIterable, Iterable.Indexed = IndexedIterable, Iterable.Set = SetIterable;
      var i = "@@__IMMUTABLE_ITERABLE__@@",
        t = "@@__IMMUTABLE_KEYED__@@",
        a = "@@__IMMUTABLE_INDEXED__@@",
        n = "@@__IMMUTABLE_ORDERED__@@",
        o = 5,
        r = 1 << o,
        s = r - 1,
        _ = {},
        l = {
          value: !1
        },
        g = {
          value: !1
        };
      function MakeRef(e) {
        return e.value = !1, e;
      }
      function SetRef(e) {
        e && (e.value = !0);
      }
      function OwnerID() {}
      function arrCopy(e, i) {
        i = i || 0;
        for (var t = Math.max(0, e.length - i), a = new Array(t), n = 0; n < t; n++) {
          a[n] = e[n + i];
        }
        return a;
      }
      function ensureSize(e) {
        return void 0 === e.size && (e.size = e.__iterate(returnTrue)), e.size;
      }
      function wrapIndex(e, i) {
        if ("number" !== typeof i) {
          var t = i >>> 0;
          if ("" + t !== i || 4294967295 === t) return NaN;
          i = t;
        }
        return i < 0 ? ensureSize(e) + i : i;
      }
      function returnTrue() {
        return !0;
      }
      function wholeSlice(e, i, t) {
        return (0 === e || void 0 !== t && e <= -t) && (void 0 === i || void 0 !== t && i >= t);
      }
      function resolveBegin(e, i) {
        return resolveIndex(e, i, 0);
      }
      function resolveEnd(e, i) {
        return resolveIndex(e, i, i);
      }
      function resolveIndex(e, i, t) {
        return void 0 === e ? t : e < 0 ? Math.max(0, i + e) : void 0 === i ? e : Math.min(i, e);
      }
      var f = 0,
        h = 1,
        d = 2,
        m = "function" === typeof Symbol && Symbol.iterator,
        u = "@@iterator",
        c = m || u;
      function Iterator(e) {
        this.next = e;
      }
      function iteratorValue(e, i, t, a) {
        var n = 0 === e ? i : 1 === e ? t : [i, t];
        return a ? a.value = n : a = {
          value: n,
          done: !1
        }, a;
      }
      function iteratorDone() {
        return {
          value: void 0,
          done: !0
        };
      }
      function hasIterator(e) {
        return !!getIteratorFn(e);
      }
      function isIterator(e) {
        return e && "function" === typeof e.next;
      }
      function getIterator(e) {
        var i = getIteratorFn(e);
        return i && i.call(e);
      }
      function getIteratorFn(e) {
        var i = e && (m && e[m] || e[u]);
        if ("function" === typeof i) return i;
      }
      function isArrayLike(e) {
        return e && "number" === typeof e.length;
      }
      function Seq(e) {
        return null === e || void 0 === e ? emptySequence() : isIterable(e) ? e.toSeq() : function seqFromValue(e) {
          var i = maybeIndexedSeqFromValue(e) || "object" === typeof e && new ObjectSeq(e);
          if (!i) throw new TypeError("Expected Array or iterable object of values, or keyed object: " + e);
          return i;
        }(e);
      }
      function KeyedSeq(e) {
        return null === e || void 0 === e ? emptySequence().toKeyedSeq() : isIterable(e) ? isKeyed(e) ? e.toSeq() : e.fromEntrySeq() : keyedSeqFromValue(e);
      }
      function IndexedSeq(e) {
        return null === e || void 0 === e ? emptySequence() : isIterable(e) ? isKeyed(e) ? e.entrySeq() : e.toIndexedSeq() : indexedSeqFromValue(e);
      }
      function SetSeq(e) {
        return (null === e || void 0 === e ? emptySequence() : isIterable(e) ? isKeyed(e) ? e.entrySeq() : e : indexedSeqFromValue(e)).toSetSeq();
      }
      Iterator.prototype.toString = function () {
        return "[Iterator]";
      }, Iterator.KEYS = f, Iterator.VALUES = h, Iterator.ENTRIES = d, Iterator.prototype.inspect = Iterator.prototype.toSource = function () {
        return this.toString();
      }, Iterator.prototype[c] = function () {
        return this;
      }, createClass(Seq, Iterable), Seq.of = function () {
        return Seq(arguments);
      }, Seq.prototype.toSeq = function () {
        return this;
      }, Seq.prototype.toString = function () {
        return this.__toString("Seq {", "}");
      }, Seq.prototype.cacheResult = function () {
        return !this._cache && this.__iterateUncached && (this._cache = this.entrySeq().toArray(), this.size = this._cache.length), this;
      }, Seq.prototype.__iterate = function (e, i) {
        return seqIterate(this, e, i, !0);
      }, Seq.prototype.__iterator = function (e, i) {
        return seqIterator(this, e, i, !0);
      }, createClass(KeyedSeq, Seq), KeyedSeq.prototype.toKeyedSeq = function () {
        return this;
      }, createClass(IndexedSeq, Seq), IndexedSeq.of = function () {
        return IndexedSeq(arguments);
      }, IndexedSeq.prototype.toIndexedSeq = function () {
        return this;
      }, IndexedSeq.prototype.toString = function () {
        return this.__toString("Seq [", "]");
      }, IndexedSeq.prototype.__iterate = function (e, i) {
        return seqIterate(this, e, i, !1);
      }, IndexedSeq.prototype.__iterator = function (e, i) {
        return seqIterator(this, e, i, !1);
      }, createClass(SetSeq, Seq), SetSeq.of = function () {
        return SetSeq(arguments);
      }, SetSeq.prototype.toSetSeq = function () {
        return this;
      }, Seq.isSeq = isSeq, Seq.Keyed = KeyedSeq, Seq.Set = SetSeq, Seq.Indexed = IndexedSeq;
      var F,
        p,
        b,
        y = "@@__IMMUTABLE_SEQ__@@";
      function ArraySeq(e) {
        this._array = e, this.size = e.length;
      }
      function ObjectSeq(e) {
        var i = Object.keys(e);
        this._object = e, this._keys = i, this.size = i.length;
      }
      function IterableSeq(e) {
        this._iterable = e, this.size = e.length || e.size;
      }
      function IteratorSeq(e) {
        this._iterator = e, this._iteratorCache = [];
      }
      function isSeq(e) {
        return !(!e || !e[y]);
      }
      function emptySequence() {
        return F || (F = new ArraySeq([]));
      }
      function keyedSeqFromValue(e) {
        var i = Array.isArray(e) ? new ArraySeq(e).fromEntrySeq() : isIterator(e) ? new IteratorSeq(e).fromEntrySeq() : hasIterator(e) ? new IterableSeq(e).fromEntrySeq() : "object" === typeof e ? new ObjectSeq(e) : void 0;
        if (!i) throw new TypeError("Expected Array or iterable object of [k, v] entries, or keyed object: " + e);
        return i;
      }
      function indexedSeqFromValue(e) {
        var i = maybeIndexedSeqFromValue(e);
        if (!i) throw new TypeError("Expected Array or iterable object of values: " + e);
        return i;
      }
      function maybeIndexedSeqFromValue(e) {
        return isArrayLike(e) ? new ArraySeq(e) : isIterator(e) ? new IteratorSeq(e) : hasIterator(e) ? new IterableSeq(e) : void 0;
      }
      function seqIterate(e, i, t, a) {
        var n = e._cache;
        if (n) {
          for (var o = n.length - 1, r = 0; r <= o; r++) {
            var s = n[t ? o - r : r];
            if (!1 === i(s[1], a ? s[0] : r, e)) return r + 1;
          }
          return r;
        }
        return e.__iterateUncached(i, t);
      }
      function seqIterator(e, i, t, a) {
        var n = e._cache;
        if (n) {
          var o = n.length - 1,
            r = 0;
          return new Iterator(function () {
            var e = n[t ? o - r : r];
            return r++ > o ? {
              value: void 0,
              done: !0
            } : iteratorValue(i, a ? e[0] : r - 1, e[1]);
          });
        }
        return e.__iteratorUncached(i, t);
      }
      function fromJS(e, i) {
        return i ? function fromJSWith(e, i, t, a) {
          return Array.isArray(i) ? e.call(a, t, IndexedSeq(i).map(function (t, a) {
            return fromJSWith(e, t, a, i);
          })) : isPlainObj(i) ? e.call(a, t, KeyedSeq(i).map(function (t, a) {
            return fromJSWith(e, t, a, i);
          })) : i;
        }(i, e, "", {
          "": e
        }) : fromJSDefault(e);
      }
      function fromJSDefault(e) {
        return Array.isArray(e) ? IndexedSeq(e).map(fromJSDefault).toList() : isPlainObj(e) ? KeyedSeq(e).map(fromJSDefault).toMap() : e;
      }
      function isPlainObj(e) {
        return e && (e.constructor === Object || void 0 === e.constructor);
      }
      function is(e, i) {
        if (e === i || e !== e && i !== i) return !0;
        if (!e || !i) return !1;
        if ("function" === typeof e.valueOf && "function" === typeof i.valueOf) {
          if (e = e.valueOf(), i = i.valueOf(), e === i || e !== e && i !== i) return !0;
          if (!e || !i) return !1;
        }
        return !("function" !== typeof e.equals || "function" !== typeof i.equals || !e.equals(i));
      }
      function deepEqual(e, i) {
        if (e === i) return !0;
        if (!isIterable(i) || void 0 !== e.size && void 0 !== i.size && e.size !== i.size || void 0 !== e.__hash && void 0 !== i.__hash && e.__hash !== i.__hash || isKeyed(e) !== isKeyed(i) || isIndexed(e) !== isIndexed(i) || isOrdered(e) !== isOrdered(i)) return !1;
        if (0 === e.size && 0 === i.size) return !0;
        var t = !isAssociative(e);
        if (isOrdered(e)) {
          var a = e.entries();
          return i.every(function (e, i) {
            var n = a.next().value;
            return n && is(n[1], e) && (t || is(n[0], i));
          }) && a.next().done;
        }
        var n = !1;
        if (void 0 === e.size) if (void 0 === i.size) "function" === typeof e.cacheResult && e.cacheResult();else {
          n = !0;
          var o = e;
          e = i, i = o;
        }
        var r = !0,
          s = i.__iterate(function (i, a) {
            if (t ? !e.has(i) : n ? !is(i, e.get(a, _)) : !is(e.get(a, _), i)) return r = !1, !1;
          });
        return r && e.size === s;
      }
      function Repeat(e, i) {
        if (!(this instanceof Repeat)) return new Repeat(e, i);
        if (this._value = e, this.size = void 0 === i ? 1 / 0 : Math.max(0, i), 0 === this.size) {
          if (p) return p;
          p = this;
        }
      }
      function invariant(e, i) {
        if (!e) throw new Error(i);
      }
      function Range(e, i, t) {
        if (!(this instanceof Range)) return new Range(e, i, t);
        if (invariant(0 !== t, "Cannot step a Range by 0"), e = e || 0, void 0 === i && (i = 1 / 0), t = void 0 === t ? 1 : Math.abs(t), i < e && (t = -t), this._start = e, this._end = i, this._step = t, this.size = Math.max(0, Math.ceil((i - e) / t - 1) + 1), 0 === this.size) {
          if (b) return b;
          b = this;
        }
      }
      function Collection() {
        throw TypeError("Abstract");
      }
      function KeyedCollection() {}
      function IndexedCollection() {}
      function SetCollection() {}
      Seq.prototype[y] = !0, createClass(ArraySeq, IndexedSeq), ArraySeq.prototype.get = function (e, i) {
        return this.has(e) ? this._array[wrapIndex(this, e)] : i;
      }, ArraySeq.prototype.__iterate = function (e, i) {
        for (var t = this._array, a = t.length - 1, n = 0; n <= a; n++) {
          if (!1 === e(t[i ? a - n : n], n, this)) return n + 1;
        }
        return n;
      }, ArraySeq.prototype.__iterator = function (e, i) {
        var t = this._array,
          a = t.length - 1,
          n = 0;
        return new Iterator(function () {
          return n > a ? {
            value: void 0,
            done: !0
          } : iteratorValue(e, n, t[i ? a - n++ : n++]);
        });
      }, createClass(ObjectSeq, KeyedSeq), ObjectSeq.prototype.get = function (e, i) {
        return void 0 === i || this.has(e) ? this._object[e] : i;
      }, ObjectSeq.prototype.has = function (e) {
        return this._object.hasOwnProperty(e);
      }, ObjectSeq.prototype.__iterate = function (e, i) {
        for (var t = this._object, a = this._keys, n = a.length - 1, o = 0; o <= n; o++) {
          var r = a[i ? n - o : o];
          if (!1 === e(t[r], r, this)) return o + 1;
        }
        return o;
      }, ObjectSeq.prototype.__iterator = function (e, i) {
        var t = this._object,
          a = this._keys,
          n = a.length - 1,
          o = 0;
        return new Iterator(function () {
          var r = a[i ? n - o : o];
          return o++ > n ? {
            value: void 0,
            done: !0
          } : iteratorValue(e, r, t[r]);
        });
      }, ObjectSeq.prototype[n] = !0, createClass(IterableSeq, IndexedSeq), IterableSeq.prototype.__iterateUncached = function (e, i) {
        if (i) return this.cacheResult().__iterate(e, i);
        var t = this._iterable,
          a = getIterator(t),
          n = 0;
        if (isIterator(a)) for (var o; !(o = a.next()).done && !1 !== e(o.value, n++, this);) {
          ;
        }
        return n;
      }, IterableSeq.prototype.__iteratorUncached = function (e, i) {
        if (i) return this.cacheResult().__iterator(e, i);
        var t = this._iterable,
          a = getIterator(t);
        if (!isIterator(a)) return new Iterator(iteratorDone);
        var n = 0;
        return new Iterator(function () {
          var i = a.next();
          return i.done ? i : iteratorValue(e, n++, i.value);
        });
      }, createClass(IteratorSeq, IndexedSeq), IteratorSeq.prototype.__iterateUncached = function (e, i) {
        if (i) return this.cacheResult().__iterate(e, i);
        for (var t, a = this._iterator, n = this._iteratorCache, o = 0; o < n.length;) {
          if (!1 === e(n[o], o++, this)) return o;
        }
        for (; !(t = a.next()).done;) {
          var r = t.value;
          if (n[o] = r, !1 === e(r, o++, this)) break;
        }
        return o;
      }, IteratorSeq.prototype.__iteratorUncached = function (e, i) {
        if (i) return this.cacheResult().__iterator(e, i);
        var t = this._iterator,
          a = this._iteratorCache,
          n = 0;
        return new Iterator(function () {
          if (n >= a.length) {
            var i = t.next();
            if (i.done) return i;
            a[n] = i.value;
          }
          return iteratorValue(e, n, a[n++]);
        });
      }, createClass(Repeat, IndexedSeq), Repeat.prototype.toString = function () {
        return 0 === this.size ? "Repeat []" : "Repeat [ " + this._value + " " + this.size + " times ]";
      }, Repeat.prototype.get = function (e, i) {
        return this.has(e) ? this._value : i;
      }, Repeat.prototype.includes = function (e) {
        return is(this._value, e);
      }, Repeat.prototype.slice = function (e, i) {
        var t = this.size;
        return wholeSlice(e, i, t) ? this : new Repeat(this._value, resolveEnd(i, t) - resolveBegin(e, t));
      }, Repeat.prototype.reverse = function () {
        return this;
      }, Repeat.prototype.indexOf = function (e) {
        return is(this._value, e) ? 0 : -1;
      }, Repeat.prototype.lastIndexOf = function (e) {
        return is(this._value, e) ? this.size : -1;
      }, Repeat.prototype.__iterate = function (e, i) {
        for (var t = 0; t < this.size; t++) {
          if (!1 === e(this._value, t, this)) return t + 1;
        }
        return t;
      }, Repeat.prototype.__iterator = function (e, i) {
        var t = this,
          a = 0;
        return new Iterator(function () {
          return a < t.size ? iteratorValue(e, a++, t._value) : {
            value: void 0,
            done: !0
          };
        });
      }, Repeat.prototype.equals = function (e) {
        return e instanceof Repeat ? is(this._value, e._value) : deepEqual(e);
      }, createClass(Range, IndexedSeq), Range.prototype.toString = function () {
        return 0 === this.size ? "Range []" : "Range [ " + this._start + "..." + this._end + (this._step > 1 ? " by " + this._step : "") + " ]";
      }, Range.prototype.get = function (e, i) {
        return this.has(e) ? this._start + wrapIndex(this, e) * this._step : i;
      }, Range.prototype.includes = function (e) {
        var i = (e - this._start) / this._step;
        return i >= 0 && i < this.size && i === Math.floor(i);
      }, Range.prototype.slice = function (e, i) {
        return wholeSlice(e, i, this.size) ? this : (e = resolveBegin(e, this.size), (i = resolveEnd(i, this.size)) <= e ? new Range(0, 0) : new Range(this.get(e, this._end), this.get(i, this._end), this._step));
      }, Range.prototype.indexOf = function (e) {
        var i = e - this._start;
        if (i % this._step === 0) {
          var t = i / this._step;
          if (t >= 0 && t < this.size) return t;
        }
        return -1;
      }, Range.prototype.lastIndexOf = function (e) {
        return this.indexOf(e);
      }, Range.prototype.__iterate = function (e, i) {
        for (var t = this.size - 1, a = this._step, n = i ? this._start + t * a : this._start, o = 0; o <= t; o++) {
          if (!1 === e(n, o, this)) return o + 1;
          n += i ? -a : a;
        }
        return o;
      }, Range.prototype.__iterator = function (e, i) {
        var t = this.size - 1,
          a = this._step,
          n = i ? this._start + t * a : this._start,
          o = 0;
        return new Iterator(function () {
          var r = n;
          return n += i ? -a : a, o > t ? {
            value: void 0,
            done: !0
          } : iteratorValue(e, o++, r);
        });
      }, Range.prototype.equals = function (e) {
        return e instanceof Range ? this._start === e._start && this._end === e._end && this._step === e._step : deepEqual(this, e);
      }, createClass(Collection, Iterable), createClass(KeyedCollection, Collection), createClass(IndexedCollection, Collection), createClass(SetCollection, Collection), Collection.Keyed = KeyedCollection, Collection.Indexed = IndexedCollection, Collection.Set = SetCollection;
      var k = "function" === typeof Math.imul && -2 === Math.imul(4294967295, 2) ? Math.imul : function imul(e, i) {
        var t = 65535 & (e |= 0),
          a = 65535 & (i |= 0);
        return t * a + ((e >>> 16) * a + t * (i >>> 16) << 16 >>> 0) | 0;
      };
      function smi(e) {
        return e >>> 1 & 1073741824 | 3221225471 & e;
      }
      function hash(e) {
        if (!1 === e || null === e || void 0 === e) return 0;
        if ("function" === typeof e.valueOf && (!1 === (e = e.valueOf()) || null === e || void 0 === e)) return 0;
        if (!0 === e) return 1;
        var i = typeof e;
        if ("number" === i) {
          var t = 0 | e;
          for (t !== e && (t ^= 4294967295 * e); e > 4294967295;) {
            t ^= e /= 4294967295;
          }
          return smi(t);
        }
        if ("string" === i) return e.length > C ? function cachedHashString(e) {
          var i = S[e];
          return void 0 === i && (i = hashString(e), B === D && (B = 0, S = {}), B++, S[e] = i), i;
        }(e) : hashString(e);
        if ("function" === typeof e.hashCode) return e.hashCode();
        if ("object" === i) return function hashJSObj(e) {
          var i;
          if (A && void 0 !== (i = v.get(e))) return i;
          if (void 0 !== (i = e[x])) return i;
          if (!E) {
            if (void 0 !== (i = e.propertyIsEnumerable && e.propertyIsEnumerable[x])) return i;
            if (void 0 !== (i = function getIENodeHash(e) {
              if (e && e.nodeType > 0) switch (e.nodeType) {
                case 1:
                  return e.uniqueID;
                case 9:
                  return e.documentElement && e.documentElement.uniqueID;
              }
            }(e))) return i;
          }
          if (i = ++j, 1073741824 & j && (j = 0), A) v.set(e, i);else {
            if (void 0 !== w && !1 === w(e)) throw new Error("Non-extensible objects are not allowed as keys.");
            if (E) Object.defineProperty(e, x, {
              enumerable: !1,
              configurable: !1,
              writable: !1,
              value: i
            });else if (void 0 !== e.propertyIsEnumerable && e.propertyIsEnumerable === e.constructor.prototype.propertyIsEnumerable) e.propertyIsEnumerable = function () {
              return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
            }, e.propertyIsEnumerable[x] = i;else {
              if (void 0 === e.nodeType) throw new Error("Unable to set a non-enumerable property on object.");
              e[x] = i;
            }
          }
          return i;
        }(e);
        if ("function" === typeof e.toString) return hashString(e.toString());
        throw new Error("Value type " + i + " cannot be hashed.");
      }
      function hashString(e) {
        for (var i = 0, t = 0; t < e.length; t++) {
          i = 31 * i + e.charCodeAt(t) | 0;
        }
        return smi(i);
      }
      var v,
        w = Object.isExtensible,
        E = function () {
          try {
            return Object.defineProperty({}, "@", {}), !0;
          } catch (e) {
            return !1;
          }
        }(),
        A = "function" === typeof WeakMap;
      A && (v = new WeakMap());
      var j = 0,
        x = "__immutablehash__";
      "function" === typeof Symbol && (x = Symbol(x));
      var C = 16,
        D = 255,
        B = 0,
        S = {};
      function assertNotInfinite(e) {
        invariant(e !== 1 / 0, "Cannot perform this action with an infinite size.");
      }
      function Map(e) {
        return null === e || void 0 === e ? emptyMap() : isMap(e) && !isOrdered(e) ? e : emptyMap().withMutations(function (i) {
          var t = KeyedIterable(e);
          assertNotInfinite(t.size), t.forEach(function (e, t) {
            return i.set(t, e);
          });
        });
      }
      function isMap(e) {
        return !(!e || !e[O]);
      }
      createClass(Map, KeyedCollection), Map.prototype.toString = function () {
        return this.__toString("Map {", "}");
      }, Map.prototype.get = function (e, i) {
        return this._root ? this._root.get(0, void 0, e, i) : i;
      }, Map.prototype.set = function (e, i) {
        return updateMap(this, e, i);
      }, Map.prototype.setIn = function (e, i) {
        return this.updateIn(e, _, function () {
          return i;
        });
      }, Map.prototype.remove = function (e) {
        return updateMap(this, e, _);
      }, Map.prototype.deleteIn = function (e) {
        return this.updateIn(e, function () {
          return _;
        });
      }, Map.prototype.update = function (e, i, t) {
        return 1 === arguments.length ? e(this) : this.updateIn([e], i, t);
      }, Map.prototype.updateIn = function (e, i, t) {
        t || (t = i, i = void 0);
        var a = function updateInDeepMap(e, i, t, a) {
          var n = e === _,
            o = i.next();
          if (o.done) {
            var r = n ? t : e,
              s = a(r);
            return s === r ? e : s;
          }
          invariant(n || e && e.set, "invalid keyPath");
          var l = o.value,
            g = n ? _ : e.get(l, _),
            f = updateInDeepMap(g, i, t, a);
          return f === g ? e : f === _ ? e.remove(l) : (n ? emptyMap() : e).set(l, f);
        }(this, forceIterator(e), i, t);
        return a === _ ? void 0 : a;
      }, Map.prototype.clear = function () {
        return 0 === this.size ? this : this.__ownerID ? (this.size = 0, this._root = null, this.__hash = void 0, this.__altered = !0, this) : emptyMap();
      }, Map.prototype.merge = function () {
        return mergeIntoMapWith(this, void 0, arguments);
      }, Map.prototype.mergeWith = function (i) {
        var t = e.call(arguments, 1);
        return mergeIntoMapWith(this, i, t);
      }, Map.prototype.mergeIn = function (i) {
        var t = e.call(arguments, 1);
        return this.updateIn(i, emptyMap(), function (e) {
          return "function" === typeof e.merge ? e.merge.apply(e, t) : t[t.length - 1];
        });
      }, Map.prototype.mergeDeep = function () {
        return mergeIntoMapWith(this, deepMerger, arguments);
      }, Map.prototype.mergeDeepWith = function (i) {
        var t = e.call(arguments, 1);
        return mergeIntoMapWith(this, deepMergerWith(i), t);
      }, Map.prototype.mergeDeepIn = function (i) {
        var t = e.call(arguments, 1);
        return this.updateIn(i, emptyMap(), function (e) {
          return "function" === typeof e.mergeDeep ? e.mergeDeep.apply(e, t) : t[t.length - 1];
        });
      }, Map.prototype.sort = function (e) {
        return OrderedMap(sortFactory(this, e));
      }, Map.prototype.sortBy = function (e, i) {
        return OrderedMap(sortFactory(this, i, e));
      }, Map.prototype.withMutations = function (e) {
        var i = this.asMutable();
        return e(i), i.wasAltered() ? i.__ensureOwner(this.__ownerID) : this;
      }, Map.prototype.asMutable = function () {
        return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
      }, Map.prototype.asImmutable = function () {
        return this.__ensureOwner();
      }, Map.prototype.wasAltered = function () {
        return this.__altered;
      }, Map.prototype.__iterator = function (e, i) {
        return new MapIterator(this, e, i);
      }, Map.prototype.__iterate = function (e, i) {
        var t = this,
          a = 0;
        return this._root && this._root.iterate(function (i) {
          return a++, e(i[1], i[0], t);
        }, i), a;
      }, Map.prototype.__ensureOwner = function (e) {
        return e === this.__ownerID ? this : e ? makeMap(this.size, this._root, e, this.__hash) : (this.__ownerID = e, this.__altered = !1, this);
      }, Map.isMap = isMap;
      var q,
        O = "@@__IMMUTABLE_MAP__@@",
        T = Map.prototype;
      function ArrayMapNode(e, i) {
        this.ownerID = e, this.entries = i;
      }
      function BitmapIndexedNode(e, i, t) {
        this.ownerID = e, this.bitmap = i, this.nodes = t;
      }
      function HashArrayMapNode(e, i, t) {
        this.ownerID = e, this.count = i, this.nodes = t;
      }
      function HashCollisionNode(e, i, t) {
        this.ownerID = e, this.keyHash = i, this.entries = t;
      }
      function ValueNode(e, i, t) {
        this.ownerID = e, this.keyHash = i, this.entry = t;
      }
      function MapIterator(e, i, t) {
        this._type = i, this._reverse = t, this._stack = e._root && mapIteratorFrame(e._root);
      }
      function mapIteratorValue(e, i) {
        return iteratorValue(e, i[0], i[1]);
      }
      function mapIteratorFrame(e, i) {
        return {
          node: e,
          index: 0,
          __prev: i
        };
      }
      function makeMap(e, i, t, a) {
        var n = Object.create(T);
        return n.size = e, n._root = i, n.__ownerID = t, n.__hash = a, n.__altered = !1, n;
      }
      function emptyMap() {
        return q || (q = makeMap(0));
      }
      function updateMap(e, i, t) {
        var a, n;
        if (e._root) {
          var o = MakeRef(l),
            r = MakeRef(g);
          if (a = updateNode(e._root, e.__ownerID, 0, void 0, i, t, o, r), !r.value) return e;
          n = e.size + (o.value ? t === _ ? -1 : 1 : 0);
        } else {
          if (t === _) return e;
          n = 1, a = new ArrayMapNode(e.__ownerID, [[i, t]]);
        }
        return e.__ownerID ? (e.size = n, e._root = a, e.__hash = void 0, e.__altered = !0, e) : a ? makeMap(n, a) : emptyMap();
      }
      function updateNode(e, i, t, a, n, o, r, s) {
        return e ? e.update(i, t, a, n, o, r, s) : o === _ ? e : (SetRef(s), SetRef(r), new ValueNode(i, a, [n, o]));
      }
      function isLeafNode(e) {
        return e.constructor === ValueNode || e.constructor === HashCollisionNode;
      }
      function mergeIntoNode(e, i, t, a, n) {
        if (e.keyHash === a) return new HashCollisionNode(i, a, [e.entry, n]);
        var r,
          _ = (0 === t ? e.keyHash : e.keyHash >>> t) & s,
          l = (0 === t ? a : a >>> t) & s,
          g = _ === l ? [mergeIntoNode(e, i, t + o, a, n)] : (r = new ValueNode(i, a, n), _ < l ? [e, r] : [r, e]);
        return new BitmapIndexedNode(i, 1 << _ | 1 << l, g);
      }
      function mergeIntoMapWith(e, i, t) {
        for (var a = [], n = 0; n < t.length; n++) {
          var o = t[n],
            r = KeyedIterable(o);
          isIterable(o) || (r = r.map(function (e) {
            return fromJS(e);
          })), a.push(r);
        }
        return mergeIntoCollectionWith(e, i, a);
      }
      function deepMerger(e, i, t) {
        return e && e.mergeDeep && isIterable(i) ? e.mergeDeep(i) : is(e, i) ? e : i;
      }
      function deepMergerWith(e) {
        return function (i, t, a) {
          if (i && i.mergeDeepWith && isIterable(t)) return i.mergeDeepWith(e, t);
          var n = e(i, t, a);
          return is(i, n) ? i : n;
        };
      }
      function mergeIntoCollectionWith(e, i, t) {
        return 0 === (t = t.filter(function (e) {
          return 0 !== e.size;
        })).length ? e : 0 !== e.size || e.__ownerID || 1 !== t.length ? e.withMutations(function (e) {
          for (var a = i ? function (t, a) {
              e.update(a, _, function (e) {
                return e === _ ? t : i(e, t, a);
              });
            } : function (i, t) {
              e.set(t, i);
            }, n = 0; n < t.length; n++) {
            t[n].forEach(a);
          }
        }) : e.constructor(t[0]);
      }
      function popCount(e) {
        return e = (e = (858993459 & (e -= e >> 1 & 1431655765)) + (e >> 2 & 858993459)) + (e >> 4) & 252645135, e += e >> 8, 127 & (e += e >> 16);
      }
      function setIn(e, i, t, a) {
        var n = a ? e : arrCopy(e);
        return n[i] = t, n;
      }
      T[O] = !0, T.delete = T.remove, T.removeIn = T.deleteIn, ArrayMapNode.prototype.get = function (e, i, t, a) {
        for (var n = this.entries, o = 0, r = n.length; o < r; o++) {
          if (is(t, n[o][0])) return n[o][1];
        }
        return a;
      }, ArrayMapNode.prototype.update = function (e, i, t, a, n, o, r) {
        for (var s = n === _, l = this.entries, g = 0, f = l.length; g < f && !is(a, l[g][0]); g++) {
          ;
        }
        var h = g < f;
        if (h ? l[g][1] === n : s) return this;
        if (SetRef(r), (s || !h) && SetRef(o), !s || 1 !== l.length) {
          if (!h && !s && l.length >= N) return function createNodes(e, i, t, a) {
            e || (e = new OwnerID());
            for (var n = new ValueNode(e, hash(t), [t, a]), o = 0; o < i.length; o++) {
              var r = i[o];
              n = n.update(e, 0, void 0, r[0], r[1]);
            }
            return n;
          }(e, l, a, n);
          var d = e && e === this.ownerID,
            m = d ? l : arrCopy(l);
          return h ? s ? g === f - 1 ? m.pop() : m[g] = m.pop() : m[g] = [a, n] : m.push([a, n]), d ? (this.entries = m, this) : new ArrayMapNode(e, m);
        }
      }, BitmapIndexedNode.prototype.get = function (e, i, t, a) {
        void 0 === i && (i = hash(t));
        var n = 1 << ((0 === e ? i : i >>> e) & s),
          r = this.bitmap;
        return 0 === (r & n) ? a : this.nodes[popCount(r & n - 1)].get(e + o, i, t, a);
      }, BitmapIndexedNode.prototype.update = function (e, i, t, a, n, l, g) {
        void 0 === t && (t = hash(a));
        var f = (0 === i ? t : t >>> i) & s,
          h = 1 << f,
          d = this.bitmap,
          m = 0 !== (d & h);
        if (!m && n === _) return this;
        var u = popCount(d & h - 1),
          c = this.nodes,
          F = m ? c[u] : void 0,
          p = updateNode(F, e, i + o, t, a, n, l, g);
        if (p === F) return this;
        if (!m && p && c.length >= I) return function expandNodes(e, i, t, a, n) {
          for (var o = 0, s = new Array(r), _ = 0; 0 !== t; _++, t >>>= 1) {
            s[_] = 1 & t ? i[o++] : void 0;
          }
          return s[a] = n, new HashArrayMapNode(e, o + 1, s);
        }(e, c, d, f, p);
        if (m && !p && 2 === c.length && isLeafNode(c[1 ^ u])) return c[1 ^ u];
        if (m && p && 1 === c.length && isLeafNode(p)) return p;
        var b = e && e === this.ownerID,
          y = m ? p ? d : d ^ h : d | h,
          k = m ? p ? setIn(c, u, p, b) : function spliceOut(e, i, t) {
            var a = e.length - 1;
            if (t && i === a) return e.pop(), e;
            for (var n = new Array(a), o = 0, r = 0; r < a; r++) {
              r === i && (o = 1), n[r] = e[r + o];
            }
            return n;
          }(c, u, b) : function spliceIn(e, i, t, a) {
            var n = e.length + 1;
            if (a && i + 1 === n) return e[i] = t, e;
            for (var o = new Array(n), r = 0, s = 0; s < n; s++) {
              s === i ? (o[s] = t, r = -1) : o[s] = e[s + r];
            }
            return o;
          }(c, u, p, b);
        return b ? (this.bitmap = y, this.nodes = k, this) : new BitmapIndexedNode(e, y, k);
      }, HashArrayMapNode.prototype.get = function (e, i, t, a) {
        void 0 === i && (i = hash(t));
        var n = (0 === e ? i : i >>> e) & s,
          r = this.nodes[n];
        return r ? r.get(e + o, i, t, a) : a;
      }, HashArrayMapNode.prototype.update = function (e, i, t, a, n, r, l) {
        void 0 === t && (t = hash(a));
        var g = (0 === i ? t : t >>> i) & s,
          f = n === _,
          h = this.nodes,
          d = h[g];
        if (f && !d) return this;
        var m = updateNode(d, e, i + o, t, a, n, r, l);
        if (m === d) return this;
        var u = this.count;
        if (d) {
          if (!m && --u < P) return function packNodes(e, i, t, a) {
            for (var n = 0, o = 0, r = new Array(t), s = 0, _ = 1, l = i.length; s < l; s++, _ <<= 1) {
              var g = i[s];
              void 0 !== g && s !== a && (n |= _, r[o++] = g);
            }
            return new BitmapIndexedNode(e, n, r);
          }(e, h, u, g);
        } else u++;
        var c = e && e === this.ownerID,
          F = setIn(h, g, m, c);
        return c ? (this.count = u, this.nodes = F, this) : new HashArrayMapNode(e, u, F);
      }, HashCollisionNode.prototype.get = function (e, i, t, a) {
        for (var n = this.entries, o = 0, r = n.length; o < r; o++) {
          if (is(t, n[o][0])) return n[o][1];
        }
        return a;
      }, HashCollisionNode.prototype.update = function (e, i, t, a, n, o, r) {
        void 0 === t && (t = hash(a));
        var s = n === _;
        if (t !== this.keyHash) return s ? this : (SetRef(r), SetRef(o), mergeIntoNode(this, e, i, t, [a, n]));
        for (var l = this.entries, g = 0, f = l.length; g < f && !is(a, l[g][0]); g++) {
          ;
        }
        var h = g < f;
        if (h ? l[g][1] === n : s) return this;
        if (SetRef(r), (s || !h) && SetRef(o), s && 2 === f) return new ValueNode(e, this.keyHash, l[1 ^ g]);
        var d = e && e === this.ownerID,
          m = d ? l : arrCopy(l);
        return h ? s ? g === f - 1 ? m.pop() : m[g] = m.pop() : m[g] = [a, n] : m.push([a, n]), d ? (this.entries = m, this) : new HashCollisionNode(e, this.keyHash, m);
      }, ValueNode.prototype.get = function (e, i, t, a) {
        return is(t, this.entry[0]) ? this.entry[1] : a;
      }, ValueNode.prototype.update = function (e, i, t, a, n, o, r) {
        var s = n === _,
          l = is(a, this.entry[0]);
        return (l ? n === this.entry[1] : s) ? this : (SetRef(r), s ? void SetRef(o) : l ? e && e === this.ownerID ? (this.entry[1] = n, this) : new ValueNode(e, this.keyHash, [a, n]) : (SetRef(o), mergeIntoNode(this, e, i, hash(a), [a, n])));
      }, ArrayMapNode.prototype.iterate = HashCollisionNode.prototype.iterate = function (e, i) {
        for (var t = this.entries, a = 0, n = t.length - 1; a <= n; a++) {
          if (!1 === e(t[i ? n - a : a])) return !1;
        }
      }, BitmapIndexedNode.prototype.iterate = HashArrayMapNode.prototype.iterate = function (e, i) {
        for (var t = this.nodes, a = 0, n = t.length - 1; a <= n; a++) {
          var o = t[i ? n - a : a];
          if (o && !1 === o.iterate(e, i)) return !1;
        }
      }, ValueNode.prototype.iterate = function (e, i) {
        return e(this.entry);
      }, createClass(MapIterator, Iterator), MapIterator.prototype.next = function () {
        for (var e = this._type, i = this._stack; i;) {
          var t,
            a = i.node,
            n = i.index++;
          if (a.entry) {
            if (0 === n) return mapIteratorValue(e, a.entry);
          } else if (a.entries) {
            if (t = a.entries.length - 1, n <= t) return mapIteratorValue(e, a.entries[this._reverse ? t - n : n]);
          } else if (t = a.nodes.length - 1, n <= t) {
            var o = a.nodes[this._reverse ? t - n : n];
            if (o) {
              if (o.entry) return mapIteratorValue(e, o.entry);
              i = this._stack = mapIteratorFrame(o, i);
            }
            continue;
          }
          i = this._stack = this._stack.__prev;
        }
        return {
          value: void 0,
          done: !0
        };
      };
      var N = r / 4,
        I = r / 2,
        P = r / 4;
      function List(e) {
        var i = emptyList();
        if (null === e || void 0 === e) return i;
        if (isList(e)) return e;
        var t = IndexedIterable(e),
          a = t.size;
        return 0 === a ? i : (assertNotInfinite(a), a > 0 && a < r ? makeList(0, a, o, null, new VNode(t.toArray())) : i.withMutations(function (e) {
          e.setSize(a), t.forEach(function (i, t) {
            return e.set(t, i);
          });
        }));
      }
      function isList(e) {
        return !(!e || !e[M]);
      }
      createClass(List, IndexedCollection), List.of = function () {
        return this(arguments);
      }, List.prototype.toString = function () {
        return this.__toString("List [", "]");
      }, List.prototype.get = function (e, i) {
        if ((e = wrapIndex(this, e)) >= 0 && e < this.size) {
          var t = listNodeFor(this, e += this._origin);
          return t && t.array[e & s];
        }
        return i;
      }, List.prototype.set = function (e, i) {
        return function updateList(e, i, t) {
          if ((i = wrapIndex(e, i)) !== i) return e;
          if (i >= e.size || i < 0) return e.withMutations(function (e) {
            i < 0 ? setListBounds(e, i).set(0, t) : setListBounds(e, 0, i + 1).set(i, t);
          });
          i += e._origin;
          var a = e._tail,
            n = e._root,
            o = MakeRef(g);
          return i >= getTailOffset(e._capacity) ? a = updateVNode(a, e.__ownerID, 0, i, t, o) : n = updateVNode(n, e.__ownerID, e._level, i, t, o), o.value ? e.__ownerID ? (e._root = n, e._tail = a, e.__hash = void 0, e.__altered = !0, e) : makeList(e._origin, e._capacity, e._level, n, a) : e;
        }(this, e, i);
      }, List.prototype.remove = function (e) {
        return this.has(e) ? 0 === e ? this.shift() : e === this.size - 1 ? this.pop() : this.splice(e, 1) : this;
      }, List.prototype.insert = function (e, i) {
        return this.splice(e, 0, i);
      }, List.prototype.clear = function () {
        return 0 === this.size ? this : this.__ownerID ? (this.size = this._origin = this._capacity = 0, this._level = o, this._root = this._tail = null, this.__hash = void 0, this.__altered = !0, this) : emptyList();
      }, List.prototype.push = function () {
        var e = arguments,
          i = this.size;
        return this.withMutations(function (t) {
          setListBounds(t, 0, i + e.length);
          for (var a = 0; a < e.length; a++) {
            t.set(i + a, e[a]);
          }
        });
      }, List.prototype.pop = function () {
        return setListBounds(this, 0, -1);
      }, List.prototype.unshift = function () {
        var e = arguments;
        return this.withMutations(function (i) {
          setListBounds(i, -e.length);
          for (var t = 0; t < e.length; t++) {
            i.set(t, e[t]);
          }
        });
      }, List.prototype.shift = function () {
        return setListBounds(this, 1);
      }, List.prototype.merge = function () {
        return mergeIntoListWith(this, void 0, arguments);
      }, List.prototype.mergeWith = function (i) {
        var t = e.call(arguments, 1);
        return mergeIntoListWith(this, i, t);
      }, List.prototype.mergeDeep = function () {
        return mergeIntoListWith(this, deepMerger, arguments);
      }, List.prototype.mergeDeepWith = function (i) {
        var t = e.call(arguments, 1);
        return mergeIntoListWith(this, deepMergerWith(i), t);
      }, List.prototype.setSize = function (e) {
        return setListBounds(this, 0, e);
      }, List.prototype.slice = function (e, i) {
        var t = this.size;
        return wholeSlice(e, i, t) ? this : setListBounds(this, resolveBegin(e, t), resolveEnd(i, t));
      }, List.prototype.__iterator = function (e, i) {
        var t = 0,
          a = iterateList(this, i);
        return new Iterator(function () {
          var i = a();
          return i === W ? {
            value: void 0,
            done: !0
          } : iteratorValue(e, t++, i);
        });
      }, List.prototype.__iterate = function (e, i) {
        for (var t, a = 0, n = iterateList(this, i); (t = n()) !== W && !1 !== e(t, a++, this);) {
          ;
        }
        return a;
      }, List.prototype.__ensureOwner = function (e) {
        return e === this.__ownerID ? this : e ? makeList(this._origin, this._capacity, this._level, this._root, this._tail, e, this.__hash) : (this.__ownerID = e, this);
      }, List.isList = isList;
      var M = "@@__IMMUTABLE_LIST__@@",
        R = List.prototype;
      function VNode(e, i) {
        this.array = e, this.ownerID = i;
      }
      R[M] = !0, R.delete = R.remove, R.setIn = T.setIn, R.deleteIn = R.removeIn = T.removeIn, R.update = T.update, R.updateIn = T.updateIn, R.mergeIn = T.mergeIn, R.mergeDeepIn = T.mergeDeepIn, R.withMutations = T.withMutations, R.asMutable = T.asMutable, R.asImmutable = T.asImmutable, R.wasAltered = T.wasAltered, VNode.prototype.removeBefore = function (e, i, t) {
        if (t === i ? 1 << i : 0 === this.array.length) return this;
        var a = t >>> i & s;
        if (a >= this.array.length) return new VNode([], e);
        var n,
          r = 0 === a;
        if (i > 0) {
          var _ = this.array[a];
          if ((n = _ && _.removeBefore(e, i - o, t)) === _ && r) return this;
        }
        if (r && !n) return this;
        var l = editableVNode(this, e);
        if (!r) for (var g = 0; g < a; g++) {
          l.array[g] = void 0;
        }
        return n && (l.array[a] = n), l;
      }, VNode.prototype.removeAfter = function (e, i, t) {
        if (t === (i ? 1 << i : 0) || 0 === this.array.length) return this;
        var a,
          n = t - 1 >>> i & s;
        if (n >= this.array.length) return this;
        if (i > 0) {
          var r = this.array[n];
          if ((a = r && r.removeAfter(e, i - o, t)) === r && n === this.array.length - 1) return this;
        }
        var _ = editableVNode(this, e);
        return _.array.splice(n + 1), a && (_.array[n] = a), _;
      };
      var z,
        L,
        W = {};
      function iterateList(e, i) {
        var t = e._origin,
          a = e._capacity,
          n = getTailOffset(a),
          s = e._tail;
        return iterateNodeOrLeaf(e._root, e._level, 0);
        function iterateNodeOrLeaf(e, _, l) {
          return 0 === _ ? function iterateLeaf(e, o) {
            var _ = o === n ? s && s.array : e && e.array,
              l = o > t ? 0 : t - o,
              g = a - o;
            return g > r && (g = r), function () {
              if (l === g) return W;
              var e = i ? --g : l++;
              return _ && _[e];
            };
          }(e, l) : function iterateNode(e, n, s) {
            var _,
              l = e && e.array,
              g = s > t ? 0 : t - s >> n,
              f = 1 + (a - s >> n);
            return f > r && (f = r), function () {
              for (;;) {
                if (_) {
                  var e = _();
                  if (e !== W) return e;
                  _ = null;
                }
                if (g === f) return W;
                var t = i ? --f : g++;
                _ = iterateNodeOrLeaf(l && l[t], n - o, s + (t << n));
              }
            };
          }(e, _, l);
        }
      }
      function makeList(e, i, t, a, n, o, r) {
        var s = Object.create(R);
        return s.size = i - e, s._origin = e, s._capacity = i, s._level = t, s._root = a, s._tail = n, s.__ownerID = o, s.__hash = r, s.__altered = !1, s;
      }
      function emptyList() {
        return z || (z = makeList(0, 0, o));
      }
      function updateVNode(e, i, t, a, n, r) {
        var _,
          l = a >>> t & s,
          g = e && l < e.array.length;
        if (!g && void 0 === n) return e;
        if (t > 0) {
          var f = e && e.array[l],
            h = updateVNode(f, i, t - o, a, n, r);
          return h === f ? e : ((_ = editableVNode(e, i)).array[l] = h, _);
        }
        return g && e.array[l] === n ? e : (SetRef(r), _ = editableVNode(e, i), void 0 === n && l === _.array.length - 1 ? _.array.pop() : _.array[l] = n, _);
      }
      function editableVNode(e, i) {
        return i && e && i === e.ownerID ? e : new VNode(e ? e.array.slice() : [], i);
      }
      function listNodeFor(e, i) {
        if (i >= getTailOffset(e._capacity)) return e._tail;
        if (i < 1 << e._level + o) {
          for (var t = e._root, a = e._level; t && a > 0;) {
            t = t.array[i >>> a & s], a -= o;
          }
          return t;
        }
      }
      function setListBounds(e, i, t) {
        void 0 !== i && (i |= 0), void 0 !== t && (t |= 0);
        var a = e.__ownerID || new OwnerID(),
          n = e._origin,
          r = e._capacity,
          _ = n + i,
          l = void 0 === t ? r : t < 0 ? r + t : n + t;
        if (_ === n && l === r) return e;
        if (_ >= l) return e.clear();
        for (var g = e._level, f = e._root, h = 0; _ + h < 0;) {
          f = new VNode(f && f.array.length ? [void 0, f] : [], a), h += 1 << (g += o);
        }
        h && (_ += h, n += h, l += h, r += h);
        for (var d = getTailOffset(r), m = getTailOffset(l); m >= 1 << g + o;) {
          f = new VNode(f && f.array.length ? [f] : [], a), g += o;
        }
        var u = e._tail,
          c = m < d ? listNodeFor(e, l - 1) : m > d ? new VNode([], a) : u;
        if (u && m > d && _ < r && u.array.length) {
          for (var F = f = editableVNode(f, a), p = g; p > o; p -= o) {
            var b = d >>> p & s;
            F = F.array[b] = editableVNode(F.array[b], a);
          }
          F.array[d >>> o & s] = u;
        }
        if (l < r && (c = c && c.removeAfter(a, 0, l)), _ >= m) _ -= m, l -= m, g = o, f = null, c = c && c.removeBefore(a, 0, _);else if (_ > n || m < d) {
          for (h = 0; f;) {
            var y = _ >>> g & s;
            if (y !== m >>> g & s) break;
            y && (h += (1 << g) * y), g -= o, f = f.array[y];
          }
          f && _ > n && (f = f.removeBefore(a, g, _ - h)), f && m < d && (f = f.removeAfter(a, g, m - h)), h && (_ -= h, l -= h);
        }
        return e.__ownerID ? (e.size = l - _, e._origin = _, e._capacity = l, e._level = g, e._root = f, e._tail = c, e.__hash = void 0, e.__altered = !0, e) : makeList(_, l, g, f, c);
      }
      function mergeIntoListWith(e, i, t) {
        for (var a = [], n = 0, o = 0; o < t.length; o++) {
          var r = t[o],
            s = IndexedIterable(r);
          s.size > n && (n = s.size), isIterable(r) || (s = s.map(function (e) {
            return fromJS(e);
          })), a.push(s);
        }
        return n > e.size && (e = e.setSize(n)), mergeIntoCollectionWith(e, i, a);
      }
      function getTailOffset(e) {
        return e < r ? 0 : e - 1 >>> o << o;
      }
      function OrderedMap(e) {
        return null === e || void 0 === e ? emptyOrderedMap() : isOrderedMap(e) ? e : emptyOrderedMap().withMutations(function (i) {
          var t = KeyedIterable(e);
          assertNotInfinite(t.size), t.forEach(function (e, t) {
            return i.set(t, e);
          });
        });
      }
      function isOrderedMap(e) {
        return isMap(e) && isOrdered(e);
      }
      function makeOrderedMap(e, i, t, a) {
        var n = Object.create(OrderedMap.prototype);
        return n.size = e ? e.size : 0, n._map = e, n._list = i, n.__ownerID = t, n.__hash = a, n;
      }
      function emptyOrderedMap() {
        return L || (L = makeOrderedMap(emptyMap(), emptyList()));
      }
      function updateOrderedMap(e, i, t) {
        var a,
          n,
          o = e._map,
          s = e._list,
          l = o.get(i),
          g = void 0 !== l;
        if (t === _) {
          if (!g) return e;
          s.size >= r && s.size >= 2 * o.size ? (n = s.filter(function (e, i) {
            return void 0 !== e && l !== i;
          }), a = n.toKeyedSeq().map(function (e) {
            return e[0];
          }).flip().toMap(), e.__ownerID && (a.__ownerID = n.__ownerID = e.__ownerID)) : (a = o.remove(i), n = l === s.size - 1 ? s.pop() : s.set(l, void 0));
        } else if (g) {
          if (t === s.get(l)[1]) return e;
          a = o, n = s.set(l, [i, t]);
        } else a = o.set(i, s.size), n = s.set(s.size, [i, t]);
        return e.__ownerID ? (e.size = a.size, e._map = a, e._list = n, e.__hash = void 0, e) : makeOrderedMap(a, n);
      }
      function ToKeyedSequence(e, i) {
        this._iter = e, this._useKeys = i, this.size = e.size;
      }
      function ToIndexedSequence(e) {
        this._iter = e, this.size = e.size;
      }
      function ToSetSequence(e) {
        this._iter = e, this.size = e.size;
      }
      function FromEntriesSequence(e) {
        this._iter = e, this.size = e.size;
      }
      function flipFactory(e) {
        var i = makeSequence(e);
        return i._iter = e, i.size = e.size, i.flip = function () {
          return e;
        }, i.reverse = function () {
          var i = e.reverse.apply(this);
          return i.flip = function () {
            return e.reverse();
          }, i;
        }, i.has = function (i) {
          return e.includes(i);
        }, i.includes = function (i) {
          return e.has(i);
        }, i.cacheResult = cacheResultThrough, i.__iterateUncached = function (i, t) {
          var a = this;
          return e.__iterate(function (e, t) {
            return !1 !== i(t, e, a);
          }, t);
        }, i.__iteratorUncached = function (i, t) {
          if (i === d) {
            var a = e.__iterator(i, t);
            return new Iterator(function () {
              var e = a.next();
              if (!e.done) {
                var i = e.value[0];
                e.value[0] = e.value[1], e.value[1] = i;
              }
              return e;
            });
          }
          return e.__iterator(i === h ? f : h, t);
        }, i;
      }
      function mapFactory(e, i, t) {
        var a = makeSequence(e);
        return a.size = e.size, a.has = function (i) {
          return e.has(i);
        }, a.get = function (a, n) {
          var o = e.get(a, _);
          return o === _ ? n : i.call(t, o, a, e);
        }, a.__iterateUncached = function (a, n) {
          var o = this;
          return e.__iterate(function (e, n, r) {
            return !1 !== a(i.call(t, e, n, r), n, o);
          }, n);
        }, a.__iteratorUncached = function (a, n) {
          var o = e.__iterator(d, n);
          return new Iterator(function () {
            var n = o.next();
            if (n.done) return n;
            var r = n.value,
              s = r[0];
            return iteratorValue(a, s, i.call(t, r[1], s, e), n);
          });
        }, a;
      }
      function reverseFactory(e, i) {
        var t = makeSequence(e);
        return t._iter = e, t.size = e.size, t.reverse = function () {
          return e;
        }, e.flip && (t.flip = function () {
          var i = flipFactory(e);
          return i.reverse = function () {
            return e.flip();
          }, i;
        }), t.get = function (t, a) {
          return e.get(i ? t : -1 - t, a);
        }, t.has = function (t) {
          return e.has(i ? t : -1 - t);
        }, t.includes = function (i) {
          return e.includes(i);
        }, t.cacheResult = cacheResultThrough, t.__iterate = function (i, t) {
          var a = this;
          return e.__iterate(function (e, t) {
            return i(e, t, a);
          }, !t);
        }, t.__iterator = function (i, t) {
          return e.__iterator(i, !t);
        }, t;
      }
      function filterFactory(e, i, t, a) {
        var n = makeSequence(e);
        return a && (n.has = function (a) {
          var n = e.get(a, _);
          return n !== _ && !!i.call(t, n, a, e);
        }, n.get = function (a, n) {
          var o = e.get(a, _);
          return o !== _ && i.call(t, o, a, e) ? o : n;
        }), n.__iterateUncached = function (n, o) {
          var r = this,
            s = 0;
          return e.__iterate(function (e, o, _) {
            if (i.call(t, e, o, _)) return s++, n(e, a ? o : s - 1, r);
          }, o), s;
        }, n.__iteratorUncached = function (n, o) {
          var r = e.__iterator(d, o),
            s = 0;
          return new Iterator(function () {
            for (;;) {
              var o = r.next();
              if (o.done) return o;
              var _ = o.value,
                l = _[0],
                g = _[1];
              if (i.call(t, g, l, e)) return iteratorValue(n, a ? l : s++, g, o);
            }
          });
        }, n;
      }
      function sliceFactory(e, i, t, a) {
        var n = e.size;
        if (void 0 !== i && (i |= 0), void 0 !== t && (t |= 0), wholeSlice(i, t, n)) return e;
        var o = resolveBegin(i, n),
          r = resolveEnd(t, n);
        if (o !== o || r !== r) return sliceFactory(e.toSeq().cacheResult(), i, t, a);
        var s,
          _ = r - o;
        _ === _ && (s = _ < 0 ? 0 : _);
        var l = makeSequence(e);
        return l.size = 0 === s ? s : e.size && s || void 0, !a && isSeq(e) && s >= 0 && (l.get = function (i, t) {
          return (i = wrapIndex(this, i)) >= 0 && i < s ? e.get(i + o, t) : t;
        }), l.__iterateUncached = function (i, t) {
          var n = this;
          if (0 === s) return 0;
          if (t) return this.cacheResult().__iterate(i, t);
          var r = 0,
            _ = !0,
            l = 0;
          return e.__iterate(function (e, t) {
            if (!_ || !(_ = r++ < o)) return l++, !1 !== i(e, a ? t : l - 1, n) && l !== s;
          }), l;
        }, l.__iteratorUncached = function (i, t) {
          if (0 !== s && t) return this.cacheResult().__iterator(i, t);
          var n = 0 !== s && e.__iterator(i, t),
            r = 0,
            _ = 0;
          return new Iterator(function () {
            for (; r++ < o;) {
              n.next();
            }
            if (++_ > s) return {
              value: void 0,
              done: !0
            };
            var e = n.next();
            return a || i === h ? e : iteratorValue(i, _ - 1, i === f ? void 0 : e.value[1], e);
          });
        }, l;
      }
      function skipWhileFactory(e, i, t, a) {
        var n = makeSequence(e);
        return n.__iterateUncached = function (n, o) {
          var r = this;
          if (o) return this.cacheResult().__iterate(n, o);
          var s = !0,
            _ = 0;
          return e.__iterate(function (e, o, l) {
            if (!s || !(s = i.call(t, e, o, l))) return _++, n(e, a ? o : _ - 1, r);
          }), _;
        }, n.__iteratorUncached = function (n, o) {
          var r = this;
          if (o) return this.cacheResult().__iterator(n, o);
          var s = e.__iterator(d, o),
            _ = !0,
            l = 0;
          return new Iterator(function () {
            var e, o, g;
            do {
              if ((e = s.next()).done) return a || n === h ? e : iteratorValue(n, l++, n === f ? void 0 : e.value[1], e);
              var m = e.value;
              o = m[0], g = m[1], _ && (_ = i.call(t, g, o, r));
            } while (_);
            return n === d ? e : iteratorValue(n, o, g, e);
          });
        }, n;
      }
      function flattenFactory(e, i, t) {
        var a = makeSequence(e);
        return a.__iterateUncached = function (a, n) {
          var o = 0,
            r = !1;
          return function flatDeep(e, s) {
            var _ = this;
            e.__iterate(function (e, n) {
              return (!i || s < i) && isIterable(e) ? flatDeep(e, s + 1) : !1 === a(e, t ? n : o++, _) && (r = !0), !r;
            }, n);
          }(e, 0), o;
        }, a.__iteratorUncached = function (a, n) {
          var o = e.__iterator(a, n),
            r = [],
            s = 0;
          return new Iterator(function () {
            for (; o;) {
              var e = o.next();
              if (!1 === e.done) {
                var _ = e.value;
                if (a === d && (_ = _[1]), i && !(r.length < i) || !isIterable(_)) return t ? e : iteratorValue(a, s++, _, e);
                r.push(o), o = _.__iterator(a, n);
              } else o = r.pop();
            }
            return {
              value: void 0,
              done: !0
            };
          });
        }, a;
      }
      function sortFactory(e, i, t) {
        i || (i = defaultComparator);
        var a = isKeyed(e),
          n = 0,
          o = e.toSeq().map(function (i, a) {
            return [a, i, n++, t ? t(i, a, e) : i];
          }).toArray();
        return o.sort(function (e, t) {
          return i(e[3], t[3]) || e[2] - t[2];
        }).forEach(a ? function (e, i) {
          o[i].length = 2;
        } : function (e, i) {
          o[i] = e[1];
        }), a ? KeyedSeq(o) : isIndexed(e) ? IndexedSeq(o) : SetSeq(o);
      }
      function maxFactory(e, i, t) {
        if (i || (i = defaultComparator), t) {
          var a = e.toSeq().map(function (i, a) {
            return [i, t(i, a, e)];
          }).reduce(function (e, t) {
            return maxCompare(i, e[1], t[1]) ? t : e;
          });
          return a && a[0];
        }
        return e.reduce(function (e, t) {
          return maxCompare(i, e, t) ? t : e;
        });
      }
      function maxCompare(e, i, t) {
        var a = e(t, i);
        return 0 === a && t !== i && (void 0 === t || null === t || t !== t) || a > 0;
      }
      function zipWithFactory(e, i, t) {
        var a = makeSequence(e);
        return a.size = new ArraySeq(t).map(function (e) {
          return e.size;
        }).min(), a.__iterate = function (e, i) {
          for (var t, a = this.__iterator(h, i), n = 0; !(t = a.next()).done && !1 !== e(t.value, n++, this);) {
            ;
          }
          return n;
        }, a.__iteratorUncached = function (e, a) {
          var n = t.map(function (e) {
              return e = Iterable(e), getIterator(a ? e.reverse() : e);
            }),
            o = 0,
            r = !1;
          return new Iterator(function () {
            var t;
            return r || (t = n.map(function (e) {
              return e.next();
            }), r = t.some(function (e) {
              return e.done;
            })), r ? {
              value: void 0,
              done: !0
            } : iteratorValue(e, o++, i.apply(null, t.map(function (e) {
              return e.value;
            })));
          });
        }, a;
      }
      function reify(e, i) {
        return isSeq(e) ? i : e.constructor(i);
      }
      function validateEntry(e) {
        if (e !== Object(e)) throw new TypeError("Expected [K, V] tuple: " + e);
      }
      function resolveSize(e) {
        return assertNotInfinite(e.size), ensureSize(e);
      }
      function iterableClass(e) {
        return isKeyed(e) ? KeyedIterable : isIndexed(e) ? IndexedIterable : SetIterable;
      }
      function makeSequence(e) {
        return Object.create((isKeyed(e) ? KeyedSeq : isIndexed(e) ? IndexedSeq : SetSeq).prototype);
      }
      function cacheResultThrough() {
        return this._iter.cacheResult ? (this._iter.cacheResult(), this.size = this._iter.size, this) : Seq.prototype.cacheResult.call(this);
      }
      function defaultComparator(e, i) {
        return e > i ? 1 : e < i ? -1 : 0;
      }
      function forceIterator(e) {
        var i = getIterator(e);
        if (!i) {
          if (!isArrayLike(e)) throw new TypeError("Expected iterable or array-like: " + e);
          i = getIterator(Iterable(e));
        }
        return i;
      }
      function Record(e, i) {
        var t,
          a = function Record(o) {
            if (o instanceof a) return o;
            if (!(this instanceof a)) return new a(o);
            if (!t) {
              t = !0;
              var r = Object.keys(e);
              !function setProps(e, i) {
                try {
                  i.forEach(function setProp(e, i) {
                    Object.defineProperty(e, i, {
                      get: function get() {
                        return this.get(i);
                      },
                      set: function set(e) {
                        invariant(this.__ownerID, "Cannot set on an immutable record."), this.set(i, e);
                      }
                    });
                  }.bind(void 0, e));
                } catch (t) {}
              }(n, r), n.size = r.length, n._name = i, n._keys = r, n._defaultValues = e;
            }
            this._map = Map(o);
          },
          n = a.prototype = Object.create(U);
        return n.constructor = a, a;
      }
      createClass(OrderedMap, Map), OrderedMap.of = function () {
        return this(arguments);
      }, OrderedMap.prototype.toString = function () {
        return this.__toString("OrderedMap {", "}");
      }, OrderedMap.prototype.get = function (e, i) {
        var t = this._map.get(e);
        return void 0 !== t ? this._list.get(t)[1] : i;
      }, OrderedMap.prototype.clear = function () {
        return 0 === this.size ? this : this.__ownerID ? (this.size = 0, this._map.clear(), this._list.clear(), this) : emptyOrderedMap();
      }, OrderedMap.prototype.set = function (e, i) {
        return updateOrderedMap(this, e, i);
      }, OrderedMap.prototype.remove = function (e) {
        return updateOrderedMap(this, e, _);
      }, OrderedMap.prototype.wasAltered = function () {
        return this._map.wasAltered() || this._list.wasAltered();
      }, OrderedMap.prototype.__iterate = function (e, i) {
        var t = this;
        return this._list.__iterate(function (i) {
          return i && e(i[1], i[0], t);
        }, i);
      }, OrderedMap.prototype.__iterator = function (e, i) {
        return this._list.fromEntrySeq().__iterator(e, i);
      }, OrderedMap.prototype.__ensureOwner = function (e) {
        if (e === this.__ownerID) return this;
        var i = this._map.__ensureOwner(e),
          t = this._list.__ensureOwner(e);
        return e ? makeOrderedMap(i, t, e, this.__hash) : (this.__ownerID = e, this._map = i, this._list = t, this);
      }, OrderedMap.isOrderedMap = isOrderedMap, OrderedMap.prototype[n] = !0, OrderedMap.prototype.delete = OrderedMap.prototype.remove, createClass(ToKeyedSequence, KeyedSeq), ToKeyedSequence.prototype.get = function (e, i) {
        return this._iter.get(e, i);
      }, ToKeyedSequence.prototype.has = function (e) {
        return this._iter.has(e);
      }, ToKeyedSequence.prototype.valueSeq = function () {
        return this._iter.valueSeq();
      }, ToKeyedSequence.prototype.reverse = function () {
        var e = this,
          i = reverseFactory(this, !0);
        return this._useKeys || (i.valueSeq = function () {
          return e._iter.toSeq().reverse();
        }), i;
      }, ToKeyedSequence.prototype.map = function (e, i) {
        var t = this,
          a = mapFactory(this, e, i);
        return this._useKeys || (a.valueSeq = function () {
          return t._iter.toSeq().map(e, i);
        }), a;
      }, ToKeyedSequence.prototype.__iterate = function (e, i) {
        var t,
          a = this;
        return this._iter.__iterate(this._useKeys ? function (i, t) {
          return e(i, t, a);
        } : (t = i ? resolveSize(this) : 0, function (n) {
          return e(n, i ? --t : t++, a);
        }), i);
      }, ToKeyedSequence.prototype.__iterator = function (e, i) {
        if (this._useKeys) return this._iter.__iterator(e, i);
        var t = this._iter.__iterator(h, i),
          a = i ? resolveSize(this) : 0;
        return new Iterator(function () {
          var n = t.next();
          return n.done ? n : iteratorValue(e, i ? --a : a++, n.value, n);
        });
      }, ToKeyedSequence.prototype[n] = !0, createClass(ToIndexedSequence, IndexedSeq), ToIndexedSequence.prototype.includes = function (e) {
        return this._iter.includes(e);
      }, ToIndexedSequence.prototype.__iterate = function (e, i) {
        var t = this,
          a = 0;
        return this._iter.__iterate(function (i) {
          return e(i, a++, t);
        }, i);
      }, ToIndexedSequence.prototype.__iterator = function (e, i) {
        var t = this._iter.__iterator(h, i),
          a = 0;
        return new Iterator(function () {
          var i = t.next();
          return i.done ? i : iteratorValue(e, a++, i.value, i);
        });
      }, createClass(ToSetSequence, SetSeq), ToSetSequence.prototype.has = function (e) {
        return this._iter.includes(e);
      }, ToSetSequence.prototype.__iterate = function (e, i) {
        var t = this;
        return this._iter.__iterate(function (i) {
          return e(i, i, t);
        }, i);
      }, ToSetSequence.prototype.__iterator = function (e, i) {
        var t = this._iter.__iterator(h, i);
        return new Iterator(function () {
          var i = t.next();
          return i.done ? i : iteratorValue(e, i.value, i.value, i);
        });
      }, createClass(FromEntriesSequence, KeyedSeq), FromEntriesSequence.prototype.entrySeq = function () {
        return this._iter.toSeq();
      }, FromEntriesSequence.prototype.__iterate = function (e, i) {
        var t = this;
        return this._iter.__iterate(function (i) {
          if (i) {
            validateEntry(i);
            var a = isIterable(i);
            return e(a ? i.get(1) : i[1], a ? i.get(0) : i[0], t);
          }
        }, i);
      }, FromEntriesSequence.prototype.__iterator = function (e, i) {
        var t = this._iter.__iterator(h, i);
        return new Iterator(function () {
          for (;;) {
            var i = t.next();
            if (i.done) return i;
            var a = i.value;
            if (a) {
              validateEntry(a);
              var n = isIterable(a);
              return iteratorValue(e, n ? a.get(0) : a[0], n ? a.get(1) : a[1], i);
            }
          }
        });
      }, ToIndexedSequence.prototype.cacheResult = ToKeyedSequence.prototype.cacheResult = ToSetSequence.prototype.cacheResult = FromEntriesSequence.prototype.cacheResult = cacheResultThrough, createClass(Record, KeyedCollection), Record.prototype.toString = function () {
        return this.__toString(recordName(this) + " {", "}");
      }, Record.prototype.has = function (e) {
        return this._defaultValues.hasOwnProperty(e);
      }, Record.prototype.get = function (e, i) {
        if (!this.has(e)) return i;
        var t = this._defaultValues[e];
        return this._map ? this._map.get(e, t) : t;
      }, Record.prototype.clear = function () {
        if (this.__ownerID) return this._map && this._map.clear(), this;
        var e = this.constructor;
        return e._empty || (e._empty = makeRecord(this, emptyMap()));
      }, Record.prototype.set = function (e, i) {
        if (!this.has(e)) throw new Error('Cannot set unknown key "' + e + '" on ' + recordName(this));
        var t = this._map && this._map.set(e, i);
        return this.__ownerID || t === this._map ? this : makeRecord(this, t);
      }, Record.prototype.remove = function (e) {
        if (!this.has(e)) return this;
        var i = this._map && this._map.remove(e);
        return this.__ownerID || i === this._map ? this : makeRecord(this, i);
      }, Record.prototype.wasAltered = function () {
        return this._map.wasAltered();
      }, Record.prototype.__iterator = function (e, i) {
        var t = this;
        return KeyedIterable(this._defaultValues).map(function (e, i) {
          return t.get(i);
        }).__iterator(e, i);
      }, Record.prototype.__iterate = function (e, i) {
        var t = this;
        return KeyedIterable(this._defaultValues).map(function (e, i) {
          return t.get(i);
        }).__iterate(e, i);
      }, Record.prototype.__ensureOwner = function (e) {
        if (e === this.__ownerID) return this;
        var i = this._map && this._map.__ensureOwner(e);
        return e ? makeRecord(this, i, e) : (this.__ownerID = e, this._map = i, this);
      };
      var U = Record.prototype;
      function makeRecord(e, i, t) {
        var a = Object.create(Object.getPrototypeOf(e));
        return a._map = i, a.__ownerID = t, a;
      }
      function recordName(e) {
        return e._name || e.constructor.name || "Record";
      }
      function Set(e) {
        return null === e || void 0 === e ? emptySet() : isSet(e) && !isOrdered(e) ? e : emptySet().withMutations(function (i) {
          var t = SetIterable(e);
          assertNotInfinite(t.size), t.forEach(function (e) {
            return i.add(e);
          });
        });
      }
      function isSet(e) {
        return !(!e || !e[H]);
      }
      U.delete = U.remove, U.deleteIn = U.removeIn = T.removeIn, U.merge = T.merge, U.mergeWith = T.mergeWith, U.mergeIn = T.mergeIn, U.mergeDeep = T.mergeDeep, U.mergeDeepWith = T.mergeDeepWith, U.mergeDeepIn = T.mergeDeepIn, U.setIn = T.setIn, U.update = T.update, U.updateIn = T.updateIn, U.withMutations = T.withMutations, U.asMutable = T.asMutable, U.asImmutable = T.asImmutable, createClass(Set, SetCollection), Set.of = function () {
        return this(arguments);
      }, Set.fromKeys = function (e) {
        return this(KeyedIterable(e).keySeq());
      }, Set.prototype.toString = function () {
        return this.__toString("Set {", "}");
      }, Set.prototype.has = function (e) {
        return this._map.has(e);
      }, Set.prototype.add = function (e) {
        return updateSet(this, this._map.set(e, !0));
      }, Set.prototype.remove = function (e) {
        return updateSet(this, this._map.remove(e));
      }, Set.prototype.clear = function () {
        return updateSet(this, this._map.clear());
      }, Set.prototype.union = function () {
        var i = e.call(arguments, 0);
        return 0 === (i = i.filter(function (e) {
          return 0 !== e.size;
        })).length ? this : 0 !== this.size || this.__ownerID || 1 !== i.length ? this.withMutations(function (e) {
          for (var t = 0; t < i.length; t++) {
            SetIterable(i[t]).forEach(function (i) {
              return e.add(i);
            });
          }
        }) : this.constructor(i[0]);
      }, Set.prototype.intersect = function () {
        var i = e.call(arguments, 0);
        if (0 === i.length) return this;
        i = i.map(function (e) {
          return SetIterable(e);
        });
        var t = this;
        return this.withMutations(function (e) {
          t.forEach(function (t) {
            i.every(function (e) {
              return e.includes(t);
            }) || e.remove(t);
          });
        });
      }, Set.prototype.subtract = function () {
        var i = e.call(arguments, 0);
        if (0 === i.length) return this;
        i = i.map(function (e) {
          return SetIterable(e);
        });
        var t = this;
        return this.withMutations(function (e) {
          t.forEach(function (t) {
            i.some(function (e) {
              return e.includes(t);
            }) && e.remove(t);
          });
        });
      }, Set.prototype.merge = function () {
        return this.union.apply(this, arguments);
      }, Set.prototype.mergeWith = function (i) {
        var t = e.call(arguments, 1);
        return this.union.apply(this, t);
      }, Set.prototype.sort = function (e) {
        return OrderedSet(sortFactory(this, e));
      }, Set.prototype.sortBy = function (e, i) {
        return OrderedSet(sortFactory(this, i, e));
      }, Set.prototype.wasAltered = function () {
        return this._map.wasAltered();
      }, Set.prototype.__iterate = function (e, i) {
        var t = this;
        return this._map.__iterate(function (i, a) {
          return e(a, a, t);
        }, i);
      }, Set.prototype.__iterator = function (e, i) {
        return this._map.map(function (e, i) {
          return i;
        }).__iterator(e, i);
      }, Set.prototype.__ensureOwner = function (e) {
        if (e === this.__ownerID) return this;
        var i = this._map.__ensureOwner(e);
        return e ? this.__make(i, e) : (this.__ownerID = e, this._map = i, this);
      }, Set.isSet = isSet;
      var K,
        H = "@@__IMMUTABLE_SET__@@",
        V = Set.prototype;
      function updateSet(e, i) {
        return e.__ownerID ? (e.size = i.size, e._map = i, e) : i === e._map ? e : 0 === i.size ? e.__empty() : e.__make(i);
      }
      function makeSet(e, i) {
        var t = Object.create(V);
        return t.size = e ? e.size : 0, t._map = e, t.__ownerID = i, t;
      }
      function emptySet() {
        return K || (K = makeSet(emptyMap()));
      }
      function OrderedSet(e) {
        return null === e || void 0 === e ? emptyOrderedSet() : isOrderedSet(e) ? e : emptyOrderedSet().withMutations(function (i) {
          var t = SetIterable(e);
          assertNotInfinite(t.size), t.forEach(function (e) {
            return i.add(e);
          });
        });
      }
      function isOrderedSet(e) {
        return isSet(e) && isOrdered(e);
      }
      V[H] = !0, V.delete = V.remove, V.mergeDeep = V.merge, V.mergeDeepWith = V.mergeWith, V.withMutations = T.withMutations, V.asMutable = T.asMutable, V.asImmutable = T.asImmutable, V.__empty = emptySet, V.__make = makeSet, createClass(OrderedSet, Set), OrderedSet.of = function () {
        return this(arguments);
      }, OrderedSet.fromKeys = function (e) {
        return this(KeyedIterable(e).keySeq());
      }, OrderedSet.prototype.toString = function () {
        return this.__toString("OrderedSet {", "}");
      }, OrderedSet.isOrderedSet = isOrderedSet;
      var J,
        $ = OrderedSet.prototype;
      function makeOrderedSet(e, i) {
        var t = Object.create($);
        return t.size = e ? e.size : 0, t._map = e, t.__ownerID = i, t;
      }
      function emptyOrderedSet() {
        return J || (J = makeOrderedSet(emptyOrderedMap()));
      }
      function Stack(e) {
        return null === e || void 0 === e ? emptyStack() : isStack(e) ? e : emptyStack().unshiftAll(e);
      }
      function isStack(e) {
        return !(!e || !e[Y]);
      }
      $[n] = !0, $.__empty = emptyOrderedSet, $.__make = makeOrderedSet, createClass(Stack, IndexedCollection), Stack.of = function () {
        return this(arguments);
      }, Stack.prototype.toString = function () {
        return this.__toString("Stack [", "]");
      }, Stack.prototype.get = function (e, i) {
        var t = this._head;
        for (e = wrapIndex(this, e); t && e--;) {
          t = t.next;
        }
        return t ? t.value : i;
      }, Stack.prototype.peek = function () {
        return this._head && this._head.value;
      }, Stack.prototype.push = function () {
        if (0 === arguments.length) return this;
        for (var e = this.size + arguments.length, i = this._head, t = arguments.length - 1; t >= 0; t--) {
          i = {
            value: arguments[t],
            next: i
          };
        }
        return this.__ownerID ? (this.size = e, this._head = i, this.__hash = void 0, this.__altered = !0, this) : makeStack(e, i);
      }, Stack.prototype.pushAll = function (e) {
        if (0 === (e = IndexedIterable(e)).size) return this;
        assertNotInfinite(e.size);
        var i = this.size,
          t = this._head;
        return e.reverse().forEach(function (e) {
          i++, t = {
            value: e,
            next: t
          };
        }), this.__ownerID ? (this.size = i, this._head = t, this.__hash = void 0, this.__altered = !0, this) : makeStack(i, t);
      }, Stack.prototype.pop = function () {
        return this.slice(1);
      }, Stack.prototype.unshift = function () {
        return this.push.apply(this, arguments);
      }, Stack.prototype.unshiftAll = function (e) {
        return this.pushAll(e);
      }, Stack.prototype.shift = function () {
        return this.pop.apply(this, arguments);
      }, Stack.prototype.clear = function () {
        return 0 === this.size ? this : this.__ownerID ? (this.size = 0, this._head = void 0, this.__hash = void 0, this.__altered = !0, this) : emptyStack();
      }, Stack.prototype.slice = function (e, i) {
        if (wholeSlice(e, i, this.size)) return this;
        var t = resolveBegin(e, this.size),
          a = resolveEnd(i, this.size);
        if (a !== this.size) return IndexedCollection.prototype.slice.call(this, e, i);
        for (var n = this.size - t, o = this._head; t--;) {
          o = o.next;
        }
        return this.__ownerID ? (this.size = n, this._head = o, this.__hash = void 0, this.__altered = !0, this) : makeStack(n, o);
      }, Stack.prototype.__ensureOwner = function (e) {
        return e === this.__ownerID ? this : e ? makeStack(this.size, this._head, e, this.__hash) : (this.__ownerID = e, this.__altered = !1, this);
      }, Stack.prototype.__iterate = function (e, i) {
        if (i) return this.reverse().__iterate(e);
        for (var t = 0, a = this._head; a && !1 !== e(a.value, t++, this);) {
          a = a.next;
        }
        return t;
      }, Stack.prototype.__iterator = function (e, i) {
        if (i) return this.reverse().__iterator(e);
        var t = 0,
          a = this._head;
        return new Iterator(function () {
          if (a) {
            var i = a.value;
            return a = a.next, iteratorValue(e, t++, i);
          }
          return {
            value: void 0,
            done: !0
          };
        });
      }, Stack.isStack = isStack;
      var G,
        Y = "@@__IMMUTABLE_STACK__@@",
        X = Stack.prototype;
      function makeStack(e, i, t, a) {
        var n = Object.create(X);
        return n.size = e, n._head = i, n.__ownerID = t, n.__hash = a, n.__altered = !1, n;
      }
      function emptyStack() {
        return G || (G = makeStack(0));
      }
      function mixin(e, i) {
        var t = function keyCopier(t) {
          e.prototype[t] = i[t];
        };
        return Object.keys(i).forEach(t), Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(i).forEach(t), e;
      }
      X[Y] = !0, X.withMutations = T.withMutations, X.asMutable = T.asMutable, X.asImmutable = T.asImmutable, X.wasAltered = T.wasAltered, Iterable.Iterator = Iterator, mixin(Iterable, {
        toArray: function toArray() {
          assertNotInfinite(this.size);
          var e = new Array(this.size || 0);
          return this.valueSeq().__iterate(function (i, t) {
            e[t] = i;
          }), e;
        },
        toIndexedSeq: function toIndexedSeq() {
          return new ToIndexedSequence(this);
        },
        toJS: function toJS() {
          return this.toSeq().map(function (e) {
            return e && "function" === typeof e.toJS ? e.toJS() : e;
          }).__toJS();
        },
        toJSON: function toJSON() {
          return this.toSeq().map(function (e) {
            return e && "function" === typeof e.toJSON ? e.toJSON() : e;
          }).__toJS();
        },
        toKeyedSeq: function toKeyedSeq() {
          return new ToKeyedSequence(this, !0);
        },
        toMap: function toMap() {
          return Map(this.toKeyedSeq());
        },
        toObject: function toObject() {
          assertNotInfinite(this.size);
          var e = {};
          return this.__iterate(function (i, t) {
            e[t] = i;
          }), e;
        },
        toOrderedMap: function toOrderedMap() {
          return OrderedMap(this.toKeyedSeq());
        },
        toOrderedSet: function toOrderedSet() {
          return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
        },
        toSet: function toSet() {
          return Set(isKeyed(this) ? this.valueSeq() : this);
        },
        toSetSeq: function toSetSeq() {
          return new ToSetSequence(this);
        },
        toSeq: function toSeq() {
          return isIndexed(this) ? this.toIndexedSeq() : isKeyed(this) ? this.toKeyedSeq() : this.toSetSeq();
        },
        toStack: function toStack() {
          return Stack(isKeyed(this) ? this.valueSeq() : this);
        },
        toList: function toList() {
          return List(isKeyed(this) ? this.valueSeq() : this);
        },
        toString: function toString() {
          return "[Iterable]";
        },
        __toString: function __toString(e, i) {
          return 0 === this.size ? e + i : e + " " + this.toSeq().map(this.__toStringMapper).join(", ") + " " + i;
        },
        concat: function concat() {
          var i = e.call(arguments, 0);
          return reify(this, function concatFactory(e, i) {
            var t = isKeyed(e),
              a = [e].concat(i).map(function (e) {
                return isIterable(e) ? t && (e = KeyedIterable(e)) : e = t ? keyedSeqFromValue(e) : indexedSeqFromValue(Array.isArray(e) ? e : [e]), e;
              }).filter(function (e) {
                return 0 !== e.size;
              });
            if (0 === a.length) return e;
            if (1 === a.length) {
              var n = a[0];
              if (n === e || t && isKeyed(n) || isIndexed(e) && isIndexed(n)) return n;
            }
            var o = new ArraySeq(a);
            return t ? o = o.toKeyedSeq() : isIndexed(e) || (o = o.toSetSeq()), (o = o.flatten(!0)).size = a.reduce(function (e, i) {
              if (void 0 !== e) {
                var t = i.size;
                if (void 0 !== t) return e + t;
              }
            }, 0), o;
          }(this, i));
        },
        includes: function includes(e) {
          return this.some(function (i) {
            return is(i, e);
          });
        },
        entries: function entries() {
          return this.__iterator(d);
        },
        every: function every(e, i) {
          assertNotInfinite(this.size);
          var t = !0;
          return this.__iterate(function (a, n, o) {
            if (!e.call(i, a, n, o)) return t = !1, !1;
          }), t;
        },
        filter: function filter(e, i) {
          return reify(this, filterFactory(this, e, i, !0));
        },
        find: function find(e, i, t) {
          var a = this.findEntry(e, i);
          return a ? a[1] : t;
        },
        findEntry: function findEntry(e, i) {
          var t;
          return this.__iterate(function (a, n, o) {
            if (e.call(i, a, n, o)) return t = [n, a], !1;
          }), t;
        },
        findLastEntry: function findLastEntry(e, i) {
          return this.toSeq().reverse().findEntry(e, i);
        },
        forEach: function forEach(e, i) {
          return assertNotInfinite(this.size), this.__iterate(i ? e.bind(i) : e);
        },
        join: function join(e) {
          assertNotInfinite(this.size), e = void 0 !== e ? "" + e : ",";
          var i = "",
            t = !0;
          return this.__iterate(function (a) {
            t ? t = !1 : i += e, i += null !== a && void 0 !== a ? a.toString() : "";
          }), i;
        },
        keys: function keys() {
          return this.__iterator(f);
        },
        map: function map(e, i) {
          return reify(this, mapFactory(this, e, i));
        },
        reduce: function reduce(e, i, t) {
          var a, n;
          return assertNotInfinite(this.size), arguments.length < 2 ? n = !0 : a = i, this.__iterate(function (i, o, r) {
            n ? (n = !1, a = i) : a = e.call(t, a, i, o, r);
          }), a;
        },
        reduceRight: function reduceRight(e, i, t) {
          var a = this.toKeyedSeq().reverse();
          return a.reduce.apply(a, arguments);
        },
        reverse: function reverse() {
          return reify(this, reverseFactory(this, !0));
        },
        slice: function slice(e, i) {
          return reify(this, sliceFactory(this, e, i, !0));
        },
        some: function some(e, i) {
          return !this.every(not(e), i);
        },
        sort: function sort(e) {
          return reify(this, sortFactory(this, e));
        },
        values: function values() {
          return this.__iterator(h);
        },
        butLast: function butLast() {
          return this.slice(0, -1);
        },
        isEmpty: function isEmpty() {
          return void 0 !== this.size ? 0 === this.size : !this.some(function () {
            return !0;
          });
        },
        count: function count(e, i) {
          return ensureSize(e ? this.toSeq().filter(e, i) : this);
        },
        countBy: function countBy(e, i) {
          return function countByFactory(e, i, t) {
            var a = Map().asMutable();
            return e.__iterate(function (n, o) {
              a.update(i.call(t, n, o, e), 0, function (e) {
                return e + 1;
              });
            }), a.asImmutable();
          }(this, e, i);
        },
        equals: function equals(e) {
          return deepEqual(this, e);
        },
        entrySeq: function entrySeq() {
          var e = this;
          if (e._cache) return new ArraySeq(e._cache);
          var i = e.toSeq().map(entryMapper).toIndexedSeq();
          return i.fromEntrySeq = function () {
            return e.toSeq();
          }, i;
        },
        filterNot: function filterNot(e, i) {
          return this.filter(not(e), i);
        },
        findLast: function findLast(e, i, t) {
          return this.toKeyedSeq().reverse().find(e, i, t);
        },
        first: function first() {
          return this.find(returnTrue);
        },
        flatMap: function flatMap(e, i) {
          return reify(this, function flatMapFactory(e, i, t) {
            var a = iterableClass(e);
            return e.toSeq().map(function (n, o) {
              return a(i.call(t, n, o, e));
            }).flatten(!0);
          }(this, e, i));
        },
        flatten: function flatten(e) {
          return reify(this, flattenFactory(this, e, !0));
        },
        fromEntrySeq: function fromEntrySeq() {
          return new FromEntriesSequence(this);
        },
        get: function get(e, i) {
          return this.find(function (i, t) {
            return is(t, e);
          }, void 0, i);
        },
        getIn: function getIn(e, i) {
          for (var t, a = this, n = forceIterator(e); !(t = n.next()).done;) {
            var o = t.value;
            if ((a = a && a.get ? a.get(o, _) : _) === _) return i;
          }
          return a;
        },
        groupBy: function groupBy(e, i) {
          return function groupByFactory(e, i, t) {
            var a = isKeyed(e),
              n = (isOrdered(e) ? OrderedMap() : Map()).asMutable();
            e.__iterate(function (o, r) {
              n.update(i.call(t, o, r, e), function (e) {
                return (e = e || []).push(a ? [r, o] : o), e;
              });
            });
            var o = iterableClass(e);
            return n.map(function (i) {
              return reify(e, o(i));
            });
          }(this, e, i);
        },
        has: function has(e) {
          return this.get(e, _) !== _;
        },
        hasIn: function hasIn(e) {
          return this.getIn(e, _) !== _;
        },
        isSubset: function isSubset(e) {
          return e = "function" === typeof e.includes ? e : Iterable(e), this.every(function (i) {
            return e.includes(i);
          });
        },
        isSuperset: function isSuperset(e) {
          return (e = "function" === typeof e.isSubset ? e : Iterable(e)).isSubset(this);
        },
        keySeq: function keySeq() {
          return this.toSeq().map(keyMapper).toIndexedSeq();
        },
        last: function last() {
          return this.toSeq().reverse().first();
        },
        max: function max(e) {
          return maxFactory(this, e);
        },
        maxBy: function maxBy(e, i) {
          return maxFactory(this, i, e);
        },
        min: function min(e) {
          return maxFactory(this, e ? neg(e) : defaultNegComparator);
        },
        minBy: function minBy(e, i) {
          return maxFactory(this, i ? neg(i) : defaultNegComparator, e);
        },
        rest: function rest() {
          return this.slice(1);
        },
        skip: function skip(e) {
          return this.slice(Math.max(0, e));
        },
        skipLast: function skipLast(e) {
          return reify(this, this.toSeq().reverse().skip(e).reverse());
        },
        skipWhile: function skipWhile(e, i) {
          return reify(this, skipWhileFactory(this, e, i, !0));
        },
        skipUntil: function skipUntil(e, i) {
          return this.skipWhile(not(e), i);
        },
        sortBy: function sortBy(e, i) {
          return reify(this, sortFactory(this, i, e));
        },
        take: function take(e) {
          return this.slice(0, Math.max(0, e));
        },
        takeLast: function takeLast(e) {
          return reify(this, this.toSeq().reverse().take(e).reverse());
        },
        takeWhile: function takeWhile(e, i) {
          return reify(this, function takeWhileFactory(e, i, t) {
            var a = makeSequence(e);
            return a.__iterateUncached = function (a, n) {
              var o = this;
              if (n) return this.cacheResult().__iterate(a, n);
              var r = 0;
              return e.__iterate(function (e, n, s) {
                return i.call(t, e, n, s) && ++r && a(e, n, o);
              }), r;
            }, a.__iteratorUncached = function (a, n) {
              var o = this;
              if (n) return this.cacheResult().__iterator(a, n);
              var r = e.__iterator(d, n),
                s = !0;
              return new Iterator(function () {
                if (!s) return {
                  value: void 0,
                  done: !0
                };
                var e = r.next();
                if (e.done) return e;
                var n = e.value,
                  _ = n[0],
                  l = n[1];
                return i.call(t, l, _, o) ? a === d ? e : iteratorValue(a, _, l, e) : (s = !1, {
                  value: void 0,
                  done: !0
                });
              });
            }, a;
          }(this, e, i));
        },
        takeUntil: function takeUntil(e, i) {
          return this.takeWhile(not(e), i);
        },
        valueSeq: function valueSeq() {
          return this.toIndexedSeq();
        },
        hashCode: function hashCode() {
          return this.__hash || (this.__hash = function hashIterable(e) {
            if (e.size === 1 / 0) return 0;
            var i = isOrdered(e),
              t = isKeyed(e),
              a = i ? 1 : 0;
            return function murmurHashOfSize(e, i) {
              return i = k(i, 3432918353), i = k(i << 15 | i >>> -15, 461845907), i = k(i << 13 | i >>> -13, 5), i = k((i = (i + 3864292196 | 0) ^ e) ^ i >>> 16, 2246822507), i = smi((i = k(i ^ i >>> 13, 3266489909)) ^ i >>> 16);
            }(e.__iterate(t ? i ? function (e, i) {
              a = 31 * a + hashMerge(hash(e), hash(i)) | 0;
            } : function (e, i) {
              a = a + hashMerge(hash(e), hash(i)) | 0;
            } : i ? function (e) {
              a = 31 * a + hash(e) | 0;
            } : function (e) {
              a = a + hash(e) | 0;
            }), a);
          }(this));
        }
      });
      var Z = Iterable.prototype;
      Z[i] = !0, Z[c] = Z.values, Z.__toJS = Z.toArray, Z.__toStringMapper = quoteString, Z.inspect = Z.toSource = function () {
        return this.toString();
      }, Z.chain = Z.flatMap, Z.contains = Z.includes, function () {
        try {
          Object.defineProperty(Z, "length", {
            get: function get() {
              if (!Iterable.noLengthWarning) {
                var e;
                try {
                  throw new Error();
                } catch (i) {
                  e = i.stack;
                }
                if (-1 === e.indexOf("_wrapObject")) return console && console.warn && console.warn("iterable.length has been deprecated, use iterable.size or iterable.count(). This warning will become a silent error in a future version. " + e), this.size;
              }
            }
          });
        } catch (e) {}
      }(), mixin(KeyedIterable, {
        flip: function flip() {
          return reify(this, flipFactory(this));
        },
        findKey: function findKey(e, i) {
          var t = this.findEntry(e, i);
          return t && t[0];
        },
        findLastKey: function findLastKey(e, i) {
          return this.toSeq().reverse().findKey(e, i);
        },
        keyOf: function keyOf(e) {
          return this.findKey(function (i) {
            return is(i, e);
          });
        },
        lastKeyOf: function lastKeyOf(e) {
          return this.findLastKey(function (i) {
            return is(i, e);
          });
        },
        mapEntries: function mapEntries(e, i) {
          var t = this,
            a = 0;
          return reify(this, this.toSeq().map(function (n, o) {
            return e.call(i, [o, n], a++, t);
          }).fromEntrySeq());
        },
        mapKeys: function mapKeys(e, i) {
          var t = this;
          return reify(this, this.toSeq().flip().map(function (a, n) {
            return e.call(i, a, n, t);
          }).flip());
        }
      });
      var Q = KeyedIterable.prototype;
      function keyMapper(e, i) {
        return i;
      }
      function entryMapper(e, i) {
        return [i, e];
      }
      function not(e) {
        return function () {
          return !e.apply(this, arguments);
        };
      }
      function neg(e) {
        return function () {
          return -e.apply(this, arguments);
        };
      }
      function quoteString(e) {
        return "string" === typeof e ? JSON.stringify(e) : e;
      }
      function defaultZipper() {
        return arrCopy(arguments);
      }
      function defaultNegComparator(e, i) {
        return e < i ? 1 : e > i ? -1 : 0;
      }
      function hashMerge(e, i) {
        return e ^ i + 2654435769 + (e << 6) + (e >> 2) | 0;
      }
      return Q[t] = !0, Q[c] = Z.entries, Q.__toJS = Z.toObject, Q.__toStringMapper = function (e, i) {
        return JSON.stringify(i) + ": " + quoteString(e);
      }, mixin(IndexedIterable, {
        toKeyedSeq: function toKeyedSeq() {
          return new ToKeyedSequence(this, !1);
        },
        filter: function filter(e, i) {
          return reify(this, filterFactory(this, e, i, !1));
        },
        findIndex: function findIndex(e, i) {
          var t = this.findEntry(e, i);
          return t ? t[0] : -1;
        },
        indexOf: function indexOf(e) {
          var i = this.toKeyedSeq().keyOf(e);
          return void 0 === i ? -1 : i;
        },
        lastIndexOf: function lastIndexOf(e) {
          var i = this.toKeyedSeq().reverse().keyOf(e);
          return void 0 === i ? -1 : i;
        },
        reverse: function reverse() {
          return reify(this, reverseFactory(this, !1));
        },
        slice: function slice(e, i) {
          return reify(this, sliceFactory(this, e, i, !1));
        },
        splice: function splice(e, i) {
          var t = arguments.length;
          if (i = Math.max(0 | i, 0), 0 === t || 2 === t && !i) return this;
          e = resolveBegin(e, e < 0 ? this.count() : this.size);
          var a = this.slice(0, e);
          return reify(this, 1 === t ? a : a.concat(arrCopy(arguments, 2), this.slice(e + i)));
        },
        findLastIndex: function findLastIndex(e, i) {
          var t = this.toKeyedSeq().findLastKey(e, i);
          return void 0 === t ? -1 : t;
        },
        first: function first() {
          return this.get(0);
        },
        flatten: function flatten(e) {
          return reify(this, flattenFactory(this, e, !1));
        },
        get: function get(e, i) {
          return (e = wrapIndex(this, e)) < 0 || this.size === 1 / 0 || void 0 !== this.size && e > this.size ? i : this.find(function (i, t) {
            return t === e;
          }, void 0, i);
        },
        has: function has(e) {
          return (e = wrapIndex(this, e)) >= 0 && (void 0 !== this.size ? this.size === 1 / 0 || e < this.size : -1 !== this.indexOf(e));
        },
        interpose: function interpose(e) {
          return reify(this, function interposeFactory(e, i) {
            var t = makeSequence(e);
            return t.size = e.size && 2 * e.size - 1, t.__iterateUncached = function (t, a) {
              var n = this,
                o = 0;
              return e.__iterate(function (e, a) {
                return (!o || !1 !== t(i, o++, n)) && !1 !== t(e, o++, n);
              }, a), o;
            }, t.__iteratorUncached = function (t, a) {
              var n,
                o = e.__iterator(h, a),
                r = 0;
              return new Iterator(function () {
                return (!n || r % 2) && (n = o.next()).done ? n : r % 2 ? iteratorValue(t, r++, i) : iteratorValue(t, r++, n.value, n);
              });
            }, t;
          }(this, e));
        },
        interleave: function interleave() {
          var e = [this].concat(arrCopy(arguments)),
            i = zipWithFactory(this.toSeq(), IndexedSeq.of, e),
            t = i.flatten(!0);
          return i.size && (t.size = i.size * e.length), reify(this, t);
        },
        last: function last() {
          return this.get(-1);
        },
        skipWhile: function skipWhile(e, i) {
          return reify(this, skipWhileFactory(this, e, i, !1));
        },
        zip: function zip() {
          return reify(this, zipWithFactory(this, defaultZipper, [this].concat(arrCopy(arguments))));
        },
        zipWith: function zipWith(e) {
          var i = arrCopy(arguments);
          return i[0] = this, reify(this, zipWithFactory(this, e, i));
        }
      }), IndexedIterable.prototype[a] = !0, IndexedIterable.prototype[n] = !0, mixin(SetIterable, {
        get: function get(e, i) {
          return this.has(e) ? e : i;
        },
        includes: function includes(e) {
          return this.has(e);
        },
        keySeq: function keySeq() {
          return this.valueSeq();
        }
      }), SetIterable.prototype.has = Z.includes, mixin(KeyedSeq, KeyedIterable.prototype), mixin(IndexedSeq, IndexedIterable.prototype), mixin(SetSeq, SetIterable.prototype), mixin(KeyedCollection, KeyedIterable.prototype), mixin(IndexedCollection, IndexedIterable.prototype), mixin(SetCollection, SetIterable.prototype), {
        Iterable: Iterable,
        Seq: Seq,
        Collection: Collection,
        Map: Map,
        OrderedMap: OrderedMap,
        List: List,
        Stack: Stack,
        Set: Set,
        OrderedSet: OrderedSet,
        Record: Record,
        Range: Range,
        Repeat: Repeat,
        is: is,
        fromJS: fromJS
      };
    }();
  }, function (e, t) {
    e.exports = i;
  }, function (e, i, t) {
    "use strict";

    var a = t(133);
    function isObjectObject(e) {
      return !0 === a(e) && "[object Object]" === Object.prototype.toString.call(e);
    }
    e.exports = function isPlainObject(e) {
      var i, t;
      return !1 !== isObjectObject(e) && "function" === typeof (i = e.constructor) && !1 !== isObjectObject(t = i.prototype) && !1 !== t.hasOwnProperty("isPrototypeOf");
    };
  }, function (e, i, t) {
    var a = t(228);
    e.exports = function getWindow(e) {
      if (function isWindow(e) {
        return e && e.window === e;
      }(e)) return e;
      var i = a(e);
      if (n) {
        i.parentWindow.execScript("document._parentWindow = window;", "Javascript");
        var t = i._parentWindow;
        return i._parentWindow = null, t;
      }
      return i.defaultView || i.parentWindow;
    };
    var n = t(229);
  }, function (e, i) {
    e.exports = t;
  }, function (e, i, t) {
    var a;
    !function () {
      "use strict";

      var t = {}.hasOwnProperty;
      function classNames() {
        for (var e = [], i = 0; i < arguments.length; i++) {
          var a = arguments[i];
          if (a) {
            var n = typeof a;
            if ("string" === n || "number" === n) e.push(a);else if (Array.isArray(a) && a.length) {
              var o = classNames.apply(null, a);
              o && e.push(o);
            } else if ("object" === n) for (var r in a) {
              t.call(a, r) && a[r] && e.push(r);
            }
          }
        }
        return e.join(" ");
      }
      e.exports ? (classNames.default = classNames, e.exports = classNames) : void 0 === (a = function () {
        return classNames;
      }.apply(i, [])) || (e.exports = a);
    }();
  }, function (e, i, t) {
    "use strict";

    var a = t(99),
      n = t(243),
      o = Object.prototype.toString;
    function isArray(e) {
      return "[object Array]" === o.call(e);
    }
    function isObject(e) {
      return null !== e && "object" === typeof e;
    }
    function isFunction(e) {
      return "[object Function]" === o.call(e);
    }
    function forEach(e, i) {
      if (null !== e && "undefined" !== typeof e) if ("object" !== typeof e && (e = [e]), isArray(e)) for (var t = 0, a = e.length; t < a; t++) {
        i.call(null, e[t], t, e);
      } else for (var n in e) {
        Object.prototype.hasOwnProperty.call(e, n) && i.call(null, e[n], n, e);
      }
    }
    e.exports = {
      isArray: isArray,
      isArrayBuffer: function isArrayBuffer(e) {
        return "[object ArrayBuffer]" === o.call(e);
      },
      isBuffer: n,
      isFormData: function isFormData(e) {
        return "undefined" !== typeof FormData && e instanceof FormData;
      },
      isArrayBufferView: function isArrayBufferView(e) {
        return "undefined" !== typeof ArrayBuffer && ArrayBuffer.isView ? ArrayBuffer.isView(e) : e && e.buffer && e.buffer instanceof ArrayBuffer;
      },
      isString: function isString(e) {
        return "string" === typeof e;
      },
      isNumber: function isNumber(e) {
        return "number" === typeof e;
      },
      isObject: isObject,
      isUndefined: function isUndefined(e) {
        return "undefined" === typeof e;
      },
      isDate: function isDate(e) {
        return "[object Date]" === o.call(e);
      },
      isFile: function isFile(e) {
        return "[object File]" === o.call(e);
      },
      isBlob: function isBlob(e) {
        return "[object Blob]" === o.call(e);
      },
      isFunction: isFunction,
      isStream: function isStream(e) {
        return isObject(e) && isFunction(e.pipe);
      },
      isURLSearchParams: function isURLSearchParams(e) {
        return "undefined" !== typeof URLSearchParams && e instanceof URLSearchParams;
      },
      isStandardBrowserEnv: function isStandardBrowserEnv() {
        return ("undefined" === typeof navigator || "ReactNative" !== navigator.product) && "undefined" !== typeof window && "undefined" !== typeof document;
      },
      forEach: forEach,
      merge: function merge() {
        var e = {};
        function assignValue(i, t) {
          "object" === typeof e[t] && "object" === typeof i ? e[t] = merge(e[t], i) : e[t] = i;
        }
        for (var i = 0, t = arguments.length; i < t; i++) {
          forEach(arguments[i], assignValue);
        }
        return e;
      },
      extend: function extend(e, i, t) {
        return forEach(i, function assignValue(i, n) {
          e[n] = t && "function" === typeof i ? a(i, t) : i;
        }), e;
      },
      trim: function trim(e) {
        return e.replace(/^\s*/, "").replace(/\s*$/, "");
      }
    };
  }, function (e, i, t) {
    var a = t(83),
      n = "object" == typeof self && self && self.Object === Object && self,
      o = a || n || Function("return this")();
    e.exports = o;
  }, function (e, i) {
    e.exports = function isObject(e) {
      var i = typeof e;
      return null != e && ("object" == i || "function" == i);
    };
  }, function (e, i, t) {
    "use strict";

    (function (a) {
      function _typeof(e) {
        return (_typeof = "function" === typeof Symbol && "symbol" === typeof Symbol.iterator ? function _typeof(e) {
          return typeof e;
        } : function _typeof(e) {
          return e && "function" === typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }
      i.log = function log() {
        var e;
        return "object" === ("undefined" === typeof console ? "undefined" : _typeof(console)) && console.log && (e = console).log.apply(e, arguments);
      }, i.formatArgs = function formatArgs(i) {
        if (i[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + i[0] + (this.useColors ? "%c " : " ") + "+" + e.exports.humanize(this.diff), !this.useColors) return;
        var t = "color: " + this.color;
        i.splice(1, 0, t, "color: inherit");
        var a = 0,
          n = 0;
        i[0].replace(/%[a-zA-Z%]/g, function (e) {
          "%%" !== e && (a++, "%c" === e && (n = a));
        }), i.splice(n, 0, t);
      }, i.save = function save(e) {
        try {
          e ? i.storage.setItem("debug", e) : i.storage.removeItem("debug");
        } catch (t) {}
      }, i.load = function load() {
        var e;
        try {
          e = i.storage.getItem("debug");
        } catch (t) {}
        !e && "undefined" !== typeof a && "env" in a && (e = Object({
          NODE_ENV: "production",
          PUBLIC_URL: ""
        }).DEBUG);
        return e;
      }, i.useColors = function useColors() {
        if ("undefined" !== typeof window && window.process && ("renderer" === window.process.type || window.process.__nwjs)) return !0;
        if ("undefined" !== typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) return !1;
        return "undefined" !== typeof document && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || "undefined" !== typeof window && window.console && (window.console.firebug || window.console.exception && window.console.table) || "undefined" !== typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || "undefined" !== typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
      }, i.storage = function localstorage() {
        try {
          return localStorage;
        } catch (e) {}
      }(), i.colors = ["#0000CC", "#0000FF", "#0033CC", "#0033FF", "#0066CC", "#0066FF", "#0099CC", "#0099FF", "#00CC00", "#00CC33", "#00CC66", "#00CC99", "#00CCCC", "#00CCFF", "#3300CC", "#3300FF", "#3333CC", "#3333FF", "#3366CC", "#3366FF", "#3399CC", "#3399FF", "#33CC00", "#33CC33", "#33CC66", "#33CC99", "#33CCCC", "#33CCFF", "#6600CC", "#6600FF", "#6633CC", "#6633FF", "#66CC00", "#66CC33", "#9900CC", "#9900FF", "#9933CC", "#9933FF", "#99CC00", "#99CC33", "#CC0000", "#CC0033", "#CC0066", "#CC0099", "#CC00CC", "#CC00FF", "#CC3300", "#CC3333", "#CC3366", "#CC3399", "#CC33CC", "#CC33FF", "#CC6600", "#CC6633", "#CC9900", "#CC9933", "#CCCC00", "#CCCC33", "#FF0000", "#FF0033", "#FF0066", "#FF0099", "#FF00CC", "#FF00FF", "#FF3300", "#FF3333", "#FF3366", "#FF3399", "#FF33CC", "#FF33FF", "#FF6600", "#FF6633", "#FF9900", "#FF9933", "#FFCC00", "#FFCC33"], e.exports = t(130)(i), e.exports.formatters.j = function (e) {
        try {
          return JSON.stringify(e);
        } catch (i) {
          return "[UnexpectedJSONParseError]: " + i.message;
        }
      };
    }).call(this, t(50));
  }, function (e, i) {
    var t = Array.isArray;
    e.exports = t;
  }, function (e, i, t) {
    e.exports = t(241);
  }, function (e, i, t) {
    e.exports = t(242);
  }, function (e, i, t) {
    var a = t(146),
      n = t(151);
    e.exports = function getNative(e, i) {
      var t = n(e, i);
      return a(t) ? t : void 0;
    };
  }, function (e, i) {
    e.exports = function isObjectLike(e) {
      return null != e && "object" == typeof e;
    };
  }, function (e, i, t) {
    var a = t(112)("wks"),
      n = t(114),
      o = t(30).Symbol,
      r = "function" == typeof o;
    (e.exports = function (e) {
      return a[e] || (a[e] = r && o[e] || (r ? o : n)("Symbol." + e));
    }).store = a;
  }, function (e, i, t) {
    "use strict";

    Object.defineProperty(i, "__esModule", {
      value: !0
    });
    var a = function () {
        function defineProperties(e, i) {
          for (var t = 0; t < i.length; t++) {
            var a = i[t];
            a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
          }
        }
        return function (e, i, t) {
          return i && defineProperties(e.prototype, i), t && defineProperties(e, t), e;
        };
      }(),
      n = function get(e, i, t) {
        for (var a = !0; a;) {
          var n = e,
            o = i,
            r = t;
          a = !1, null === n && (n = Function.prototype);
          var s = Object.getOwnPropertyDescriptor(n, o);
          if (void 0 !== s) {
            if ("value" in s) return s.value;
            var _ = s.get;
            if (void 0 === _) return;
            return _.call(r);
          }
          var l = Object.getPrototypeOf(n);
          if (null === l) return;
          e = l, i = o, t = r, a = !0, s = l = void 0;
        }
      };
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    var o = _interopRequireDefault(t(0)),
      r = _interopRequireDefault(t(46));
    i.default = function onClickOutside(e) {
      var i = [],
        t = [];
      return function (s) {
        function OnClickOutside() {
          !function _classCallCheck(e, i) {
            if (!(e instanceof i)) throw new TypeError("Cannot call a class as a function");
          }(this, OnClickOutside), n(Object.getPrototypeOf(OnClickOutside.prototype), "constructor", this).apply(this, arguments);
        }
        return function _inherits(e, i) {
          if ("function" !== typeof i && null !== i) throw new TypeError("Super expression must either be null or a function, not " + typeof i);
          e.prototype = Object.create(i && i.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), i && (Object.setPrototypeOf ? Object.setPrototypeOf(e, i) : e.__proto__ = i);
        }(OnClickOutside, o.default.Component), a(OnClickOutside, [{
          key: "componentDidMount",
          value: function componentDidMount() {
            var e,
              a,
              n = this.__outsideClickHandler = (e = r.default.findDOMNode(this), a = this.props.onClickOutside || function () {}, function (i) {
                for (var t = i.target; t.parentNode;) {
                  if (t === e || t.classList.contains("ignore-react-onclickoutside")) return;
                  t = t.parentNode;
                }
                a(i);
              }),
              o = i.length;
            i.push(this), t[o] = n, this.props.disableOnClickOutside || this.enableOnClickOutside();
          }
        }, {
          key: "componentWillUnmount",
          value: function componentWillUnmount() {
            this.disableOnClickOutside(), this.__outsideClickHandler = !1;
            var e = i.indexOf(this);
            e > -1 && t[e] && (t.splice(e, 1), i.splice(e, 1));
          }
        }, {
          key: "componentWillReceiveProps",
          value: function componentWillReceiveProps(e) {
            !e.disableOnClickOutside && this.props.disableOnClickOutside ? this.enableOnClickOutside() : e.disableOnClickOutside && !this.props.disableOnClickOutside && this.disableOnClickOutside();
          }
        }, {
          key: "render",
          value: function render() {
            return o.default.createElement(e, this.props);
          }
        }, {
          key: "enableOnClickOutside",
          value: function enableOnClickOutside() {
            var e = this.__outsideClickHandler;
            document.addEventListener("mousedown", e), document.addEventListener("touchstart", e);
          }
        }, {
          key: "disableOnClickOutside",
          value: function disableOnClickOutside(e) {
            e = this.__outsideClickHandler, document.removeEventListener("mousedown", e), document.removeEventListener("touchstart", e);
          }
        }]), OnClickOutside;
      }();
    }, e.exports = i.default;
  }, function (e, i, t) {
    var a = t(28),
      n = t(147),
      o = t(148),
      r = "[object Null]",
      s = "[object Undefined]",
      _ = a ? a.toStringTag : void 0;
    e.exports = function baseGetTag(e) {
      return null == e ? void 0 === e ? s : r : _ && _ in Object(e) ? n(e) : o(e);
    };
  }, function (e, i, t) {
    var a = t(12),
      n = t(200),
      o = t(201),
      r = t(204);
    e.exports = function castPath(e, i) {
      return a(e) ? e : n(e, i) ? [e] : o(r(e));
    };
  }, function (e, i, t) {
    "use strict";

    e.exports = function (e) {
      var i = [];
      return i.toString = function toString() {
        return this.map(function (i) {
          var t = function cssWithMappingToString(e, i) {
            var t = e[1] || "",
              a = e[3];
            if (!a) return t;
            if (i && "function" === typeof btoa) {
              var n = function toComment(e) {
                  return "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(e)))) + " */";
                }(a),
                o = a.sources.map(function (e) {
                  return "/*# sourceURL=" + a.sourceRoot + e + " */";
                });
              return [t].concat(o).concat([n]).join("\n");
            }
            return [t].join("\n");
          }(i, e);
          return i[2] ? "@media " + i[2] + "{" + t + "}" : t;
        }).join("");
      }, i.i = function (e, t) {
        "string" === typeof e && (e = [[null, e, ""]]);
        for (var a = {}, n = 0; n < this.length; n++) {
          var o = this[n][0];
          null != o && (a[o] = !0);
        }
        for (n = 0; n < e.length; n++) {
          var r = e[n];
          null != r[0] && a[r[0]] || (t && !r[2] ? r[2] = t : t && (r[2] = "(" + r[2] + ") and (" + t + ")"), i.push(r));
        }
      }, i;
    };
  }, function (e, i, t) {
    "use strict";

    var a = {},
      n = function isOldIE() {
        var e;
        return function memorize() {
          return "undefined" === typeof e && (e = Boolean(window && document && document.all && !window.atob)), e;
        };
      }(),
      o = function getTarget() {
        var e = {};
        return function memorize(i) {
          if ("undefined" === typeof e[i]) {
            var t = document.querySelector(i);
            if (window.HTMLIFrameElement && t instanceof window.HTMLIFrameElement) try {
              t = t.contentDocument.head;
            } catch (a) {
              t = null;
            }
            e[i] = t;
          }
          return e[i];
        };
      }();
    function listToStyles(e, i) {
      for (var t = [], a = {}, n = 0; n < e.length; n++) {
        var o = e[n],
          r = i.base ? o[0] + i.base : o[0],
          s = {
            css: o[1],
            media: o[2],
            sourceMap: o[3]
          };
        a[r] ? a[r].parts.push(s) : t.push(a[r] = {
          id: r,
          parts: [s]
        });
      }
      return t;
    }
    function addStylesToDom(e, i) {
      for (var t = 0; t < e.length; t++) {
        var n = e[t],
          o = a[n.id],
          r = 0;
        if (o) {
          for (o.refs++; r < o.parts.length; r++) {
            o.parts[r](n.parts[r]);
          }
          for (; r < n.parts.length; r++) {
            o.parts.push(addStyle(n.parts[r], i));
          }
        } else {
          for (var s = []; r < n.parts.length; r++) {
            s.push(addStyle(n.parts[r], i));
          }
          a[n.id] = {
            id: n.id,
            refs: 1,
            parts: s
          };
        }
      }
    }
    function insertStyleElement(e) {
      var i = document.createElement("style");
      if ("undefined" === typeof e.attributes.nonce) {
        var a = t.nc;
        a && (e.attributes.nonce = a);
      }
      if (Object.keys(e.attributes).forEach(function (t) {
        i.setAttribute(t, e.attributes[t]);
      }), "function" === typeof e.insert) e.insert(i);else {
        var n = o(e.insert || "head");
        if (!n) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
        n.appendChild(i);
      }
      return i;
    }
    var r = function replaceText() {
      var e = [];
      return function replace(i, t) {
        return e[i] = t, e.filter(Boolean).join("\n");
      };
    }();
    function applyToSingletonTag(e, i, t, a) {
      var n = t ? "" : a.css;
      if (e.styleSheet) e.styleSheet.cssText = r(i, n);else {
        var o = document.createTextNode(n),
          s = e.childNodes;
        s[i] && e.removeChild(s[i]), s.length ? e.insertBefore(o, s[i]) : e.appendChild(o);
      }
    }
    var s = null,
      _ = 0;
    function addStyle(e, i) {
      var t, a, n;
      if (i.singleton) {
        var o = _++;
        t = s || (s = insertStyleElement(i)), a = applyToSingletonTag.bind(null, t, o, !1), n = applyToSingletonTag.bind(null, t, o, !0);
      } else t = insertStyleElement(i), a = function applyToTag(e, i, t) {
        var a = t.css,
          n = t.media,
          o = t.sourceMap;
        if (n && e.setAttribute("media", n), o && btoa && (a += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(o)))), " */")), e.styleSheet) e.styleSheet.cssText = a;else {
          for (; e.firstChild;) {
            e.removeChild(e.firstChild);
          }
          e.appendChild(document.createTextNode(a));
        }
      }.bind(null, t, i), n = function remove() {
        !function removeStyleElement(e) {
          if (null === e.parentNode) return !1;
          e.parentNode.removeChild(e);
        }(t);
      };
      return a(e), function updateStyle(i) {
        if (i) {
          if (i.css === e.css && i.media === e.media && i.sourceMap === e.sourceMap) return;
          a(e = i);
        } else n();
      };
    }
    e.exports = function (e, i) {
      (i = i || {}).attributes = "object" === typeof i.attributes ? i.attributes : {}, i.singleton || "boolean" === typeof i.singleton || (i.singleton = n());
      var t = listToStyles(e, i);
      return addStylesToDom(t, i), function update(e) {
        for (var n = [], o = 0; o < t.length; o++) {
          var r = t[o],
            s = a[r.id];
          s && (s.refs--, n.push(s));
        }
        e && addStylesToDom(listToStyles(e, i), i);
        for (var _ = 0; _ < n.length; _++) {
          var l = n[_];
          if (0 === l.refs) {
            for (var g = 0; g < l.parts.length; g++) {
              l.parts[g]();
            }
            delete a[l.id];
          }
        }
      };
    };
  }, function (e, i) {
    var t = e.exports = {
      version: "2.6.11"
    };
    "number" == typeof __e && (__e = t);
  }, function (e) {
    e.exports = {
      compressed: !0,
      categories: [{
        id: "people",
        name: "Smileys & People",
        emojis: ["grinning", "grin", "joy", "rolling_on_the_floor_laughing", "smiley", "smile", "sweat_smile", "laughing", "wink", "blush", "yum", "sunglasses", "heart_eyes", "kissing_heart", "kissing", "kissing_smiling_eyes", "kissing_closed_eyes", "relaxed", "slightly_smiling_face", "hugging_face", "star-struck", "thinking_face", "face_with_raised_eyebrow", "neutral_face", "expressionless", "no_mouth", "face_with_rolling_eyes", "smirk", "persevere", "disappointed_relieved", "open_mouth", "zipper_mouth_face", "hushed", "sleepy", "tired_face", "sleeping", "relieved", "stuck_out_tongue", "stuck_out_tongue_winking_eye", "stuck_out_tongue_closed_eyes", "drooling_face", "unamused", "sweat", "pensive", "confused", "upside_down_face", "money_mouth_face", "astonished", "white_frowning_face", "slightly_frowning_face", "confounded", "disappointed", "worried", "triumph", "cry", "sob", "frowning", "anguished", "fearful", "weary", "exploding_head", "grimacing", "cold_sweat", "scream", "flushed", "zany_face", "dizzy_face", "rage", "angry", "face_with_symbols_on_mouth", "mask", "face_with_thermometer", "face_with_head_bandage", "nauseated_face", "face_vomiting", "sneezing_face", "innocent", "face_with_cowboy_hat", "clown_face", "lying_face", "shushing_face", "face_with_hand_over_mouth", "face_with_monocle", "nerd_face", "smiling_imp", "imp", "japanese_ogre", "japanese_goblin", "skull", "skull_and_crossbones", "ghost", "alien", "space_invader", "robot_face", "hankey", "smiley_cat", "smile_cat", "joy_cat", "heart_eyes_cat", "smirk_cat", "kissing_cat", "scream_cat", "crying_cat_face", "pouting_cat", "see_no_evil", "hear_no_evil", "speak_no_evil", "baby", "child", "boy", "girl", "adult", "man", "woman", "older_adult", "older_man", "older_woman", "male-doctor", "female-doctor", "male-student", "female-student", "male-teacher", "female-teacher", "male-judge", "female-judge", "male-farmer", "female-farmer", "male-cook", "female-cook", "male-mechanic", "female-mechanic", "male-factory-worker", "female-factory-worker", "male-office-worker", "female-office-worker", "male-scientist", "female-scientist", "male-technologist", "female-technologist", "male-singer", "female-singer", "male-artist", "female-artist", "male-pilot", "female-pilot", "male-astronaut", "female-astronaut", "male-firefighter", "female-firefighter", "cop", "male-police-officer", "female-police-officer", "sleuth_or_spy", "male-detective", "female-detective", "guardsman", "male-guard", "female-guard", "construction_worker", "male-construction-worker", "female-construction-worker", "prince", "princess", "man_with_turban", "man-wearing-turban", "woman-wearing-turban", "man_with_gua_pi_mao", "person_with_headscarf", "bearded_person", "person_with_blond_hair", "blond-haired-man", "blond-haired-woman", "man_in_tuxedo", "bride_with_veil", "pregnant_woman", "breast-feeding", "angel", "santa", "mrs_claus", "mage", "female_mage", "male_mage", "fairy", "female_fairy", "male_fairy", "vampire", "female_vampire", "male_vampire", "merperson", "mermaid", "merman", "elf", "female_elf", "male_elf", "genie", "female_genie", "male_genie", "zombie", "female_zombie", "male_zombie", "person_frowning", "man-frowning", "woman-frowning", "person_with_pouting_face", "man-pouting", "woman-pouting", "no_good", "man-gesturing-no", "woman-gesturing-no", "ok_woman", "man-gesturing-ok", "woman-gesturing-ok", "information_desk_person", "man-tipping-hand", "woman-tipping-hand", "raising_hand", "man-raising-hand", "woman-raising-hand", "bow", "man-bowing", "woman-bowing", "face_palm", "man-facepalming", "woman-facepalming", "shrug", "man-shrugging", "woman-shrugging", "massage", "man-getting-massage", "woman-getting-massage", "haircut", "man-getting-haircut", "woman-getting-haircut", "walking", "man-walking", "woman-walking", "runner", "man-running", "woman-running", "dancer", "man_dancing", "dancers", "man-with-bunny-ears-partying", "woman-with-bunny-ears-partying", "person_in_steamy_room", "woman_in_steamy_room", "man_in_steamy_room", "person_climbing", "woman_climbing", "man_climbing", "person_in_lotus_position", "woman_in_lotus_position", "man_in_lotus_position", "bath", "sleeping_accommodation", "man_in_business_suit_levitating", "speaking_head_in_silhouette", "bust_in_silhouette", "busts_in_silhouette", "fencer", "horse_racing", "skier", "snowboarder", "golfer", "man-golfing", "woman-golfing", "surfer", "man-surfing", "woman-surfing", "rowboat", "man-rowing-boat", "woman-rowing-boat", "swimmer", "man-swimming", "woman-swimming", "person_with_ball", "man-bouncing-ball", "woman-bouncing-ball", "weight_lifter", "man-lifting-weights", "woman-lifting-weights", "bicyclist", "man-biking", "woman-biking", "mountain_bicyclist", "man-mountain-biking", "woman-mountain-biking", "racing_car", "racing_motorcycle", "person_doing_cartwheel", "man-cartwheeling", "woman-cartwheeling", "wrestlers", "man-wrestling", "woman-wrestling", "water_polo", "man-playing-water-polo", "woman-playing-water-polo", "handball", "man-playing-handball", "woman-playing-handball", "juggling", "man-juggling", "woman-juggling", "couple", "two_men_holding_hands", "two_women_holding_hands", "couplekiss", "woman-kiss-man", "man-kiss-man", "woman-kiss-woman", "couple_with_heart", "woman-heart-man", "man-heart-man", "woman-heart-woman", "family", "man-woman-boy", "man-woman-girl", "man-woman-girl-boy", "man-woman-boy-boy", "man-woman-girl-girl", "man-man-boy", "man-man-girl", "man-man-girl-boy", "man-man-boy-boy", "man-man-girl-girl", "woman-woman-boy", "woman-woman-girl", "woman-woman-girl-boy", "woman-woman-boy-boy", "woman-woman-girl-girl", "man-boy", "man-boy-boy", "man-girl", "man-girl-boy", "man-girl-girl", "woman-boy", "woman-boy-boy", "woman-girl", "woman-girl-boy", "woman-girl-girl", "selfie", "muscle", "point_left", "point_right", "point_up", "point_up_2", "middle_finger", "point_down", "v", "crossed_fingers", "spock-hand", "the_horns", "call_me_hand", "raised_hand_with_fingers_splayed", "hand", "ok_hand", "+1", "-1", "fist", "facepunch", "left-facing_fist", "right-facing_fist", "raised_back_of_hand", "wave", "i_love_you_hand_sign", "writing_hand", "clap", "open_hands", "raised_hands", "palms_up_together", "pray", "handshake", "nail_care", "ear", "nose", "footprints", "eyes", "eye", "eye-in-speech-bubble", "brain", "tongue", "lips", "kiss", "cupid", "heart", "heartbeat", "broken_heart", "two_hearts", "sparkling_heart", "heartpulse", "blue_heart", "green_heart", "yellow_heart", "orange_heart", "purple_heart", "black_heart", "gift_heart", "revolving_hearts", "heart_decoration", "heavy_heart_exclamation_mark_ornament", "love_letter", "zzz", "anger", "bomb", "boom", "sweat_drops", "dash", "dizzy", "speech_balloon", "left_speech_bubble", "right_anger_bubble", "thought_balloon", "hole", "eyeglasses", "dark_sunglasses", "necktie", "shirt", "jeans", "scarf", "gloves", "coat", "socks", "dress", "kimono", "bikini", "womans_clothes", "purse", "handbag", "pouch", "shopping_bags", "school_satchel", "mans_shoe", "athletic_shoe", "high_heel", "sandal", "boot", "crown", "womans_hat", "tophat", "mortar_board", "billed_cap", "helmet_with_white_cross", "prayer_beads", "lipstick", "ring", "gem"]
      }, {
        id: "nature",
        name: "Animals & Nature",
        emojis: ["monkey_face", "monkey", "gorilla", "dog", "dog2", "poodle", "wolf", "fox_face", "cat", "cat2", "lion_face", "tiger", "tiger2", "leopard", "horse", "racehorse", "unicorn_face", "zebra_face", "deer", "cow", "ox", "water_buffalo", "cow2", "pig", "pig2", "boar", "pig_nose", "ram", "sheep", "goat", "dromedary_camel", "camel", "giraffe_face", "elephant", "rhinoceros", "mouse", "mouse2", "rat", "hamster", "rabbit", "rabbit2", "chipmunk", "hedgehog", "bat", "bear", "koala", "panda_face", "feet", "turkey", "chicken", "rooster", "hatching_chick", "baby_chick", "hatched_chick", "bird", "penguin", "dove_of_peace", "eagle", "duck", "owl", "frog", "crocodile", "turtle", "lizard", "snake", "dragon_face", "dragon", "sauropod", "t-rex", "whale", "whale2", "dolphin", "fish", "tropical_fish", "blowfish", "shark", "octopus", "shell", "crab", "shrimp", "squid", "snail", "butterfly", "bug", "ant", "bee", "beetle", "cricket", "spider", "spider_web", "scorpion", "bouquet", "cherry_blossom", "white_flower", "rosette", "rose", "wilted_flower", "hibiscus", "sunflower", "blossom", "tulip", "seedling", "evergreen_tree", "deciduous_tree", "palm_tree", "cactus", "ear_of_rice", "herb", "shamrock", "four_leaf_clover", "maple_leaf", "fallen_leaf", "leaves"]
      }, {
        id: "foods",
        name: "Food & Drink",
        emojis: ["grapes", "melon", "watermelon", "tangerine", "lemon", "banana", "pineapple", "apple", "green_apple", "pear", "peach", "cherries", "strawberry", "kiwifruit", "tomato", "coconut", "avocado", "eggplant", "potato", "carrot", "corn", "hot_pepper", "cucumber", "broccoli", "mushroom", "peanuts", "chestnut", "bread", "croissant", "baguette_bread", "pretzel", "pancakes", "cheese_wedge", "meat_on_bone", "poultry_leg", "cut_of_meat", "bacon", "hamburger", "fries", "pizza", "hotdog", "sandwich", "taco", "burrito", "stuffed_flatbread", "egg", "fried_egg", "shallow_pan_of_food", "stew", "bowl_with_spoon", "green_salad", "popcorn", "canned_food", "bento", "rice_cracker", "rice_ball", "rice", "curry", "ramen", "spaghetti", "sweet_potato", "oden", "sushi", "fried_shrimp", "fish_cake", "dango", "dumpling", "fortune_cookie", "takeout_box", "icecream", "shaved_ice", "ice_cream", "doughnut", "cookie", "birthday", "cake", "pie", "chocolate_bar", "candy", "lollipop", "custard", "honey_pot", "baby_bottle", "glass_of_milk", "coffee", "tea", "sake", "champagne", "wine_glass", "cocktail", "tropical_drink", "beer", "beers", "clinking_glasses", "tumbler_glass", "cup_with_straw", "chopsticks", "knife_fork_plate", "fork_and_knife", "spoon", "hocho", "amphora"]
      }, {
        id: "activity",
        name: "Activities",
        emojis: ["jack_o_lantern", "christmas_tree", "fireworks", "sparkler", "sparkles", "balloon", "tada", "confetti_ball", "tanabata_tree", "bamboo", "dolls", "flags", "wind_chime", "rice_scene", "ribbon", "gift", "reminder_ribbon", "admission_tickets", "ticket", "medal", "trophy", "sports_medal", "first_place_medal", "second_place_medal", "third_place_medal", "soccer", "baseball", "basketball", "volleyball", "football", "rugby_football", "tennis", "8ball", "bowling", "cricket_bat_and_ball", "field_hockey_stick_and_ball", "ice_hockey_stick_and_puck", "table_tennis_paddle_and_ball", "badminton_racquet_and_shuttlecock", "boxing_glove", "martial_arts_uniform", "goal_net", "dart", "golf", "ice_skate", "fishing_pole_and_fish", "running_shirt_with_sash", "ski", "sled", "curling_stone", "video_game", "joystick", "game_die", "spades", "hearts", "diamonds", "clubs", "black_joker", "mahjong", "flower_playing_cards"]
      }, {
        id: "places",
        name: "Travel & Places",
        emojis: ["earth_africa", "earth_americas", "earth_asia", "globe_with_meridians", "world_map", "japan", "snow_capped_mountain", "mountain", "volcano", "mount_fuji", "camping", "beach_with_umbrella", "desert", "desert_island", "national_park", "stadium", "classical_building", "building_construction", "house_buildings", "cityscape", "derelict_house_building", "house", "house_with_garden", "office", "post_office", "european_post_office", "hospital", "bank", "hotel", "love_hotel", "convenience_store", "school", "department_store", "factory", "japanese_castle", "european_castle", "wedding", "tokyo_tower", "statue_of_liberty", "church", "mosque", "synagogue", "shinto_shrine", "kaaba", "fountain", "tent", "foggy", "night_with_stars", "sunrise_over_mountains", "sunrise", "city_sunset", "city_sunrise", "bridge_at_night", "hotsprings", "milky_way", "carousel_horse", "ferris_wheel", "roller_coaster", "barber", "circus_tent", "performing_arts", "frame_with_picture", "art", "slot_machine", "steam_locomotive", "railway_car", "bullettrain_side", "bullettrain_front", "train2", "metro", "light_rail", "station", "tram", "monorail", "mountain_railway", "train", "bus", "oncoming_bus", "trolleybus", "minibus", "ambulance", "fire_engine", "police_car", "oncoming_police_car", "taxi", "oncoming_taxi", "car", "oncoming_automobile", "blue_car", "truck", "articulated_lorry", "tractor", "bike", "scooter", "motor_scooter", "busstop", "motorway", "railway_track", "fuelpump", "rotating_light", "traffic_light", "vertical_traffic_light", "construction", "octagonal_sign", "anchor", "boat", "canoe", "speedboat", "passenger_ship", "ferry", "motor_boat", "ship", "airplane", "small_airplane", "airplane_departure", "airplane_arriving", "seat", "helicopter", "suspension_railway", "mountain_cableway", "aerial_tramway", "satellite", "rocket", "flying_saucer", "bellhop_bell", "door", "bed", "couch_and_lamp", "toilet", "shower", "bathtub", "hourglass", "hourglass_flowing_sand", "watch", "alarm_clock", "stopwatch", "timer_clock", "mantelpiece_clock", "clock12", "clock1230", "clock1", "clock130", "clock2", "clock230", "clock3", "clock330", "clock4", "clock430", "clock5", "clock530", "clock6", "clock630", "clock7", "clock730", "clock8", "clock830", "clock9", "clock930", "clock10", "clock1030", "clock11", "clock1130", "new_moon", "waxing_crescent_moon", "first_quarter_moon", "moon", "full_moon", "waning_gibbous_moon", "last_quarter_moon", "waning_crescent_moon", "crescent_moon", "new_moon_with_face", "first_quarter_moon_with_face", "last_quarter_moon_with_face", "thermometer", "sunny", "full_moon_with_face", "sun_with_face", "star", "star2", "stars", "cloud", "partly_sunny", "thunder_cloud_and_rain", "mostly_sunny", "barely_sunny", "partly_sunny_rain", "rain_cloud", "snow_cloud", "lightning", "tornado", "fog", "wind_blowing_face", "cyclone", "rainbow", "closed_umbrella", "umbrella", "umbrella_with_rain_drops", "umbrella_on_ground", "zap", "snowflake", "snowman", "snowman_without_snow", "comet", "fire", "droplet", "ocean"]
      }, {
        id: "objects",
        name: "Objects",
        emojis: ["mute", "speaker", "sound", "loud_sound", "loudspeaker", "mega", "postal_horn", "bell", "no_bell", "musical_score", "musical_note", "notes", "studio_microphone", "level_slider", "control_knobs", "microphone", "headphones", "radio", "saxophone", "guitar", "musical_keyboard", "trumpet", "violin", "drum_with_drumsticks", "iphone", "calling", "phone", "telephone_receiver", "pager", "fax", "battery", "electric_plug", "computer", "desktop_computer", "printer", "keyboard", "three_button_mouse", "trackball", "minidisc", "floppy_disk", "cd", "dvd", "movie_camera", "film_frames", "film_projector", "clapper", "tv", "camera", "camera_with_flash", "video_camera", "vhs", "mag", "mag_right", "microscope", "telescope", "satellite_antenna", "candle", "bulb", "flashlight", "izakaya_lantern", "notebook_with_decorative_cover", "closed_book", "book", "green_book", "blue_book", "orange_book", "books", "notebook", "ledger", "page_with_curl", "scroll", "page_facing_up", "newspaper", "rolled_up_newspaper", "bookmark_tabs", "bookmark", "label", "moneybag", "yen", "dollar", "euro", "pound", "money_with_wings", "credit_card", "chart", "currency_exchange", "heavy_dollar_sign", "email", "e-mail", "incoming_envelope", "envelope_with_arrow", "outbox_tray", "inbox_tray", "package", "mailbox", "mailbox_closed", "mailbox_with_mail", "mailbox_with_no_mail", "postbox", "ballot_box_with_ballot", "pencil2", "black_nib", "lower_left_fountain_pen", "lower_left_ballpoint_pen", "lower_left_paintbrush", "lower_left_crayon", "memo", "briefcase", "file_folder", "open_file_folder", "card_index_dividers", "date", "calendar", "spiral_note_pad", "spiral_calendar_pad", "card_index", "chart_with_upwards_trend", "chart_with_downwards_trend", "bar_chart", "clipboard", "pushpin", "round_pushpin", "paperclip", "linked_paperclips", "straight_ruler", "triangular_ruler", "scissors", "card_file_box", "file_cabinet", "wastebasket", "lock", "unlock", "lock_with_ink_pen", "closed_lock_with_key", "key", "old_key", "hammer", "pick", "hammer_and_pick", "hammer_and_wrench", "dagger_knife", "crossed_swords", "gun", "bow_and_arrow", "shield", "wrench", "nut_and_bolt", "gear", "compression", "alembic", "scales", "link", "chains", "syringe", "pill", "smoking", "coffin", "funeral_urn", "moyai", "oil_drum", "crystal_ball", "shopping_trolley"]
      }, {
        id: "symbols",
        name: "Symbols",
        emojis: ["atm", "put_litter_in_its_place", "potable_water", "wheelchair", "mens", "womens", "restroom", "baby_symbol", "wc", "passport_control", "customs", "baggage_claim", "left_luggage", "warning", "children_crossing", "no_entry", "no_entry_sign", "no_bicycles", "no_smoking", "do_not_litter", "non-potable_water", "no_pedestrians", "no_mobile_phones", "underage", "radioactive_sign", "biohazard_sign", "arrow_up", "arrow_upper_right", "arrow_right", "arrow_lower_right", "arrow_down", "arrow_lower_left", "arrow_left", "arrow_upper_left", "arrow_up_down", "left_right_arrow", "leftwards_arrow_with_hook", "arrow_right_hook", "arrow_heading_up", "arrow_heading_down", "arrows_clockwise", "arrows_counterclockwise", "back", "end", "on", "soon", "top", "place_of_worship", "atom_symbol", "om_symbol", "star_of_david", "wheel_of_dharma", "yin_yang", "latin_cross", "orthodox_cross", "star_and_crescent", "peace_symbol", "menorah_with_nine_branches", "six_pointed_star", "aries", "taurus", "gemini", "cancer", "leo", "virgo", "libra", "scorpius", "sagittarius", "capricorn", "aquarius", "pisces", "ophiuchus", "twisted_rightwards_arrows", "repeat", "repeat_one", "arrow_forward", "fast_forward", "black_right_pointing_double_triangle_with_vertical_bar", "black_right_pointing_triangle_with_double_vertical_bar", "arrow_backward", "rewind", "black_left_pointing_double_triangle_with_vertical_bar", "arrow_up_small", "arrow_double_up", "arrow_down_small", "arrow_double_down", "double_vertical_bar", "black_square_for_stop", "black_circle_for_record", "eject", "cinema", "low_brightness", "high_brightness", "signal_strength", "vibration_mode", "mobile_phone_off", "female_sign", "male_sign", "medical_symbol", "recycle", "fleur_de_lis", "trident", "name_badge", "beginner", "o", "white_check_mark", "ballot_box_with_check", "heavy_check_mark", "heavy_multiplication_x", "x", "negative_squared_cross_mark", "heavy_plus_sign", "heavy_minus_sign", "heavy_division_sign", "curly_loop", "loop", "part_alternation_mark", "eight_spoked_asterisk", "eight_pointed_black_star", "sparkle", "bangbang", "interrobang", "question", "grey_question", "grey_exclamation", "exclamation", "wavy_dash", "copyright", "registered", "tm", "hash", "keycap_star", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "keycap_ten", "100", "capital_abcd", "abcd", "1234", "symbols", "abc", "a", "ab", "b", "cl", "cool", "free", "information_source", "id", "m", "new", "ng", "o2", "ok", "parking", "sos", "up", "vs", "koko", "sa", "u6708", "u6709", "u6307", "ideograph_advantage", "u5272", "u7121", "u7981", "accept", "u7533", "u5408", "u7a7a", "congratulations", "secret", "u55b6", "u6e80", "black_small_square", "white_small_square", "white_medium_square", "black_medium_square", "white_medium_small_square", "black_medium_small_square", "black_large_square", "white_large_square", "large_orange_diamond", "large_blue_diamond", "small_orange_diamond", "small_blue_diamond", "small_red_triangle", "small_red_triangle_down", "diamond_shape_with_a_dot_inside", "radio_button", "black_square_button", "white_square_button", "white_circle", "black_circle", "red_circle", "large_blue_circle"]
      }, {
        id: "flags",
        name: "Flags",
        emojis: ["checkered_flag", "cn", "crossed_flags", "de", "es", "flag-ac", "flag-ad", "flag-ae", "flag-af", "flag-ag", "flag-ai", "flag-al", "flag-am", "flag-ao", "flag-aq", "flag-ar", "flag-as", "flag-at", "flag-au", "flag-aw", "flag-ax", "flag-az", "flag-ba", "flag-bb", "flag-bd", "flag-be", "flag-bf", "flag-bg", "flag-bh", "flag-bi", "flag-bj", "flag-bl", "flag-bm", "flag-bn", "flag-bo", "flag-bq", "flag-br", "flag-bs", "flag-bt", "flag-bv", "flag-bw", "flag-by", "flag-bz", "flag-ca", "flag-cc", "flag-cd", "flag-cf", "flag-cg", "flag-ch", "flag-ci", "flag-ck", "flag-cl", "flag-cm", "flag-co", "flag-cp", "flag-cr", "flag-cu", "flag-cv", "flag-cw", "flag-cx", "flag-cy", "flag-cz", "flag-dg", "flag-dj", "flag-dk", "flag-dm", "flag-do", "flag-dz", "flag-ea", "flag-ec", "flag-ee", "flag-eg", "flag-eh", "flag-england", "flag-er", "flag-et", "flag-eu", "flag-fi", "flag-fj", "flag-fk", "flag-fm", "flag-fo", "flag-ga", "flag-gd", "flag-ge", "flag-gf", "flag-gg", "flag-gh", "flag-gi", "flag-gl", "flag-gm", "flag-gn", "flag-gp", "flag-gq", "flag-gr", "flag-gs", "flag-gt", "flag-gu", "flag-gw", "flag-gy", "flag-hk", "flag-hm", "flag-hn", "flag-hr", "flag-ht", "flag-hu", "flag-ic", "flag-id", "flag-ie", "flag-il", "flag-im", "flag-in", "flag-io", "flag-iq", "flag-ir", "flag-is", "flag-je", "flag-jm", "flag-jo", "flag-ke", "flag-kg", "flag-kh", "flag-ki", "flag-km", "flag-kn", "flag-kp", "flag-kw", "flag-ky", "flag-kz", "flag-la", "flag-lb", "flag-lc", "flag-li", "flag-lk", "flag-lr", "flag-ls", "flag-lt", "flag-lu", "flag-lv", "flag-ly", "flag-ma", "flag-mc", "flag-md", "flag-me", "flag-mf", "flag-mg", "flag-mh", "flag-mk", "flag-ml", "flag-mm", "flag-mn", "flag-mo", "flag-mp", "flag-mq", "flag-mr", "flag-ms", "flag-mt", "flag-mu", "flag-mv", "flag-mw", "flag-mx", "flag-my", "flag-mz", "flag-na", "flag-nc", "flag-ne", "flag-nf", "flag-ng", "flag-ni", "flag-nl", "flag-no", "flag-np", "flag-nr", "flag-nu", "flag-nz", "flag-om", "flag-pa", "flag-pe", "flag-pf", "flag-pg", "flag-ph", "flag-pk", "flag-pl", "flag-pm", "flag-pn", "flag-pr", "flag-ps", "flag-pt", "flag-pw", "flag-py", "flag-qa", "flag-re", "flag-ro", "flag-rs", "flag-rw", "flag-sa", "flag-sb", "flag-sc", "flag-scotland", "flag-sd", "flag-se", "flag-sg", "flag-sh", "flag-si", "flag-sj", "flag-sk", "flag-sl", "flag-sm", "flag-sn", "flag-so", "flag-sr", "flag-ss", "flag-st", "flag-sv", "flag-sx", "flag-sy", "flag-sz", "flag-ta", "flag-tc", "flag-td", "flag-tf", "flag-tg", "flag-th", "flag-tj", "flag-tk", "flag-tl", "flag-tm", "flag-tn", "flag-to", "flag-tr", "flag-tt", "flag-tv", "flag-tw", "flag-tz", "flag-ua", "flag-ug", "flag-um", "flag-uy", "flag-uz", "flag-va", "flag-vc", "flag-ve", "flag-vg", "flag-vi", "flag-vn", "flag-vu", "flag-wales", "flag-wf", "flag-ws", "flag-xk", "flag-ye", "flag-yt", "flag-za", "flag-zm", "flag-zw", "fr", "gb", "it", "jp", "kr", "rainbow-flag", "ru", "triangular_flag_on_post", "us", "waving_black_flag", "waving_white_flag"]
      }],
      emojis: {
        100: {
          a: "Hundred Points Symbol",
          b: "1F4AF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["score", "perfect", "numbers", "century", "exam", "quiz", "test", "pass", "hundred"],
          k: [25, 26]
        },
        1234: {
          a: "Input Symbol for Numbers",
          b: "1F522",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["numbers", "blue-square"],
          k: [27, 36]
        },
        monkey_face: {
          a: "Monkey Face",
          b: "1F435",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "circus"],
          k: [13, 31],
          l: [":o)"]
        },
        grinning: {
          a: "Grinning Face",
          b: "1F600",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "smile", "happy", "joy", ":D", "grin"],
          k: [30, 24],
          m: ":D"
        },
        earth_africa: {
          a: "Earth Globe Europe-Africa",
          b: "1F30D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["globe", "world", "international"],
          k: [6, 5]
        },
        checkered_flag: {
          a: "Chequered Flag",
          b: "1F3C1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["contest", "finishline", "race", "gokart"],
          k: [9, 27]
        },
        mute: {
          a: "Speaker with Cancellation Stroke",
          b: "1F507",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sound", "volume", "silence", "quiet"],
          k: [27, 9]
        },
        jack_o_lantern: {
          a: "Jack-O-Lantern",
          b: "1F383",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["halloween", "light", "pumpkin", "creepy", "fall"],
          k: [8, 17]
        },
        atm: {
          a: "Automated Teller Machine",
          b: "1F3E7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["money", "sales", "cash", "blue-square", "payment", "bank"],
          k: [12, 4]
        },
        grapes: {
          a: "Grapes",
          b: "1F347",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fruit", "food", "wine"],
          k: [7, 9]
        },
        earth_americas: {
          a: "Earth Globe Americas",
          b: "1F30E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["globe", "world", "USA", "international"],
          k: [6, 6]
        },
        grin: {
          a: "Grinning Face with Smiling Eyes",
          b: "1F601",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "happy", "smile", "joy", "kawaii"],
          k: [30, 25]
        },
        melon: {
          a: "Melon",
          b: "1F348",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fruit", "nature", "food"],
          k: [7, 10]
        },
        triangular_flag_on_post: {
          a: "Triangular Flag on Post",
          b: "1F6A9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["mark", "milestone", "place"],
          k: [35, 14]
        },
        monkey: {
          a: "Monkey",
          b: "1F412",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "banana", "circus"],
          k: [12, 48]
        },
        christmas_tree: {
          a: "Christmas Tree",
          b: "1F384",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["festival", "vacation", "december", "xmas", "celebration"],
          k: [8, 18]
        },
        put_litter_in_its_place: {
          a: "Put Litter in Its Place Symbol",
          b: "1F6AE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "sign", "human", "info"],
          k: [35, 19]
        },
        speaker: {
          a: "Speaker",
          b: "1F508",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sound", "volume", "silence", "broadcast"],
          k: [27, 10]
        },
        earth_asia: {
          a: "Earth Globe Asia-Australia",
          b: "1F30F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["globe", "world", "east", "international"],
          k: [6, 7]
        },
        crossed_flags: {
          a: "Crossed Flags",
          b: "1F38C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["japanese", "nation", "country", "border"],
          k: [8, 31]
        },
        joy: {
          a: "Face with Tears of Joy",
          b: "1F602",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "cry", "tears", "weep", "happy", "happytears", "haha"],
          k: [30, 26]
        },
        sound: {
          a: "Speaker with One Sound Wave",
          b: "1F509",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["volume", "speaker", "broadcast"],
          k: [27, 11]
        },
        watermelon: {
          a: "Watermelon",
          b: "1F349",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fruit", "food", "picnic", "summer"],
          k: [7, 11]
        },
        gorilla: {
          a: "Gorilla",
          b: "1F98D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["animal", "nature", "circus"],
          k: [42, 37],
          o: 9
        },
        fireworks: {
          a: "Fireworks",
          b: "1F386",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["photo", "festival", "carnival", "congratulations"],
          k: [8, 25]
        },
        potable_water: {
          a: "Potable Water Symbol",
          b: "1F6B0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "liquid", "restroom", "cleaning", "faucet"],
          k: [35, 21]
        },
        wheelchair: {
          a: "Wheelchair Symbol",
          b: "267F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "disabled", "a11y", "accessibility"],
          k: [48, 10],
          o: 4
        },
        rolling_on_the_floor_laughing: {
          a: "Rolling on the Floor Laughing",
          b: "1F923",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [38, 26],
          o: 9
        },
        loud_sound: {
          a: "Speaker with Three Sound Waves",
          b: "1F50A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["volume", "noise", "noisy", "speaker", "broadcast"],
          k: [27, 12]
        },
        waving_black_flag: {
          a: "Waving Black Flag",
          b: "1F3F4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [12, 19],
          o: 7
        },
        tangerine: {
          a: "Tangerine",
          b: "1F34A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "fruit", "nature", "orange"],
          k: [7, 12]
        },
        dog: {
          a: "Dog Face",
          b: "1F436",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "friend", "nature", "woof", "puppy", "pet", "faithful"],
          k: [13, 32]
        },
        sparkler: {
          a: "Firework Sparkler",
          b: "1F387",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["stars", "night", "shine"],
          k: [8, 26]
        },
        globe_with_meridians: {
          a: "Globe with Meridians",
          b: "1F310",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["earth", "international", "world", "internet", "interweb", "i18n"],
          k: [6, 8]
        },
        smiley: {
          a: "Smiling Face with Open Mouth",
          b: "1F603",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "happy", "joy", "haha", ":D", ":)", "smile", "funny"],
          k: [30, 27],
          l: ["=)", "=-)"],
          m: ":)"
        },
        loudspeaker: {
          a: "Public Address Loudspeaker",
          b: "1F4E2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["volume", "sound"],
          k: [26, 25]
        },
        sparkles: {
          a: "Sparkles",
          b: "2728",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["stars", "shine", "shiny", "cool", "awesome", "good", "magic"],
          k: [49, 48]
        },
        dog2: {
          a: "Dog",
          b: "1F415",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "friend", "doge", "pet", "faithful"],
          k: [12, 51]
        },
        waving_white_flag: {
          a: "Waving White Flag",
          b: "1F3F3-FE0F",
          c: "1F3F3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [12, 15],
          o: 7
        },
        world_map: {
          a: "World Map",
          b: "1F5FA-FE0F",
          c: "1F5FA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["location", "direction"],
          k: [30, 18],
          o: 7
        },
        lemon: {
          a: "Lemon",
          b: "1F34B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fruit", "nature"],
          k: [7, 13]
        },
        mens: {
          a: "Mens Symbol",
          b: "1F6B9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["toilet", "restroom", "wc", "blue-square", "gender", "male"],
          k: [36, 29]
        },
        womens: {
          a: "Womens Symbol",
          b: "1F6BA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["purple-square", "woman", "female", "toilet", "loo", "restroom", "gender"],
          k: [36, 30]
        },
        "rainbow-flag": {
          a: "Rainbow Flag",
          b: "1F3F3-FE0F-200D-1F308",
          c: "1F3F3-200D-1F308",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [12, 14],
          o: 7
        },
        smile: {
          a: "Smiling Face with Open Mouth and Smiling Eyes",
          b: "1F604",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "happy", "joy", "funny", "haha", "laugh", "like", ":D", ":)"],
          k: [30, 28],
          l: ["C:", "c:", ":D", ":-D"],
          m: ":)"
        },
        banana: {
          a: "Banana",
          b: "1F34C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fruit", "food", "monkey"],
          k: [7, 14]
        },
        mega: {
          a: "Cheering Megaphone",
          b: "1F4E3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sound", "speaker", "volume"],
          k: [26, 26]
        },
        japan: {
          a: "Silhouette of Japan",
          b: "1F5FE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nation", "country", "japanese", "asia"],
          k: [30, 22]
        },
        poodle: {
          a: "Poodle",
          b: "1F429",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["dog", "animal", "101", "nature", "pet"],
          k: [13, 19]
        },
        balloon: {
          a: "Balloon",
          b: "1F388",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["party", "celebration", "birthday", "circus"],
          k: [8, 27]
        },
        "flag-ac": {
          a: "Ascension Island Flag",
          b: "1F1E6-1F1E8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [0, 31]
        },
        sweat_smile: {
          a: "Smiling Face with Open Mouth and Cold Sweat",
          b: "1F605",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "hot", "happy", "laugh", "sweat", "smile", "relief"],
          k: [30, 29]
        },
        pineapple: {
          a: "Pineapple",
          b: "1F34D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fruit", "nature", "food"],
          k: [7, 15]
        },
        restroom: {
          a: "Restroom",
          b: "1F6BB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "toilet", "refresh", "wc", "gender"],
          k: [36, 31]
        },
        postal_horn: {
          a: "Postal Horn",
          b: "1F4EF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["instrument", "music"],
          k: [26, 38]
        },
        wolf: {
          a: "Wolf Face",
          b: "1F43A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "wild"],
          k: [13, 36]
        },
        tada: {
          a: "Party Popper",
          b: "1F389",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["party", "congratulations", "birthday", "magic", "circus", "celebration"],
          k: [8, 28]
        },
        snow_capped_mountain: {
          a: "Snow Capped Mountain",
          b: "1F3D4-FE0F",
          c: "1F3D4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [11, 37],
          o: 7
        },
        laughing: {
          a: "Smiling Face with Open Mouth and Tightly-Closed Eyes",
          b: "1F606",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["happy", "joy", "lol", "satisfied", "haha", "face", "glad", "XD", "laugh"],
          k: [30, 30],
          l: [":>", ":->"],
          n: ["satisfied"]
        },
        apple: {
          a: "Red Apple",
          b: "1F34E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fruit", "mac", "school"],
          k: [7, 16]
        },
        "flag-ad": {
          a: "Andorra Flag",
          b: "1F1E6-1F1E9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [0, 32]
        },
        fox_face: {
          a: "Fox Face",
          b: "1F98A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["animal", "nature", "face"],
          k: [42, 34],
          o: 9
        },
        confetti_ball: {
          a: "Confetti Ball",
          b: "1F38A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["festival", "party", "birthday", "circus"],
          k: [8, 29]
        },
        bell: {
          a: "Bell",
          b: "1F514",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sound", "notification", "christmas", "xmas", "chime"],
          k: [27, 22]
        },
        mountain: {
          a: "Mountain",
          b: "26F0-FE0F",
          c: "26F0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["photo", "nature", "environment"],
          k: [48, 38],
          o: 5
        },
        baby_symbol: {
          a: "Baby Symbol",
          b: "1F6BC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["orange-square", "child"],
          k: [36, 32]
        },
        wc: {
          a: "Water Closet",
          b: "1F6BE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["toilet", "restroom", "blue-square"],
          k: [36, 34]
        },
        wink: {
          a: "Winking Face",
          b: "1F609",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "happy", "mischievous", "secret", ";)", "smile", "eye"],
          k: [30, 33],
          l: [";)", ";-)"],
          m: ";)"
        },
        no_bell: {
          a: "Bell with Cancellation Stroke",
          b: "1F515",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sound", "volume", "mute", "quiet", "silent"],
          k: [27, 23]
        },
        green_apple: {
          a: "Green Apple",
          b: "1F34F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fruit", "nature"],
          k: [7, 17]
        },
        tanabata_tree: {
          a: "Tanabata Tree",
          b: "1F38B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["plant", "nature", "branch", "summer"],
          k: [8, 30]
        },
        "flag-ae": {
          a: "United Arab Emirates Flag",
          b: "1F1E6-1F1EA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [0, 33]
        },
        volcano: {
          a: "Volcano",
          b: "1F30B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["photo", "nature", "disaster"],
          k: [6, 3]
        },
        cat: {
          a: "Cat Face",
          b: "1F431",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "meow", "nature", "pet", "kitten"],
          k: [13, 27]
        },
        "flag-af": {
          a: "Afghanistan Flag",
          b: "1F1E6-1F1EB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [0, 34]
        },
        musical_score: {
          a: "Musical Score",
          b: "1F3BC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["treble", "clef", "compose"],
          k: [9, 22]
        },
        blush: {
          a: "Smiling Face with Smiling Eyes",
          b: "1F60A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "smile", "happy", "flushed", "crush", "embarrassed", "shy", "joy"],
          k: [30, 34],
          m: ":)"
        },
        pear: {
          a: "Pear",
          b: "1F350",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fruit", "nature", "food"],
          k: [7, 18]
        },
        bamboo: {
          a: "Pine Decoration",
          b: "1F38D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["plant", "nature", "vegetable", "panda", "pine_decoration"],
          k: [8, 32]
        },
        passport_control: {
          a: "Passport Control",
          b: "1F6C2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["custom", "blue-square"],
          k: [36, 43]
        },
        mount_fuji: {
          a: "Mount Fuji",
          b: "1F5FB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["photo", "mountain", "nature", "japanese"],
          k: [30, 19]
        },
        cat2: {
          a: "Cat",
          b: "1F408",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "meow", "pet", "cats"],
          k: [12, 38]
        },
        musical_note: {
          a: "Musical Note",
          b: "1F3B5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["score", "tone", "sound"],
          k: [9, 15]
        },
        dolls: {
          a: "Japanese Dolls",
          b: "1F38E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["japanese", "toy", "kimono"],
          k: [8, 33]
        },
        lion_face: {
          a: "Lion Face",
          b: "1F981",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 25],
          o: 8
        },
        camping: {
          a: "Camping",
          b: "1F3D5-FE0F",
          c: "1F3D5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["photo", "outdoors", "tent"],
          k: [11, 38],
          o: 7
        },
        "flag-ag": {
          a: "Antigua & Barbuda Flag",
          b: "1F1E6-1F1EC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [0, 35]
        },
        customs: {
          a: "Customs",
          b: "1F6C3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["passport", "border", "blue-square"],
          k: [36, 44]
        },
        yum: {
          a: "Face Savouring Delicious Food",
          b: "1F60B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["happy", "joy", "tongue", "smile", "face", "silly", "yummy", "nom", "delicious", "savouring"],
          k: [30, 35]
        },
        peach: {
          a: "Peach",
          b: "1F351",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fruit", "nature", "food"],
          k: [7, 19]
        },
        tiger: {
          a: "Tiger Face",
          b: "1F42F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "cat", "danger", "wild", "nature", "roar"],
          k: [13, 25]
        },
        notes: {
          a: "Multiple Musical Notes",
          b: "1F3B6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["music", "score"],
          k: [9, 16]
        },
        flags: {
          a: "Carp Streamer",
          b: "1F38F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fish", "japanese", "koinobori", "carp", "banner"],
          k: [8, 34]
        },
        beach_with_umbrella: {
          a: "Beach with Umbrella",
          b: "1F3D6-FE0F",
          c: "1F3D6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [11, 39],
          o: 7
        },
        cherries: {
          a: "Cherries",
          b: "1F352",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "fruit"],
          k: [7, 20]
        },
        "flag-ai": {
          a: "Anguilla Flag",
          b: "1F1E6-1F1EE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [0, 36]
        },
        baggage_claim: {
          a: "Baggage Claim",
          b: "1F6C4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "airport", "transport"],
          k: [36, 45]
        },
        sunglasses: {
          a: "Smiling Face with Sunglasses",
          b: "1F60E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "cool", "smile", "summer", "beach", "sunglass"],
          k: [30, 38],
          l: ["8)"]
        },
        left_luggage: {
          a: "Left Luggage",
          b: "1F6C5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "travel"],
          k: [36, 46]
        },
        wind_chime: {
          a: "Wind Chime",
          b: "1F390",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nature", "ding", "spring", "bell"],
          k: [8, 35]
        },
        strawberry: {
          a: "Strawberry",
          b: "1F353",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fruit", "food", "nature"],
          k: [7, 21]
        },
        desert: {
          a: "Desert",
          b: "1F3DC-FE0F",
          c: "1F3DC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["photo", "warm", "saharah"],
          k: [11, 45],
          o: 7
        },
        studio_microphone: {
          a: "Studio Microphone",
          b: "1F399-FE0F",
          c: "1F399",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["sing", "recording", "artist", "talkshow"],
          k: [8, 41],
          o: 7
        },
        "flag-al": {
          a: "Albania Flag",
          b: "1F1E6-1F1F1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [0, 37]
        },
        tiger2: {
          a: "Tiger",
          b: "1F405",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "roar"],
          k: [12, 35]
        },
        heart_eyes: {
          a: "Smiling Face with Heart-Shaped Eyes",
          b: "1F60D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "love", "like", "affection", "valentines", "infatuation", "crush", "heart"],
          k: [30, 37]
        },
        desert_island: {
          a: "Desert Island",
          b: "1F3DD-FE0F",
          c: "1F3DD",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["photo", "tropical", "mojito"],
          k: [11, 46],
          o: 7
        },
        kiwifruit: {
          a: "Kiwifruit",
          b: "1F95D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 9],
          o: 9
        },
        rice_scene: {
          a: "Moon Viewing Ceremony",
          b: "1F391",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["photo", "japan", "asia", "tsukimi"],
          k: [8, 36]
        },
        kissing_heart: {
          a: "Face Throwing a Kiss",
          b: "1F618",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "love", "like", "affection", "valentines", "infatuation", "kiss"],
          k: [30, 48],
          l: [":*", ":-*"]
        },
        warning: {
          a: "Warning Sign",
          b: "26A0-FE0F",
          c: "26A0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["exclamation", "wip", "alert", "error", "problem", "issue"],
          k: [48, 20],
          o: 4
        },
        "flag-am": {
          a: "Armenia Flag",
          b: "1F1E6-1F1F2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [0, 38]
        },
        leopard: {
          a: "Leopard",
          b: "1F406",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature"],
          k: [12, 36]
        },
        level_slider: {
          a: "Level Slider",
          b: "1F39A-FE0F",
          c: "1F39A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["scale"],
          k: [8, 42],
          o: 7
        },
        horse: {
          a: "Horse Face",
          b: "1F434",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "brown", "nature"],
          k: [13, 30]
        },
        children_crossing: {
          a: "Children Crossing",
          b: "1F6B8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["school", "warning", "danger", "sign", "driving", "yellow-diamond"],
          k: [36, 28]
        },
        ribbon: {
          a: "Ribbon",
          b: "1F380",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["decoration", "pink", "girl", "bowtie"],
          k: [8, 14]
        },
        national_park: {
          a: "National Park",
          b: "1F3DE-FE0F",
          c: "1F3DE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["photo", "environment", "nature"],
          k: [11, 47],
          o: 7
        },
        control_knobs: {
          a: "Control Knobs",
          b: "1F39B-FE0F",
          c: "1F39B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["dial"],
          k: [8, 43],
          o: 7
        },
        kissing: {
          a: "Kissing Face",
          b: "1F617",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["love", "like", "face", "3", "valentines", "infatuation", "kiss"],
          k: [30, 47]
        },
        tomato: {
          a: "Tomato",
          b: "1F345",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fruit", "vegetable", "nature", "food"],
          k: [7, 7]
        },
        "flag-ao": {
          a: "Angola Flag",
          b: "1F1E6-1F1F4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [0, 39]
        },
        stadium: {
          a: "Stadium",
          b: "1F3DF-FE0F",
          c: "1F3DF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["photo", "place", "sports", "concert", "venue"],
          k: [11, 48],
          o: 7
        },
        "flag-aq": {
          a: "Antarctica Flag",
          b: "1F1E6-1F1F6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [0, 40]
        },
        gift: {
          a: "Wrapped Present",
          b: "1F381",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["present", "birthday", "christmas", "xmas"],
          k: [8, 15]
        },
        no_entry: {
          a: "No Entry",
          b: "26D4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["limit", "security", "privacy", "bad", "denied", "stop", "circle"],
          k: [48, 35],
          o: 5
        },
        kissing_smiling_eyes: {
          a: "Kissing Face with Smiling Eyes",
          b: "1F619",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "affection", "valentines", "infatuation", "kiss"],
          k: [30, 49]
        },
        coconut: {
          a: "Coconut",
          b: "1F965",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 17],
          o: 10
        },
        racehorse: {
          a: "Horse",
          b: "1F40E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "gamble", "luck"],
          k: [12, 44]
        },
        microphone: {
          a: "Microphone",
          b: "1F3A4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sound", "music", "PA", "sing", "talkshow"],
          k: [8, 50]
        },
        classical_building: {
          a: "Classical Building",
          b: "1F3DB-FE0F",
          c: "1F3DB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["art", "culture", "history"],
          k: [11, 44],
          o: 7
        },
        no_entry_sign: {
          a: "No Entry Sign",
          b: "1F6AB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["forbid", "stop", "limit", "denied", "disallow", "circle"],
          k: [35, 16]
        },
        reminder_ribbon: {
          a: "Reminder Ribbon",
          b: "1F397-FE0F",
          c: "1F397",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["sports", "cause", "support", "awareness"],
          k: [8, 40],
          o: 7
        },
        kissing_closed_eyes: {
          a: "Kissing Face with Closed Eyes",
          b: "1F61A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "love", "like", "affection", "valentines", "infatuation", "kiss"],
          k: [30, 50]
        },
        unicorn_face: {
          a: "Unicorn Face",
          b: "1F984",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 28],
          o: 8
        },
        "flag-ar": {
          a: "Argentina Flag",
          b: "1F1E6-1F1F7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [0, 41]
        },
        headphones: {
          a: "Headphone",
          b: "1F3A7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["music", "score", "gadgets"],
          k: [9, 1]
        },
        avocado: {
          a: "Avocado",
          b: "1F951",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["fruit", "food"],
          k: [41, 49],
          o: 9
        },
        relaxed: {
          a: "White Smiling Face",
          b: "263A-FE0F",
          c: "263A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "blush", "massage", "happiness"],
          k: [47, 41],
          o: 1
        },
        zebra_face: {
          a: "Zebra Face",
          b: "1F993",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 43],
          o: 10
        },
        eggplant: {
          a: "Aubergine",
          b: "1F346",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["vegetable", "nature", "food", "aubergine"],
          k: [7, 8]
        },
        radio: {
          a: "Radio",
          b: "1F4FB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["communication", "music", "podcast", "program"],
          k: [26, 50]
        },
        building_construction: {
          a: "Building Construction",
          b: "1F3D7-FE0F",
          c: "1F3D7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["wip", "working", "progress"],
          k: [11, 40],
          o: 7
        },
        "flag-as": {
          a: "American Samoa Flag",
          b: "1F1E6-1F1F8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [0, 42]
        },
        admission_tickets: {
          a: "Admission Tickets",
          b: "1F39F-FE0F",
          c: "1F39F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [8, 45],
          o: 7
        },
        no_bicycles: {
          a: "No Bicycles",
          b: "1F6B3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["cyclist", "prohibited", "circle"],
          k: [35, 24]
        },
        no_smoking: {
          a: "No Smoking Symbol",
          b: "1F6AD",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["cigarette", "blue-square", "smell", "smoke"],
          k: [35, 18]
        },
        slightly_smiling_face: {
          a: "Slightly Smiling Face",
          b: "1F642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "smile"],
          k: [31, 38],
          l: [":)", "(:", ":-)"],
          o: 7
        },
        "flag-at": {
          a: "Austria Flag",
          b: "1F1E6-1F1F9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [0, 43]
        },
        ticket: {
          a: "Ticket",
          b: "1F3AB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["event", "concert", "pass"],
          k: [9, 5]
        },
        saxophone: {
          a: "Saxophone",
          b: "1F3B7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["music", "instrument", "jazz", "blues"],
          k: [9, 17]
        },
        deer: {
          a: "Deer",
          b: "1F98C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["animal", "nature", "horns", "venison"],
          k: [42, 36],
          o: 9
        },
        house_buildings: {
          a: "House Buildings",
          b: "1F3D8-FE0F",
          c: "1F3D8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [11, 41],
          o: 7
        },
        potato: {
          a: "Potato",
          b: "1F954",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["food", "tuber", "vegatable", "starch"],
          k: [42, 0],
          o: 9
        },
        guitar: {
          a: "Guitar",
          b: "1F3B8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["music", "instrument"],
          k: [9, 18]
        },
        carrot: {
          a: "Carrot",
          b: "1F955",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["vegetable", "food", "orange"],
          k: [42, 1],
          o: 9
        },
        cityscape: {
          a: "Cityscape",
          b: "1F3D9-FE0F",
          c: "1F3D9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["photo", "night life", "urban"],
          k: [11, 42],
          o: 7
        },
        "flag-au": {
          a: "Australia Flag",
          b: "1F1E6-1F1FA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [0, 44]
        },
        do_not_litter: {
          a: "Do Not Litter Symbol",
          b: "1F6AF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["trash", "bin", "garbage", "circle"],
          k: [35, 20]
        },
        hugging_face: {
          a: "Hugging Face",
          b: "1F917",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [37, 31],
          o: 8
        },
        cow: {
          a: "Cow Face",
          b: "1F42E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["beef", "ox", "animal", "nature", "moo", "milk"],
          k: [13, 24]
        },
        medal: {
          a: "Medal",
          b: "1F396-FE0F",
          c: "1F396",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [8, 39],
          o: 7
        },
        musical_keyboard: {
          a: "Musical Keyboard",
          b: "1F3B9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["piano", "instrument", "compose"],
          k: [9, 19]
        },
        corn: {
          a: "Ear of Maize",
          b: "1F33D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "vegetable", "plant"],
          k: [6, 51]
        },
        derelict_house_building: {
          a: "Derelict House Building",
          b: "1F3DA-FE0F",
          c: "1F3DA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [11, 43],
          o: 7
        },
        "non-potable_water": {
          a: "Non-Potable Water Symbol",
          b: "1F6B1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["drink", "faucet", "tap", "circle"],
          k: [35, 22]
        },
        trophy: {
          a: "Trophy",
          b: "1F3C6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["win", "award", "contest", "place", "ftw", "ceremony"],
          k: [10, 19]
        },
        "flag-aw": {
          a: "Aruba Flag",
          b: "1F1E6-1F1FC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [0, 45]
        },
        "star-struck": {
          a: "Grinning Face with Star Eyes",
          b: "1F929",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [38, 49],
          n: ["grinning_face_with_star_eyes"],
          o: 10
        },
        ox: {
          a: "Ox",
          b: "1F402",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "cow", "beef"],
          k: [12, 32]
        },
        trumpet: {
          a: "Trumpet",
          b: "1F3BA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["music", "brass"],
          k: [9, 20]
        },
        hot_pepper: {
          a: "Hot Pepper",
          b: "1F336-FE0F",
          c: "1F336",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["food", "spicy", "chilli", "chili"],
          k: [6, 44],
          o: 7
        },
        sports_medal: {
          a: "Sports Medal",
          b: "1F3C5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [10, 18],
          o: 7
        },
        "flag-ax": {
          a: "\xc5land Islands Flag",
          b: "1F1E6-1F1FD",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [0, 46]
        },
        water_buffalo: {
          a: "Water Buffalo",
          b: "1F403",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "ox", "cow"],
          k: [12, 33]
        },
        no_pedestrians: {
          a: "No Pedestrians",
          b: "1F6B7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["rules", "crossing", "walking", "circle"],
          k: [36, 27]
        },
        thinking_face: {
          a: "Thinking Face",
          b: "1F914",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [37, 28],
          o: 8
        },
        house: {
          a: "House Building",
          b: "1F3E0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["building", "home"],
          k: [11, 49]
        },
        no_mobile_phones: {
          a: "No Mobile Phones",
          b: "1F4F5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["iphone", "mute", "circle"],
          k: [26, 44]
        },
        "flag-az": {
          a: "Azerbaijan Flag",
          b: "1F1E6-1F1FF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [0, 47]
        },
        first_place_medal: {
          a: "First Place Medal",
          b: "1F947",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [41, 42],
          o: 9
        },
        house_with_garden: {
          a: "House with Garden",
          b: "1F3E1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["home", "plant", "nature"],
          k: [11, 50]
        },
        violin: {
          a: "Violin",
          b: "1F3BB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["music", "instrument", "orchestra", "symphony"],
          k: [9, 21]
        },
        face_with_raised_eyebrow: {
          a: "Face with One Eyebrow Raised",
          b: "1F928",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [38, 48],
          n: ["face_with_one_eyebrow_raised"],
          o: 10
        },
        cucumber: {
          a: "Cucumber",
          b: "1F952",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["fruit", "food", "pickle"],
          k: [41, 50],
          o: 9
        },
        cow2: {
          a: "Cow",
          b: "1F404",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["beef", "ox", "animal", "nature", "moo", "milk"],
          k: [12, 34]
        },
        "flag-ba": {
          a: "Bosnia & Herzegovina Flag",
          b: "1F1E7-1F1E6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [0, 48]
        },
        pig: {
          a: "Pig Face",
          b: "1F437",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "oink", "nature"],
          k: [13, 33]
        },
        drum_with_drumsticks: {
          a: "Drum with Drumsticks",
          b: "1F941",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [41, 37],
          o: 9
        },
        underage: {
          a: "No One Under Eighteen Symbol",
          b: "1F51E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["18", "drink", "pub", "night", "minor", "circle"],
          k: [27, 32]
        },
        broccoli: {
          a: "Broccoli",
          b: "1F966",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 18],
          o: 10
        },
        office: {
          a: "Office Building",
          b: "1F3E2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["building", "bureau", "work"],
          k: [11, 51]
        },
        second_place_medal: {
          a: "Second Place Medal",
          b: "1F948",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [41, 43],
          o: 9
        },
        neutral_face: {
          a: "Neutral Face",
          b: "1F610",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["indifference", "meh", ":|", "neutral"],
          k: [30, 40],
          l: [":|", ":-|"]
        },
        third_place_medal: {
          a: "Third Place Medal",
          b: "1F949",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [41, 44],
          o: 9
        },
        mushroom: {
          a: "Mushroom",
          b: "1F344",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["plant", "vegetable"],
          k: [7, 6]
        },
        "flag-bb": {
          a: "Barbados Flag",
          b: "1F1E7-1F1E7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [0, 49]
        },
        radioactive_sign: {
          a: "Radioactive Sign",
          b: "2622-FE0F",
          c: "2622",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [47, 33],
          o: 1
        },
        pig2: {
          a: "Pig",
          b: "1F416",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature"],
          k: [13, 0]
        },
        expressionless: {
          a: "Expressionless Face",
          b: "1F611",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "indifferent", "-_-", "meh", "deadpan"],
          k: [30, 41]
        },
        iphone: {
          a: "Mobile Phone",
          b: "1F4F1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["technology", "apple", "gadgets", "dial"],
          k: [26, 40]
        },
        post_office: {
          a: "Japanese Post Office",
          b: "1F3E3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["building", "envelope", "communication"],
          k: [12, 0]
        },
        european_post_office: {
          a: "European Post Office",
          b: "1F3E4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["building", "email"],
          k: [12, 1]
        },
        soccer: {
          a: "Soccer Ball",
          b: "26BD",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sports", "football"],
          k: [48, 26],
          o: 5
        },
        boar: {
          a: "Boar",
          b: "1F417",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature"],
          k: [13, 1]
        },
        peanuts: {
          a: "Peanuts",
          b: "1F95C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["food", "nut"],
          k: [42, 8],
          o: 9
        },
        calling: {
          a: "Mobile Phone with Rightwards Arrow at Left",
          b: "1F4F2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["iphone", "incoming"],
          k: [26, 41]
        },
        biohazard_sign: {
          a: "Biohazard Sign",
          b: "2623-FE0F",
          c: "2623",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [47, 34],
          o: 1
        },
        "flag-bd": {
          a: "Bangladesh Flag",
          b: "1F1E7-1F1E9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [0, 50]
        },
        no_mouth: {
          a: "Face Without Mouth",
          b: "1F636",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "hellokitty"],
          k: [31, 26]
        },
        face_with_rolling_eyes: {
          a: "Face with Rolling Eyes",
          b: "1F644",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [31, 40],
          o: 8
        },
        phone: {
          a: "Black Telephone",
          b: "260E-FE0F",
          c: "260E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["technology", "communication", "dial", "telephone"],
          k: [47, 21],
          n: ["telephone"],
          o: 1
        },
        pig_nose: {
          a: "Pig Nose",
          b: "1F43D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "oink"],
          k: [13, 39]
        },
        chestnut: {
          a: "Chestnut",
          b: "1F330",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "squirrel"],
          k: [6, 38]
        },
        arrow_up: {
          a: "Upwards Black Arrow",
          b: "2B06-FE0F",
          c: "2B06",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "continue", "top", "direction"],
          k: [50, 18],
          o: 4
        },
        hospital: {
          a: "Hospital",
          b: "1F3E5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["building", "health", "surgery", "doctor"],
          k: [12, 2]
        },
        "flag-be": {
          a: "Belgium Flag",
          b: "1F1E7-1F1EA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [0, 51]
        },
        baseball: {
          a: "Baseball",
          b: "26BE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sports", "balls"],
          k: [48, 27],
          o: 5
        },
        smirk: {
          a: "Smirking Face",
          b: "1F60F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "smile", "mean", "prank", "smug", "sarcasm"],
          k: [30, 39]
        },
        arrow_upper_right: {
          a: "North East Arrow",
          b: "2197-FE0F",
          c: "2197",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "point", "direction", "diagonal", "northeast"],
          k: [46, 36],
          o: 1
        },
        "flag-bf": {
          a: "Burkina Faso Flag",
          b: "1F1E7-1F1EB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 0]
        },
        basketball: {
          a: "Basketball and Hoop",
          b: "1F3C0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sports", "balls", "NBA"],
          k: [9, 26]
        },
        ram: {
          a: "Ram",
          b: "1F40F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "sheep", "nature"],
          k: [12, 45]
        },
        bank: {
          a: "Bank",
          b: "1F3E6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["building", "money", "sales", "cash", "business", "enterprise"],
          k: [12, 3]
        },
        bread: {
          a: "Bread",
          b: "1F35E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "wheat", "breakfast", "toast"],
          k: [7, 32]
        },
        telephone_receiver: {
          a: "Telephone Receiver",
          b: "1F4DE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["technology", "communication", "dial"],
          k: [26, 21]
        },
        croissant: {
          a: "Croissant",
          b: "1F950",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["food", "bread", "french"],
          k: [41, 48],
          o: 9
        },
        pager: {
          a: "Pager",
          b: "1F4DF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["bbcall", "oldschool", "90s"],
          k: [26, 22]
        },
        sheep: {
          a: "Sheep",
          b: "1F411",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "wool", "shipit"],
          k: [12, 47]
        },
        arrow_right: {
          a: "Black Rightwards Arrow",
          b: "27A1-FE0F",
          c: "27A1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "next"],
          k: [50, 12],
          o: 1
        },
        persevere: {
          a: "Persevering Face",
          b: "1F623",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "sick", "no", "upset", "oops"],
          k: [31, 7]
        },
        "flag-bg": {
          a: "Bulgaria Flag",
          b: "1F1E7-1F1EC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 1]
        },
        volleyball: {
          a: "Volleyball",
          b: "1F3D0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["sports", "balls"],
          k: [11, 33],
          o: 8
        },
        hotel: {
          a: "Hotel",
          b: "1F3E8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["building", "accomodation", "checkin"],
          k: [12, 5]
        },
        arrow_lower_right: {
          a: "South East Arrow",
          b: "2198-FE0F",
          c: "2198",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "direction", "diagonal", "southeast"],
          k: [46, 37],
          o: 1
        },
        goat: {
          a: "Goat",
          b: "1F410",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature"],
          k: [12, 46]
        },
        "flag-bh": {
          a: "Bahrain Flag",
          b: "1F1E7-1F1ED",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 2]
        },
        love_hotel: {
          a: "Love Hotel",
          b: "1F3E9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["like", "affection", "dating"],
          k: [12, 6]
        },
        disappointed_relieved: {
          a: "Disappointed but Relieved Face",
          b: "1F625",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "phew", "sweat", "nervous"],
          k: [31, 9]
        },
        baguette_bread: {
          a: "Baguette Bread",
          b: "1F956",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["food", "bread", "french"],
          k: [42, 2],
          o: 9
        },
        football: {
          a: "American Football",
          b: "1F3C8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sports", "balls", "NFL"],
          k: [10, 26]
        },
        fax: {
          a: "Fax Machine",
          b: "1F4E0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["communication", "technology"],
          k: [26, 23]
        },
        convenience_store: {
          a: "Convenience Store",
          b: "1F3EA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["building", "shopping", "groceries"],
          k: [12, 7]
        },
        dromedary_camel: {
          a: "Dromedary Camel",
          b: "1F42A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "hot", "desert", "hump"],
          k: [13, 20]
        },
        arrow_down: {
          a: "Downwards Black Arrow",
          b: "2B07-FE0F",
          c: "2B07",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "direction", "bottom"],
          k: [50, 19],
          o: 4
        },
        battery: {
          a: "Battery",
          b: "1F50B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["power", "energy", "sustain"],
          k: [27, 13]
        },
        rugby_football: {
          a: "Rugby Football",
          b: "1F3C9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sports", "team"],
          k: [10, 27]
        },
        pretzel: {
          a: "Pretzel",
          b: "1F968",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 20],
          o: 10
        },
        open_mouth: {
          a: "Face with Open Mouth",
          b: "1F62E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "surprise", "impressed", "wow", "whoa", ":O"],
          k: [31, 18],
          l: [":o", ":-o", ":O", ":-O"]
        },
        "flag-bi": {
          a: "Burundi Flag",
          b: "1F1E7-1F1EE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 3]
        },
        "flag-bj": {
          a: "Benin Flag",
          b: "1F1E7-1F1EF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 4]
        },
        pancakes: {
          a: "Pancakes",
          b: "1F95E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["food", "breakfast", "flapjacks", "hotcakes"],
          k: [42, 10],
          o: 9
        },
        school: {
          a: "School",
          b: "1F3EB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["building", "student", "education", "learn", "teach"],
          k: [12, 8]
        },
        tennis: {
          a: "Tennis Racquet and Ball",
          b: "1F3BE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sports", "balls", "green"],
          k: [9, 24]
        },
        zipper_mouth_face: {
          a: "Zipper-Mouth Face",
          b: "1F910",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["face", "sealed", "zipper", "secret"],
          k: [37, 24],
          o: 8
        },
        camel: {
          a: "Bactrian Camel",
          b: "1F42B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "hot", "desert", "hump"],
          k: [13, 21]
        },
        arrow_lower_left: {
          a: "South West Arrow",
          b: "2199-FE0F",
          c: "2199",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "direction", "diagonal", "southwest"],
          k: [46, 38],
          o: 1
        },
        electric_plug: {
          a: "Electric Plug",
          b: "1F50C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["charger", "power"],
          k: [27, 14]
        },
        cheese_wedge: {
          a: "Cheese Wedge",
          b: "1F9C0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 48],
          o: 8
        },
        hushed: {
          a: "Hushed Face",
          b: "1F62F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "woo", "shh"],
          k: [31, 19]
        },
        computer: {
          a: "Personal Computer",
          b: "1F4BB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["technology", "laptop", "screen", "display", "monitor"],
          k: [25, 38]
        },
        giraffe_face: {
          a: "Giraffe Face",
          b: "1F992",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 42],
          o: 10
        },
        "8ball": {
          a: "Billiards",
          b: "1F3B1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["pool", "hobby", "game", "luck", "magic"],
          k: [9, 11]
        },
        "flag-bl": {
          a: "St. Barth\xe9lemy Flag",
          b: "1F1E7-1F1F1",
          d: !0,
          e: !1,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 5]
        },
        arrow_left: {
          a: "Leftwards Black Arrow",
          b: "2B05-FE0F",
          c: "2B05",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "previous", "back"],
          k: [50, 17],
          o: 4
        },
        department_store: {
          a: "Department Store",
          b: "1F3EC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["building", "shopping", "mall"],
          k: [12, 9]
        },
        meat_on_bone: {
          a: "Meat on Bone",
          b: "1F356",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["good", "food", "drumstick"],
          k: [7, 24]
        },
        arrow_upper_left: {
          a: "North West Arrow",
          b: "2196-FE0F",
          c: "2196",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "point", "direction", "diagonal", "northwest"],
          k: [46, 35],
          o: 1
        },
        "flag-bm": {
          a: "Bermuda Flag",
          b: "1F1E7-1F1F2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 6]
        },
        sleepy: {
          a: "Sleepy Face",
          b: "1F62A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "tired", "rest", "nap"],
          k: [31, 14]
        },
        bowling: {
          a: "Bowling",
          b: "1F3B3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sports", "fun", "play"],
          k: [9, 13]
        },
        factory: {
          a: "Factory",
          b: "1F3ED",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["building", "industry", "pollution", "smoke"],
          k: [12, 10]
        },
        desktop_computer: {
          a: "Desktop Computer",
          b: "1F5A5-FE0F",
          c: "1F5A5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["technology", "computing", "screen"],
          k: [29, 51],
          o: 7
        },
        elephant: {
          a: "Elephant",
          b: "1F418",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "nose", "th", "circus"],
          k: [13, 2]
        },
        rhinoceros: {
          a: "Rhinoceros",
          b: "1F98F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["animal", "nature", "horn"],
          k: [42, 39],
          o: 9
        },
        arrow_up_down: {
          a: "Up Down Arrow",
          b: "2195-FE0F",
          c: "2195",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "direction", "way", "vertical"],
          k: [46, 34],
          o: 1
        },
        cricket_bat_and_ball: {
          a: "Cricket Bat and Ball",
          b: "1F3CF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [11, 32],
          o: 8
        },
        printer: {
          a: "Printer",
          b: "1F5A8-FE0F",
          c: "1F5A8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["paper", "ink"],
          k: [30, 0],
          o: 7
        },
        poultry_leg: {
          a: "Poultry Leg",
          b: "1F357",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "meat", "drumstick", "bird", "chicken", "turkey"],
          k: [7, 25]
        },
        tired_face: {
          a: "Tired Face",
          b: "1F62B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sick", "whine", "upset", "frustrated"],
          k: [31, 15]
        },
        japanese_castle: {
          a: "Japanese Castle",
          b: "1F3EF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["photo", "building"],
          k: [12, 12]
        },
        "flag-bn": {
          a: "Brunei Flag",
          b: "1F1E7-1F1F3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [1, 7]
        },
        field_hockey_stick_and_ball: {
          a: "Field Hockey Stick and Ball",
          b: "1F3D1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [11, 34],
          o: 8
        },
        sleeping: {
          a: "Sleeping Face",
          b: "1F634",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "tired", "sleepy", "night", "zzz"],
          k: [31, 24]
        },
        left_right_arrow: {
          a: "Left Right Arrow",
          b: "2194-FE0F",
          c: "2194",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shape", "direction", "horizontal", "sideways"],
          k: [46, 33],
          o: 1
        },
        keyboard: {
          a: "Keyboard",
          b: "2328-FE0F",
          c: "2328",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["technology", "computer", "type", "input", "text"],
          k: [46, 43],
          o: 1
        },
        european_castle: {
          a: "European Castle",
          b: "1F3F0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["building", "royalty", "history"],
          k: [12, 13]
        },
        mouse: {
          a: "Mouse Face",
          b: "1F42D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "cheese_wedge", "rodent"],
          k: [13, 23]
        },
        "flag-bo": {
          a: "Bolivia Flag",
          b: "1F1E7-1F1F4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 8]
        },
        cut_of_meat: {
          a: "Cut of Meat",
          b: "1F969",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 21],
          o: 10
        },
        ice_hockey_stick_and_puck: {
          a: "Ice Hockey Stick and Puck",
          b: "1F3D2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [11, 35],
          o: 8
        },
        mouse2: {
          a: "Mouse",
          b: "1F401",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "rodent"],
          k: [12, 31]
        },
        three_button_mouse: {
          a: "Three Button Mouse",
          b: "1F5B1-FE0F",
          c: "1F5B1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [30, 1],
          o: 7
        },
        leftwards_arrow_with_hook: {
          a: "Leftwards Arrow with Hook",
          b: "21A9-FE0F",
          c: "21A9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["back", "return", "blue-square", "undo", "enter"],
          k: [46, 39],
          o: 1
        },
        bacon: {
          a: "Bacon",
          b: "1F953",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["food", "breakfast", "pork", "pig", "meat"],
          k: [41, 51],
          o: 9
        },
        relieved: {
          a: "Relieved Face",
          b: "1F60C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "relaxed", "phew", "massage", "happiness"],
          k: [30, 36]
        },
        "flag-bq": {
          a: "Caribbean Netherlands Flag",
          b: "1F1E7-1F1F6",
          d: !0,
          e: !1,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 9]
        },
        wedding: {
          a: "Wedding",
          b: "1F492",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["love", "like", "affection", "couple", "marriage", "bride", "groom"],
          k: [24, 44]
        },
        tokyo_tower: {
          a: "Tokyo Tower",
          b: "1F5FC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["photo", "japanese"],
          k: [30, 20]
        },
        arrow_right_hook: {
          a: "Rightwards Arrow with Hook",
          b: "21AA-FE0F",
          c: "21AA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "return", "rotate", "direction"],
          k: [46, 40],
          o: 1
        },
        hamburger: {
          a: "Hamburger",
          b: "1F354",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["meat", "fast food", "beef", "cheeseburger", "mcdonalds", "burger king"],
          k: [7, 22]
        },
        stuck_out_tongue: {
          a: "Face with Stuck-out Tongue",
          b: "1F61B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "prank", "childish", "playful", "mischievous", "smile", "tongue"],
          k: [30, 51],
          l: [":p", ":-p", ":P", ":-P", ":b", ":-b"],
          m: ":p"
        },
        trackball: {
          a: "Trackball",
          b: "1F5B2-FE0F",
          c: "1F5B2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["technology", "trackpad"],
          k: [30, 2],
          o: 7
        },
        "flag-br": {
          a: "Brazil Flag",
          b: "1F1E7-1F1F7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 10]
        },
        rat: {
          a: "Rat",
          b: "1F400",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "mouse", "rodent"],
          k: [12, 30]
        },
        table_tennis_paddle_and_ball: {
          a: "Table Tennis Paddle and Ball",
          b: "1F3D3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [11, 36],
          o: 8
        },
        minidisc: {
          a: "Minidisc",
          b: "1F4BD",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["technology", "record", "data", "disk", "90s"],
          k: [25, 40]
        },
        stuck_out_tongue_winking_eye: {
          a: "Face with Stuck-out Tongue and Winking Eye",
          b: "1F61C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "prank", "childish", "playful", "mischievous", "smile", "wink", "tongue"],
          k: [31, 0],
          l: [";p", ";-p", ";b", ";-b", ";P", ";-P"],
          m: ";p"
        },
        fries: {
          a: "French Fries",
          b: "1F35F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["chips", "snack", "fast food"],
          k: [7, 33]
        },
        badminton_racquet_and_shuttlecock: {
          a: "Badminton Racquet and Shuttlecock",
          b: "1F3F8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [12, 22],
          o: 8
        },
        statue_of_liberty: {
          a: "Statue of Liberty",
          b: "1F5FD",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["american", "newyork"],
          k: [30, 21]
        },
        "flag-bs": {
          a: "Bahamas Flag",
          b: "1F1E7-1F1F8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 11]
        },
        arrow_heading_up: {
          a: "Arrow Pointing Rightwards Then Curving Upwards",
          b: "2934-FE0F",
          c: "2934",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "direction", "top"],
          k: [50, 15],
          o: 3
        },
        hamster: {
          a: "Hamster Face",
          b: "1F439",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature"],
          k: [13, 35]
        },
        stuck_out_tongue_closed_eyes: {
          a: "Face with Stuck-out Tongue and Tightly-Closed Eyes",
          b: "1F61D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "prank", "playful", "mischievous", "smile", "tongue"],
          k: [31, 1]
        },
        pizza: {
          a: "Slice of Pizza",
          b: "1F355",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "party"],
          k: [7, 23]
        },
        boxing_glove: {
          a: "Boxing Glove",
          b: "1F94A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["sports", "fighting"],
          k: [41, 45],
          o: 9
        },
        floppy_disk: {
          a: "Floppy Disk",
          b: "1F4BE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["oldschool", "technology", "save", "90s", "80s"],
          k: [25, 41]
        },
        arrow_heading_down: {
          a: "Arrow Pointing Rightwards Then Curving Downwards",
          b: "2935-FE0F",
          c: "2935",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "direction", "bottom"],
          k: [50, 16],
          o: 3
        },
        "flag-bt": {
          a: "Bhutan Flag",
          b: "1F1E7-1F1F9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 12]
        },
        rabbit: {
          a: "Rabbit Face",
          b: "1F430",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "pet", "spring", "magic", "bunny"],
          k: [13, 26]
        },
        church: {
          a: "Church",
          b: "26EA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["building", "religion", "christ"],
          k: [48, 37],
          o: 5
        },
        drooling_face: {
          a: "Drooling Face",
          b: "1F924",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["face"],
          k: [38, 27],
          o: 9
        },
        "flag-bv": {
          a: "Bouvet Island Flag",
          b: "1F1E7-1F1FB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 13]
        },
        mosque: {
          a: "Mosque",
          b: "1F54C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["islam", "worship", "minaret"],
          k: [28, 15],
          o: 8
        },
        rabbit2: {
          a: "Rabbit",
          b: "1F407",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "pet", "magic", "spring"],
          k: [12, 37]
        },
        hotdog: {
          a: "Hot Dog",
          b: "1F32D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["food", "frankfurter"],
          k: [6, 35],
          o: 8
        },
        martial_arts_uniform: {
          a: "Martial Arts Uniform",
          b: "1F94B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["judo", "karate", "taekwondo"],
          k: [41, 46],
          o: 9
        },
        arrows_clockwise: {
          a: "Clockwise Downwards and Upwards Open Circle Arrows",
          b: "1F503",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sync", "cycle", "round", "repeat"],
          k: [27, 5]
        },
        cd: {
          a: "Optical Disc",
          b: "1F4BF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["technology", "dvd", "disk", "disc", "90s"],
          k: [25, 42]
        },
        arrows_counterclockwise: {
          a: "Anticlockwise Downwards and Upwards Open Circle Arrows",
          b: "1F504",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "sync", "cycle"],
          k: [27, 6]
        },
        sandwich: {
          a: "Sandwich",
          b: "1F96A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 22],
          o: 10
        },
        chipmunk: {
          a: "Chipmunk",
          b: "1F43F-FE0F",
          c: "1F43F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["animal", "nature", "rodent", "squirrel"],
          k: [13, 41],
          o: 7
        },
        synagogue: {
          a: "Synagogue",
          b: "1F54D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["judaism", "worship", "temple", "jewish"],
          k: [28, 16],
          o: 8
        },
        unamused: {
          a: "Unamused Face",
          b: "1F612",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["indifference", "bored", "straight face", "serious", "sarcasm"],
          k: [30, 42],
          m: ":("
        },
        goal_net: {
          a: "Goal Net",
          b: "1F945",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["sports"],
          k: [41, 41],
          o: 9
        },
        "flag-bw": {
          a: "Botswana Flag",
          b: "1F1E7-1F1FC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 14]
        },
        dvd: {
          a: "Dvd",
          b: "1F4C0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["cd", "disk", "disc"],
          k: [25, 43]
        },
        hedgehog: {
          a: "Hedgehog",
          b: "1F994",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 44],
          o: 10
        },
        dart: {
          a: "Direct Hit",
          b: "1F3AF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["game", "play", "bar"],
          k: [9, 9]
        },
        taco: {
          a: "Taco",
          b: "1F32E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["food", "mexican"],
          k: [6, 36],
          o: 8
        },
        back: {
          a: "Back with Leftwards Arrow Above",
          b: "1F519",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["arrow", "words", "return"],
          k: [27, 27]
        },
        "flag-by": {
          a: "Belarus Flag",
          b: "1F1E7-1F1FE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 15]
        },
        shinto_shrine: {
          a: "Shinto Shrine",
          b: "26E9-FE0F",
          c: "26E9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["temple", "japan", "kyoto"],
          k: [48, 36],
          o: 5
        },
        movie_camera: {
          a: "Movie Camera",
          b: "1F3A5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["film", "record"],
          k: [8, 51]
        },
        sweat: {
          a: "Face with Cold Sweat",
          b: "1F613",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "hot", "sad", "tired", "exercise"],
          k: [30, 43]
        },
        burrito: {
          a: "Burrito",
          b: "1F32F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["food", "mexican"],
          k: [6, 37],
          o: 8
        },
        "flag-bz": {
          a: "Belize Flag",
          b: "1F1E7-1F1FF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 16]
        },
        pensive: {
          a: "Pensive Face",
          b: "1F614",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "sad", "depressed", "upset"],
          k: [30, 44]
        },
        kaaba: {
          a: "Kaaba",
          b: "1F54B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["mecca", "mosque", "islam"],
          k: [28, 14],
          o: 8
        },
        film_frames: {
          a: "Film Frames",
          b: "1F39E-FE0F",
          c: "1F39E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [8, 44],
          o: 7
        },
        bat: {
          a: "Bat",
          b: "1F987",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["animal", "nature", "blind", "vampire"],
          k: [42, 31],
          o: 9
        },
        golf: {
          a: "Flag in Hole",
          b: "26F3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sports", "business", "flag", "hole", "summer"],
          k: [48, 41],
          o: 5
        },
        end: {
          a: "End with Leftwards Arrow Above",
          b: "1F51A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["words", "arrow"],
          k: [27, 28]
        },
        film_projector: {
          a: "Film Projector",
          b: "1F4FD-FE0F",
          c: "1F4FD",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["video", "tape", "record", "movie"],
          k: [27, 0],
          o: 7
        },
        bear: {
          a: "Bear Face",
          b: "1F43B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "wild"],
          k: [13, 37]
        },
        ice_skate: {
          a: "Ice Skate",
          b: "26F8-FE0F",
          c: "26F8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["sports"],
          k: [48, 45],
          o: 5
        },
        fountain: {
          a: "Fountain",
          b: "26F2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["photo", "summer", "water", "fresh"],
          k: [48, 40],
          o: 5
        },
        confused: {
          a: "Confused Face",
          b: "1F615",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "indifference", "huh", "weird", "hmmm", ":/"],
          k: [30, 45],
          l: [":\\", ":-\\", ":/", ":-/"]
        },
        "flag-ca": {
          a: "Canada Flag",
          b: "1F1E8-1F1E6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 17]
        },
        on: {
          a: "On with Exclamation Mark with Left Right Arrow Above",
          b: "1F51B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["arrow", "words"],
          k: [27, 29]
        },
        stuffed_flatbread: {
          a: "Stuffed Flatbread",
          b: "1F959",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["food", "flatbread", "stuffed", "gyro"],
          k: [42, 5],
          o: 9
        },
        soon: {
          a: "Soon with Rightwards Arrow Above",
          b: "1F51C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["arrow", "words"],
          k: [27, 30]
        },
        upside_down_face: {
          a: "Upside-Down Face",
          b: "1F643",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["face", "flipped", "silly", "smile"],
          k: [31, 39],
          o: 8
        },
        fishing_pole_and_fish: {
          a: "Fishing Pole and Fish",
          b: "1F3A3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "hobby", "summer"],
          k: [8, 49]
        },
        tent: {
          a: "Tent",
          b: "26FA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["photo", "camping", "outdoors"],
          k: [49, 12],
          o: 5
        },
        clapper: {
          a: "Clapper Board",
          b: "1F3AC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["movie", "film", "record"],
          k: [9, 6]
        },
        egg: {
          a: "Egg",
          b: "1F95A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["food", "chicken", "breakfast"],
          k: [42, 6],
          o: 9
        },
        "flag-cc": {
          a: "Cocos (keeling) Islands Flag",
          b: "1F1E8-1F1E8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 18]
        },
        koala: {
          a: "Koala",
          b: "1F428",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature"],
          k: [13, 18]
        },
        foggy: {
          a: "Foggy",
          b: "1F301",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["photo", "mountain"],
          k: [5, 45]
        },
        tv: {
          a: "Television",
          b: "1F4FA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["technology", "program", "oldschool", "show", "television"],
          k: [26, 49]
        },
        panda_face: {
          a: "Panda Face",
          b: "1F43C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "panda"],
          k: [13, 38]
        },
        fried_egg: {
          a: "Cooking",
          b: "1F373",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "breakfast", "kitchen", "egg"],
          k: [8, 1],
          n: ["cooking"]
        },
        top: {
          a: "Top with Upwards Arrow Above",
          b: "1F51D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["words", "blue-square"],
          k: [27, 31]
        },
        "flag-cd": {
          a: "Congo - Kinshasa Flag",
          b: "1F1E8-1F1E9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 19]
        },
        money_mouth_face: {
          a: "Money-Mouth Face",
          b: "1F911",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["face", "rich", "dollar", "money"],
          k: [37, 25],
          o: 8
        },
        running_shirt_with_sash: {
          a: "Running Shirt with Sash",
          b: "1F3BD",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["play", "pageant"],
          k: [9, 23]
        },
        astonished: {
          a: "Astonished Face",
          b: "1F632",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "xox", "surprised", "poisoned"],
          k: [31, 22]
        },
        feet: {
          a: "Paw Prints",
          b: "1F43E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [13, 40],
          n: ["paw_prints"]
        },
        camera: {
          a: "Camera",
          b: "1F4F7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["gadgets", "photography"],
          k: [26, 46]
        },
        "flag-cf": {
          a: "Central African Republic Flag",
          b: "1F1E8-1F1EB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 20]
        },
        place_of_worship: {
          a: "Place of Worship",
          b: "1F6D0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["religion", "church", "temple", "prayer"],
          k: [37, 5],
          o: 8
        },
        night_with_stars: {
          a: "Night with Stars",
          b: "1F303",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["evening", "city", "downtown"],
          k: [5, 47]
        },
        ski: {
          a: "Ski and Ski Boot",
          b: "1F3BF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sports", "winter", "cold", "snow"],
          k: [9, 25]
        },
        shallow_pan_of_food: {
          a: "Shallow Pan of Food",
          b: "1F958",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["food", "cooking", "casserole", "paella"],
          k: [42, 4],
          o: 9
        },
        camera_with_flash: {
          a: "Camera with Flash",
          b: "1F4F8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [26, 47],
          o: 7
        },
        sunrise_over_mountains: {
          a: "Sunrise over Mountains",
          b: "1F304",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["view", "vacation", "photo"],
          k: [5, 48]
        },
        turkey: {
          a: "Turkey",
          b: "1F983",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["animal", "bird"],
          k: [42, 27],
          o: 8
        },
        white_frowning_face: {
          a: "White Frowning Face",
          b: "2639-FE0F",
          c: "2639",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [47, 40],
          o: 1
        },
        "flag-cg": {
          a: "Congo - Brazzaville Flag",
          b: "1F1E8-1F1EC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 21]
        },
        stew: {
          a: "Pot of Food",
          b: "1F372",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "meat", "soup"],
          k: [8, 0]
        },
        sled: {
          a: "Sled",
          b: "1F6F7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [37, 22],
          o: 10
        },
        atom_symbol: {
          a: "Atom Symbol",
          b: "269B-FE0F",
          c: "269B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["science", "physics", "chemistry"],
          k: [48, 18],
          o: 4
        },
        curling_stone: {
          a: "Curling Stone",
          b: "1F94C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [41, 47],
          o: 10
        },
        slightly_frowning_face: {
          a: "Slightly Frowning Face",
          b: "1F641",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["face", "frowning", "disappointed", "sad", "upset"],
          k: [31, 37],
          o: 7
        },
        sunrise: {
          a: "Sunrise",
          b: "1F305",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["morning", "view", "vacation", "photo"],
          k: [5, 49]
        },
        om_symbol: {
          a: "Om Symbol",
          b: "1F549-FE0F",
          c: "1F549",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [28, 12],
          o: 7
        },
        chicken: {
          a: "Chicken",
          b: "1F414",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "cluck", "nature", "bird"],
          k: [12, 50]
        },
        bowl_with_spoon: {
          a: "Bowl with Spoon",
          b: "1F963",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 15],
          o: 10
        },
        "flag-ch": {
          a: "Switzerland Flag",
          b: "1F1E8-1F1ED",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 22]
        },
        video_camera: {
          a: "Video Camera",
          b: "1F4F9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["film", "record"],
          k: [26, 48]
        },
        video_game: {
          a: "Video Game",
          b: "1F3AE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["play", "console", "PS4", "controller"],
          k: [9, 8]
        },
        rooster: {
          a: "Rooster",
          b: "1F413",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "chicken"],
          k: [12, 49]
        },
        vhs: {
          a: "Videocassette",
          b: "1F4FC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["record", "video", "oldschool", "90s", "80s"],
          k: [26, 51]
        },
        city_sunset: {
          a: "Cityscape at Dusk",
          b: "1F306",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["photo", "evening", "sky", "buildings"],
          k: [5, 50]
        },
        confounded: {
          a: "Confounded Face",
          b: "1F616",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "confused", "sick", "unwell", "oops", ":S"],
          k: [30, 46]
        },
        green_salad: {
          a: "Green Salad",
          b: "1F957",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["food", "healthy", "lettuce"],
          k: [42, 3],
          o: 9
        },
        star_of_david: {
          a: "Star of David",
          b: "2721-FE0F",
          c: "2721",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["judaism"],
          k: [49, 47],
          o: 1
        },
        "flag-ci": {
          a: "C\xF4te D\u2019ivoire Flag",
          b: "1F1E8-1F1EE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 23]
        },
        popcorn: {
          a: "Popcorn",
          b: "1F37F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["food", "movie theater", "films", "snack"],
          k: [8, 13],
          o: 8
        },
        city_sunrise: {
          a: "Sunset over Buildings",
          b: "1F307",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["photo", "good morning", "dawn"],
          k: [5, 51]
        },
        disappointed: {
          a: "Disappointed Face",
          b: "1F61E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "sad", "upset", "depressed", ":("],
          k: [31, 2],
          l: ["):", ":(", ":-("],
          m: ":("
        },
        mag: {
          a: "Left-Pointing Magnifying Glass",
          b: "1F50D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["search", "zoom", "find", "detective"],
          k: [27, 15]
        },
        hatching_chick: {
          a: "Hatching Chick",
          b: "1F423",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "chicken", "egg", "born", "baby", "bird"],
          k: [13, 13]
        },
        joystick: {
          a: "Joystick",
          b: "1F579-FE0F",
          c: "1F579",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["game", "play"],
          k: [29, 20],
          o: 7
        },
        wheel_of_dharma: {
          a: "Wheel of Dharma",
          b: "2638-FE0F",
          c: "2638",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["hinduism", "buddhism", "sikhism", "jainism"],
          k: [47, 39],
          o: 1
        },
        "flag-ck": {
          a: "Cook Islands Flag",
          b: "1F1E8-1F1F0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 24]
        },
        canned_food: {
          a: "Canned Food",
          b: "1F96B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 23],
          o: 10
        },
        worried: {
          a: "Worried Face",
          b: "1F61F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "concern", "nervous", ":("],
          k: [31, 3]
        },
        baby_chick: {
          a: "Baby Chick",
          b: "1F424",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "chicken", "bird"],
          k: [13, 14]
        },
        "flag-cl": {
          a: "Chile Flag",
          b: "1F1E8-1F1F1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 25]
        },
        game_die: {
          a: "Game Die",
          b: "1F3B2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["dice", "random", "tabletop", "play", "luck"],
          k: [9, 12]
        },
        mag_right: {
          a: "Right-Pointing Magnifying Glass",
          b: "1F50E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["search", "zoom", "find", "detective"],
          k: [27, 16]
        },
        yin_yang: {
          a: "Yin Yang",
          b: "262F-FE0F",
          c: "262F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["balance"],
          k: [47, 38],
          o: 1
        },
        bridge_at_night: {
          a: "Bridge at Night",
          b: "1F309",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["photo", "sanfrancisco"],
          k: [6, 1]
        },
        spades: {
          a: "Black Spade Suit",
          b: "2660-FE0F",
          c: "2660",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["poker", "cards", "suits", "magic"],
          k: [48, 4],
          o: 1
        },
        hatched_chick: {
          a: "Front-Facing Baby Chick",
          b: "1F425",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "chicken", "baby", "bird"],
          k: [13, 15]
        },
        "flag-cm": {
          a: "Cameroon Flag",
          b: "1F1E8-1F1F2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 26]
        },
        latin_cross: {
          a: "Latin Cross",
          b: "271D-FE0F",
          c: "271D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["christianity"],
          k: [49, 46],
          o: 1
        },
        triumph: {
          a: "Face with Look of Triumph",
          b: "1F624",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "gas", "phew", "proud", "pride"],
          k: [31, 8]
        },
        hotsprings: {
          a: "Hot Springs",
          b: "2668-FE0F",
          c: "2668",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["bath", "warm", "relax"],
          k: [48, 8],
          o: 1
        },
        bento: {
          a: "Bento Box",
          b: "1F371",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "japanese", "box"],
          k: [7, 51]
        },
        microscope: {
          a: "Microscope",
          b: "1F52C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["laboratory", "experiment", "zoomin", "science", "study"],
          k: [27, 46]
        },
        cry: {
          a: "Crying Face",
          b: "1F622",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "tears", "sad", "depressed", "upset", ":'("],
          k: [31, 6],
          l: [":'("],
          m: ":'("
        },
        bird: {
          a: "Bird",
          b: "1F426",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "fly", "tweet", "spring"],
          k: [13, 16]
        },
        cn: {
          a: "China Flag",
          b: "1F1E8-1F1F3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["china", "chinese", "prc", "flag", "country", "nation", "banner"],
          k: [1, 27],
          n: ["flag-cn"]
        },
        telescope: {
          a: "Telescope",
          b: "1F52D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["stars", "space", "zoom", "science", "astronomy"],
          k: [27, 47]
        },
        rice_cracker: {
          a: "Rice Cracker",
          b: "1F358",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "japanese"],
          k: [7, 26]
        },
        hearts: {
          a: "Black Heart Suit",
          b: "2665-FE0F",
          c: "2665",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["poker", "cards", "magic", "suits"],
          k: [48, 6],
          o: 1
        },
        orthodox_cross: {
          a: "Orthodox Cross",
          b: "2626-FE0F",
          c: "2626",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["suppedaneum", "religion"],
          k: [47, 35],
          o: 1
        },
        milky_way: {
          a: "Milky Way",
          b: "1F30C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["photo", "space", "stars"],
          k: [6, 4]
        },
        rice_ball: {
          a: "Rice Ball",
          b: "1F359",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "japanese"],
          k: [7, 27]
        },
        satellite_antenna: {
          a: "Satellite Antenna",
          b: "1F4E1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [26, 24]
        },
        "flag-co": {
          a: "Colombia Flag",
          b: "1F1E8-1F1F4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 28]
        },
        carousel_horse: {
          a: "Carousel Horse",
          b: "1F3A0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["photo", "carnival"],
          k: [8, 46]
        },
        sob: {
          a: "Loudly Crying Face",
          b: "1F62D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "cry", "tears", "sad", "upset", "depressed"],
          k: [31, 17],
          m: ":'("
        },
        diamonds: {
          a: "Black Diamond Suit",
          b: "2666-FE0F",
          c: "2666",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["poker", "cards", "magic", "suits"],
          k: [48, 7],
          o: 1
        },
        star_and_crescent: {
          a: "Star and Crescent",
          b: "262A-FE0F",
          c: "262A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["islam"],
          k: [47, 36],
          o: 1
        },
        penguin: {
          a: "Penguin",
          b: "1F427",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature"],
          k: [13, 17]
        },
        dove_of_peace: {
          a: "Dove of Peace",
          b: "1F54A-FE0F",
          c: "1F54A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [28, 13],
          o: 7
        },
        "flag-cp": {
          a: "Clipperton Island Flag",
          b: "1F1E8-1F1F5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [1, 29]
        },
        ferris_wheel: {
          a: "Ferris Wheel",
          b: "1F3A1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["photo", "carnival", "londoneye"],
          k: [8, 47]
        },
        clubs: {
          a: "Black Club Suit",
          b: "2663-FE0F",
          c: "2663",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["poker", "cards", "magic", "suits"],
          k: [48, 5],
          o: 1
        },
        peace_symbol: {
          a: "Peace Symbol",
          b: "262E-FE0F",
          c: "262E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["hippie"],
          k: [47, 37],
          o: 1
        },
        candle: {
          a: "Candle",
          b: "1F56F-FE0F",
          c: "1F56F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["fire", "wax"],
          k: [28, 42],
          o: 7
        },
        frowning: {
          a: "Frowning Face with Open Mouth",
          b: "1F626",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "aw", "what"],
          k: [31, 10]
        },
        rice: {
          a: "Cooked Rice",
          b: "1F35A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "china", "asian"],
          k: [7, 28]
        },
        "flag-cr": {
          a: "Costa Rica Flag",
          b: "1F1E8-1F1F7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 30]
        },
        roller_coaster: {
          a: "Roller Coaster",
          b: "1F3A2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["carnival", "playground", "photo", "fun"],
          k: [8, 48]
        },
        menorah_with_nine_branches: {
          a: "Menorah with Nine Branches",
          b: "1F54E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [28, 17],
          o: 8
        },
        black_joker: {
          a: "Playing Card Black Joker",
          b: "1F0CF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["poker", "cards", "game", "play", "magic"],
          k: [0, 15]
        },
        eagle: {
          a: "Eagle",
          b: "1F985",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["animal", "nature", "bird"],
          k: [42, 29],
          o: 9
        },
        curry: {
          a: "Curry and Rice",
          b: "1F35B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "spicy", "hot", "indian"],
          k: [7, 29]
        },
        bulb: {
          a: "Electric Light Bulb",
          b: "1F4A1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["light", "electricity", "idea"],
          k: [25, 7]
        },
        anguished: {
          a: "Anguished Face",
          b: "1F627",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "stunned", "nervous"],
          k: [31, 11],
          l: ["D:"]
        },
        "flag-cu": {
          a: "Cuba Flag",
          b: "1F1E8-1F1FA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 31]
        },
        barber: {
          a: "Barber Pole",
          b: "1F488",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["hair", "salon", "style"],
          k: [24, 34]
        },
        duck: {
          a: "Duck",
          b: "1F986",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["animal", "nature", "bird", "mallard"],
          k: [42, 30],
          o: 9
        },
        six_pointed_star: {
          a: "Six Pointed Star with Middle Dot",
          b: "1F52F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["purple-square", "religion", "jewish", "hexagram"],
          k: [27, 49]
        },
        ramen: {
          a: "Steaming Bowl",
          b: "1F35C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "japanese", "noodle", "chopsticks"],
          k: [7, 30]
        },
        flashlight: {
          a: "Electric Torch",
          b: "1F526",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["dark", "camping", "sight", "night"],
          k: [27, 40]
        },
        mahjong: {
          a: "Mahjong Tile Red Dragon",
          b: "1F004",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["game", "play", "chinese", "kanji"],
          k: [0, 14],
          o: 5
        },
        fearful: {
          a: "Fearful Face",
          b: "1F628",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "scared", "terrified", "nervous", "oops", "huh"],
          k: [31, 12]
        },
        aries: {
          a: "Aries",
          b: "2648",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sign", "purple-square", "zodiac", "astrology"],
          k: [47, 44],
          o: 1
        },
        spaghetti: {
          a: "Spaghetti",
          b: "1F35D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "italian", "noodle"],
          k: [7, 31]
        },
        circus_tent: {
          a: "Circus Tent",
          b: "1F3AA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["festival", "carnival", "party"],
          k: [9, 4]
        },
        izakaya_lantern: {
          a: "Izakaya Lantern",
          b: "1F3EE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["light", "paper", "halloween", "spooky"],
          k: [12, 11],
          n: ["lantern"]
        },
        "flag-cv": {
          a: "Cape Verde Flag",
          b: "1F1E8-1F1FB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 32]
        },
        weary: {
          a: "Weary Face",
          b: "1F629",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "tired", "sleepy", "sad", "frustrated", "upset"],
          k: [31, 13]
        },
        flower_playing_cards: {
          a: "Flower Playing Cards",
          b: "1F3B4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["game", "sunset", "red"],
          k: [9, 14]
        },
        owl: {
          a: "Owl",
          b: "1F989",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["animal", "nature", "bird", "hoot"],
          k: [42, 33],
          o: 9
        },
        performing_arts: {
          a: "Performing Arts",
          b: "1F3AD",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["acting", "theater", "drama"],
          k: [9, 7]
        },
        frog: {
          a: "Frog Face",
          b: "1F438",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "croak", "toad"],
          k: [13, 34]
        },
        "flag-cw": {
          a: "Cura\xe7ao Flag",
          b: "1F1E8-1F1FC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 33]
        },
        notebook_with_decorative_cover: {
          a: "Notebook with Decorative Cover",
          b: "1F4D4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["classroom", "notes", "record", "paper", "study"],
          k: [26, 11]
        },
        exploding_head: {
          a: "Shocked Face with Exploding Head",
          b: "1F92F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [39, 3],
          n: ["shocked_face_with_exploding_head"],
          o: 10
        },
        taurus: {
          a: "Taurus",
          b: "2649",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["purple-square", "sign", "zodiac", "astrology"],
          k: [47, 45],
          o: 1
        },
        sweet_potato: {
          a: "Roasted Sweet Potato",
          b: "1F360",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "nature"],
          k: [7, 34]
        },
        closed_book: {
          a: "Closed Book",
          b: "1F4D5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["read", "library", "knowledge", "textbook", "learn"],
          k: [26, 12]
        },
        gemini: {
          a: "Gemini",
          b: "264A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sign", "zodiac", "purple-square", "astrology"],
          k: [47, 46],
          o: 1
        },
        frame_with_picture: {
          a: "Frame with Picture",
          b: "1F5BC-FE0F",
          c: "1F5BC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [30, 3],
          o: 7
        },
        "flag-cx": {
          a: "Christmas Island Flag",
          b: "1F1E8-1F1FD",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 34]
        },
        grimacing: {
          a: "Grimacing Face",
          b: "1F62C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "grimace", "teeth"],
          k: [31, 16]
        },
        crocodile: {
          a: "Crocodile",
          b: "1F40A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "reptile", "lizard", "alligator"],
          k: [12, 40]
        },
        oden: {
          a: "Oden",
          b: "1F362",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "japanese"],
          k: [7, 36]
        },
        "flag-cy": {
          a: "Cyprus Flag",
          b: "1F1E8-1F1FE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 35]
        },
        book: {
          a: "Open Book",
          b: "1F4D6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [26, 13],
          n: ["open_book"]
        },
        turtle: {
          a: "Turtle",
          b: "1F422",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "slow", "nature", "tortoise"],
          k: [13, 12]
        },
        art: {
          a: "Artist Palette",
          b: "1F3A8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["design", "paint", "draw", "colors"],
          k: [9, 2]
        },
        sushi: {
          a: "Sushi",
          b: "1F363",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "fish", "japanese", "rice"],
          k: [7, 37]
        },
        cold_sweat: {
          a: "Face with Open Mouth and Cold Sweat",
          b: "1F630",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "nervous", "sweat"],
          k: [31, 20]
        },
        cancer: {
          a: "Cancer",
          b: "264B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sign", "zodiac", "purple-square", "astrology"],
          k: [47, 47],
          o: 1
        },
        fried_shrimp: {
          a: "Fried Shrimp",
          b: "1F364",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "animal", "appetizer", "summer"],
          k: [7, 38]
        },
        slot_machine: {
          a: "Slot Machine",
          b: "1F3B0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["bet", "gamble", "vegas", "fruit machine", "luck", "casino"],
          k: [9, 10]
        },
        scream: {
          a: "Face Screaming in Fear",
          b: "1F631",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "munch", "scared", "omg"],
          k: [31, 21]
        },
        green_book: {
          a: "Green Book",
          b: "1F4D7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["read", "library", "knowledge", "study"],
          k: [26, 14]
        },
        leo: {
          a: "Leo",
          b: "264C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sign", "purple-square", "zodiac", "astrology"],
          k: [47, 48],
          o: 1
        },
        "flag-cz": {
          a: "Czechia Flag",
          b: "1F1E8-1F1FF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 36]
        },
        lizard: {
          a: "Lizard",
          b: "1F98E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["animal", "nature", "reptile"],
          k: [42, 38],
          o: 9
        },
        virgo: {
          a: "Virgo",
          b: "264D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sign", "zodiac", "purple-square", "astrology"],
          k: [47, 49],
          o: 1
        },
        steam_locomotive: {
          a: "Steam Locomotive",
          b: "1F682",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["transportation", "vehicle", "train"],
          k: [34, 10]
        },
        de: {
          a: "Germany Flag",
          b: "1F1E9-1F1EA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["german", "nation", "flag", "country", "banner"],
          k: [1, 37],
          n: ["flag-de"]
        },
        flushed: {
          a: "Flushed Face",
          b: "1F633",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "blush", "shy", "flattered"],
          k: [31, 23]
        },
        blue_book: {
          a: "Blue Book",
          b: "1F4D8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["read", "library", "knowledge", "learn", "study"],
          k: [26, 15]
        },
        snake: {
          a: "Snake",
          b: "1F40D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "evil", "nature", "hiss", "python"],
          k: [12, 43]
        },
        fish_cake: {
          a: "Fish Cake with Swirl Design",
          b: "1F365",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "japan", "sea", "beach", "narutomaki", "pink", "swirl", "kamaboko", "surimi", "ramen"],
          k: [7, 39]
        },
        railway_car: {
          a: "Railway Car",
          b: "1F683",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["transportation", "vehicle"],
          k: [34, 11]
        },
        dango: {
          a: "Dango",
          b: "1F361",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "dessert", "sweet", "japanese", "barbecue", "meat"],
          k: [7, 35]
        },
        orange_book: {
          a: "Orange Book",
          b: "1F4D9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["read", "library", "knowledge", "textbook", "study"],
          k: [26, 16]
        },
        libra: {
          a: "Libra",
          b: "264E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sign", "purple-square", "zodiac", "astrology"],
          k: [47, 50],
          o: 1
        },
        dragon_face: {
          a: "Dragon Face",
          b: "1F432",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "myth", "nature", "chinese", "green"],
          k: [13, 28]
        },
        "flag-dg": {
          a: "Diego Garcia Flag",
          b: "1F1E9-1F1EC",
          d: !0,
          e: !1,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 38]
        },
        zany_face: {
          a: "Grinning Face with One Large and One Small Eye",
          b: "1F92A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [38, 50],
          n: ["grinning_face_with_one_large_and_one_small_eye"],
          o: 10
        },
        books: {
          a: "Books",
          b: "1F4DA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["literature", "library", "study"],
          k: [26, 17]
        },
        dragon: {
          a: "Dragon",
          b: "1F409",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "myth", "nature", "chinese", "green"],
          k: [12, 39]
        },
        "flag-dj": {
          a: "Djibouti Flag",
          b: "1F1E9-1F1EF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 39]
        },
        dumpling: {
          a: "Dumpling",
          b: "1F95F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 11],
          o: 10
        },
        dizzy_face: {
          a: "Dizzy Face",
          b: "1F635",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["spent", "unconscious", "xox", "dizzy"],
          k: [31, 25]
        },
        scorpius: {
          a: "Scorpius",
          b: "264F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sign", "zodiac", "purple-square", "astrology", "scorpio"],
          k: [47, 51],
          o: 1
        },
        bullettrain_side: {
          a: "High-Speed Train",
          b: "1F684",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["transportation", "vehicle"],
          k: [34, 12]
        },
        bullettrain_front: {
          a: "High-Speed Train with Bullet Nose",
          b: "1F685",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["transportation", "vehicle", "speed", "fast", "public", "travel"],
          k: [34, 13]
        },
        notebook: {
          a: "Notebook",
          b: "1F4D3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["stationery", "record", "notes", "paper", "study"],
          k: [26, 10]
        },
        fortune_cookie: {
          a: "Fortune Cookie",
          b: "1F960",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 12],
          o: 10
        },
        sagittarius: {
          a: "Sagittarius",
          b: "2650",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sign", "zodiac", "purple-square", "astrology"],
          k: [48, 0],
          o: 1
        },
        sauropod: {
          a: "Sauropod",
          b: "1F995",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 45],
          o: 10
        },
        "flag-dk": {
          a: "Denmark Flag",
          b: "1F1E9-1F1F0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 40]
        },
        rage: {
          a: "Pouting Face",
          b: "1F621",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["angry", "mad", "hate", "despise"],
          k: [31, 5]
        },
        ledger: {
          a: "Ledger",
          b: "1F4D2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["notes", "paper"],
          k: [26, 9]
        },
        angry: {
          a: "Angry Face",
          b: "1F620",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["mad", "face", "annoyed", "frustrated"],
          k: [31, 4],
          l: [">:(", ">:-("]
        },
        "t-rex": {
          a: "T-Rex",
          b: "1F996",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 46],
          o: 10
        },
        capricorn: {
          a: "Capricorn",
          b: "2651",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sign", "zodiac", "purple-square", "astrology"],
          k: [48, 1],
          o: 1
        },
        takeout_box: {
          a: "Takeout Box",
          b: "1F961",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 13],
          o: 10
        },
        "flag-dm": {
          a: "Dominica Flag",
          b: "1F1E9-1F1F2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 41]
        },
        train2: {
          a: "Train",
          b: "1F686",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["transportation", "vehicle"],
          k: [34, 14]
        },
        page_with_curl: {
          a: "Page with Curl",
          b: "1F4C3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["documents", "office", "paper"],
          k: [25, 46]
        },
        whale: {
          a: "Spouting Whale",
          b: "1F433",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "sea", "ocean"],
          k: [13, 29]
        },
        face_with_symbols_on_mouth: {
          a: "Serious Face with Symbols Covering Mouth",
          b: "1F92C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [39, 0],
          n: ["serious_face_with_symbols_covering_mouth"],
          o: 10
        },
        "flag-do": {
          a: "Dominican Republic Flag",
          b: "1F1E9-1F1F4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 42]
        },
        metro: {
          a: "Metro",
          b: "1F687",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["transportation", "blue-square", "mrt", "underground", "tube"],
          k: [34, 15]
        },
        icecream: {
          a: "Soft Ice Cream",
          b: "1F366",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "hot", "dessert", "summer"],
          k: [7, 40]
        },
        aquarius: {
          a: "Aquarius",
          b: "2652",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sign", "purple-square", "zodiac", "astrology"],
          k: [48, 2],
          o: 1
        },
        "flag-dz": {
          a: "Algeria Flag",
          b: "1F1E9-1F1FF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 43]
        },
        whale2: {
          a: "Whale",
          b: "1F40B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "sea", "ocean"],
          k: [12, 41]
        },
        mask: {
          a: "Face with Medical Mask",
          b: "1F637",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "sick", "ill", "disease"],
          k: [31, 27]
        },
        scroll: {
          a: "Scroll",
          b: "1F4DC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["documents", "ancient", "history", "paper"],
          k: [26, 19]
        },
        shaved_ice: {
          a: "Shaved Ice",
          b: "1F367",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["hot", "dessert", "summer"],
          k: [7, 41]
        },
        pisces: {
          a: "Pisces",
          b: "2653",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["purple-square", "sign", "zodiac", "astrology"],
          k: [48, 3],
          o: 1
        },
        light_rail: {
          a: "Light Rail",
          b: "1F688",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["transportation", "vehicle"],
          k: [34, 16]
        },
        dolphin: {
          a: "Dolphin",
          b: "1F42C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "fish", "sea", "ocean", "flipper", "fins", "beach"],
          k: [13, 22],
          n: ["flipper"]
        },
        face_with_thermometer: {
          a: "Face with Thermometer",
          b: "1F912",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["sick", "temperature", "thermometer", "cold", "fever"],
          k: [37, 26],
          o: 8
        },
        "flag-ea": {
          a: "Ceuta & Melilla Flag",
          b: "1F1EA-1F1E6",
          d: !0,
          e: !1,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 44]
        },
        ophiuchus: {
          a: "Ophiuchus",
          b: "26CE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sign", "purple-square", "constellation", "astrology"],
          k: [48, 31]
        },
        station: {
          a: "Station",
          b: "1F689",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["transportation", "vehicle", "public"],
          k: [34, 17]
        },
        ice_cream: {
          a: "Ice Cream",
          b: "1F368",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "hot", "dessert"],
          k: [7, 42]
        },
        page_facing_up: {
          a: "Page Facing Up",
          b: "1F4C4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["documents", "office", "paper", "information"],
          k: [25, 47]
        },
        doughnut: {
          a: "Doughnut",
          b: "1F369",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "dessert", "snack", "sweet", "donut"],
          k: [7, 43]
        },
        face_with_head_bandage: {
          a: "Face with Head-Bandage",
          b: "1F915",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["injured", "clumsy", "bandage", "hurt"],
          k: [37, 29],
          o: 8
        },
        fish: {
          a: "Fish",
          b: "1F41F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "food", "nature"],
          k: [13, 9]
        },
        newspaper: {
          a: "Newspaper",
          b: "1F4F0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["press", "headline"],
          k: [26, 39]
        },
        tram: {
          a: "Tram",
          b: "1F68A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["transportation", "vehicle"],
          k: [34, 18]
        },
        "flag-ec": {
          a: "Ecuador Flag",
          b: "1F1EA-1F1E8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 45]
        },
        twisted_rightwards_arrows: {
          a: "Twisted Rightwards Arrows",
          b: "1F500",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "shuffle", "music", "random"],
          k: [27, 2]
        },
        "flag-ee": {
          a: "Estonia Flag",
          b: "1F1EA-1F1EA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 46]
        },
        cookie: {
          a: "Cookie",
          b: "1F36A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "snack", "oreo", "chocolate", "sweet", "dessert"],
          k: [7, 44]
        },
        monorail: {
          a: "Monorail",
          b: "1F69D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["transportation", "vehicle"],
          k: [34, 37]
        },
        tropical_fish: {
          a: "Tropical Fish",
          b: "1F420",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "swim", "ocean", "beach", "nemo"],
          k: [13, 10]
        },
        rolled_up_newspaper: {
          a: "Rolled Up Newspaper",
          b: "1F5DE-FE0F",
          c: "1F5DE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [30, 12],
          o: 7
        },
        nauseated_face: {
          a: "Nauseated Face",
          b: "1F922",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["face", "vomit", "gross", "green", "sick", "throw up", "ill"],
          k: [38, 25],
          o: 9
        },
        repeat: {
          a: "Clockwise Rightwards and Leftwards Open Circle Arrows",
          b: "1F501",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["loop", "record"],
          k: [27, 3]
        },
        bookmark_tabs: {
          a: "Bookmark Tabs",
          b: "1F4D1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["favorite", "save", "order", "tidy"],
          k: [26, 8]
        },
        repeat_one: {
          a: "Clockwise Rightwards and Leftwards Open Circle Arrows with Circled One Overlay",
          b: "1F502",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "loop"],
          k: [27, 4]
        },
        "flag-eg": {
          a: "Egypt Flag",
          b: "1F1EA-1F1EC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 47]
        },
        mountain_railway: {
          a: "Mountain Railway",
          b: "1F69E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["transportation", "vehicle"],
          k: [34, 38]
        },
        birthday: {
          a: "Birthday Cake",
          b: "1F382",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "dessert", "cake"],
          k: [8, 16]
        },
        blowfish: {
          a: "Blowfish",
          b: "1F421",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "food", "sea", "ocean"],
          k: [13, 11]
        },
        face_vomiting: {
          a: "Face with Open Mouth Vomiting",
          b: "1F92E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [39, 2],
          n: ["face_with_open_mouth_vomiting"],
          o: 10
        },
        arrow_forward: {
          a: "Black Right-Pointing Triangle",
          b: "25B6-FE0F",
          c: "25B6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "right", "direction", "play"],
          k: [47, 10],
          o: 1
        },
        bookmark: {
          a: "Bookmark",
          b: "1F516",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["favorite", "label", "save"],
          k: [27, 24]
        },
        "flag-eh": {
          a: "Western Sahara Flag",
          b: "1F1EA-1F1ED",
          d: !0,
          e: !1,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 48]
        },
        shark: {
          a: "Shark",
          b: "1F988",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["animal", "nature", "fish", "sea", "ocean", "jaws", "fins", "beach"],
          k: [42, 32],
          o: 9
        },
        train: {
          a: "Tram Car",
          b: "1F68B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["transportation", "vehicle", "carriage", "public", "travel"],
          k: [34, 19]
        },
        sneezing_face: {
          a: "Sneezing Face",
          b: "1F927",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["face", "gesundheit", "sneeze", "sick", "allergy"],
          k: [38, 47],
          o: 9
        },
        cake: {
          a: "Shortcake",
          b: "1F370",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "dessert"],
          k: [7, 50]
        },
        bus: {
          a: "Bus",
          b: "1F68C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["car", "vehicle", "transportation"],
          k: [34, 20]
        },
        pie: {
          a: "Pie",
          b: "1F967",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 19],
          o: 10
        },
        innocent: {
          a: "Smiling Face with Halo",
          b: "1F607",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "angel", "heaven", "halo"],
          k: [30, 31]
        },
        fast_forward: {
          a: "Black Right-Pointing Double Triangle",
          b: "23E9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "play", "speed", "continue"],
          k: [46, 45]
        },
        label: {
          a: "Label",
          b: "1F3F7-FE0F",
          c: "1F3F7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["sale", "tag"],
          k: [12, 21],
          o: 7
        },
        octopus: {
          a: "Octopus",
          b: "1F419",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "creature", "ocean", "sea", "nature", "beach"],
          k: [13, 3]
        },
        "flag-er": {
          a: "Eritrea Flag",
          b: "1F1EA-1F1F7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 49]
        },
        black_right_pointing_double_triangle_with_vertical_bar: {
          a: "Black Right Pointing Double Triangle with Vertical Bar",
          b: "23ED-FE0F",
          c: "23ED",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [46, 49]
        },
        chocolate_bar: {
          a: "Chocolate Bar",
          b: "1F36B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "snack", "dessert", "sweet"],
          k: [7, 45]
        },
        oncoming_bus: {
          a: "Oncoming Bus",
          b: "1F68D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["vehicle", "transportation"],
          k: [34, 21]
        },
        shell: {
          a: "Spiral Shell",
          b: "1F41A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nature", "sea", "beach"],
          k: [13, 4]
        },
        face_with_cowboy_hat: {
          a: "Face with Cowboy Hat",
          b: "1F920",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [38, 23],
          o: 9
        },
        moneybag: {
          a: "Money Bag",
          b: "1F4B0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["dollar", "payment", "coins", "sale"],
          k: [25, 27]
        },
        es: {
          a: "Spain Flag",
          b: "1F1EA-1F1F8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["spain", "flag", "nation", "country", "banner"],
          k: [1, 50],
          n: ["flag-es"]
        },
        crab: {
          a: "Crab",
          b: "1F980",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["animal", "crustacean"],
          k: [42, 24],
          o: 8
        },
        yen: {
          a: "Banknote with Yen Sign",
          b: "1F4B4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["money", "sales", "japanese", "dollar", "currency"],
          k: [25, 31]
        },
        "flag-et": {
          a: "Ethiopia Flag",
          b: "1F1EA-1F1F9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 51]
        },
        clown_face: {
          a: "Clown Face",
          b: "1F921",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["face"],
          k: [38, 24],
          o: 9
        },
        black_right_pointing_triangle_with_double_vertical_bar: {
          a: "Black Right Pointing Triangle with Double Vertical Bar",
          b: "23EF-FE0F",
          c: "23EF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [46, 51]
        },
        trolleybus: {
          a: "Trolleybus",
          b: "1F68E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["bart", "transportation", "vehicle"],
          k: [34, 22]
        },
        candy: {
          a: "Candy",
          b: "1F36C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["snack", "dessert", "sweet", "lolly"],
          k: [7, 46]
        },
        lying_face: {
          a: "Lying Face",
          b: "1F925",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["face", "lie", "pinocchio"],
          k: [38, 28],
          o: 9
        },
        arrow_backward: {
          a: "Black Left-Pointing Triangle",
          b: "25C0-FE0F",
          c: "25C0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "left", "direction"],
          k: [47, 11],
          o: 1
        },
        dollar: {
          a: "Banknote with Dollar Sign",
          b: "1F4B5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["money", "sales", "bill", "currency"],
          k: [25, 32]
        },
        shrimp: {
          a: "Shrimp",
          b: "1F990",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["animal", "ocean", "nature", "seafood"],
          k: [42, 40],
          o: 9
        },
        minibus: {
          a: "Minibus",
          b: "1F690",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["vehicle", "car", "transportation"],
          k: [34, 24]
        },
        "flag-eu": {
          a: "European Union Flag",
          b: "1F1EA-1F1FA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 0]
        },
        lollipop: {
          a: "Lollipop",
          b: "1F36D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "snack", "candy", "sweet"],
          k: [7, 47]
        },
        squid: {
          a: "Squid",
          b: "1F991",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["animal", "nature", "ocean", "sea"],
          k: [42, 41],
          o: 9
        },
        euro: {
          a: "Banknote with Euro Sign",
          b: "1F4B6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["money", "sales", "dollar", "currency"],
          k: [25, 33]
        },
        "flag-fi": {
          a: "Finland Flag",
          b: "1F1EB-1F1EE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 1]
        },
        ambulance: {
          a: "Ambulance",
          b: "1F691",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["health", "911", "hospital"],
          k: [34, 25]
        },
        custard: {
          a: "Custard",
          b: "1F36E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["dessert", "food"],
          k: [7, 48]
        },
        shushing_face: {
          a: "Face with Finger Covering Closed Lips",
          b: "1F92B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [38, 51],
          n: ["face_with_finger_covering_closed_lips"],
          o: 10
        },
        rewind: {
          a: "Black Left-Pointing Double Triangle",
          b: "23EA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["play", "blue-square"],
          k: [46, 46]
        },
        black_left_pointing_double_triangle_with_vertical_bar: {
          a: "Black Left Pointing Double Triangle with Vertical Bar",
          b: "23EE-FE0F",
          c: "23EE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [46, 50]
        },
        face_with_hand_over_mouth: {
          a: "Smiling Face with Smiling Eyes and Hand Covering Mouth",
          b: "1F92D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [39, 1],
          n: ["smiling_face_with_smiling_eyes_and_hand_covering_mouth"],
          o: 10
        },
        "flag-fj": {
          a: "Fiji Flag",
          b: "1F1EB-1F1EF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 2]
        },
        honey_pot: {
          a: "Honey Pot",
          b: "1F36F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["bees", "sweet", "kitchen"],
          k: [7, 49]
        },
        snail: {
          a: "Snail",
          b: "1F40C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["slow", "animal", "shell"],
          k: [12, 42]
        },
        pound: {
          a: "Banknote with Pound Sign",
          b: "1F4B7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["british", "sterling", "money", "sales", "bills", "uk", "england", "currency"],
          k: [25, 34]
        },
        fire_engine: {
          a: "Fire Engine",
          b: "1F692",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["transportation", "cars", "vehicle"],
          k: [34, 26]
        },
        baby_bottle: {
          a: "Baby Bottle",
          b: "1F37C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "container", "milk"],
          k: [8, 10]
        },
        "flag-fk": {
          a: "Falkland Islands Flag",
          b: "1F1EB-1F1F0",
          d: !0,
          e: !1,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 3]
        },
        butterfly: {
          a: "Butterfly",
          b: "1F98B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["animal", "insect", "nature", "caterpillar"],
          k: [42, 35],
          o: 9
        },
        money_with_wings: {
          a: "Money with Wings",
          b: "1F4B8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["dollar", "bills", "payment", "sale"],
          k: [25, 35]
        },
        face_with_monocle: {
          a: "Face with Monocle",
          b: "1F9D0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 49],
          o: 10
        },
        police_car: {
          a: "Police Car",
          b: "1F693",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["vehicle", "cars", "transportation", "law", "legal", "enforcement"],
          k: [34, 27]
        },
        arrow_up_small: {
          a: "Up-Pointing Small Red Triangle",
          b: "1F53C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "triangle", "direction", "point", "forward", "top"],
          k: [28, 10]
        },
        "flag-fm": {
          a: "Micronesia Flag",
          b: "1F1EB-1F1F2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 4]
        },
        glass_of_milk: {
          a: "Glass of Milk",
          b: "1F95B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 7],
          o: 9
        },
        credit_card: {
          a: "Credit Card",
          b: "1F4B3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["money", "sales", "dollar", "bill", "payment", "shopping"],
          k: [25, 30]
        },
        oncoming_police_car: {
          a: "Oncoming Police Car",
          b: "1F694",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["vehicle", "law", "legal", "enforcement", "911"],
          k: [34, 28]
        },
        bug: {
          a: "Bug",
          b: "1F41B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "insect", "nature", "worm"],
          k: [13, 5]
        },
        nerd_face: {
          a: "Nerd Face",
          b: "1F913",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["face", "nerdy", "geek", "dork"],
          k: [37, 27],
          o: 8
        },
        arrow_double_up: {
          a: "Black Up-Pointing Double Triangle",
          b: "23EB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "direction", "top"],
          k: [46, 47]
        },
        chart: {
          a: "Chart with Upwards Trend and Yen Sign",
          b: "1F4B9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["green-square", "graph", "presentation", "stats"],
          k: [25, 36]
        },
        "flag-fo": {
          a: "Faroe Islands Flag",
          b: "1F1EB-1F1F4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 5]
        },
        ant: {
          a: "Ant",
          b: "1F41C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "insect", "nature", "bug"],
          k: [13, 6]
        },
        arrow_down_small: {
          a: "Down-Pointing Small Red Triangle",
          b: "1F53D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "direction", "bottom"],
          k: [28, 11]
        },
        smiling_imp: {
          a: "Smiling Face with Horns",
          b: "1F608",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["devil", "horns"],
          k: [30, 32]
        },
        taxi: {
          a: "Taxi",
          b: "1F695",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["uber", "vehicle", "cars", "transportation"],
          k: [34, 29]
        },
        coffee: {
          a: "Hot Beverage",
          b: "2615",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["beverage", "caffeine", "latte", "espresso"],
          k: [47, 24],
          o: 4
        },
        fr: {
          a: "France Flag",
          b: "1F1EB-1F1F7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["banner", "flag", "nation", "france", "french", "country"],
          k: [2, 6],
          n: ["flag-fr"]
        },
        oncoming_taxi: {
          a: "Oncoming Taxi",
          b: "1F696",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["vehicle", "cars", "uber"],
          k: [34, 30]
        },
        arrow_double_down: {
          a: "Black Down-Pointing Double Triangle",
          b: "23EC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "direction", "bottom"],
          k: [46, 48]
        },
        imp: {
          a: "Imp",
          b: "1F47F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["devil", "angry", "horns"],
          k: [22, 51]
        },
        currency_exchange: {
          a: "Currency Exchange",
          b: "1F4B1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["money", "sales", "dollar", "travel"],
          k: [25, 28]
        },
        tea: {
          a: "Teacup Without Handle",
          b: "1F375",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["drink", "bowl", "breakfast", "green", "british"],
          k: [8, 3]
        },
        bee: {
          a: "Honeybee",
          b: "1F41D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [13, 7],
          n: ["honeybee"]
        },
        heavy_dollar_sign: {
          a: "Heavy Dollar Sign",
          b: "1F4B2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["money", "sales", "payment", "currency", "buck"],
          k: [25, 29]
        },
        car: {
          a: "Automobile",
          b: "1F697",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [34, 31],
          n: ["red_car"]
        },
        sake: {
          a: "Sake Bottle and Cup",
          b: "1F376",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["wine", "drink", "drunk", "beverage", "japanese", "alcohol", "booze"],
          k: [8, 4]
        },
        "flag-ga": {
          a: "Gabon Flag",
          b: "1F1EC-1F1E6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 7]
        },
        beetle: {
          a: "Lady Beetle",
          b: "1F41E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "insect", "nature", "ladybug"],
          k: [13, 8]
        },
        japanese_ogre: {
          a: "Japanese Ogre",
          b: "1F479",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["monster", "red", "mask", "halloween", "scary", "creepy", "devil", "demon", "japanese", "ogre"],
          k: [22, 40]
        },
        double_vertical_bar: {
          a: "Double Vertical Bar",
          b: "23F8-FE0F",
          c: "23F8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [47, 4],
          o: 7
        },
        champagne: {
          a: "Bottle with Popping Cork",
          b: "1F37E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["drink", "wine", "bottle", "celebration"],
          k: [8, 12],
          o: 8
        },
        japanese_goblin: {
          a: "Japanese Goblin",
          b: "1F47A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["red", "evil", "mask", "monster", "scary", "creepy", "japanese", "goblin"],
          k: [22, 41]
        },
        black_square_for_stop: {
          a: "Black Square for Stop",
          b: "23F9-FE0F",
          c: "23F9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [47, 5],
          o: 7
        },
        oncoming_automobile: {
          a: "Oncoming Automobile",
          b: "1F698",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["car", "vehicle", "transportation"],
          k: [34, 32]
        },
        email: {
          a: "Envelope",
          b: "2709-FE0F",
          c: "2709",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["letter", "postal", "inbox", "communication"],
          k: [49, 17],
          n: ["envelope"],
          o: 1
        },
        cricket: {
          a: "Cricket",
          b: "1F997",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["sports"],
          k: [42, 47],
          o: 10
        },
        gb: {
          a: "United Kingdom Flag",
          b: "1F1EC-1F1E7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 8],
          n: ["uk", "flag-gb"]
        },
        black_circle_for_record: {
          a: "Black Circle for Record",
          b: "23FA-FE0F",
          c: "23FA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [47, 6],
          o: 7
        },
        "flag-gd": {
          a: "Grenada Flag",
          b: "1F1EC-1F1E9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 9]
        },
        spider: {
          a: "Spider",
          b: "1F577-FE0F",
          c: "1F577",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["animal", "arachnid"],
          k: [29, 18],
          o: 7
        },
        blue_car: {
          a: "Recreational Vehicle",
          b: "1F699",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["transportation", "vehicle"],
          k: [34, 33]
        },
        skull: {
          a: "Skull",
          b: "1F480",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["dead", "skeleton", "creepy", "death"],
          k: [23, 0]
        },
        "e-mail": {
          a: "E-Mail Symbol",
          b: "1F4E7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["communication", "inbox"],
          k: [26, 30]
        },
        wine_glass: {
          a: "Wine Glass",
          b: "1F377",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["drink", "beverage", "drunk", "alcohol", "booze"],
          k: [8, 5]
        },
        spider_web: {
          a: "Spider Web",
          b: "1F578-FE0F",
          c: "1F578",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["animal", "insect", "arachnid", "silk"],
          k: [29, 19],
          o: 7
        },
        cocktail: {
          a: "Cocktail Glass",
          b: "1F378",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["drink", "drunk", "alcohol", "beverage", "booze", "mojito"],
          k: [8, 6]
        },
        skull_and_crossbones: {
          a: "Skull and Crossbones",
          b: "2620-FE0F",
          c: "2620",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["poison", "danger", "deadly", "scary", "death", "pirate", "evil"],
          k: [47, 32],
          o: 1
        },
        "flag-ge": {
          a: "Georgia Flag",
          b: "1F1EC-1F1EA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 10]
        },
        eject: {
          a: "Eject",
          b: "23CF-FE0F",
          c: "23CF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [46, 44],
          o: 4
        },
        truck: {
          a: "Delivery Truck",
          b: "1F69A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["cars", "transportation"],
          k: [34, 34]
        },
        incoming_envelope: {
          a: "Incoming Envelope",
          b: "1F4E8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["email", "inbox"],
          k: [26, 31]
        },
        tropical_drink: {
          a: "Tropical Drink",
          b: "1F379",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["beverage", "cocktail", "summer", "beach", "alcohol", "booze", "mojito"],
          k: [8, 7]
        },
        scorpion: {
          a: "Scorpion",
          b: "1F982",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["animal", "arachnid"],
          k: [42, 26],
          o: 8
        },
        cinema: {
          a: "Cinema",
          b: "1F3A6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "record", "film", "movie", "curtain", "stage", "theater"],
          k: [9, 0]
        },
        articulated_lorry: {
          a: "Articulated Lorry",
          b: "1F69B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["vehicle", "cars", "transportation", "express"],
          k: [34, 35]
        },
        envelope_with_arrow: {
          a: "Envelope with Downwards Arrow Above",
          b: "1F4E9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["email", "communication"],
          k: [26, 32]
        },
        ghost: {
          a: "Ghost",
          b: "1F47B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["halloween", "spooky", "scary"],
          k: [22, 42]
        },
        "flag-gf": {
          a: "French Guiana Flag",
          b: "1F1EC-1F1EB",
          d: !0,
          e: !1,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 11]
        },
        bouquet: {
          a: "Bouquet",
          b: "1F490",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["flowers", "nature", "spring"],
          k: [24, 42]
        },
        tractor: {
          a: "Tractor",
          b: "1F69C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["vehicle", "car", "farming", "agriculture"],
          k: [34, 36]
        },
        beer: {
          a: "Beer Mug",
          b: "1F37A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["relax", "beverage", "drink", "drunk", "party", "pub", "summer", "alcohol", "booze"],
          k: [8, 8]
        },
        outbox_tray: {
          a: "Outbox Tray",
          b: "1F4E4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["inbox", "email"],
          k: [26, 27]
        },
        low_brightness: {
          a: "Low Brightness Symbol",
          b: "1F505",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sun", "afternoon", "warm", "summer"],
          k: [27, 7]
        },
        alien: {
          a: "Extraterrestrial Alien",
          b: "1F47D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["UFO", "paul", "weird", "outer_space"],
          k: [22, 49]
        },
        "flag-gg": {
          a: "Guernsey Flag",
          b: "1F1EC-1F1EC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 12]
        },
        cherry_blossom: {
          a: "Cherry Blossom",
          b: "1F338",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nature", "plant", "spring", "flower"],
          k: [6, 46]
        },
        inbox_tray: {
          a: "Inbox Tray",
          b: "1F4E5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["email", "documents"],
          k: [26, 28]
        },
        "flag-gh": {
          a: "Ghana Flag",
          b: "1F1EC-1F1ED",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 13]
        },
        bike: {
          a: "Bicycle",
          b: "1F6B2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sports", "bicycle", "exercise", "hipster"],
          k: [35, 23]
        },
        space_invader: {
          a: "Alien Monster",
          b: "1F47E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["game", "arcade", "play"],
          k: [22, 50]
        },
        beers: {
          a: "Clinking Beer Mugs",
          b: "1F37B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["relax", "beverage", "drink", "drunk", "party", "pub", "summer", "alcohol", "booze"],
          k: [8, 9]
        },
        high_brightness: {
          a: "High Brightness Symbol",
          b: "1F506",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sun", "light"],
          k: [27, 8]
        },
        package: {
          a: "Package",
          b: "1F4E6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["mail", "gift", "cardboard", "box", "moving"],
          k: [26, 29]
        },
        scooter: {
          a: "Scooter",
          b: "1F6F4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [37, 19],
          o: 9
        },
        white_flower: {
          a: "White Flower",
          b: "1F4AE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["japanese", "spring"],
          k: [25, 25]
        },
        clinking_glasses: {
          a: "Clinking Glasses",
          b: "1F942",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["beverage", "drink", "party", "alcohol", "celebrate", "cheers"],
          k: [41, 38],
          o: 9
        },
        robot_face: {
          a: "Robot Face",
          b: "1F916",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [37, 30],
          o: 8
        },
        signal_strength: {
          a: "Antenna with Bars",
          b: "1F4F6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "reception", "phone", "internet", "connection", "wifi", "bluetooth", "bars"],
          k: [26, 45]
        },
        "flag-gi": {
          a: "Gibraltar Flag",
          b: "1F1EC-1F1EE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 14]
        },
        "flag-gl": {
          a: "Greenland Flag",
          b: "1F1EC-1F1F1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 15]
        },
        motor_scooter: {
          a: "Motor Scooter",
          b: "1F6F5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["vehicle", "vespa", "sasha"],
          k: [37, 20],
          o: 9
        },
        mailbox: {
          a: "Closed Mailbox with Raised Flag",
          b: "1F4EB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["email", "inbox", "communication"],
          k: [26, 34]
        },
        vibration_mode: {
          a: "Vibration Mode",
          b: "1F4F3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["orange-square", "phone"],
          k: [26, 42]
        },
        hankey: {
          a: "Pile of Poo",
          b: "1F4A9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [25, 15],
          n: ["poop", "shit"]
        },
        rosette: {
          a: "Rosette",
          b: "1F3F5-FE0F",
          c: "1F3F5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["flower", "decoration", "military"],
          k: [12, 20],
          o: 7
        },
        tumbler_glass: {
          a: "Tumbler Glass",
          b: "1F943",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["drink", "beverage", "drunk", "alcohol", "liquor", "booze", "bourbon", "scotch", "whisky", "glass", "shot"],
          k: [41, 39],
          o: 9
        },
        cup_with_straw: {
          a: "Cup with Straw",
          b: "1F964",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 16],
          o: 10
        },
        "flag-gm": {
          a: "Gambia Flag",
          b: "1F1EC-1F1F2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 16]
        },
        mailbox_closed: {
          a: "Closed Mailbox with Lowered Flag",
          b: "1F4EA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["email", "communication", "inbox"],
          k: [26, 33]
        },
        mobile_phone_off: {
          a: "Mobile Phone off",
          b: "1F4F4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["mute", "orange-square", "silence", "quiet"],
          k: [26, 43]
        },
        busstop: {
          a: "Bus Stop",
          b: "1F68F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["transportation", "wait"],
          k: [34, 23]
        },
        smiley_cat: {
          a: "Smiling Cat Face with Open Mouth",
          b: "1F63A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "cats", "happy", "smile"],
          k: [31, 30]
        },
        rose: {
          a: "Rose",
          b: "1F339",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["flowers", "valentines", "love", "spring"],
          k: [6, 47]
        },
        motorway: {
          a: "Motorway",
          b: "1F6E3-FE0F",
          c: "1F6E3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["road", "cupertino", "interstate", "highway"],
          k: [37, 11],
          o: 7
        },
        smile_cat: {
          a: "Grinning Cat Face with Smiling Eyes",
          b: "1F638",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "cats", "smile"],
          k: [31, 28]
        },
        "flag-gn": {
          a: "Guinea Flag",
          b: "1F1EC-1F1F3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 17]
        },
        wilted_flower: {
          a: "Wilted Flower",
          b: "1F940",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["plant", "nature", "flower"],
          k: [41, 36],
          o: 9
        },
        mailbox_with_mail: {
          a: "Open Mailbox with Raised Flag",
          b: "1F4EC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["email", "inbox", "communication"],
          k: [26, 35]
        },
        chopsticks: {
          a: "Chopsticks",
          b: "1F962",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 14],
          o: 10
        },
        female_sign: {
          a: "Female Sign",
          b: "2640-FE0F",
          c: "2640",
          d: !1,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [47, 42],
          o: 1
        },
        mailbox_with_no_mail: {
          a: "Open Mailbox with Lowered Flag",
          b: "1F4ED",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["email", "inbox"],
          k: [26, 36]
        },
        knife_fork_plate: {
          a: "Knife Fork Plate",
          b: "1F37D-FE0F",
          c: "1F37D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [8, 11],
          o: 7
        },
        hibiscus: {
          a: "Hibiscus",
          b: "1F33A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["plant", "vegetable", "flowers", "beach"],
          k: [6, 48]
        },
        "flag-gp": {
          a: "Guadeloupe Flag",
          b: "1F1EC-1F1F5",
          d: !0,
          e: !1,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 18]
        },
        railway_track: {
          a: "Railway Track",
          b: "1F6E4-FE0F",
          c: "1F6E4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["train", "transportation"],
          k: [37, 12],
          o: 7
        },
        male_sign: {
          a: "Male Sign",
          b: "2642-FE0F",
          c: "2642",
          d: !1,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [47, 43],
          o: 1
        },
        joy_cat: {
          a: "Cat Face with Tears of Joy",
          b: "1F639",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "cats", "haha", "happy", "tears"],
          k: [31, 29]
        },
        fuelpump: {
          a: "Fuel Pump",
          b: "26FD",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["gas station", "petroleum"],
          k: [49, 13],
          o: 5
        },
        sunflower: {
          a: "Sunflower",
          b: "1F33B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nature", "plant", "fall"],
          k: [6, 49]
        },
        postbox: {
          a: "Postbox",
          b: "1F4EE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["email", "letter", "envelope"],
          k: [26, 37]
        },
        "flag-gq": {
          a: "Equatorial Guinea Flag",
          b: "1F1EC-1F1F6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 19]
        },
        heart_eyes_cat: {
          a: "Smiling Cat Face with Heart-Shaped Eyes",
          b: "1F63B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "love", "like", "affection", "cats", "valentines", "heart"],
          k: [31, 31]
        },
        fork_and_knife: {
          a: "Fork and Knife",
          b: "1F374",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["cutlery", "kitchen"],
          k: [8, 2]
        },
        medical_symbol: {
          a: "Medical Symbol",
          b: "2695-FE0F",
          c: "2695",
          d: !1,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [48, 14],
          n: ["staff_of_aesculapius"],
          o: 4
        },
        recycle: {
          a: "Black Universal Recycling Symbol",
          b: "267B-FE0F",
          c: "267B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["arrow", "environment", "garbage", "trash"],
          k: [48, 9],
          o: 3
        },
        spoon: {
          a: "Spoon",
          b: "1F944",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["cutlery", "kitchen", "tableware"],
          k: [41, 40],
          o: 9
        },
        blossom: {
          a: "Blossom",
          b: "1F33C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nature", "flowers", "yellow"],
          k: [6, 50]
        },
        rotating_light: {
          a: "Police Cars Revolving Light",
          b: "1F6A8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["police", "ambulance", "911", "emergency", "alert", "error", "pinged", "law", "legal"],
          k: [35, 13]
        },
        smirk_cat: {
          a: "Cat Face with Wry Smile",
          b: "1F63C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "cats", "smirk"],
          k: [31, 32]
        },
        ballot_box_with_ballot: {
          a: "Ballot Box with Ballot",
          b: "1F5F3-FE0F",
          c: "1F5F3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [30, 17],
          o: 7
        },
        "flag-gr": {
          a: "Greece Flag",
          b: "1F1EC-1F1F7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 20]
        },
        kissing_cat: {
          a: "Kissing Cat Face with Closed Eyes",
          b: "1F63D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "cats", "kiss"],
          k: [31, 33]
        },
        pencil2: {
          a: "Pencil",
          b: "270F-FE0F",
          c: "270F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["stationery", "write", "paper", "writing", "school", "study"],
          k: [49, 42],
          o: 1
        },
        traffic_light: {
          a: "Horizontal Traffic Light",
          b: "1F6A5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["transportation", "signal"],
          k: [35, 10]
        },
        fleur_de_lis: {
          a: "Fleur De Lis",
          b: "269C-FE0F",
          c: "269C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["decorative", "scout"],
          k: [48, 19],
          o: 4
        },
        tulip: {
          a: "Tulip",
          b: "1F337",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["flowers", "plant", "nature", "summer", "spring"],
          k: [6, 45]
        },
        hocho: {
          a: "Hocho",
          b: "1F52A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["knife", "blade", "cutlery", "kitchen", "weapon"],
          k: [27, 44],
          n: ["knife"]
        },
        "flag-gs": {
          a: "South Georgia & South Sandwich Islands Flag",
          b: "1F1EC-1F1F8",
          d: !0,
          e: !1,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 21]
        },
        seedling: {
          a: "Seedling",
          b: "1F331",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["plant", "nature", "grass", "lawn", "spring"],
          k: [6, 39]
        },
        amphora: {
          a: "Amphora",
          b: "1F3FA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["vase", "jar"],
          k: [12, 24],
          o: 8
        },
        scream_cat: {
          a: "Weary Cat Face",
          b: "1F640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "cats", "munch", "scared", "scream"],
          k: [31, 36]
        },
        vertical_traffic_light: {
          a: "Vertical Traffic Light",
          b: "1F6A6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["transportation", "driving"],
          k: [35, 11]
        },
        black_nib: {
          a: "Black Nib",
          b: "2712-FE0F",
          c: "2712",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["pen", "stationery", "writing", "write"],
          k: [49, 43],
          o: 1
        },
        "flag-gt": {
          a: "Guatemala Flag",
          b: "1F1EC-1F1F9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 22]
        },
        trident: {
          a: "Trident Emblem",
          b: "1F531",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["weapon", "spear"],
          k: [27, 51]
        },
        "flag-gu": {
          a: "Guam Flag",
          b: "1F1EC-1F1FA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 23]
        },
        name_badge: {
          a: "Name Badge",
          b: "1F4DB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fire", "forbid"],
          k: [26, 18]
        },
        construction: {
          a: "Construction Sign",
          b: "1F6A7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["wip", "progress", "caution", "warning"],
          k: [35, 12]
        },
        lower_left_fountain_pen: {
          a: "Lower Left Fountain Pen",
          b: "1F58B-FE0F",
          c: "1F58B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [29, 29],
          o: 7
        },
        evergreen_tree: {
          a: "Evergreen Tree",
          b: "1F332",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["plant", "nature"],
          k: [6, 40]
        },
        crying_cat_face: {
          a: "Crying Cat Face",
          b: "1F63F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "tears", "weep", "sad", "cats", "upset", "cry"],
          k: [31, 35]
        },
        "flag-gw": {
          a: "Guinea-Bissau Flag",
          b: "1F1EC-1F1FC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 24]
        },
        lower_left_ballpoint_pen: {
          a: "Lower Left Ballpoint Pen",
          b: "1F58A-FE0F",
          c: "1F58A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [29, 28],
          o: 7
        },
        pouting_cat: {
          a: "Pouting Cat Face",
          b: "1F63E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "cats"],
          k: [31, 34]
        },
        deciduous_tree: {
          a: "Deciduous Tree",
          b: "1F333",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["plant", "nature"],
          k: [6, 41]
        },
        octagonal_sign: {
          a: "Octagonal Sign",
          b: "1F6D1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [37, 6],
          o: 9
        },
        beginner: {
          a: "Japanese Symbol for Beginner",
          b: "1F530",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["badge", "shield"],
          k: [27, 50]
        },
        "flag-gy": {
          a: "Guyana Flag",
          b: "1F1EC-1F1FE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 25]
        },
        lower_left_paintbrush: {
          a: "Lower Left Paintbrush",
          b: "1F58C-FE0F",
          c: "1F58C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [29, 30],
          o: 7
        },
        o: {
          a: "Heavy Large Circle",
          b: "2B55",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["circle", "round"],
          k: [50, 23],
          o: 5
        },
        palm_tree: {
          a: "Palm Tree",
          b: "1F334",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["plant", "vegetable", "nature", "summer", "beach", "mojito", "tropical"],
          k: [6, 42]
        },
        anchor: {
          a: "Anchor",
          b: "2693",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["ship", "ferry", "sea", "boat"],
          k: [48, 12],
          o: 4
        },
        see_no_evil: {
          a: "See-No-Evil Monkey",
          b: "1F648",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["monkey", "animal", "nature", "haha"],
          k: [32, 43]
        },
        boat: {
          a: "Sailboat",
          b: "26F5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [48, 43],
          n: ["sailboat"],
          o: 5
        },
        white_check_mark: {
          a: "White Heavy Check Mark",
          b: "2705",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["green-square", "ok", "agree", "vote", "election", "answer", "tick"],
          k: [49, 15]
        },
        "flag-hk": {
          a: "Hong Kong Sar China Flag",
          b: "1F1ED-1F1F0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 26]
        },
        lower_left_crayon: {
          a: "Lower Left Crayon",
          b: "1F58D-FE0F",
          c: "1F58D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [29, 31],
          o: 7
        },
        hear_no_evil: {
          a: "Hear-No-Evil Monkey",
          b: "1F649",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "monkey", "nature"],
          k: [32, 44]
        },
        cactus: {
          a: "Cactus",
          b: "1F335",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["vegetable", "plant", "nature"],
          k: [6, 43]
        },
        ear_of_rice: {
          a: "Ear of Rice",
          b: "1F33E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nature", "plant"],
          k: [7, 0]
        },
        speak_no_evil: {
          a: "Speak-No-Evil Monkey",
          b: "1F64A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["monkey", "animal", "nature", "omg"],
          k: [32, 45]
        },
        "flag-hm": {
          a: "Heard & Mcdonald Islands Flag",
          b: "1F1ED-1F1F2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 27]
        },
        ballot_box_with_check: {
          a: "Ballot Box with Check",
          b: "2611-FE0F",
          c: "2611",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["ok", "agree", "confirm", "black-square", "vote", "election", "yes", "tick"],
          k: [47, 22],
          o: 1
        },
        canoe: {
          a: "Canoe",
          b: "1F6F6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["boat", "paddle", "water", "ship"],
          k: [37, 21],
          o: 9
        },
        memo: {
          a: "Memo",
          b: "1F4DD",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["write", "documents", "stationery", "pencil", "paper", "writing", "legal", "exam", "quiz", "test", "study", "compose"],
          k: [26, 20],
          n: ["pencil"]
        },
        herb: {
          a: "Herb",
          b: "1F33F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["vegetable", "plant", "medicine", "weed", "grass", "lawn"],
          k: [7, 1]
        },
        "flag-hn": {
          a: "Honduras Flag",
          b: "1F1ED-1F1F3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 28]
        },
        heavy_check_mark: {
          a: "Heavy Check Mark",
          b: "2714-FE0F",
          c: "2714",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["ok", "nike", "answer", "yes", "tick"],
          k: [49, 44],
          o: 1
        },
        briefcase: {
          a: "Briefcase",
          b: "1F4BC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["business", "documents", "work", "law", "legal", "job", "career"],
          k: [25, 39]
        },
        speedboat: {
          a: "Speedboat",
          b: "1F6A4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["ship", "transportation", "vehicle", "summer"],
          k: [35, 9]
        },
        baby: {
          skin_variations: {
            "1F3FB": {
              unified: "1F476-1F3FB",
              non_qualified: null,
              image: "1f476-1f3fb.png",
              sheet_x: 22,
              sheet_y: 11,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F476-1F3FC",
              non_qualified: null,
              image: "1f476-1f3fc.png",
              sheet_x: 22,
              sheet_y: 12,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F476-1F3FD",
              non_qualified: null,
              image: "1f476-1f3fd.png",
              sheet_x: 22,
              sheet_y: 13,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F476-1F3FE",
              non_qualified: null,
              image: "1f476-1f3fe.png",
              sheet_x: 22,
              sheet_y: 14,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F476-1F3FF",
              non_qualified: null,
              image: "1f476-1f3ff.png",
              sheet_x: 22,
              sheet_y: 15,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Baby",
          b: "1F476",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["child", "boy", "girl", "toddler"],
          k: [22, 10]
        },
        heavy_multiplication_x: {
          a: "Heavy Multiplication X",
          b: "2716-FE0F",
          c: "2716",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["math", "calculation"],
          k: [49, 45],
          o: 1
        },
        child: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9D2-1F3FB",
              non_qualified: null,
              image: "1f9d2-1f3fb.png",
              sheet_x: 43,
              sheet_y: 5,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F9D2-1F3FC",
              non_qualified: null,
              image: "1f9d2-1f3fc.png",
              sheet_x: 43,
              sheet_y: 6,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F9D2-1F3FD",
              non_qualified: null,
              image: "1f9d2-1f3fd.png",
              sheet_x: 43,
              sheet_y: 7,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F9D2-1F3FE",
              non_qualified: null,
              image: "1f9d2-1f3fe.png",
              sheet_x: 43,
              sheet_y: 8,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F9D2-1F3FF",
              non_qualified: null,
              image: "1f9d2-1f3ff.png",
              sheet_x: 43,
              sheet_y: 9,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Child",
          b: "1F9D2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [43, 4],
          o: 10
        },
        shamrock: {
          a: "Shamrock",
          b: "2618-FE0F",
          c: "2618",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["vegetable", "plant", "nature", "irish", "clover"],
          k: [47, 25],
          o: 4
        },
        passenger_ship: {
          a: "Passenger Ship",
          b: "1F6F3-FE0F",
          c: "1F6F3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["yacht", "cruise", "ferry"],
          k: [37, 18],
          o: 7
        },
        "flag-hr": {
          a: "Croatia Flag",
          b: "1F1ED-1F1F7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 29]
        },
        file_folder: {
          a: "File Folder",
          b: "1F4C1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["documents", "business", "office"],
          k: [25, 44]
        },
        x: {
          a: "Cross Mark",
          b: "274C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["no", "delete", "remove", "cancel"],
          k: [50, 1]
        },
        four_leaf_clover: {
          a: "Four Leaf Clover",
          b: "1F340",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["vegetable", "plant", "nature", "lucky", "irish"],
          k: [7, 2]
        },
        open_file_folder: {
          a: "Open File Folder",
          b: "1F4C2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["documents", "load"],
          k: [25, 45]
        },
        boy: {
          skin_variations: {
            "1F3FB": {
              unified: "1F466-1F3FB",
              non_qualified: null,
              image: "1f466-1f3fb.png",
              sheet_x: 15,
              sheet_y: 43,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F466-1F3FC",
              non_qualified: null,
              image: "1f466-1f3fc.png",
              sheet_x: 15,
              sheet_y: 44,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F466-1F3FD",
              non_qualified: null,
              image: "1f466-1f3fd.png",
              sheet_x: 15,
              sheet_y: 45,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F466-1F3FE",
              non_qualified: null,
              image: "1f466-1f3fe.png",
              sheet_x: 15,
              sheet_y: 46,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F466-1F3FF",
              non_qualified: null,
              image: "1f466-1f3ff.png",
              sheet_x: 15,
              sheet_y: 47,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Boy",
          b: "1F466",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["man", "male", "guy", "teenager"],
          k: [15, 42]
        },
        ferry: {
          a: "Ferry",
          b: "26F4-FE0F",
          c: "26F4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["boat", "ship", "yacht"],
          k: [48, 42],
          o: 5
        },
        "flag-ht": {
          a: "Haiti Flag",
          b: "1F1ED-1F1F9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 30]
        },
        girl: {
          skin_variations: {
            "1F3FB": {
              unified: "1F467-1F3FB",
              non_qualified: null,
              image: "1f467-1f3fb.png",
              sheet_x: 15,
              sheet_y: 49,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F467-1F3FC",
              non_qualified: null,
              image: "1f467-1f3fc.png",
              sheet_x: 15,
              sheet_y: 50,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F467-1F3FD",
              non_qualified: null,
              image: "1f467-1f3fd.png",
              sheet_x: 15,
              sheet_y: 51,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F467-1F3FE",
              non_qualified: null,
              image: "1f467-1f3fe.png",
              sheet_x: 16,
              sheet_y: 0,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F467-1F3FF",
              non_qualified: null,
              image: "1f467-1f3ff.png",
              sheet_x: 16,
              sheet_y: 1,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Girl",
          b: "1F467",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["female", "woman", "teenager"],
          k: [15, 48]
        },
        negative_squared_cross_mark: {
          a: "Negative Squared Cross Mark",
          b: "274E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["x", "green-square", "no", "deny"],
          k: [50, 2]
        },
        "flag-hu": {
          a: "Hungary Flag",
          b: "1F1ED-1F1FA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 31]
        },
        card_index_dividers: {
          a: "Card Index Dividers",
          b: "1F5C2-FE0F",
          c: "1F5C2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["organizing", "business", "stationery"],
          k: [30, 4],
          o: 7
        },
        maple_leaf: {
          a: "Maple Leaf",
          b: "1F341",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nature", "plant", "vegetable", "ca", "fall"],
          k: [7, 3]
        },
        motor_boat: {
          a: "Motor Boat",
          b: "1F6E5-FE0F",
          c: "1F6E5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["ship"],
          k: [37, 13],
          o: 7
        },
        "flag-ic": {
          a: "Canary Islands Flag",
          b: "1F1EE-1F1E8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 32]
        },
        fallen_leaf: {
          a: "Fallen Leaf",
          b: "1F342",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nature", "plant", "vegetable", "leaves"],
          k: [7, 4]
        },
        adult: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9D1-1F3FB",
              non_qualified: null,
              image: "1f9d1-1f3fb.png",
              sheet_x: 42,
              sheet_y: 51,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F9D1-1F3FC",
              non_qualified: null,
              image: "1f9d1-1f3fc.png",
              sheet_x: 43,
              sheet_y: 0,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F9D1-1F3FD",
              non_qualified: null,
              image: "1f9d1-1f3fd.png",
              sheet_x: 43,
              sheet_y: 1,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F9D1-1F3FE",
              non_qualified: null,
              image: "1f9d1-1f3fe.png",
              sheet_x: 43,
              sheet_y: 2,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F9D1-1F3FF",
              non_qualified: null,
              image: "1f9d1-1f3ff.png",
              sheet_x: 43,
              sheet_y: 3,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Adult",
          b: "1F9D1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 50],
          o: 10
        },
        ship: {
          a: "Ship",
          b: "1F6A2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["transportation", "titanic", "deploy"],
          k: [34, 42]
        },
        heavy_plus_sign: {
          a: "Heavy Plus Sign",
          b: "2795",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["math", "calculation", "addition", "more", "increase"],
          k: [50, 9]
        },
        date: {
          a: "Calendar",
          b: "1F4C5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["calendar", "schedule"],
          k: [25, 48]
        },
        man: {
          skin_variations: {
            "1F3FB": {
              unified: "1F468-1F3FB",
              non_qualified: null,
              image: "1f468-1f3fb.png",
              sheet_x: 18,
              sheet_y: 12,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F468-1F3FC",
              non_qualified: null,
              image: "1f468-1f3fc.png",
              sheet_x: 18,
              sheet_y: 13,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F468-1F3FD",
              non_qualified: null,
              image: "1f468-1f3fd.png",
              sheet_x: 18,
              sheet_y: 14,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F468-1F3FE",
              non_qualified: null,
              image: "1f468-1f3fe.png",
              sheet_x: 18,
              sheet_y: 15,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F468-1F3FF",
              non_qualified: null,
              image: "1f468-1f3ff.png",
              sheet_x: 18,
              sheet_y: 16,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Man",
          b: "1F468",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["mustache", "father", "dad", "guy", "classy", "sir", "moustache"],
          k: [18, 11]
        },
        "flag-id": {
          a: "Indonesia Flag",
          b: "1F1EE-1F1E9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 33]
        },
        leaves: {
          a: "Leaf Fluttering in Wind",
          b: "1F343",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nature", "plant", "tree", "vegetable", "grass", "lawn", "spring"],
          k: [7, 5]
        },
        heavy_minus_sign: {
          a: "Heavy Minus Sign",
          b: "2796",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["math", "calculation", "subtract", "less"],
          k: [50, 10]
        },
        calendar: {
          a: "Tear-off Calendar",
          b: "1F4C6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["schedule", "date", "planning"],
          k: [25, 49]
        },
        airplane: {
          a: "Airplane",
          b: "2708-FE0F",
          c: "2708",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["vehicle", "transportation", "flight", "fly"],
          k: [49, 16],
          o: 1
        },
        spiral_note_pad: {
          a: "Spiral Note Pad",
          b: "1F5D2-FE0F",
          c: "1F5D2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [30, 8],
          o: 7
        },
        heavy_division_sign: {
          a: "Heavy Division Sign",
          b: "2797",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["divide", "math", "calculation"],
          k: [50, 11]
        },
        small_airplane: {
          a: "Small Airplane",
          b: "1F6E9-FE0F",
          c: "1F6E9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["flight", "transportation", "fly", "vehicle"],
          k: [37, 14],
          o: 7
        },
        woman: {
          skin_variations: {
            "1F3FB": {
              unified: "1F469-1F3FB",
              non_qualified: null,
              image: "1f469-1f3fb.png",
              sheet_x: 20,
              sheet_y: 24,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F469-1F3FC",
              non_qualified: null,
              image: "1f469-1f3fc.png",
              sheet_x: 20,
              sheet_y: 25,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F469-1F3FD",
              non_qualified: null,
              image: "1f469-1f3fd.png",
              sheet_x: 20,
              sheet_y: 26,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F469-1F3FE",
              non_qualified: null,
              image: "1f469-1f3fe.png",
              sheet_x: 20,
              sheet_y: 27,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F469-1F3FF",
              non_qualified: null,
              image: "1f469-1f3ff.png",
              sheet_x: 20,
              sheet_y: 28,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Woman",
          b: "1F469",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["female", "girls", "lady"],
          k: [20, 23]
        },
        "flag-ie": {
          a: "Ireland Flag",
          b: "1F1EE-1F1EA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 34]
        },
        curly_loop: {
          a: "Curly Loop",
          b: "27B0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["scribble", "draw", "shape", "squiggle"],
          k: [50, 13]
        },
        "flag-il": {
          a: "Israel Flag",
          b: "1F1EE-1F1F1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 35]
        },
        airplane_departure: {
          a: "Airplane Departure",
          b: "1F6EB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [37, 15],
          o: 7
        },
        spiral_calendar_pad: {
          a: "Spiral Calendar Pad",
          b: "1F5D3-FE0F",
          c: "1F5D3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [30, 9],
          o: 7
        },
        older_adult: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9D3-1F3FB",
              non_qualified: null,
              image: "1f9d3-1f3fb.png",
              sheet_x: 43,
              sheet_y: 11,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F9D3-1F3FC",
              non_qualified: null,
              image: "1f9d3-1f3fc.png",
              sheet_x: 43,
              sheet_y: 12,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F9D3-1F3FD",
              non_qualified: null,
              image: "1f9d3-1f3fd.png",
              sheet_x: 43,
              sheet_y: 13,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F9D3-1F3FE",
              non_qualified: null,
              image: "1f9d3-1f3fe.png",
              sheet_x: 43,
              sheet_y: 14,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F9D3-1F3FF",
              non_qualified: null,
              image: "1f9d3-1f3ff.png",
              sheet_x: 43,
              sheet_y: 15,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Older Adult",
          b: "1F9D3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [43, 10],
          o: 10
        },
        airplane_arriving: {
          a: "Airplane Arriving",
          b: "1F6EC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [37, 16],
          o: 7
        },
        card_index: {
          a: "Card Index",
          b: "1F4C7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["business", "stationery"],
          k: [25, 50]
        },
        loop: {
          a: "Double Curly Loop",
          b: "27BF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["tape", "cassette"],
          k: [50, 14]
        },
        older_man: {
          skin_variations: {
            "1F3FB": {
              unified: "1F474-1F3FB",
              non_qualified: null,
              image: "1f474-1f3fb.png",
              sheet_x: 21,
              sheet_y: 51,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F474-1F3FC",
              non_qualified: null,
              image: "1f474-1f3fc.png",
              sheet_x: 22,
              sheet_y: 0,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F474-1F3FD",
              non_qualified: null,
              image: "1f474-1f3fd.png",
              sheet_x: 22,
              sheet_y: 1,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F474-1F3FE",
              non_qualified: null,
              image: "1f474-1f3fe.png",
              sheet_x: 22,
              sheet_y: 2,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F474-1F3FF",
              non_qualified: null,
              image: "1f474-1f3ff.png",
              sheet_x: 22,
              sheet_y: 3,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Older Man",
          b: "1F474",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["human", "male", "men", "old", "elder", "senior"],
          k: [21, 50]
        },
        "flag-im": {
          a: "Isle of Man Flag",
          b: "1F1EE-1F1F2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 36]
        },
        "flag-in": {
          a: "India Flag",
          b: "1F1EE-1F1F3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 37]
        },
        chart_with_upwards_trend: {
          a: "Chart with Upwards Trend",
          b: "1F4C8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["graph", "presentation", "stats", "recovery", "business", "economics", "money", "sales", "good", "success"],
          k: [25, 51]
        },
        part_alternation_mark: {
          a: "Part Alternation Mark",
          b: "303D-FE0F",
          c: "303D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["graph", "presentation", "stats", "business", "economics", "bad"],
          k: [50, 25],
          o: 3
        },
        seat: {
          a: "Seat",
          b: "1F4BA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sit", "airplane", "transport", "bus", "flight", "fly"],
          k: [25, 37]
        },
        older_woman: {
          skin_variations: {
            "1F3FB": {
              unified: "1F475-1F3FB",
              non_qualified: null,
              image: "1f475-1f3fb.png",
              sheet_x: 22,
              sheet_y: 5,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F475-1F3FC",
              non_qualified: null,
              image: "1f475-1f3fc.png",
              sheet_x: 22,
              sheet_y: 6,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F475-1F3FD",
              non_qualified: null,
              image: "1f475-1f3fd.png",
              sheet_x: 22,
              sheet_y: 7,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F475-1F3FE",
              non_qualified: null,
              image: "1f475-1f3fe.png",
              sheet_x: 22,
              sheet_y: 8,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F475-1F3FF",
              non_qualified: null,
              image: "1f475-1f3ff.png",
              sheet_x: 22,
              sheet_y: 9,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Older Woman",
          b: "1F475",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["human", "female", "women", "lady", "old", "elder", "senior"],
          k: [22, 4]
        },
        eight_spoked_asterisk: {
          a: "Eight Spoked Asterisk",
          b: "2733-FE0F",
          c: "2733",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["star", "sparkle", "green-square"],
          k: [49, 49],
          o: 1
        },
        chart_with_downwards_trend: {
          a: "Chart with Downwards Trend",
          b: "1F4C9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["graph", "presentation", "stats", "recession", "business", "economics", "money", "sales", "bad", "failure"],
          k: [26, 0]
        },
        "flag-io": {
          a: "British Indian Ocean Territory Flag",
          b: "1F1EE-1F1F4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 38]
        },
        "male-doctor": {
          skin_variations: {
            "1F3FB": {
              unified: "1F468-1F3FB-200D-2695-FE0F",
              non_qualified: "1F468-1F3FB-200D-2695",
              image: "1f468-1f3fb-200d-2695-fe0f.png",
              sheet_x: 17,
              sheet_y: 44,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F468-1F3FC-200D-2695-FE0F",
              non_qualified: "1F468-1F3FC-200D-2695",
              image: "1f468-1f3fc-200d-2695-fe0f.png",
              sheet_x: 17,
              sheet_y: 45,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F468-1F3FD-200D-2695-FE0F",
              non_qualified: "1F468-1F3FD-200D-2695",
              image: "1f468-1f3fd-200d-2695-fe0f.png",
              sheet_x: 17,
              sheet_y: 46,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F468-1F3FE-200D-2695-FE0F",
              non_qualified: "1F468-1F3FE-200D-2695",
              image: "1f468-1f3fe-200d-2695-fe0f.png",
              sheet_x: 17,
              sheet_y: 47,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F468-1F3FF-200D-2695-FE0F",
              non_qualified: "1F468-1F3FF-200D-2695",
              image: "1f468-1f3ff-200d-2695-fe0f.png",
              sheet_x: 17,
              sheet_y: 48,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Male Doctor",
          b: "1F468-200D-2695-FE0F",
          c: "1F468-200D-2695",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [17, 43]
        },
        helicopter: {
          a: "Helicopter",
          b: "1F681",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["transportation", "vehicle", "fly"],
          k: [34, 9]
        },
        "female-doctor": {
          skin_variations: {
            "1F3FB": {
              unified: "1F469-1F3FB-200D-2695-FE0F",
              non_qualified: "1F469-1F3FB-200D-2695",
              image: "1f469-1f3fb-200d-2695-fe0f.png",
              sheet_x: 20,
              sheet_y: 2,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F469-1F3FC-200D-2695-FE0F",
              non_qualified: "1F469-1F3FC-200D-2695",
              image: "1f469-1f3fc-200d-2695-fe0f.png",
              sheet_x: 20,
              sheet_y: 3,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F469-1F3FD-200D-2695-FE0F",
              non_qualified: "1F469-1F3FD-200D-2695",
              image: "1f469-1f3fd-200d-2695-fe0f.png",
              sheet_x: 20,
              sheet_y: 4,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F469-1F3FE-200D-2695-FE0F",
              non_qualified: "1F469-1F3FE-200D-2695",
              image: "1f469-1f3fe-200d-2695-fe0f.png",
              sheet_x: 20,
              sheet_y: 5,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F469-1F3FF-200D-2695-FE0F",
              non_qualified: "1F469-1F3FF-200D-2695",
              image: "1f469-1f3ff-200d-2695-fe0f.png",
              sheet_x: 20,
              sheet_y: 6,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Female Doctor",
          b: "1F469-200D-2695-FE0F",
          c: "1F469-200D-2695",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [20, 1]
        },
        suspension_railway: {
          a: "Suspension Railway",
          b: "1F69F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["vehicle", "transportation"],
          k: [34, 39]
        },
        bar_chart: {
          a: "Bar Chart",
          b: "1F4CA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["graph", "presentation", "stats"],
          k: [26, 1]
        },
        "flag-iq": {
          a: "Iraq Flag",
          b: "1F1EE-1F1F6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 39]
        },
        eight_pointed_black_star: {
          a: "Eight Pointed Black Star",
          b: "2734-FE0F",
          c: "2734",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["orange-square", "shape", "polygon"],
          k: [49, 50],
          o: 1
        },
        mountain_cableway: {
          a: "Mountain Cableway",
          b: "1F6A0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["transportation", "vehicle", "ski"],
          k: [34, 40]
        },
        "male-student": {
          skin_variations: {
            "1F3FB": {
              unified: "1F468-1F3FB-200D-1F393",
              non_qualified: null,
              image: "1f468-1f3fb-200d-1f393.png",
              sheet_x: 16,
              sheet_y: 15,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F468-1F3FC-200D-1F393",
              non_qualified: null,
              image: "1f468-1f3fc-200d-1f393.png",
              sheet_x: 16,
              sheet_y: 16,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F468-1F3FD-200D-1F393",
              non_qualified: null,
              image: "1f468-1f3fd-200d-1f393.png",
              sheet_x: 16,
              sheet_y: 17,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F468-1F3FE-200D-1F393",
              non_qualified: null,
              image: "1f468-1f3fe-200d-1f393.png",
              sheet_x: 16,
              sheet_y: 18,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F468-1F3FF-200D-1F393",
              non_qualified: null,
              image: "1f468-1f3ff-200d-1f393.png",
              sheet_x: 16,
              sheet_y: 19,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Male Student",
          b: "1F468-200D-1F393",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [16, 14]
        },
        clipboard: {
          a: "Clipboard",
          b: "1F4CB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["stationery", "documents"],
          k: [26, 2]
        },
        "flag-ir": {
          a: "Iran Flag",
          b: "1F1EE-1F1F7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 40]
        },
        sparkle: {
          a: "Sparkle",
          b: "2747-FE0F",
          c: "2747",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["stars", "green-square", "awesome", "good", "fireworks"],
          k: [50, 0],
          o: 1
        },
        "female-student": {
          skin_variations: {
            "1F3FB": {
              unified: "1F469-1F3FB-200D-1F393",
              non_qualified: null,
              image: "1f469-1f3fb-200d-1f393.png",
              sheet_x: 18,
              sheet_y: 30,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F469-1F3FC-200D-1F393",
              non_qualified: null,
              image: "1f469-1f3fc-200d-1f393.png",
              sheet_x: 18,
              sheet_y: 31,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F469-1F3FD-200D-1F393",
              non_qualified: null,
              image: "1f469-1f3fd-200d-1f393.png",
              sheet_x: 18,
              sheet_y: 32,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F469-1F3FE-200D-1F393",
              non_qualified: null,
              image: "1f469-1f3fe-200d-1f393.png",
              sheet_x: 18,
              sheet_y: 33,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F469-1F3FF-200D-1F393",
              non_qualified: null,
              image: "1f469-1f3ff-200d-1f393.png",
              sheet_x: 18,
              sheet_y: 34,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Female Student",
          b: "1F469-200D-1F393",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [18, 29]
        },
        pushpin: {
          a: "Pushpin",
          b: "1F4CC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["stationery", "mark", "here"],
          k: [26, 3]
        },
        aerial_tramway: {
          a: "Aerial Tramway",
          b: "1F6A1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["transportation", "vehicle", "ski"],
          k: [34, 41]
        },
        "flag-is": {
          a: "Iceland Flag",
          b: "1F1EE-1F1F8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 41]
        },
        bangbang: {
          a: "Double Exclamation Mark",
          b: "203C-FE0F",
          c: "203C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["exclamation", "surprise"],
          k: [46, 29],
          o: 1
        },
        interrobang: {
          a: "Exclamation Question Mark",
          b: "2049-FE0F",
          c: "2049",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["wat", "punctuation", "surprise"],
          k: [46, 30],
          o: 3
        },
        satellite: {
          a: "Satellite",
          b: "1F6F0-FE0F",
          c: "1F6F0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["communication", "future", "radio", "space"],
          k: [37, 17],
          o: 7
        },
        it: {
          a: "Italy Flag",
          b: "1F1EE-1F1F9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["italy", "flag", "nation", "country", "banner"],
          k: [2, 42],
          n: ["flag-it"]
        },
        "male-teacher": {
          skin_variations: {
            "1F3FB": {
              unified: "1F468-1F3FB-200D-1F3EB",
              non_qualified: null,
              image: "1f468-1f3fb-200d-1f3eb.png",
              sheet_x: 16,
              sheet_y: 33,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F468-1F3FC-200D-1F3EB",
              non_qualified: null,
              image: "1f468-1f3fc-200d-1f3eb.png",
              sheet_x: 16,
              sheet_y: 34,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F468-1F3FD-200D-1F3EB",
              non_qualified: null,
              image: "1f468-1f3fd-200d-1f3eb.png",
              sheet_x: 16,
              sheet_y: 35,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F468-1F3FE-200D-1F3EB",
              non_qualified: null,
              image: "1f468-1f3fe-200d-1f3eb.png",
              sheet_x: 16,
              sheet_y: 36,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F468-1F3FF-200D-1F3EB",
              non_qualified: null,
              image: "1f468-1f3ff-200d-1f3eb.png",
              sheet_x: 16,
              sheet_y: 37,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Male Teacher",
          b: "1F468-200D-1F3EB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [16, 32]
        },
        round_pushpin: {
          a: "Round Pushpin",
          b: "1F4CD",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["stationery", "location", "map", "here"],
          k: [26, 4]
        },
        "flag-je": {
          a: "Jersey Flag",
          b: "1F1EF-1F1EA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 43]
        },
        question: {
          a: "Black Question Mark Ornament",
          b: "2753",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["doubt", "confused"],
          k: [50, 3]
        },
        rocket: {
          a: "Rocket",
          b: "1F680",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["launch", "ship", "staffmode", "NASA", "outer space", "outer_space", "fly"],
          k: [34, 8]
        },
        "female-teacher": {
          skin_variations: {
            "1F3FB": {
              unified: "1F469-1F3FB-200D-1F3EB",
              non_qualified: null,
              image: "1f469-1f3fb-200d-1f3eb.png",
              sheet_x: 18,
              sheet_y: 48,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F469-1F3FC-200D-1F3EB",
              non_qualified: null,
              image: "1f469-1f3fc-200d-1f3eb.png",
              sheet_x: 18,
              sheet_y: 49,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F469-1F3FD-200D-1F3EB",
              non_qualified: null,
              image: "1f469-1f3fd-200d-1f3eb.png",
              sheet_x: 18,
              sheet_y: 50,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F469-1F3FE-200D-1F3EB",
              non_qualified: null,
              image: "1f469-1f3fe-200d-1f3eb.png",
              sheet_x: 18,
              sheet_y: 51,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F469-1F3FF-200D-1F3EB",
              non_qualified: null,
              image: "1f469-1f3ff-200d-1f3eb.png",
              sheet_x: 19,
              sheet_y: 0,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Female Teacher",
          b: "1F469-200D-1F3EB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [18, 47]
        },
        paperclip: {
          a: "Paperclip",
          b: "1F4CE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["documents", "stationery"],
          k: [26, 5]
        },
        linked_paperclips: {
          a: "Linked Paperclips",
          b: "1F587-FE0F",
          c: "1F587",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [29, 27],
          o: 7
        },
        flying_saucer: {
          a: "Flying Saucer",
          b: "1F6F8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [37, 23],
          o: 10
        },
        "male-judge": {
          skin_variations: {
            "1F3FB": {
              unified: "1F468-1F3FB-200D-2696-FE0F",
              non_qualified: "1F468-1F3FB-200D-2696",
              image: "1f468-1f3fb-200d-2696-fe0f.png",
              sheet_x: 17,
              sheet_y: 50,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F468-1F3FC-200D-2696-FE0F",
              non_qualified: "1F468-1F3FC-200D-2696",
              image: "1f468-1f3fc-200d-2696-fe0f.png",
              sheet_x: 17,
              sheet_y: 51,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F468-1F3FD-200D-2696-FE0F",
              non_qualified: "1F468-1F3FD-200D-2696",
              image: "1f468-1f3fd-200d-2696-fe0f.png",
              sheet_x: 18,
              sheet_y: 0,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F468-1F3FE-200D-2696-FE0F",
              non_qualified: "1F468-1F3FE-200D-2696",
              image: "1f468-1f3fe-200d-2696-fe0f.png",
              sheet_x: 18,
              sheet_y: 1,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F468-1F3FF-200D-2696-FE0F",
              non_qualified: "1F468-1F3FF-200D-2696",
              image: "1f468-1f3ff-200d-2696-fe0f.png",
              sheet_x: 18,
              sheet_y: 2,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Male Judge",
          b: "1F468-200D-2696-FE0F",
          c: "1F468-200D-2696",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [17, 49]
        },
        grey_question: {
          a: "White Question Mark Ornament",
          b: "2754",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["doubts", "gray", "huh", "confused"],
          k: [50, 4]
        },
        "flag-jm": {
          a: "Jamaica Flag",
          b: "1F1EF-1F1F2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 44]
        },
        bellhop_bell: {
          a: "Bellhop Bell",
          b: "1F6CE-FE0F",
          c: "1F6CE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["service"],
          k: [37, 3],
          o: 7
        },
        straight_ruler: {
          a: "Straight Ruler",
          b: "1F4CF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["stationery", "calculate", "length", "math", "school", "drawing", "architect", "sketch"],
          k: [26, 6]
        },
        "flag-jo": {
          a: "Jordan Flag",
          b: "1F1EF-1F1F4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 45]
        },
        "female-judge": {
          skin_variations: {
            "1F3FB": {
              unified: "1F469-1F3FB-200D-2696-FE0F",
              non_qualified: "1F469-1F3FB-200D-2696",
              image: "1f469-1f3fb-200d-2696-fe0f.png",
              sheet_x: 20,
              sheet_y: 8,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F469-1F3FC-200D-2696-FE0F",
              non_qualified: "1F469-1F3FC-200D-2696",
              image: "1f469-1f3fc-200d-2696-fe0f.png",
              sheet_x: 20,
              sheet_y: 9,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F469-1F3FD-200D-2696-FE0F",
              non_qualified: "1F469-1F3FD-200D-2696",
              image: "1f469-1f3fd-200d-2696-fe0f.png",
              sheet_x: 20,
              sheet_y: 10,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F469-1F3FE-200D-2696-FE0F",
              non_qualified: "1F469-1F3FE-200D-2696",
              image: "1f469-1f3fe-200d-2696-fe0f.png",
              sheet_x: 20,
              sheet_y: 11,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F469-1F3FF-200D-2696-FE0F",
              non_qualified: "1F469-1F3FF-200D-2696",
              image: "1f469-1f3ff-200d-2696-fe0f.png",
              sheet_x: 20,
              sheet_y: 12,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Female Judge",
          b: "1F469-200D-2696-FE0F",
          c: "1F469-200D-2696",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [20, 7]
        },
        grey_exclamation: {
          a: "White Exclamation Mark Ornament",
          b: "2755",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["surprise", "punctuation", "gray", "wow", "warning"],
          k: [50, 5]
        },
        door: {
          a: "Door",
          b: "1F6AA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["house", "entry", "exit"],
          k: [35, 15]
        },
        "male-farmer": {
          skin_variations: {
            "1F3FB": {
              unified: "1F468-1F3FB-200D-1F33E",
              non_qualified: null,
              image: "1f468-1f3fb-200d-1f33e.png",
              sheet_x: 16,
              sheet_y: 3,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F468-1F3FC-200D-1F33E",
              non_qualified: null,
              image: "1f468-1f3fc-200d-1f33e.png",
              sheet_x: 16,
              sheet_y: 4,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F468-1F3FD-200D-1F33E",
              non_qualified: null,
              image: "1f468-1f3fd-200d-1f33e.png",
              sheet_x: 16,
              sheet_y: 5,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F468-1F3FE-200D-1F33E",
              non_qualified: null,
              image: "1f468-1f3fe-200d-1f33e.png",
              sheet_x: 16,
              sheet_y: 6,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F468-1F3FF-200D-1F33E",
              non_qualified: null,
              image: "1f468-1f3ff-200d-1f33e.png",
              sheet_x: 16,
              sheet_y: 7,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Male Farmer",
          b: "1F468-200D-1F33E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [16, 2]
        },
        jp: {
          a: "Japan Flag",
          b: "1F1EF-1F1F5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["japanese", "nation", "flag", "country", "banner"],
          k: [2, 46],
          n: ["flag-jp"]
        },
        triangular_ruler: {
          a: "Triangular Ruler",
          b: "1F4D0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["stationery", "math", "architect", "sketch"],
          k: [26, 7]
        },
        exclamation: {
          a: "Heavy Exclamation Mark Symbol",
          b: "2757",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["heavy_exclamation_mark", "danger", "surprise", "punctuation", "wow", "warning"],
          k: [50, 6],
          n: ["heavy_exclamation_mark"],
          o: 5
        },
        bed: {
          a: "Bed",
          b: "1F6CF-FE0F",
          c: "1F6CF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["sleep", "rest"],
          k: [37, 4],
          o: 7
        },
        "female-farmer": {
          skin_variations: {
            "1F3FB": {
              unified: "1F469-1F3FB-200D-1F33E",
              non_qualified: null,
              image: "1f469-1f3fb-200d-1f33e.png",
              sheet_x: 18,
              sheet_y: 18,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F469-1F3FC-200D-1F33E",
              non_qualified: null,
              image: "1f469-1f3fc-200d-1f33e.png",
              sheet_x: 18,
              sheet_y: 19,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F469-1F3FD-200D-1F33E",
              non_qualified: null,
              image: "1f469-1f3fd-200d-1f33e.png",
              sheet_x: 18,
              sheet_y: 20,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F469-1F3FE-200D-1F33E",
              non_qualified: null,
              image: "1f469-1f3fe-200d-1f33e.png",
              sheet_x: 18,
              sheet_y: 21,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F469-1F3FF-200D-1F33E",
              non_qualified: null,
              image: "1f469-1f3ff-200d-1f33e.png",
              sheet_x: 18,
              sheet_y: 22,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Female Farmer",
          b: "1F469-200D-1F33E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [18, 17]
        },
        scissors: {
          a: "Black Scissors",
          b: "2702-FE0F",
          c: "2702",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["stationery", "cut"],
          k: [49, 14],
          o: 1
        },
        wavy_dash: {
          a: "Wavy Dash",
          b: "3030-FE0F",
          c: "3030",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["draw", "line", "moustache", "mustache", "squiggle", "scribble"],
          k: [50, 24],
          o: 1
        },
        "flag-ke": {
          a: "Kenya Flag",
          b: "1F1F0-1F1EA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 47]
        },
        "flag-kg": {
          a: "Kyrgyzstan Flag",
          b: "1F1F0-1F1EC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 48]
        },
        couch_and_lamp: {
          a: "Couch and Lamp",
          b: "1F6CB-FE0F",
          c: "1F6CB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["read", "chill"],
          k: [36, 47],
          o: 7
        },
        "male-cook": {
          skin_variations: {
            "1F3FB": {
              unified: "1F468-1F3FB-200D-1F373",
              non_qualified: null,
              image: "1f468-1f3fb-200d-1f373.png",
              sheet_x: 16,
              sheet_y: 9,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F468-1F3FC-200D-1F373",
              non_qualified: null,
              image: "1f468-1f3fc-200d-1f373.png",
              sheet_x: 16,
              sheet_y: 10,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F468-1F3FD-200D-1F373",
              non_qualified: null,
              image: "1f468-1f3fd-200d-1f373.png",
              sheet_x: 16,
              sheet_y: 11,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F468-1F3FE-200D-1F373",
              non_qualified: null,
              image: "1f468-1f3fe-200d-1f373.png",
              sheet_x: 16,
              sheet_y: 12,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F468-1F3FF-200D-1F373",
              non_qualified: null,
              image: "1f468-1f3ff-200d-1f373.png",
              sheet_x: 16,
              sheet_y: 13,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Male Cook",
          b: "1F468-200D-1F373",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [16, 8]
        },
        card_file_box: {
          a: "Card File Box",
          b: "1F5C3-FE0F",
          c: "1F5C3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["business", "stationery"],
          k: [30, 5],
          o: 7
        },
        copyright: {
          a: "Copyright Sign",
          b: "00A9-FE0F",
          c: "00A9",
          d: !0,
          e: !0,
          f: !1,
          g: !0,
          h: !1,
          i: !1,
          j: ["ip", "license", "circle", "law", "legal"],
          k: [0, 12],
          o: 1
        },
        file_cabinet: {
          a: "File Cabinet",
          b: "1F5C4-FE0F",
          c: "1F5C4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["filing", "organizing"],
          k: [30, 6],
          o: 7
        },
        registered: {
          a: "Registered Sign",
          b: "00AE-FE0F",
          c: "00AE",
          d: !0,
          e: !0,
          f: !1,
          g: !0,
          h: !1,
          i: !1,
          j: ["alphabet", "circle"],
          k: [0, 13],
          o: 1
        },
        "flag-kh": {
          a: "Cambodia Flag",
          b: "1F1F0-1F1ED",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 49]
        },
        "female-cook": {
          skin_variations: {
            "1F3FB": {
              unified: "1F469-1F3FB-200D-1F373",
              non_qualified: null,
              image: "1f469-1f3fb-200d-1f373.png",
              sheet_x: 18,
              sheet_y: 24,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F469-1F3FC-200D-1F373",
              non_qualified: null,
              image: "1f469-1f3fc-200d-1f373.png",
              sheet_x: 18,
              sheet_y: 25,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F469-1F3FD-200D-1F373",
              non_qualified: null,
              image: "1f469-1f3fd-200d-1f373.png",
              sheet_x: 18,
              sheet_y: 26,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F469-1F3FE-200D-1F373",
              non_qualified: null,
              image: "1f469-1f3fe-200d-1f373.png",
              sheet_x: 18,
              sheet_y: 27,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F469-1F3FF-200D-1F373",
              non_qualified: null,
              image: "1f469-1f3ff-200d-1f373.png",
              sheet_x: 18,
              sheet_y: 28,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Female Cook",
          b: "1F469-200D-1F373",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [18, 23]
        },
        toilet: {
          a: "Toilet",
          b: "1F6BD",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["restroom", "wc", "washroom", "bathroom", "potty"],
          k: [36, 33]
        },
        wastebasket: {
          a: "Wastebasket",
          b: "1F5D1-FE0F",
          c: "1F5D1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["bin", "trash", "rubbish", "garbage", "toss"],
          k: [30, 7],
          o: 7
        },
        "flag-ki": {
          a: "Kiribati Flag",
          b: "1F1F0-1F1EE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 50]
        },
        shower: {
          a: "Shower",
          b: "1F6BF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["clean", "water", "bathroom"],
          k: [36, 35]
        },
        "male-mechanic": {
          skin_variations: {
            "1F3FB": {
              unified: "1F468-1F3FB-200D-1F527",
              non_qualified: null,
              image: "1f468-1f3fb-200d-1f527.png",
              sheet_x: 17,
              sheet_y: 20,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F468-1F3FC-200D-1F527",
              non_qualified: null,
              image: "1f468-1f3fc-200d-1f527.png",
              sheet_x: 17,
              sheet_y: 21,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F468-1F3FD-200D-1F527",
              non_qualified: null,
              image: "1f468-1f3fd-200d-1f527.png",
              sheet_x: 17,
              sheet_y: 22,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F468-1F3FE-200D-1F527",
              non_qualified: null,
              image: "1f468-1f3fe-200d-1f527.png",
              sheet_x: 17,
              sheet_y: 23,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F468-1F3FF-200D-1F527",
              non_qualified: null,
              image: "1f468-1f3ff-200d-1f527.png",
              sheet_x: 17,
              sheet_y: 24,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Male Mechanic",
          b: "1F468-200D-1F527",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [17, 19]
        },
        tm: {
          a: "Trade Mark Sign",
          b: "2122-FE0F",
          c: "2122",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["trademark", "brand", "law", "legal"],
          k: [46, 31],
          o: 1
        },
        hash: {
          a: "Hash Key",
          b: "0023-FE0F-20E3",
          c: "0023-20E3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          j: ["symbol", "blue-square", "twitter"],
          k: [0, 0],
          o: 3
        },
        "flag-km": {
          a: "Comoros Flag",
          b: "1F1F0-1F1F2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 51]
        },
        bathtub: {
          a: "Bathtub",
          b: "1F6C1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["clean", "shower", "bathroom"],
          k: [36, 42]
        },
        "female-mechanic": {
          skin_variations: {
            "1F3FB": {
              unified: "1F469-1F3FB-200D-1F527",
              non_qualified: null,
              image: "1f469-1f3fb-200d-1f527.png",
              sheet_x: 19,
              sheet_y: 30,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F469-1F3FC-200D-1F527",
              non_qualified: null,
              image: "1f469-1f3fc-200d-1f527.png",
              sheet_x: 19,
              sheet_y: 31,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F469-1F3FD-200D-1F527",
              non_qualified: null,
              image: "1f469-1f3fd-200d-1f527.png",
              sheet_x: 19,
              sheet_y: 32,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F469-1F3FE-200D-1F527",
              non_qualified: null,
              image: "1f469-1f3fe-200d-1f527.png",
              sheet_x: 19,
              sheet_y: 33,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F469-1F3FF-200D-1F527",
              non_qualified: null,
              image: "1f469-1f3ff-200d-1f527.png",
              sheet_x: 19,
              sheet_y: 34,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Female Mechanic",
          b: "1F469-200D-1F527",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [19, 29]
        },
        lock: {
          a: "Lock",
          b: "1F512",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["security", "password", "padlock"],
          k: [27, 20]
        },
        "male-factory-worker": {
          skin_variations: {
            "1F3FB": {
              unified: "1F468-1F3FB-200D-1F3ED",
              non_qualified: null,
              image: "1f468-1f3fb-200d-1f3ed.png",
              sheet_x: 16,
              sheet_y: 39,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F468-1F3FC-200D-1F3ED",
              non_qualified: null,
              image: "1f468-1f3fc-200d-1f3ed.png",
              sheet_x: 16,
              sheet_y: 40,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F468-1F3FD-200D-1F3ED",
              non_qualified: null,
              image: "1f468-1f3fd-200d-1f3ed.png",
              sheet_x: 16,
              sheet_y: 41,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F468-1F3FE-200D-1F3ED",
              non_qualified: null,
              image: "1f468-1f3fe-200d-1f3ed.png",
              sheet_x: 16,
              sheet_y: 42,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F468-1F3FF-200D-1F3ED",
              non_qualified: null,
              image: "1f468-1f3ff-200d-1f3ed.png",
              sheet_x: 16,
              sheet_y: 43,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Male Factory Worker",
          b: "1F468-200D-1F3ED",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [16, 38]
        },
        "flag-kn": {
          a: "St. Kitts & Nevis Flag",
          b: "1F1F0-1F1F3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 0]
        },
        hourglass: {
          a: "Hourglass",
          b: "231B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "clock", "oldschool", "limit", "exam", "quiz", "test"],
          k: [46, 42],
          o: 1
        },
        keycap_star: {
          a: "Keycap Star",
          b: "002A-FE0F-20E3",
          c: "002A-20E3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          k: [0, 1],
          o: 3
        },
        unlock: {
          a: "Open Lock",
          b: "1F513",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["privacy", "security"],
          k: [27, 21]
        },
        "flag-kp": {
          a: "North Korea Flag",
          b: "1F1F0-1F1F5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 1]
        },
        "female-factory-worker": {
          skin_variations: {
            "1F3FB": {
              unified: "1F469-1F3FB-200D-1F3ED",
              non_qualified: null,
              image: "1f469-1f3fb-200d-1f3ed.png",
              sheet_x: 19,
              sheet_y: 2,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F469-1F3FC-200D-1F3ED",
              non_qualified: null,
              image: "1f469-1f3fc-200d-1f3ed.png",
              sheet_x: 19,
              sheet_y: 3,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F469-1F3FD-200D-1F3ED",
              non_qualified: null,
              image: "1f469-1f3fd-200d-1f3ed.png",
              sheet_x: 19,
              sheet_y: 4,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F469-1F3FE-200D-1F3ED",
              non_qualified: null,
              image: "1f469-1f3fe-200d-1f3ed.png",
              sheet_x: 19,
              sheet_y: 5,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F469-1F3FF-200D-1F3ED",
              non_qualified: null,
              image: "1f469-1f3ff-200d-1f3ed.png",
              sheet_x: 19,
              sheet_y: 6,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Female Factory Worker",
          b: "1F469-200D-1F3ED",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [19, 1]
        },
        zero: {
          a: "Keycap 0",
          b: "0030-FE0F-20E3",
          c: "0030-20E3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          j: ["0", "numbers", "blue-square", "null"],
          k: [0, 2],
          o: 3
        },
        lock_with_ink_pen: {
          a: "Lock with Ink Pen",
          b: "1F50F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["security", "secret"],
          k: [27, 17]
        },
        hourglass_flowing_sand: {
          a: "Hourglass with Flowing Sand",
          b: "23F3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["oldschool", "time", "countdown"],
          k: [47, 3]
        },
        one: {
          a: "Keycap 1",
          b: "0031-FE0F-20E3",
          c: "0031-20E3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          j: ["blue-square", "numbers", "1"],
          k: [0, 3],
          o: 3
        },
        kr: {
          a: "South Korea Flag",
          b: "1F1F0-1F1F7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["south", "korea", "nation", "flag", "country", "banner"],
          k: [3, 2],
          n: ["flag-kr"]
        },
        watch: {
          a: "Watch",
          b: "231A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "accessories"],
          k: [46, 41],
          o: 1
        },
        "male-office-worker": {
          skin_variations: {
            "1F3FB": {
              unified: "1F468-1F3FB-200D-1F4BC",
              non_qualified: null,
              image: "1f468-1f3fb-200d-1f4bc.png",
              sheet_x: 17,
              sheet_y: 14,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F468-1F3FC-200D-1F4BC",
              non_qualified: null,
              image: "1f468-1f3fc-200d-1f4bc.png",
              sheet_x: 17,
              sheet_y: 15,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F468-1F3FD-200D-1F4BC",
              non_qualified: null,
              image: "1f468-1f3fd-200d-1f4bc.png",
              sheet_x: 17,
              sheet_y: 16,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F468-1F3FE-200D-1F4BC",
              non_qualified: null,
              image: "1f468-1f3fe-200d-1f4bc.png",
              sheet_x: 17,
              sheet_y: 17,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F468-1F3FF-200D-1F4BC",
              non_qualified: null,
              image: "1f468-1f3ff-200d-1f4bc.png",
              sheet_x: 17,
              sheet_y: 18,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Male Office Worker",
          b: "1F468-200D-1F4BC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [17, 13]
        },
        closed_lock_with_key: {
          a: "Closed Lock with Key",
          b: "1F510",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["security", "privacy"],
          k: [27, 18]
        },
        "female-office-worker": {
          skin_variations: {
            "1F3FB": {
              unified: "1F469-1F3FB-200D-1F4BC",
              non_qualified: null,
              image: "1f469-1f3fb-200d-1f4bc.png",
              sheet_x: 19,
              sheet_y: 24,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F469-1F3FC-200D-1F4BC",
              non_qualified: null,
              image: "1f469-1f3fc-200d-1f4bc.png",
              sheet_x: 19,
              sheet_y: 25,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F469-1F3FD-200D-1F4BC",
              non_qualified: null,
              image: "1f469-1f3fd-200d-1f4bc.png",
              sheet_x: 19,
              sheet_y: 26,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F469-1F3FE-200D-1F4BC",
              non_qualified: null,
              image: "1f469-1f3fe-200d-1f4bc.png",
              sheet_x: 19,
              sheet_y: 27,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F469-1F3FF-200D-1F4BC",
              non_qualified: null,
              image: "1f469-1f3ff-200d-1f4bc.png",
              sheet_x: 19,
              sheet_y: 28,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Female Office Worker",
          b: "1F469-200D-1F4BC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [19, 23]
        },
        two: {
          a: "Keycap 2",
          b: "0032-FE0F-20E3",
          c: "0032-20E3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          j: ["numbers", "2", "prime", "blue-square"],
          k: [0, 4],
          o: 3
        },
        alarm_clock: {
          a: "Alarm Clock",
          b: "23F0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "wake"],
          k: [47, 0]
        },
        key: {
          a: "Key",
          b: "1F511",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["lock", "door", "password"],
          k: [27, 19]
        },
        "flag-kw": {
          a: "Kuwait Flag",
          b: "1F1F0-1F1FC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 3]
        },
        stopwatch: {
          a: "Stopwatch",
          b: "23F1-FE0F",
          c: "23F1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["time", "deadline"],
          k: [47, 1]
        },
        "male-scientist": {
          skin_variations: {
            "1F3FB": {
              unified: "1F468-1F3FB-200D-1F52C",
              non_qualified: null,
              image: "1f468-1f3fb-200d-1f52c.png",
              sheet_x: 17,
              sheet_y: 26,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F468-1F3FC-200D-1F52C",
              non_qualified: null,
              image: "1f468-1f3fc-200d-1f52c.png",
              sheet_x: 17,
              sheet_y: 27,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F468-1F3FD-200D-1F52C",
              non_qualified: null,
              image: "1f468-1f3fd-200d-1f52c.png",
              sheet_x: 17,
              sheet_y: 28,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F468-1F3FE-200D-1F52C",
              non_qualified: null,
              image: "1f468-1f3fe-200d-1f52c.png",
              sheet_x: 17,
              sheet_y: 29,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F468-1F3FF-200D-1F52C",
              non_qualified: null,
              image: "1f468-1f3ff-200d-1f52c.png",
              sheet_x: 17,
              sheet_y: 30,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Male Scientist",
          b: "1F468-200D-1F52C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [17, 25]
        },
        three: {
          a: "Keycap 3",
          b: "0033-FE0F-20E3",
          c: "0033-20E3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          j: ["3", "numbers", "prime", "blue-square"],
          k: [0, 5],
          o: 3
        },
        "flag-ky": {
          a: "Cayman Islands Flag",
          b: "1F1F0-1F1FE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 4]
        },
        old_key: {
          a: "Old Key",
          b: "1F5DD-FE0F",
          c: "1F5DD",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["lock", "door", "password"],
          k: [30, 11],
          o: 7
        },
        "flag-kz": {
          a: "Kazakhstan Flag",
          b: "1F1F0-1F1FF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 5]
        },
        hammer: {
          a: "Hammer",
          b: "1F528",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["tools", "build", "create"],
          k: [27, 42]
        },
        "female-scientist": {
          skin_variations: {
            "1F3FB": {
              unified: "1F469-1F3FB-200D-1F52C",
              non_qualified: null,
              image: "1f469-1f3fb-200d-1f52c.png",
              sheet_x: 19,
              sheet_y: 36,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F469-1F3FC-200D-1F52C",
              non_qualified: null,
              image: "1f469-1f3fc-200d-1f52c.png",
              sheet_x: 19,
              sheet_y: 37,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F469-1F3FD-200D-1F52C",
              non_qualified: null,
              image: "1f469-1f3fd-200d-1f52c.png",
              sheet_x: 19,
              sheet_y: 38,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F469-1F3FE-200D-1F52C",
              non_qualified: null,
              image: "1f469-1f3fe-200d-1f52c.png",
              sheet_x: 19,
              sheet_y: 39,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F469-1F3FF-200D-1F52C",
              non_qualified: null,
              image: "1f469-1f3ff-200d-1f52c.png",
              sheet_x: 19,
              sheet_y: 40,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Female Scientist",
          b: "1F469-200D-1F52C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [19, 35]
        },
        timer_clock: {
          a: "Timer Clock",
          b: "23F2-FE0F",
          c: "23F2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["alarm"],
          k: [47, 2]
        },
        four: {
          a: "Keycap 4",
          b: "0034-FE0F-20E3",
          c: "0034-20E3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          j: ["4", "numbers", "blue-square"],
          k: [0, 6],
          o: 3
        },
        "male-technologist": {
          skin_variations: {
            "1F3FB": {
              unified: "1F468-1F3FB-200D-1F4BB",
              non_qualified: null,
              image: "1f468-1f3fb-200d-1f4bb.png",
              sheet_x: 17,
              sheet_y: 8,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F468-1F3FC-200D-1F4BB",
              non_qualified: null,
              image: "1f468-1f3fc-200d-1f4bb.png",
              sheet_x: 17,
              sheet_y: 9,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F468-1F3FD-200D-1F4BB",
              non_qualified: null,
              image: "1f468-1f3fd-200d-1f4bb.png",
              sheet_x: 17,
              sheet_y: 10,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F468-1F3FE-200D-1F4BB",
              non_qualified: null,
              image: "1f468-1f3fe-200d-1f4bb.png",
              sheet_x: 17,
              sheet_y: 11,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F468-1F3FF-200D-1F4BB",
              non_qualified: null,
              image: "1f468-1f3ff-200d-1f4bb.png",
              sheet_x: 17,
              sheet_y: 12,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Male Technologist",
          b: "1F468-200D-1F4BB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [17, 7]
        },
        mantelpiece_clock: {
          a: "Mantelpiece Clock",
          b: "1F570-FE0F",
          c: "1F570",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["time"],
          k: [28, 43],
          o: 7
        },
        five: {
          a: "Keycap 5",
          b: "0035-FE0F-20E3",
          c: "0035-20E3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          j: ["5", "numbers", "blue-square", "prime"],
          k: [0, 7],
          o: 3
        },
        "flag-la": {
          a: "Laos Flag",
          b: "1F1F1-1F1E6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 6]
        },
        pick: {
          a: "Pick",
          b: "26CF-FE0F",
          c: "26CF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["tools", "dig"],
          k: [48, 32],
          o: 5
        },
        "flag-lb": {
          a: "Lebanon Flag",
          b: "1F1F1-1F1E7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 7]
        },
        clock12: {
          a: "Clock Face Twelve Oclock",
          b: "1F55B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "noon", "midnight", "midday", "late", "early", "schedule"],
          k: [28, 29]
        },
        hammer_and_pick: {
          a: "Hammer and Pick",
          b: "2692-FE0F",
          c: "2692",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["tools", "build", "create"],
          k: [48, 11],
          o: 4
        },
        six: {
          a: "Keycap 6",
          b: "0036-FE0F-20E3",
          c: "0036-20E3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          j: ["6", "numbers", "blue-square"],
          k: [0, 8],
          o: 3
        },
        "female-technologist": {
          skin_variations: {
            "1F3FB": {
              unified: "1F469-1F3FB-200D-1F4BB",
              non_qualified: null,
              image: "1f469-1f3fb-200d-1f4bb.png",
              sheet_x: 19,
              sheet_y: 18,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F469-1F3FC-200D-1F4BB",
              non_qualified: null,
              image: "1f469-1f3fc-200d-1f4bb.png",
              sheet_x: 19,
              sheet_y: 19,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F469-1F3FD-200D-1F4BB",
              non_qualified: null,
              image: "1f469-1f3fd-200d-1f4bb.png",
              sheet_x: 19,
              sheet_y: 20,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F469-1F3FE-200D-1F4BB",
              non_qualified: null,
              image: "1f469-1f3fe-200d-1f4bb.png",
              sheet_x: 19,
              sheet_y: 21,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F469-1F3FF-200D-1F4BB",
              non_qualified: null,
              image: "1f469-1f3ff-200d-1f4bb.png",
              sheet_x: 19,
              sheet_y: 22,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Female Technologist",
          b: "1F469-200D-1F4BB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [19, 17]
        },
        hammer_and_wrench: {
          a: "Hammer and Wrench",
          b: "1F6E0-FE0F",
          c: "1F6E0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["tools", "build", "create"],
          k: [37, 8],
          o: 7
        },
        "flag-lc": {
          a: "St. Lucia Flag",
          b: "1F1F1-1F1E8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 8]
        },
        clock1230: {
          a: "Clock Face Twelve-Thirty",
          b: "1F567",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule"],
          k: [28, 41]
        },
        seven: {
          a: "Keycap 7",
          b: "0037-FE0F-20E3",
          c: "0037-20E3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          j: ["7", "numbers", "blue-square", "prime"],
          k: [0, 9],
          o: 3
        },
        "male-singer": {
          skin_variations: {
            "1F3FB": {
              unified: "1F468-1F3FB-200D-1F3A4",
              non_qualified: null,
              image: "1f468-1f3fb-200d-1f3a4.png",
              sheet_x: 16,
              sheet_y: 21,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F468-1F3FC-200D-1F3A4",
              non_qualified: null,
              image: "1f468-1f3fc-200d-1f3a4.png",
              sheet_x: 16,
              sheet_y: 22,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F468-1F3FD-200D-1F3A4",
              non_qualified: null,
              image: "1f468-1f3fd-200d-1f3a4.png",
              sheet_x: 16,
              sheet_y: 23,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F468-1F3FE-200D-1F3A4",
              non_qualified: null,
              image: "1f468-1f3fe-200d-1f3a4.png",
              sheet_x: 16,
              sheet_y: 24,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F468-1F3FF-200D-1F3A4",
              non_qualified: null,
              image: "1f468-1f3ff-200d-1f3a4.png",
              sheet_x: 16,
              sheet_y: 25,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Male Singer",
          b: "1F468-200D-1F3A4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [16, 20]
        },
        eight: {
          a: "Keycap 8",
          b: "0038-FE0F-20E3",
          c: "0038-20E3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          j: ["8", "blue-square", "numbers"],
          k: [0, 10],
          o: 3
        },
        "flag-li": {
          a: "Liechtenstein Flag",
          b: "1F1F1-1F1EE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 9]
        },
        dagger_knife: {
          a: "Dagger Knife",
          b: "1F5E1-FE0F",
          c: "1F5E1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [30, 13],
          o: 7
        },
        clock1: {
          a: "Clock Face One Oclock",
          b: "1F550",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule"],
          k: [28, 18]
        },
        "female-singer": {
          skin_variations: {
            "1F3FB": {
              unified: "1F469-1F3FB-200D-1F3A4",
              non_qualified: null,
              image: "1f469-1f3fb-200d-1f3a4.png",
              sheet_x: 18,
              sheet_y: 36,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F469-1F3FC-200D-1F3A4",
              non_qualified: null,
              image: "1f469-1f3fc-200d-1f3a4.png",
              sheet_x: 18,
              sheet_y: 37,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F469-1F3FD-200D-1F3A4",
              non_qualified: null,
              image: "1f469-1f3fd-200d-1f3a4.png",
              sheet_x: 18,
              sheet_y: 38,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F469-1F3FE-200D-1F3A4",
              non_qualified: null,
              image: "1f469-1f3fe-200d-1f3a4.png",
              sheet_x: 18,
              sheet_y: 39,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F469-1F3FF-200D-1F3A4",
              non_qualified: null,
              image: "1f469-1f3ff-200d-1f3a4.png",
              sheet_x: 18,
              sheet_y: 40,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Female Singer",
          b: "1F469-200D-1F3A4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [18, 35]
        },
        "male-artist": {
          skin_variations: {
            "1F3FB": {
              unified: "1F468-1F3FB-200D-1F3A8",
              non_qualified: null,
              image: "1f468-1f3fb-200d-1f3a8.png",
              sheet_x: 16,
              sheet_y: 27,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F468-1F3FC-200D-1F3A8",
              non_qualified: null,
              image: "1f468-1f3fc-200d-1f3a8.png",
              sheet_x: 16,
              sheet_y: 28,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F468-1F3FD-200D-1F3A8",
              non_qualified: null,
              image: "1f468-1f3fd-200d-1f3a8.png",
              sheet_x: 16,
              sheet_y: 29,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F468-1F3FE-200D-1F3A8",
              non_qualified: null,
              image: "1f468-1f3fe-200d-1f3a8.png",
              sheet_x: 16,
              sheet_y: 30,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F468-1F3FF-200D-1F3A8",
              non_qualified: null,
              image: "1f468-1f3ff-200d-1f3a8.png",
              sheet_x: 16,
              sheet_y: 31,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Male Artist",
          b: "1F468-200D-1F3A8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [16, 26]
        },
        crossed_swords: {
          a: "Crossed Swords",
          b: "2694-FE0F",
          c: "2694",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["weapon"],
          k: [48, 13],
          o: 4
        },
        nine: {
          a: "Keycap 9",
          b: "0039-FE0F-20E3",
          c: "0039-20E3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          j: ["blue-square", "numbers", "9"],
          k: [0, 11],
          o: 3
        },
        "flag-lk": {
          a: "Sri Lanka Flag",
          b: "1F1F1-1F1F0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 10]
        },
        clock130: {
          a: "Clock Face One-Thirty",
          b: "1F55C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule"],
          k: [28, 30]
        },
        clock2: {
          a: "Clock Face Two Oclock",
          b: "1F551",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule"],
          k: [28, 19]
        },
        gun: {
          a: "Pistol",
          b: "1F52B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["violence", "weapon", "pistol", "revolver"],
          k: [27, 45]
        },
        keycap_ten: {
          a: "Keycap Ten",
          b: "1F51F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["numbers", "10", "blue-square"],
          k: [27, 33]
        },
        "female-artist": {
          skin_variations: {
            "1F3FB": {
              unified: "1F469-1F3FB-200D-1F3A8",
              non_qualified: null,
              image: "1f469-1f3fb-200d-1f3a8.png",
              sheet_x: 18,
              sheet_y: 42,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F469-1F3FC-200D-1F3A8",
              non_qualified: null,
              image: "1f469-1f3fc-200d-1f3a8.png",
              sheet_x: 18,
              sheet_y: 43,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F469-1F3FD-200D-1F3A8",
              non_qualified: null,
              image: "1f469-1f3fd-200d-1f3a8.png",
              sheet_x: 18,
              sheet_y: 44,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F469-1F3FE-200D-1F3A8",
              non_qualified: null,
              image: "1f469-1f3fe-200d-1f3a8.png",
              sheet_x: 18,
              sheet_y: 45,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F469-1F3FF-200D-1F3A8",
              non_qualified: null,
              image: "1f469-1f3ff-200d-1f3a8.png",
              sheet_x: 18,
              sheet_y: 46,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Female Artist",
          b: "1F469-200D-1F3A8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [18, 41]
        },
        "flag-lr": {
          a: "Liberia Flag",
          b: "1F1F1-1F1F7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 11]
        },
        clock230: {
          a: "Clock Face Two-Thirty",
          b: "1F55D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule"],
          k: [28, 31]
        },
        bow_and_arrow: {
          a: "Bow and Arrow",
          b: "1F3F9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["sports"],
          k: [12, 23],
          o: 8
        },
        "male-pilot": {
          skin_variations: {
            "1F3FB": {
              unified: "1F468-1F3FB-200D-2708-FE0F",
              non_qualified: "1F468-1F3FB-200D-2708",
              image: "1f468-1f3fb-200d-2708-fe0f.png",
              sheet_x: 18,
              sheet_y: 4,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F468-1F3FC-200D-2708-FE0F",
              non_qualified: "1F468-1F3FC-200D-2708",
              image: "1f468-1f3fc-200d-2708-fe0f.png",
              sheet_x: 18,
              sheet_y: 5,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F468-1F3FD-200D-2708-FE0F",
              non_qualified: "1F468-1F3FD-200D-2708",
              image: "1f468-1f3fd-200d-2708-fe0f.png",
              sheet_x: 18,
              sheet_y: 6,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F468-1F3FE-200D-2708-FE0F",
              non_qualified: "1F468-1F3FE-200D-2708",
              image: "1f468-1f3fe-200d-2708-fe0f.png",
              sheet_x: 18,
              sheet_y: 7,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F468-1F3FF-200D-2708-FE0F",
              non_qualified: "1F468-1F3FF-200D-2708",
              image: "1f468-1f3ff-200d-2708-fe0f.png",
              sheet_x: 18,
              sheet_y: 8,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Male Pilot",
          b: "1F468-200D-2708-FE0F",
          c: "1F468-200D-2708",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [18, 3]
        },
        "flag-ls": {
          a: "Lesotho Flag",
          b: "1F1F1-1F1F8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 12]
        },
        "flag-lt": {
          a: "Lithuania Flag",
          b: "1F1F1-1F1F9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 13]
        },
        capital_abcd: {
          a: "Input Symbol for Latin Capital Letters",
          b: "1F520",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["alphabet", "words", "blue-square"],
          k: [27, 34]
        },
        "female-pilot": {
          skin_variations: {
            "1F3FB": {
              unified: "1F469-1F3FB-200D-2708-FE0F",
              non_qualified: "1F469-1F3FB-200D-2708",
              image: "1f469-1f3fb-200d-2708-fe0f.png",
              sheet_x: 20,
              sheet_y: 14,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F469-1F3FC-200D-2708-FE0F",
              non_qualified: "1F469-1F3FC-200D-2708",
              image: "1f469-1f3fc-200d-2708-fe0f.png",
              sheet_x: 20,
              sheet_y: 15,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F469-1F3FD-200D-2708-FE0F",
              non_qualified: "1F469-1F3FD-200D-2708",
              image: "1f469-1f3fd-200d-2708-fe0f.png",
              sheet_x: 20,
              sheet_y: 16,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F469-1F3FE-200D-2708-FE0F",
              non_qualified: "1F469-1F3FE-200D-2708",
              image: "1f469-1f3fe-200d-2708-fe0f.png",
              sheet_x: 20,
              sheet_y: 17,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F469-1F3FF-200D-2708-FE0F",
              non_qualified: "1F469-1F3FF-200D-2708",
              image: "1f469-1f3ff-200d-2708-fe0f.png",
              sheet_x: 20,
              sheet_y: 18,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Female Pilot",
          b: "1F469-200D-2708-FE0F",
          c: "1F469-200D-2708",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [20, 13]
        },
        clock3: {
          a: "Clock Face Three Oclock",
          b: "1F552",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule"],
          k: [28, 20]
        },
        shield: {
          a: "Shield",
          b: "1F6E1-FE0F",
          c: "1F6E1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["protection", "security"],
          k: [37, 9],
          o: 7
        },
        "male-astronaut": {
          skin_variations: {
            "1F3FB": {
              unified: "1F468-1F3FB-200D-1F680",
              non_qualified: null,
              image: "1f468-1f3fb-200d-1f680.png",
              sheet_x: 17,
              sheet_y: 32,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F468-1F3FC-200D-1F680",
              non_qualified: null,
              image: "1f468-1f3fc-200d-1f680.png",
              sheet_x: 17,
              sheet_y: 33,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F468-1F3FD-200D-1F680",
              non_qualified: null,
              image: "1f468-1f3fd-200d-1f680.png",
              sheet_x: 17,
              sheet_y: 34,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F468-1F3FE-200D-1F680",
              non_qualified: null,
              image: "1f468-1f3fe-200d-1f680.png",
              sheet_x: 17,
              sheet_y: 35,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F468-1F3FF-200D-1F680",
              non_qualified: null,
              image: "1f468-1f3ff-200d-1f680.png",
              sheet_x: 17,
              sheet_y: 36,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Male Astronaut",
          b: "1F468-200D-1F680",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [17, 31]
        },
        abcd: {
          a: "Input Symbol for Latin Small Letters",
          b: "1F521",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "alphabet"],
          k: [27, 35]
        },
        clock330: {
          a: "Clock Face Three-Thirty",
          b: "1F55E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule"],
          k: [28, 32]
        },
        "flag-lu": {
          a: "Luxembourg Flag",
          b: "1F1F1-1F1FA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 14]
        },
        wrench: {
          a: "Wrench",
          b: "1F527",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["tools", "diy", "ikea", "fix", "maintainer"],
          k: [27, 41]
        },
        nut_and_bolt: {
          a: "Nut and Bolt",
          b: "1F529",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["handy", "tools", "fix"],
          k: [27, 43]
        },
        clock4: {
          a: "Clock Face Four Oclock",
          b: "1F553",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule"],
          k: [28, 21]
        },
        "female-astronaut": {
          skin_variations: {
            "1F3FB": {
              unified: "1F469-1F3FB-200D-1F680",
              non_qualified: null,
              image: "1f469-1f3fb-200d-1f680.png",
              sheet_x: 19,
              sheet_y: 42,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F469-1F3FC-200D-1F680",
              non_qualified: null,
              image: "1f469-1f3fc-200d-1f680.png",
              sheet_x: 19,
              sheet_y: 43,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F469-1F3FD-200D-1F680",
              non_qualified: null,
              image: "1f469-1f3fd-200d-1f680.png",
              sheet_x: 19,
              sheet_y: 44,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F469-1F3FE-200D-1F680",
              non_qualified: null,
              image: "1f469-1f3fe-200d-1f680.png",
              sheet_x: 19,
              sheet_y: 45,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F469-1F3FF-200D-1F680",
              non_qualified: null,
              image: "1f469-1f3ff-200d-1f680.png",
              sheet_x: 19,
              sheet_y: 46,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Female Astronaut",
          b: "1F469-200D-1F680",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [19, 41]
        },
        "flag-lv": {
          a: "Latvia Flag",
          b: "1F1F1-1F1FB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 15]
        },
        gear: {
          a: "Gear",
          b: "2699-FE0F",
          c: "2699",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["cog"],
          k: [48, 17],
          o: 4
        },
        "male-firefighter": {
          skin_variations: {
            "1F3FB": {
              unified: "1F468-1F3FB-200D-1F692",
              non_qualified: null,
              image: "1f468-1f3fb-200d-1f692.png",
              sheet_x: 17,
              sheet_y: 38,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F468-1F3FC-200D-1F692",
              non_qualified: null,
              image: "1f468-1f3fc-200d-1f692.png",
              sheet_x: 17,
              sheet_y: 39,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F468-1F3FD-200D-1F692",
              non_qualified: null,
              image: "1f468-1f3fd-200d-1f692.png",
              sheet_x: 17,
              sheet_y: 40,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F468-1F3FE-200D-1F692",
              non_qualified: null,
              image: "1f468-1f3fe-200d-1f692.png",
              sheet_x: 17,
              sheet_y: 41,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F468-1F3FF-200D-1F692",
              non_qualified: null,
              image: "1f468-1f3ff-200d-1f692.png",
              sheet_x: 17,
              sheet_y: 42,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Male Firefighter",
          b: "1F468-200D-1F692",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [17, 37]
        },
        "flag-ly": {
          a: "Libya Flag",
          b: "1F1F1-1F1FE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 16]
        },
        symbols: {
          a: "Input Symbol for Symbols",
          b: "1F523",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "music", "note", "ampersand", "percent", "glyphs", "characters"],
          k: [27, 37]
        },
        clock430: {
          a: "Clock Face Four-Thirty",
          b: "1F55F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule"],
          k: [28, 33]
        },
        "flag-ma": {
          a: "Morocco Flag",
          b: "1F1F2-1F1E6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 17]
        },
        compression: {
          a: "Compression",
          b: "1F5DC-FE0F",
          c: "1F5DC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [30, 10],
          o: 7
        },
        "female-firefighter": {
          skin_variations: {
            "1F3FB": {
              unified: "1F469-1F3FB-200D-1F692",
              non_qualified: null,
              image: "1f469-1f3fb-200d-1f692.png",
              sheet_x: 19,
              sheet_y: 48,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F469-1F3FC-200D-1F692",
              non_qualified: null,
              image: "1f469-1f3fc-200d-1f692.png",
              sheet_x: 19,
              sheet_y: 49,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F469-1F3FD-200D-1F692",
              non_qualified: null,
              image: "1f469-1f3fd-200d-1f692.png",
              sheet_x: 19,
              sheet_y: 50,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F469-1F3FE-200D-1F692",
              non_qualified: null,
              image: "1f469-1f3fe-200d-1f692.png",
              sheet_x: 19,
              sheet_y: 51,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F469-1F3FF-200D-1F692",
              non_qualified: null,
              image: "1f469-1f3ff-200d-1f692.png",
              sheet_x: 20,
              sheet_y: 0,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Female Firefighter",
          b: "1F469-200D-1F692",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [19, 47]
        },
        abc: {
          a: "Input Symbol for Latin Letters",
          b: "1F524",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "alphabet"],
          k: [27, 38]
        },
        clock5: {
          a: "Clock Face Five Oclock",
          b: "1F554",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule"],
          k: [28, 22]
        },
        clock530: {
          a: "Clock Face Five-Thirty",
          b: "1F560",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule"],
          k: [28, 34]
        },
        a: {
          a: "Negative Squared Latin Capital Letter a",
          b: "1F170-FE0F",
          c: "1F170",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["red-square", "alphabet", "letter"],
          k: [0, 16]
        },
        alembic: {
          a: "Alembic",
          b: "2697-FE0F",
          c: "2697",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["distilling", "science", "experiment", "chemistry"],
          k: [48, 16],
          o: 4
        },
        "flag-mc": {
          a: "Monaco Flag",
          b: "1F1F2-1F1E8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 18]
        },
        cop: {
          skin_variations: {
            "1F3FB": {
              unified: "1F46E-1F3FB",
              non_qualified: null,
              image: "1f46e-1f3fb.png",
              sheet_x: 20,
              sheet_y: 46,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F46E-1F3FC",
              non_qualified: null,
              image: "1f46e-1f3fc.png",
              sheet_x: 20,
              sheet_y: 47,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F46E-1F3FD",
              non_qualified: null,
              image: "1f46e-1f3fd.png",
              sheet_x: 20,
              sheet_y: 48,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F46E-1F3FE",
              non_qualified: null,
              image: "1f46e-1f3fe.png",
              sheet_x: 20,
              sheet_y: 49,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F46E-1F3FF",
              non_qualified: null,
              image: "1f46e-1f3ff.png",
              sheet_x: 20,
              sheet_y: 50,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            }
          },
          obsoleted_by: "1F46E-200D-2642-FE0F",
          a: "Police Officer",
          b: "1F46E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          k: [20, 45]
        },
        scales: {
          a: "Scales",
          b: "2696-FE0F",
          c: "2696",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [48, 15],
          o: 4
        },
        clock6: {
          a: "Clock Face Six Oclock",
          b: "1F555",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule", "dawn", "dusk"],
          k: [28, 23]
        },
        "flag-md": {
          a: "Moldova Flag",
          b: "1F1F2-1F1E9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 19]
        },
        ab: {
          a: "Negative Squared Ab",
          b: "1F18E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["red-square", "alphabet"],
          k: [0, 20]
        },
        "male-police-officer": {
          skin_variations: {
            "1F3FB": {
              unified: "1F46E-1F3FB-200D-2642-FE0F",
              non_qualified: "1F46E-1F3FB-200D-2642",
              image: "1f46e-1f3fb-200d-2642-fe0f.png",
              sheet_x: 20,
              sheet_y: 40,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F46E-1F3FC-200D-2642-FE0F",
              non_qualified: "1F46E-1F3FC-200D-2642",
              image: "1f46e-1f3fc-200d-2642-fe0f.png",
              sheet_x: 20,
              sheet_y: 41,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F46E-1F3FD-200D-2642-FE0F",
              non_qualified: "1F46E-1F3FD-200D-2642",
              image: "1f46e-1f3fd-200d-2642-fe0f.png",
              sheet_x: 20,
              sheet_y: 42,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F46E-1F3FE-200D-2642-FE0F",
              non_qualified: "1F46E-1F3FE-200D-2642",
              image: "1f46e-1f3fe-200d-2642-fe0f.png",
              sheet_x: 20,
              sheet_y: 43,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F46E-1F3FF-200D-2642-FE0F",
              non_qualified: "1F46E-1F3FF-200D-2642",
              image: "1f46e-1f3ff-200d-2642-fe0f.png",
              sheet_x: 20,
              sheet_y: 44,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F46E",
          a: "Male Police Officer",
          b: "1F46E-200D-2642-FE0F",
          c: "1F46E-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [20, 39]
        },
        link: {
          a: "Link Symbol",
          b: "1F517",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["rings", "url"],
          k: [27, 25]
        },
        "flag-me": {
          a: "Montenegro Flag",
          b: "1F1F2-1F1EA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 20]
        },
        clock630: {
          a: "Clock Face Six-Thirty",
          b: "1F561",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule"],
          k: [28, 35]
        },
        b: {
          a: "Negative Squared Latin Capital Letter B",
          b: "1F171-FE0F",
          c: "1F171",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["red-square", "alphabet", "letter"],
          k: [0, 17]
        },
        "female-police-officer": {
          skin_variations: {
            "1F3FB": {
              unified: "1F46E-1F3FB-200D-2640-FE0F",
              non_qualified: "1F46E-1F3FB-200D-2640",
              image: "1f46e-1f3fb-200d-2640-fe0f.png",
              sheet_x: 20,
              sheet_y: 34,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F46E-1F3FC-200D-2640-FE0F",
              non_qualified: "1F46E-1F3FC-200D-2640",
              image: "1f46e-1f3fc-200d-2640-fe0f.png",
              sheet_x: 20,
              sheet_y: 35,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F46E-1F3FD-200D-2640-FE0F",
              non_qualified: "1F46E-1F3FD-200D-2640",
              image: "1f46e-1f3fd-200d-2640-fe0f.png",
              sheet_x: 20,
              sheet_y: 36,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F46E-1F3FE-200D-2640-FE0F",
              non_qualified: "1F46E-1F3FE-200D-2640",
              image: "1f46e-1f3fe-200d-2640-fe0f.png",
              sheet_x: 20,
              sheet_y: 37,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F46E-1F3FF-200D-2640-FE0F",
              non_qualified: "1F46E-1F3FF-200D-2640",
              image: "1f46e-1f3ff-200d-2640-fe0f.png",
              sheet_x: 20,
              sheet_y: 38,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Female Police Officer",
          b: "1F46E-200D-2640-FE0F",
          c: "1F46E-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [20, 33]
        },
        clock7: {
          a: "Clock Face Seven Oclock",
          b: "1F556",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule"],
          k: [28, 24]
        },
        cl: {
          a: "Squared Cl",
          b: "1F191",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["alphabet", "words", "red-square"],
          k: [0, 21]
        },
        sleuth_or_spy: {
          skin_variations: {
            "1F3FB": {
              unified: "1F575-1F3FB",
              non_qualified: null,
              image: "1f575-1f3fb.png",
              sheet_x: 29,
              sheet_y: 12,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F575-1F3FC",
              non_qualified: null,
              image: "1f575-1f3fc.png",
              sheet_x: 29,
              sheet_y: 13,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F575-1F3FD",
              non_qualified: null,
              image: "1f575-1f3fd.png",
              sheet_x: 29,
              sheet_y: 14,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F575-1F3FE",
              non_qualified: null,
              image: "1f575-1f3fe.png",
              sheet_x: 29,
              sheet_y: 15,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F575-1F3FF",
              non_qualified: null,
              image: "1f575-1f3ff.png",
              sheet_x: 29,
              sheet_y: 16,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoleted_by: "1F575-FE0F-200D-2642-FE0F",
          a: "Sleuth or Spy",
          b: "1F575-FE0F",
          c: "1F575",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          k: [29, 11],
          o: 7
        },
        "flag-mf": {
          a: "St. Martin Flag",
          b: "1F1F2-1F1EB",
          d: !0,
          e: !1,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 21]
        },
        chains: {
          a: "Chains",
          b: "26D3-FE0F",
          c: "26D3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["lock", "arrest"],
          k: [48, 34],
          o: 5
        },
        syringe: {
          a: "Syringe",
          b: "1F489",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["health", "hospital", "drugs", "blood", "medicine", "needle", "doctor", "nurse"],
          k: [24, 35]
        },
        "male-detective": {
          skin_variations: {
            "1F3FB": {
              unified: "1F575-1F3FB-200D-2642-FE0F",
              non_qualified: "1F575-1F3FB-200D-2642",
              image: "1f575-1f3fb-200d-2642-fe0f.png",
              sheet_x: 29,
              sheet_y: 6,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F575-1F3FC-200D-2642-FE0F",
              non_qualified: "1F575-1F3FC-200D-2642",
              image: "1f575-1f3fc-200d-2642-fe0f.png",
              sheet_x: 29,
              sheet_y: 7,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F575-1F3FD-200D-2642-FE0F",
              non_qualified: "1F575-1F3FD-200D-2642",
              image: "1f575-1f3fd-200d-2642-fe0f.png",
              sheet_x: 29,
              sheet_y: 8,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F575-1F3FE-200D-2642-FE0F",
              non_qualified: "1F575-1F3FE-200D-2642",
              image: "1f575-1f3fe-200d-2642-fe0f.png",
              sheet_x: 29,
              sheet_y: 9,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F575-1F3FF-200D-2642-FE0F",
              non_qualified: "1F575-1F3FF-200D-2642",
              image: "1f575-1f3ff-200d-2642-fe0f.png",
              sheet_x: 29,
              sheet_y: 10,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F575-FE0F",
          a: "Male Detective",
          b: "1F575-FE0F-200D-2642-FE0F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          k: [29, 5],
          o: 7
        },
        cool: {
          a: "Squared Cool",
          b: "1F192",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["words", "blue-square"],
          k: [0, 22]
        },
        clock730: {
          a: "Clock Face Seven-Thirty",
          b: "1F562",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule"],
          k: [28, 36]
        },
        "flag-mg": {
          a: "Madagascar Flag",
          b: "1F1F2-1F1EC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 22]
        },
        free: {
          a: "Squared Free",
          b: "1F193",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "words"],
          k: [0, 23]
        },
        "flag-mh": {
          a: "Marshall Islands Flag",
          b: "1F1F2-1F1ED",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 23]
        },
        clock8: {
          a: "Clock Face Eight Oclock",
          b: "1F557",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule"],
          k: [28, 25]
        },
        pill: {
          a: "Pill",
          b: "1F48A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["health", "medicine", "doctor", "pharmacy", "drug"],
          k: [24, 36]
        },
        "female-detective": {
          skin_variations: {
            "1F3FB": {
              unified: "1F575-1F3FB-200D-2640-FE0F",
              non_qualified: "1F575-1F3FB-200D-2640",
              image: "1f575-1f3fb-200d-2640-fe0f.png",
              sheet_x: 29,
              sheet_y: 0,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F575-1F3FC-200D-2640-FE0F",
              non_qualified: "1F575-1F3FC-200D-2640",
              image: "1f575-1f3fc-200d-2640-fe0f.png",
              sheet_x: 29,
              sheet_y: 1,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F575-1F3FD-200D-2640-FE0F",
              non_qualified: "1F575-1F3FD-200D-2640",
              image: "1f575-1f3fd-200d-2640-fe0f.png",
              sheet_x: 29,
              sheet_y: 2,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F575-1F3FE-200D-2640-FE0F",
              non_qualified: "1F575-1F3FE-200D-2640",
              image: "1f575-1f3fe-200d-2640-fe0f.png",
              sheet_x: 29,
              sheet_y: 3,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F575-1F3FF-200D-2640-FE0F",
              non_qualified: "1F575-1F3FF-200D-2640",
              image: "1f575-1f3ff-200d-2640-fe0f.png",
              sheet_x: 29,
              sheet_y: 4,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Female Detective",
          b: "1F575-FE0F-200D-2640-FE0F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          k: [28, 51],
          o: 7
        },
        clock830: {
          a: "Clock Face Eight-Thirty",
          b: "1F563",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule"],
          k: [28, 37]
        },
        guardsman: {
          skin_variations: {
            "1F3FB": {
              unified: "1F482-1F3FB",
              non_qualified: null,
              image: "1f482-1f3fb.png",
              sheet_x: 23,
              sheet_y: 32,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F482-1F3FC",
              non_qualified: null,
              image: "1f482-1f3fc.png",
              sheet_x: 23,
              sheet_y: 33,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F482-1F3FD",
              non_qualified: null,
              image: "1f482-1f3fd.png",
              sheet_x: 23,
              sheet_y: 34,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F482-1F3FE",
              non_qualified: null,
              image: "1f482-1f3fe.png",
              sheet_x: 23,
              sheet_y: 35,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F482-1F3FF",
              non_qualified: null,
              image: "1f482-1f3ff.png",
              sheet_x: 23,
              sheet_y: 36,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            }
          },
          obsoleted_by: "1F482-200D-2642-FE0F",
          a: "Guardsman",
          b: "1F482",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          j: ["uk", "gb", "british", "male", "guy", "royal"],
          k: [23, 31]
        },
        information_source: {
          a: "Information Source",
          b: "2139-FE0F",
          c: "2139",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "alphabet", "letter"],
          k: [46, 32],
          o: 3
        },
        "flag-mk": {
          a: "Macedonia Flag",
          b: "1F1F2-1F1F0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 24]
        },
        smoking: {
          a: "Smoking Symbol",
          b: "1F6AC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["kills", "tobacco", "cigarette", "joint", "smoke"],
          k: [35, 17]
        },
        id: {
          a: "Squared Id",
          b: "1F194",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["purple-square", "words"],
          k: [0, 24]
        },
        clock9: {
          a: "Clock Face Nine Oclock",
          b: "1F558",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule"],
          k: [28, 26]
        },
        "flag-ml": {
          a: "Mali Flag",
          b: "1F1F2-1F1F1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 25]
        },
        coffin: {
          a: "Coffin",
          b: "26B0-FE0F",
          c: "26B0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["vampire", "dead", "die", "death", "rip", "graveyard", "cemetery", "casket", "funeral", "box"],
          k: [48, 24],
          o: 4
        },
        "male-guard": {
          skin_variations: {
            "1F3FB": {
              unified: "1F482-1F3FB-200D-2642-FE0F",
              non_qualified: "1F482-1F3FB-200D-2642",
              image: "1f482-1f3fb-200d-2642-fe0f.png",
              sheet_x: 23,
              sheet_y: 26,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F482-1F3FC-200D-2642-FE0F",
              non_qualified: "1F482-1F3FC-200D-2642",
              image: "1f482-1f3fc-200d-2642-fe0f.png",
              sheet_x: 23,
              sheet_y: 27,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F482-1F3FD-200D-2642-FE0F",
              non_qualified: "1F482-1F3FD-200D-2642",
              image: "1f482-1f3fd-200d-2642-fe0f.png",
              sheet_x: 23,
              sheet_y: 28,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F482-1F3FE-200D-2642-FE0F",
              non_qualified: "1F482-1F3FE-200D-2642",
              image: "1f482-1f3fe-200d-2642-fe0f.png",
              sheet_x: 23,
              sheet_y: 29,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F482-1F3FF-200D-2642-FE0F",
              non_qualified: "1F482-1F3FF-200D-2642",
              image: "1f482-1f3ff-200d-2642-fe0f.png",
              sheet_x: 23,
              sheet_y: 30,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F482",
          a: "Male Guard",
          b: "1F482-200D-2642-FE0F",
          c: "1F482-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [23, 25]
        },
        m: {
          a: "Circled Latin Capital Letter M",
          b: "24C2-FE0F",
          c: "24C2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["alphabet", "blue-circle", "letter"],
          k: [47, 7],
          o: 1
        },
        funeral_urn: {
          a: "Funeral Urn",
          b: "26B1-FE0F",
          c: "26B1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["dead", "die", "death", "rip", "ashes"],
          k: [48, 25],
          o: 4
        },
        "female-guard": {
          skin_variations: {
            "1F3FB": {
              unified: "1F482-1F3FB-200D-2640-FE0F",
              non_qualified: "1F482-1F3FB-200D-2640",
              image: "1f482-1f3fb-200d-2640-fe0f.png",
              sheet_x: 23,
              sheet_y: 20,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F482-1F3FC-200D-2640-FE0F",
              non_qualified: "1F482-1F3FC-200D-2640",
              image: "1f482-1f3fc-200d-2640-fe0f.png",
              sheet_x: 23,
              sheet_y: 21,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F482-1F3FD-200D-2640-FE0F",
              non_qualified: "1F482-1F3FD-200D-2640",
              image: "1f482-1f3fd-200d-2640-fe0f.png",
              sheet_x: 23,
              sheet_y: 22,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F482-1F3FE-200D-2640-FE0F",
              non_qualified: "1F482-1F3FE-200D-2640",
              image: "1f482-1f3fe-200d-2640-fe0f.png",
              sheet_x: 23,
              sheet_y: 23,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F482-1F3FF-200D-2640-FE0F",
              non_qualified: "1F482-1F3FF-200D-2640",
              image: "1f482-1f3ff-200d-2640-fe0f.png",
              sheet_x: 23,
              sheet_y: 24,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Female Guard",
          b: "1F482-200D-2640-FE0F",
          c: "1F482-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [23, 19]
        },
        "flag-mm": {
          a: "Myanmar (burma) Flag",
          b: "1F1F2-1F1F2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 26]
        },
        clock930: {
          a: "Clock Face Nine-Thirty",
          b: "1F564",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule"],
          k: [28, 38]
        },
        moyai: {
          a: "Moyai",
          b: "1F5FF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["rock", "easter island", "moai"],
          k: [30, 23]
        },
        new: {
          a: "Squared New",
          b: "1F195",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "words", "start"],
          k: [0, 25]
        },
        "flag-mn": {
          a: "Mongolia Flag",
          b: "1F1F2-1F1F3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 27]
        },
        construction_worker: {
          skin_variations: {
            "1F3FB": {
              unified: "1F477-1F3FB",
              non_qualified: null,
              image: "1f477-1f3fb.png",
              sheet_x: 22,
              sheet_y: 29,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F477-1F3FC",
              non_qualified: null,
              image: "1f477-1f3fc.png",
              sheet_x: 22,
              sheet_y: 30,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F477-1F3FD",
              non_qualified: null,
              image: "1f477-1f3fd.png",
              sheet_x: 22,
              sheet_y: 31,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F477-1F3FE",
              non_qualified: null,
              image: "1f477-1f3fe.png",
              sheet_x: 22,
              sheet_y: 32,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F477-1F3FF",
              non_qualified: null,
              image: "1f477-1f3ff.png",
              sheet_x: 22,
              sheet_y: 33,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            }
          },
          obsoleted_by: "1F477-200D-2642-FE0F",
          a: "Construction Worker",
          b: "1F477",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          k: [22, 28]
        },
        clock10: {
          a: "Clock Face Ten Oclock",
          b: "1F559",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule"],
          k: [28, 27]
        },
        clock1030: {
          a: "Clock Face Ten-Thirty",
          b: "1F565",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule"],
          k: [28, 39]
        },
        ng: {
          a: "Squared Ng",
          b: "1F196",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "words", "shape", "icon"],
          k: [0, 26]
        },
        "male-construction-worker": {
          skin_variations: {
            "1F3FB": {
              unified: "1F477-1F3FB-200D-2642-FE0F",
              non_qualified: "1F477-1F3FB-200D-2642",
              image: "1f477-1f3fb-200d-2642-fe0f.png",
              sheet_x: 22,
              sheet_y: 23,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F477-1F3FC-200D-2642-FE0F",
              non_qualified: "1F477-1F3FC-200D-2642",
              image: "1f477-1f3fc-200d-2642-fe0f.png",
              sheet_x: 22,
              sheet_y: 24,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F477-1F3FD-200D-2642-FE0F",
              non_qualified: "1F477-1F3FD-200D-2642",
              image: "1f477-1f3fd-200d-2642-fe0f.png",
              sheet_x: 22,
              sheet_y: 25,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F477-1F3FE-200D-2642-FE0F",
              non_qualified: "1F477-1F3FE-200D-2642",
              image: "1f477-1f3fe-200d-2642-fe0f.png",
              sheet_x: 22,
              sheet_y: 26,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F477-1F3FF-200D-2642-FE0F",
              non_qualified: "1F477-1F3FF-200D-2642",
              image: "1f477-1f3ff-200d-2642-fe0f.png",
              sheet_x: 22,
              sheet_y: 27,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F477",
          a: "Male Construction Worker",
          b: "1F477-200D-2642-FE0F",
          c: "1F477-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [22, 22]
        },
        "flag-mo": {
          a: "Macau Sar China Flag",
          b: "1F1F2-1F1F4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 28]
        },
        oil_drum: {
          a: "Oil Drum",
          b: "1F6E2-FE0F",
          c: "1F6E2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["barrell"],
          k: [37, 10],
          o: 7
        },
        o2: {
          a: "Negative Squared Latin Capital Letter O",
          b: "1F17E-FE0F",
          c: "1F17E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["alphabet", "red-square", "letter"],
          k: [0, 18]
        },
        "female-construction-worker": {
          skin_variations: {
            "1F3FB": {
              unified: "1F477-1F3FB-200D-2640-FE0F",
              non_qualified: "1F477-1F3FB-200D-2640",
              image: "1f477-1f3fb-200d-2640-fe0f.png",
              sheet_x: 22,
              sheet_y: 17,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F477-1F3FC-200D-2640-FE0F",
              non_qualified: "1F477-1F3FC-200D-2640",
              image: "1f477-1f3fc-200d-2640-fe0f.png",
              sheet_x: 22,
              sheet_y: 18,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F477-1F3FD-200D-2640-FE0F",
              non_qualified: "1F477-1F3FD-200D-2640",
              image: "1f477-1f3fd-200d-2640-fe0f.png",
              sheet_x: 22,
              sheet_y: 19,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F477-1F3FE-200D-2640-FE0F",
              non_qualified: "1F477-1F3FE-200D-2640",
              image: "1f477-1f3fe-200d-2640-fe0f.png",
              sheet_x: 22,
              sheet_y: 20,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F477-1F3FF-200D-2640-FE0F",
              non_qualified: "1F477-1F3FF-200D-2640",
              image: "1f477-1f3ff-200d-2640-fe0f.png",
              sheet_x: 22,
              sheet_y: 21,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Female Construction Worker",
          b: "1F477-200D-2640-FE0F",
          c: "1F477-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [22, 16]
        },
        clock11: {
          a: "Clock Face Eleven Oclock",
          b: "1F55A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule"],
          k: [28, 28]
        },
        crystal_ball: {
          a: "Crystal Ball",
          b: "1F52E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["disco", "party", "magic", "circus", "fortune_teller"],
          k: [27, 48]
        },
        "flag-mp": {
          a: "Northern Mariana Islands Flag",
          b: "1F1F2-1F1F5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 29]
        },
        "flag-mq": {
          a: "Martinique Flag",
          b: "1F1F2-1F1F6",
          d: !0,
          e: !1,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 30]
        },
        prince: {
          skin_variations: {
            "1F3FB": {
              unified: "1F934-1F3FB",
              non_qualified: null,
              image: "1f934-1f3fb.png",
              sheet_x: 39,
              sheet_y: 29,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F934-1F3FC",
              non_qualified: null,
              image: "1f934-1f3fc.png",
              sheet_x: 39,
              sheet_y: 30,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F934-1F3FD",
              non_qualified: null,
              image: "1f934-1f3fd.png",
              sheet_x: 39,
              sheet_y: 31,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F934-1F3FE",
              non_qualified: null,
              image: "1f934-1f3fe.png",
              sheet_x: 39,
              sheet_y: 32,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F934-1F3FF",
              non_qualified: null,
              image: "1f934-1f3ff.png",
              sheet_x: 39,
              sheet_y: 33,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Prince",
          b: "1F934",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["boy", "man", "male", "crown", "royal", "king"],
          k: [39, 28],
          o: 9
        },
        ok: {
          a: "Squared Ok",
          b: "1F197",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["good", "agree", "yes", "blue-square"],
          k: [0, 27]
        },
        clock1130: {
          a: "Clock Face Eleven-Thirty",
          b: "1F566",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule"],
          k: [28, 40]
        },
        shopping_trolley: {
          a: "Shopping Trolley",
          b: "1F6D2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [37, 7],
          o: 9
        },
        "flag-mr": {
          a: "Mauritania Flag",
          b: "1F1F2-1F1F7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 31]
        },
        princess: {
          skin_variations: {
            "1F3FB": {
              unified: "1F478-1F3FB",
              non_qualified: null,
              image: "1f478-1f3fb.png",
              sheet_x: 22,
              sheet_y: 35,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F478-1F3FC",
              non_qualified: null,
              image: "1f478-1f3fc.png",
              sheet_x: 22,
              sheet_y: 36,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F478-1F3FD",
              non_qualified: null,
              image: "1f478-1f3fd.png",
              sheet_x: 22,
              sheet_y: 37,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F478-1F3FE",
              non_qualified: null,
              image: "1f478-1f3fe.png",
              sheet_x: 22,
              sheet_y: 38,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F478-1F3FF",
              non_qualified: null,
              image: "1f478-1f3ff.png",
              sheet_x: 22,
              sheet_y: 39,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Princess",
          b: "1F478",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["girl", "woman", "female", "blond", "crown", "royal", "queen"],
          k: [22, 34]
        },
        new_moon: {
          a: "New Moon Symbol",
          b: "1F311",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nature", "twilight", "planet", "space", "night", "evening", "sleep"],
          k: [6, 9]
        },
        parking: {
          a: "Negative Squared Latin Capital Letter P",
          b: "1F17F-FE0F",
          c: "1F17F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["cars", "blue-square", "alphabet", "letter"],
          k: [0, 19],
          o: 5
        },
        sos: {
          a: "Squared Sos",
          b: "1F198",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["help", "red-square", "words", "emergency", "911"],
          k: [0, 28]
        },
        man_with_turban: {
          skin_variations: {
            "1F3FB": {
              unified: "1F473-1F3FB",
              non_qualified: null,
              image: "1f473-1f3fb.png",
              sheet_x: 21,
              sheet_y: 45,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F473-1F3FC",
              non_qualified: null,
              image: "1f473-1f3fc.png",
              sheet_x: 21,
              sheet_y: 46,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F473-1F3FD",
              non_qualified: null,
              image: "1f473-1f3fd.png",
              sheet_x: 21,
              sheet_y: 47,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F473-1F3FE",
              non_qualified: null,
              image: "1f473-1f3fe.png",
              sheet_x: 21,
              sheet_y: 48,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F473-1F3FF",
              non_qualified: null,
              image: "1f473-1f3ff.png",
              sheet_x: 21,
              sheet_y: 49,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            }
          },
          obsoleted_by: "1F473-200D-2642-FE0F",
          a: "Man with Turban",
          b: "1F473",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          j: ["male", "indian", "hinduism", "arabs"],
          k: [21, 44]
        },
        "flag-ms": {
          a: "Montserrat Flag",
          b: "1F1F2-1F1F8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 32]
        },
        waxing_crescent_moon: {
          a: "Waxing Crescent Moon Symbol",
          b: "1F312",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nature", "twilight", "planet", "space", "night", "evening", "sleep"],
          k: [6, 10]
        },
        up: {
          a: "Squared Up with Exclamation Mark",
          b: "1F199",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "above", "high"],
          k: [0, 29]
        },
        first_quarter_moon: {
          a: "First Quarter Moon Symbol",
          b: "1F313",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nature", "twilight", "planet", "space", "night", "evening", "sleep"],
          k: [6, 11]
        },
        "flag-mt": {
          a: "Malta Flag",
          b: "1F1F2-1F1F9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 33]
        },
        "man-wearing-turban": {
          skin_variations: {
            "1F3FB": {
              unified: "1F473-1F3FB-200D-2642-FE0F",
              non_qualified: "1F473-1F3FB-200D-2642",
              image: "1f473-1f3fb-200d-2642-fe0f.png",
              sheet_x: 21,
              sheet_y: 39,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F473-1F3FC-200D-2642-FE0F",
              non_qualified: "1F473-1F3FC-200D-2642",
              image: "1f473-1f3fc-200d-2642-fe0f.png",
              sheet_x: 21,
              sheet_y: 40,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F473-1F3FD-200D-2642-FE0F",
              non_qualified: "1F473-1F3FD-200D-2642",
              image: "1f473-1f3fd-200d-2642-fe0f.png",
              sheet_x: 21,
              sheet_y: 41,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F473-1F3FE-200D-2642-FE0F",
              non_qualified: "1F473-1F3FE-200D-2642",
              image: "1f473-1f3fe-200d-2642-fe0f.png",
              sheet_x: 21,
              sheet_y: 42,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F473-1F3FF-200D-2642-FE0F",
              non_qualified: "1F473-1F3FF-200D-2642",
              image: "1f473-1f3ff-200d-2642-fe0f.png",
              sheet_x: 21,
              sheet_y: 43,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F473",
          a: "Man Wearing Turban",
          b: "1F473-200D-2642-FE0F",
          c: "1F473-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [21, 38]
        },
        moon: {
          a: "Waxing Gibbous Moon Symbol",
          b: "1F314",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [6, 12],
          n: ["waxing_gibbous_moon"]
        },
        "woman-wearing-turban": {
          skin_variations: {
            "1F3FB": {
              unified: "1F473-1F3FB-200D-2640-FE0F",
              non_qualified: "1F473-1F3FB-200D-2640",
              image: "1f473-1f3fb-200d-2640-fe0f.png",
              sheet_x: 21,
              sheet_y: 33,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F473-1F3FC-200D-2640-FE0F",
              non_qualified: "1F473-1F3FC-200D-2640",
              image: "1f473-1f3fc-200d-2640-fe0f.png",
              sheet_x: 21,
              sheet_y: 34,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F473-1F3FD-200D-2640-FE0F",
              non_qualified: "1F473-1F3FD-200D-2640",
              image: "1f473-1f3fd-200d-2640-fe0f.png",
              sheet_x: 21,
              sheet_y: 35,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F473-1F3FE-200D-2640-FE0F",
              non_qualified: "1F473-1F3FE-200D-2640",
              image: "1f473-1f3fe-200d-2640-fe0f.png",
              sheet_x: 21,
              sheet_y: 36,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F473-1F3FF-200D-2640-FE0F",
              non_qualified: "1F473-1F3FF-200D-2640",
              image: "1f473-1f3ff-200d-2640-fe0f.png",
              sheet_x: 21,
              sheet_y: 37,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Woman Wearing Turban",
          b: "1F473-200D-2640-FE0F",
          c: "1F473-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [21, 32]
        },
        vs: {
          a: "Squared Vs",
          b: "1F19A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["words", "orange-square"],
          k: [0, 30]
        },
        "flag-mu": {
          a: "Mauritius Flag",
          b: "1F1F2-1F1FA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 34]
        },
        man_with_gua_pi_mao: {
          skin_variations: {
            "1F3FB": {
              unified: "1F472-1F3FB",
              non_qualified: null,
              image: "1f472-1f3fb.png",
              sheet_x: 21,
              sheet_y: 27,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F472-1F3FC",
              non_qualified: null,
              image: "1f472-1f3fc.png",
              sheet_x: 21,
              sheet_y: 28,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F472-1F3FD",
              non_qualified: null,
              image: "1f472-1f3fd.png",
              sheet_x: 21,
              sheet_y: 29,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F472-1F3FE",
              non_qualified: null,
              image: "1f472-1f3fe.png",
              sheet_x: 21,
              sheet_y: 30,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F472-1F3FF",
              non_qualified: null,
              image: "1f472-1f3ff.png",
              sheet_x: 21,
              sheet_y: 31,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Man with Gua Pi Mao",
          b: "1F472",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["male", "boy", "chinese"],
          k: [21, 26]
        },
        koko: {
          a: "Squared Katakana Koko",
          b: "1F201",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "here", "katakana", "japanese", "destination"],
          k: [5, 29]
        },
        full_moon: {
          a: "Full Moon Symbol",
          b: "1F315",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nature", "yellow", "twilight", "planet", "space", "night", "evening", "sleep"],
          k: [6, 13]
        },
        "flag-mv": {
          a: "Maldives Flag",
          b: "1F1F2-1F1FB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 35]
        },
        person_with_headscarf: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9D5-1F3FB",
              non_qualified: null,
              image: "1f9d5-1f3fb.png",
              sheet_x: 43,
              sheet_y: 23,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F9D5-1F3FC",
              non_qualified: null,
              image: "1f9d5-1f3fc.png",
              sheet_x: 43,
              sheet_y: 24,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F9D5-1F3FD",
              non_qualified: null,
              image: "1f9d5-1f3fd.png",
              sheet_x: 43,
              sheet_y: 25,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F9D5-1F3FE",
              non_qualified: null,
              image: "1f9d5-1f3fe.png",
              sheet_x: 43,
              sheet_y: 26,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F9D5-1F3FF",
              non_qualified: null,
              image: "1f9d5-1f3ff.png",
              sheet_x: 43,
              sheet_y: 27,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Person with Headscarf",
          b: "1F9D5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [43, 22],
          o: 10
        },
        waning_gibbous_moon: {
          a: "Waning Gibbous Moon Symbol",
          b: "1F316",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nature", "twilight", "planet", "space", "night", "evening", "sleep", "waxing_gibbous_moon"],
          k: [6, 14]
        },
        sa: {
          a: "Squared Katakana Sa",
          b: "1F202-FE0F",
          c: "1F202",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["japanese", "blue-square", "katakana"],
          k: [5, 30]
        },
        "flag-mw": {
          a: "Malawi Flag",
          b: "1F1F2-1F1FC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 36]
        },
        last_quarter_moon: {
          a: "Last Quarter Moon Symbol",
          b: "1F317",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nature", "twilight", "planet", "space", "night", "evening", "sleep"],
          k: [6, 15]
        },
        u6708: {
          a: "Squared Cjk Unified Ideograph-6708",
          b: "1F237-FE0F",
          c: "1F237",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["chinese", "month", "moon", "japanese", "orange-square", "kanji"],
          k: [5, 38]
        },
        bearded_person: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9D4-1F3FB",
              non_qualified: null,
              image: "1f9d4-1f3fb.png",
              sheet_x: 43,
              sheet_y: 17,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F9D4-1F3FC",
              non_qualified: null,
              image: "1f9d4-1f3fc.png",
              sheet_x: 43,
              sheet_y: 18,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F9D4-1F3FD",
              non_qualified: null,
              image: "1f9d4-1f3fd.png",
              sheet_x: 43,
              sheet_y: 19,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F9D4-1F3FE",
              non_qualified: null,
              image: "1f9d4-1f3fe.png",
              sheet_x: 43,
              sheet_y: 20,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F9D4-1F3FF",
              non_qualified: null,
              image: "1f9d4-1f3ff.png",
              sheet_x: 43,
              sheet_y: 21,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Bearded Person",
          b: "1F9D4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [43, 16],
          o: 10
        },
        "flag-mx": {
          a: "Mexico Flag",
          b: "1F1F2-1F1FD",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 37]
        },
        u6709: {
          a: "Squared Cjk Unified Ideograph-6709",
          b: "1F236",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["orange-square", "chinese", "have", "kanji"],
          k: [5, 37]
        },
        person_with_blond_hair: {
          skin_variations: {
            "1F3FB": {
              unified: "1F471-1F3FB",
              non_qualified: null,
              image: "1f471-1f3fb.png",
              sheet_x: 21,
              sheet_y: 21,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F471-1F3FC",
              non_qualified: null,
              image: "1f471-1f3fc.png",
              sheet_x: 21,
              sheet_y: 22,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F471-1F3FD",
              non_qualified: null,
              image: "1f471-1f3fd.png",
              sheet_x: 21,
              sheet_y: 23,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F471-1F3FE",
              non_qualified: null,
              image: "1f471-1f3fe.png",
              sheet_x: 21,
              sheet_y: 24,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F471-1F3FF",
              non_qualified: null,
              image: "1f471-1f3ff.png",
              sheet_x: 21,
              sheet_y: 25,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            }
          },
          obsoleted_by: "1F471-200D-2642-FE0F",
          a: "Person with Blond Hair",
          b: "1F471",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          k: [21, 20]
        },
        waning_crescent_moon: {
          a: "Waning Crescent Moon Symbol",
          b: "1F318",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nature", "twilight", "planet", "space", "night", "evening", "sleep"],
          k: [6, 16]
        },
        "flag-my": {
          a: "Malaysia Flag",
          b: "1F1F2-1F1FE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 38]
        },
        u6307: {
          a: "Squared Cjk Unified Ideograph-6307",
          b: "1F22F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["chinese", "point", "green-square", "kanji"],
          k: [5, 32],
          o: 5
        },
        "blond-haired-man": {
          skin_variations: {
            "1F3FB": {
              unified: "1F471-1F3FB-200D-2642-FE0F",
              non_qualified: "1F471-1F3FB-200D-2642",
              image: "1f471-1f3fb-200d-2642-fe0f.png",
              sheet_x: 21,
              sheet_y: 15,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F471-1F3FC-200D-2642-FE0F",
              non_qualified: "1F471-1F3FC-200D-2642",
              image: "1f471-1f3fc-200d-2642-fe0f.png",
              sheet_x: 21,
              sheet_y: 16,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F471-1F3FD-200D-2642-FE0F",
              non_qualified: "1F471-1F3FD-200D-2642",
              image: "1f471-1f3fd-200d-2642-fe0f.png",
              sheet_x: 21,
              sheet_y: 17,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F471-1F3FE-200D-2642-FE0F",
              non_qualified: "1F471-1F3FE-200D-2642",
              image: "1f471-1f3fe-200d-2642-fe0f.png",
              sheet_x: 21,
              sheet_y: 18,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F471-1F3FF-200D-2642-FE0F",
              non_qualified: "1F471-1F3FF-200D-2642",
              image: "1f471-1f3ff-200d-2642-fe0f.png",
              sheet_x: 21,
              sheet_y: 19,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F471",
          a: "Blond Haired Man",
          b: "1F471-200D-2642-FE0F",
          c: "1F471-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [21, 14]
        },
        crescent_moon: {
          a: "Crescent Moon",
          b: "1F319",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["night", "sleep", "sky", "evening", "magic"],
          k: [6, 17]
        },
        "flag-mz": {
          a: "Mozambique Flag",
          b: "1F1F2-1F1FF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 39]
        },
        new_moon_with_face: {
          a: "New Moon with Face",
          b: "1F31A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nature", "twilight", "planet", "space", "night", "evening", "sleep"],
          k: [6, 18]
        },
        "flag-na": {
          a: "Namibia Flag",
          b: "1F1F3-1F1E6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 40]
        },
        "blond-haired-woman": {
          skin_variations: {
            "1F3FB": {
              unified: "1F471-1F3FB-200D-2640-FE0F",
              non_qualified: "1F471-1F3FB-200D-2640",
              image: "1f471-1f3fb-200d-2640-fe0f.png",
              sheet_x: 21,
              sheet_y: 9,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F471-1F3FC-200D-2640-FE0F",
              non_qualified: "1F471-1F3FC-200D-2640",
              image: "1f471-1f3fc-200d-2640-fe0f.png",
              sheet_x: 21,
              sheet_y: 10,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F471-1F3FD-200D-2640-FE0F",
              non_qualified: "1F471-1F3FD-200D-2640",
              image: "1f471-1f3fd-200d-2640-fe0f.png",
              sheet_x: 21,
              sheet_y: 11,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F471-1F3FE-200D-2640-FE0F",
              non_qualified: "1F471-1F3FE-200D-2640",
              image: "1f471-1f3fe-200d-2640-fe0f.png",
              sheet_x: 21,
              sheet_y: 12,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F471-1F3FF-200D-2640-FE0F",
              non_qualified: "1F471-1F3FF-200D-2640",
              image: "1f471-1f3ff-200d-2640-fe0f.png",
              sheet_x: 21,
              sheet_y: 13,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Blond Haired Woman",
          b: "1F471-200D-2640-FE0F",
          c: "1F471-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [21, 8]
        },
        ideograph_advantage: {
          a: "Circled Ideograph Advantage",
          b: "1F250",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["chinese", "kanji", "obtain", "get", "circle"],
          k: [5, 42]
        },
        first_quarter_moon_with_face: {
          a: "First Quarter Moon with Face",
          b: "1F31B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nature", "twilight", "planet", "space", "night", "evening", "sleep"],
          k: [6, 19]
        },
        man_in_tuxedo: {
          skin_variations: {
            "1F3FB": {
              unified: "1F935-1F3FB",
              non_qualified: null,
              image: "1f935-1f3fb.png",
              sheet_x: 39,
              sheet_y: 35,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F935-1F3FC",
              non_qualified: null,
              image: "1f935-1f3fc.png",
              sheet_x: 39,
              sheet_y: 36,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F935-1F3FD",
              non_qualified: null,
              image: "1f935-1f3fd.png",
              sheet_x: 39,
              sheet_y: 37,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F935-1F3FE",
              non_qualified: null,
              image: "1f935-1f3fe.png",
              sheet_x: 39,
              sheet_y: 38,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F935-1F3FF",
              non_qualified: null,
              image: "1f935-1f3ff.png",
              sheet_x: 39,
              sheet_y: 39,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Man in Tuxedo",
          b: "1F935",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["couple", "marriage", "wedding", "groom"],
          k: [39, 34],
          o: 9
        },
        "flag-nc": {
          a: "New Caledonia Flag",
          b: "1F1F3-1F1E8",
          d: !0,
          e: !1,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 41]
        },
        u5272: {
          a: "Squared Cjk Unified Ideograph-5272",
          b: "1F239",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["cut", "divide", "chinese", "kanji", "pink-square"],
          k: [5, 40]
        },
        "flag-ne": {
          a: "Niger Flag",
          b: "1F1F3-1F1EA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 42]
        },
        last_quarter_moon_with_face: {
          a: "Last Quarter Moon with Face",
          b: "1F31C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nature", "twilight", "planet", "space", "night", "evening", "sleep"],
          k: [6, 20]
        },
        u7121: {
          a: "Squared Cjk Unified Ideograph-7121",
          b: "1F21A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nothing", "chinese", "kanji", "japanese", "orange-square"],
          k: [5, 31],
          o: 5
        },
        bride_with_veil: {
          skin_variations: {
            "1F3FB": {
              unified: "1F470-1F3FB",
              non_qualified: null,
              image: "1f470-1f3fb.png",
              sheet_x: 21,
              sheet_y: 3,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F470-1F3FC",
              non_qualified: null,
              image: "1f470-1f3fc.png",
              sheet_x: 21,
              sheet_y: 4,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F470-1F3FD",
              non_qualified: null,
              image: "1f470-1f3fd.png",
              sheet_x: 21,
              sheet_y: 5,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F470-1F3FE",
              non_qualified: null,
              image: "1f470-1f3fe.png",
              sheet_x: 21,
              sheet_y: 6,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F470-1F3FF",
              non_qualified: null,
              image: "1f470-1f3ff.png",
              sheet_x: 21,
              sheet_y: 7,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Bride with Veil",
          b: "1F470",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["couple", "marriage", "wedding", "woman", "bride"],
          k: [21, 2]
        },
        u7981: {
          a: "Squared Cjk Unified Ideograph-7981",
          b: "1F232",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["kanji", "japanese", "chinese", "forbidden", "limit", "restricted", "red-square"],
          k: [5, 33]
        },
        pregnant_woman: {
          skin_variations: {
            "1F3FB": {
              unified: "1F930-1F3FB",
              non_qualified: null,
              image: "1f930-1f3fb.png",
              sheet_x: 39,
              sheet_y: 5,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F930-1F3FC",
              non_qualified: null,
              image: "1f930-1f3fc.png",
              sheet_x: 39,
              sheet_y: 6,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F930-1F3FD",
              non_qualified: null,
              image: "1f930-1f3fd.png",
              sheet_x: 39,
              sheet_y: 7,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F930-1F3FE",
              non_qualified: null,
              image: "1f930-1f3fe.png",
              sheet_x: 39,
              sheet_y: 8,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F930-1F3FF",
              non_qualified: null,
              image: "1f930-1f3ff.png",
              sheet_x: 39,
              sheet_y: 9,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Pregnant Woman",
          b: "1F930",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["baby"],
          k: [39, 4],
          o: 9
        },
        thermometer: {
          a: "Thermometer",
          b: "1F321-FE0F",
          c: "1F321",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["weather", "temperature", "hot", "cold"],
          k: [6, 25],
          o: 7
        },
        "flag-nf": {
          a: "Norfolk Island Flag",
          b: "1F1F3-1F1EB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 43]
        },
        sunny: {
          a: "Black Sun with Rays",
          b: "2600-FE0F",
          c: "2600",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["weather", "nature", "brightness", "summer", "beach", "spring"],
          k: [47, 16],
          o: 1
        },
        accept: {
          a: "Circled Ideograph Accept",
          b: "1F251",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["ok", "good", "chinese", "kanji", "agree", "yes", "orange-circle"],
          k: [5, 43]
        },
        "flag-ng": {
          a: "Nigeria Flag",
          b: "1F1F3-1F1EC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 44]
        },
        "breast-feeding": {
          skin_variations: {
            "1F3FB": {
              unified: "1F931-1F3FB",
              non_qualified: null,
              image: "1f931-1f3fb.png",
              sheet_x: 39,
              sheet_y: 11,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F931-1F3FC",
              non_qualified: null,
              image: "1f931-1f3fc.png",
              sheet_x: 39,
              sheet_y: 12,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F931-1F3FD",
              non_qualified: null,
              image: "1f931-1f3fd.png",
              sheet_x: 39,
              sheet_y: 13,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F931-1F3FE",
              non_qualified: null,
              image: "1f931-1f3fe.png",
              sheet_x: 39,
              sheet_y: 14,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F931-1F3FF",
              non_qualified: null,
              image: "1f931-1f3ff.png",
              sheet_x: 39,
              sheet_y: 15,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Breast-Feeding",
          b: "1F931",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [39, 10],
          o: 10
        },
        full_moon_with_face: {
          a: "Full Moon with Face",
          b: "1F31D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nature", "twilight", "planet", "space", "night", "evening", "sleep"],
          k: [6, 21]
        },
        "flag-ni": {
          a: "Nicaragua Flag",
          b: "1F1F3-1F1EE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 45]
        },
        u7533: {
          a: "Squared Cjk Unified Ideograph-7533",
          b: "1F238",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["chinese", "japanese", "kanji", "orange-square"],
          k: [5, 39]
        },
        angel: {
          skin_variations: {
            "1F3FB": {
              unified: "1F47C-1F3FB",
              non_qualified: null,
              image: "1f47c-1f3fb.png",
              sheet_x: 22,
              sheet_y: 44,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F47C-1F3FC",
              non_qualified: null,
              image: "1f47c-1f3fc.png",
              sheet_x: 22,
              sheet_y: 45,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F47C-1F3FD",
              non_qualified: null,
              image: "1f47c-1f3fd.png",
              sheet_x: 22,
              sheet_y: 46,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F47C-1F3FE",
              non_qualified: null,
              image: "1f47c-1f3fe.png",
              sheet_x: 22,
              sheet_y: 47,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F47C-1F3FF",
              non_qualified: null,
              image: "1f47c-1f3ff.png",
              sheet_x: 22,
              sheet_y: 48,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Baby Angel",
          b: "1F47C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["heaven", "wings", "halo"],
          k: [22, 43]
        },
        sun_with_face: {
          a: "Sun with Face",
          b: "1F31E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nature", "morning", "sky"],
          k: [6, 22]
        },
        santa: {
          skin_variations: {
            "1F3FB": {
              unified: "1F385-1F3FB",
              non_qualified: null,
              image: "1f385-1f3fb.png",
              sheet_x: 8,
              sheet_y: 20,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F385-1F3FC",
              non_qualified: null,
              image: "1f385-1f3fc.png",
              sheet_x: 8,
              sheet_y: 21,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F385-1F3FD",
              non_qualified: null,
              image: "1f385-1f3fd.png",
              sheet_x: 8,
              sheet_y: 22,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F385-1F3FE",
              non_qualified: null,
              image: "1f385-1f3fe.png",
              sheet_x: 8,
              sheet_y: 23,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F385-1F3FF",
              non_qualified: null,
              image: "1f385-1f3ff.png",
              sheet_x: 8,
              sheet_y: 24,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Father Christmas",
          b: "1F385",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["festival", "man", "male", "xmas", "father christmas"],
          k: [8, 19]
        },
        u5408: {
          a: "Squared Cjk Unified Ideograph-5408",
          b: "1F234",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["japanese", "chinese", "join", "kanji", "red-square"],
          k: [5, 35]
        },
        "flag-nl": {
          a: "Netherlands Flag",
          b: "1F1F3-1F1F1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 46]
        },
        mrs_claus: {
          skin_variations: {
            "1F3FB": {
              unified: "1F936-1F3FB",
              non_qualified: null,
              image: "1f936-1f3fb.png",
              sheet_x: 39,
              sheet_y: 41,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F936-1F3FC",
              non_qualified: null,
              image: "1f936-1f3fc.png",
              sheet_x: 39,
              sheet_y: 42,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F936-1F3FD",
              non_qualified: null,
              image: "1f936-1f3fd.png",
              sheet_x: 39,
              sheet_y: 43,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F936-1F3FE",
              non_qualified: null,
              image: "1f936-1f3fe.png",
              sheet_x: 39,
              sheet_y: 44,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F936-1F3FF",
              non_qualified: null,
              image: "1f936-1f3ff.png",
              sheet_x: 39,
              sheet_y: 45,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Mother Christmas",
          b: "1F936",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["woman", "female", "xmas", "mother christmas"],
          k: [39, 40],
          n: ["mother_christmas"],
          o: 9
        },
        u7a7a: {
          a: "Squared Cjk Unified Ideograph-7a7a",
          b: "1F233",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["kanji", "japanese", "chinese", "empty", "sky", "blue-square"],
          k: [5, 34]
        },
        star: {
          a: "White Medium Star",
          b: "2B50",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["night", "yellow"],
          k: [50, 22],
          o: 5
        },
        "flag-no": {
          a: "Norway Flag",
          b: "1F1F3-1F1F4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 47]
        },
        mage: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9D9-1F3FB",
              non_qualified: null,
              image: "1f9d9-1f3fb.png",
              sheet_x: 44,
              sheet_y: 43,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9D9-1F3FB-200D-2640-FE0F"
            },
            "1F3FC": {
              unified: "1F9D9-1F3FC",
              non_qualified: null,
              image: "1f9d9-1f3fc.png",
              sheet_x: 44,
              sheet_y: 44,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9D9-1F3FC-200D-2640-FE0F"
            },
            "1F3FD": {
              unified: "1F9D9-1F3FD",
              non_qualified: null,
              image: "1f9d9-1f3fd.png",
              sheet_x: 44,
              sheet_y: 45,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9D9-1F3FD-200D-2640-FE0F"
            },
            "1F3FE": {
              unified: "1F9D9-1F3FE",
              non_qualified: null,
              image: "1f9d9-1f3fe.png",
              sheet_x: 44,
              sheet_y: 46,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9D9-1F3FE-200D-2640-FE0F"
            },
            "1F3FF": {
              unified: "1F9D9-1F3FF",
              non_qualified: null,
              image: "1f9d9-1f3ff.png",
              sheet_x: 44,
              sheet_y: 47,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9D9-1F3FF-200D-2640-FE0F"
            }
          },
          obsoleted_by: "1F9D9-200D-2640-FE0F",
          a: "Mage",
          b: "1F9D9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [44, 42],
          o: 10
        },
        star2: {
          a: "Glowing Star",
          b: "1F31F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["night", "sparkle", "awesome", "good", "magic"],
          k: [6, 23]
        },
        "flag-np": {
          a: "Nepal Flag",
          b: "1F1F3-1F1F5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 48]
        },
        congratulations: {
          a: "Circled Ideograph Congratulation",
          b: "3297-FE0F",
          c: "3297",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["chinese", "kanji", "japanese", "red-circle"],
          k: [50, 26],
          o: 1
        },
        "flag-nr": {
          a: "Nauru Flag",
          b: "1F1F3-1F1F7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 49]
        },
        stars: {
          a: "Shooting Star",
          b: "1F320",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["night", "photo"],
          k: [6, 24]
        },
        female_mage: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9D9-1F3FB-200D-2640-FE0F",
              non_qualified: "1F9D9-1F3FB-200D-2640",
              image: "1f9d9-1f3fb-200d-2640-fe0f.png",
              sheet_x: 44,
              sheet_y: 31,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9D9-1F3FB"
            },
            "1F3FC": {
              unified: "1F9D9-1F3FC-200D-2640-FE0F",
              non_qualified: "1F9D9-1F3FC-200D-2640",
              image: "1f9d9-1f3fc-200d-2640-fe0f.png",
              sheet_x: 44,
              sheet_y: 32,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9D9-1F3FC"
            },
            "1F3FD": {
              unified: "1F9D9-1F3FD-200D-2640-FE0F",
              non_qualified: "1F9D9-1F3FD-200D-2640",
              image: "1f9d9-1f3fd-200d-2640-fe0f.png",
              sheet_x: 44,
              sheet_y: 33,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9D9-1F3FD"
            },
            "1F3FE": {
              unified: "1F9D9-1F3FE-200D-2640-FE0F",
              non_qualified: "1F9D9-1F3FE-200D-2640",
              image: "1f9d9-1f3fe-200d-2640-fe0f.png",
              sheet_x: 44,
              sheet_y: 34,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9D9-1F3FE"
            },
            "1F3FF": {
              unified: "1F9D9-1F3FF-200D-2640-FE0F",
              non_qualified: "1F9D9-1F3FF-200D-2640",
              image: "1f9d9-1f3ff-200d-2640-fe0f.png",
              sheet_x: 44,
              sheet_y: 35,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9D9-1F3FF"
            }
          },
          obsoletes: "1F9D9",
          a: "Female Mage",
          b: "1F9D9-200D-2640-FE0F",
          c: "1F9D9-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [44, 30],
          o: 10
        },
        secret: {
          a: "Circled Ideograph Secret",
          b: "3299-FE0F",
          c: "3299",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["privacy", "chinese", "sshh", "kanji", "red-circle"],
          k: [50, 27],
          o: 1
        },
        "flag-nu": {
          a: "Niue Flag",
          b: "1F1F3-1F1FA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 50]
        },
        u55b6: {
          a: "Squared Cjk Unified Ideograph-55b6",
          b: "1F23A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["japanese", "opening hours", "orange-square"],
          k: [5, 41]
        },
        male_mage: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9D9-1F3FB-200D-2642-FE0F",
              non_qualified: "1F9D9-1F3FB-200D-2642",
              image: "1f9d9-1f3fb-200d-2642-fe0f.png",
              sheet_x: 44,
              sheet_y: 37,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F9D9-1F3FC-200D-2642-FE0F",
              non_qualified: "1F9D9-1F3FC-200D-2642",
              image: "1f9d9-1f3fc-200d-2642-fe0f.png",
              sheet_x: 44,
              sheet_y: 38,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F9D9-1F3FD-200D-2642-FE0F",
              non_qualified: "1F9D9-1F3FD-200D-2642",
              image: "1f9d9-1f3fd-200d-2642-fe0f.png",
              sheet_x: 44,
              sheet_y: 39,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F9D9-1F3FE-200D-2642-FE0F",
              non_qualified: "1F9D9-1F3FE-200D-2642",
              image: "1f9d9-1f3fe-200d-2642-fe0f.png",
              sheet_x: 44,
              sheet_y: 40,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F9D9-1F3FF-200D-2642-FE0F",
              non_qualified: "1F9D9-1F3FF-200D-2642",
              image: "1f9d9-1f3ff-200d-2642-fe0f.png",
              sheet_x: 44,
              sheet_y: 41,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Male Mage",
          b: "1F9D9-200D-2642-FE0F",
          c: "1F9D9-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [44, 36],
          o: 10
        },
        cloud: {
          a: "Cloud",
          b: "2601-FE0F",
          c: "2601",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["weather", "sky"],
          k: [47, 17],
          o: 1
        },
        "flag-nz": {
          a: "New Zealand Flag",
          b: "1F1F3-1F1FF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 51]
        },
        partly_sunny: {
          a: "Sun Behind Cloud",
          b: "26C5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["weather", "nature", "cloudy", "morning", "fall", "spring"],
          k: [48, 29],
          o: 5
        },
        fairy: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9DA-1F3FB",
              non_qualified: null,
              image: "1f9da-1f3fb.png",
              sheet_x: 45,
              sheet_y: 9,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoleted_by: "1F9DA-1F3FB-200D-2640-FE0F"
            },
            "1F3FC": {
              unified: "1F9DA-1F3FC",
              non_qualified: null,
              image: "1f9da-1f3fc.png",
              sheet_x: 45,
              sheet_y: 10,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoleted_by: "1F9DA-1F3FC-200D-2640-FE0F"
            },
            "1F3FD": {
              unified: "1F9DA-1F3FD",
              non_qualified: null,
              image: "1f9da-1f3fd.png",
              sheet_x: 45,
              sheet_y: 11,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoleted_by: "1F9DA-1F3FD-200D-2640-FE0F"
            },
            "1F3FE": {
              unified: "1F9DA-1F3FE",
              non_qualified: null,
              image: "1f9da-1f3fe.png",
              sheet_x: 45,
              sheet_y: 12,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoleted_by: "1F9DA-1F3FE-200D-2640-FE0F"
            },
            "1F3FF": {
              unified: "1F9DA-1F3FF",
              non_qualified: null,
              image: "1f9da-1f3ff.png",
              sheet_x: 45,
              sheet_y: 13,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoleted_by: "1F9DA-1F3FF-200D-2640-FE0F"
            }
          },
          obsoleted_by: "1F9DA-200D-2640-FE0F",
          a: "Fairy",
          b: "1F9DA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [45, 8],
          o: 10
        },
        u6e80: {
          a: "Squared Cjk Unified Ideograph-6e80",
          b: "1F235",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["full", "chinese", "japanese", "red-square", "kanji"],
          k: [5, 36]
        },
        black_small_square: {
          a: "Black Small Square",
          b: "25AA-FE0F",
          c: "25AA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shape", "icon"],
          k: [47, 8],
          o: 1
        },
        thunder_cloud_and_rain: {
          a: "Thunder Cloud and Rain",
          b: "26C8-FE0F",
          c: "26C8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [48, 30],
          o: 5
        },
        female_fairy: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9DA-1F3FB-200D-2640-FE0F",
              non_qualified: "1F9DA-1F3FB-200D-2640",
              image: "1f9da-1f3fb-200d-2640-fe0f.png",
              sheet_x: 44,
              sheet_y: 49,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9DA-1F3FB"
            },
            "1F3FC": {
              unified: "1F9DA-1F3FC-200D-2640-FE0F",
              non_qualified: "1F9DA-1F3FC-200D-2640",
              image: "1f9da-1f3fc-200d-2640-fe0f.png",
              sheet_x: 44,
              sheet_y: 50,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9DA-1F3FC"
            },
            "1F3FD": {
              unified: "1F9DA-1F3FD-200D-2640-FE0F",
              non_qualified: "1F9DA-1F3FD-200D-2640",
              image: "1f9da-1f3fd-200d-2640-fe0f.png",
              sheet_x: 44,
              sheet_y: 51,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9DA-1F3FD"
            },
            "1F3FE": {
              unified: "1F9DA-1F3FE-200D-2640-FE0F",
              non_qualified: "1F9DA-1F3FE-200D-2640",
              image: "1f9da-1f3fe-200d-2640-fe0f.png",
              sheet_x: 45,
              sheet_y: 0,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9DA-1F3FE"
            },
            "1F3FF": {
              unified: "1F9DA-1F3FF-200D-2640-FE0F",
              non_qualified: "1F9DA-1F3FF-200D-2640",
              image: "1f9da-1f3ff-200d-2640-fe0f.png",
              sheet_x: 45,
              sheet_y: 1,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9DA-1F3FF"
            }
          },
          obsoletes: "1F9DA",
          a: "Female Fairy",
          b: "1F9DA-200D-2640-FE0F",
          c: "1F9DA-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [44, 48],
          o: 10
        },
        "flag-om": {
          a: "Oman Flag",
          b: "1F1F4-1F1F2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 0]
        },
        white_small_square: {
          a: "White Small Square",
          b: "25AB-FE0F",
          c: "25AB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shape", "icon"],
          k: [47, 9],
          o: 1
        },
        "flag-pa": {
          a: "Panama Flag",
          b: "1F1F5-1F1E6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 1]
        },
        mostly_sunny: {
          a: "Mostly Sunny",
          b: "1F324-FE0F",
          c: "1F324",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [6, 26],
          n: ["sun_small_cloud"],
          o: 7
        },
        male_fairy: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9DA-1F3FB-200D-2642-FE0F",
              non_qualified: "1F9DA-1F3FB-200D-2642",
              image: "1f9da-1f3fb-200d-2642-fe0f.png",
              sheet_x: 45,
              sheet_y: 3,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F9DA-1F3FC-200D-2642-FE0F",
              non_qualified: "1F9DA-1F3FC-200D-2642",
              image: "1f9da-1f3fc-200d-2642-fe0f.png",
              sheet_x: 45,
              sheet_y: 4,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F9DA-1F3FD-200D-2642-FE0F",
              non_qualified: "1F9DA-1F3FD-200D-2642",
              image: "1f9da-1f3fd-200d-2642-fe0f.png",
              sheet_x: 45,
              sheet_y: 5,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F9DA-1F3FE-200D-2642-FE0F",
              non_qualified: "1F9DA-1F3FE-200D-2642",
              image: "1f9da-1f3fe-200d-2642-fe0f.png",
              sheet_x: 45,
              sheet_y: 6,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F9DA-1F3FF-200D-2642-FE0F",
              non_qualified: "1F9DA-1F3FF-200D-2642",
              image: "1f9da-1f3ff-200d-2642-fe0f.png",
              sheet_x: 45,
              sheet_y: 7,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Male Fairy",
          b: "1F9DA-200D-2642-FE0F",
          c: "1F9DA-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [45, 2],
          o: 10
        },
        barely_sunny: {
          a: "Barely Sunny",
          b: "1F325-FE0F",
          c: "1F325",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [6, 27],
          n: ["sun_behind_cloud"],
          o: 7
        },
        white_medium_square: {
          a: "White Medium Square",
          b: "25FB-FE0F",
          c: "25FB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shape", "stone", "icon"],
          k: [47, 12],
          o: 3
        },
        "flag-pe": {
          a: "Peru Flag",
          b: "1F1F5-1F1EA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 2]
        },
        vampire: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9DB-1F3FB",
              non_qualified: null,
              image: "1f9db-1f3fb.png",
              sheet_x: 45,
              sheet_y: 27,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoleted_by: "1F9DB-1F3FB-200D-2640-FE0F"
            },
            "1F3FC": {
              unified: "1F9DB-1F3FC",
              non_qualified: null,
              image: "1f9db-1f3fc.png",
              sheet_x: 45,
              sheet_y: 28,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoleted_by: "1F9DB-1F3FC-200D-2640-FE0F"
            },
            "1F3FD": {
              unified: "1F9DB-1F3FD",
              non_qualified: null,
              image: "1f9db-1f3fd.png",
              sheet_x: 45,
              sheet_y: 29,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoleted_by: "1F9DB-1F3FD-200D-2640-FE0F"
            },
            "1F3FE": {
              unified: "1F9DB-1F3FE",
              non_qualified: null,
              image: "1f9db-1f3fe.png",
              sheet_x: 45,
              sheet_y: 30,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoleted_by: "1F9DB-1F3FE-200D-2640-FE0F"
            },
            "1F3FF": {
              unified: "1F9DB-1F3FF",
              non_qualified: null,
              image: "1f9db-1f3ff.png",
              sheet_x: 45,
              sheet_y: 31,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoleted_by: "1F9DB-1F3FF-200D-2640-FE0F"
            }
          },
          obsoleted_by: "1F9DB-200D-2640-FE0F",
          a: "Vampire",
          b: "1F9DB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [45, 26],
          o: 10
        },
        female_vampire: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9DB-1F3FB-200D-2640-FE0F",
              non_qualified: "1F9DB-1F3FB-200D-2640",
              image: "1f9db-1f3fb-200d-2640-fe0f.png",
              sheet_x: 45,
              sheet_y: 15,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9DB-1F3FB"
            },
            "1F3FC": {
              unified: "1F9DB-1F3FC-200D-2640-FE0F",
              non_qualified: "1F9DB-1F3FC-200D-2640",
              image: "1f9db-1f3fc-200d-2640-fe0f.png",
              sheet_x: 45,
              sheet_y: 16,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9DB-1F3FC"
            },
            "1F3FD": {
              unified: "1F9DB-1F3FD-200D-2640-FE0F",
              non_qualified: "1F9DB-1F3FD-200D-2640",
              image: "1f9db-1f3fd-200d-2640-fe0f.png",
              sheet_x: 45,
              sheet_y: 17,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9DB-1F3FD"
            },
            "1F3FE": {
              unified: "1F9DB-1F3FE-200D-2640-FE0F",
              non_qualified: "1F9DB-1F3FE-200D-2640",
              image: "1f9db-1f3fe-200d-2640-fe0f.png",
              sheet_x: 45,
              sheet_y: 18,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9DB-1F3FE"
            },
            "1F3FF": {
              unified: "1F9DB-1F3FF-200D-2640-FE0F",
              non_qualified: "1F9DB-1F3FF-200D-2640",
              image: "1f9db-1f3ff-200d-2640-fe0f.png",
              sheet_x: 45,
              sheet_y: 19,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9DB-1F3FF"
            }
          },
          obsoletes: "1F9DB",
          a: "Female Vampire",
          b: "1F9DB-200D-2640-FE0F",
          c: "1F9DB-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [45, 14],
          o: 10
        },
        partly_sunny_rain: {
          a: "Partly Sunny Rain",
          b: "1F326-FE0F",
          c: "1F326",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [6, 28],
          n: ["sun_behind_rain_cloud"],
          o: 7
        },
        "flag-pf": {
          a: "French Polynesia Flag",
          b: "1F1F5-1F1EB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 3]
        },
        black_medium_square: {
          a: "Black Medium Square",
          b: "25FC-FE0F",
          c: "25FC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shape", "button", "icon"],
          k: [47, 13],
          o: 3
        },
        white_medium_small_square: {
          a: "White Medium Small Square",
          b: "25FD",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shape", "stone", "icon", "button"],
          k: [47, 14],
          o: 3
        },
        rain_cloud: {
          a: "Rain Cloud",
          b: "1F327-FE0F",
          c: "1F327",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [6, 29],
          o: 7
        },
        "flag-pg": {
          a: "Papua New Guinea Flag",
          b: "1F1F5-1F1EC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 4]
        },
        male_vampire: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9DB-1F3FB-200D-2642-FE0F",
              non_qualified: "1F9DB-1F3FB-200D-2642",
              image: "1f9db-1f3fb-200d-2642-fe0f.png",
              sheet_x: 45,
              sheet_y: 21,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F9DB-1F3FC-200D-2642-FE0F",
              non_qualified: "1F9DB-1F3FC-200D-2642",
              image: "1f9db-1f3fc-200d-2642-fe0f.png",
              sheet_x: 45,
              sheet_y: 22,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F9DB-1F3FD-200D-2642-FE0F",
              non_qualified: "1F9DB-1F3FD-200D-2642",
              image: "1f9db-1f3fd-200d-2642-fe0f.png",
              sheet_x: 45,
              sheet_y: 23,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F9DB-1F3FE-200D-2642-FE0F",
              non_qualified: "1F9DB-1F3FE-200D-2642",
              image: "1f9db-1f3fe-200d-2642-fe0f.png",
              sheet_x: 45,
              sheet_y: 24,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F9DB-1F3FF-200D-2642-FE0F",
              non_qualified: "1F9DB-1F3FF-200D-2642",
              image: "1f9db-1f3ff-200d-2642-fe0f.png",
              sheet_x: 45,
              sheet_y: 25,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Male Vampire",
          b: "1F9DB-200D-2642-FE0F",
          c: "1F9DB-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [45, 20],
          o: 10
        },
        "flag-ph": {
          a: "Philippines Flag",
          b: "1F1F5-1F1ED",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 5]
        },
        merperson: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9DC-1F3FB",
              non_qualified: null,
              image: "1f9dc-1f3fb.png",
              sheet_x: 45,
              sheet_y: 45,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9DC-1F3FB-200D-2642-FE0F"
            },
            "1F3FC": {
              unified: "1F9DC-1F3FC",
              non_qualified: null,
              image: "1f9dc-1f3fc.png",
              sheet_x: 45,
              sheet_y: 46,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9DC-1F3FC-200D-2642-FE0F"
            },
            "1F3FD": {
              unified: "1F9DC-1F3FD",
              non_qualified: null,
              image: "1f9dc-1f3fd.png",
              sheet_x: 45,
              sheet_y: 47,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9DC-1F3FD-200D-2642-FE0F"
            },
            "1F3FE": {
              unified: "1F9DC-1F3FE",
              non_qualified: null,
              image: "1f9dc-1f3fe.png",
              sheet_x: 45,
              sheet_y: 48,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9DC-1F3FE-200D-2642-FE0F"
            },
            "1F3FF": {
              unified: "1F9DC-1F3FF",
              non_qualified: null,
              image: "1f9dc-1f3ff.png",
              sheet_x: 45,
              sheet_y: 49,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9DC-1F3FF-200D-2642-FE0F"
            }
          },
          obsoleted_by: "1F9DC-200D-2642-FE0F",
          a: "Merperson",
          b: "1F9DC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [45, 44],
          o: 10
        },
        black_medium_small_square: {
          a: "Black Medium Small Square",
          b: "25FE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["icon", "shape", "button"],
          k: [47, 15],
          o: 3
        },
        snow_cloud: {
          a: "Snow Cloud",
          b: "1F328-FE0F",
          c: "1F328",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [6, 30],
          o: 7
        },
        lightning: {
          a: "Lightning",
          b: "1F329-FE0F",
          c: "1F329",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [6, 31],
          n: ["lightning_cloud"],
          o: 7
        },
        black_large_square: {
          a: "Black Large Square",
          b: "2B1B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shape", "icon", "button"],
          k: [50, 20],
          o: 5
        },
        mermaid: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9DC-1F3FB-200D-2640-FE0F",
              non_qualified: "1F9DC-1F3FB-200D-2640",
              image: "1f9dc-1f3fb-200d-2640-fe0f.png",
              sheet_x: 45,
              sheet_y: 33,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F9DC-1F3FC-200D-2640-FE0F",
              non_qualified: "1F9DC-1F3FC-200D-2640",
              image: "1f9dc-1f3fc-200d-2640-fe0f.png",
              sheet_x: 45,
              sheet_y: 34,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F9DC-1F3FD-200D-2640-FE0F",
              non_qualified: "1F9DC-1F3FD-200D-2640",
              image: "1f9dc-1f3fd-200d-2640-fe0f.png",
              sheet_x: 45,
              sheet_y: 35,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F9DC-1F3FE-200D-2640-FE0F",
              non_qualified: "1F9DC-1F3FE-200D-2640",
              image: "1f9dc-1f3fe-200d-2640-fe0f.png",
              sheet_x: 45,
              sheet_y: 36,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F9DC-1F3FF-200D-2640-FE0F",
              non_qualified: "1F9DC-1F3FF-200D-2640",
              image: "1f9dc-1f3ff-200d-2640-fe0f.png",
              sheet_x: 45,
              sheet_y: 37,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Mermaid",
          b: "1F9DC-200D-2640-FE0F",
          c: "1F9DC-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [45, 32],
          o: 10
        },
        "flag-pk": {
          a: "Pakistan Flag",
          b: "1F1F5-1F1F0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 6]
        },
        merman: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9DC-1F3FB-200D-2642-FE0F",
              non_qualified: "1F9DC-1F3FB-200D-2642",
              image: "1f9dc-1f3fb-200d-2642-fe0f.png",
              sheet_x: 45,
              sheet_y: 39,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9DC-1F3FB"
            },
            "1F3FC": {
              unified: "1F9DC-1F3FC-200D-2642-FE0F",
              non_qualified: "1F9DC-1F3FC-200D-2642",
              image: "1f9dc-1f3fc-200d-2642-fe0f.png",
              sheet_x: 45,
              sheet_y: 40,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9DC-1F3FC"
            },
            "1F3FD": {
              unified: "1F9DC-1F3FD-200D-2642-FE0F",
              non_qualified: "1F9DC-1F3FD-200D-2642",
              image: "1f9dc-1f3fd-200d-2642-fe0f.png",
              sheet_x: 45,
              sheet_y: 41,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9DC-1F3FD"
            },
            "1F3FE": {
              unified: "1F9DC-1F3FE-200D-2642-FE0F",
              non_qualified: "1F9DC-1F3FE-200D-2642",
              image: "1f9dc-1f3fe-200d-2642-fe0f.png",
              sheet_x: 45,
              sheet_y: 42,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9DC-1F3FE"
            },
            "1F3FF": {
              unified: "1F9DC-1F3FF-200D-2642-FE0F",
              non_qualified: "1F9DC-1F3FF-200D-2642",
              image: "1f9dc-1f3ff-200d-2642-fe0f.png",
              sheet_x: 45,
              sheet_y: 43,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9DC-1F3FF"
            }
          },
          obsoletes: "1F9DC",
          a: "Merman",
          b: "1F9DC-200D-2642-FE0F",
          c: "1F9DC-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [45, 38],
          o: 10
        },
        white_large_square: {
          a: "White Large Square",
          b: "2B1C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shape", "icon", "stone", "button"],
          k: [50, 21],
          o: 5
        },
        tornado: {
          a: "Tornado",
          b: "1F32A-FE0F",
          c: "1F32A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["weather", "cyclone", "twister"],
          k: [6, 32],
          n: ["tornado_cloud"],
          o: 7
        },
        "flag-pl": {
          a: "Poland Flag",
          b: "1F1F5-1F1F1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 7]
        },
        elf: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9DD-1F3FB",
              non_qualified: null,
              image: "1f9dd-1f3fb.png",
              sheet_x: 46,
              sheet_y: 11,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9DD-1F3FB-200D-2642-FE0F"
            },
            "1F3FC": {
              unified: "1F9DD-1F3FC",
              non_qualified: null,
              image: "1f9dd-1f3fc.png",
              sheet_x: 46,
              sheet_y: 12,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9DD-1F3FC-200D-2642-FE0F"
            },
            "1F3FD": {
              unified: "1F9DD-1F3FD",
              non_qualified: null,
              image: "1f9dd-1f3fd.png",
              sheet_x: 46,
              sheet_y: 13,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9DD-1F3FD-200D-2642-FE0F"
            },
            "1F3FE": {
              unified: "1F9DD-1F3FE",
              non_qualified: null,
              image: "1f9dd-1f3fe.png",
              sheet_x: 46,
              sheet_y: 14,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9DD-1F3FE-200D-2642-FE0F"
            },
            "1F3FF": {
              unified: "1F9DD-1F3FF",
              non_qualified: null,
              image: "1f9dd-1f3ff.png",
              sheet_x: 46,
              sheet_y: 15,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9DD-1F3FF-200D-2642-FE0F"
            }
          },
          obsoleted_by: "1F9DD-200D-2642-FE0F",
          a: "Elf",
          b: "1F9DD",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [46, 10],
          o: 10
        },
        fog: {
          a: "Fog",
          b: "1F32B-FE0F",
          c: "1F32B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["weather"],
          k: [6, 33],
          o: 7
        },
        large_orange_diamond: {
          a: "Large Orange Diamond",
          b: "1F536",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shape", "jewel", "gem"],
          k: [28, 4]
        },
        "flag-pm": {
          a: "St. Pierre & Miquelon Flag",
          b: "1F1F5-1F1F2",
          d: !0,
          e: !1,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 8]
        },
        "flag-pn": {
          a: "Pitcairn Islands Flag",
          b: "1F1F5-1F1F3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 9]
        },
        wind_blowing_face: {
          a: "Wind Blowing Face",
          b: "1F32C-FE0F",
          c: "1F32C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [6, 34],
          o: 7
        },
        female_elf: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9DD-1F3FB-200D-2640-FE0F",
              non_qualified: "1F9DD-1F3FB-200D-2640",
              image: "1f9dd-1f3fb-200d-2640-fe0f.png",
              sheet_x: 45,
              sheet_y: 51,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F9DD-1F3FC-200D-2640-FE0F",
              non_qualified: "1F9DD-1F3FC-200D-2640",
              image: "1f9dd-1f3fc-200d-2640-fe0f.png",
              sheet_x: 46,
              sheet_y: 0,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F9DD-1F3FD-200D-2640-FE0F",
              non_qualified: "1F9DD-1F3FD-200D-2640",
              image: "1f9dd-1f3fd-200d-2640-fe0f.png",
              sheet_x: 46,
              sheet_y: 1,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F9DD-1F3FE-200D-2640-FE0F",
              non_qualified: "1F9DD-1F3FE-200D-2640",
              image: "1f9dd-1f3fe-200d-2640-fe0f.png",
              sheet_x: 46,
              sheet_y: 2,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F9DD-1F3FF-200D-2640-FE0F",
              non_qualified: "1F9DD-1F3FF-200D-2640",
              image: "1f9dd-1f3ff-200d-2640-fe0f.png",
              sheet_x: 46,
              sheet_y: 3,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Female Elf",
          b: "1F9DD-200D-2640-FE0F",
          c: "1F9DD-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [45, 50],
          o: 10
        },
        large_blue_diamond: {
          a: "Large Blue Diamond",
          b: "1F537",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shape", "jewel", "gem"],
          k: [28, 5]
        },
        male_elf: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9DD-1F3FB-200D-2642-FE0F",
              non_qualified: "1F9DD-1F3FB-200D-2642",
              image: "1f9dd-1f3fb-200d-2642-fe0f.png",
              sheet_x: 46,
              sheet_y: 5,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9DD-1F3FB"
            },
            "1F3FC": {
              unified: "1F9DD-1F3FC-200D-2642-FE0F",
              non_qualified: "1F9DD-1F3FC-200D-2642",
              image: "1f9dd-1f3fc-200d-2642-fe0f.png",
              sheet_x: 46,
              sheet_y: 6,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9DD-1F3FC"
            },
            "1F3FD": {
              unified: "1F9DD-1F3FD-200D-2642-FE0F",
              non_qualified: "1F9DD-1F3FD-200D-2642",
              image: "1f9dd-1f3fd-200d-2642-fe0f.png",
              sheet_x: 46,
              sheet_y: 7,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9DD-1F3FD"
            },
            "1F3FE": {
              unified: "1F9DD-1F3FE-200D-2642-FE0F",
              non_qualified: "1F9DD-1F3FE-200D-2642",
              image: "1f9dd-1f3fe-200d-2642-fe0f.png",
              sheet_x: 46,
              sheet_y: 8,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9DD-1F3FE"
            },
            "1F3FF": {
              unified: "1F9DD-1F3FF-200D-2642-FE0F",
              non_qualified: "1F9DD-1F3FF-200D-2642",
              image: "1f9dd-1f3ff-200d-2642-fe0f.png",
              sheet_x: 46,
              sheet_y: 9,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9DD-1F3FF"
            }
          },
          obsoletes: "1F9DD",
          a: "Male Elf",
          b: "1F9DD-200D-2642-FE0F",
          c: "1F9DD-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [46, 4],
          o: 10
        },
        small_orange_diamond: {
          a: "Small Orange Diamond",
          b: "1F538",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shape", "jewel", "gem"],
          k: [28, 6]
        },
        "flag-pr": {
          a: "Puerto Rico Flag",
          b: "1F1F5-1F1F7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 10]
        },
        cyclone: {
          a: "Cyclone",
          b: "1F300",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["weather", "swirl", "blue", "cloud", "vortex", "spiral", "whirlpool", "spin", "tornado", "hurricane", "typhoon"],
          k: [5, 44]
        },
        rainbow: {
          a: "Rainbow",
          b: "1F308",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nature", "happy", "unicorn_face", "photo", "sky", "spring"],
          k: [6, 0]
        },
        small_blue_diamond: {
          a: "Small Blue Diamond",
          b: "1F539",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shape", "jewel", "gem"],
          k: [28, 7]
        },
        genie: {
          obsoleted_by: "1F9DE-200D-2642-FE0F",
          a: "Genie",
          b: "1F9DE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [46, 18],
          o: 10
        },
        "flag-ps": {
          a: "Palestinian Territories Flag",
          b: "1F1F5-1F1F8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 11]
        },
        small_red_triangle: {
          a: "Up-Pointing Red Triangle",
          b: "1F53A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shape", "direction", "up", "top"],
          k: [28, 8]
        },
        closed_umbrella: {
          a: "Closed Umbrella",
          b: "1F302",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["weather", "rain", "drizzle"],
          k: [5, 46]
        },
        female_genie: {
          a: "Female Genie",
          b: "1F9DE-200D-2640-FE0F",
          c: "1F9DE-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [46, 16],
          o: 10
        },
        "flag-pt": {
          a: "Portugal Flag",
          b: "1F1F5-1F1F9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 12]
        },
        "flag-pw": {
          a: "Palau Flag",
          b: "1F1F5-1F1FC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 13]
        },
        small_red_triangle_down: {
          a: "Down-Pointing Red Triangle",
          b: "1F53B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shape", "direction", "bottom"],
          k: [28, 9]
        },
        umbrella: {
          a: "Umbrella",
          b: "2602-FE0F",
          c: "2602",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["rainy", "weather", "spring"],
          k: [47, 18],
          o: 1
        },
        male_genie: {
          obsoletes: "1F9DE",
          a: "Male Genie",
          b: "1F9DE-200D-2642-FE0F",
          c: "1F9DE-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [46, 17],
          o: 10
        },
        zombie: {
          obsoleted_by: "1F9DF-200D-2642-FE0F",
          a: "Zombie",
          b: "1F9DF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [46, 21],
          o: 10
        },
        "flag-py": {
          a: "Paraguay Flag",
          b: "1F1F5-1F1FE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 14]
        },
        diamond_shape_with_a_dot_inside: {
          a: "Diamond Shape with a Dot Inside",
          b: "1F4A0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["jewel", "blue", "gem", "crystal", "fancy"],
          k: [25, 6]
        },
        umbrella_with_rain_drops: {
          a: "Umbrella with Rain Drops",
          b: "2614",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [47, 23],
          o: 4
        },
        radio_button: {
          a: "Radio Button",
          b: "1F518",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["input", "old", "music", "circle"],
          k: [27, 26]
        },
        female_zombie: {
          a: "Female Zombie",
          b: "1F9DF-200D-2640-FE0F",
          c: "1F9DF-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [46, 19],
          o: 10
        },
        "flag-qa": {
          a: "Qatar Flag",
          b: "1F1F6-1F1E6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 15]
        },
        umbrella_on_ground: {
          a: "Umbrella on Ground",
          b: "26F1-FE0F",
          c: "26F1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [48, 39],
          o: 5
        },
        black_square_button: {
          a: "Black Square Button",
          b: "1F532",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shape", "input", "frame"],
          k: [28, 0]
        },
        zap: {
          a: "High Voltage Sign",
          b: "26A1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["thunder", "weather", "lightning bolt", "fast"],
          k: [48, 21],
          o: 4
        },
        male_zombie: {
          obsoletes: "1F9DF",
          a: "Male Zombie",
          b: "1F9DF-200D-2642-FE0F",
          c: "1F9DF-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [46, 20],
          o: 10
        },
        "flag-re": {
          a: "R\xe9union Flag",
          b: "1F1F7-1F1EA",
          d: !0,
          e: !1,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 16]
        },
        "flag-ro": {
          a: "Romania Flag",
          b: "1F1F7-1F1F4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 17]
        },
        snowflake: {
          a: "Snowflake",
          b: "2744-FE0F",
          c: "2744",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["winter", "season", "cold", "weather", "christmas", "xmas"],
          k: [49, 51],
          o: 1
        },
        white_square_button: {
          a: "White Square Button",
          b: "1F533",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shape", "input"],
          k: [28, 1]
        },
        person_frowning: {
          skin_variations: {
            "1F3FB": {
              unified: "1F64D-1F3FB",
              non_qualified: null,
              image: "1f64d-1f3fb.png",
              sheet_x: 33,
              sheet_y: 31,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F64D-1F3FC",
              non_qualified: null,
              image: "1f64d-1f3fc.png",
              sheet_x: 33,
              sheet_y: 32,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F64D-1F3FD",
              non_qualified: null,
              image: "1f64d-1f3fd.png",
              sheet_x: 33,
              sheet_y: 33,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F64D-1F3FE",
              non_qualified: null,
              image: "1f64d-1f3fe.png",
              sheet_x: 33,
              sheet_y: 34,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F64D-1F3FF",
              non_qualified: null,
              image: "1f64d-1f3ff.png",
              sheet_x: 33,
              sheet_y: 35,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            }
          },
          obsoleted_by: "1F64D-200D-2640-FE0F",
          a: "Person Frowning",
          b: "1F64D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          k: [33, 30]
        },
        "flag-rs": {
          a: "Serbia Flag",
          b: "1F1F7-1F1F8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 18]
        },
        "man-frowning": {
          skin_variations: {
            "1F3FB": {
              unified: "1F64D-1F3FB-200D-2642-FE0F",
              non_qualified: "1F64D-1F3FB-200D-2642",
              image: "1f64d-1f3fb-200d-2642-fe0f.png",
              sheet_x: 33,
              sheet_y: 25,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F64D-1F3FC-200D-2642-FE0F",
              non_qualified: "1F64D-1F3FC-200D-2642",
              image: "1f64d-1f3fc-200d-2642-fe0f.png",
              sheet_x: 33,
              sheet_y: 26,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F64D-1F3FD-200D-2642-FE0F",
              non_qualified: "1F64D-1F3FD-200D-2642",
              image: "1f64d-1f3fd-200d-2642-fe0f.png",
              sheet_x: 33,
              sheet_y: 27,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F64D-1F3FE-200D-2642-FE0F",
              non_qualified: "1F64D-1F3FE-200D-2642",
              image: "1f64d-1f3fe-200d-2642-fe0f.png",
              sheet_x: 33,
              sheet_y: 28,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F64D-1F3FF-200D-2642-FE0F",
              non_qualified: "1F64D-1F3FF-200D-2642",
              image: "1f64d-1f3ff-200d-2642-fe0f.png",
              sheet_x: 33,
              sheet_y: 29,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Man Frowning",
          b: "1F64D-200D-2642-FE0F",
          c: "1F64D-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [33, 24]
        },
        white_circle: {
          a: "Medium White Circle",
          b: "26AA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shape", "round"],
          k: [48, 22],
          o: 4
        },
        snowman: {
          a: "Snowman",
          b: "2603-FE0F",
          c: "2603",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["winter", "season", "cold", "weather", "christmas", "xmas", "frozen", "without_snow"],
          k: [47, 19],
          o: 1
        },
        snowman_without_snow: {
          a: "Snowman Without Snow",
          b: "26C4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [48, 28],
          o: 5
        },
        ru: {
          a: "Russia Flag",
          b: "1F1F7-1F1FA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["russian", "federation", "flag", "nation", "country", "banner"],
          k: [4, 19],
          n: ["flag-ru"]
        },
        black_circle: {
          a: "Medium Black Circle",
          b: "26AB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shape", "button", "round"],
          k: [48, 23],
          o: 4
        },
        "woman-frowning": {
          skin_variations: {
            "1F3FB": {
              unified: "1F64D-1F3FB-200D-2640-FE0F",
              non_qualified: "1F64D-1F3FB-200D-2640",
              image: "1f64d-1f3fb-200d-2640-fe0f.png",
              sheet_x: 33,
              sheet_y: 19,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F64D-1F3FC-200D-2640-FE0F",
              non_qualified: "1F64D-1F3FC-200D-2640",
              image: "1f64d-1f3fc-200d-2640-fe0f.png",
              sheet_x: 33,
              sheet_y: 20,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F64D-1F3FD-200D-2640-FE0F",
              non_qualified: "1F64D-1F3FD-200D-2640",
              image: "1f64d-1f3fd-200d-2640-fe0f.png",
              sheet_x: 33,
              sheet_y: 21,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F64D-1F3FE-200D-2640-FE0F",
              non_qualified: "1F64D-1F3FE-200D-2640",
              image: "1f64d-1f3fe-200d-2640-fe0f.png",
              sheet_x: 33,
              sheet_y: 22,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F64D-1F3FF-200D-2640-FE0F",
              non_qualified: "1F64D-1F3FF-200D-2640",
              image: "1f64d-1f3ff-200d-2640-fe0f.png",
              sheet_x: 33,
              sheet_y: 23,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F64D",
          a: "Woman Frowning",
          b: "1F64D-200D-2640-FE0F",
          c: "1F64D-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [33, 18]
        },
        "flag-rw": {
          a: "Rwanda Flag",
          b: "1F1F7-1F1FC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 20]
        },
        comet: {
          a: "Comet",
          b: "2604-FE0F",
          c: "2604",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["space"],
          k: [47, 20],
          o: 1
        },
        person_with_pouting_face: {
          skin_variations: {
            "1F3FB": {
              unified: "1F64E-1F3FB",
              non_qualified: null,
              image: "1f64e-1f3fb.png",
              sheet_x: 33,
              sheet_y: 49,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F64E-1F3FC",
              non_qualified: null,
              image: "1f64e-1f3fc.png",
              sheet_x: 33,
              sheet_y: 50,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F64E-1F3FD",
              non_qualified: null,
              image: "1f64e-1f3fd.png",
              sheet_x: 33,
              sheet_y: 51,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F64E-1F3FE",
              non_qualified: null,
              image: "1f64e-1f3fe.png",
              sheet_x: 34,
              sheet_y: 0,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F64E-1F3FF",
              non_qualified: null,
              image: "1f64e-1f3ff.png",
              sheet_x: 34,
              sheet_y: 1,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            }
          },
          obsoleted_by: "1F64E-200D-2640-FE0F",
          a: "Person with Pouting Face",
          b: "1F64E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          k: [33, 48]
        },
        red_circle: {
          a: "Large Red Circle",
          b: "1F534",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shape", "error", "danger"],
          k: [28, 2]
        },
        large_blue_circle: {
          a: "Large Blue Circle",
          b: "1F535",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shape", "icon", "button"],
          k: [28, 3]
        },
        "man-pouting": {
          skin_variations: {
            "1F3FB": {
              unified: "1F64E-1F3FB-200D-2642-FE0F",
              non_qualified: "1F64E-1F3FB-200D-2642",
              image: "1f64e-1f3fb-200d-2642-fe0f.png",
              sheet_x: 33,
              sheet_y: 43,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F64E-1F3FC-200D-2642-FE0F",
              non_qualified: "1F64E-1F3FC-200D-2642",
              image: "1f64e-1f3fc-200d-2642-fe0f.png",
              sheet_x: 33,
              sheet_y: 44,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F64E-1F3FD-200D-2642-FE0F",
              non_qualified: "1F64E-1F3FD-200D-2642",
              image: "1f64e-1f3fd-200d-2642-fe0f.png",
              sheet_x: 33,
              sheet_y: 45,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F64E-1F3FE-200D-2642-FE0F",
              non_qualified: "1F64E-1F3FE-200D-2642",
              image: "1f64e-1f3fe-200d-2642-fe0f.png",
              sheet_x: 33,
              sheet_y: 46,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F64E-1F3FF-200D-2642-FE0F",
              non_qualified: "1F64E-1F3FF-200D-2642",
              image: "1f64e-1f3ff-200d-2642-fe0f.png",
              sheet_x: 33,
              sheet_y: 47,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Man Pouting",
          b: "1F64E-200D-2642-FE0F",
          c: "1F64E-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [33, 42]
        },
        "flag-sa": {
          a: "Saudi Arabia Flag",
          b: "1F1F8-1F1E6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 21]
        },
        fire: {
          a: "Fire",
          b: "1F525",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["hot", "cook", "flame"],
          k: [27, 39]
        },
        "woman-pouting": {
          skin_variations: {
            "1F3FB": {
              unified: "1F64E-1F3FB-200D-2640-FE0F",
              non_qualified: "1F64E-1F3FB-200D-2640",
              image: "1f64e-1f3fb-200d-2640-fe0f.png",
              sheet_x: 33,
              sheet_y: 37,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F64E-1F3FC-200D-2640-FE0F",
              non_qualified: "1F64E-1F3FC-200D-2640",
              image: "1f64e-1f3fc-200d-2640-fe0f.png",
              sheet_x: 33,
              sheet_y: 38,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F64E-1F3FD-200D-2640-FE0F",
              non_qualified: "1F64E-1F3FD-200D-2640",
              image: "1f64e-1f3fd-200d-2640-fe0f.png",
              sheet_x: 33,
              sheet_y: 39,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F64E-1F3FE-200D-2640-FE0F",
              non_qualified: "1F64E-1F3FE-200D-2640",
              image: "1f64e-1f3fe-200d-2640-fe0f.png",
              sheet_x: 33,
              sheet_y: 40,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F64E-1F3FF-200D-2640-FE0F",
              non_qualified: "1F64E-1F3FF-200D-2640",
              image: "1f64e-1f3ff-200d-2640-fe0f.png",
              sheet_x: 33,
              sheet_y: 41,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F64E",
          a: "Woman Pouting",
          b: "1F64E-200D-2640-FE0F",
          c: "1F64E-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [33, 36]
        },
        "flag-sb": {
          a: "Solomon Islands Flag",
          b: "1F1F8-1F1E7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 22]
        },
        droplet: {
          a: "Droplet",
          b: "1F4A7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["water", "drip", "faucet", "spring"],
          k: [25, 13]
        },
        no_good: {
          skin_variations: {
            "1F3FB": {
              unified: "1F645-1F3FB",
              non_qualified: null,
              image: "1f645-1f3fb.png",
              sheet_x: 32,
              sheet_y: 2,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F645-1F3FC",
              non_qualified: null,
              image: "1f645-1f3fc.png",
              sheet_x: 32,
              sheet_y: 3,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F645-1F3FD",
              non_qualified: null,
              image: "1f645-1f3fd.png",
              sheet_x: 32,
              sheet_y: 4,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F645-1F3FE",
              non_qualified: null,
              image: "1f645-1f3fe.png",
              sheet_x: 32,
              sheet_y: 5,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F645-1F3FF",
              non_qualified: null,
              image: "1f645-1f3ff.png",
              sheet_x: 32,
              sheet_y: 6,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            }
          },
          obsoleted_by: "1F645-200D-2640-FE0F",
          a: "Face with No Good Gesture",
          b: "1F645",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          k: [32, 1]
        },
        "flag-sc": {
          a: "Seychelles Flag",
          b: "1F1F8-1F1E8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 23]
        },
        ocean: {
          a: "Water Wave",
          b: "1F30A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sea", "water", "wave", "nature", "tsunami", "disaster"],
          k: [6, 2]
        },
        "man-gesturing-no": {
          skin_variations: {
            "1F3FB": {
              unified: "1F645-1F3FB-200D-2642-FE0F",
              non_qualified: "1F645-1F3FB-200D-2642",
              image: "1f645-1f3fb-200d-2642-fe0f.png",
              sheet_x: 31,
              sheet_y: 48,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F645-1F3FC-200D-2642-FE0F",
              non_qualified: "1F645-1F3FC-200D-2642",
              image: "1f645-1f3fc-200d-2642-fe0f.png",
              sheet_x: 31,
              sheet_y: 49,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F645-1F3FD-200D-2642-FE0F",
              non_qualified: "1F645-1F3FD-200D-2642",
              image: "1f645-1f3fd-200d-2642-fe0f.png",
              sheet_x: 31,
              sheet_y: 50,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F645-1F3FE-200D-2642-FE0F",
              non_qualified: "1F645-1F3FE-200D-2642",
              image: "1f645-1f3fe-200d-2642-fe0f.png",
              sheet_x: 31,
              sheet_y: 51,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F645-1F3FF-200D-2642-FE0F",
              non_qualified: "1F645-1F3FF-200D-2642",
              image: "1f645-1f3ff-200d-2642-fe0f.png",
              sheet_x: 32,
              sheet_y: 0,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Man Gesturing No",
          b: "1F645-200D-2642-FE0F",
          c: "1F645-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [31, 47]
        },
        "flag-sd": {
          a: "Sudan Flag",
          b: "1F1F8-1F1E9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 24]
        },
        "woman-gesturing-no": {
          skin_variations: {
            "1F3FB": {
              unified: "1F645-1F3FB-200D-2640-FE0F",
              non_qualified: "1F645-1F3FB-200D-2640",
              image: "1f645-1f3fb-200d-2640-fe0f.png",
              sheet_x: 31,
              sheet_y: 42,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F645-1F3FC-200D-2640-FE0F",
              non_qualified: "1F645-1F3FC-200D-2640",
              image: "1f645-1f3fc-200d-2640-fe0f.png",
              sheet_x: 31,
              sheet_y: 43,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F645-1F3FD-200D-2640-FE0F",
              non_qualified: "1F645-1F3FD-200D-2640",
              image: "1f645-1f3fd-200d-2640-fe0f.png",
              sheet_x: 31,
              sheet_y: 44,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F645-1F3FE-200D-2640-FE0F",
              non_qualified: "1F645-1F3FE-200D-2640",
              image: "1f645-1f3fe-200d-2640-fe0f.png",
              sheet_x: 31,
              sheet_y: 45,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F645-1F3FF-200D-2640-FE0F",
              non_qualified: "1F645-1F3FF-200D-2640",
              image: "1f645-1f3ff-200d-2640-fe0f.png",
              sheet_x: 31,
              sheet_y: 46,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F645",
          a: "Woman Gesturing No",
          b: "1F645-200D-2640-FE0F",
          c: "1F645-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [31, 41]
        },
        "flag-se": {
          a: "Sweden Flag",
          b: "1F1F8-1F1EA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 25]
        },
        "flag-sg": {
          a: "Singapore Flag",
          b: "1F1F8-1F1EC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 26]
        },
        ok_woman: {
          skin_variations: {
            "1F3FB": {
              unified: "1F646-1F3FB",
              non_qualified: null,
              image: "1f646-1f3fb.png",
              sheet_x: 32,
              sheet_y: 20,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F646-1F3FC",
              non_qualified: null,
              image: "1f646-1f3fc.png",
              sheet_x: 32,
              sheet_y: 21,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F646-1F3FD",
              non_qualified: null,
              image: "1f646-1f3fd.png",
              sheet_x: 32,
              sheet_y: 22,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F646-1F3FE",
              non_qualified: null,
              image: "1f646-1f3fe.png",
              sheet_x: 32,
              sheet_y: 23,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F646-1F3FF",
              non_qualified: null,
              image: "1f646-1f3ff.png",
              sheet_x: 32,
              sheet_y: 24,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            }
          },
          obsoleted_by: "1F646-200D-2640-FE0F",
          a: "Face with Ok Gesture",
          b: "1F646",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          j: ["women", "girl", "female", "pink", "human", "woman"],
          k: [32, 19]
        },
        "flag-sh": {
          a: "St. Helena Flag",
          b: "1F1F8-1F1ED",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 27]
        },
        "man-gesturing-ok": {
          skin_variations: {
            "1F3FB": {
              unified: "1F646-1F3FB-200D-2642-FE0F",
              non_qualified: "1F646-1F3FB-200D-2642",
              image: "1f646-1f3fb-200d-2642-fe0f.png",
              sheet_x: 32,
              sheet_y: 14,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F646-1F3FC-200D-2642-FE0F",
              non_qualified: "1F646-1F3FC-200D-2642",
              image: "1f646-1f3fc-200d-2642-fe0f.png",
              sheet_x: 32,
              sheet_y: 15,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F646-1F3FD-200D-2642-FE0F",
              non_qualified: "1F646-1F3FD-200D-2642",
              image: "1f646-1f3fd-200d-2642-fe0f.png",
              sheet_x: 32,
              sheet_y: 16,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F646-1F3FE-200D-2642-FE0F",
              non_qualified: "1F646-1F3FE-200D-2642",
              image: "1f646-1f3fe-200d-2642-fe0f.png",
              sheet_x: 32,
              sheet_y: 17,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F646-1F3FF-200D-2642-FE0F",
              non_qualified: "1F646-1F3FF-200D-2642",
              image: "1f646-1f3ff-200d-2642-fe0f.png",
              sheet_x: 32,
              sheet_y: 18,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Man Gesturing Ok",
          b: "1F646-200D-2642-FE0F",
          c: "1F646-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [32, 13]
        },
        "flag-si": {
          a: "Slovenia Flag",
          b: "1F1F8-1F1EE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 28]
        },
        "woman-gesturing-ok": {
          skin_variations: {
            "1F3FB": {
              unified: "1F646-1F3FB-200D-2640-FE0F",
              non_qualified: "1F646-1F3FB-200D-2640",
              image: "1f646-1f3fb-200d-2640-fe0f.png",
              sheet_x: 32,
              sheet_y: 8,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F646-1F3FC-200D-2640-FE0F",
              non_qualified: "1F646-1F3FC-200D-2640",
              image: "1f646-1f3fc-200d-2640-fe0f.png",
              sheet_x: 32,
              sheet_y: 9,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F646-1F3FD-200D-2640-FE0F",
              non_qualified: "1F646-1F3FD-200D-2640",
              image: "1f646-1f3fd-200d-2640-fe0f.png",
              sheet_x: 32,
              sheet_y: 10,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F646-1F3FE-200D-2640-FE0F",
              non_qualified: "1F646-1F3FE-200D-2640",
              image: "1f646-1f3fe-200d-2640-fe0f.png",
              sheet_x: 32,
              sheet_y: 11,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F646-1F3FF-200D-2640-FE0F",
              non_qualified: "1F646-1F3FF-200D-2640",
              image: "1f646-1f3ff-200d-2640-fe0f.png",
              sheet_x: 32,
              sheet_y: 12,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F646",
          a: "Woman Gesturing Ok",
          b: "1F646-200D-2640-FE0F",
          c: "1F646-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [32, 7]
        },
        information_desk_person: {
          skin_variations: {
            "1F3FB": {
              unified: "1F481-1F3FB",
              non_qualified: null,
              image: "1f481-1f3fb.png",
              sheet_x: 23,
              sheet_y: 14,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F481-1F3FC",
              non_qualified: null,
              image: "1f481-1f3fc.png",
              sheet_x: 23,
              sheet_y: 15,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F481-1F3FD",
              non_qualified: null,
              image: "1f481-1f3fd.png",
              sheet_x: 23,
              sheet_y: 16,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F481-1F3FE",
              non_qualified: null,
              image: "1f481-1f3fe.png",
              sheet_x: 23,
              sheet_y: 17,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F481-1F3FF",
              non_qualified: null,
              image: "1f481-1f3ff.png",
              sheet_x: 23,
              sheet_y: 18,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            }
          },
          obsoleted_by: "1F481-200D-2640-FE0F",
          a: "Information Desk Person",
          b: "1F481",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          k: [23, 13]
        },
        "flag-sj": {
          a: "Svalbard & Jan Mayen Flag",
          b: "1F1F8-1F1EF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 29]
        },
        "man-tipping-hand": {
          skin_variations: {
            "1F3FB": {
              unified: "1F481-1F3FB-200D-2642-FE0F",
              non_qualified: "1F481-1F3FB-200D-2642",
              image: "1f481-1f3fb-200d-2642-fe0f.png",
              sheet_x: 23,
              sheet_y: 8,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F481-1F3FC-200D-2642-FE0F",
              non_qualified: "1F481-1F3FC-200D-2642",
              image: "1f481-1f3fc-200d-2642-fe0f.png",
              sheet_x: 23,
              sheet_y: 9,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F481-1F3FD-200D-2642-FE0F",
              non_qualified: "1F481-1F3FD-200D-2642",
              image: "1f481-1f3fd-200d-2642-fe0f.png",
              sheet_x: 23,
              sheet_y: 10,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F481-1F3FE-200D-2642-FE0F",
              non_qualified: "1F481-1F3FE-200D-2642",
              image: "1f481-1f3fe-200d-2642-fe0f.png",
              sheet_x: 23,
              sheet_y: 11,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F481-1F3FF-200D-2642-FE0F",
              non_qualified: "1F481-1F3FF-200D-2642",
              image: "1f481-1f3ff-200d-2642-fe0f.png",
              sheet_x: 23,
              sheet_y: 12,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Man Tipping Hand",
          b: "1F481-200D-2642-FE0F",
          c: "1F481-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [23, 7]
        },
        "flag-sk": {
          a: "Slovakia Flag",
          b: "1F1F8-1F1F0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 30]
        },
        "flag-sl": {
          a: "Sierra Leone Flag",
          b: "1F1F8-1F1F1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 31]
        },
        "woman-tipping-hand": {
          skin_variations: {
            "1F3FB": {
              unified: "1F481-1F3FB-200D-2640-FE0F",
              non_qualified: "1F481-1F3FB-200D-2640",
              image: "1f481-1f3fb-200d-2640-fe0f.png",
              sheet_x: 23,
              sheet_y: 2,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F481-1F3FC-200D-2640-FE0F",
              non_qualified: "1F481-1F3FC-200D-2640",
              image: "1f481-1f3fc-200d-2640-fe0f.png",
              sheet_x: 23,
              sheet_y: 3,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F481-1F3FD-200D-2640-FE0F",
              non_qualified: "1F481-1F3FD-200D-2640",
              image: "1f481-1f3fd-200d-2640-fe0f.png",
              sheet_x: 23,
              sheet_y: 4,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F481-1F3FE-200D-2640-FE0F",
              non_qualified: "1F481-1F3FE-200D-2640",
              image: "1f481-1f3fe-200d-2640-fe0f.png",
              sheet_x: 23,
              sheet_y: 5,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F481-1F3FF-200D-2640-FE0F",
              non_qualified: "1F481-1F3FF-200D-2640",
              image: "1f481-1f3ff-200d-2640-fe0f.png",
              sheet_x: 23,
              sheet_y: 6,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F481",
          a: "Woman Tipping Hand",
          b: "1F481-200D-2640-FE0F",
          c: "1F481-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [23, 1]
        },
        "flag-sm": {
          a: "San Marino Flag",
          b: "1F1F8-1F1F2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 32]
        },
        raising_hand: {
          skin_variations: {
            "1F3FB": {
              unified: "1F64B-1F3FB",
              non_qualified: null,
              image: "1f64b-1f3fb.png",
              sheet_x: 33,
              sheet_y: 7,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F64B-1F3FC",
              non_qualified: null,
              image: "1f64b-1f3fc.png",
              sheet_x: 33,
              sheet_y: 8,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F64B-1F3FD",
              non_qualified: null,
              image: "1f64b-1f3fd.png",
              sheet_x: 33,
              sheet_y: 9,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F64B-1F3FE",
              non_qualified: null,
              image: "1f64b-1f3fe.png",
              sheet_x: 33,
              sheet_y: 10,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F64B-1F3FF",
              non_qualified: null,
              image: "1f64b-1f3ff.png",
              sheet_x: 33,
              sheet_y: 11,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            }
          },
          obsoleted_by: "1F64B-200D-2640-FE0F",
          a: "Happy Person Raising One Hand",
          b: "1F64B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          k: [33, 6]
        },
        "flag-sn": {
          a: "Senegal Flag",
          b: "1F1F8-1F1F3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 33]
        },
        "man-raising-hand": {
          skin_variations: {
            "1F3FB": {
              unified: "1F64B-1F3FB-200D-2642-FE0F",
              non_qualified: "1F64B-1F3FB-200D-2642",
              image: "1f64b-1f3fb-200d-2642-fe0f.png",
              sheet_x: 33,
              sheet_y: 1,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F64B-1F3FC-200D-2642-FE0F",
              non_qualified: "1F64B-1F3FC-200D-2642",
              image: "1f64b-1f3fc-200d-2642-fe0f.png",
              sheet_x: 33,
              sheet_y: 2,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F64B-1F3FD-200D-2642-FE0F",
              non_qualified: "1F64B-1F3FD-200D-2642",
              image: "1f64b-1f3fd-200d-2642-fe0f.png",
              sheet_x: 33,
              sheet_y: 3,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F64B-1F3FE-200D-2642-FE0F",
              non_qualified: "1F64B-1F3FE-200D-2642",
              image: "1f64b-1f3fe-200d-2642-fe0f.png",
              sheet_x: 33,
              sheet_y: 4,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F64B-1F3FF-200D-2642-FE0F",
              non_qualified: "1F64B-1F3FF-200D-2642",
              image: "1f64b-1f3ff-200d-2642-fe0f.png",
              sheet_x: 33,
              sheet_y: 5,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Man Raising Hand",
          b: "1F64B-200D-2642-FE0F",
          c: "1F64B-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [33, 0]
        },
        "flag-so": {
          a: "Somalia Flag",
          b: "1F1F8-1F1F4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 34]
        },
        "woman-raising-hand": {
          skin_variations: {
            "1F3FB": {
              unified: "1F64B-1F3FB-200D-2640-FE0F",
              non_qualified: "1F64B-1F3FB-200D-2640",
              image: "1f64b-1f3fb-200d-2640-fe0f.png",
              sheet_x: 32,
              sheet_y: 47,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F64B-1F3FC-200D-2640-FE0F",
              non_qualified: "1F64B-1F3FC-200D-2640",
              image: "1f64b-1f3fc-200d-2640-fe0f.png",
              sheet_x: 32,
              sheet_y: 48,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F64B-1F3FD-200D-2640-FE0F",
              non_qualified: "1F64B-1F3FD-200D-2640",
              image: "1f64b-1f3fd-200d-2640-fe0f.png",
              sheet_x: 32,
              sheet_y: 49,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F64B-1F3FE-200D-2640-FE0F",
              non_qualified: "1F64B-1F3FE-200D-2640",
              image: "1f64b-1f3fe-200d-2640-fe0f.png",
              sheet_x: 32,
              sheet_y: 50,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F64B-1F3FF-200D-2640-FE0F",
              non_qualified: "1F64B-1F3FF-200D-2640",
              image: "1f64b-1f3ff-200d-2640-fe0f.png",
              sheet_x: 32,
              sheet_y: 51,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F64B",
          a: "Woman Raising Hand",
          b: "1F64B-200D-2640-FE0F",
          c: "1F64B-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [32, 46]
        },
        "flag-sr": {
          a: "Suriname Flag",
          b: "1F1F8-1F1F7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 35]
        },
        bow: {
          skin_variations: {
            "1F3FB": {
              unified: "1F647-1F3FB",
              non_qualified: null,
              image: "1f647-1f3fb.png",
              sheet_x: 32,
              sheet_y: 38,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F647-1F3FC",
              non_qualified: null,
              image: "1f647-1f3fc.png",
              sheet_x: 32,
              sheet_y: 39,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F647-1F3FD",
              non_qualified: null,
              image: "1f647-1f3fd.png",
              sheet_x: 32,
              sheet_y: 40,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F647-1F3FE",
              non_qualified: null,
              image: "1f647-1f3fe.png",
              sheet_x: 32,
              sheet_y: 41,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F647-1F3FF",
              non_qualified: null,
              image: "1f647-1f3ff.png",
              sheet_x: 32,
              sheet_y: 42,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            }
          },
          obsoleted_by: "1F647-200D-2642-FE0F",
          a: "Person Bowing Deeply",
          b: "1F647",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          k: [32, 37]
        },
        "man-bowing": {
          skin_variations: {
            "1F3FB": {
              unified: "1F647-1F3FB-200D-2642-FE0F",
              non_qualified: "1F647-1F3FB-200D-2642",
              image: "1f647-1f3fb-200d-2642-fe0f.png",
              sheet_x: 32,
              sheet_y: 32,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F647-1F3FC-200D-2642-FE0F",
              non_qualified: "1F647-1F3FC-200D-2642",
              image: "1f647-1f3fc-200d-2642-fe0f.png",
              sheet_x: 32,
              sheet_y: 33,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F647-1F3FD-200D-2642-FE0F",
              non_qualified: "1F647-1F3FD-200D-2642",
              image: "1f647-1f3fd-200d-2642-fe0f.png",
              sheet_x: 32,
              sheet_y: 34,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F647-1F3FE-200D-2642-FE0F",
              non_qualified: "1F647-1F3FE-200D-2642",
              image: "1f647-1f3fe-200d-2642-fe0f.png",
              sheet_x: 32,
              sheet_y: 35,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F647-1F3FF-200D-2642-FE0F",
              non_qualified: "1F647-1F3FF-200D-2642",
              image: "1f647-1f3ff-200d-2642-fe0f.png",
              sheet_x: 32,
              sheet_y: 36,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F647",
          a: "Man Bowing",
          b: "1F647-200D-2642-FE0F",
          c: "1F647-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [32, 31]
        },
        "flag-ss": {
          a: "South Sudan Flag",
          b: "1F1F8-1F1F8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 36]
        },
        "woman-bowing": {
          skin_variations: {
            "1F3FB": {
              unified: "1F647-1F3FB-200D-2640-FE0F",
              non_qualified: "1F647-1F3FB-200D-2640",
              image: "1f647-1f3fb-200d-2640-fe0f.png",
              sheet_x: 32,
              sheet_y: 26,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F647-1F3FC-200D-2640-FE0F",
              non_qualified: "1F647-1F3FC-200D-2640",
              image: "1f647-1f3fc-200d-2640-fe0f.png",
              sheet_x: 32,
              sheet_y: 27,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F647-1F3FD-200D-2640-FE0F",
              non_qualified: "1F647-1F3FD-200D-2640",
              image: "1f647-1f3fd-200d-2640-fe0f.png",
              sheet_x: 32,
              sheet_y: 28,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F647-1F3FE-200D-2640-FE0F",
              non_qualified: "1F647-1F3FE-200D-2640",
              image: "1f647-1f3fe-200d-2640-fe0f.png",
              sheet_x: 32,
              sheet_y: 29,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F647-1F3FF-200D-2640-FE0F",
              non_qualified: "1F647-1F3FF-200D-2640",
              image: "1f647-1f3ff-200d-2640-fe0f.png",
              sheet_x: 32,
              sheet_y: 30,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Woman Bowing",
          b: "1F647-200D-2640-FE0F",
          c: "1F647-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [32, 25]
        },
        "flag-st": {
          a: "S\xe3o Tom\xe9 & Pr\xedncipe Flag",
          b: "1F1F8-1F1F9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 37]
        },
        face_palm: {
          skin_variations: {
            "1F3FB": {
              unified: "1F926-1F3FB",
              non_qualified: null,
              image: "1f926-1f3fb.png",
              sheet_x: 38,
              sheet_y: 42,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F926-1F3FC",
              non_qualified: null,
              image: "1f926-1f3fc.png",
              sheet_x: 38,
              sheet_y: 43,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F926-1F3FD",
              non_qualified: null,
              image: "1f926-1f3fd.png",
              sheet_x: 38,
              sheet_y: 44,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F926-1F3FE",
              non_qualified: null,
              image: "1f926-1f3fe.png",
              sheet_x: 38,
              sheet_y: 45,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F926-1F3FF",
              non_qualified: null,
              image: "1f926-1f3ff.png",
              sheet_x: 38,
              sheet_y: 46,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Face Palm",
          b: "1F926",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          k: [38, 41],
          o: 9
        },
        "flag-sv": {
          a: "El Salvador Flag",
          b: "1F1F8-1F1FB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 38]
        },
        "man-facepalming": {
          skin_variations: {
            "1F3FB": {
              unified: "1F926-1F3FB-200D-2642-FE0F",
              non_qualified: "1F926-1F3FB-200D-2642",
              image: "1f926-1f3fb-200d-2642-fe0f.png",
              sheet_x: 38,
              sheet_y: 36,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F926-1F3FC-200D-2642-FE0F",
              non_qualified: "1F926-1F3FC-200D-2642",
              image: "1f926-1f3fc-200d-2642-fe0f.png",
              sheet_x: 38,
              sheet_y: 37,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F926-1F3FD-200D-2642-FE0F",
              non_qualified: "1F926-1F3FD-200D-2642",
              image: "1f926-1f3fd-200d-2642-fe0f.png",
              sheet_x: 38,
              sheet_y: 38,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F926-1F3FE-200D-2642-FE0F",
              non_qualified: "1F926-1F3FE-200D-2642",
              image: "1f926-1f3fe-200d-2642-fe0f.png",
              sheet_x: 38,
              sheet_y: 39,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F926-1F3FF-200D-2642-FE0F",
              non_qualified: "1F926-1F3FF-200D-2642",
              image: "1f926-1f3ff-200d-2642-fe0f.png",
              sheet_x: 38,
              sheet_y: 40,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Man Facepalming",
          b: "1F926-200D-2642-FE0F",
          c: "1F926-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [38, 35],
          o: 9
        },
        "flag-sx": {
          a: "Sint Maarten Flag",
          b: "1F1F8-1F1FD",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 39]
        },
        "flag-sy": {
          a: "Syria Flag",
          b: "1F1F8-1F1FE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 40]
        },
        "woman-facepalming": {
          skin_variations: {
            "1F3FB": {
              unified: "1F926-1F3FB-200D-2640-FE0F",
              non_qualified: "1F926-1F3FB-200D-2640",
              image: "1f926-1f3fb-200d-2640-fe0f.png",
              sheet_x: 38,
              sheet_y: 30,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F926-1F3FC-200D-2640-FE0F",
              non_qualified: "1F926-1F3FC-200D-2640",
              image: "1f926-1f3fc-200d-2640-fe0f.png",
              sheet_x: 38,
              sheet_y: 31,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F926-1F3FD-200D-2640-FE0F",
              non_qualified: "1F926-1F3FD-200D-2640",
              image: "1f926-1f3fd-200d-2640-fe0f.png",
              sheet_x: 38,
              sheet_y: 32,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F926-1F3FE-200D-2640-FE0F",
              non_qualified: "1F926-1F3FE-200D-2640",
              image: "1f926-1f3fe-200d-2640-fe0f.png",
              sheet_x: 38,
              sheet_y: 33,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F926-1F3FF-200D-2640-FE0F",
              non_qualified: "1F926-1F3FF-200D-2640",
              image: "1f926-1f3ff-200d-2640-fe0f.png",
              sheet_x: 38,
              sheet_y: 34,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Woman Facepalming",
          b: "1F926-200D-2640-FE0F",
          c: "1F926-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [38, 29],
          o: 9
        },
        shrug: {
          skin_variations: {
            "1F3FB": {
              unified: "1F937-1F3FB",
              non_qualified: null,
              image: "1f937-1f3fb.png",
              sheet_x: 40,
              sheet_y: 7,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F937-1F3FC",
              non_qualified: null,
              image: "1f937-1f3fc.png",
              sheet_x: 40,
              sheet_y: 8,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F937-1F3FD",
              non_qualified: null,
              image: "1f937-1f3fd.png",
              sheet_x: 40,
              sheet_y: 9,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F937-1F3FE",
              non_qualified: null,
              image: "1f937-1f3fe.png",
              sheet_x: 40,
              sheet_y: 10,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F937-1F3FF",
              non_qualified: null,
              image: "1f937-1f3ff.png",
              sheet_x: 40,
              sheet_y: 11,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Shrug",
          b: "1F937",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          k: [40, 6],
          o: 9
        },
        "flag-sz": {
          a: "Swaziland Flag",
          b: "1F1F8-1F1FF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 41]
        },
        "flag-ta": {
          a: "Tristan Da Cunha Flag",
          b: "1F1F9-1F1E6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 42]
        },
        "man-shrugging": {
          skin_variations: {
            "1F3FB": {
              unified: "1F937-1F3FB-200D-2642-FE0F",
              non_qualified: "1F937-1F3FB-200D-2642",
              image: "1f937-1f3fb-200d-2642-fe0f.png",
              sheet_x: 40,
              sheet_y: 1,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F937-1F3FC-200D-2642-FE0F",
              non_qualified: "1F937-1F3FC-200D-2642",
              image: "1f937-1f3fc-200d-2642-fe0f.png",
              sheet_x: 40,
              sheet_y: 2,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F937-1F3FD-200D-2642-FE0F",
              non_qualified: "1F937-1F3FD-200D-2642",
              image: "1f937-1f3fd-200d-2642-fe0f.png",
              sheet_x: 40,
              sheet_y: 3,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F937-1F3FE-200D-2642-FE0F",
              non_qualified: "1F937-1F3FE-200D-2642",
              image: "1f937-1f3fe-200d-2642-fe0f.png",
              sheet_x: 40,
              sheet_y: 4,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F937-1F3FF-200D-2642-FE0F",
              non_qualified: "1F937-1F3FF-200D-2642",
              image: "1f937-1f3ff-200d-2642-fe0f.png",
              sheet_x: 40,
              sheet_y: 5,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Man Shrugging",
          b: "1F937-200D-2642-FE0F",
          c: "1F937-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [40, 0],
          o: 9
        },
        "woman-shrugging": {
          skin_variations: {
            "1F3FB": {
              unified: "1F937-1F3FB-200D-2640-FE0F",
              non_qualified: "1F937-1F3FB-200D-2640",
              image: "1f937-1f3fb-200d-2640-fe0f.png",
              sheet_x: 39,
              sheet_y: 47,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F937-1F3FC-200D-2640-FE0F",
              non_qualified: "1F937-1F3FC-200D-2640",
              image: "1f937-1f3fc-200d-2640-fe0f.png",
              sheet_x: 39,
              sheet_y: 48,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F937-1F3FD-200D-2640-FE0F",
              non_qualified: "1F937-1F3FD-200D-2640",
              image: "1f937-1f3fd-200d-2640-fe0f.png",
              sheet_x: 39,
              sheet_y: 49,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F937-1F3FE-200D-2640-FE0F",
              non_qualified: "1F937-1F3FE-200D-2640",
              image: "1f937-1f3fe-200d-2640-fe0f.png",
              sheet_x: 39,
              sheet_y: 50,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F937-1F3FF-200D-2640-FE0F",
              non_qualified: "1F937-1F3FF-200D-2640",
              image: "1f937-1f3ff-200d-2640-fe0f.png",
              sheet_x: 39,
              sheet_y: 51,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Woman Shrugging",
          b: "1F937-200D-2640-FE0F",
          c: "1F937-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [39, 46],
          o: 9
        },
        "flag-tc": {
          a: "Turks & Caicos Islands Flag",
          b: "1F1F9-1F1E8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 43]
        },
        massage: {
          skin_variations: {
            "1F3FB": {
              unified: "1F486-1F3FB",
              non_qualified: null,
              image: "1f486-1f3fb.png",
              sheet_x: 24,
              sheet_y: 11,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F486-1F3FC",
              non_qualified: null,
              image: "1f486-1f3fc.png",
              sheet_x: 24,
              sheet_y: 12,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F486-1F3FD",
              non_qualified: null,
              image: "1f486-1f3fd.png",
              sheet_x: 24,
              sheet_y: 13,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F486-1F3FE",
              non_qualified: null,
              image: "1f486-1f3fe.png",
              sheet_x: 24,
              sheet_y: 14,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F486-1F3FF",
              non_qualified: null,
              image: "1f486-1f3ff.png",
              sheet_x: 24,
              sheet_y: 15,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            }
          },
          obsoleted_by: "1F486-200D-2640-FE0F",
          a: "Face Massage",
          b: "1F486",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          k: [24, 10]
        },
        "flag-td": {
          a: "Chad Flag",
          b: "1F1F9-1F1E9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 44]
        },
        "man-getting-massage": {
          skin_variations: {
            "1F3FB": {
              unified: "1F486-1F3FB-200D-2642-FE0F",
              non_qualified: "1F486-1F3FB-200D-2642",
              image: "1f486-1f3fb-200d-2642-fe0f.png",
              sheet_x: 24,
              sheet_y: 5,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F486-1F3FC-200D-2642-FE0F",
              non_qualified: "1F486-1F3FC-200D-2642",
              image: "1f486-1f3fc-200d-2642-fe0f.png",
              sheet_x: 24,
              sheet_y: 6,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F486-1F3FD-200D-2642-FE0F",
              non_qualified: "1F486-1F3FD-200D-2642",
              image: "1f486-1f3fd-200d-2642-fe0f.png",
              sheet_x: 24,
              sheet_y: 7,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F486-1F3FE-200D-2642-FE0F",
              non_qualified: "1F486-1F3FE-200D-2642",
              image: "1f486-1f3fe-200d-2642-fe0f.png",
              sheet_x: 24,
              sheet_y: 8,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F486-1F3FF-200D-2642-FE0F",
              non_qualified: "1F486-1F3FF-200D-2642",
              image: "1f486-1f3ff-200d-2642-fe0f.png",
              sheet_x: 24,
              sheet_y: 9,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Man Getting Massage",
          b: "1F486-200D-2642-FE0F",
          c: "1F486-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [24, 4]
        },
        "flag-tf": {
          a: "French Southern Territories Flag",
          b: "1F1F9-1F1EB",
          d: !0,
          e: !1,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 45]
        },
        "woman-getting-massage": {
          skin_variations: {
            "1F3FB": {
              unified: "1F486-1F3FB-200D-2640-FE0F",
              non_qualified: "1F486-1F3FB-200D-2640",
              image: "1f486-1f3fb-200d-2640-fe0f.png",
              sheet_x: 23,
              sheet_y: 51,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F486-1F3FC-200D-2640-FE0F",
              non_qualified: "1F486-1F3FC-200D-2640",
              image: "1f486-1f3fc-200d-2640-fe0f.png",
              sheet_x: 24,
              sheet_y: 0,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F486-1F3FD-200D-2640-FE0F",
              non_qualified: "1F486-1F3FD-200D-2640",
              image: "1f486-1f3fd-200d-2640-fe0f.png",
              sheet_x: 24,
              sheet_y: 1,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F486-1F3FE-200D-2640-FE0F",
              non_qualified: "1F486-1F3FE-200D-2640",
              image: "1f486-1f3fe-200d-2640-fe0f.png",
              sheet_x: 24,
              sheet_y: 2,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F486-1F3FF-200D-2640-FE0F",
              non_qualified: "1F486-1F3FF-200D-2640",
              image: "1f486-1f3ff-200d-2640-fe0f.png",
              sheet_x: 24,
              sheet_y: 3,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F486",
          a: "Woman Getting Massage",
          b: "1F486-200D-2640-FE0F",
          c: "1F486-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [23, 50]
        },
        "flag-tg": {
          a: "Togo Flag",
          b: "1F1F9-1F1EC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 46]
        },
        haircut: {
          skin_variations: {
            "1F3FB": {
              unified: "1F487-1F3FB",
              non_qualified: null,
              image: "1f487-1f3fb.png",
              sheet_x: 24,
              sheet_y: 29,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F487-1F3FC",
              non_qualified: null,
              image: "1f487-1f3fc.png",
              sheet_x: 24,
              sheet_y: 30,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F487-1F3FD",
              non_qualified: null,
              image: "1f487-1f3fd.png",
              sheet_x: 24,
              sheet_y: 31,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F487-1F3FE",
              non_qualified: null,
              image: "1f487-1f3fe.png",
              sheet_x: 24,
              sheet_y: 32,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F487-1F3FF",
              non_qualified: null,
              image: "1f487-1f3ff.png",
              sheet_x: 24,
              sheet_y: 33,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            }
          },
          obsoleted_by: "1F487-200D-2640-FE0F",
          a: "Haircut",
          b: "1F487",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          k: [24, 28]
        },
        "flag-th": {
          a: "Thailand Flag",
          b: "1F1F9-1F1ED",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 47]
        },
        "man-getting-haircut": {
          skin_variations: {
            "1F3FB": {
              unified: "1F487-1F3FB-200D-2642-FE0F",
              non_qualified: "1F487-1F3FB-200D-2642",
              image: "1f487-1f3fb-200d-2642-fe0f.png",
              sheet_x: 24,
              sheet_y: 23,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F487-1F3FC-200D-2642-FE0F",
              non_qualified: "1F487-1F3FC-200D-2642",
              image: "1f487-1f3fc-200d-2642-fe0f.png",
              sheet_x: 24,
              sheet_y: 24,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F487-1F3FD-200D-2642-FE0F",
              non_qualified: "1F487-1F3FD-200D-2642",
              image: "1f487-1f3fd-200d-2642-fe0f.png",
              sheet_x: 24,
              sheet_y: 25,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F487-1F3FE-200D-2642-FE0F",
              non_qualified: "1F487-1F3FE-200D-2642",
              image: "1f487-1f3fe-200d-2642-fe0f.png",
              sheet_x: 24,
              sheet_y: 26,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F487-1F3FF-200D-2642-FE0F",
              non_qualified: "1F487-1F3FF-200D-2642",
              image: "1f487-1f3ff-200d-2642-fe0f.png",
              sheet_x: 24,
              sheet_y: 27,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Man Getting Haircut",
          b: "1F487-200D-2642-FE0F",
          c: "1F487-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [24, 22]
        },
        "flag-tj": {
          a: "Tajikistan Flag",
          b: "1F1F9-1F1EF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 48]
        },
        "flag-tk": {
          a: "Tokelau Flag",
          b: "1F1F9-1F1F0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 49]
        },
        "woman-getting-haircut": {
          skin_variations: {
            "1F3FB": {
              unified: "1F487-1F3FB-200D-2640-FE0F",
              non_qualified: "1F487-1F3FB-200D-2640",
              image: "1f487-1f3fb-200d-2640-fe0f.png",
              sheet_x: 24,
              sheet_y: 17,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F487-1F3FC-200D-2640-FE0F",
              non_qualified: "1F487-1F3FC-200D-2640",
              image: "1f487-1f3fc-200d-2640-fe0f.png",
              sheet_x: 24,
              sheet_y: 18,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F487-1F3FD-200D-2640-FE0F",
              non_qualified: "1F487-1F3FD-200D-2640",
              image: "1f487-1f3fd-200d-2640-fe0f.png",
              sheet_x: 24,
              sheet_y: 19,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F487-1F3FE-200D-2640-FE0F",
              non_qualified: "1F487-1F3FE-200D-2640",
              image: "1f487-1f3fe-200d-2640-fe0f.png",
              sheet_x: 24,
              sheet_y: 20,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F487-1F3FF-200D-2640-FE0F",
              non_qualified: "1F487-1F3FF-200D-2640",
              image: "1f487-1f3ff-200d-2640-fe0f.png",
              sheet_x: 24,
              sheet_y: 21,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F487",
          a: "Woman Getting Haircut",
          b: "1F487-200D-2640-FE0F",
          c: "1F487-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [24, 16]
        },
        walking: {
          skin_variations: {
            "1F3FB": {
              unified: "1F6B6-1F3FB",
              non_qualified: null,
              image: "1f6b6-1f3fb.png",
              sheet_x: 36,
              sheet_y: 22,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F6B6-1F3FC",
              non_qualified: null,
              image: "1f6b6-1f3fc.png",
              sheet_x: 36,
              sheet_y: 23,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F6B6-1F3FD",
              non_qualified: null,
              image: "1f6b6-1f3fd.png",
              sheet_x: 36,
              sheet_y: 24,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F6B6-1F3FE",
              non_qualified: null,
              image: "1f6b6-1f3fe.png",
              sheet_x: 36,
              sheet_y: 25,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F6B6-1F3FF",
              non_qualified: null,
              image: "1f6b6-1f3ff.png",
              sheet_x: 36,
              sheet_y: 26,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            }
          },
          obsoleted_by: "1F6B6-200D-2642-FE0F",
          a: "Pedestrian",
          b: "1F6B6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          k: [36, 21]
        },
        "flag-tl": {
          a: "Timor-Leste Flag",
          b: "1F1F9-1F1F1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 50]
        },
        "man-walking": {
          skin_variations: {
            "1F3FB": {
              unified: "1F6B6-1F3FB-200D-2642-FE0F",
              non_qualified: "1F6B6-1F3FB-200D-2642",
              image: "1f6b6-1f3fb-200d-2642-fe0f.png",
              sheet_x: 36,
              sheet_y: 16,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F6B6-1F3FC-200D-2642-FE0F",
              non_qualified: "1F6B6-1F3FC-200D-2642",
              image: "1f6b6-1f3fc-200d-2642-fe0f.png",
              sheet_x: 36,
              sheet_y: 17,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F6B6-1F3FD-200D-2642-FE0F",
              non_qualified: "1F6B6-1F3FD-200D-2642",
              image: "1f6b6-1f3fd-200d-2642-fe0f.png",
              sheet_x: 36,
              sheet_y: 18,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F6B6-1F3FE-200D-2642-FE0F",
              non_qualified: "1F6B6-1F3FE-200D-2642",
              image: "1f6b6-1f3fe-200d-2642-fe0f.png",
              sheet_x: 36,
              sheet_y: 19,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F6B6-1F3FF-200D-2642-FE0F",
              non_qualified: "1F6B6-1F3FF-200D-2642",
              image: "1f6b6-1f3ff-200d-2642-fe0f.png",
              sheet_x: 36,
              sheet_y: 20,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F6B6",
          a: "Man Walking",
          b: "1F6B6-200D-2642-FE0F",
          c: "1F6B6-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [36, 15]
        },
        "flag-tm": {
          a: "Turkmenistan Flag",
          b: "1F1F9-1F1F2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 51]
        },
        "woman-walking": {
          skin_variations: {
            "1F3FB": {
              unified: "1F6B6-1F3FB-200D-2640-FE0F",
              non_qualified: "1F6B6-1F3FB-200D-2640",
              image: "1f6b6-1f3fb-200d-2640-fe0f.png",
              sheet_x: 36,
              sheet_y: 10,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F6B6-1F3FC-200D-2640-FE0F",
              non_qualified: "1F6B6-1F3FC-200D-2640",
              image: "1f6b6-1f3fc-200d-2640-fe0f.png",
              sheet_x: 36,
              sheet_y: 11,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F6B6-1F3FD-200D-2640-FE0F",
              non_qualified: "1F6B6-1F3FD-200D-2640",
              image: "1f6b6-1f3fd-200d-2640-fe0f.png",
              sheet_x: 36,
              sheet_y: 12,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F6B6-1F3FE-200D-2640-FE0F",
              non_qualified: "1F6B6-1F3FE-200D-2640",
              image: "1f6b6-1f3fe-200d-2640-fe0f.png",
              sheet_x: 36,
              sheet_y: 13,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F6B6-1F3FF-200D-2640-FE0F",
              non_qualified: "1F6B6-1F3FF-200D-2640",
              image: "1f6b6-1f3ff-200d-2640-fe0f.png",
              sheet_x: 36,
              sheet_y: 14,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Woman Walking",
          b: "1F6B6-200D-2640-FE0F",
          c: "1F6B6-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [36, 9]
        },
        "flag-tn": {
          a: "Tunisia Flag",
          b: "1F1F9-1F1F3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 0]
        },
        runner: {
          skin_variations: {
            "1F3FB": {
              unified: "1F3C3-1F3FB",
              non_qualified: null,
              image: "1f3c3-1f3fb.png",
              sheet_x: 9,
              sheet_y: 47,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F3C3-1F3FC",
              non_qualified: null,
              image: "1f3c3-1f3fc.png",
              sheet_x: 9,
              sheet_y: 48,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F3C3-1F3FD",
              non_qualified: null,
              image: "1f3c3-1f3fd.png",
              sheet_x: 9,
              sheet_y: 49,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F3C3-1F3FE",
              non_qualified: null,
              image: "1f3c3-1f3fe.png",
              sheet_x: 9,
              sheet_y: 50,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F3C3-1F3FF",
              non_qualified: null,
              image: "1f3c3-1f3ff.png",
              sheet_x: 9,
              sheet_y: 51,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            }
          },
          obsoleted_by: "1F3C3-200D-2642-FE0F",
          a: "Runner",
          b: "1F3C3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          k: [9, 46],
          n: ["running"]
        },
        "flag-to": {
          a: "Tonga Flag",
          b: "1F1F9-1F1F4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 1]
        },
        "man-running": {
          skin_variations: {
            "1F3FB": {
              unified: "1F3C3-1F3FB-200D-2642-FE0F",
              non_qualified: "1F3C3-1F3FB-200D-2642",
              image: "1f3c3-1f3fb-200d-2642-fe0f.png",
              sheet_x: 9,
              sheet_y: 41,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F3C3-1F3FC-200D-2642-FE0F",
              non_qualified: "1F3C3-1F3FC-200D-2642",
              image: "1f3c3-1f3fc-200d-2642-fe0f.png",
              sheet_x: 9,
              sheet_y: 42,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F3C3-1F3FD-200D-2642-FE0F",
              non_qualified: "1F3C3-1F3FD-200D-2642",
              image: "1f3c3-1f3fd-200d-2642-fe0f.png",
              sheet_x: 9,
              sheet_y: 43,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F3C3-1F3FE-200D-2642-FE0F",
              non_qualified: "1F3C3-1F3FE-200D-2642",
              image: "1f3c3-1f3fe-200d-2642-fe0f.png",
              sheet_x: 9,
              sheet_y: 44,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F3C3-1F3FF-200D-2642-FE0F",
              non_qualified: "1F3C3-1F3FF-200D-2642",
              image: "1f3c3-1f3ff-200d-2642-fe0f.png",
              sheet_x: 9,
              sheet_y: 45,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F3C3",
          a: "Man Running",
          b: "1F3C3-200D-2642-FE0F",
          c: "1F3C3-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [9, 40]
        },
        "flag-tr": {
          a: "Turkey Flag",
          b: "1F1F9-1F1F7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 2]
        },
        "flag-tt": {
          a: "Trinidad & Tobago Flag",
          b: "1F1F9-1F1F9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 3]
        },
        "woman-running": {
          skin_variations: {
            "1F3FB": {
              unified: "1F3C3-1F3FB-200D-2640-FE0F",
              non_qualified: "1F3C3-1F3FB-200D-2640",
              image: "1f3c3-1f3fb-200d-2640-fe0f.png",
              sheet_x: 9,
              sheet_y: 35,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F3C3-1F3FC-200D-2640-FE0F",
              non_qualified: "1F3C3-1F3FC-200D-2640",
              image: "1f3c3-1f3fc-200d-2640-fe0f.png",
              sheet_x: 9,
              sheet_y: 36,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F3C3-1F3FD-200D-2640-FE0F",
              non_qualified: "1F3C3-1F3FD-200D-2640",
              image: "1f3c3-1f3fd-200d-2640-fe0f.png",
              sheet_x: 9,
              sheet_y: 37,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F3C3-1F3FE-200D-2640-FE0F",
              non_qualified: "1F3C3-1F3FE-200D-2640",
              image: "1f3c3-1f3fe-200d-2640-fe0f.png",
              sheet_x: 9,
              sheet_y: 38,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F3C3-1F3FF-200D-2640-FE0F",
              non_qualified: "1F3C3-1F3FF-200D-2640",
              image: "1f3c3-1f3ff-200d-2640-fe0f.png",
              sheet_x: 9,
              sheet_y: 39,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Woman Running",
          b: "1F3C3-200D-2640-FE0F",
          c: "1F3C3-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [9, 34]
        },
        "flag-tv": {
          a: "Tuvalu Flag",
          b: "1F1F9-1F1FB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 4]
        },
        dancer: {
          skin_variations: {
            "1F3FB": {
              unified: "1F483-1F3FB",
              non_qualified: null,
              image: "1f483-1f3fb.png",
              sheet_x: 23,
              sheet_y: 38,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F483-1F3FC",
              non_qualified: null,
              image: "1f483-1f3fc.png",
              sheet_x: 23,
              sheet_y: 39,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F483-1F3FD",
              non_qualified: null,
              image: "1f483-1f3fd.png",
              sheet_x: 23,
              sheet_y: 40,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F483-1F3FE",
              non_qualified: null,
              image: "1f483-1f3fe.png",
              sheet_x: 23,
              sheet_y: 41,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F483-1F3FF",
              non_qualified: null,
              image: "1f483-1f3ff.png",
              sheet_x: 23,
              sheet_y: 42,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Dancer",
          b: "1F483",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["female", "girl", "woman", "fun"],
          k: [23, 37]
        },
        "flag-tw": {
          a: "Taiwan Flag",
          b: "1F1F9-1F1FC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 5]
        },
        man_dancing: {
          skin_variations: {
            "1F3FB": {
              unified: "1F57A-1F3FB",
              non_qualified: null,
              image: "1f57a-1f3fb.png",
              sheet_x: 29,
              sheet_y: 22,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F57A-1F3FC",
              non_qualified: null,
              image: "1f57a-1f3fc.png",
              sheet_x: 29,
              sheet_y: 23,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F57A-1F3FD",
              non_qualified: null,
              image: "1f57a-1f3fd.png",
              sheet_x: 29,
              sheet_y: 24,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F57A-1F3FE",
              non_qualified: null,
              image: "1f57a-1f3fe.png",
              sheet_x: 29,
              sheet_y: 25,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F57A-1F3FF",
              non_qualified: null,
              image: "1f57a-1f3ff.png",
              sheet_x: 29,
              sheet_y: 26,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Man Dancing",
          b: "1F57A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["male", "boy", "fun", "dancer"],
          k: [29, 21],
          o: 9
        },
        dancers: {
          obsoleted_by: "1F46F-200D-2640-FE0F",
          a: "Woman with Bunny Ears",
          b: "1F46F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          k: [21, 1]
        },
        "flag-tz": {
          a: "Tanzania Flag",
          b: "1F1F9-1F1FF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 6]
        },
        "flag-ua": {
          a: "Ukraine Flag",
          b: "1F1FA-1F1E6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 7]
        },
        "man-with-bunny-ears-partying": {
          a: "Man with Bunny Ears Partying",
          b: "1F46F-200D-2642-FE0F",
          c: "1F46F-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [21, 0]
        },
        "woman-with-bunny-ears-partying": {
          obsoletes: "1F46F",
          a: "Woman with Bunny Ears Partying",
          b: "1F46F-200D-2640-FE0F",
          c: "1F46F-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [20, 51]
        },
        "flag-ug": {
          a: "Uganda Flag",
          b: "1F1FA-1F1EC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 8]
        },
        "flag-um": {
          a: "U.s. Outlying Islands Flag",
          b: "1F1FA-1F1F2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 9]
        },
        person_in_steamy_room: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9D6-1F3FB",
              non_qualified: null,
              image: "1f9d6-1f3fb.png",
              sheet_x: 43,
              sheet_y: 41,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9D6-1F3FB-200D-2642-FE0F"
            },
            "1F3FC": {
              unified: "1F9D6-1F3FC",
              non_qualified: null,
              image: "1f9d6-1f3fc.png",
              sheet_x: 43,
              sheet_y: 42,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9D6-1F3FC-200D-2642-FE0F"
            },
            "1F3FD": {
              unified: "1F9D6-1F3FD",
              non_qualified: null,
              image: "1f9d6-1f3fd.png",
              sheet_x: 43,
              sheet_y: 43,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9D6-1F3FD-200D-2642-FE0F"
            },
            "1F3FE": {
              unified: "1F9D6-1F3FE",
              non_qualified: null,
              image: "1f9d6-1f3fe.png",
              sheet_x: 43,
              sheet_y: 44,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9D6-1F3FE-200D-2642-FE0F"
            },
            "1F3FF": {
              unified: "1F9D6-1F3FF",
              non_qualified: null,
              image: "1f9d6-1f3ff.png",
              sheet_x: 43,
              sheet_y: 45,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9D6-1F3FF-200D-2642-FE0F"
            }
          },
          obsoleted_by: "1F9D6-200D-2642-FE0F",
          a: "Person in Steamy Room",
          b: "1F9D6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [43, 40],
          o: 10
        },
        woman_in_steamy_room: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9D6-1F3FB-200D-2640-FE0F",
              non_qualified: "1F9D6-1F3FB-200D-2640",
              image: "1f9d6-1f3fb-200d-2640-fe0f.png",
              sheet_x: 43,
              sheet_y: 29,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F9D6-1F3FC-200D-2640-FE0F",
              non_qualified: "1F9D6-1F3FC-200D-2640",
              image: "1f9d6-1f3fc-200d-2640-fe0f.png",
              sheet_x: 43,
              sheet_y: 30,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F9D6-1F3FD-200D-2640-FE0F",
              non_qualified: "1F9D6-1F3FD-200D-2640",
              image: "1f9d6-1f3fd-200d-2640-fe0f.png",
              sheet_x: 43,
              sheet_y: 31,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F9D6-1F3FE-200D-2640-FE0F",
              non_qualified: "1F9D6-1F3FE-200D-2640",
              image: "1f9d6-1f3fe-200d-2640-fe0f.png",
              sheet_x: 43,
              sheet_y: 32,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F9D6-1F3FF-200D-2640-FE0F",
              non_qualified: "1F9D6-1F3FF-200D-2640",
              image: "1f9d6-1f3ff-200d-2640-fe0f.png",
              sheet_x: 43,
              sheet_y: 33,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Woman in Steamy Room",
          b: "1F9D6-200D-2640-FE0F",
          c: "1F9D6-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [43, 28],
          o: 10
        },
        "flag-un": {
          a: "United Nations Flag",
          b: "1F1FA-1F1F3",
          d: !1,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [5, 10]
        },
        us: {
          a: "United States Flag",
          b: "1F1FA-1F1F8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["united", "states", "america", "flag", "nation", "country", "banner"],
          k: [5, 11],
          n: ["flag-us"]
        },
        man_in_steamy_room: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9D6-1F3FB-200D-2642-FE0F",
              non_qualified: "1F9D6-1F3FB-200D-2642",
              image: "1f9d6-1f3fb-200d-2642-fe0f.png",
              sheet_x: 43,
              sheet_y: 35,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9D6-1F3FB"
            },
            "1F3FC": {
              unified: "1F9D6-1F3FC-200D-2642-FE0F",
              non_qualified: "1F9D6-1F3FC-200D-2642",
              image: "1f9d6-1f3fc-200d-2642-fe0f.png",
              sheet_x: 43,
              sheet_y: 36,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9D6-1F3FC"
            },
            "1F3FD": {
              unified: "1F9D6-1F3FD-200D-2642-FE0F",
              non_qualified: "1F9D6-1F3FD-200D-2642",
              image: "1f9d6-1f3fd-200d-2642-fe0f.png",
              sheet_x: 43,
              sheet_y: 37,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9D6-1F3FD"
            },
            "1F3FE": {
              unified: "1F9D6-1F3FE-200D-2642-FE0F",
              non_qualified: "1F9D6-1F3FE-200D-2642",
              image: "1f9d6-1f3fe-200d-2642-fe0f.png",
              sheet_x: 43,
              sheet_y: 38,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9D6-1F3FE"
            },
            "1F3FF": {
              unified: "1F9D6-1F3FF-200D-2642-FE0F",
              non_qualified: "1F9D6-1F3FF-200D-2642",
              image: "1f9d6-1f3ff-200d-2642-fe0f.png",
              sheet_x: 43,
              sheet_y: 39,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9D6-1F3FF"
            }
          },
          obsoletes: "1F9D6",
          a: "Man in Steamy Room",
          b: "1F9D6-200D-2642-FE0F",
          c: "1F9D6-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [43, 34],
          o: 10
        },
        person_climbing: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9D7-1F3FB",
              non_qualified: null,
              image: "1f9d7-1f3fb.png",
              sheet_x: 44,
              sheet_y: 7,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9D7-1F3FB-200D-2640-FE0F"
            },
            "1F3FC": {
              unified: "1F9D7-1F3FC",
              non_qualified: null,
              image: "1f9d7-1f3fc.png",
              sheet_x: 44,
              sheet_y: 8,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9D7-1F3FC-200D-2640-FE0F"
            },
            "1F3FD": {
              unified: "1F9D7-1F3FD",
              non_qualified: null,
              image: "1f9d7-1f3fd.png",
              sheet_x: 44,
              sheet_y: 9,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9D7-1F3FD-200D-2640-FE0F"
            },
            "1F3FE": {
              unified: "1F9D7-1F3FE",
              non_qualified: null,
              image: "1f9d7-1f3fe.png",
              sheet_x: 44,
              sheet_y: 10,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9D7-1F3FE-200D-2640-FE0F"
            },
            "1F3FF": {
              unified: "1F9D7-1F3FF",
              non_qualified: null,
              image: "1f9d7-1f3ff.png",
              sheet_x: 44,
              sheet_y: 11,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9D7-1F3FF-200D-2640-FE0F"
            }
          },
          obsoleted_by: "1F9D7-200D-2640-FE0F",
          a: "Person Climbing",
          b: "1F9D7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [44, 6],
          o: 10
        },
        "flag-uy": {
          a: "Uruguay Flag",
          b: "1F1FA-1F1FE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 12]
        },
        woman_climbing: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9D7-1F3FB-200D-2640-FE0F",
              non_qualified: "1F9D7-1F3FB-200D-2640",
              image: "1f9d7-1f3fb-200d-2640-fe0f.png",
              sheet_x: 43,
              sheet_y: 47,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9D7-1F3FB"
            },
            "1F3FC": {
              unified: "1F9D7-1F3FC-200D-2640-FE0F",
              non_qualified: "1F9D7-1F3FC-200D-2640",
              image: "1f9d7-1f3fc-200d-2640-fe0f.png",
              sheet_x: 43,
              sheet_y: 48,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9D7-1F3FC"
            },
            "1F3FD": {
              unified: "1F9D7-1F3FD-200D-2640-FE0F",
              non_qualified: "1F9D7-1F3FD-200D-2640",
              image: "1f9d7-1f3fd-200d-2640-fe0f.png",
              sheet_x: 43,
              sheet_y: 49,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9D7-1F3FD"
            },
            "1F3FE": {
              unified: "1F9D7-1F3FE-200D-2640-FE0F",
              non_qualified: "1F9D7-1F3FE-200D-2640",
              image: "1f9d7-1f3fe-200d-2640-fe0f.png",
              sheet_x: 43,
              sheet_y: 50,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9D7-1F3FE"
            },
            "1F3FF": {
              unified: "1F9D7-1F3FF-200D-2640-FE0F",
              non_qualified: "1F9D7-1F3FF-200D-2640",
              image: "1f9d7-1f3ff-200d-2640-fe0f.png",
              sheet_x: 43,
              sheet_y: 51,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9D7-1F3FF"
            }
          },
          obsoletes: "1F9D7",
          a: "Woman Climbing",
          b: "1F9D7-200D-2640-FE0F",
          c: "1F9D7-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [43, 46],
          o: 10
        },
        "flag-uz": {
          a: "Uzbekistan Flag",
          b: "1F1FA-1F1FF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 13]
        },
        man_climbing: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9D7-1F3FB-200D-2642-FE0F",
              non_qualified: "1F9D7-1F3FB-200D-2642",
              image: "1f9d7-1f3fb-200d-2642-fe0f.png",
              sheet_x: 44,
              sheet_y: 1,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F9D7-1F3FC-200D-2642-FE0F",
              non_qualified: "1F9D7-1F3FC-200D-2642",
              image: "1f9d7-1f3fc-200d-2642-fe0f.png",
              sheet_x: 44,
              sheet_y: 2,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F9D7-1F3FD-200D-2642-FE0F",
              non_qualified: "1F9D7-1F3FD-200D-2642",
              image: "1f9d7-1f3fd-200d-2642-fe0f.png",
              sheet_x: 44,
              sheet_y: 3,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F9D7-1F3FE-200D-2642-FE0F",
              non_qualified: "1F9D7-1F3FE-200D-2642",
              image: "1f9d7-1f3fe-200d-2642-fe0f.png",
              sheet_x: 44,
              sheet_y: 4,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F9D7-1F3FF-200D-2642-FE0F",
              non_qualified: "1F9D7-1F3FF-200D-2642",
              image: "1f9d7-1f3ff-200d-2642-fe0f.png",
              sheet_x: 44,
              sheet_y: 5,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Man Climbing",
          b: "1F9D7-200D-2642-FE0F",
          c: "1F9D7-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [44, 0],
          o: 10
        },
        "flag-va": {
          a: "Vatican City Flag",
          b: "1F1FB-1F1E6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 14]
        },
        person_in_lotus_position: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9D8-1F3FB",
              non_qualified: null,
              image: "1f9d8-1f3fb.png",
              sheet_x: 44,
              sheet_y: 25,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9D8-1F3FB-200D-2640-FE0F"
            },
            "1F3FC": {
              unified: "1F9D8-1F3FC",
              non_qualified: null,
              image: "1f9d8-1f3fc.png",
              sheet_x: 44,
              sheet_y: 26,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9D8-1F3FC-200D-2640-FE0F"
            },
            "1F3FD": {
              unified: "1F9D8-1F3FD",
              non_qualified: null,
              image: "1f9d8-1f3fd.png",
              sheet_x: 44,
              sheet_y: 27,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9D8-1F3FD-200D-2640-FE0F"
            },
            "1F3FE": {
              unified: "1F9D8-1F3FE",
              non_qualified: null,
              image: "1f9d8-1f3fe.png",
              sheet_x: 44,
              sheet_y: 28,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9D8-1F3FE-200D-2640-FE0F"
            },
            "1F3FF": {
              unified: "1F9D8-1F3FF",
              non_qualified: null,
              image: "1f9d8-1f3ff.png",
              sheet_x: 44,
              sheet_y: 29,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9D8-1F3FF-200D-2640-FE0F"
            }
          },
          obsoleted_by: "1F9D8-200D-2640-FE0F",
          a: "Person in Lotus Position",
          b: "1F9D8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [44, 24],
          o: 10
        },
        "flag-vc": {
          a: "St. Vincent & Grenadines Flag",
          b: "1F1FB-1F1E8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 15]
        },
        "flag-ve": {
          a: "Venezuela Flag",
          b: "1F1FB-1F1EA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 16]
        },
        woman_in_lotus_position: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9D8-1F3FB-200D-2640-FE0F",
              non_qualified: "1F9D8-1F3FB-200D-2640",
              image: "1f9d8-1f3fb-200d-2640-fe0f.png",
              sheet_x: 44,
              sheet_y: 13,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9D8-1F3FB"
            },
            "1F3FC": {
              unified: "1F9D8-1F3FC-200D-2640-FE0F",
              non_qualified: "1F9D8-1F3FC-200D-2640",
              image: "1f9d8-1f3fc-200d-2640-fe0f.png",
              sheet_x: 44,
              sheet_y: 14,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9D8-1F3FC"
            },
            "1F3FD": {
              unified: "1F9D8-1F3FD-200D-2640-FE0F",
              non_qualified: "1F9D8-1F3FD-200D-2640",
              image: "1f9d8-1f3fd-200d-2640-fe0f.png",
              sheet_x: 44,
              sheet_y: 15,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9D8-1F3FD"
            },
            "1F3FE": {
              unified: "1F9D8-1F3FE-200D-2640-FE0F",
              non_qualified: "1F9D8-1F3FE-200D-2640",
              image: "1f9d8-1f3fe-200d-2640-fe0f.png",
              sheet_x: 44,
              sheet_y: 16,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9D8-1F3FE"
            },
            "1F3FF": {
              unified: "1F9D8-1F3FF-200D-2640-FE0F",
              non_qualified: "1F9D8-1F3FF-200D-2640",
              image: "1f9d8-1f3ff-200d-2640-fe0f.png",
              sheet_x: 44,
              sheet_y: 17,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9D8-1F3FF"
            }
          },
          obsoletes: "1F9D8",
          a: "Woman in Lotus Position",
          b: "1F9D8-200D-2640-FE0F",
          c: "1F9D8-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [44, 12],
          o: 10
        },
        man_in_lotus_position: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9D8-1F3FB-200D-2642-FE0F",
              non_qualified: "1F9D8-1F3FB-200D-2642",
              image: "1f9d8-1f3fb-200d-2642-fe0f.png",
              sheet_x: 44,
              sheet_y: 19,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F9D8-1F3FC-200D-2642-FE0F",
              non_qualified: "1F9D8-1F3FC-200D-2642",
              image: "1f9d8-1f3fc-200d-2642-fe0f.png",
              sheet_x: 44,
              sheet_y: 20,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F9D8-1F3FD-200D-2642-FE0F",
              non_qualified: "1F9D8-1F3FD-200D-2642",
              image: "1f9d8-1f3fd-200d-2642-fe0f.png",
              sheet_x: 44,
              sheet_y: 21,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F9D8-1F3FE-200D-2642-FE0F",
              non_qualified: "1F9D8-1F3FE-200D-2642",
              image: "1f9d8-1f3fe-200d-2642-fe0f.png",
              sheet_x: 44,
              sheet_y: 22,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F9D8-1F3FF-200D-2642-FE0F",
              non_qualified: "1F9D8-1F3FF-200D-2642",
              image: "1f9d8-1f3ff-200d-2642-fe0f.png",
              sheet_x: 44,
              sheet_y: 23,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Man in Lotus Position",
          b: "1F9D8-200D-2642-FE0F",
          c: "1F9D8-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [44, 18],
          o: 10
        },
        "flag-vg": {
          a: "British Virgin Islands Flag",
          b: "1F1FB-1F1EC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 17]
        },
        "flag-vi": {
          a: "U.s. Virgin Islands Flag",
          b: "1F1FB-1F1EE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 18]
        },
        bath: {
          skin_variations: {
            "1F3FB": {
              unified: "1F6C0-1F3FB",
              non_qualified: null,
              image: "1f6c0-1f3fb.png",
              sheet_x: 36,
              sheet_y: 37,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F6C0-1F3FC",
              non_qualified: null,
              image: "1f6c0-1f3fc.png",
              sheet_x: 36,
              sheet_y: 38,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F6C0-1F3FD",
              non_qualified: null,
              image: "1f6c0-1f3fd.png",
              sheet_x: 36,
              sheet_y: 39,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F6C0-1F3FE",
              non_qualified: null,
              image: "1f6c0-1f3fe.png",
              sheet_x: 36,
              sheet_y: 40,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F6C0-1F3FF",
              non_qualified: null,
              image: "1f6c0-1f3ff.png",
              sheet_x: 36,
              sheet_y: 41,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Bath",
          b: "1F6C0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["clean", "shower", "bathroom"],
          k: [36, 36]
        },
        sleeping_accommodation: {
          skin_variations: {
            "1F3FB": {
              unified: "1F6CC-1F3FB",
              non_qualified: null,
              image: "1f6cc-1f3fb.png",
              sheet_x: 36,
              sheet_y: 49,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F6CC-1F3FC",
              non_qualified: null,
              image: "1f6cc-1f3fc.png",
              sheet_x: 36,
              sheet_y: 50,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F6CC-1F3FD",
              non_qualified: null,
              image: "1f6cc-1f3fd.png",
              sheet_x: 36,
              sheet_y: 51,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F6CC-1F3FE",
              non_qualified: null,
              image: "1f6cc-1f3fe.png",
              sheet_x: 37,
              sheet_y: 0,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F6CC-1F3FF",
              non_qualified: null,
              image: "1f6cc-1f3ff.png",
              sheet_x: 37,
              sheet_y: 1,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Sleeping Accommodation",
          b: "1F6CC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [36, 48],
          o: 7
        },
        "flag-vn": {
          a: "Vietnam Flag",
          b: "1F1FB-1F1F3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 19]
        },
        man_in_business_suit_levitating: {
          skin_variations: {
            "1F3FB": {
              unified: "1F574-1F3FB",
              non_qualified: null,
              image: "1f574-1f3fb.png",
              sheet_x: 28,
              sheet_y: 46,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F574-1F3FC",
              non_qualified: null,
              image: "1f574-1f3fc.png",
              sheet_x: 28,
              sheet_y: 47,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F574-1F3FD",
              non_qualified: null,
              image: "1f574-1f3fd.png",
              sheet_x: 28,
              sheet_y: 48,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F574-1F3FE",
              non_qualified: null,
              image: "1f574-1f3fe.png",
              sheet_x: 28,
              sheet_y: 49,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F574-1F3FF",
              non_qualified: null,
              image: "1f574-1f3ff.png",
              sheet_x: 28,
              sheet_y: 50,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Man in Business Suit Levitating",
          b: "1F574-FE0F",
          c: "1F574",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [28, 45],
          o: 7
        },
        "flag-vu": {
          a: "Vanuatu Flag",
          b: "1F1FB-1F1FA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 20]
        },
        "flag-wf": {
          a: "Wallis & Futuna Flag",
          b: "1F1FC-1F1EB",
          d: !0,
          e: !1,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 21]
        },
        speaking_head_in_silhouette: {
          a: "Speaking Head in Silhouette",
          b: "1F5E3-FE0F",
          c: "1F5E3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [30, 14],
          o: 7
        },
        bust_in_silhouette: {
          a: "Bust in Silhouette",
          b: "1F464",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["user", "person", "human"],
          k: [15, 40]
        },
        "flag-ws": {
          a: "Samoa Flag",
          b: "1F1FC-1F1F8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 22]
        },
        busts_in_silhouette: {
          a: "Busts in Silhouette",
          b: "1F465",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["user", "person", "human", "group", "team"],
          k: [15, 41]
        },
        "flag-xk": {
          a: "Kosovo Flag",
          b: "1F1FD-1F1F0",
          d: !0,
          e: !1,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 23]
        },
        fencer: {
          a: "Fencer",
          b: "1F93A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [40, 48],
          o: 9
        },
        "flag-ye": {
          a: "Yemen Flag",
          b: "1F1FE-1F1EA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 24]
        },
        "flag-yt": {
          a: "Mayotte Flag",
          b: "1F1FE-1F1F9",
          d: !0,
          e: !1,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 25]
        },
        horse_racing: {
          skin_variations: {
            "1F3FB": {
              unified: "1F3C7-1F3FB",
              non_qualified: null,
              image: "1f3c7-1f3fb.png",
              sheet_x: 10,
              sheet_y: 21,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F3C7-1F3FC",
              non_qualified: null,
              image: "1f3c7-1f3fc.png",
              sheet_x: 10,
              sheet_y: 22,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F3C7-1F3FD",
              non_qualified: null,
              image: "1f3c7-1f3fd.png",
              sheet_x: 10,
              sheet_y: 23,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F3C7-1F3FE",
              non_qualified: null,
              image: "1f3c7-1f3fe.png",
              sheet_x: 10,
              sheet_y: 24,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F3C7-1F3FF",
              non_qualified: null,
              image: "1f3c7-1f3ff.png",
              sheet_x: 10,
              sheet_y: 25,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Horse Racing",
          b: "1F3C7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "betting", "competition", "gambling", "luck"],
          k: [10, 20]
        },
        "flag-za": {
          a: "South Africa Flag",
          b: "1F1FF-1F1E6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 26]
        },
        skier: {
          a: "Skier",
          b: "26F7-FE0F",
          c: "26F7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["sports", "winter", "snow"],
          k: [48, 44],
          o: 5
        },
        "flag-zm": {
          a: "Zambia Flag",
          b: "1F1FF-1F1F2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 27]
        },
        snowboarder: {
          skin_variations: {
            "1F3FB": {
              unified: "1F3C2-1F3FB",
              non_qualified: null,
              image: "1f3c2-1f3fb.png",
              sheet_x: 9,
              sheet_y: 29,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F3C2-1F3FC",
              non_qualified: null,
              image: "1f3c2-1f3fc.png",
              sheet_x: 9,
              sheet_y: 30,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F3C2-1F3FD",
              non_qualified: null,
              image: "1f3c2-1f3fd.png",
              sheet_x: 9,
              sheet_y: 31,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F3C2-1F3FE",
              non_qualified: null,
              image: "1f3c2-1f3fe.png",
              sheet_x: 9,
              sheet_y: 32,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F3C2-1F3FF",
              non_qualified: null,
              image: "1f3c2-1f3ff.png",
              sheet_x: 9,
              sheet_y: 33,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Snowboarder",
          b: "1F3C2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sports", "winter"],
          k: [9, 28]
        },
        golfer: {
          skin_variations: {
            "1F3FB": {
              unified: "1F3CC-1F3FB",
              non_qualified: null,
              image: "1f3cc-1f3fb.png",
              sheet_x: 11,
              sheet_y: 25,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F3CC-1F3FC",
              non_qualified: null,
              image: "1f3cc-1f3fc.png",
              sheet_x: 11,
              sheet_y: 26,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F3CC-1F3FD",
              non_qualified: null,
              image: "1f3cc-1f3fd.png",
              sheet_x: 11,
              sheet_y: 27,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F3CC-1F3FE",
              non_qualified: null,
              image: "1f3cc-1f3fe.png",
              sheet_x: 11,
              sheet_y: 28,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F3CC-1F3FF",
              non_qualified: null,
              image: "1f3cc-1f3ff.png",
              sheet_x: 11,
              sheet_y: 29,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoleted_by: "1F3CC-FE0F-200D-2642-FE0F",
          a: "Golfer",
          b: "1F3CC-FE0F",
          c: "1F3CC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          k: [11, 24],
          o: 7
        },
        "flag-zw": {
          a: "Zimbabwe Flag",
          b: "1F1FF-1F1FC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 28]
        },
        "man-golfing": {
          skin_variations: {
            "1F3FB": {
              unified: "1F3CC-1F3FB-200D-2642-FE0F",
              non_qualified: "1F3CC-1F3FB-200D-2642",
              image: "1f3cc-1f3fb-200d-2642-fe0f.png",
              sheet_x: 11,
              sheet_y: 19,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F3CC-1F3FC-200D-2642-FE0F",
              non_qualified: "1F3CC-1F3FC-200D-2642",
              image: "1f3cc-1f3fc-200d-2642-fe0f.png",
              sheet_x: 11,
              sheet_y: 20,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F3CC-1F3FD-200D-2642-FE0F",
              non_qualified: "1F3CC-1F3FD-200D-2642",
              image: "1f3cc-1f3fd-200d-2642-fe0f.png",
              sheet_x: 11,
              sheet_y: 21,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F3CC-1F3FE-200D-2642-FE0F",
              non_qualified: "1F3CC-1F3FE-200D-2642",
              image: "1f3cc-1f3fe-200d-2642-fe0f.png",
              sheet_x: 11,
              sheet_y: 22,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F3CC-1F3FF-200D-2642-FE0F",
              non_qualified: "1F3CC-1F3FF-200D-2642",
              image: "1f3cc-1f3ff-200d-2642-fe0f.png",
              sheet_x: 11,
              sheet_y: 23,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F3CC-FE0F",
          a: "Man Golfing",
          b: "1F3CC-FE0F-200D-2642-FE0F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          k: [11, 18],
          o: 7
        },
        "flag-england": {
          a: "England Flag",
          b: "1F3F4-E0067-E0062-E0065-E006E-E0067-E007F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [12, 16],
          o: 7
        },
        "woman-golfing": {
          skin_variations: {
            "1F3FB": {
              unified: "1F3CC-1F3FB-200D-2640-FE0F",
              non_qualified: "1F3CC-1F3FB-200D-2640",
              image: "1f3cc-1f3fb-200d-2640-fe0f.png",
              sheet_x: 11,
              sheet_y: 13,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F3CC-1F3FC-200D-2640-FE0F",
              non_qualified: "1F3CC-1F3FC-200D-2640",
              image: "1f3cc-1f3fc-200d-2640-fe0f.png",
              sheet_x: 11,
              sheet_y: 14,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F3CC-1F3FD-200D-2640-FE0F",
              non_qualified: "1F3CC-1F3FD-200D-2640",
              image: "1f3cc-1f3fd-200d-2640-fe0f.png",
              sheet_x: 11,
              sheet_y: 15,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F3CC-1F3FE-200D-2640-FE0F",
              non_qualified: "1F3CC-1F3FE-200D-2640",
              image: "1f3cc-1f3fe-200d-2640-fe0f.png",
              sheet_x: 11,
              sheet_y: 16,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F3CC-1F3FF-200D-2640-FE0F",
              non_qualified: "1F3CC-1F3FF-200D-2640",
              image: "1f3cc-1f3ff-200d-2640-fe0f.png",
              sheet_x: 11,
              sheet_y: 17,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Woman Golfing",
          b: "1F3CC-FE0F-200D-2640-FE0F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          k: [11, 12],
          o: 7
        },
        "flag-scotland": {
          a: "Scotland Flag",
          b: "1F3F4-E0067-E0062-E0073-E0063-E0074-E007F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [12, 17],
          o: 7
        },
        "flag-wales": {
          a: "Wales Flag",
          b: "1F3F4-E0067-E0062-E0077-E006C-E0073-E007F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [12, 18],
          o: 7
        },
        surfer: {
          skin_variations: {
            "1F3FB": {
              unified: "1F3C4-1F3FB",
              non_qualified: null,
              image: "1f3c4-1f3fb.png",
              sheet_x: 10,
              sheet_y: 13,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F3C4-1F3FC",
              non_qualified: null,
              image: "1f3c4-1f3fc.png",
              sheet_x: 10,
              sheet_y: 14,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F3C4-1F3FD",
              non_qualified: null,
              image: "1f3c4-1f3fd.png",
              sheet_x: 10,
              sheet_y: 15,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F3C4-1F3FE",
              non_qualified: null,
              image: "1f3c4-1f3fe.png",
              sheet_x: 10,
              sheet_y: 16,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F3C4-1F3FF",
              non_qualified: null,
              image: "1f3c4-1f3ff.png",
              sheet_x: 10,
              sheet_y: 17,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            }
          },
          obsoleted_by: "1F3C4-200D-2642-FE0F",
          a: "Surfer",
          b: "1F3C4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          k: [10, 12]
        },
        "man-surfing": {
          skin_variations: {
            "1F3FB": {
              unified: "1F3C4-1F3FB-200D-2642-FE0F",
              non_qualified: "1F3C4-1F3FB-200D-2642",
              image: "1f3c4-1f3fb-200d-2642-fe0f.png",
              sheet_x: 10,
              sheet_y: 7,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F3C4-1F3FC-200D-2642-FE0F",
              non_qualified: "1F3C4-1F3FC-200D-2642",
              image: "1f3c4-1f3fc-200d-2642-fe0f.png",
              sheet_x: 10,
              sheet_y: 8,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F3C4-1F3FD-200D-2642-FE0F",
              non_qualified: "1F3C4-1F3FD-200D-2642",
              image: "1f3c4-1f3fd-200d-2642-fe0f.png",
              sheet_x: 10,
              sheet_y: 9,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F3C4-1F3FE-200D-2642-FE0F",
              non_qualified: "1F3C4-1F3FE-200D-2642",
              image: "1f3c4-1f3fe-200d-2642-fe0f.png",
              sheet_x: 10,
              sheet_y: 10,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F3C4-1F3FF-200D-2642-FE0F",
              non_qualified: "1F3C4-1F3FF-200D-2642",
              image: "1f3c4-1f3ff-200d-2642-fe0f.png",
              sheet_x: 10,
              sheet_y: 11,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F3C4",
          a: "Man Surfing",
          b: "1F3C4-200D-2642-FE0F",
          c: "1F3C4-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [10, 6]
        },
        "woman-surfing": {
          skin_variations: {
            "1F3FB": {
              unified: "1F3C4-1F3FB-200D-2640-FE0F",
              non_qualified: "1F3C4-1F3FB-200D-2640",
              image: "1f3c4-1f3fb-200d-2640-fe0f.png",
              sheet_x: 10,
              sheet_y: 1,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F3C4-1F3FC-200D-2640-FE0F",
              non_qualified: "1F3C4-1F3FC-200D-2640",
              image: "1f3c4-1f3fc-200d-2640-fe0f.png",
              sheet_x: 10,
              sheet_y: 2,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F3C4-1F3FD-200D-2640-FE0F",
              non_qualified: "1F3C4-1F3FD-200D-2640",
              image: "1f3c4-1f3fd-200d-2640-fe0f.png",
              sheet_x: 10,
              sheet_y: 3,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F3C4-1F3FE-200D-2640-FE0F",
              non_qualified: "1F3C4-1F3FE-200D-2640",
              image: "1f3c4-1f3fe-200d-2640-fe0f.png",
              sheet_x: 10,
              sheet_y: 4,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F3C4-1F3FF-200D-2640-FE0F",
              non_qualified: "1F3C4-1F3FF-200D-2640",
              image: "1f3c4-1f3ff-200d-2640-fe0f.png",
              sheet_x: 10,
              sheet_y: 5,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Woman Surfing",
          b: "1F3C4-200D-2640-FE0F",
          c: "1F3C4-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [10, 0]
        },
        rowboat: {
          skin_variations: {
            "1F3FB": {
              unified: "1F6A3-1F3FB",
              non_qualified: null,
              image: "1f6a3-1f3fb.png",
              sheet_x: 35,
              sheet_y: 4,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F6A3-1F3FC",
              non_qualified: null,
              image: "1f6a3-1f3fc.png",
              sheet_x: 35,
              sheet_y: 5,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F6A3-1F3FD",
              non_qualified: null,
              image: "1f6a3-1f3fd.png",
              sheet_x: 35,
              sheet_y: 6,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F6A3-1F3FE",
              non_qualified: null,
              image: "1f6a3-1f3fe.png",
              sheet_x: 35,
              sheet_y: 7,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F6A3-1F3FF",
              non_qualified: null,
              image: "1f6a3-1f3ff.png",
              sheet_x: 35,
              sheet_y: 8,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoleted_by: "1F6A3-200D-2642-FE0F",
          a: "Rowboat",
          b: "1F6A3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          k: [35, 3]
        },
        "man-rowing-boat": {
          skin_variations: {
            "1F3FB": {
              unified: "1F6A3-1F3FB-200D-2642-FE0F",
              non_qualified: "1F6A3-1F3FB-200D-2642",
              image: "1f6a3-1f3fb-200d-2642-fe0f.png",
              sheet_x: 34,
              sheet_y: 50,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F6A3-1F3FC-200D-2642-FE0F",
              non_qualified: "1F6A3-1F3FC-200D-2642",
              image: "1f6a3-1f3fc-200d-2642-fe0f.png",
              sheet_x: 34,
              sheet_y: 51,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F6A3-1F3FD-200D-2642-FE0F",
              non_qualified: "1F6A3-1F3FD-200D-2642",
              image: "1f6a3-1f3fd-200d-2642-fe0f.png",
              sheet_x: 35,
              sheet_y: 0,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F6A3-1F3FE-200D-2642-FE0F",
              non_qualified: "1F6A3-1F3FE-200D-2642",
              image: "1f6a3-1f3fe-200d-2642-fe0f.png",
              sheet_x: 35,
              sheet_y: 1,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F6A3-1F3FF-200D-2642-FE0F",
              non_qualified: "1F6A3-1F3FF-200D-2642",
              image: "1f6a3-1f3ff-200d-2642-fe0f.png",
              sheet_x: 35,
              sheet_y: 2,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F6A3",
          a: "Man Rowing Boat",
          b: "1F6A3-200D-2642-FE0F",
          c: "1F6A3-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [34, 49]
        },
        "woman-rowing-boat": {
          skin_variations: {
            "1F3FB": {
              unified: "1F6A3-1F3FB-200D-2640-FE0F",
              non_qualified: "1F6A3-1F3FB-200D-2640",
              image: "1f6a3-1f3fb-200d-2640-fe0f.png",
              sheet_x: 34,
              sheet_y: 44,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F6A3-1F3FC-200D-2640-FE0F",
              non_qualified: "1F6A3-1F3FC-200D-2640",
              image: "1f6a3-1f3fc-200d-2640-fe0f.png",
              sheet_x: 34,
              sheet_y: 45,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F6A3-1F3FD-200D-2640-FE0F",
              non_qualified: "1F6A3-1F3FD-200D-2640",
              image: "1f6a3-1f3fd-200d-2640-fe0f.png",
              sheet_x: 34,
              sheet_y: 46,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F6A3-1F3FE-200D-2640-FE0F",
              non_qualified: "1F6A3-1F3FE-200D-2640",
              image: "1f6a3-1f3fe-200d-2640-fe0f.png",
              sheet_x: 34,
              sheet_y: 47,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F6A3-1F3FF-200D-2640-FE0F",
              non_qualified: "1F6A3-1F3FF-200D-2640",
              image: "1f6a3-1f3ff-200d-2640-fe0f.png",
              sheet_x: 34,
              sheet_y: 48,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Woman Rowing Boat",
          b: "1F6A3-200D-2640-FE0F",
          c: "1F6A3-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [34, 43]
        },
        swimmer: {
          skin_variations: {
            "1F3FB": {
              unified: "1F3CA-1F3FB",
              non_qualified: null,
              image: "1f3ca-1f3fb.png",
              sheet_x: 10,
              sheet_y: 41,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F3CA-1F3FC",
              non_qualified: null,
              image: "1f3ca-1f3fc.png",
              sheet_x: 10,
              sheet_y: 42,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F3CA-1F3FD",
              non_qualified: null,
              image: "1f3ca-1f3fd.png",
              sheet_x: 10,
              sheet_y: 43,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F3CA-1F3FE",
              non_qualified: null,
              image: "1f3ca-1f3fe.png",
              sheet_x: 10,
              sheet_y: 44,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F3CA-1F3FF",
              non_qualified: null,
              image: "1f3ca-1f3ff.png",
              sheet_x: 10,
              sheet_y: 45,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            }
          },
          obsoleted_by: "1F3CA-200D-2642-FE0F",
          a: "Swimmer",
          b: "1F3CA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          k: [10, 40]
        },
        "man-swimming": {
          skin_variations: {
            "1F3FB": {
              unified: "1F3CA-1F3FB-200D-2642-FE0F",
              non_qualified: "1F3CA-1F3FB-200D-2642",
              image: "1f3ca-1f3fb-200d-2642-fe0f.png",
              sheet_x: 10,
              sheet_y: 35,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F3CA-1F3FC-200D-2642-FE0F",
              non_qualified: "1F3CA-1F3FC-200D-2642",
              image: "1f3ca-1f3fc-200d-2642-fe0f.png",
              sheet_x: 10,
              sheet_y: 36,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F3CA-1F3FD-200D-2642-FE0F",
              non_qualified: "1F3CA-1F3FD-200D-2642",
              image: "1f3ca-1f3fd-200d-2642-fe0f.png",
              sheet_x: 10,
              sheet_y: 37,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F3CA-1F3FE-200D-2642-FE0F",
              non_qualified: "1F3CA-1F3FE-200D-2642",
              image: "1f3ca-1f3fe-200d-2642-fe0f.png",
              sheet_x: 10,
              sheet_y: 38,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F3CA-1F3FF-200D-2642-FE0F",
              non_qualified: "1F3CA-1F3FF-200D-2642",
              image: "1f3ca-1f3ff-200d-2642-fe0f.png",
              sheet_x: 10,
              sheet_y: 39,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F3CA",
          a: "Man Swimming",
          b: "1F3CA-200D-2642-FE0F",
          c: "1F3CA-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [10, 34]
        },
        "woman-swimming": {
          skin_variations: {
            "1F3FB": {
              unified: "1F3CA-1F3FB-200D-2640-FE0F",
              non_qualified: "1F3CA-1F3FB-200D-2640",
              image: "1f3ca-1f3fb-200d-2640-fe0f.png",
              sheet_x: 10,
              sheet_y: 29,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F3CA-1F3FC-200D-2640-FE0F",
              non_qualified: "1F3CA-1F3FC-200D-2640",
              image: "1f3ca-1f3fc-200d-2640-fe0f.png",
              sheet_x: 10,
              sheet_y: 30,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F3CA-1F3FD-200D-2640-FE0F",
              non_qualified: "1F3CA-1F3FD-200D-2640",
              image: "1f3ca-1f3fd-200d-2640-fe0f.png",
              sheet_x: 10,
              sheet_y: 31,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F3CA-1F3FE-200D-2640-FE0F",
              non_qualified: "1F3CA-1F3FE-200D-2640",
              image: "1f3ca-1f3fe-200d-2640-fe0f.png",
              sheet_x: 10,
              sheet_y: 32,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F3CA-1F3FF-200D-2640-FE0F",
              non_qualified: "1F3CA-1F3FF-200D-2640",
              image: "1f3ca-1f3ff-200d-2640-fe0f.png",
              sheet_x: 10,
              sheet_y: 33,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Woman Swimming",
          b: "1F3CA-200D-2640-FE0F",
          c: "1F3CA-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [10, 28]
        },
        person_with_ball: {
          skin_variations: {
            "1F3FB": {
              unified: "26F9-1F3FB",
              non_qualified: null,
              image: "26f9-1f3fb.png",
              sheet_x: 49,
              sheet_y: 7,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "26F9-1F3FC",
              non_qualified: null,
              image: "26f9-1f3fc.png",
              sheet_x: 49,
              sheet_y: 8,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "26F9-1F3FD",
              non_qualified: null,
              image: "26f9-1f3fd.png",
              sheet_x: 49,
              sheet_y: 9,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "26F9-1F3FE",
              non_qualified: null,
              image: "26f9-1f3fe.png",
              sheet_x: 49,
              sheet_y: 10,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "26F9-1F3FF",
              non_qualified: null,
              image: "26f9-1f3ff.png",
              sheet_x: 49,
              sheet_y: 11,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoleted_by: "26F9-FE0F-200D-2642-FE0F",
          a: "Person with Ball",
          b: "26F9-FE0F",
          c: "26F9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          k: [49, 6],
          o: 5
        },
        "man-bouncing-ball": {
          skin_variations: {
            "1F3FB": {
              unified: "26F9-1F3FB-200D-2642-FE0F",
              non_qualified: "26F9-1F3FB-200D-2642",
              image: "26f9-1f3fb-200d-2642-fe0f.png",
              sheet_x: 49,
              sheet_y: 1,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "26F9-1F3FC-200D-2642-FE0F",
              non_qualified: "26F9-1F3FC-200D-2642",
              image: "26f9-1f3fc-200d-2642-fe0f.png",
              sheet_x: 49,
              sheet_y: 2,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "26F9-1F3FD-200D-2642-FE0F",
              non_qualified: "26F9-1F3FD-200D-2642",
              image: "26f9-1f3fd-200d-2642-fe0f.png",
              sheet_x: 49,
              sheet_y: 3,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "26F9-1F3FE-200D-2642-FE0F",
              non_qualified: "26F9-1F3FE-200D-2642",
              image: "26f9-1f3fe-200d-2642-fe0f.png",
              sheet_x: 49,
              sheet_y: 4,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "26F9-1F3FF-200D-2642-FE0F",
              non_qualified: "26F9-1F3FF-200D-2642",
              image: "26f9-1f3ff-200d-2642-fe0f.png",
              sheet_x: 49,
              sheet_y: 5,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "26F9-FE0F",
          a: "Man Bouncing Ball",
          b: "26F9-FE0F-200D-2642-FE0F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          k: [49, 0],
          o: 5
        },
        "woman-bouncing-ball": {
          skin_variations: {
            "1F3FB": {
              unified: "26F9-1F3FB-200D-2640-FE0F",
              non_qualified: "26F9-1F3FB-200D-2640",
              image: "26f9-1f3fb-200d-2640-fe0f.png",
              sheet_x: 48,
              sheet_y: 47,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "26F9-1F3FC-200D-2640-FE0F",
              non_qualified: "26F9-1F3FC-200D-2640",
              image: "26f9-1f3fc-200d-2640-fe0f.png",
              sheet_x: 48,
              sheet_y: 48,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "26F9-1F3FD-200D-2640-FE0F",
              non_qualified: "26F9-1F3FD-200D-2640",
              image: "26f9-1f3fd-200d-2640-fe0f.png",
              sheet_x: 48,
              sheet_y: 49,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "26F9-1F3FE-200D-2640-FE0F",
              non_qualified: "26F9-1F3FE-200D-2640",
              image: "26f9-1f3fe-200d-2640-fe0f.png",
              sheet_x: 48,
              sheet_y: 50,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "26F9-1F3FF-200D-2640-FE0F",
              non_qualified: "26F9-1F3FF-200D-2640",
              image: "26f9-1f3ff-200d-2640-fe0f.png",
              sheet_x: 48,
              sheet_y: 51,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Woman Bouncing Ball",
          b: "26F9-FE0F-200D-2640-FE0F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          k: [48, 46],
          o: 5
        },
        weight_lifter: {
          skin_variations: {
            "1F3FB": {
              unified: "1F3CB-1F3FB",
              non_qualified: null,
              image: "1f3cb-1f3fb.png",
              sheet_x: 11,
              sheet_y: 7,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F3CB-1F3FC",
              non_qualified: null,
              image: "1f3cb-1f3fc.png",
              sheet_x: 11,
              sheet_y: 8,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F3CB-1F3FD",
              non_qualified: null,
              image: "1f3cb-1f3fd.png",
              sheet_x: 11,
              sheet_y: 9,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F3CB-1F3FE",
              non_qualified: null,
              image: "1f3cb-1f3fe.png",
              sheet_x: 11,
              sheet_y: 10,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F3CB-1F3FF",
              non_qualified: null,
              image: "1f3cb-1f3ff.png",
              sheet_x: 11,
              sheet_y: 11,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoleted_by: "1F3CB-FE0F-200D-2642-FE0F",
          a: "Weight Lifter",
          b: "1F3CB-FE0F",
          c: "1F3CB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          k: [11, 6],
          o: 7
        },
        "man-lifting-weights": {
          skin_variations: {
            "1F3FB": {
              unified: "1F3CB-1F3FB-200D-2642-FE0F",
              non_qualified: "1F3CB-1F3FB-200D-2642",
              image: "1f3cb-1f3fb-200d-2642-fe0f.png",
              sheet_x: 11,
              sheet_y: 1,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F3CB-1F3FC-200D-2642-FE0F",
              non_qualified: "1F3CB-1F3FC-200D-2642",
              image: "1f3cb-1f3fc-200d-2642-fe0f.png",
              sheet_x: 11,
              sheet_y: 2,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F3CB-1F3FD-200D-2642-FE0F",
              non_qualified: "1F3CB-1F3FD-200D-2642",
              image: "1f3cb-1f3fd-200d-2642-fe0f.png",
              sheet_x: 11,
              sheet_y: 3,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F3CB-1F3FE-200D-2642-FE0F",
              non_qualified: "1F3CB-1F3FE-200D-2642",
              image: "1f3cb-1f3fe-200d-2642-fe0f.png",
              sheet_x: 11,
              sheet_y: 4,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F3CB-1F3FF-200D-2642-FE0F",
              non_qualified: "1F3CB-1F3FF-200D-2642",
              image: "1f3cb-1f3ff-200d-2642-fe0f.png",
              sheet_x: 11,
              sheet_y: 5,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F3CB-FE0F",
          a: "Man Lifting Weights",
          b: "1F3CB-FE0F-200D-2642-FE0F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          k: [11, 0],
          o: 7
        },
        "woman-lifting-weights": {
          skin_variations: {
            "1F3FB": {
              unified: "1F3CB-1F3FB-200D-2640-FE0F",
              non_qualified: "1F3CB-1F3FB-200D-2640",
              image: "1f3cb-1f3fb-200d-2640-fe0f.png",
              sheet_x: 10,
              sheet_y: 47,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F3CB-1F3FC-200D-2640-FE0F",
              non_qualified: "1F3CB-1F3FC-200D-2640",
              image: "1f3cb-1f3fc-200d-2640-fe0f.png",
              sheet_x: 10,
              sheet_y: 48,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F3CB-1F3FD-200D-2640-FE0F",
              non_qualified: "1F3CB-1F3FD-200D-2640",
              image: "1f3cb-1f3fd-200d-2640-fe0f.png",
              sheet_x: 10,
              sheet_y: 49,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F3CB-1F3FE-200D-2640-FE0F",
              non_qualified: "1F3CB-1F3FE-200D-2640",
              image: "1f3cb-1f3fe-200d-2640-fe0f.png",
              sheet_x: 10,
              sheet_y: 50,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F3CB-1F3FF-200D-2640-FE0F",
              non_qualified: "1F3CB-1F3FF-200D-2640",
              image: "1f3cb-1f3ff-200d-2640-fe0f.png",
              sheet_x: 10,
              sheet_y: 51,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Woman Lifting Weights",
          b: "1F3CB-FE0F-200D-2640-FE0F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          k: [10, 46],
          o: 7
        },
        bicyclist: {
          skin_variations: {
            "1F3FB": {
              unified: "1F6B4-1F3FB",
              non_qualified: null,
              image: "1f6b4-1f3fb.png",
              sheet_x: 35,
              sheet_y: 38,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F6B4-1F3FC",
              non_qualified: null,
              image: "1f6b4-1f3fc.png",
              sheet_x: 35,
              sheet_y: 39,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F6B4-1F3FD",
              non_qualified: null,
              image: "1f6b4-1f3fd.png",
              sheet_x: 35,
              sheet_y: 40,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F6B4-1F3FE",
              non_qualified: null,
              image: "1f6b4-1f3fe.png",
              sheet_x: 35,
              sheet_y: 41,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F6B4-1F3FF",
              non_qualified: null,
              image: "1f6b4-1f3ff.png",
              sheet_x: 35,
              sheet_y: 42,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            }
          },
          obsoleted_by: "1F6B4-200D-2642-FE0F",
          a: "Bicyclist",
          b: "1F6B4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          k: [35, 37]
        },
        "man-biking": {
          skin_variations: {
            "1F3FB": {
              unified: "1F6B4-1F3FB-200D-2642-FE0F",
              non_qualified: "1F6B4-1F3FB-200D-2642",
              image: "1f6b4-1f3fb-200d-2642-fe0f.png",
              sheet_x: 35,
              sheet_y: 32,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F6B4-1F3FC-200D-2642-FE0F",
              non_qualified: "1F6B4-1F3FC-200D-2642",
              image: "1f6b4-1f3fc-200d-2642-fe0f.png",
              sheet_x: 35,
              sheet_y: 33,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F6B4-1F3FD-200D-2642-FE0F",
              non_qualified: "1F6B4-1F3FD-200D-2642",
              image: "1f6b4-1f3fd-200d-2642-fe0f.png",
              sheet_x: 35,
              sheet_y: 34,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F6B4-1F3FE-200D-2642-FE0F",
              non_qualified: "1F6B4-1F3FE-200D-2642",
              image: "1f6b4-1f3fe-200d-2642-fe0f.png",
              sheet_x: 35,
              sheet_y: 35,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F6B4-1F3FF-200D-2642-FE0F",
              non_qualified: "1F6B4-1F3FF-200D-2642",
              image: "1f6b4-1f3ff-200d-2642-fe0f.png",
              sheet_x: 35,
              sheet_y: 36,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F6B4",
          a: "Man Biking",
          b: "1F6B4-200D-2642-FE0F",
          c: "1F6B4-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [35, 31]
        },
        "woman-biking": {
          skin_variations: {
            "1F3FB": {
              unified: "1F6B4-1F3FB-200D-2640-FE0F",
              non_qualified: "1F6B4-1F3FB-200D-2640",
              image: "1f6b4-1f3fb-200d-2640-fe0f.png",
              sheet_x: 35,
              sheet_y: 26,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F6B4-1F3FC-200D-2640-FE0F",
              non_qualified: "1F6B4-1F3FC-200D-2640",
              image: "1f6b4-1f3fc-200d-2640-fe0f.png",
              sheet_x: 35,
              sheet_y: 27,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F6B4-1F3FD-200D-2640-FE0F",
              non_qualified: "1F6B4-1F3FD-200D-2640",
              image: "1f6b4-1f3fd-200d-2640-fe0f.png",
              sheet_x: 35,
              sheet_y: 28,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F6B4-1F3FE-200D-2640-FE0F",
              non_qualified: "1F6B4-1F3FE-200D-2640",
              image: "1f6b4-1f3fe-200d-2640-fe0f.png",
              sheet_x: 35,
              sheet_y: 29,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F6B4-1F3FF-200D-2640-FE0F",
              non_qualified: "1F6B4-1F3FF-200D-2640",
              image: "1f6b4-1f3ff-200d-2640-fe0f.png",
              sheet_x: 35,
              sheet_y: 30,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Woman Biking",
          b: "1F6B4-200D-2640-FE0F",
          c: "1F6B4-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [35, 25]
        },
        mountain_bicyclist: {
          skin_variations: {
            "1F3FB": {
              unified: "1F6B5-1F3FB",
              non_qualified: null,
              image: "1f6b5-1f3fb.png",
              sheet_x: 36,
              sheet_y: 4,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F6B5-1F3FC",
              non_qualified: null,
              image: "1f6b5-1f3fc.png",
              sheet_x: 36,
              sheet_y: 5,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F6B5-1F3FD",
              non_qualified: null,
              image: "1f6b5-1f3fd.png",
              sheet_x: 36,
              sheet_y: 6,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F6B5-1F3FE",
              non_qualified: null,
              image: "1f6b5-1f3fe.png",
              sheet_x: 36,
              sheet_y: 7,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F6B5-1F3FF",
              non_qualified: null,
              image: "1f6b5-1f3ff.png",
              sheet_x: 36,
              sheet_y: 8,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            }
          },
          obsoleted_by: "1F6B5-200D-2642-FE0F",
          a: "Mountain Bicyclist",
          b: "1F6B5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          k: [36, 3]
        },
        "man-mountain-biking": {
          skin_variations: {
            "1F3FB": {
              unified: "1F6B5-1F3FB-200D-2642-FE0F",
              non_qualified: "1F6B5-1F3FB-200D-2642",
              image: "1f6b5-1f3fb-200d-2642-fe0f.png",
              sheet_x: 35,
              sheet_y: 50,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F6B5-1F3FC-200D-2642-FE0F",
              non_qualified: "1F6B5-1F3FC-200D-2642",
              image: "1f6b5-1f3fc-200d-2642-fe0f.png",
              sheet_x: 35,
              sheet_y: 51,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F6B5-1F3FD-200D-2642-FE0F",
              non_qualified: "1F6B5-1F3FD-200D-2642",
              image: "1f6b5-1f3fd-200d-2642-fe0f.png",
              sheet_x: 36,
              sheet_y: 0,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F6B5-1F3FE-200D-2642-FE0F",
              non_qualified: "1F6B5-1F3FE-200D-2642",
              image: "1f6b5-1f3fe-200d-2642-fe0f.png",
              sheet_x: 36,
              sheet_y: 1,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F6B5-1F3FF-200D-2642-FE0F",
              non_qualified: "1F6B5-1F3FF-200D-2642",
              image: "1f6b5-1f3ff-200d-2642-fe0f.png",
              sheet_x: 36,
              sheet_y: 2,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F6B5",
          a: "Man Mountain Biking",
          b: "1F6B5-200D-2642-FE0F",
          c: "1F6B5-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [35, 49]
        },
        "woman-mountain-biking": {
          skin_variations: {
            "1F3FB": {
              unified: "1F6B5-1F3FB-200D-2640-FE0F",
              non_qualified: "1F6B5-1F3FB-200D-2640",
              image: "1f6b5-1f3fb-200d-2640-fe0f.png",
              sheet_x: 35,
              sheet_y: 44,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F6B5-1F3FC-200D-2640-FE0F",
              non_qualified: "1F6B5-1F3FC-200D-2640",
              image: "1f6b5-1f3fc-200d-2640-fe0f.png",
              sheet_x: 35,
              sheet_y: 45,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F6B5-1F3FD-200D-2640-FE0F",
              non_qualified: "1F6B5-1F3FD-200D-2640",
              image: "1f6b5-1f3fd-200d-2640-fe0f.png",
              sheet_x: 35,
              sheet_y: 46,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F6B5-1F3FE-200D-2640-FE0F",
              non_qualified: "1F6B5-1F3FE-200D-2640",
              image: "1f6b5-1f3fe-200d-2640-fe0f.png",
              sheet_x: 35,
              sheet_y: 47,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F6B5-1F3FF-200D-2640-FE0F",
              non_qualified: "1F6B5-1F3FF-200D-2640",
              image: "1f6b5-1f3ff-200d-2640-fe0f.png",
              sheet_x: 35,
              sheet_y: 48,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Woman Mountain Biking",
          b: "1F6B5-200D-2640-FE0F",
          c: "1F6B5-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [35, 43]
        },
        racing_car: {
          a: "Racing Car",
          b: "1F3CE-FE0F",
          c: "1F3CE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["sports", "race", "fast", "formula", "f1"],
          k: [11, 31],
          o: 7
        },
        racing_motorcycle: {
          a: "Racing Motorcycle",
          b: "1F3CD-FE0F",
          c: "1F3CD",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [11, 30],
          o: 7
        },
        person_doing_cartwheel: {
          skin_variations: {
            "1F3FB": {
              unified: "1F938-1F3FB",
              non_qualified: null,
              image: "1f938-1f3fb.png",
              sheet_x: 40,
              sheet_y: 25,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F938-1F3FC",
              non_qualified: null,
              image: "1f938-1f3fc.png",
              sheet_x: 40,
              sheet_y: 26,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F938-1F3FD",
              non_qualified: null,
              image: "1f938-1f3fd.png",
              sheet_x: 40,
              sheet_y: 27,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F938-1F3FE",
              non_qualified: null,
              image: "1f938-1f3fe.png",
              sheet_x: 40,
              sheet_y: 28,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F938-1F3FF",
              non_qualified: null,
              image: "1f938-1f3ff.png",
              sheet_x: 40,
              sheet_y: 29,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Person Doing Cartwheel",
          b: "1F938",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          k: [40, 24],
          o: 9
        },
        "man-cartwheeling": {
          skin_variations: {
            "1F3FB": {
              unified: "1F938-1F3FB-200D-2642-FE0F",
              non_qualified: "1F938-1F3FB-200D-2642",
              image: "1f938-1f3fb-200d-2642-fe0f.png",
              sheet_x: 40,
              sheet_y: 19,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F938-1F3FC-200D-2642-FE0F",
              non_qualified: "1F938-1F3FC-200D-2642",
              image: "1f938-1f3fc-200d-2642-fe0f.png",
              sheet_x: 40,
              sheet_y: 20,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F938-1F3FD-200D-2642-FE0F",
              non_qualified: "1F938-1F3FD-200D-2642",
              image: "1f938-1f3fd-200d-2642-fe0f.png",
              sheet_x: 40,
              sheet_y: 21,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F938-1F3FE-200D-2642-FE0F",
              non_qualified: "1F938-1F3FE-200D-2642",
              image: "1f938-1f3fe-200d-2642-fe0f.png",
              sheet_x: 40,
              sheet_y: 22,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F938-1F3FF-200D-2642-FE0F",
              non_qualified: "1F938-1F3FF-200D-2642",
              image: "1f938-1f3ff-200d-2642-fe0f.png",
              sheet_x: 40,
              sheet_y: 23,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Man Cartwheeling",
          b: "1F938-200D-2642-FE0F",
          c: "1F938-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [40, 18],
          o: 9
        },
        "woman-cartwheeling": {
          skin_variations: {
            "1F3FB": {
              unified: "1F938-1F3FB-200D-2640-FE0F",
              non_qualified: "1F938-1F3FB-200D-2640",
              image: "1f938-1f3fb-200d-2640-fe0f.png",
              sheet_x: 40,
              sheet_y: 13,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F938-1F3FC-200D-2640-FE0F",
              non_qualified: "1F938-1F3FC-200D-2640",
              image: "1f938-1f3fc-200d-2640-fe0f.png",
              sheet_x: 40,
              sheet_y: 14,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F938-1F3FD-200D-2640-FE0F",
              non_qualified: "1F938-1F3FD-200D-2640",
              image: "1f938-1f3fd-200d-2640-fe0f.png",
              sheet_x: 40,
              sheet_y: 15,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F938-1F3FE-200D-2640-FE0F",
              non_qualified: "1F938-1F3FE-200D-2640",
              image: "1f938-1f3fe-200d-2640-fe0f.png",
              sheet_x: 40,
              sheet_y: 16,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F938-1F3FF-200D-2640-FE0F",
              non_qualified: "1F938-1F3FF-200D-2640",
              image: "1f938-1f3ff-200d-2640-fe0f.png",
              sheet_x: 40,
              sheet_y: 17,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Woman Cartwheeling",
          b: "1F938-200D-2640-FE0F",
          c: "1F938-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [40, 12],
          o: 9
        },
        wrestlers: {
          a: "Wrestlers",
          b: "1F93C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          k: [40, 51],
          o: 9
        },
        "man-wrestling": {
          a: "Man Wrestling",
          b: "1F93C-200D-2642-FE0F",
          c: "1F93C-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [40, 50],
          o: 9
        },
        "woman-wrestling": {
          a: "Woman Wrestling",
          b: "1F93C-200D-2640-FE0F",
          c: "1F93C-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [40, 49],
          o: 9
        },
        water_polo: {
          skin_variations: {
            "1F3FB": {
              unified: "1F93D-1F3FB",
              non_qualified: null,
              image: "1f93d-1f3fb.png",
              sheet_x: 41,
              sheet_y: 13,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F93D-1F3FC",
              non_qualified: null,
              image: "1f93d-1f3fc.png",
              sheet_x: 41,
              sheet_y: 14,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F93D-1F3FD",
              non_qualified: null,
              image: "1f93d-1f3fd.png",
              sheet_x: 41,
              sheet_y: 15,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F93D-1F3FE",
              non_qualified: null,
              image: "1f93d-1f3fe.png",
              sheet_x: 41,
              sheet_y: 16,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F93D-1F3FF",
              non_qualified: null,
              image: "1f93d-1f3ff.png",
              sheet_x: 41,
              sheet_y: 17,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Water Polo",
          b: "1F93D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          k: [41, 12],
          o: 9
        },
        "man-playing-water-polo": {
          skin_variations: {
            "1F3FB": {
              unified: "1F93D-1F3FB-200D-2642-FE0F",
              non_qualified: "1F93D-1F3FB-200D-2642",
              image: "1f93d-1f3fb-200d-2642-fe0f.png",
              sheet_x: 41,
              sheet_y: 7,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F93D-1F3FC-200D-2642-FE0F",
              non_qualified: "1F93D-1F3FC-200D-2642",
              image: "1f93d-1f3fc-200d-2642-fe0f.png",
              sheet_x: 41,
              sheet_y: 8,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F93D-1F3FD-200D-2642-FE0F",
              non_qualified: "1F93D-1F3FD-200D-2642",
              image: "1f93d-1f3fd-200d-2642-fe0f.png",
              sheet_x: 41,
              sheet_y: 9,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F93D-1F3FE-200D-2642-FE0F",
              non_qualified: "1F93D-1F3FE-200D-2642",
              image: "1f93d-1f3fe-200d-2642-fe0f.png",
              sheet_x: 41,
              sheet_y: 10,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F93D-1F3FF-200D-2642-FE0F",
              non_qualified: "1F93D-1F3FF-200D-2642",
              image: "1f93d-1f3ff-200d-2642-fe0f.png",
              sheet_x: 41,
              sheet_y: 11,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Man Playing Water Polo",
          b: "1F93D-200D-2642-FE0F",
          c: "1F93D-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [41, 6],
          o: 9
        },
        "woman-playing-water-polo": {
          skin_variations: {
            "1F3FB": {
              unified: "1F93D-1F3FB-200D-2640-FE0F",
              non_qualified: "1F93D-1F3FB-200D-2640",
              image: "1f93d-1f3fb-200d-2640-fe0f.png",
              sheet_x: 41,
              sheet_y: 1,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F93D-1F3FC-200D-2640-FE0F",
              non_qualified: "1F93D-1F3FC-200D-2640",
              image: "1f93d-1f3fc-200d-2640-fe0f.png",
              sheet_x: 41,
              sheet_y: 2,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F93D-1F3FD-200D-2640-FE0F",
              non_qualified: "1F93D-1F3FD-200D-2640",
              image: "1f93d-1f3fd-200d-2640-fe0f.png",
              sheet_x: 41,
              sheet_y: 3,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F93D-1F3FE-200D-2640-FE0F",
              non_qualified: "1F93D-1F3FE-200D-2640",
              image: "1f93d-1f3fe-200d-2640-fe0f.png",
              sheet_x: 41,
              sheet_y: 4,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F93D-1F3FF-200D-2640-FE0F",
              non_qualified: "1F93D-1F3FF-200D-2640",
              image: "1f93d-1f3ff-200d-2640-fe0f.png",
              sheet_x: 41,
              sheet_y: 5,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Woman Playing Water Polo",
          b: "1F93D-200D-2640-FE0F",
          c: "1F93D-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [41, 0],
          o: 9
        },
        handball: {
          skin_variations: {
            "1F3FB": {
              unified: "1F93E-1F3FB",
              non_qualified: null,
              image: "1f93e-1f3fb.png",
              sheet_x: 41,
              sheet_y: 31,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F93E-1F3FC",
              non_qualified: null,
              image: "1f93e-1f3fc.png",
              sheet_x: 41,
              sheet_y: 32,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F93E-1F3FD",
              non_qualified: null,
              image: "1f93e-1f3fd.png",
              sheet_x: 41,
              sheet_y: 33,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F93E-1F3FE",
              non_qualified: null,
              image: "1f93e-1f3fe.png",
              sheet_x: 41,
              sheet_y: 34,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F93E-1F3FF",
              non_qualified: null,
              image: "1f93e-1f3ff.png",
              sheet_x: 41,
              sheet_y: 35,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Handball",
          b: "1F93E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          k: [41, 30],
          o: 9
        },
        "man-playing-handball": {
          skin_variations: {
            "1F3FB": {
              unified: "1F93E-1F3FB-200D-2642-FE0F",
              non_qualified: "1F93E-1F3FB-200D-2642",
              image: "1f93e-1f3fb-200d-2642-fe0f.png",
              sheet_x: 41,
              sheet_y: 25,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F93E-1F3FC-200D-2642-FE0F",
              non_qualified: "1F93E-1F3FC-200D-2642",
              image: "1f93e-1f3fc-200d-2642-fe0f.png",
              sheet_x: 41,
              sheet_y: 26,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F93E-1F3FD-200D-2642-FE0F",
              non_qualified: "1F93E-1F3FD-200D-2642",
              image: "1f93e-1f3fd-200d-2642-fe0f.png",
              sheet_x: 41,
              sheet_y: 27,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F93E-1F3FE-200D-2642-FE0F",
              non_qualified: "1F93E-1F3FE-200D-2642",
              image: "1f93e-1f3fe-200d-2642-fe0f.png",
              sheet_x: 41,
              sheet_y: 28,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F93E-1F3FF-200D-2642-FE0F",
              non_qualified: "1F93E-1F3FF-200D-2642",
              image: "1f93e-1f3ff-200d-2642-fe0f.png",
              sheet_x: 41,
              sheet_y: 29,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Man Playing Handball",
          b: "1F93E-200D-2642-FE0F",
          c: "1F93E-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [41, 24],
          o: 9
        },
        "woman-playing-handball": {
          skin_variations: {
            "1F3FB": {
              unified: "1F93E-1F3FB-200D-2640-FE0F",
              non_qualified: "1F93E-1F3FB-200D-2640",
              image: "1f93e-1f3fb-200d-2640-fe0f.png",
              sheet_x: 41,
              sheet_y: 19,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F93E-1F3FC-200D-2640-FE0F",
              non_qualified: "1F93E-1F3FC-200D-2640",
              image: "1f93e-1f3fc-200d-2640-fe0f.png",
              sheet_x: 41,
              sheet_y: 20,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F93E-1F3FD-200D-2640-FE0F",
              non_qualified: "1F93E-1F3FD-200D-2640",
              image: "1f93e-1f3fd-200d-2640-fe0f.png",
              sheet_x: 41,
              sheet_y: 21,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F93E-1F3FE-200D-2640-FE0F",
              non_qualified: "1F93E-1F3FE-200D-2640",
              image: "1f93e-1f3fe-200d-2640-fe0f.png",
              sheet_x: 41,
              sheet_y: 22,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F93E-1F3FF-200D-2640-FE0F",
              non_qualified: "1F93E-1F3FF-200D-2640",
              image: "1f93e-1f3ff-200d-2640-fe0f.png",
              sheet_x: 41,
              sheet_y: 23,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Woman Playing Handball",
          b: "1F93E-200D-2640-FE0F",
          c: "1F93E-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [41, 18],
          o: 9
        },
        juggling: {
          skin_variations: {
            "1F3FB": {
              unified: "1F939-1F3FB",
              non_qualified: null,
              image: "1f939-1f3fb.png",
              sheet_x: 40,
              sheet_y: 43,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F939-1F3FC",
              non_qualified: null,
              image: "1f939-1f3fc.png",
              sheet_x: 40,
              sheet_y: 44,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F939-1F3FD",
              non_qualified: null,
              image: "1f939-1f3fd.png",
              sheet_x: 40,
              sheet_y: 45,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F939-1F3FE",
              non_qualified: null,
              image: "1f939-1f3fe.png",
              sheet_x: 40,
              sheet_y: 46,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F939-1F3FF",
              non_qualified: null,
              image: "1f939-1f3ff.png",
              sheet_x: 40,
              sheet_y: 47,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Juggling",
          b: "1F939",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [40, 42],
          o: 9
        },
        "man-juggling": {
          skin_variations: {
            "1F3FB": {
              unified: "1F939-1F3FB-200D-2642-FE0F",
              non_qualified: "1F939-1F3FB-200D-2642",
              image: "1f939-1f3fb-200d-2642-fe0f.png",
              sheet_x: 40,
              sheet_y: 37,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F939-1F3FC-200D-2642-FE0F",
              non_qualified: "1F939-1F3FC-200D-2642",
              image: "1f939-1f3fc-200d-2642-fe0f.png",
              sheet_x: 40,
              sheet_y: 38,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F939-1F3FD-200D-2642-FE0F",
              non_qualified: "1F939-1F3FD-200D-2642",
              image: "1f939-1f3fd-200d-2642-fe0f.png",
              sheet_x: 40,
              sheet_y: 39,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F939-1F3FE-200D-2642-FE0F",
              non_qualified: "1F939-1F3FE-200D-2642",
              image: "1f939-1f3fe-200d-2642-fe0f.png",
              sheet_x: 40,
              sheet_y: 40,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F939-1F3FF-200D-2642-FE0F",
              non_qualified: "1F939-1F3FF-200D-2642",
              image: "1f939-1f3ff-200d-2642-fe0f.png",
              sheet_x: 40,
              sheet_y: 41,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Man Juggling",
          b: "1F939-200D-2642-FE0F",
          c: "1F939-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          k: [40, 36],
          o: 9
        },
        "woman-juggling": {
          skin_variations: {
            "1F3FB": {
              unified: "1F939-1F3FB-200D-2640-FE0F",
              non_qualified: "1F939-1F3FB-200D-2640",
              image: "1f939-1f3fb-200d-2640-fe0f.png",
              sheet_x: 40,
              sheet_y: 31,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F939-1F3FC-200D-2640-FE0F",
              non_qualified: "1F939-1F3FC-200D-2640",
              image: "1f939-1f3fc-200d-2640-fe0f.png",
              sheet_x: 40,
              sheet_y: 32,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F939-1F3FD-200D-2640-FE0F",
              non_qualified: "1F939-1F3FD-200D-2640",
              image: "1f939-1f3fd-200d-2640-fe0f.png",
              sheet_x: 40,
              sheet_y: 33,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F939-1F3FE-200D-2640-FE0F",
              non_qualified: "1F939-1F3FE-200D-2640",
              image: "1f939-1f3fe-200d-2640-fe0f.png",
              sheet_x: 40,
              sheet_y: 34,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F939-1F3FF-200D-2640-FE0F",
              non_qualified: "1F939-1F3FF-200D-2640",
              image: "1f939-1f3ff-200d-2640-fe0f.png",
              sheet_x: 40,
              sheet_y: 35,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Woman Juggling",
          b: "1F939-200D-2640-FE0F",
          c: "1F939-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          k: [40, 30],
          o: 9
        },
        couple: {
          a: "Man and Woman Holding Hands",
          b: "1F46B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["pair", "people", "human", "love", "date", "dating", "like", "affection", "valentines", "marriage"],
          k: [20, 30],
          n: ["man_and_woman_holding_hands"]
        },
        two_men_holding_hands: {
          a: "Two Men Holding Hands",
          b: "1F46C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["pair", "couple", "love", "like", "bromance", "friendship", "people", "human"],
          k: [20, 31]
        },
        two_women_holding_hands: {
          a: "Two Women Holding Hands",
          b: "1F46D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["pair", "friendship", "couple", "love", "like", "female", "people", "human"],
          k: [20, 32]
        },
        couplekiss: {
          obsoleted_by: "1F469-200D-2764-FE0F-200D-1F48B-200D-1F468",
          a: "Kiss",
          b: "1F48F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          k: [24, 41]
        },
        "woman-kiss-man": {
          obsoletes: "1F48F",
          a: "Woman Kiss Man",
          b: "1F469-200D-2764-FE0F-200D-1F48B-200D-1F468",
          c: "1F469-200D-2764-200D-1F48B-200D-1F468",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [20, 21]
        },
        "man-kiss-man": {
          a: "Man Kiss Man",
          b: "1F468-200D-2764-FE0F-200D-1F48B-200D-1F468",
          c: "1F468-200D-2764-200D-1F48B-200D-1F468",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [18, 10]
        },
        "woman-kiss-woman": {
          a: "Woman Kiss Woman",
          b: "1F469-200D-2764-FE0F-200D-1F48B-200D-1F469",
          c: "1F469-200D-2764-200D-1F48B-200D-1F469",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [20, 22]
        },
        couple_with_heart: {
          obsoleted_by: "1F469-200D-2764-FE0F-200D-1F468",
          a: "Couple with Heart",
          b: "1F491",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          k: [24, 43]
        },
        "woman-heart-man": {
          obsoletes: "1F491",
          a: "Woman Heart Man",
          b: "1F469-200D-2764-FE0F-200D-1F468",
          c: "1F469-200D-2764-200D-1F468",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [20, 19]
        },
        "man-heart-man": {
          a: "Man Heart Man",
          b: "1F468-200D-2764-FE0F-200D-1F468",
          c: "1F468-200D-2764-200D-1F468",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [18, 9]
        },
        "woman-heart-woman": {
          a: "Woman Heart Woman",
          b: "1F469-200D-2764-FE0F-200D-1F469",
          c: "1F469-200D-2764-200D-1F469",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [20, 20]
        },
        family: {
          obsoleted_by: "1F468-200D-1F469-200D-1F466",
          a: "Family",
          b: "1F46A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          k: [20, 29],
          n: ["man-woman-boy"]
        },
        "man-woman-boy": {
          obsoletes: "1F46A",
          a: "Man Woman Boy",
          b: "1F468-200D-1F469-200D-1F466",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [17, 2],
          n: ["family"]
        },
        "man-woman-girl": {
          a: "Man Woman Girl",
          b: "1F468-200D-1F469-200D-1F467",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [17, 4]
        },
        "man-woman-girl-boy": {
          a: "Man Woman Girl Boy",
          b: "1F468-200D-1F469-200D-1F467-200D-1F466",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [17, 5]
        },
        "man-woman-boy-boy": {
          a: "Man Woman Boy Boy",
          b: "1F468-200D-1F469-200D-1F466-200D-1F466",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [17, 3]
        },
        "man-woman-girl-girl": {
          a: "Man Woman Girl Girl",
          b: "1F468-200D-1F469-200D-1F467-200D-1F467",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [17, 6]
        },
        "man-man-boy": {
          a: "Man Man Boy",
          b: "1F468-200D-1F468-200D-1F466",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [16, 49]
        },
        "man-man-girl": {
          a: "Man Man Girl",
          b: "1F468-200D-1F468-200D-1F467",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [16, 51]
        },
        "man-man-girl-boy": {
          a: "Man Man Girl Boy",
          b: "1F468-200D-1F468-200D-1F467-200D-1F466",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [17, 0]
        },
        "man-man-boy-boy": {
          a: "Man Man Boy Boy",
          b: "1F468-200D-1F468-200D-1F466-200D-1F466",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [16, 50]
        },
        "man-man-girl-girl": {
          a: "Man Man Girl Girl",
          b: "1F468-200D-1F468-200D-1F467-200D-1F467",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [17, 1]
        },
        "woman-woman-boy": {
          a: "Woman Woman Boy",
          b: "1F469-200D-1F469-200D-1F466",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [19, 12]
        },
        "woman-woman-girl": {
          a: "Woman Woman Girl",
          b: "1F469-200D-1F469-200D-1F467",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [19, 14]
        },
        "woman-woman-girl-boy": {
          a: "Woman Woman Girl Boy",
          b: "1F469-200D-1F469-200D-1F467-200D-1F466",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [19, 15]
        },
        "woman-woman-boy-boy": {
          a: "Woman Woman Boy Boy",
          b: "1F469-200D-1F469-200D-1F466-200D-1F466",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [19, 13]
        },
        "woman-woman-girl-girl": {
          a: "Woman Woman Girl Girl",
          b: "1F469-200D-1F469-200D-1F467-200D-1F467",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [19, 16]
        },
        "man-boy": {
          a: "Man Boy",
          b: "1F468-200D-1F466",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [16, 45]
        },
        "man-boy-boy": {
          a: "Man Boy Boy",
          b: "1F468-200D-1F466-200D-1F466",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [16, 44]
        },
        "man-girl": {
          a: "Man Girl",
          b: "1F468-200D-1F467",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [16, 48]
        },
        "man-girl-boy": {
          a: "Man Girl Boy",
          b: "1F468-200D-1F467-200D-1F466",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [16, 46]
        },
        "man-girl-girl": {
          a: "Man Girl Girl",
          b: "1F468-200D-1F467-200D-1F467",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [16, 47]
        },
        "woman-boy": {
          a: "Woman Boy",
          b: "1F469-200D-1F466",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [19, 8]
        },
        "woman-boy-boy": {
          a: "Woman Boy Boy",
          b: "1F469-200D-1F466-200D-1F466",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [19, 7]
        },
        "woman-girl": {
          a: "Woman Girl",
          b: "1F469-200D-1F467",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [19, 11]
        },
        "woman-girl-boy": {
          a: "Woman Girl Boy",
          b: "1F469-200D-1F467-200D-1F466",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [19, 9]
        },
        "woman-girl-girl": {
          a: "Woman Girl Girl",
          b: "1F469-200D-1F467-200D-1F467",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [19, 10]
        },
        selfie: {
          skin_variations: {
            "1F3FB": {
              unified: "1F933-1F3FB",
              non_qualified: null,
              image: "1f933-1f3fb.png",
              sheet_x: 39,
              sheet_y: 23,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F933-1F3FC",
              non_qualified: null,
              image: "1f933-1f3fc.png",
              sheet_x: 39,
              sheet_y: 24,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F933-1F3FD",
              non_qualified: null,
              image: "1f933-1f3fd.png",
              sheet_x: 39,
              sheet_y: 25,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F933-1F3FE",
              non_qualified: null,
              image: "1f933-1f3fe.png",
              sheet_x: 39,
              sheet_y: 26,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F933-1F3FF",
              non_qualified: null,
              image: "1f933-1f3ff.png",
              sheet_x: 39,
              sheet_y: 27,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Selfie",
          b: "1F933",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["camera", "phone"],
          k: [39, 22],
          o: 9
        },
        muscle: {
          skin_variations: {
            "1F3FB": {
              unified: "1F4AA-1F3FB",
              non_qualified: null,
              image: "1f4aa-1f3fb.png",
              sheet_x: 25,
              sheet_y: 17,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F4AA-1F3FC",
              non_qualified: null,
              image: "1f4aa-1f3fc.png",
              sheet_x: 25,
              sheet_y: 18,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F4AA-1F3FD",
              non_qualified: null,
              image: "1f4aa-1f3fd.png",
              sheet_x: 25,
              sheet_y: 19,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F4AA-1F3FE",
              non_qualified: null,
              image: "1f4aa-1f3fe.png",
              sheet_x: 25,
              sheet_y: 20,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F4AA-1F3FF",
              non_qualified: null,
              image: "1f4aa-1f3ff.png",
              sheet_x: 25,
              sheet_y: 21,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Flexed Biceps",
          b: "1F4AA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["arm", "flex", "hand", "summer", "strong", "biceps"],
          k: [25, 16]
        },
        point_left: {
          skin_variations: {
            "1F3FB": {
              unified: "1F448-1F3FB",
              non_qualified: null,
              image: "1f448-1f3fb.png",
              sheet_x: 14,
              sheet_y: 20,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F448-1F3FC",
              non_qualified: null,
              image: "1f448-1f3fc.png",
              sheet_x: 14,
              sheet_y: 21,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F448-1F3FD",
              non_qualified: null,
              image: "1f448-1f3fd.png",
              sheet_x: 14,
              sheet_y: 22,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F448-1F3FE",
              non_qualified: null,
              image: "1f448-1f3fe.png",
              sheet_x: 14,
              sheet_y: 23,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F448-1F3FF",
              non_qualified: null,
              image: "1f448-1f3ff.png",
              sheet_x: 14,
              sheet_y: 24,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "White Left Pointing Backhand Index",
          b: "1F448",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["direction", "fingers", "hand", "left"],
          k: [14, 19]
        },
        point_right: {
          skin_variations: {
            "1F3FB": {
              unified: "1F449-1F3FB",
              non_qualified: null,
              image: "1f449-1f3fb.png",
              sheet_x: 14,
              sheet_y: 26,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F449-1F3FC",
              non_qualified: null,
              image: "1f449-1f3fc.png",
              sheet_x: 14,
              sheet_y: 27,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F449-1F3FD",
              non_qualified: null,
              image: "1f449-1f3fd.png",
              sheet_x: 14,
              sheet_y: 28,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F449-1F3FE",
              non_qualified: null,
              image: "1f449-1f3fe.png",
              sheet_x: 14,
              sheet_y: 29,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F449-1F3FF",
              non_qualified: null,
              image: "1f449-1f3ff.png",
              sheet_x: 14,
              sheet_y: 30,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "White Right Pointing Backhand Index",
          b: "1F449",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fingers", "hand", "direction", "right"],
          k: [14, 25]
        },
        point_up: {
          skin_variations: {
            "1F3FB": {
              unified: "261D-1F3FB",
              non_qualified: null,
              image: "261d-1f3fb.png",
              sheet_x: 47,
              sheet_y: 27,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "261D-1F3FC",
              non_qualified: null,
              image: "261d-1f3fc.png",
              sheet_x: 47,
              sheet_y: 28,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "261D-1F3FD",
              non_qualified: null,
              image: "261d-1f3fd.png",
              sheet_x: 47,
              sheet_y: 29,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "261D-1F3FE",
              non_qualified: null,
              image: "261d-1f3fe.png",
              sheet_x: 47,
              sheet_y: 30,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "261D-1F3FF",
              non_qualified: null,
              image: "261d-1f3ff.png",
              sheet_x: 47,
              sheet_y: 31,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "White Up Pointing Index",
          b: "261D-FE0F",
          c: "261D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["hand", "fingers", "direction", "up"],
          k: [47, 26],
          o: 1
        },
        point_up_2: {
          skin_variations: {
            "1F3FB": {
              unified: "1F446-1F3FB",
              non_qualified: null,
              image: "1f446-1f3fb.png",
              sheet_x: 14,
              sheet_y: 8,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F446-1F3FC",
              non_qualified: null,
              image: "1f446-1f3fc.png",
              sheet_x: 14,
              sheet_y: 9,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F446-1F3FD",
              non_qualified: null,
              image: "1f446-1f3fd.png",
              sheet_x: 14,
              sheet_y: 10,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F446-1F3FE",
              non_qualified: null,
              image: "1f446-1f3fe.png",
              sheet_x: 14,
              sheet_y: 11,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F446-1F3FF",
              non_qualified: null,
              image: "1f446-1f3ff.png",
              sheet_x: 14,
              sheet_y: 12,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "White Up Pointing Backhand Index",
          b: "1F446",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fingers", "hand", "direction", "up"],
          k: [14, 7]
        },
        middle_finger: {
          skin_variations: {
            "1F3FB": {
              unified: "1F595-1F3FB",
              non_qualified: null,
              image: "1f595-1f3fb.png",
              sheet_x: 29,
              sheet_y: 39,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F595-1F3FC",
              non_qualified: null,
              image: "1f595-1f3fc.png",
              sheet_x: 29,
              sheet_y: 40,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F595-1F3FD",
              non_qualified: null,
              image: "1f595-1f3fd.png",
              sheet_x: 29,
              sheet_y: 41,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F595-1F3FE",
              non_qualified: null,
              image: "1f595-1f3fe.png",
              sheet_x: 29,
              sheet_y: 42,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F595-1F3FF",
              non_qualified: null,
              image: "1f595-1f3ff.png",
              sheet_x: 29,
              sheet_y: 43,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Reversed Hand with Middle Finger Extended",
          b: "1F595",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [29, 38],
          n: ["reversed_hand_with_middle_finger_extended"],
          o: 7
        },
        point_down: {
          skin_variations: {
            "1F3FB": {
              unified: "1F447-1F3FB",
              non_qualified: null,
              image: "1f447-1f3fb.png",
              sheet_x: 14,
              sheet_y: 14,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F447-1F3FC",
              non_qualified: null,
              image: "1f447-1f3fc.png",
              sheet_x: 14,
              sheet_y: 15,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F447-1F3FD",
              non_qualified: null,
              image: "1f447-1f3fd.png",
              sheet_x: 14,
              sheet_y: 16,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F447-1F3FE",
              non_qualified: null,
              image: "1f447-1f3fe.png",
              sheet_x: 14,
              sheet_y: 17,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F447-1F3FF",
              non_qualified: null,
              image: "1f447-1f3ff.png",
              sheet_x: 14,
              sheet_y: 18,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "White Down Pointing Backhand Index",
          b: "1F447",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fingers", "hand", "direction", "down"],
          k: [14, 13]
        },
        v: {
          skin_variations: {
            "1F3FB": {
              unified: "270C-1F3FB",
              non_qualified: null,
              image: "270c-1f3fb.png",
              sheet_x: 49,
              sheet_y: 31,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "270C-1F3FC",
              non_qualified: null,
              image: "270c-1f3fc.png",
              sheet_x: 49,
              sheet_y: 32,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "270C-1F3FD",
              non_qualified: null,
              image: "270c-1f3fd.png",
              sheet_x: 49,
              sheet_y: 33,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "270C-1F3FE",
              non_qualified: null,
              image: "270c-1f3fe.png",
              sheet_x: 49,
              sheet_y: 34,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "270C-1F3FF",
              non_qualified: null,
              image: "270c-1f3ff.png",
              sheet_x: 49,
              sheet_y: 35,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Victory Hand",
          b: "270C-FE0F",
          c: "270C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fingers", "ohyeah", "hand", "peace", "victory", "two"],
          k: [49, 30],
          o: 1
        },
        crossed_fingers: {
          skin_variations: {
            "1F3FB": {
              unified: "1F91E-1F3FB",
              non_qualified: null,
              image: "1f91e-1f3fb.png",
              sheet_x: 38,
              sheet_y: 12,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F91E-1F3FC",
              non_qualified: null,
              image: "1f91e-1f3fc.png",
              sheet_x: 38,
              sheet_y: 13,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F91E-1F3FD",
              non_qualified: null,
              image: "1f91e-1f3fd.png",
              sheet_x: 38,
              sheet_y: 14,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F91E-1F3FE",
              non_qualified: null,
              image: "1f91e-1f3fe.png",
              sheet_x: 38,
              sheet_y: 15,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F91E-1F3FF",
              non_qualified: null,
              image: "1f91e-1f3ff.png",
              sheet_x: 38,
              sheet_y: 16,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Hand with Index and Middle Fingers Crossed",
          b: "1F91E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["good", "lucky"],
          k: [38, 11],
          n: ["hand_with_index_and_middle_fingers_crossed"],
          o: 9
        },
        "spock-hand": {
          skin_variations: {
            "1F3FB": {
              unified: "1F596-1F3FB",
              non_qualified: null,
              image: "1f596-1f3fb.png",
              sheet_x: 29,
              sheet_y: 45,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F596-1F3FC",
              non_qualified: null,
              image: "1f596-1f3fc.png",
              sheet_x: 29,
              sheet_y: 46,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F596-1F3FD",
              non_qualified: null,
              image: "1f596-1f3fd.png",
              sheet_x: 29,
              sheet_y: 47,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F596-1F3FE",
              non_qualified: null,
              image: "1f596-1f3fe.png",
              sheet_x: 29,
              sheet_y: 48,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F596-1F3FF",
              non_qualified: null,
              image: "1f596-1f3ff.png",
              sheet_x: 29,
              sheet_y: 49,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Raised Hand with Part Between Middle and Ring Fingers",
          b: "1F596",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [29, 44],
          o: 7
        },
        the_horns: {
          skin_variations: {
            "1F3FB": {
              unified: "1F918-1F3FB",
              non_qualified: null,
              image: "1f918-1f3fb.png",
              sheet_x: 37,
              sheet_y: 33,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F918-1F3FC",
              non_qualified: null,
              image: "1f918-1f3fc.png",
              sheet_x: 37,
              sheet_y: 34,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F918-1F3FD",
              non_qualified: null,
              image: "1f918-1f3fd.png",
              sheet_x: 37,
              sheet_y: 35,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F918-1F3FE",
              non_qualified: null,
              image: "1f918-1f3fe.png",
              sheet_x: 37,
              sheet_y: 36,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F918-1F3FF",
              non_qualified: null,
              image: "1f918-1f3ff.png",
              sheet_x: 37,
              sheet_y: 37,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Sign of the Horns",
          b: "1F918",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [37, 32],
          n: ["sign_of_the_horns"],
          o: 8
        },
        call_me_hand: {
          skin_variations: {
            "1F3FB": {
              unified: "1F919-1F3FB",
              non_qualified: null,
              image: "1f919-1f3fb.png",
              sheet_x: 37,
              sheet_y: 39,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F919-1F3FC",
              non_qualified: null,
              image: "1f919-1f3fc.png",
              sheet_x: 37,
              sheet_y: 40,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F919-1F3FD",
              non_qualified: null,
              image: "1f919-1f3fd.png",
              sheet_x: 37,
              sheet_y: 41,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F919-1F3FE",
              non_qualified: null,
              image: "1f919-1f3fe.png",
              sheet_x: 37,
              sheet_y: 42,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F919-1F3FF",
              non_qualified: null,
              image: "1f919-1f3ff.png",
              sheet_x: 37,
              sheet_y: 43,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Call Me Hand",
          b: "1F919",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["hands", "gesture"],
          k: [37, 38],
          o: 9
        },
        raised_hand_with_fingers_splayed: {
          skin_variations: {
            "1F3FB": {
              unified: "1F590-1F3FB",
              non_qualified: null,
              image: "1f590-1f3fb.png",
              sheet_x: 29,
              sheet_y: 33,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F590-1F3FC",
              non_qualified: null,
              image: "1f590-1f3fc.png",
              sheet_x: 29,
              sheet_y: 34,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F590-1F3FD",
              non_qualified: null,
              image: "1f590-1f3fd.png",
              sheet_x: 29,
              sheet_y: 35,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F590-1F3FE",
              non_qualified: null,
              image: "1f590-1f3fe.png",
              sheet_x: 29,
              sheet_y: 36,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F590-1F3FF",
              non_qualified: null,
              image: "1f590-1f3ff.png",
              sheet_x: 29,
              sheet_y: 37,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Raised Hand with Fingers Splayed",
          b: "1F590-FE0F",
          c: "1F590",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["hand", "fingers", "palm"],
          k: [29, 32],
          o: 7
        },
        hand: {
          skin_variations: {
            "1F3FB": {
              unified: "270B-1F3FB",
              non_qualified: null,
              image: "270b-1f3fb.png",
              sheet_x: 49,
              sheet_y: 25,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "270B-1F3FC",
              non_qualified: null,
              image: "270b-1f3fc.png",
              sheet_x: 49,
              sheet_y: 26,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "270B-1F3FD",
              non_qualified: null,
              image: "270b-1f3fd.png",
              sheet_x: 49,
              sheet_y: 27,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "270B-1F3FE",
              non_qualified: null,
              image: "270b-1f3fe.png",
              sheet_x: 49,
              sheet_y: 28,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "270B-1F3FF",
              non_qualified: null,
              image: "270b-1f3ff.png",
              sheet_x: 49,
              sheet_y: 29,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Raised Hand",
          b: "270B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [49, 24],
          n: ["raised_hand"]
        },
        ok_hand: {
          skin_variations: {
            "1F3FB": {
              unified: "1F44C-1F3FB",
              non_qualified: null,
              image: "1f44c-1f3fb.png",
              sheet_x: 14,
              sheet_y: 44,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F44C-1F3FC",
              non_qualified: null,
              image: "1f44c-1f3fc.png",
              sheet_x: 14,
              sheet_y: 45,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F44C-1F3FD",
              non_qualified: null,
              image: "1f44c-1f3fd.png",
              sheet_x: 14,
              sheet_y: 46,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F44C-1F3FE",
              non_qualified: null,
              image: "1f44c-1f3fe.png",
              sheet_x: 14,
              sheet_y: 47,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F44C-1F3FF",
              non_qualified: null,
              image: "1f44c-1f3ff.png",
              sheet_x: 14,
              sheet_y: 48,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Ok Hand Sign",
          b: "1F44C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fingers", "limbs", "perfect", "ok", "okay"],
          k: [14, 43]
        },
        "+1": {
          skin_variations: {
            "1F3FB": {
              unified: "1F44D-1F3FB",
              non_qualified: null,
              image: "1f44d-1f3fb.png",
              sheet_x: 14,
              sheet_y: 50,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F44D-1F3FC",
              non_qualified: null,
              image: "1f44d-1f3fc.png",
              sheet_x: 14,
              sheet_y: 51,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F44D-1F3FD",
              non_qualified: null,
              image: "1f44d-1f3fd.png",
              sheet_x: 15,
              sheet_y: 0,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F44D-1F3FE",
              non_qualified: null,
              image: "1f44d-1f3fe.png",
              sheet_x: 15,
              sheet_y: 1,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F44D-1F3FF",
              non_qualified: null,
              image: "1f44d-1f3ff.png",
              sheet_x: 15,
              sheet_y: 2,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Thumbs Up Sign",
          b: "1F44D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["thumbsup", "yes", "awesome", "good", "agree", "accept", "cool", "hand", "like"],
          k: [14, 49],
          n: ["thumbsup"]
        },
        "-1": {
          skin_variations: {
            "1F3FB": {
              unified: "1F44E-1F3FB",
              non_qualified: null,
              image: "1f44e-1f3fb.png",
              sheet_x: 15,
              sheet_y: 4,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F44E-1F3FC",
              non_qualified: null,
              image: "1f44e-1f3fc.png",
              sheet_x: 15,
              sheet_y: 5,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F44E-1F3FD",
              non_qualified: null,
              image: "1f44e-1f3fd.png",
              sheet_x: 15,
              sheet_y: 6,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F44E-1F3FE",
              non_qualified: null,
              image: "1f44e-1f3fe.png",
              sheet_x: 15,
              sheet_y: 7,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F44E-1F3FF",
              non_qualified: null,
              image: "1f44e-1f3ff.png",
              sheet_x: 15,
              sheet_y: 8,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Thumbs Down Sign",
          b: "1F44E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["thumbsdown", "no", "dislike", "hand"],
          k: [15, 3],
          n: ["thumbsdown"]
        },
        fist: {
          skin_variations: {
            "1F3FB": {
              unified: "270A-1F3FB",
              non_qualified: null,
              image: "270a-1f3fb.png",
              sheet_x: 49,
              sheet_y: 19,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "270A-1F3FC",
              non_qualified: null,
              image: "270a-1f3fc.png",
              sheet_x: 49,
              sheet_y: 20,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "270A-1F3FD",
              non_qualified: null,
              image: "270a-1f3fd.png",
              sheet_x: 49,
              sheet_y: 21,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "270A-1F3FE",
              non_qualified: null,
              image: "270a-1f3fe.png",
              sheet_x: 49,
              sheet_y: 22,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "270A-1F3FF",
              non_qualified: null,
              image: "270a-1f3ff.png",
              sheet_x: 49,
              sheet_y: 23,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Raised Fist",
          b: "270A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fingers", "hand", "grasp"],
          k: [49, 18]
        },
        facepunch: {
          skin_variations: {
            "1F3FB": {
              unified: "1F44A-1F3FB",
              non_qualified: null,
              image: "1f44a-1f3fb.png",
              sheet_x: 14,
              sheet_y: 32,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F44A-1F3FC",
              non_qualified: null,
              image: "1f44a-1f3fc.png",
              sheet_x: 14,
              sheet_y: 33,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F44A-1F3FD",
              non_qualified: null,
              image: "1f44a-1f3fd.png",
              sheet_x: 14,
              sheet_y: 34,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F44A-1F3FE",
              non_qualified: null,
              image: "1f44a-1f3fe.png",
              sheet_x: 14,
              sheet_y: 35,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F44A-1F3FF",
              non_qualified: null,
              image: "1f44a-1f3ff.png",
              sheet_x: 14,
              sheet_y: 36,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Fisted Hand Sign",
          b: "1F44A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["angry", "violence", "fist", "hit", "attack", "hand"],
          k: [14, 31],
          n: ["punch"]
        },
        "left-facing_fist": {
          skin_variations: {
            "1F3FB": {
              unified: "1F91B-1F3FB",
              non_qualified: null,
              image: "1f91b-1f3fb.png",
              sheet_x: 37,
              sheet_y: 51,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F91B-1F3FC",
              non_qualified: null,
              image: "1f91b-1f3fc.png",
              sheet_x: 38,
              sheet_y: 0,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F91B-1F3FD",
              non_qualified: null,
              image: "1f91b-1f3fd.png",
              sheet_x: 38,
              sheet_y: 1,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F91B-1F3FE",
              non_qualified: null,
              image: "1f91b-1f3fe.png",
              sheet_x: 38,
              sheet_y: 2,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F91B-1F3FF",
              non_qualified: null,
              image: "1f91b-1f3ff.png",
              sheet_x: 38,
              sheet_y: 3,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Left-Facing Fist",
          b: "1F91B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [37, 50],
          o: 9
        },
        "right-facing_fist": {
          skin_variations: {
            "1F3FB": {
              unified: "1F91C-1F3FB",
              non_qualified: null,
              image: "1f91c-1f3fb.png",
              sheet_x: 38,
              sheet_y: 5,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F91C-1F3FC",
              non_qualified: null,
              image: "1f91c-1f3fc.png",
              sheet_x: 38,
              sheet_y: 6,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F91C-1F3FD",
              non_qualified: null,
              image: "1f91c-1f3fd.png",
              sheet_x: 38,
              sheet_y: 7,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F91C-1F3FE",
              non_qualified: null,
              image: "1f91c-1f3fe.png",
              sheet_x: 38,
              sheet_y: 8,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F91C-1F3FF",
              non_qualified: null,
              image: "1f91c-1f3ff.png",
              sheet_x: 38,
              sheet_y: 9,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Right-Facing Fist",
          b: "1F91C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [38, 4],
          o: 9
        },
        raised_back_of_hand: {
          skin_variations: {
            "1F3FB": {
              unified: "1F91A-1F3FB",
              non_qualified: null,
              image: "1f91a-1f3fb.png",
              sheet_x: 37,
              sheet_y: 45,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F91A-1F3FC",
              non_qualified: null,
              image: "1f91a-1f3fc.png",
              sheet_x: 37,
              sheet_y: 46,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F91A-1F3FD",
              non_qualified: null,
              image: "1f91a-1f3fd.png",
              sheet_x: 37,
              sheet_y: 47,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F91A-1F3FE",
              non_qualified: null,
              image: "1f91a-1f3fe.png",
              sheet_x: 37,
              sheet_y: 48,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F91A-1F3FF",
              non_qualified: null,
              image: "1f91a-1f3ff.png",
              sheet_x: 37,
              sheet_y: 49,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Raised Back of Hand",
          b: "1F91A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["fingers", "raised", "backhand"],
          k: [37, 44],
          o: 9
        },
        wave: {
          skin_variations: {
            "1F3FB": {
              unified: "1F44B-1F3FB",
              non_qualified: null,
              image: "1f44b-1f3fb.png",
              sheet_x: 14,
              sheet_y: 38,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F44B-1F3FC",
              non_qualified: null,
              image: "1f44b-1f3fc.png",
              sheet_x: 14,
              sheet_y: 39,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F44B-1F3FD",
              non_qualified: null,
              image: "1f44b-1f3fd.png",
              sheet_x: 14,
              sheet_y: 40,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F44B-1F3FE",
              non_qualified: null,
              image: "1f44b-1f3fe.png",
              sheet_x: 14,
              sheet_y: 41,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F44B-1F3FF",
              non_qualified: null,
              image: "1f44b-1f3ff.png",
              sheet_x: 14,
              sheet_y: 42,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Waving Hand Sign",
          b: "1F44B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["hands", "gesture", "goodbye", "solong", "farewell", "hello", "hi", "palm"],
          k: [14, 37]
        },
        i_love_you_hand_sign: {
          skin_variations: {
            "1F3FB": {
              unified: "1F91F-1F3FB",
              non_qualified: null,
              image: "1f91f-1f3fb.png",
              sheet_x: 38,
              sheet_y: 18,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F91F-1F3FC",
              non_qualified: null,
              image: "1f91f-1f3fc.png",
              sheet_x: 38,
              sheet_y: 19,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F91F-1F3FD",
              non_qualified: null,
              image: "1f91f-1f3fd.png",
              sheet_x: 38,
              sheet_y: 20,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F91F-1F3FE",
              non_qualified: null,
              image: "1f91f-1f3fe.png",
              sheet_x: 38,
              sheet_y: 21,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F91F-1F3FF",
              non_qualified: null,
              image: "1f91f-1f3ff.png",
              sheet_x: 38,
              sheet_y: 22,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "I Love You Hand Sign",
          b: "1F91F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [38, 17],
          o: 10
        },
        writing_hand: {
          skin_variations: {
            "1F3FB": {
              unified: "270D-1F3FB",
              non_qualified: null,
              image: "270d-1f3fb.png",
              sheet_x: 49,
              sheet_y: 37,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "270D-1F3FC",
              non_qualified: null,
              image: "270d-1f3fc.png",
              sheet_x: 49,
              sheet_y: 38,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "270D-1F3FD",
              non_qualified: null,
              image: "270d-1f3fd.png",
              sheet_x: 49,
              sheet_y: 39,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "270D-1F3FE",
              non_qualified: null,
              image: "270d-1f3fe.png",
              sheet_x: 49,
              sheet_y: 40,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "270D-1F3FF",
              non_qualified: null,
              image: "270d-1f3ff.png",
              sheet_x: 49,
              sheet_y: 41,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Writing Hand",
          b: "270D-FE0F",
          c: "270D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["lower_left_ballpoint_pen", "stationery", "write", "compose"],
          k: [49, 36],
          o: 1
        },
        clap: {
          skin_variations: {
            "1F3FB": {
              unified: "1F44F-1F3FB",
              non_qualified: null,
              image: "1f44f-1f3fb.png",
              sheet_x: 15,
              sheet_y: 10,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F44F-1F3FC",
              non_qualified: null,
              image: "1f44f-1f3fc.png",
              sheet_x: 15,
              sheet_y: 11,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F44F-1F3FD",
              non_qualified: null,
              image: "1f44f-1f3fd.png",
              sheet_x: 15,
              sheet_y: 12,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F44F-1F3FE",
              non_qualified: null,
              image: "1f44f-1f3fe.png",
              sheet_x: 15,
              sheet_y: 13,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F44F-1F3FF",
              non_qualified: null,
              image: "1f44f-1f3ff.png",
              sheet_x: 15,
              sheet_y: 14,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Clapping Hands Sign",
          b: "1F44F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["hands", "praise", "applause", "congrats", "yay"],
          k: [15, 9]
        },
        open_hands: {
          skin_variations: {
            "1F3FB": {
              unified: "1F450-1F3FB",
              non_qualified: null,
              image: "1f450-1f3fb.png",
              sheet_x: 15,
              sheet_y: 16,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F450-1F3FC",
              non_qualified: null,
              image: "1f450-1f3fc.png",
              sheet_x: 15,
              sheet_y: 17,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F450-1F3FD",
              non_qualified: null,
              image: "1f450-1f3fd.png",
              sheet_x: 15,
              sheet_y: 18,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F450-1F3FE",
              non_qualified: null,
              image: "1f450-1f3fe.png",
              sheet_x: 15,
              sheet_y: 19,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F450-1F3FF",
              non_qualified: null,
              image: "1f450-1f3ff.png",
              sheet_x: 15,
              sheet_y: 20,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Open Hands Sign",
          b: "1F450",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fingers", "butterfly", "hands", "open"],
          k: [15, 15]
        },
        raised_hands: {
          skin_variations: {
            "1F3FB": {
              unified: "1F64C-1F3FB",
              non_qualified: null,
              image: "1f64c-1f3fb.png",
              sheet_x: 33,
              sheet_y: 13,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F64C-1F3FC",
              non_qualified: null,
              image: "1f64c-1f3fc.png",
              sheet_x: 33,
              sheet_y: 14,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F64C-1F3FD",
              non_qualified: null,
              image: "1f64c-1f3fd.png",
              sheet_x: 33,
              sheet_y: 15,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F64C-1F3FE",
              non_qualified: null,
              image: "1f64c-1f3fe.png",
              sheet_x: 33,
              sheet_y: 16,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F64C-1F3FF",
              non_qualified: null,
              image: "1f64c-1f3ff.png",
              sheet_x: 33,
              sheet_y: 17,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Person Raising Both Hands in Celebration",
          b: "1F64C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["gesture", "hooray", "yea", "celebration", "hands"],
          k: [33, 12]
        },
        palms_up_together: {
          skin_variations: {
            "1F3FB": {
              unified: "1F932-1F3FB",
              non_qualified: null,
              image: "1f932-1f3fb.png",
              sheet_x: 39,
              sheet_y: 17,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F932-1F3FC",
              non_qualified: null,
              image: "1f932-1f3fc.png",
              sheet_x: 39,
              sheet_y: 18,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F932-1F3FD",
              non_qualified: null,
              image: "1f932-1f3fd.png",
              sheet_x: 39,
              sheet_y: 19,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F932-1F3FE",
              non_qualified: null,
              image: "1f932-1f3fe.png",
              sheet_x: 39,
              sheet_y: 20,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F932-1F3FF",
              non_qualified: null,
              image: "1f932-1f3ff.png",
              sheet_x: 39,
              sheet_y: 21,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Palms Up Together",
          b: "1F932",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [39, 16],
          o: 10
        },
        pray: {
          skin_variations: {
            "1F3FB": {
              unified: "1F64F-1F3FB",
              non_qualified: null,
              image: "1f64f-1f3fb.png",
              sheet_x: 34,
              sheet_y: 3,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F64F-1F3FC",
              non_qualified: null,
              image: "1f64f-1f3fc.png",
              sheet_x: 34,
              sheet_y: 4,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F64F-1F3FD",
              non_qualified: null,
              image: "1f64f-1f3fd.png",
              sheet_x: 34,
              sheet_y: 5,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F64F-1F3FE",
              non_qualified: null,
              image: "1f64f-1f3fe.png",
              sheet_x: 34,
              sheet_y: 6,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F64F-1F3FF",
              non_qualified: null,
              image: "1f64f-1f3ff.png",
              sheet_x: 34,
              sheet_y: 7,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Person with Folded Hands",
          b: "1F64F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["please", "hope", "wish", "namaste", "highfive"],
          k: [34, 2]
        },
        handshake: {
          a: "Handshake",
          b: "1F91D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["agreement", "shake"],
          k: [38, 10],
          o: 9
        },
        nail_care: {
          skin_variations: {
            "1F3FB": {
              unified: "1F485-1F3FB",
              non_qualified: null,
              image: "1f485-1f3fb.png",
              sheet_x: 23,
              sheet_y: 45,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F485-1F3FC",
              non_qualified: null,
              image: "1f485-1f3fc.png",
              sheet_x: 23,
              sheet_y: 46,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F485-1F3FD",
              non_qualified: null,
              image: "1f485-1f3fd.png",
              sheet_x: 23,
              sheet_y: 47,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F485-1F3FE",
              non_qualified: null,
              image: "1f485-1f3fe.png",
              sheet_x: 23,
              sheet_y: 48,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F485-1F3FF",
              non_qualified: null,
              image: "1f485-1f3ff.png",
              sheet_x: 23,
              sheet_y: 49,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Nail Polish",
          b: "1F485",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["beauty", "manicure", "finger", "fashion", "nail"],
          k: [23, 44]
        },
        ear: {
          skin_variations: {
            "1F3FB": {
              unified: "1F442-1F3FB",
              non_qualified: null,
              image: "1f442-1f3fb.png",
              sheet_x: 13,
              sheet_y: 46,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F442-1F3FC",
              non_qualified: null,
              image: "1f442-1f3fc.png",
              sheet_x: 13,
              sheet_y: 47,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F442-1F3FD",
              non_qualified: null,
              image: "1f442-1f3fd.png",
              sheet_x: 13,
              sheet_y: 48,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F442-1F3FE",
              non_qualified: null,
              image: "1f442-1f3fe.png",
              sheet_x: 13,
              sheet_y: 49,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F442-1F3FF",
              non_qualified: null,
              image: "1f442-1f3ff.png",
              sheet_x: 13,
              sheet_y: 50,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Ear",
          b: "1F442",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "hear", "sound", "listen"],
          k: [13, 45]
        },
        nose: {
          skin_variations: {
            "1F3FB": {
              unified: "1F443-1F3FB",
              non_qualified: null,
              image: "1f443-1f3fb.png",
              sheet_x: 14,
              sheet_y: 0,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F443-1F3FC",
              non_qualified: null,
              image: "1f443-1f3fc.png",
              sheet_x: 14,
              sheet_y: 1,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F443-1F3FD",
              non_qualified: null,
              image: "1f443-1f3fd.png",
              sheet_x: 14,
              sheet_y: 2,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F443-1F3FE",
              non_qualified: null,
              image: "1f443-1f3fe.png",
              sheet_x: 14,
              sheet_y: 3,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F443-1F3FF",
              non_qualified: null,
              image: "1f443-1f3ff.png",
              sheet_x: 14,
              sheet_y: 4,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Nose",
          b: "1F443",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["smell", "sniff"],
          k: [13, 51]
        },
        footprints: {
          a: "Footprints",
          b: "1F463",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["feet", "tracking", "walking", "beach"],
          k: [15, 39]
        },
        eyes: {
          a: "Eyes",
          b: "1F440",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["look", "watch", "stalk", "peek", "see"],
          k: [13, 42]
        },
        eye: {
          a: "Eye",
          b: "1F441-FE0F",
          c: "1F441",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["face", "look", "see", "watch", "stare"],
          k: [13, 44],
          o: 7
        },
        "eye-in-speech-bubble": {
          a: "Eye in Speech Bubble",
          b: "1F441-FE0F-200D-1F5E8-FE0F",
          d: !0,
          e: !0,
          f: !1,
          g: !0,
          h: !1,
          i: !1,
          k: [13, 43],
          o: 7
        },
        brain: {
          a: "Brain",
          b: "1F9E0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [46, 22],
          o: 10
        },
        tongue: {
          a: "Tongue",
          b: "1F445",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["mouth", "playful"],
          k: [14, 6]
        },
        lips: {
          a: "Mouth",
          b: "1F444",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["mouth", "kiss"],
          k: [14, 5]
        },
        kiss: {
          a: "Kiss Mark",
          b: "1F48B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "lips", "love", "like", "affection", "valentines"],
          k: [24, 37]
        },
        cupid: {
          a: "Heart with Arrow",
          b: "1F498",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["love", "like", "heart", "affection", "valentines"],
          k: [24, 50]
        },
        heart: {
          a: "Heavy Black Heart",
          b: "2764-FE0F",
          c: "2764",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["love", "like", "valentines"],
          k: [50, 8],
          l: ["<3"],
          m: "<3",
          o: 1
        },
        heartbeat: {
          a: "Beating Heart",
          b: "1F493",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["love", "like", "affection", "valentines", "pink", "heart"],
          k: [24, 45]
        },
        broken_heart: {
          a: "Broken Heart",
          b: "1F494",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sad", "sorry", "break", "heart", "heartbreak"],
          k: [24, 46],
          l: ["</3"],
          m: "</3"
        },
        two_hearts: {
          a: "Two Hearts",
          b: "1F495",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["love", "like", "affection", "valentines", "heart"],
          k: [24, 47]
        },
        sparkling_heart: {
          a: "Sparkling Heart",
          b: "1F496",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["love", "like", "affection", "valentines"],
          k: [24, 48]
        },
        heartpulse: {
          a: "Growing Heart",
          b: "1F497",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["like", "love", "affection", "valentines", "pink"],
          k: [24, 49]
        },
        blue_heart: {
          a: "Blue Heart",
          b: "1F499",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["love", "like", "affection", "valentines"],
          k: [24, 51],
          m: "<3"
        },
        green_heart: {
          a: "Green Heart",
          b: "1F49A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["love", "like", "affection", "valentines"],
          k: [25, 0],
          m: "<3"
        },
        yellow_heart: {
          a: "Yellow Heart",
          b: "1F49B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["love", "like", "affection", "valentines"],
          k: [25, 1],
          m: "<3"
        },
        orange_heart: {
          a: "Orange Heart",
          b: "1F9E1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [46, 23],
          o: 10
        },
        purple_heart: {
          a: "Purple Heart",
          b: "1F49C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["love", "like", "affection", "valentines"],
          k: [25, 2],
          m: "<3"
        },
        black_heart: {
          a: "Black Heart",
          b: "1F5A4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["evil"],
          k: [29, 50],
          o: 9
        },
        gift_heart: {
          a: "Heart with Ribbon",
          b: "1F49D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["love", "valentines"],
          k: [25, 3]
        },
        revolving_hearts: {
          a: "Revolving Hearts",
          b: "1F49E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["love", "like", "affection", "valentines"],
          k: [25, 4]
        },
        heart_decoration: {
          a: "Heart Decoration",
          b: "1F49F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["purple-square", "love", "like"],
          k: [25, 5]
        },
        heavy_heart_exclamation_mark_ornament: {
          a: "Heavy Heart Exclamation Mark Ornament",
          b: "2763-FE0F",
          c: "2763",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [50, 7],
          o: 1
        },
        love_letter: {
          a: "Love Letter",
          b: "1F48C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["email", "like", "affection", "envelope", "valentines"],
          k: [24, 38]
        },
        zzz: {
          a: "Sleeping Symbol",
          b: "1F4A4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sleepy", "tired", "dream"],
          k: [25, 10]
        },
        anger: {
          a: "Anger Symbol",
          b: "1F4A2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["angry", "mad"],
          k: [25, 8]
        },
        bomb: {
          a: "Bomb",
          b: "1F4A3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["boom", "explode", "explosion", "terrorism"],
          k: [25, 9]
        },
        boom: {
          a: "Collision Symbol",
          b: "1F4A5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["bomb", "explode", "explosion", "collision", "blown"],
          k: [25, 11],
          n: ["collision"]
        },
        sweat_drops: {
          a: "Splashing Sweat Symbol",
          b: "1F4A6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["water", "drip", "oops"],
          k: [25, 12]
        },
        dash: {
          a: "Dash Symbol",
          b: "1F4A8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["wind", "air", "fast", "shoo", "fart", "smoke", "puff"],
          k: [25, 14]
        },
        dizzy: {
          a: "Dizzy Symbol",
          b: "1F4AB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["star", "sparkle", "shoot", "magic"],
          k: [25, 22]
        },
        speech_balloon: {
          a: "Speech Balloon",
          b: "1F4AC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["bubble", "words", "message", "talk", "chatting"],
          k: [25, 23]
        },
        left_speech_bubble: {
          a: "Left Speech Bubble",
          b: "1F5E8-FE0F",
          c: "1F5E8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["words", "message", "talk", "chatting"],
          k: [30, 15],
          o: 7
        },
        right_anger_bubble: {
          a: "Right Anger Bubble",
          b: "1F5EF-FE0F",
          c: "1F5EF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["caption", "speech", "thinking", "mad"],
          k: [30, 16],
          o: 7
        },
        thought_balloon: {
          a: "Thought Balloon",
          b: "1F4AD",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["bubble", "cloud", "speech", "thinking", "dream"],
          k: [25, 24]
        },
        hole: {
          a: "Hole",
          b: "1F573-FE0F",
          c: "1F573",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["embarrassing"],
          k: [28, 44],
          o: 7
        },
        eyeglasses: {
          a: "Eyeglasses",
          b: "1F453",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fashion", "accessories", "eyesight", "nerdy", "dork", "geek"],
          k: [15, 23]
        },
        dark_sunglasses: {
          a: "Dark Sunglasses",
          b: "1F576-FE0F",
          c: "1F576",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["face", "cool", "accessories"],
          k: [29, 17],
          o: 7
        },
        necktie: {
          a: "Necktie",
          b: "1F454",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shirt", "suitup", "formal", "fashion", "cloth", "business"],
          k: [15, 24]
        },
        shirt: {
          a: "T-Shirt",
          b: "1F455",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [15, 25],
          n: ["tshirt"]
        },
        jeans: {
          a: "Jeans",
          b: "1F456",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fashion", "shopping"],
          k: [15, 26]
        },
        scarf: {
          a: "Scarf",
          b: "1F9E3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [46, 25],
          o: 10
        },
        gloves: {
          a: "Gloves",
          b: "1F9E4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [46, 26],
          o: 10
        },
        coat: {
          a: "Coat",
          b: "1F9E5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [46, 27],
          o: 10
        },
        socks: {
          a: "Socks",
          b: "1F9E6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [46, 28],
          o: 10
        },
        dress: {
          a: "Dress",
          b: "1F457",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["clothes", "fashion", "shopping"],
          k: [15, 27]
        },
        kimono: {
          a: "Kimono",
          b: "1F458",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["dress", "fashion", "women", "female", "japanese"],
          k: [15, 28]
        },
        bikini: {
          a: "Bikini",
          b: "1F459",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["swimming", "female", "woman", "girl", "fashion", "beach", "summer"],
          k: [15, 29]
        },
        womans_clothes: {
          a: "Womans Clothes",
          b: "1F45A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fashion", "shopping_bags", "female"],
          k: [15, 30]
        },
        purse: {
          a: "Purse",
          b: "1F45B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fashion", "accessories", "money", "sales", "shopping"],
          k: [15, 31]
        },
        handbag: {
          a: "Handbag",
          b: "1F45C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fashion", "accessory", "accessories", "shopping"],
          k: [15, 32]
        },
        pouch: {
          a: "Pouch",
          b: "1F45D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["bag", "accessories", "shopping"],
          k: [15, 33]
        },
        shopping_bags: {
          a: "Shopping Bags",
          b: "1F6CD-FE0F",
          c: "1F6CD",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [37, 2],
          o: 7
        },
        school_satchel: {
          a: "School Satchel",
          b: "1F392",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["student", "education", "bag", "backpack"],
          k: [8, 37]
        },
        mans_shoe: {
          a: "Mans Shoe",
          b: "1F45E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fashion", "male"],
          k: [15, 34],
          n: ["shoe"]
        },
        athletic_shoe: {
          a: "Athletic Shoe",
          b: "1F45F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shoes", "sports", "sneakers"],
          k: [15, 35]
        },
        high_heel: {
          a: "High-Heeled Shoe",
          b: "1F460",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fashion", "shoes", "female", "pumps", "stiletto"],
          k: [15, 36]
        },
        sandal: {
          a: "Womans Sandal",
          b: "1F461",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shoes", "fashion", "flip flops"],
          k: [15, 37]
        },
        boot: {
          a: "Womans Boots",
          b: "1F462",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shoes", "fashion"],
          k: [15, 38]
        },
        crown: {
          a: "Crown",
          b: "1F451",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["king", "kod", "leader", "royalty", "lord"],
          k: [15, 21]
        },
        womans_hat: {
          a: "Womans Hat",
          b: "1F452",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fashion", "accessories", "female", "lady", "spring"],
          k: [15, 22]
        },
        tophat: {
          a: "Top Hat",
          b: "1F3A9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["magic", "gentleman", "classy", "circus"],
          k: [9, 3]
        },
        mortar_board: {
          a: "Graduation Cap",
          b: "1F393",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["school", "college", "degree", "university", "graduation", "cap", "hat", "legal", "learn", "education"],
          k: [8, 38]
        },
        billed_cap: {
          a: "Billed Cap",
          b: "1F9E2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [46, 24],
          o: 10
        },
        helmet_with_white_cross: {
          a: "Helmet with White Cross",
          b: "26D1-FE0F",
          c: "26D1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [48, 33],
          o: 5
        },
        prayer_beads: {
          a: "Prayer Beads",
          b: "1F4FF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["dhikr", "religious"],
          k: [27, 1],
          o: 8
        },
        lipstick: {
          a: "Lipstick",
          b: "1F484",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["female", "girl", "fashion", "woman"],
          k: [23, 43]
        },
        ring: {
          a: "Ring",
          b: "1F48D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["wedding", "propose", "marriage", "valentines", "diamond", "fashion", "jewelry", "gem", "engagement"],
          k: [24, 39]
        },
        gem: {
          a: "Gem Stone",
          b: "1F48E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue", "ruby", "diamond", "jewelry"],
          k: [24, 40]
        }
      },
      aliases: {
        satisfied: "laughing",
        grinning_face_with_star_eyes: "star-struck",
        face_with_one_eyebrow_raised: "face_with_raised_eyebrow",
        telephone: "phone",
        cooking: "fried_egg",
        paw_prints: "feet",
        "flag-cn": "cn",
        lantern: "izakaya_lantern",
        shocked_face_with_exploding_head: "exploding_head",
        open_book: "book",
        "flag-de": "de",
        grinning_face_with_one_large_and_one_small_eye: "zany_face",
        serious_face_with_symbols_covering_mouth: "face_with_symbols_on_mouth",
        flipper: "dolphin",
        face_with_open_mouth_vomiting: "face_vomiting",
        "flag-es": "es",
        face_with_finger_covering_closed_lips: "shushing_face",
        smiling_face_with_smiling_eyes_and_hand_covering_mouth: "face_with_hand_over_mouth",
        "flag-fr": "fr",
        honeybee: "bee",
        red_car: "car",
        envelope: "email",
        uk: "gb",
        "flag-gb": "gb",
        poop: "hankey",
        shit: "hankey",
        staff_of_aesculapius: "medical_symbol",
        knife: "hocho",
        sailboat: "boat",
        pencil: "memo",
        "flag-it": "it",
        "flag-jp": "jp",
        heavy_exclamation_mark: "exclamation",
        "flag-kr": "kr",
        waxing_gibbous_moon: "moon",
        mother_christmas: "mrs_claus",
        sun_small_cloud: "mostly_sunny",
        sun_behind_cloud: "barely_sunny",
        sun_behind_rain_cloud: "partly_sunny_rain",
        lightning_cloud: "lightning",
        tornado_cloud: "tornado",
        "flag-ru": "ru",
        running: "runner",
        "flag-us": "us",
        man_and_woman_holding_hands: "couple",
        "man-woman-boy": "family",
        family: "man-woman-boy",
        reversed_hand_with_middle_finger_extended: "middle_finger",
        hand_with_index_and_middle_fingers_crossed: "crossed_fingers",
        sign_of_the_horns: "the_horns",
        raised_hand: "hand",
        thumbsup: "+1",
        thumbsdown: "-1",
        punch: "facepunch",
        collision: "boom",
        tshirt: "shirt",
        shoe: "mans_shoe"
      }
    };
  }, function (e, i) {
    e.exports = a;
  }, function (e, i, t) {
    var a = t(221),
      n = t(98)(function (e, i) {
        return null == e ? {} : a(e, i);
      });
    e.exports = n;
  }, function (e, i, t) {
    "use strict";

    (function (a) {
      function _typeof(e) {
        return (_typeof = "function" === typeof Symbol && "symbol" === typeof Symbol.iterator ? function _typeof(e) {
          return typeof e;
        } : function _typeof(e) {
          return e && "function" === typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }
      i.log = function log() {
        var e;
        return "object" === ("undefined" === typeof console ? "undefined" : _typeof(console)) && console.log && (e = console).log.apply(e, arguments);
      }, i.formatArgs = function formatArgs(i) {
        if (i[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + i[0] + (this.useColors ? "%c " : " ") + "+" + e.exports.humanize(this.diff), !this.useColors) return;
        var t = "color: " + this.color;
        i.splice(1, 0, t, "color: inherit");
        var a = 0,
          n = 0;
        i[0].replace(/%[a-zA-Z%]/g, function (e) {
          "%%" !== e && (a++, "%c" === e && (n = a));
        }), i.splice(n, 0, t);
      }, i.save = function save(e) {
        try {
          e ? i.storage.setItem("debug", e) : i.storage.removeItem("debug");
        } catch (t) {}
      }, i.load = function load() {
        var e;
        try {
          e = i.storage.getItem("debug");
        } catch (t) {}
        !e && "undefined" !== typeof a && "env" in a && (e = Object({
          NODE_ENV: "production",
          PUBLIC_URL: ""
        }).DEBUG);
        return e;
      }, i.useColors = function useColors() {
        if ("undefined" !== typeof window && window.process && ("renderer" === window.process.type || window.process.__nwjs)) return !0;
        if ("undefined" !== typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) return !1;
        return "undefined" !== typeof document && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || "undefined" !== typeof window && window.console && (window.console.firebug || window.console.exception && window.console.table) || "undefined" !== typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || "undefined" !== typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
      }, i.storage = function localstorage() {
        try {
          return localStorage;
        } catch (e) {}
      }(), i.colors = ["#0000CC", "#0000FF", "#0033CC", "#0033FF", "#0066CC", "#0066FF", "#0099CC", "#0099FF", "#00CC00", "#00CC33", "#00CC66", "#00CC99", "#00CCCC", "#00CCFF", "#3300CC", "#3300FF", "#3333CC", "#3333FF", "#3366CC", "#3366FF", "#3399CC", "#3399FF", "#33CC00", "#33CC33", "#33CC66", "#33CC99", "#33CCCC", "#33CCFF", "#6600CC", "#6600FF", "#6633CC", "#6633FF", "#66CC00", "#66CC33", "#9900CC", "#9900FF", "#9933CC", "#9933FF", "#99CC00", "#99CC33", "#CC0000", "#CC0033", "#CC0066", "#CC0099", "#CC00CC", "#CC00FF", "#CC3300", "#CC3333", "#CC3366", "#CC3399", "#CC33CC", "#CC33FF", "#CC6600", "#CC6633", "#CC9900", "#CC9933", "#CCCC00", "#CCCC33", "#FF0000", "#FF0033", "#FF0066", "#FF0099", "#FF00CC", "#FF00FF", "#FF3300", "#FF3333", "#FF3366", "#FF3399", "#FF33CC", "#FF33FF", "#FF6600", "#FF6633", "#FF9900", "#FF9933", "#FFCC00", "#FFCC33"], e.exports = t(227)(i), e.exports.formatters.j = function (e) {
        try {
          return JSON.stringify(e);
        } catch (i) {
          return "[UnexpectedJSONParseError]: " + i.message;
        }
      };
    }).call(this, t(50));
  }, function (e, i, t) {
    var a = t(9).Symbol;
    e.exports = a;
  }, function (e, i, t) {
    var a = t(52),
      n = t(86);
    e.exports = function copyObject(e, i, t, o) {
      var r = !t;
      t || (t = {});
      for (var s = -1, _ = i.length; ++s < _;) {
        var l = i[s],
          g = o ? o(t[l], e[l], l, t, e) : void 0;
        void 0 === g && (g = e[l]), r ? n(t, l, g) : a(t, l, g);
      }
      return t;
    };
  }, function (e, i) {
    var t = e.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
    "number" == typeof __g && (__g = t);
  }, function (e, i, t) {
    e.exports = !t(107)(function () {
      return 7 != Object.defineProperty({}, "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, function (e, i, t) {
    e.exports = {
      default: t(262),
      __esModule: !0
    };
  }, function (e, i, t) {
    "use strict";

    Object.defineProperty(i, "__esModule", {
      value: !0
    });
    for (var a = "undefined" != typeof window && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform), n = {
        alt: "altKey",
        control: "ctrlKey",
        meta: "metaKey",
        shift: "shiftKey"
      }, o = {
        add: "+",
        break: "pause",
        cmd: "meta",
        command: "meta",
        ctl: "control",
        ctrl: "control",
        del: "delete",
        down: "arrowdown",
        esc: "escape",
        ins: "insert",
        left: "arrowleft",
        mod: a ? "meta" : "control",
        opt: "alt",
        option: "alt",
        return: "enter",
        right: "arrowright",
        space: " ",
        spacebar: " ",
        up: "arrowup",
        win: "meta",
        windows: "meta"
      }, r = {
        backspace: 8,
        tab: 9,
        enter: 13,
        shift: 16,
        control: 17,
        alt: 18,
        pause: 19,
        capslock: 20,
        escape: 27,
        " ": 32,
        pageup: 33,
        pagedown: 34,
        end: 35,
        home: 36,
        arrowleft: 37,
        arrowup: 38,
        arrowright: 39,
        arrowdown: 40,
        insert: 45,
        delete: 46,
        meta: 91,
        numlock: 144,
        scrolllock: 145,
        ";": 186,
        "=": 187,
        ",": 188,
        "-": 189,
        ".": 190,
        "/": 191,
        "`": 192,
        "[": 219,
        "\\": 220,
        "]": 221,
        "'": 222
      }, s = 1; s < 20; s++) {
      r["f" + s] = 111 + s;
    }
    function isHotkey(e, i, t) {
      !i || "byKey" in i || (t = i, i = null), Array.isArray(e) || (e = [e]);
      var a = e.map(function (e) {
          return parseHotkey(e, i);
        }),
        n = function check(e) {
          return a.some(function (i) {
            return compareHotkey(i, e);
          });
        };
      return null == t ? n : n(t);
    }
    function parseHotkey(e, i) {
      var t = i && i.byKey,
        a = {},
        o = (e = e.replace("++", "+add")).split("+"),
        r = o.length;
      for (var s in n) {
        a[n[s]] = !1;
      }
      var _ = !0,
        l = !1,
        g = void 0;
      try {
        for (var f, h = o[Symbol.iterator](); !(_ = (f = h.next()).done); _ = !0) {
          var d = f.value,
            m = d.endsWith("?") && d.length > 1;
          m && (d = d.slice(0, -1));
          var u = toKeyName(d),
            c = n[u];
          1 !== r && c || (t ? a.key = u : a.which = toKeyCode(d)), c && (a[c] = !m || null);
        }
      } catch (F) {
        l = !0, g = F;
      } finally {
        try {
          !_ && h.return && h.return();
        } finally {
          if (l) throw g;
        }
      }
      return a;
    }
    function compareHotkey(e, i) {
      for (var t in e) {
        var a = e[t],
          n = void 0;
        if (null != a && (null != (n = "key" === t && null != i.key ? i.key.toLowerCase() : "which" === t ? 91 === a && 93 === i.which ? 91 : i.which : i[t]) || !1 !== a) && n !== a) return !1;
      }
      return !0;
    }
    function toKeyCode(e) {
      return e = toKeyName(e), r[e] || e.toUpperCase().charCodeAt(0);
    }
    function toKeyName(e) {
      return e = e.toLowerCase(), e = o[e] || e;
    }
    i.default = isHotkey, i.isHotkey = isHotkey, i.isCodeHotkey = function isCodeHotkey(e, i) {
      return isHotkey(e, i);
    }, i.isKeyHotkey = function isKeyHotkey(e, i) {
      return isHotkey(e, {
        byKey: !0
      }, i);
    }, i.parseHotkey = parseHotkey, i.compareHotkey = compareHotkey, i.toKeyCode = toKeyCode, i.toKeyName = toKeyName;
  }, function (e, i) {
    e.exports = function (e) {
      return e.webpackPolyfill || (e.deprecate = function () {}, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", {
        enumerable: !0,
        get: function get() {
          return e.l;
        }
      }), Object.defineProperty(e, "id", {
        enumerable: !0,
        get: function get() {
          return e.i;
        }
      }), e.webpackPolyfill = 1), e;
    };
  }, function (e, i, t) {
    var a = t(136),
      n = t(137),
      o = t(138),
      r = t(139),
      s = t(140);
    function ListCache(e) {
      var i = -1,
        t = null == e ? 0 : e.length;
      for (this.clear(); ++i < t;) {
        var a = e[i];
        this.set(a[0], a[1]);
      }
    }
    ListCache.prototype.clear = a, ListCache.prototype.delete = n, ListCache.prototype.get = o, ListCache.prototype.has = r, ListCache.prototype.set = s, e.exports = ListCache;
  }, function (e, i, t) {
    var a = t(81);
    e.exports = function assocIndexOf(e, i) {
      for (var t = e.length; t--;) {
        if (a(e[t][0], i)) return t;
      }
      return -1;
    };
  }, function (e, i, t) {
    var a = t(15)(Object, "create");
    e.exports = a;
  }, function (e, i, t) {
    var a = t(160);
    e.exports = function getMapData(e, i) {
      var t = e.__data__;
      return a(i) ? t["string" == typeof i ? "string" : "hash"] : t.map;
    };
  }, function (e, i, t) {
    var a = t(19),
      n = t(16),
      o = "[object Symbol]";
    e.exports = function isSymbol(e) {
      return "symbol" == typeof e || n(e) && a(e) == o;
    };
  }, function (e, i, t) {
    var a = t(39),
      n = 1 / 0;
    e.exports = function toKey(e) {
      if ("string" == typeof e || a(e)) return e;
      var i = e + "";
      return "0" == i && 1 / e == -n ? "-0" : i;
    };
  }, function (e, i, t) {
    var a = t(42),
      n = t(68);
    e.exports = t(31) ? function (e, i, t) {
      return a.f(e, i, n(1, t));
    } : function (e, i, t) {
      return e[i] = t, e;
    };
  }, function (e, i, t) {
    var a = t(43),
      n = t(266),
      o = t(267),
      r = Object.defineProperty;
    i.f = t(31) ? Object.defineProperty : function defineProperty(e, i, t) {
      if (a(e), i = o(i, !0), a(t), n) try {
        return r(e, i, t);
      } catch (s) {}
      if ("get" in t || "set" in t) throw TypeError("Accessors not supported!");
      return "value" in t && (e[i] = t.value), e;
    };
  }, function (e, i, t) {
    var a = t(67);
    e.exports = function (e) {
      if (!a(e)) throw TypeError(e + " is not an object!");
      return e;
    };
  }, function (e, i) {
    var t = {}.hasOwnProperty;
    e.exports = function (e, i) {
      return t.call(e, i);
    };
  }, function (e, i, t) {
    "use strict";

    e.exports = t(233);
  }, function (e, i) {
    e.exports = n;
  }, function (e, i, t) {
    "use strict";

    Object.defineProperty(i, "__esModule", {
      value: !0
    });
    for (var a = "undefined" != typeof window && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform), n = {
        alt: "altKey",
        control: "ctrlKey",
        meta: "metaKey",
        shift: "shiftKey"
      }, o = {
        add: "+",
        break: "pause",
        cmd: "meta",
        command: "meta",
        ctl: "control",
        ctrl: "control",
        del: "delete",
        down: "arrowdown",
        esc: "escape",
        ins: "insert",
        left: "arrowleft",
        mod: a ? "meta" : "control",
        opt: "alt",
        option: "alt",
        return: "enter",
        right: "arrowright",
        space: " ",
        spacebar: " ",
        up: "arrowup",
        win: "meta",
        windows: "meta"
      }, r = {
        backspace: 8,
        tab: 9,
        enter: 13,
        shift: 16,
        control: 17,
        alt: 18,
        pause: 19,
        capslock: 20,
        escape: 27,
        " ": 32,
        pageup: 33,
        pagedown: 34,
        end: 35,
        home: 36,
        arrowleft: 37,
        arrowup: 38,
        arrowright: 39,
        arrowdown: 40,
        insert: 45,
        delete: 46,
        meta: 91,
        numlock: 144,
        scrolllock: 145,
        ";": 186,
        "=": 187,
        ",": 188,
        "-": 189,
        ".": 190,
        "/": 191,
        "`": 192,
        "[": 219,
        "\\": 220,
        "]": 221,
        "'": 222
      }, s = 1; s < 20; s++) {
      r["f" + s] = 111 + s;
    }
    function isHotkey(e, i, t) {
      !i || "byKey" in i || (t = i, i = null), Array.isArray(e) || (e = [e]);
      var a = e.map(function (e) {
          return parseHotkey(e, i);
        }),
        n = function check(e) {
          return a.some(function (i) {
            return compareHotkey(i, e);
          });
        };
      return null == t ? n : n(t);
    }
    function parseHotkey(e, i) {
      var t = i && i.byKey,
        a = {},
        o = (e = e.replace("++", "+add")).split("+"),
        r = o.length;
      for (var s in n) {
        a[n[s]] = !1;
      }
      var _ = !0,
        l = !1,
        g = void 0;
      try {
        for (var f, h = o[Symbol.iterator](); !(_ = (f = h.next()).done); _ = !0) {
          var d = f.value,
            m = d.endsWith("?");
          m && (d = d.slice(0, -1));
          var u = toKeyName(d),
            c = n[u];
          1 !== r && c || (t ? a.key = u : a.which = toKeyCode(d)), c && (a[c] = !m || null);
        }
      } catch (F) {
        l = !0, g = F;
      } finally {
        try {
          !_ && h.return && h.return();
        } finally {
          if (l) throw g;
        }
      }
      return a;
    }
    function compareHotkey(e, i) {
      for (var t in e) {
        var a = e[t],
          n = void 0;
        if (null != a && (null != (n = "key" === t ? i.key.toLowerCase() : "which" === t ? 91 === a && 93 === i.which ? 91 : i.which : i[t]) || !1 !== a) && n !== a) return !1;
      }
      return !0;
    }
    function toKeyCode(e) {
      return e = toKeyName(e), r[e] || e.toUpperCase().charCodeAt(0);
    }
    function toKeyName(e) {
      return e = e.toLowerCase(), e = o[e] || e;
    }
    i.default = isHotkey, i.isHotkey = isHotkey, i.isCodeHotkey = function isCodeHotkey(e, i) {
      return isHotkey(e, i);
    }, i.isKeyHotkey = function isKeyHotkey(e, i) {
      return isHotkey(e, {
        byKey: !0
      }, i);
    }, i.parseHotkey = parseHotkey, i.compareHotkey = compareHotkey, i.toKeyCode = toKeyCode, i.toKeyName = toKeyName;
  }, function (e, i) {
    var t = Object.prototype.toString;
    e.exports = function (e) {
      switch (t.call(e)) {
        case "[object Function]":
          return "function";
        case "[object Date]":
          return "date";
        case "[object RegExp]":
          return "regexp";
        case "[object Arguments]":
          return "arguments";
        case "[object Array]":
          return "array";
        case "[object String]":
          return "string";
      }
      if ("object" == typeof e && e && "number" == typeof e.length) try {
        if ("function" == typeof e.callee) return "arguments";
      } catch (i) {
        if (i instanceof TypeError) return "arguments";
      }
      return null === e ? "null" : void 0 === e ? "undefined" : e && 1 === e.nodeType ? "element" : e === Object(e) ? "object" : typeof e;
    };
  }, function (e, i, t) {
    "use strict";

    var a = t(260),
      n = t(261),
      o = t(105);
    e.exports = {
      formats: o,
      parse: n,
      stringify: a
    };
  }, function (e, i) {
    var t,
      a,
      n = e.exports = {};
    function defaultSetTimout() {
      throw new Error("setTimeout has not been defined");
    }
    function defaultClearTimeout() {
      throw new Error("clearTimeout has not been defined");
    }
    function runTimeout(e) {
      if (t === setTimeout) return setTimeout(e, 0);
      if ((t === defaultSetTimout || !t) && setTimeout) return t = setTimeout, setTimeout(e, 0);
      try {
        return t(e, 0);
      } catch (i) {
        try {
          return t.call(null, e, 0);
        } catch (i) {
          return t.call(this, e, 0);
        }
      }
    }
    !function () {
      try {
        t = "function" === typeof setTimeout ? setTimeout : defaultSetTimout;
      } catch (e) {
        t = defaultSetTimout;
      }
      try {
        a = "function" === typeof clearTimeout ? clearTimeout : defaultClearTimeout;
      } catch (e) {
        a = defaultClearTimeout;
      }
    }();
    var o,
      r = [],
      s = !1,
      _ = -1;
    function cleanUpNextTick() {
      s && o && (s = !1, o.length ? r = o.concat(r) : _ = -1, r.length && drainQueue());
    }
    function drainQueue() {
      if (!s) {
        var e = runTimeout(cleanUpNextTick);
        s = !0;
        for (var i = r.length; i;) {
          for (o = r, r = []; ++_ < i;) {
            o && o[_].run();
          }
          _ = -1, i = r.length;
        }
        o = null, s = !1, function runClearTimeout(e) {
          if (a === clearTimeout) return clearTimeout(e);
          if ((a === defaultClearTimeout || !a) && clearTimeout) return a = clearTimeout, clearTimeout(e);
          try {
            return a(e);
          } catch (i) {
            try {
              return a.call(null, e);
            } catch (i) {
              return a.call(this, e);
            }
          }
        }(e);
      }
    }
    function Item(e, i) {
      this.fun = e, this.array = i;
    }
    function noop() {}
    n.nextTick = function (e) {
      var i = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var t = 1; t < arguments.length; t++) {
        i[t - 1] = arguments[t];
      }
      r.push(new Item(e, i)), 1 !== r.length || s || runTimeout(drainQueue);
    }, Item.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, n.title = "browser", n.browser = !0, n.env = {}, n.argv = [], n.version = "", n.versions = {}, n.on = noop, n.addListener = noop, n.once = noop, n.off = noop, n.removeListener = noop, n.removeAllListeners = noop, n.emit = noop, n.prependListener = noop, n.prependOnceListener = noop, n.listeners = function (e) {
      return [];
    }, n.binding = function (e) {
      throw new Error("process.binding is not supported");
    }, n.cwd = function () {
      return "/";
    }, n.chdir = function (e) {
      throw new Error("process.chdir is not supported");
    }, n.umask = function () {
      return 0;
    };
  }, function (e, i, t) {
    var a = t(15)(t(9), "Map");
    e.exports = a;
  }, function (e, i, t) {
    var a = t(86),
      n = t(81),
      o = Object.prototype.hasOwnProperty;
    e.exports = function assignValue(e, i, t) {
      var r = e[i];
      o.call(e, i) && n(r, t) && (void 0 !== t || i in e) || a(e, i, t);
    };
  }, function (e, i, t) {
    var a = t(88),
      n = t(171),
      o = t(91);
    e.exports = function keys(e) {
      return o(e) ? a(e) : n(e);
    };
  }, function (e, i, t) {
    var a = t(167),
      n = t(16),
      o = Object.prototype,
      r = o.hasOwnProperty,
      s = o.propertyIsEnumerable,
      _ = a(function () {
        return arguments;
      }()) ? a : function (e) {
        return n(e) && r.call(e, "callee") && !s.call(e, "callee");
      };
    e.exports = _;
  }, function (e, i) {
    var t = 9007199254740991,
      a = /^(?:0|[1-9]\d*)$/;
    e.exports = function isIndex(e, i) {
      var n = typeof e;
      return !!(i = null == i ? t : i) && ("number" == n || "symbol" != n && a.test(e)) && e > -1 && e % 1 == 0 && e < i;
    };
  }, function (e, i) {
    var t = 9007199254740991;
    e.exports = function isLength(e) {
      return "number" == typeof e && e > -1 && e % 1 == 0 && e <= t;
    };
  }, function (e, i) {
    e.exports = function baseUnary(e) {
      return function (i) {
        return e(i);
      };
    };
  }, function (e, i, t) {
    (function (e) {
      var a = t(83),
        n = i && !i.nodeType && i,
        o = n && "object" == typeof e && e && !e.nodeType && e,
        r = o && o.exports === n && a.process,
        s = function () {
          try {
            var e = o && o.require && o.require("util").types;
            return e || r && r.binding && r.binding("util");
          } catch (i) {}
        }();
      e.exports = s;
    }).call(this, t(34)(e));
  }, function (e, i) {
    var t = Object.prototype;
    e.exports = function isPrototype(e) {
      var i = e && e.constructor;
      return e === ("function" == typeof i && i.prototype || t);
    };
  }, function (e, i, t) {
    var a = t(179),
      n = t(93),
      o = Object.prototype.propertyIsEnumerable,
      r = Object.getOwnPropertySymbols,
      s = r ? function (e) {
        return null == e ? [] : (e = Object(e), a(r(e), function (i) {
          return o.call(e, i);
        }));
      } : n;
    e.exports = s;
  }, function (e, i) {
    e.exports = function arrayPush(e, i) {
      for (var t = -1, a = i.length, n = e.length; ++t < a;) {
        e[n + t] = i[t];
      }
      return e;
    };
  }, function (e, i, t) {
    var a = t(90)(Object.getPrototypeOf, Object);
    e.exports = a;
  }, function (e, i, t) {
    var a = t(182),
      n = t(51),
      o = t(183),
      r = t(184),
      s = t(185),
      _ = t(19),
      l = t(84),
      g = l(a),
      f = l(n),
      h = l(o),
      d = l(r),
      m = l(s),
      u = _;
    (a && "[object DataView]" != u(new a(new ArrayBuffer(1))) || n && "[object Map]" != u(new n()) || o && "[object Promise]" != u(o.resolve()) || r && "[object Set]" != u(new r()) || s && "[object WeakMap]" != u(new s())) && (u = function getTag(e) {
      var i = _(e),
        t = "[object Object]" == i ? e.constructor : void 0,
        a = t ? l(t) : "";
      if (a) switch (a) {
        case g:
          return "[object DataView]";
        case f:
          return "[object Map]";
        case h:
          return "[object Promise]";
        case d:
          return "[object Set]";
        case m:
          return "[object WeakMap]";
      }
      return i;
    }), e.exports = u;
  }, function (e, i, t) {
    var a = t(188);
    e.exports = function cloneArrayBuffer(e) {
      var i = new e.constructor(e.byteLength);
      return new a(i).set(new a(e)), i;
    };
  }, function (e, i, t) {
    "use strict";

    (function (i) {
      var a = t(8),
        n = t(245),
        o = {
          "Content-Type": "application/x-www-form-urlencoded"
        };
      function setContentTypeIfUnset(e, i) {
        !a.isUndefined(e) && a.isUndefined(e["Content-Type"]) && (e["Content-Type"] = i);
      }
      var r = {
        adapter: function getDefaultAdapter() {
          var e;
          return "undefined" !== typeof XMLHttpRequest ? e = t(100) : "undefined" !== typeof i && (e = t(100)), e;
        }(),
        transformRequest: [function transformRequest(e, i) {
          return n(i, "Content-Type"), a.isFormData(e) || a.isArrayBuffer(e) || a.isBuffer(e) || a.isStream(e) || a.isFile(e) || a.isBlob(e) ? e : a.isArrayBufferView(e) ? e.buffer : a.isURLSearchParams(e) ? (setContentTypeIfUnset(i, "application/x-www-form-urlencoded;charset=utf-8"), e.toString()) : a.isObject(e) ? (setContentTypeIfUnset(i, "application/json;charset=utf-8"), JSON.stringify(e)) : e;
        }],
        transformResponse: [function transformResponse(e) {
          if ("string" === typeof e) try {
            e = JSON.parse(e);
          } catch (i) {}
          return e;
        }],
        timeout: 0,
        xsrfCookieName: "XSRF-TOKEN",
        xsrfHeaderName: "X-XSRF-TOKEN",
        maxContentLength: -1,
        validateStatus: function validateStatus(e) {
          return e >= 200 && e < 300;
        },
        headers: {
          common: {
            Accept: "application/json, text/plain, */*"
          }
        }
      };
      a.forEach(["delete", "get", "head"], function forEachMethodNoData(e) {
        r.headers[e] = {};
      }), a.forEach(["post", "put", "patch"], function forEachMethodWithData(e) {
        r.headers[e] = a.merge(o);
      }), e.exports = r;
    }).call(this, t(50));
  }, function (e, i, t) {
    var a = t(30),
      n = t(23),
      o = t(106),
      r = t(41),
      s = t(44),
      _ = function $export(e, i, t) {
        var _,
          l,
          g,
          f = e & $export.F,
          h = e & $export.G,
          d = e & $export.S,
          m = e & $export.P,
          u = e & $export.B,
          c = e & $export.W,
          F = h ? n : n[i] || (n[i] = {}),
          p = F.prototype,
          b = h ? a : d ? a[i] : (a[i] || {}).prototype;
        for (_ in h && (t = i), t) {
          (l = !f && b && void 0 !== b[_]) && s(F, _) || (g = l ? b[_] : t[_], F[_] = h && "function" != typeof b[_] ? t[_] : u && l ? o(g, a) : c && b[_] == g ? function (e) {
            var i = function F(i, t, a) {
              if (this instanceof e) {
                switch (arguments.length) {
                  case 0:
                    return new e();
                  case 1:
                    return new e(i);
                  case 2:
                    return new e(i, t);
                }
                return new e(i, t, a);
              }
              return e.apply(this, arguments);
            };
            return i.prototype = e.prototype, i;
          }(g) : m && "function" == typeof g ? o(Function.call, g) : g, m && ((F.virtual || (F.virtual = {}))[_] = g, e & $export.R && p && !p[_] && r(p, _, g)));
        }
      };
    _.F = 1, _.G = 2, _.S = 4, _.P = 8, _.B = 16, _.W = 32, _.U = 64, _.R = 128, e.exports = _;
  }, function (e, i) {
    e.exports = function (e) {
      return "object" === typeof e ? null !== e : "function" === typeof e;
    };
  }, function (e, i) {
    e.exports = function (e, i) {
      return {
        enumerable: !(1 & e),
        configurable: !(2 & e),
        writable: !(4 & e),
        value: i
      };
    };
  }, function (e, i, t) {
    var a = t(270),
      n = t(70);
    e.exports = function (e) {
      return a(n(e));
    };
  }, function (e, i) {
    e.exports = function (e) {
      if (void 0 == e) throw TypeError("Can't call method on  " + e);
      return e;
    };
  }, function (e, i) {
    var t = Math.ceil,
      a = Math.floor;
    e.exports = function (e) {
      return isNaN(e = +e) ? 0 : (e > 0 ? a : t)(e);
    };
  }, function (e, i, t) {
    var a = t(112)("keys"),
      n = t(114);
    e.exports = function (e) {
      return a[e] || (a[e] = n(e));
    };
  }, function (e, i) {
    e.exports = {};
  }, function (e, i, t) {
    (function (e, a) {
      var n;
      !function (o) {
        var r = i,
          s = (e && e.exports, "object" == typeof a && a);
        s.global !== s && s.window;
        var _ = /([\0-\u02FF\u0370-\u1AAF\u1B00-\u1DBF\u1E00-\u20CF\u2100-\uD7FF\uE000-\uFE1F\uFE30-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])([\u0300-\u036F\u1AB0-\u1AFF\u1DC0-\u1DFF\u20D0-\u20FF\uFE20-\uFE2F]+)/g,
          l = /([\uD800-\uDBFF])([\uDC00-\uDFFF])/g,
          g = {
            version: "0.2.0",
            reverse: function reverse(e) {
              for (var i = "", t = (e = e.replace(_, function (e, i, t) {
                  return reverse(t) + i;
                }).replace(l, "$2$1")).length; t--;) {
                i += e.charAt(t);
              }
              return i;
            }
          };
        void 0 === (n = function () {
          return g;
        }.call(i, t, i, e)) || (e.exports = n);
      }();
    }).call(this, t(34)(e), t(79));
  }, function (e, i, t) {
    var a = t(80),
      n = t(134),
      o = t(199),
      r = t(20),
      s = t(29),
      _ = t(209),
      l = t(98),
      g = t(96),
      f = l(function (e, i) {
        var t = {};
        if (null == e) return t;
        var l = !1;
        i = a(i, function (i) {
          return i = r(i, e), l || (l = i.length > 1), i;
        }), s(e, g(e), t), l && (t = n(t, 7, _));
        for (var f = i.length; f--;) {
          o(t, i[f]);
        }
        return t;
      });
    e.exports = f;
  }, function (e, i, t) {
    "use strict";

    var a,
      n = t(2),
      o = "<<anonymous>>",
      r = function productionTypeChecker() {
        invariant(!1, "ImmutablePropTypes type checking code is stripped in production.");
      };
    r.isRequired = r;
    var s = function getProductionTypeChecker() {
      return r;
    };
    function getPropType(e) {
      var i = typeof e;
      return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : e instanceof n.Iterable ? "Immutable." + e.toSource().split(" ")[0] : i;
    }
    function createChainableTypeChecker(e) {
      function checkType(i, t, a, n, r, s) {
        for (var _ = arguments.length, l = Array(_ > 6 ? _ - 6 : 0), g = 6; g < _; g++) {
          l[g - 6] = arguments[g];
        }
        return s = s || a, n = n || o, null != t[a] ? e.apply(void 0, [t, a, n, r, s].concat(l)) : i ? new Error("Required " + r + " `" + s + "` was not specified in `" + n + "`.") : void 0;
      }
      var i = checkType.bind(null, !1);
      return i.isRequired = checkType.bind(null, !0), i;
    }
    function createIterableSubclassTypeChecker(e, i) {
      return function createImmutableTypeChecker(e, i) {
        return createChainableTypeChecker(function validate(t, a, n, o, r) {
          var s = t[a];
          if (!i(s)) {
            var _ = getPropType(s);
            return new Error("Invalid " + o + " `" + r + "` of type `" + _ + "` supplied to `" + n + "`, expected `" + e + "`.");
          }
          return null;
        });
      }("Iterable." + e, function (e) {
        return n.Iterable.isIterable(e) && i(e);
      });
    }
    (a = {
      listOf: s,
      mapOf: s,
      orderedMapOf: s,
      setOf: s,
      orderedSetOf: s,
      stackOf: s,
      iterableOf: s,
      recordOf: s,
      shape: s,
      contains: s,
      mapContains: s,
      orderedMapContains: s,
      list: r,
      map: r,
      orderedMap: r,
      set: r,
      orderedSet: r,
      stack: r,
      seq: r,
      record: r,
      iterable: r
    }).iterable.indexed = createIterableSubclassTypeChecker("Indexed", n.Iterable.isIndexed), a.iterable.keyed = createIterableSubclassTypeChecker("Keyed", n.Iterable.isKeyed), e.exports = a;
  }, function (e, i, t) {
    "use strict";

    i.atob = self.atob.bind(self), i.btoa = self.btoa.bind(self);
  }, function (e, i) {
    var t = 1e3,
      a = 60 * t,
      n = 60 * a,
      o = 24 * n,
      r = 7 * o,
      s = 365.25 * o;
    function plural(e, i, t, a) {
      var n = i >= 1.5 * t;
      return Math.round(e / t) + " " + a + (n ? "s" : "");
    }
    e.exports = function (e, i) {
      i = i || {};
      var _ = typeof e;
      if ("string" === _ && e.length > 0) return function parse(e) {
        if ((e = String(e)).length > 100) return;
        var i = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(e);
        if (!i) return;
        var _ = parseFloat(i[1]);
        switch ((i[2] || "ms").toLowerCase()) {
          case "years":
          case "year":
          case "yrs":
          case "yr":
          case "y":
            return _ * s;
          case "weeks":
          case "week":
          case "w":
            return _ * r;
          case "days":
          case "day":
          case "d":
            return _ * o;
          case "hours":
          case "hour":
          case "hrs":
          case "hr":
          case "h":
            return _ * n;
          case "minutes":
          case "minute":
          case "mins":
          case "min":
          case "m":
            return _ * a;
          case "seconds":
          case "second":
          case "secs":
          case "sec":
          case "s":
            return _ * t;
          case "milliseconds":
          case "millisecond":
          case "msecs":
          case "msec":
          case "ms":
            return _;
          default:
            return;
        }
      }(e);
      if ("number" === _ && isFinite(e)) return i.long ? function fmtLong(e) {
        var i = Math.abs(e);
        if (i >= o) return plural(e, i, o, "day");
        if (i >= n) return plural(e, i, n, "hour");
        if (i >= a) return plural(e, i, a, "minute");
        if (i >= t) return plural(e, i, t, "second");
        return e + " ms";
      }(e) : function fmtShort(e) {
        var i = Math.abs(e);
        if (i >= o) return Math.round(e / o) + "d";
        if (i >= n) return Math.round(e / n) + "h";
        if (i >= a) return Math.round(e / a) + "m";
        if (i >= t) return Math.round(e / t) + "s";
        return e + "ms";
      }(e);
      throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(e));
    };
  }, function (e, i) {
    var t;
    t = function () {
      return this;
    }();
    try {
      t = t || new Function("return this")();
    } catch (a) {
      "object" === typeof window && (t = window);
    }
    e.exports = t;
  }, function (e, i) {
    e.exports = function arrayMap(e, i) {
      for (var t = -1, a = null == e ? 0 : e.length, n = Array(a); ++t < a;) {
        n[t] = i(e[t], t, e);
      }
      return n;
    };
  }, function (e, i) {
    e.exports = function eq(e, i) {
      return e === i || e !== e && i !== i;
    };
  }, function (e, i, t) {
    var a = t(19),
      n = t(10),
      o = "[object AsyncFunction]",
      r = "[object Function]",
      s = "[object GeneratorFunction]",
      _ = "[object Proxy]";
    e.exports = function isFunction(e) {
      if (!n(e)) return !1;
      var i = a(e);
      return i == r || i == s || i == o || i == _;
    };
  }, function (e, i, t) {
    (function (i) {
      var t = "object" == typeof i && i && i.Object === Object && i;
      e.exports = t;
    }).call(this, t(79));
  }, function (e, i) {
    var t = Function.prototype.toString;
    e.exports = function toSource(e) {
      if (null != e) {
        try {
          return t.call(e);
        } catch (i) {}
        try {
          return e + "";
        } catch (i) {}
      }
      return "";
    };
  }, function (e, i, t) {
    var a = t(152),
      n = t(159),
      o = t(161),
      r = t(162),
      s = t(163);
    function MapCache(e) {
      var i = -1,
        t = null == e ? 0 : e.length;
      for (this.clear(); ++i < t;) {
        var a = e[i];
        this.set(a[0], a[1]);
      }
    }
    MapCache.prototype.clear = a, MapCache.prototype.delete = n, MapCache.prototype.get = o, MapCache.prototype.has = r, MapCache.prototype.set = s, e.exports = MapCache;
  }, function (e, i, t) {
    var a = t(87);
    e.exports = function baseAssignValue(e, i, t) {
      "__proto__" == i && a ? a(e, i, {
        configurable: !0,
        enumerable: !0,
        value: t,
        writable: !0
      }) : e[i] = t;
    };
  }, function (e, i, t) {
    var a = t(15),
      n = function () {
        try {
          var e = a(Object, "defineProperty");
          return e({}, "", {}), e;
        } catch (i) {}
      }();
    e.exports = n;
  }, function (e, i, t) {
    var a = t(166),
      n = t(54),
      o = t(12),
      r = t(89),
      s = t(55),
      _ = t(169),
      l = Object.prototype.hasOwnProperty;
    e.exports = function arrayLikeKeys(e, i) {
      var t = o(e),
        g = !t && n(e),
        f = !t && !g && r(e),
        h = !t && !g && !f && _(e),
        d = t || g || f || h,
        m = d ? a(e.length, String) : [],
        u = m.length;
      for (var c in e) {
        !i && !l.call(e, c) || d && ("length" == c || f && ("offset" == c || "parent" == c) || h && ("buffer" == c || "byteLength" == c || "byteOffset" == c) || s(c, u)) || m.push(c);
      }
      return m;
    };
  }, function (e, i, t) {
    (function (e) {
      var a = t(9),
        n = t(168),
        o = i && !i.nodeType && i,
        r = o && "object" == typeof e && e && !e.nodeType && e,
        s = r && r.exports === o ? a.Buffer : void 0,
        _ = (s ? s.isBuffer : void 0) || n;
      e.exports = _;
    }).call(this, t(34)(e));
  }, function (e, i) {
    e.exports = function overArg(e, i) {
      return function (t) {
        return e(i(t));
      };
    };
  }, function (e, i, t) {
    var a = t(82),
      n = t(56);
    e.exports = function isArrayLike(e) {
      return null != e && n(e.length) && !a(e);
    };
  }, function (e, i, t) {
    var a = t(88),
      n = t(174),
      o = t(91);
    e.exports = function keysIn(e) {
      return o(e) ? a(e, !0) : n(e);
    };
  }, function (e, i) {
    e.exports = function stubArray() {
      return [];
    };
  }, function (e, i, t) {
    var a = t(61),
      n = t(62),
      o = t(60),
      r = t(93),
      s = Object.getOwnPropertySymbols ? function (e) {
        for (var i = []; e;) {
          a(i, o(e)), e = n(e);
        }
        return i;
      } : r;
    e.exports = s;
  }, function (e, i, t) {
    var a = t(61),
      n = t(12);
    e.exports = function baseGetAllKeys(e, i, t) {
      var o = i(e);
      return n(e) ? o : a(o, t(e));
    };
  }, function (e, i, t) {
    var a = t(95),
      n = t(94),
      o = t(92);
    e.exports = function getAllKeysIn(e) {
      return a(e, o, n);
    };
  }, function (e, i, t) {
    var a = t(20),
      n = t(40);
    e.exports = function baseGet(e, i) {
      for (var t = 0, o = (i = a(i, e)).length; null != e && t < o;) {
        e = e[n(i[t++])];
      }
      return t && t == o ? e : void 0;
    };
  }, function (e, i, t) {
    var a = t(211),
      n = t(214),
      o = t(216);
    e.exports = function flatRest(e) {
      return o(n(e, void 0, a), e + "");
    };
  }, function (e, i, t) {
    "use strict";

    e.exports = function bind(e, i) {
      return function wrap() {
        for (var t = new Array(arguments.length), a = 0; a < t.length; a++) {
          t[a] = arguments[a];
        }
        return e.apply(i, t);
      };
    };
  }, function (e, i, t) {
    "use strict";

    var a = t(8),
      n = t(246),
      o = t(248),
      r = t(249),
      s = t(250),
      _ = t(101),
      l = "undefined" !== typeof window && window.btoa && window.btoa.bind(window) || t(251);
    e.exports = function xhrAdapter(e) {
      return new Promise(function dispatchXhrRequest(i, g) {
        var f = e.data,
          h = e.headers;
        a.isFormData(f) && delete h["Content-Type"];
        var d = new XMLHttpRequest(),
          m = "onreadystatechange",
          u = !1;
        if ("undefined" === typeof window || !window.XDomainRequest || "withCredentials" in d || s(e.url) || (d = new window.XDomainRequest(), m = "onload", u = !0, d.onprogress = function handleProgress() {}, d.ontimeout = function handleTimeout() {}), e.auth) {
          var c = e.auth.username || "",
            F = e.auth.password || "";
          h.Authorization = "Basic " + l(c + ":" + F);
        }
        if (d.open(e.method.toUpperCase(), o(e.url, e.params, e.paramsSerializer), !0), d.timeout = e.timeout, d[m] = function handleLoad() {
          if (d && (4 === d.readyState || u) && (0 !== d.status || d.responseURL && 0 === d.responseURL.indexOf("file:"))) {
            var t = "getAllResponseHeaders" in d ? r(d.getAllResponseHeaders()) : null,
              a = {
                data: e.responseType && "text" !== e.responseType ? d.response : d.responseText,
                status: 1223 === d.status ? 204 : d.status,
                statusText: 1223 === d.status ? "No Content" : d.statusText,
                headers: t,
                config: e,
                request: d
              };
            n(i, g, a), d = null;
          }
        }, d.onerror = function handleError() {
          g(_("Network Error", e, null, d)), d = null;
        }, d.ontimeout = function handleTimeout() {
          g(_("timeout of " + e.timeout + "ms exceeded", e, "ECONNABORTED", d)), d = null;
        }, a.isStandardBrowserEnv()) {
          var p = t(252),
            b = (e.withCredentials || s(e.url)) && e.xsrfCookieName ? p.read(e.xsrfCookieName) : void 0;
          b && (h[e.xsrfHeaderName] = b);
        }
        if ("setRequestHeader" in d && a.forEach(h, function setRequestHeader(e, i) {
          "undefined" === typeof f && "content-type" === i.toLowerCase() ? delete h[i] : d.setRequestHeader(i, e);
        }), e.withCredentials && (d.withCredentials = !0), e.responseType) try {
          d.responseType = e.responseType;
        } catch (y) {
          if ("json" !== e.responseType) throw y;
        }
        "function" === typeof e.onDownloadProgress && d.addEventListener("progress", e.onDownloadProgress), "function" === typeof e.onUploadProgress && d.upload && d.upload.addEventListener("progress", e.onUploadProgress), e.cancelToken && e.cancelToken.promise.then(function onCanceled(e) {
          d && (d.abort(), g(e), d = null);
        }), void 0 === f && (f = null), d.send(f);
      });
    };
  }, function (e, i, t) {
    "use strict";

    var a = t(247);
    e.exports = function createError(e, i, t, n, o) {
      var r = new Error(e);
      return a(r, i, t, n, o);
    };
  }, function (e, i, t) {
    "use strict";

    e.exports = function isCancel(e) {
      return !(!e || !e.__CANCEL__);
    };
  }, function (e, i, t) {
    "use strict";

    function Cancel(e) {
      this.message = e;
    }
    Cancel.prototype.toString = function toString() {
      return "Cancel" + (this.message ? ": " + this.message : "");
    }, Cancel.prototype.__CANCEL__ = !0, e.exports = Cancel;
  }, function (e, i, t) {
    "use strict";

    var a = Object.prototype.hasOwnProperty,
      n = function () {
        for (var e = [], i = 0; i < 256; ++i) {
          e.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
        }
        return e;
      }(),
      o = function arrayToObject(e, i) {
        for (var t = i && i.plainObjects ? Object.create(null) : {}, a = 0; a < e.length; ++a) {
          "undefined" !== typeof e[a] && (t[a] = e[a]);
        }
        return t;
      };
    e.exports = {
      arrayToObject: o,
      assign: function assignSingleSource(e, i) {
        return Object.keys(i).reduce(function (e, t) {
          return e[t] = i[t], e;
        }, e);
      },
      compact: function compact(e) {
        for (var i = [{
            obj: {
              o: e
            },
            prop: "o"
          }], t = [], a = 0; a < i.length; ++a) {
          for (var n = i[a], o = n.obj[n.prop], r = Object.keys(o), s = 0; s < r.length; ++s) {
            var _ = r[s],
              l = o[_];
            "object" === typeof l && null !== l && -1 === t.indexOf(l) && (i.push({
              obj: o,
              prop: _
            }), t.push(l));
          }
        }
        return function compactQueue(e) {
          for (var i; e.length;) {
            var t = e.pop();
            if (i = t.obj[t.prop], Array.isArray(i)) {
              for (var a = [], n = 0; n < i.length; ++n) {
                "undefined" !== typeof i[n] && a.push(i[n]);
              }
              t.obj[t.prop] = a;
            }
          }
          return i;
        }(i);
      },
      decode: function decode(e) {
        try {
          return decodeURIComponent(e.replace(/\+/g, " "));
        } catch (i) {
          return e;
        }
      },
      encode: function encode(e) {
        if (0 === e.length) return e;
        for (var i = "string" === typeof e ? e : String(e), t = "", a = 0; a < i.length; ++a) {
          var o = i.charCodeAt(a);
          45 === o || 46 === o || 95 === o || 126 === o || o >= 48 && o <= 57 || o >= 65 && o <= 90 || o >= 97 && o <= 122 ? t += i.charAt(a) : o < 128 ? t += n[o] : o < 2048 ? t += n[192 | o >> 6] + n[128 | 63 & o] : o < 55296 || o >= 57344 ? t += n[224 | o >> 12] + n[128 | o >> 6 & 63] + n[128 | 63 & o] : (a += 1, o = 65536 + ((1023 & o) << 10 | 1023 & i.charCodeAt(a)), t += n[240 | o >> 18] + n[128 | o >> 12 & 63] + n[128 | o >> 6 & 63] + n[128 | 63 & o]);
        }
        return t;
      },
      isBuffer: function isBuffer(e) {
        return null !== e && "undefined" !== typeof e && !!(e.constructor && e.constructor.isBuffer && e.constructor.isBuffer(e));
      },
      isRegExp: function isRegExp(e) {
        return "[object RegExp]" === Object.prototype.toString.call(e);
      },
      merge: function merge(e, i, t) {
        if (!i) return e;
        if ("object" !== typeof i) {
          if (Array.isArray(e)) e.push(i);else {
            if ("object" !== typeof e) return [e, i];
            (t.plainObjects || t.allowPrototypes || !a.call(Object.prototype, i)) && (e[i] = !0);
          }
          return e;
        }
        if ("object" !== typeof e) return [e].concat(i);
        var n = e;
        return Array.isArray(e) && !Array.isArray(i) && (n = o(e, t)), Array.isArray(e) && Array.isArray(i) ? (i.forEach(function (i, n) {
          a.call(e, n) ? e[n] && "object" === typeof e[n] ? e[n] = merge(e[n], i, t) : e.push(i) : e[n] = i;
        }), e) : Object.keys(i).reduce(function (e, n) {
          var o = i[n];
          return a.call(e, n) ? e[n] = merge(e[n], o, t) : e[n] = o, e;
        }, n);
      }
    };
  }, function (e, i, t) {
    "use strict";

    var a = String.prototype.replace,
      n = /%20/g;
    e.exports = {
      default: "RFC3986",
      formatters: {
        RFC1738: function RFC1738(e) {
          return a.call(e, n, "+");
        },
        RFC3986: function RFC3986(e) {
          return e;
        }
      },
      RFC1738: "RFC1738",
      RFC3986: "RFC3986"
    };
  }, function (e, i, t) {
    var a = t(265);
    e.exports = function (e, i, t) {
      if (a(e), void 0 === i) return e;
      switch (t) {
        case 1:
          return function (t) {
            return e.call(i, t);
          };
        case 2:
          return function (t, a) {
            return e.call(i, t, a);
          };
        case 3:
          return function (t, a, n) {
            return e.call(i, t, a, n);
          };
      }
      return function () {
        return e.apply(i, arguments);
      };
    };
  }, function (e, i) {
    e.exports = function (e) {
      try {
        return !!e();
      } catch (i) {
        return !0;
      }
    };
  }, function (e, i, t) {
    var a = t(67),
      n = t(30).document,
      o = a(n) && a(n.createElement);
    e.exports = function (e) {
      return o ? n.createElement(e) : {};
    };
  }, function (e, i, t) {
    var a = t(269),
      n = t(115);
    e.exports = Object.keys || function keys(e) {
      return a(e, n);
    };
  }, function (e, i) {
    var t = {}.toString;
    e.exports = function (e) {
      return t.call(e).slice(8, -1);
    };
  }, function (e, i, t) {
    var a = t(71),
      n = Math.min;
    e.exports = function (e) {
      return e > 0 ? n(a(e), 9007199254740991) : 0;
    };
  }, function (e, i, t) {
    var a = t(23),
      n = t(30),
      o = n["__core-js_shared__"] || (n["__core-js_shared__"] = {});
    (e.exports = function (e, i) {
      return o[e] || (o[e] = void 0 !== i ? i : {});
    })("versions", []).push({
      version: a.version,
      mode: t(113) ? "pure" : "global",
      copyright: "\xa9 2019 Denis Pushkarev (zloirock.ru)"
    });
  }, function (e, i) {
    e.exports = !0;
  }, function (e, i) {
    var t = 0,
      a = Math.random();
    e.exports = function (e) {
      return "Symbol(".concat(void 0 === e ? "" : e, ")_", (++t + a).toString(36));
    };
  }, function (e, i) {
    e.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
  }, function (e, i, t) {
    var a = t(42).f,
      n = t(44),
      o = t(17)("toStringTag");
    e.exports = function (e, i, t) {
      e && !n(e = t ? e : e.prototype, o) && a(e, o, {
        configurable: !0,
        value: i
      });
    };
  }, function (e, i, t) {
    var a = t(70);
    e.exports = function (e) {
      return Object(a(e));
    };
  }, function (e, i, t) {
    "use strict";

    var a, n;
    a = new RegExp("^[^\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC]*[A-Za-z\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u0300-\u0590\u0800-\u1FFF\u200E\u2C00-\uFB1C\uFE00-\uFE6F\uFEFD-\uFFFF]"), n = new RegExp("^[^A-Za-z\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u0300-\u0590\u0800-\u1FFF\u200E\u2C00-\uFB1C\uFE00-\uFE6F\uFEFD-\uFFFF]*[\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC]"), e.exports = function direction(e) {
      return e = e.toString(), n.test(e) ? "rtl" : a.test(e) ? "ltr" : "neutral";
    };
  }, function (e, i) {
    e.exports = function isBackward(e) {
      var i = e.anchorNode,
        t = e.anchorOffset,
        a = e.focusNode,
        n = e.focusOffset,
        o = i.compareDocumentPosition(a);
      return !(4 === o || 0 === o && t < n);
    };
  }, function (e, i, t) {
    var a = t(230),
      n = t(10),
      o = "Expected a function";
    e.exports = function throttle(e, i, t) {
      var r = !0,
        s = !0;
      if ("function" != typeof e) throw new TypeError(o);
      return n(t) && (r = "leading" in t ? !!t.leading : r, s = "trailing" in t ? !!t.trailing : s), a(e, i, {
        leading: r,
        maxWait: i,
        trailing: s
      });
    };
  }, function (e, i, t) {
    "use strict";

    var a = t(45),
      n = t.n(a);
    t.o(a, "renderToStaticMarkup") && t.d(i, "renderToStaticMarkup", function () {
      return a.renderToStaticMarkup;
    });
    n.a;
  }, function (e, i) {
    e.exports = o;
  }, function (e, i) {
    e.exports = r;
  }, function (e, i, t) {
    var a, n;
    !function (o) {
      if (void 0 === (n = "function" === typeof (a = o) ? a.call(i, t, i, e) : a) || (e.exports = n), !0, e.exports = o(), !!0) {
        var r = window.Cookies,
          s = window.Cookies = o();
        s.noConflict = function () {
          return window.Cookies = r, s;
        };
      }
    }(function () {
      function extend() {
        for (var e = 0, i = {}; e < arguments.length; e++) {
          var t = arguments[e];
          for (var a in t) {
            i[a] = t[a];
          }
        }
        return i;
      }
      function decode(e) {
        return e.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
      }
      return function init(e) {
        function api() {}
        function set(i, t, a) {
          if ("undefined" !== typeof document) {
            "number" === typeof (a = extend({
              path: "/"
            }, api.defaults, a)).expires && (a.expires = new Date(1 * new Date() + 864e5 * a.expires)), a.expires = a.expires ? a.expires.toUTCString() : "";
            try {
              var n = JSON.stringify(t);
              /^[\{\[]/.test(n) && (t = n);
            } catch (s) {}
            t = e.write ? e.write(t, i) : encodeURIComponent(String(t)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), i = encodeURIComponent(String(i)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var o = "";
            for (var r in a) {
              a[r] && (o += "; " + r, !0 !== a[r] && (o += "=" + a[r].split(";")[0]));
            }
            return document.cookie = i + "=" + t + o;
          }
        }
        function get(i, t) {
          if ("undefined" !== typeof document) {
            for (var a = {}, n = document.cookie ? document.cookie.split("; ") : [], o = 0; o < n.length; o++) {
              var r = n[o].split("="),
                s = r.slice(1).join("=");
              t || '"' !== s.charAt(0) || (s = s.slice(1, -1));
              try {
                var _ = decode(r[0]);
                if (s = (e.read || e)(s, _) || decode(s), t) try {
                  s = JSON.parse(s);
                } catch (l) {}
                if (a[_] = s, i === _) break;
              } catch (l) {}
            }
            return i ? a[i] : a;
          }
        }
        return api.set = set, api.get = function (e) {
          return get(e, !1);
        }, api.getJSON = function (e) {
          return get(e, !0);
        }, api.remove = function (e, i) {
          set(e, "", extend(i, {
            expires: -1
          }));
        }, api.defaults = {}, api.withConverter = init, api;
      }(function () {});
    });
  }, function (e) {
    e.exports = {
      CUSTOMER_API: "https://customer2.api.driftqa.com",
      CONVERSATION_API: "https://conversation2.api.driftqa.com",
      ACCOUNTS_API: "https://account.api.driftqa.com",
      WS_API: "https://ws.api.driftqa.com",
      WS: "wss://ws.api.driftqa.com",
      FILE_API: "https://file2.api.driftqa.com",
      SALES_INBOX_ID: 44,
      SALES_USER_ID: 46894,
      MEETINGS_API: "https://meetings.api.driftqa.com"
    };
  }, function (e) {
    e.exports = {
      CUSTOMER_API: "https://customer.api.drift.com",
      CONVERSATION_API: "https://conversation.api.drift.com",
      ACCOUNTS_API: "https://account.api.drift.com",
      WS_API: "https://ws.api.drift.com",
      WS: "wss://ws.api.drift.com",
      FILE_API: "https://file2.api.drift.com",
      SALES_INBOX_ID: 44,
      SALES_USER_ID: 46894,
      MEETINGS_API: "https://meetings.api.drift.com"
    };
  }, function (e, i, t) {
    e.exports = {
      default: t(263),
      __esModule: !0
    };
  }, function (e, i, t) {
    "use strict";

    i.__esModule = !0;
    var a = function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }(t(274));
    i.default = function (e) {
      if (Array.isArray(e)) {
        for (var i = 0, t = Array(e.length); i < e.length; i++) {
          t[i] = e[i];
        }
        return t;
      }
      return (0, a.default)(e);
    };
  }, function (e, i, t) {
    e.exports = t(299);
  }, function (e, i, t) {
    "use strict";

    e.exports = function setup(e) {
      function selectColor(e) {
        for (var i = 0, t = 0; t < e.length; t++) {
          i = (i << 5) - i + e.charCodeAt(t), i |= 0;
        }
        return createDebug.colors[Math.abs(i) % createDebug.colors.length];
      }
      function createDebug(e) {
        var i;
        function debug() {
          if (debug.enabled) {
            for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++) {
              t[a] = arguments[a];
            }
            var n = debug,
              o = Number(new Date()),
              r = o - (i || o);
            n.diff = r, n.prev = i, n.curr = o, i = o, t[0] = createDebug.coerce(t[0]), "string" !== typeof t[0] && t.unshift("%O");
            var s = 0;
            t[0] = t[0].replace(/%([a-zA-Z%])/g, function (e, i) {
              if ("%%" === e) return e;
              s++;
              var a = createDebug.formatters[i];
              if ("function" === typeof a) {
                var o = t[s];
                e = a.call(n, o), t.splice(s, 1), s--;
              }
              return e;
            }), createDebug.formatArgs.call(n, t), (n.log || createDebug.log).apply(n, t);
          }
        }
        return debug.namespace = e, debug.enabled = createDebug.enabled(e), debug.useColors = createDebug.useColors(), debug.color = selectColor(e), debug.destroy = destroy, debug.extend = extend, "function" === typeof createDebug.init && createDebug.init(debug), createDebug.instances.push(debug), debug;
      }
      function destroy() {
        var e = createDebug.instances.indexOf(this);
        return -1 !== e && (createDebug.instances.splice(e, 1), !0);
      }
      function extend(e, i) {
        return createDebug(this.namespace + ("undefined" === typeof i ? ":" : i) + e);
      }
      return createDebug.debug = createDebug, createDebug.default = createDebug, createDebug.coerce = function coerce(e) {
        return e instanceof Error ? e.stack || e.message : e;
      }, createDebug.disable = function disable() {
        createDebug.enable("");
      }, createDebug.enable = function enable(e) {
        var i;
        createDebug.save(e), createDebug.names = [], createDebug.skips = [];
        var t = ("string" === typeof e ? e : "").split(/[\s,]+/),
          a = t.length;
        for (i = 0; i < a; i++) {
          t[i] && ("-" === (e = t[i].replace(/\*/g, ".*?"))[0] ? createDebug.skips.push(new RegExp("^" + e.substr(1) + "$")) : createDebug.names.push(new RegExp("^" + e + "$")));
        }
        for (i = 0; i < createDebug.instances.length; i++) {
          var n = createDebug.instances[i];
          n.enabled = createDebug.enabled(n.namespace);
        }
      }, createDebug.enabled = function enabled(e) {
        if ("*" === e[e.length - 1]) return !0;
        var i, t;
        for (i = 0, t = createDebug.skips.length; i < t; i++) {
          if (createDebug.skips[i].test(e)) return !1;
        }
        for (i = 0, t = createDebug.names.length; i < t; i++) {
          if (createDebug.names[i].test(e)) return !0;
        }
        return !1;
      }, createDebug.humanize = t(78), Object.keys(e).forEach(function (i) {
        createDebug[i] = e[i];
      }), createDebug.instances = [], createDebug.names = [], createDebug.skips = [], createDebug.formatters = {}, createDebug.selectColor = selectColor, createDebug.enable(createDebug.load()), createDebug;
    };
  }, function (e, i, t) {
    "use strict";

    var a = t(132);
    function emptyFunction() {}
    function emptyFunctionWithReset() {}
    emptyFunctionWithReset.resetWarningCache = emptyFunction, e.exports = function () {
      function shim(e, i, t, n, o, r) {
        if (r !== a) {
          var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw s.name = "Invariant Violation", s;
        }
      }
      function getShim() {
        return shim;
      }
      shim.isRequired = shim;
      var e = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
      };
      return e.PropTypes = e, e;
    };
  }, function (e, i, t) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, i, t) {
    "use strict";

    e.exports = function isObject(e) {
      return null != e && "object" === typeof e && !1 === Array.isArray(e);
    };
  }, function (e, i, t) {
    var a = t(135),
      n = t(164),
      o = t(52),
      r = t(165),
      s = t(173),
      _ = t(176),
      l = t(177),
      g = t(178),
      f = t(180),
      h = t(181),
      d = t(96),
      m = t(63),
      u = t(186),
      c = t(187),
      F = t(193),
      p = t(12),
      b = t(89),
      y = t(195),
      k = t(10),
      v = t(197),
      w = t(53),
      E = 1,
      A = 2,
      j = 4,
      x = "[object Arguments]",
      C = "[object Function]",
      D = "[object GeneratorFunction]",
      B = "[object Object]",
      S = {};
    S[x] = S["[object Array]"] = S["[object ArrayBuffer]"] = S["[object DataView]"] = S["[object Boolean]"] = S["[object Date]"] = S["[object Float32Array]"] = S["[object Float64Array]"] = S["[object Int8Array]"] = S["[object Int16Array]"] = S["[object Int32Array]"] = S["[object Map]"] = S["[object Number]"] = S[B] = S["[object RegExp]"] = S["[object Set]"] = S["[object String]"] = S["[object Symbol]"] = S["[object Uint8Array]"] = S["[object Uint8ClampedArray]"] = S["[object Uint16Array]"] = S["[object Uint32Array]"] = !0, S["[object Error]"] = S[C] = S["[object WeakMap]"] = !1, e.exports = function baseClone(e, i, t, q, O, T) {
      var N,
        I = i & E,
        P = i & A,
        M = i & j;
      if (t && (N = O ? t(e, q, O, T) : t(e)), void 0 !== N) return N;
      if (!k(e)) return e;
      var R = p(e);
      if (R) {
        if (N = u(e), !I) return l(e, N);
      } else {
        var z = m(e),
          L = z == C || z == D;
        if (b(e)) return _(e, I);
        if (z == B || z == x || L && !O) {
          if (N = P || L ? {} : F(e), !I) return P ? f(e, s(N, e)) : g(e, r(N, e));
        } else {
          if (!S[z]) return O ? e : {};
          N = c(e, z, I);
        }
      }
      T || (T = new a());
      var W = T.get(e);
      if (W) return W;
      T.set(e, N), v(e) ? e.forEach(function (a) {
        N.add(baseClone(a, i, t, a, e, T));
      }) : y(e) && e.forEach(function (a, n) {
        N.set(n, baseClone(a, i, t, n, e, T));
      });
      var U = M ? P ? d : h : P ? keysIn : w,
        K = R ? void 0 : U(e);
      return n(K || e, function (a, n) {
        K && (a = e[n = a]), o(N, n, baseClone(a, i, t, n, e, T));
      }), N;
    };
  }, function (e, i, t) {
    var a = t(35),
      n = t(141),
      o = t(142),
      r = t(143),
      s = t(144),
      _ = t(145);
    function Stack(e) {
      var i = this.__data__ = new a(e);
      this.size = i.size;
    }
    Stack.prototype.clear = n, Stack.prototype.delete = o, Stack.prototype.get = r, Stack.prototype.has = s, Stack.prototype.set = _, e.exports = Stack;
  }, function (e, i) {
    e.exports = function listCacheClear() {
      this.__data__ = [], this.size = 0;
    };
  }, function (e, i, t) {
    var a = t(36),
      n = Array.prototype.splice;
    e.exports = function listCacheDelete(e) {
      var i = this.__data__,
        t = a(i, e);
      return !(t < 0) && (t == i.length - 1 ? i.pop() : n.call(i, t, 1), --this.size, !0);
    };
  }, function (e, i, t) {
    var a = t(36);
    e.exports = function listCacheGet(e) {
      var i = this.__data__,
        t = a(i, e);
      return t < 0 ? void 0 : i[t][1];
    };
  }, function (e, i, t) {
    var a = t(36);
    e.exports = function listCacheHas(e) {
      return a(this.__data__, e) > -1;
    };
  }, function (e, i, t) {
    var a = t(36);
    e.exports = function listCacheSet(e, i) {
      var t = this.__data__,
        n = a(t, e);
      return n < 0 ? (++this.size, t.push([e, i])) : t[n][1] = i, this;
    };
  }, function (e, i, t) {
    var a = t(35);
    e.exports = function stackClear() {
      this.__data__ = new a(), this.size = 0;
    };
  }, function (e, i) {
    e.exports = function stackDelete(e) {
      var i = this.__data__,
        t = i.delete(e);
      return this.size = i.size, t;
    };
  }, function (e, i) {
    e.exports = function stackGet(e) {
      return this.__data__.get(e);
    };
  }, function (e, i) {
    e.exports = function stackHas(e) {
      return this.__data__.has(e);
    };
  }, function (e, i, t) {
    var a = t(35),
      n = t(51),
      o = t(85),
      r = 200;
    e.exports = function stackSet(e, i) {
      var t = this.__data__;
      if (t instanceof a) {
        var s = t.__data__;
        if (!n || s.length < r - 1) return s.push([e, i]), this.size = ++t.size, this;
        t = this.__data__ = new o(s);
      }
      return t.set(e, i), this.size = t.size, this;
    };
  }, function (e, i, t) {
    var a = t(82),
      n = t(149),
      o = t(10),
      r = t(84),
      s = /^\[object .+?Constructor\]$/,
      _ = Function.prototype,
      l = Object.prototype,
      g = _.toString,
      f = l.hasOwnProperty,
      h = RegExp("^" + g.call(f).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
    e.exports = function baseIsNative(e) {
      return !(!o(e) || n(e)) && (a(e) ? h : s).test(r(e));
    };
  }, function (e, i, t) {
    var a = t(28),
      n = Object.prototype,
      o = n.hasOwnProperty,
      r = n.toString,
      s = a ? a.toStringTag : void 0;
    e.exports = function getRawTag(e) {
      var i = o.call(e, s),
        t = e[s];
      try {
        e[s] = void 0;
        var a = !0;
      } catch (_) {}
      var n = r.call(e);
      return a && (i ? e[s] = t : delete e[s]), n;
    };
  }, function (e, i) {
    var t = Object.prototype.toString;
    e.exports = function objectToString(e) {
      return t.call(e);
    };
  }, function (e, i, t) {
    var a = t(150),
      n = function () {
        var e = /[^.]+$/.exec(a && a.keys && a.keys.IE_PROTO || "");
        return e ? "Symbol(src)_1." + e : "";
      }();
    e.exports = function isMasked(e) {
      return !!n && n in e;
    };
  }, function (e, i, t) {
    var a = t(9)["__core-js_shared__"];
    e.exports = a;
  }, function (e, i) {
    e.exports = function getValue(e, i) {
      return null == e ? void 0 : e[i];
    };
  }, function (e, i, t) {
    var a = t(153),
      n = t(35),
      o = t(51);
    e.exports = function mapCacheClear() {
      this.size = 0, this.__data__ = {
        hash: new a(),
        map: new (o || n)(),
        string: new a()
      };
    };
  }, function (e, i, t) {
    var a = t(154),
      n = t(155),
      o = t(156),
      r = t(157),
      s = t(158);
    function Hash(e) {
      var i = -1,
        t = null == e ? 0 : e.length;
      for (this.clear(); ++i < t;) {
        var a = e[i];
        this.set(a[0], a[1]);
      }
    }
    Hash.prototype.clear = a, Hash.prototype.delete = n, Hash.prototype.get = o, Hash.prototype.has = r, Hash.prototype.set = s, e.exports = Hash;
  }, function (e, i, t) {
    var a = t(37);
    e.exports = function hashClear() {
      this.__data__ = a ? a(null) : {}, this.size = 0;
    };
  }, function (e, i) {
    e.exports = function hashDelete(e) {
      var i = this.has(e) && delete this.__data__[e];
      return this.size -= i ? 1 : 0, i;
    };
  }, function (e, i, t) {
    var a = t(37),
      n = "__lodash_hash_undefined__",
      o = Object.prototype.hasOwnProperty;
    e.exports = function hashGet(e) {
      var i = this.__data__;
      if (a) {
        var t = i[e];
        return t === n ? void 0 : t;
      }
      return o.call(i, e) ? i[e] : void 0;
    };
  }, function (e, i, t) {
    var a = t(37),
      n = Object.prototype.hasOwnProperty;
    e.exports = function hashHas(e) {
      var i = this.__data__;
      return a ? void 0 !== i[e] : n.call(i, e);
    };
  }, function (e, i, t) {
    var a = t(37),
      n = "__lodash_hash_undefined__";
    e.exports = function hashSet(e, i) {
      var t = this.__data__;
      return this.size += this.has(e) ? 0 : 1, t[e] = a && void 0 === i ? n : i, this;
    };
  }, function (e, i, t) {
    var a = t(38);
    e.exports = function mapCacheDelete(e) {
      var i = a(this, e).delete(e);
      return this.size -= i ? 1 : 0, i;
    };
  }, function (e, i) {
    e.exports = function isKeyable(e) {
      var i = typeof e;
      return "string" == i || "number" == i || "symbol" == i || "boolean" == i ? "__proto__" !== e : null === e;
    };
  }, function (e, i, t) {
    var a = t(38);
    e.exports = function mapCacheGet(e) {
      return a(this, e).get(e);
    };
  }, function (e, i, t) {
    var a = t(38);
    e.exports = function mapCacheHas(e) {
      return a(this, e).has(e);
    };
  }, function (e, i, t) {
    var a = t(38);
    e.exports = function mapCacheSet(e, i) {
      var t = a(this, e),
        n = t.size;
      return t.set(e, i), this.size += t.size == n ? 0 : 1, this;
    };
  }, function (e, i) {
    e.exports = function arrayEach(e, i) {
      for (var t = -1, a = null == e ? 0 : e.length; ++t < a && !1 !== i(e[t], t, e);) {
        ;
      }
      return e;
    };
  }, function (e, i, t) {
    var a = t(29),
      n = t(53);
    e.exports = function baseAssign(e, i) {
      return e && a(i, n(i), e);
    };
  }, function (e, i) {
    e.exports = function baseTimes(e, i) {
      for (var t = -1, a = Array(e); ++t < e;) {
        a[t] = i(t);
      }
      return a;
    };
  }, function (e, i, t) {
    var a = t(19),
      n = t(16),
      o = "[object Arguments]";
    e.exports = function baseIsArguments(e) {
      return n(e) && a(e) == o;
    };
  }, function (e, i) {
    e.exports = function stubFalse() {
      return !1;
    };
  }, function (e, i, t) {
    var a = t(170),
      n = t(57),
      o = t(58),
      r = o && o.isTypedArray,
      s = r ? n(r) : a;
    e.exports = s;
  }, function (e, i, t) {
    var a = t(19),
      n = t(56),
      o = t(16),
      r = {};
    r["[object Float32Array]"] = r["[object Float64Array]"] = r["[object Int8Array]"] = r["[object Int16Array]"] = r["[object Int32Array]"] = r["[object Uint8Array]"] = r["[object Uint8ClampedArray]"] = r["[object Uint16Array]"] = r["[object Uint32Array]"] = !0, r["[object Arguments]"] = r["[object Array]"] = r["[object ArrayBuffer]"] = r["[object Boolean]"] = r["[object DataView]"] = r["[object Date]"] = r["[object Error]"] = r["[object Function]"] = r["[object Map]"] = r["[object Number]"] = r["[object Object]"] = r["[object RegExp]"] = r["[object Set]"] = r["[object String]"] = r["[object WeakMap]"] = !1, e.exports = function baseIsTypedArray(e) {
      return o(e) && n(e.length) && !!r[a(e)];
    };
  }, function (e, i, t) {
    var a = t(59),
      n = t(172),
      o = Object.prototype.hasOwnProperty;
    e.exports = function baseKeys(e) {
      if (!a(e)) return n(e);
      var i = [];
      for (var t in Object(e)) {
        o.call(e, t) && "constructor" != t && i.push(t);
      }
      return i;
    };
  }, function (e, i, t) {
    var a = t(90)(Object.keys, Object);
    e.exports = a;
  }, function (e, i, t) {
    var a = t(29),
      n = t(92);
    e.exports = function baseAssignIn(e, i) {
      return e && a(i, n(i), e);
    };
  }, function (e, i, t) {
    var a = t(10),
      n = t(59),
      o = t(175),
      r = Object.prototype.hasOwnProperty;
    e.exports = function baseKeysIn(e) {
      if (!a(e)) return o(e);
      var i = n(e),
        t = [];
      for (var s in e) {
        ("constructor" != s || !i && r.call(e, s)) && t.push(s);
      }
      return t;
    };
  }, function (e, i) {
    e.exports = function nativeKeysIn(e) {
      var i = [];
      if (null != e) for (var t in Object(e)) {
        i.push(t);
      }
      return i;
    };
  }, function (e, i, t) {
    (function (e) {
      var a = t(9),
        n = i && !i.nodeType && i,
        o = n && "object" == typeof e && e && !e.nodeType && e,
        r = o && o.exports === n ? a.Buffer : void 0,
        s = r ? r.allocUnsafe : void 0;
      e.exports = function cloneBuffer(e, i) {
        if (i) return e.slice();
        var t = e.length,
          a = s ? s(t) : new e.constructor(t);
        return e.copy(a), a;
      };
    }).call(this, t(34)(e));
  }, function (e, i) {
    e.exports = function copyArray(e, i) {
      var t = -1,
        a = e.length;
      for (i || (i = Array(a)); ++t < a;) {
        i[t] = e[t];
      }
      return i;
    };
  }, function (e, i, t) {
    var a = t(29),
      n = t(60);
    e.exports = function copySymbols(e, i) {
      return a(e, n(e), i);
    };
  }, function (e, i) {
    e.exports = function arrayFilter(e, i) {
      for (var t = -1, a = null == e ? 0 : e.length, n = 0, o = []; ++t < a;) {
        var r = e[t];
        i(r, t, e) && (o[n++] = r);
      }
      return o;
    };
  }, function (e, i, t) {
    var a = t(29),
      n = t(94);
    e.exports = function copySymbolsIn(e, i) {
      return a(e, n(e), i);
    };
  }, function (e, i, t) {
    var a = t(95),
      n = t(60),
      o = t(53);
    e.exports = function getAllKeys(e) {
      return a(e, o, n);
    };
  }, function (e, i, t) {
    var a = t(15)(t(9), "DataView");
    e.exports = a;
  }, function (e, i, t) {
    var a = t(15)(t(9), "Promise");
    e.exports = a;
  }, function (e, i, t) {
    var a = t(15)(t(9), "Set");
    e.exports = a;
  }, function (e, i, t) {
    var a = t(15)(t(9), "WeakMap");
    e.exports = a;
  }, function (e, i) {
    var t = Object.prototype.hasOwnProperty;
    e.exports = function initCloneArray(e) {
      var i = e.length,
        a = new e.constructor(i);
      return i && "string" == typeof e[0] && t.call(e, "index") && (a.index = e.index, a.input = e.input), a;
    };
  }, function (e, i, t) {
    var a = t(64),
      n = t(189),
      o = t(190),
      r = t(191),
      s = t(192),
      _ = "[object Boolean]",
      l = "[object Date]",
      g = "[object Map]",
      f = "[object Number]",
      h = "[object RegExp]",
      d = "[object Set]",
      m = "[object String]",
      u = "[object Symbol]",
      c = "[object ArrayBuffer]",
      F = "[object DataView]",
      p = "[object Float32Array]",
      b = "[object Float64Array]",
      y = "[object Int8Array]",
      k = "[object Int16Array]",
      v = "[object Int32Array]",
      w = "[object Uint8Array]",
      E = "[object Uint8ClampedArray]",
      A = "[object Uint16Array]",
      j = "[object Uint32Array]";
    e.exports = function initCloneByTag(e, i, t) {
      var x = e.constructor;
      switch (i) {
        case c:
          return a(e);
        case _:
        case l:
          return new x(+e);
        case F:
          return n(e, t);
        case p:
        case b:
        case y:
        case k:
        case v:
        case w:
        case E:
        case A:
        case j:
          return s(e, t);
        case g:
          return new x();
        case f:
        case m:
          return new x(e);
        case h:
          return o(e);
        case d:
          return new x();
        case u:
          return r(e);
      }
    };
  }, function (e, i, t) {
    var a = t(9).Uint8Array;
    e.exports = a;
  }, function (e, i, t) {
    var a = t(64);
    e.exports = function cloneDataView(e, i) {
      var t = i ? a(e.buffer) : e.buffer;
      return new e.constructor(t, e.byteOffset, e.byteLength);
    };
  }, function (e, i) {
    var t = /\w*$/;
    e.exports = function cloneRegExp(e) {
      var i = new e.constructor(e.source, t.exec(e));
      return i.lastIndex = e.lastIndex, i;
    };
  }, function (e, i, t) {
    var a = t(28),
      n = a ? a.prototype : void 0,
      o = n ? n.valueOf : void 0;
    e.exports = function cloneSymbol(e) {
      return o ? Object(o.call(e)) : {};
    };
  }, function (e, i, t) {
    var a = t(64);
    e.exports = function cloneTypedArray(e, i) {
      var t = i ? a(e.buffer) : e.buffer;
      return new e.constructor(t, e.byteOffset, e.length);
    };
  }, function (e, i, t) {
    var a = t(194),
      n = t(62),
      o = t(59);
    e.exports = function initCloneObject(e) {
      return "function" != typeof e.constructor || o(e) ? {} : a(n(e));
    };
  }, function (e, i, t) {
    var a = t(10),
      n = Object.create,
      o = function () {
        function object() {}
        return function (e) {
          if (!a(e)) return {};
          if (n) return n(e);
          object.prototype = e;
          var i = new object();
          return object.prototype = void 0, i;
        };
      }();
    e.exports = o;
  }, function (e, i, t) {
    var a = t(196),
      n = t(57),
      o = t(58),
      r = o && o.isMap,
      s = r ? n(r) : a;
    e.exports = s;
  }, function (e, i, t) {
    var a = t(63),
      n = t(16),
      o = "[object Map]";
    e.exports = function baseIsMap(e) {
      return n(e) && a(e) == o;
    };
  }, function (e, i, t) {
    var a = t(198),
      n = t(57),
      o = t(58),
      r = o && o.isSet,
      s = r ? n(r) : a;
    e.exports = s;
  }, function (e, i, t) {
    var a = t(63),
      n = t(16),
      o = "[object Set]";
    e.exports = function baseIsSet(e) {
      return n(e) && a(e) == o;
    };
  }, function (e, i, t) {
    var a = t(20),
      n = t(206),
      o = t(207),
      r = t(40);
    e.exports = function baseUnset(e, i) {
      return i = a(i, e), null == (e = o(e, i)) || delete e[r(n(i))];
    };
  }, function (e, i, t) {
    var a = t(12),
      n = t(39),
      o = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      r = /^\w*$/;
    e.exports = function isKey(e, i) {
      if (a(e)) return !1;
      var t = typeof e;
      return !("number" != t && "symbol" != t && "boolean" != t && null != e && !n(e)) || r.test(e) || !o.test(e) || null != i && e in Object(i);
    };
  }, function (e, i, t) {
    var a = t(202),
      n = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
      o = /\\(\\)?/g,
      r = a(function (e) {
        var i = [];
        return 46 === e.charCodeAt(0) && i.push(""), e.replace(n, function (e, t, a, n) {
          i.push(a ? n.replace(o, "$1") : t || e);
        }), i;
      });
    e.exports = r;
  }, function (e, i, t) {
    var a = t(203),
      n = 500;
    e.exports = function memoizeCapped(e) {
      var i = a(e, function (e) {
          return t.size === n && t.clear(), e;
        }),
        t = i.cache;
      return i;
    };
  }, function (e, i, t) {
    var a = t(85),
      n = "Expected a function";
    function memoize(e, i) {
      if ("function" != typeof e || null != i && "function" != typeof i) throw new TypeError(n);
      var t = function memoized() {
        var t = arguments,
          a = i ? i.apply(this, t) : t[0],
          n = memoized.cache;
        if (n.has(a)) return n.get(a);
        var o = e.apply(this, t);
        return memoized.cache = n.set(a, o) || n, o;
      };
      return t.cache = new (memoize.Cache || a)(), t;
    }
    memoize.Cache = a, e.exports = memoize;
  }, function (e, i, t) {
    var a = t(205);
    e.exports = function toString(e) {
      return null == e ? "" : a(e);
    };
  }, function (e, i, t) {
    var a = t(28),
      n = t(80),
      o = t(12),
      r = t(39),
      s = 1 / 0,
      _ = a ? a.prototype : void 0,
      l = _ ? _.toString : void 0;
    e.exports = function baseToString(e) {
      if ("string" == typeof e) return e;
      if (o(e)) return n(e, baseToString) + "";
      if (r(e)) return l ? l.call(e) : "";
      var i = e + "";
      return "0" == i && 1 / e == -s ? "-0" : i;
    };
  }, function (e, i) {
    e.exports = function last(e) {
      var i = null == e ? 0 : e.length;
      return i ? e[i - 1] : void 0;
    };
  }, function (e, i, t) {
    var a = t(97),
      n = t(208);
    e.exports = function parent(e, i) {
      return i.length < 2 ? e : a(e, n(i, 0, -1));
    };
  }, function (e, i) {
    e.exports = function baseSlice(e, i, t) {
      var a = -1,
        n = e.length;
      i < 0 && (i = -i > n ? 0 : n + i), (t = t > n ? n : t) < 0 && (t += n), n = i > t ? 0 : t - i >>> 0, i >>>= 0;
      for (var o = Array(n); ++a < n;) {
        o[a] = e[a + i];
      }
      return o;
    };
  }, function (e, i, t) {
    var a = t(210);
    e.exports = function customOmitClone(e) {
      return a(e) ? void 0 : e;
    };
  }, function (e, i, t) {
    var a = t(19),
      n = t(62),
      o = t(16),
      r = "[object Object]",
      s = Function.prototype,
      _ = Object.prototype,
      l = s.toString,
      g = _.hasOwnProperty,
      f = l.call(Object);
    e.exports = function isPlainObject(e) {
      if (!o(e) || a(e) != r) return !1;
      var i = n(e);
      if (null === i) return !0;
      var t = g.call(i, "constructor") && i.constructor;
      return "function" == typeof t && t instanceof t && l.call(t) == f;
    };
  }, function (e, i, t) {
    var a = t(212);
    e.exports = function flatten(e) {
      return null != e && e.length ? a(e, 1) : [];
    };
  }, function (e, i, t) {
    var a = t(61),
      n = t(213);
    e.exports = function baseFlatten(e, i, t, o, r) {
      var s = -1,
        _ = e.length;
      for (t || (t = n), r || (r = []); ++s < _;) {
        var l = e[s];
        i > 0 && t(l) ? i > 1 ? baseFlatten(l, i - 1, t, o, r) : a(r, l) : o || (r[r.length] = l);
      }
      return r;
    };
  }, function (e, i, t) {
    var a = t(28),
      n = t(54),
      o = t(12),
      r = a ? a.isConcatSpreadable : void 0;
    e.exports = function isFlattenable(e) {
      return o(e) || n(e) || !!(r && e && e[r]);
    };
  }, function (e, i, t) {
    var a = t(215),
      n = Math.max;
    e.exports = function overRest(e, i, t) {
      return i = n(void 0 === i ? e.length - 1 : i, 0), function () {
        for (var o = arguments, r = -1, s = n(o.length - i, 0), _ = Array(s); ++r < s;) {
          _[r] = o[i + r];
        }
        r = -1;
        for (var l = Array(i + 1); ++r < i;) {
          l[r] = o[r];
        }
        return l[i] = t(_), a(e, this, l);
      };
    };
  }, function (e, i) {
    e.exports = function apply(e, i, t) {
      switch (t.length) {
        case 0:
          return e.call(i);
        case 1:
          return e.call(i, t[0]);
        case 2:
          return e.call(i, t[0], t[1]);
        case 3:
          return e.call(i, t[0], t[1], t[2]);
      }
      return e.apply(i, t);
    };
  }, function (e, i, t) {
    var a = t(217),
      n = t(220)(a);
    e.exports = n;
  }, function (e, i, t) {
    var a = t(218),
      n = t(87),
      o = t(219),
      r = n ? function (e, i) {
        return n(e, "toString", {
          configurable: !0,
          enumerable: !1,
          value: a(i),
          writable: !0
        });
      } : o;
    e.exports = r;
  }, function (e, i) {
    e.exports = function constant(e) {
      return function () {
        return e;
      };
    };
  }, function (e, i) {
    e.exports = function identity(e) {
      return e;
    };
  }, function (e, i) {
    var t = 800,
      a = 16,
      n = Date.now;
    e.exports = function shortOut(e) {
      var i = 0,
        o = 0;
      return function () {
        var r = n(),
          s = a - (r - o);
        if (o = r, s > 0) {
          if (++i >= t) return arguments[0];
        } else i = 0;
        return e.apply(void 0, arguments);
      };
    };
  }, function (e, i, t) {
    var a = t(222),
      n = t(224);
    e.exports = function basePick(e, i) {
      return a(e, i, function (i, t) {
        return n(e, t);
      });
    };
  }, function (e, i, t) {
    var a = t(97),
      n = t(223),
      o = t(20);
    e.exports = function basePickBy(e, i, t) {
      for (var r = -1, s = i.length, _ = {}; ++r < s;) {
        var l = i[r],
          g = a(e, l);
        t(g, l) && n(_, o(l, e), g);
      }
      return _;
    };
  }, function (e, i, t) {
    var a = t(52),
      n = t(20),
      o = t(55),
      r = t(10),
      s = t(40);
    e.exports = function baseSet(e, i, t, _) {
      if (!r(e)) return e;
      for (var l = -1, g = (i = n(i, e)).length, f = g - 1, h = e; null != h && ++l < g;) {
        var d = s(i[l]),
          m = t;
        if (l != f) {
          var u = h[d];
          void 0 === (m = _ ? _(u, d, h) : void 0) && (m = r(u) ? u : o(i[l + 1]) ? [] : {});
        }
        a(h, d, m), h = h[d];
      }
      return e;
    };
  }, function (e, i, t) {
    var a = t(225),
      n = t(226);
    e.exports = function hasIn(e, i) {
      return null != e && n(e, i, a);
    };
  }, function (e, i) {
    e.exports = function baseHasIn(e, i) {
      return null != e && i in Object(e);
    };
  }, function (e, i, t) {
    var a = t(20),
      n = t(54),
      o = t(12),
      r = t(55),
      s = t(56),
      _ = t(40);
    e.exports = function hasPath(e, i, t) {
      for (var l = -1, g = (i = a(i, e)).length, f = !1; ++l < g;) {
        var h = _(i[l]);
        if (!(f = null != e && t(e, h))) break;
        e = e[h];
      }
      return f || ++l != g ? f : !!(g = null == e ? 0 : e.length) && s(g) && r(h, g) && (o(e) || n(e));
    };
  }, function (e, i, t) {
    "use strict";

    e.exports = function setup(e) {
      function selectColor(e) {
        for (var i = 0, t = 0; t < e.length; t++) {
          i = (i << 5) - i + e.charCodeAt(t), i |= 0;
        }
        return createDebug.colors[Math.abs(i) % createDebug.colors.length];
      }
      function createDebug(e) {
        var i;
        function debug() {
          if (debug.enabled) {
            for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++) {
              t[a] = arguments[a];
            }
            var n = debug,
              o = Number(new Date()),
              r = o - (i || o);
            n.diff = r, n.prev = i, n.curr = o, i = o, t[0] = createDebug.coerce(t[0]), "string" !== typeof t[0] && t.unshift("%O");
            var s = 0;
            t[0] = t[0].replace(/%([a-zA-Z%])/g, function (e, i) {
              if ("%%" === e) return e;
              s++;
              var a = createDebug.formatters[i];
              if ("function" === typeof a) {
                var o = t[s];
                e = a.call(n, o), t.splice(s, 1), s--;
              }
              return e;
            }), createDebug.formatArgs.call(n, t), (n.log || createDebug.log).apply(n, t);
          }
        }
        return debug.namespace = e, debug.enabled = createDebug.enabled(e), debug.useColors = createDebug.useColors(), debug.color = selectColor(e), debug.destroy = destroy, debug.extend = extend, "function" === typeof createDebug.init && createDebug.init(debug), createDebug.instances.push(debug), debug;
      }
      function destroy() {
        var e = createDebug.instances.indexOf(this);
        return -1 !== e && (createDebug.instances.splice(e, 1), !0);
      }
      function extend(e, i) {
        return createDebug(this.namespace + ("undefined" === typeof i ? ":" : i) + e);
      }
      return createDebug.debug = createDebug, createDebug.default = createDebug, createDebug.coerce = function coerce(e) {
        return e instanceof Error ? e.stack || e.message : e;
      }, createDebug.disable = function disable() {
        createDebug.enable("");
      }, createDebug.enable = function enable(e) {
        var i;
        createDebug.save(e), createDebug.names = [], createDebug.skips = [];
        var t = ("string" === typeof e ? e : "").split(/[\s,]+/),
          a = t.length;
        for (i = 0; i < a; i++) {
          t[i] && ("-" === (e = t[i].replace(/\*/g, ".*?"))[0] ? createDebug.skips.push(new RegExp("^" + e.substr(1) + "$")) : createDebug.names.push(new RegExp("^" + e + "$")));
        }
        for (i = 0; i < createDebug.instances.length; i++) {
          var n = createDebug.instances[i];
          n.enabled = createDebug.enabled(n.namespace);
        }
      }, createDebug.enabled = function enabled(e) {
        if ("*" === e[e.length - 1]) return !0;
        var i, t;
        for (i = 0, t = createDebug.skips.length; i < t; i++) {
          if (createDebug.skips[i].test(e)) return !1;
        }
        for (i = 0, t = createDebug.names.length; i < t; i++) {
          if (createDebug.names[i].test(e)) return !0;
        }
        return !1;
      }, createDebug.humanize = t(78), Object.keys(e).forEach(function (i) {
        createDebug[i] = e[i];
      }), createDebug.instances = [], createDebug.names = [], createDebug.skips = [], createDebug.formatters = {}, createDebug.selectColor = selectColor, createDebug.enable(createDebug.load()), createDebug;
    };
  }, function (e, i) {
    e.exports = function getDocument(e) {
      if (isDocument(e)) return e;
      if (isDocument(e.ownerDocument)) return e.ownerDocument;
      if (isDocument(e.document)) return e.document;
      if (e.parentNode) return getDocument(e.parentNode);
      if (e.commonAncestorContainer) return getDocument(e.commonAncestorContainer);
      if (e.startContainer) return getDocument(e.startContainer);
      if (e.anchorNode) return getDocument(e.anchorNode);
    };
    var t = 9;
    function isDocument(e) {
      return e && e.nodeType === t;
    }
  }, function (e, i) {
    e.exports = !!document.attachEvent && window !== document.parentWindow;
  }, function (e, i, t) {
    var a = t(10),
      n = t(231),
      o = t(232),
      r = "Expected a function",
      s = Math.max,
      _ = Math.min;
    e.exports = function debounce(e, i, t) {
      var l,
        g,
        f,
        h,
        d,
        m,
        u = 0,
        c = !1,
        F = !1,
        p = !0;
      if ("function" != typeof e) throw new TypeError(r);
      function invokeFunc(i) {
        var t = l,
          a = g;
        return l = g = void 0, u = i, h = e.apply(a, t);
      }
      function shouldInvoke(e) {
        var t = e - m;
        return void 0 === m || t >= i || t < 0 || F && e - u >= f;
      }
      function timerExpired() {
        var e = n();
        if (shouldInvoke(e)) return trailingEdge(e);
        d = setTimeout(timerExpired, function remainingWait(e) {
          var t = i - (e - m);
          return F ? _(t, f - (e - u)) : t;
        }(e));
      }
      function trailingEdge(e) {
        return d = void 0, p && l ? invokeFunc(e) : (l = g = void 0, h);
      }
      function debounced() {
        var e = n(),
          t = shouldInvoke(e);
        if (l = arguments, g = this, m = e, t) {
          if (void 0 === d) return function leadingEdge(e) {
            return u = e, d = setTimeout(timerExpired, i), c ? invokeFunc(e) : h;
          }(m);
          if (F) return clearTimeout(d), d = setTimeout(timerExpired, i), invokeFunc(m);
        }
        return void 0 === d && (d = setTimeout(timerExpired, i)), h;
      }
      return i = o(i) || 0, a(t) && (c = !!t.leading, f = (F = "maxWait" in t) ? s(o(t.maxWait) || 0, i) : f, p = "trailing" in t ? !!t.trailing : p), debounced.cancel = function cancel() {
        void 0 !== d && clearTimeout(d), u = 0, l = m = g = d = void 0;
      }, debounced.flush = function flush() {
        return void 0 === d ? h : trailingEdge(n());
      }, debounced;
    };
  }, function (e, i, t) {
    var a = t(9);
    e.exports = function now() {
      return a.Date.now();
    };
  }, function (e, i, t) {
    var a = t(10),
      n = t(39),
      o = NaN,
      r = /^\s+|\s+$/g,
      s = /^[-+]0x[0-9a-f]+$/i,
      _ = /^0b[01]+$/i,
      l = /^0o[0-7]+$/i,
      g = parseInt;
    e.exports = function toNumber(e) {
      if ("number" == typeof e) return e;
      if (n(e)) return o;
      if (a(e)) {
        var i = "function" == typeof e.valueOf ? e.valueOf() : e;
        e = a(i) ? i + "" : i;
      }
      if ("string" != typeof e) return 0 === e ? e : +e;
      e = e.replace(r, "");
      var t = _.test(e);
      return t || l.test(e) ? g(e.slice(2), t ? 2 : 8) : s.test(e) ? o : +e;
    };
  }, function (e, i, t) {
    "use strict";

    var n = t(234),
      o = t(0);
    function q(e) {
      for (var i = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, t = 1; t < arguments.length; t++) {
        i += "&args[]=" + encodeURIComponent(arguments[t]);
      }
      return "Minified React error #" + e + "; visit " + i + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }
    var r = "function" === typeof Symbol && Symbol.for,
      s = r ? Symbol.for("react.portal") : 60106,
      _ = r ? Symbol.for("react.fragment") : 60107,
      l = r ? Symbol.for("react.strict_mode") : 60108,
      g = r ? Symbol.for("react.profiler") : 60114,
      f = r ? Symbol.for("react.provider") : 60109,
      h = r ? Symbol.for("react.context") : 60110,
      m = r ? Symbol.for("react.concurrent_mode") : 60111,
      u = r ? Symbol.for("react.forward_ref") : 60112,
      c = r ? Symbol.for("react.suspense") : 60113,
      F = r ? Symbol.for("react.suspense_list") : 60120,
      p = r ? Symbol.for("react.memo") : 60115,
      b = r ? Symbol.for("react.lazy") : 60116,
      y = r ? Symbol.for("react.fundamental") : 60117,
      k = r ? Symbol.for("react.scope") : 60119,
      v = o.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function D(e) {
      if (null == e) return null;
      if ("function" === typeof e) return e.displayName || e.name || null;
      if ("string" === typeof e) return e;
      switch (e) {
        case _:
          return "Fragment";
        case s:
          return "Portal";
        case g:
          return "Profiler";
        case l:
          return "StrictMode";
        case c:
          return "Suspense";
        case F:
          return "SuspenseList";
      }
      if ("object" === typeof e) switch (e.$$typeof) {
        case h:
          return "Context.Consumer";
        case f:
          return "Context.Provider";
        case u:
          var i = e.render;
          return i = i.displayName || i.name || "", e.displayName || ("" !== i ? "ForwardRef(" + i + ")" : "ForwardRef");
        case p:
          return D(e.type);
        case b:
          if (e = 1 === e._status ? e._result : null) return D(e);
      }
      return null;
    }
    v.hasOwnProperty("ReactCurrentDispatcher") || (v.ReactCurrentDispatcher = {
      current: null
    }), v.hasOwnProperty("ReactCurrentBatchConfig") || (v.ReactCurrentBatchConfig = {
      suspense: null
    });
    var w = {};
    function E(e, i) {
      for (var t = 0 | e._threadCount; t <= i; t++) {
        e[t] = e._currentValue2, e._threadCount = t + 1;
      }
    }
    for (var A = new Uint16Array(16), j = 0; 15 > j; j++) {
      A[j] = j + 1;
    }
    A[15] = 0;
    var x = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
      C = Object.prototype.hasOwnProperty,
      B = {},
      S = {};
    function ta(e) {
      return !!C.call(S, e) || !C.call(B, e) && (x.test(e) ? S[e] = !0 : (B[e] = !0, !1));
    }
    function J(e, i, t, a, n, o) {
      this.acceptsBooleans = 2 === i || 3 === i || 4 === i, this.attributeName = a, this.attributeNamespace = n, this.mustUseProperty = t, this.propertyName = e, this.type = i, this.sanitizeURL = o;
    }
    var O = {};
    "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function (e) {
      O[e] = new J(e, 0, !1, e, null, !1);
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (e) {
      var i = e[0];
      O[i] = new J(i, 1, !1, e[1], null, !1);
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function (e) {
      O[e] = new J(e, 2, !1, e.toLowerCase(), null, !1);
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (e) {
      O[e] = new J(e, 2, !1, e, null, !1);
    }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function (e) {
      O[e] = new J(e, 3, !1, e.toLowerCase(), null, !1);
    }), ["checked", "multiple", "muted", "selected"].forEach(function (e) {
      O[e] = new J(e, 3, !0, e, null, !1);
    }), ["capture", "download"].forEach(function (e) {
      O[e] = new J(e, 4, !1, e, null, !1);
    }), ["cols", "rows", "size", "span"].forEach(function (e) {
      O[e] = new J(e, 6, !1, e, null, !1);
    }), ["rowSpan", "start"].forEach(function (e) {
      O[e] = new J(e, 5, !1, e.toLowerCase(), null, !1);
    });
    var T = /[\-:]([a-z])/g;
    function M(e) {
      return e[1].toUpperCase();
    }
    "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function (e) {
      var i = e.replace(T, M);
      O[i] = new J(i, 1, !1, e, null, !1);
    }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (e) {
      var i = e.replace(T, M);
      O[i] = new J(i, 1, !1, e, "http://www.w3.org/1999/xlink", !1);
    }), ["xml:base", "xml:lang", "xml:space"].forEach(function (e) {
      var i = e.replace(T, M);
      O[i] = new J(i, 1, !1, e, "http://www.w3.org/XML/1998/namespace", !1);
    }), ["tabIndex", "crossOrigin"].forEach(function (e) {
      O[e] = new J(e, 1, !1, e.toLowerCase(), null, !1);
    }), O.xlinkHref = new J("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0), ["src", "href", "action", "formAction"].forEach(function (e) {
      O[e] = new J(e, 1, !1, e.toLowerCase(), null, !0);
    });
    var I = /["'&<>]/;
    function N(e) {
      if ("boolean" === typeof e || "number" === typeof e) return "" + e;
      e = "" + e;
      var i = I.exec(e);
      if (i) {
        var t,
          a = "",
          n = 0;
        for (t = i.index; t < e.length; t++) {
          switch (e.charCodeAt(t)) {
            case 34:
              i = "&quot;";
              break;
            case 38:
              i = "&amp;";
              break;
            case 39:
              i = "&#x27;";
              break;
            case 60:
              i = "&lt;";
              break;
            case 62:
              i = "&gt;";
              break;
            default:
              continue;
          }
          n !== t && (a += e.substring(n, t)), n = t + 1, a += i;
        }
        e = n !== t ? a + e.substring(n, t) : a;
      }
      return e;
    }
    function xa(e, i) {
      var t,
        a = O.hasOwnProperty(e) ? O[e] : null;
      return (t = "style" !== e) && (t = null !== a ? 0 === a.type : 2 < e.length && ("o" === e[0] || "O" === e[0]) && ("n" === e[1] || "N" === e[1])), t || function va(e, i, t, a) {
        if (null === i || "undefined" === typeof i || function ua(e, i, t, a) {
          if (null !== t && 0 === t.type) return !1;
          switch (typeof i) {
            case "function":
            case "symbol":
              return !0;
            case "boolean":
              return !a && (null !== t ? !t.acceptsBooleans : "data-" !== (e = e.toLowerCase().slice(0, 5)) && "aria-" !== e);
            default:
              return !1;
          }
        }(e, i, t, a)) return !0;
        if (a) return !1;
        if (null !== t) switch (t.type) {
          case 3:
            return !i;
          case 4:
            return !1 === i;
          case 5:
            return isNaN(i);
          case 6:
            return isNaN(i) || 1 > i;
        }
        return !1;
      }(e, i, a, !1) ? "" : null !== a ? (e = a.attributeName, 3 === (t = a.type) || 4 === t && !0 === i ? e + '=""' : (a.sanitizeURL && (i = "" + i), e + '="' + N(i) + '"')) : ta(e) ? e + '="' + N(i) + '"' : "";
    }
    var P = "function" === typeof Object.is ? Object.is : function ya(e, i) {
        return e === i && (0 !== e || 1 / e === 1 / i) || e !== e && i !== i;
      },
      R = null,
      z = null,
      L = null,
      U = !1,
      K = !1,
      H = null,
      V = 0;
    function W() {
      if (null === R) throw Error(q(321));
      return R;
    }
    function Aa() {
      if (0 < V) throw Error(q(312));
      return {
        memoizedState: null,
        queue: null,
        next: null
      };
    }
    function Ba() {
      return null === L ? null === z ? (U = !1, z = L = Aa()) : (U = !0, L = z) : null === L.next ? (U = !1, L = L.next = Aa()) : (U = !0, L = L.next), L;
    }
    function Ca(e, i, t, a) {
      for (; K;) {
        K = !1, V += 1, L = null, t = e(i, a);
      }
      return z = R = null, V = 0, L = H = null, t;
    }
    function Da(e, i) {
      return "function" === typeof i ? i(e) : i;
    }
    function Ea(e, i, t) {
      if (R = W(), L = Ba(), U) {
        var a = L.queue;
        if (i = a.dispatch, null !== H && void 0 !== (t = H.get(a))) {
          H.delete(a), a = L.memoizedState;
          do {
            a = e(a, t.action), t = t.next;
          } while (null !== t);
          return L.memoizedState = a, [a, i];
        }
        return [L.memoizedState, i];
      }
      return e = e === Da ? "function" === typeof i ? i() : i : void 0 !== t ? t(i) : i, L.memoizedState = e, e = (e = L.queue = {
        last: null,
        dispatch: null
      }).dispatch = function Fa(e, i, t) {
        if (!(25 > V)) throw Error(q(301));
        if (e === R) if (K = !0, e = {
          action: t,
          next: null
        }, null === H && (H = new Map()), void 0 === (t = H.get(i))) H.set(i, e);else {
          for (i = t; null !== i.next;) {
            i = i.next;
          }
          i.next = e;
        }
      }.bind(null, R, e), [L.memoizedState, e];
    }
    function Ga() {}
    var $ = 0,
      G = {
        readContext: function readContext(e) {
          var i = $;
          return E(e, i), e[i];
        },
        useContext: function useContext(e) {
          W();
          var i = $;
          return E(e, i), e[i];
        },
        useMemo: function useMemo(e, i) {
          if (R = W(), i = void 0 === i ? null : i, null !== (L = Ba())) {
            var t = L.memoizedState;
            if (null !== t && null !== i) {
              e: {
                var a = t[1];
                if (null === a) a = !1;else {
                  for (var n = 0; n < a.length && n < i.length; n++) {
                    if (!P(i[n], a[n])) {
                      a = !1;
                      break e;
                    }
                  }
                  a = !0;
                }
              }
              if (a) return t[0];
            }
          }
          return e = e(), L.memoizedState = [e, i], e;
        },
        useReducer: Ea,
        useRef: function useRef(e) {
          R = W();
          var i = (L = Ba()).memoizedState;
          return null === i ? (e = {
            current: e
          }, L.memoizedState = e) : i;
        },
        useState: function useState(e) {
          return Ea(Da, e);
        },
        useLayoutEffect: function useLayoutEffect() {},
        useCallback: function useCallback(e) {
          return e;
        },
        useImperativeHandle: Ga,
        useEffect: Ga,
        useDebugValue: Ga,
        useResponder: function useResponder(e, i) {
          return {
            props: i,
            responder: e
          };
        },
        useDeferredValue: function useDeferredValue(e) {
          return W(), e;
        },
        useTransition: function useTransition() {
          return W(), [function (e) {
            e();
          }, !1];
        }
      },
      Y = {
        html: "http://www.w3.org/1999/xhtml",
        mathml: "http://www.w3.org/1998/Math/MathML",
        svg: "http://www.w3.org/2000/svg"
      };
    function Ja(e) {
      switch (e) {
        case "svg":
          return "http://www.w3.org/2000/svg";
        case "math":
          return "http://www.w3.org/1998/Math/MathML";
        default:
          return "http://www.w3.org/1999/xhtml";
      }
    }
    var X = {
        area: !0,
        base: !0,
        br: !0,
        col: !0,
        embed: !0,
        hr: !0,
        img: !0,
        input: !0,
        keygen: !0,
        link: !0,
        meta: !0,
        param: !0,
        source: !0,
        track: !0,
        wbr: !0
      },
      Z = n({
        menuitem: !0
      }, X),
      Q = {
        animationIterationCount: !0,
        borderImageOutset: !0,
        borderImageSlice: !0,
        borderImageWidth: !0,
        boxFlex: !0,
        boxFlexGroup: !0,
        boxOrdinalGroup: !0,
        columnCount: !0,
        columns: !0,
        flex: !0,
        flexGrow: !0,
        flexPositive: !0,
        flexShrink: !0,
        flexNegative: !0,
        flexOrder: !0,
        gridArea: !0,
        gridRow: !0,
        gridRowEnd: !0,
        gridRowSpan: !0,
        gridRowStart: !0,
        gridColumn: !0,
        gridColumnEnd: !0,
        gridColumnSpan: !0,
        gridColumnStart: !0,
        fontWeight: !0,
        lineClamp: !0,
        lineHeight: !0,
        opacity: !0,
        order: !0,
        orphans: !0,
        tabSize: !0,
        widows: !0,
        zIndex: !0,
        zoom: !0,
        fillOpacity: !0,
        floodOpacity: !0,
        stopOpacity: !0,
        strokeDasharray: !0,
        strokeDashoffset: !0,
        strokeMiterlimit: !0,
        strokeOpacity: !0,
        strokeWidth: !0
      },
      ee = ["Webkit", "ms", "Moz", "O"];
    Object.keys(Q).forEach(function (e) {
      ee.forEach(function (i) {
        i = i + e.charAt(0).toUpperCase() + e.substring(1), Q[i] = Q[e];
      });
    });
    var ie = /([A-Z])/g,
      te = /^ms-/,
      ae = o.Children.toArray,
      ne = v.ReactCurrentDispatcher,
      oe = {
        listing: !0,
        pre: !0,
        textarea: !0
      },
      re = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,
      se = {},
      _e = {};
    var le = Object.prototype.hasOwnProperty,
      ge = {
        children: null,
        dangerouslySetInnerHTML: null,
        suppressContentEditableWarning: null,
        suppressHydrationWarning: null
      };
    function Xa(e, i) {
      if (void 0 === e) throw Error(q(152, D(i) || "Component"));
    }
    function Ya(e, i, t) {
      function d(a, o) {
        var r = o.prototype && o.prototype.isReactComponent,
          s = function oa(e, i, t, a) {
            if (a && "object" === typeof (a = e.contextType) && null !== a) return E(a, t), a[t];
            if (e = e.contextTypes) {
              for (var n in t = {}, e) {
                t[n] = i[n];
              }
              i = t;
            } else i = w;
            return i;
          }(o, i, t, r),
          _ = [],
          l = !1,
          g = {
            isMounted: function isMounted() {
              return !1;
            },
            enqueueForceUpdate: function enqueueForceUpdate() {
              if (null === _) return null;
            },
            enqueueReplaceState: function enqueueReplaceState(e, i) {
              l = !0, _ = [i];
            },
            enqueueSetState: function enqueueSetState(e, i) {
              if (null === _) return null;
              _.push(i);
            }
          };
        if (r) {
          if (r = new o(a.props, s, g), "function" === typeof o.getDerivedStateFromProps) {
            var f = o.getDerivedStateFromProps.call(null, a.props, r.state);
            null != f && (r.state = n({}, r.state, f));
          }
        } else if (R = {}, r = o(a.props, s, g), null == (r = Ca(o, a.props, r, s)) || null == r.render) return void Xa(e = r, o);
        if (r.props = a.props, r.context = s, r.updater = g, void 0 === (g = r.state) && (r.state = g = null), "function" === typeof r.UNSAFE_componentWillMount || "function" === typeof r.componentWillMount) if ("function" === typeof r.componentWillMount && "function" !== typeof o.getDerivedStateFromProps && r.componentWillMount(), "function" === typeof r.UNSAFE_componentWillMount && "function" !== typeof o.getDerivedStateFromProps && r.UNSAFE_componentWillMount(), _.length) {
          g = _;
          var h = l;
          if (_ = null, l = !1, h && 1 === g.length) r.state = g[0];else {
            f = h ? g[0] : r.state;
            var d = !0;
            for (h = h ? 1 : 0; h < g.length; h++) {
              var m = g[h];
              null != (m = "function" === typeof m ? m.call(r, f, a.props, s) : m) && (d ? (d = !1, f = n({}, f, m)) : n(f, m));
            }
            r.state = f;
          }
        } else _ = null;
        if (Xa(e = r.render(), o), "function" === typeof r.getChildContext && "object" === typeof (a = o.childContextTypes)) {
          var u = r.getChildContext();
          for (var c in u) {
            if (!(c in a)) throw Error(q(108, D(o) || "Unknown", c));
          }
        }
        u && (i = n({}, i, u));
      }
      for (; o.isValidElement(e);) {
        var a = e,
          r = a.type;
        if ("function" !== typeof r) break;
        d(a, r);
      }
      return {
        child: e,
        context: i
      };
    }
    var fe = function () {
        function a(e, i) {
          o.isValidElement(e) ? e.type !== _ ? e = [e] : (e = e.props.children, e = o.isValidElement(e) ? [e] : ae(e)) : e = ae(e), e = {
            type: null,
            domNamespace: Y.html,
            children: e,
            childIndex: 0,
            context: w,
            footer: ""
          };
          var t = A[0];
          if (0 === t) {
            var a = A,
              n = 2 * (t = a.length);
            if (!(65536 >= n)) throw Error(q(304));
            var r = new Uint16Array(n);
            for (r.set(a), (A = r)[0] = t + 1, a = t; a < n - 1; a++) {
              A[a] = a + 1;
            }
            A[n - 1] = 0;
          } else A[0] = A[t];
          this.threadID = t, this.stack = [e], this.exhausted = !1, this.currentSelectValue = null, this.previousWasTextNode = !1, this.makeStaticMarkup = i, this.suspenseDepth = 0, this.contextIndex = -1, this.contextStack = [], this.contextValueStack = [];
        }
        var e = a.prototype;
        return e.destroy = function () {
          if (!this.exhausted) {
            this.exhausted = !0, this.clearProviders();
            var e = this.threadID;
            A[e] = A[0], A[0] = e;
          }
        }, e.pushProvider = function (e) {
          var i = ++this.contextIndex,
            t = e.type._context,
            a = this.threadID;
          E(t, a);
          var n = t[a];
          this.contextStack[i] = t, this.contextValueStack[i] = n, t[a] = e.props.value;
        }, e.popProvider = function () {
          var e = this.contextIndex,
            i = this.contextStack[e],
            t = this.contextValueStack[e];
          this.contextStack[e] = null, this.contextValueStack[e] = null, this.contextIndex--, i[this.threadID] = t;
        }, e.clearProviders = function () {
          for (var e = this.contextIndex; 0 <= e; e--) {
            this.contextStack[e][this.threadID] = this.contextValueStack[e];
          }
        }, e.read = function (e) {
          if (this.exhausted) return null;
          var i = $;
          $ = this.threadID;
          var t = ne.current;
          ne.current = G;
          try {
            for (var a = [""], n = !1; a[0].length < e;) {
              if (0 === this.stack.length) {
                this.exhausted = !0;
                var o = this.threadID;
                A[o] = A[0], A[0] = o;
                break;
              }
              var r = this.stack[this.stack.length - 1];
              if (n || r.childIndex >= r.children.length) {
                var s = r.footer;
                if ("" !== s && (this.previousWasTextNode = !1), this.stack.pop(), "select" === r.type) this.currentSelectValue = null;else if (null != r.type && null != r.type.type && r.type.type.$$typeof === f) this.popProvider(r.type);else if (r.type === c) {
                  this.suspenseDepth--;
                  var _ = a.pop();
                  if (n) {
                    n = !1;
                    var l = r.fallbackFrame;
                    if (!l) throw Error(q(303));
                    this.stack.push(l), a[this.suspenseDepth] += "\x3c!--$!--\x3e";
                    continue;
                  }
                  a[this.suspenseDepth] += _;
                }
                a[this.suspenseDepth] += s;
              } else {
                var g = r.children[r.childIndex++],
                  h = "";
                try {
                  h += this.render(g, r.context, r.domNamespace);
                } catch (d) {
                  if (null != d && "function" === typeof d.then) throw Error(q(294));
                  throw d;
                }
                a.length <= this.suspenseDepth && a.push(""), a[this.suspenseDepth] += h;
              }
            }
            return a[0];
          } finally {
            ne.current = t, $ = i;
          }
        }, e.render = function (e, i, t) {
          if ("string" === typeof e || "number" === typeof e) return "" === (t = "" + e) ? "" : this.makeStaticMarkup ? N(t) : this.previousWasTextNode ? "\x3c!-- --\x3e" + N(t) : (this.previousWasTextNode = !0, N(t));
          if (e = (i = Ya(e, i, this.threadID)).child, i = i.context, null === e || !1 === e) return "";
          if (!o.isValidElement(e)) {
            if (null != e && null != e.$$typeof) {
              if ((t = e.$$typeof) === s) throw Error(q(257));
              throw Error(q(258, t.toString()));
            }
            return e = ae(e), this.stack.push({
              type: null,
              domNamespace: t,
              children: e,
              childIndex: 0,
              context: i,
              footer: ""
            }), "";
          }
          var a = e.type;
          if ("string" === typeof a) return this.renderDOM(e, i, t);
          switch (a) {
            case l:
            case m:
            case g:
            case F:
            case _:
              return e = ae(e.props.children), this.stack.push({
                type: null,
                domNamespace: t,
                children: e,
                childIndex: 0,
                context: i,
                footer: ""
              }), "";
            case c:
              throw Error(q(294));
          }
          if ("object" === typeof a && null !== a) switch (a.$$typeof) {
            case u:
              R = {};
              var r = a.render(e.props, e.ref);
              return r = Ca(a.render, e.props, r, e.ref), r = ae(r), this.stack.push({
                type: null,
                domNamespace: t,
                children: r,
                childIndex: 0,
                context: i,
                footer: ""
              }), "";
            case p:
              return e = [o.createElement(a.type, n({
                ref: e.ref
              }, e.props))], this.stack.push({
                type: null,
                domNamespace: t,
                children: e,
                childIndex: 0,
                context: i,
                footer: ""
              }), "";
            case f:
              return t = {
                type: e,
                domNamespace: t,
                children: a = ae(e.props.children),
                childIndex: 0,
                context: i,
                footer: ""
              }, this.pushProvider(e), this.stack.push(t), "";
            case h:
              a = e.type, r = e.props;
              var d = this.threadID;
              return E(a, d), a = ae(r.children(a[d])), this.stack.push({
                type: e,
                domNamespace: t,
                children: a,
                childIndex: 0,
                context: i,
                footer: ""
              }), "";
            case y:
              throw Error(q(338));
            case b:
              switch (function ma(e) {
                if (-1 === e._status) {
                  e._status = 0;
                  var i = e._ctor;
                  i = i(), e._result = i, i.then(function (i) {
                    0 === e._status && (i = i.default, e._status = 1, e._result = i);
                  }, function (i) {
                    0 === e._status && (e._status = 2, e._result = i);
                  });
                }
              }(a = e.type), a._status) {
                case 1:
                  return e = [o.createElement(a._result, n({
                    ref: e.ref
                  }, e.props))], this.stack.push({
                    type: null,
                    domNamespace: t,
                    children: e,
                    childIndex: 0,
                    context: i,
                    footer: ""
                  }), "";
                case 2:
                  throw a._result;
                default:
                  throw Error(q(295));
              }
            case k:
              throw Error(q(343));
          }
          throw Error(q(130, null == a ? a : typeof a, ""));
        }, e.renderDOM = function (e, i, t) {
          var a = e.type.toLowerCase();
          if (t === Y.html && Ja(a), !se.hasOwnProperty(a)) {
            if (!re.test(a)) throw Error(q(65, a));
            se[a] = !0;
          }
          var r = e.props;
          if ("input" === a) r = n({
            type: void 0
          }, r, {
            defaultChecked: void 0,
            defaultValue: void 0,
            value: null != r.value ? r.value : r.defaultValue,
            checked: null != r.checked ? r.checked : r.defaultChecked
          });else if ("textarea" === a) {
            var s = r.value;
            if (null == s) {
              s = r.defaultValue;
              var _ = r.children;
              if (null != _) {
                if (null != s) throw Error(q(92));
                if (Array.isArray(_)) {
                  if (!(1 >= _.length)) throw Error(q(93));
                  _ = _[0];
                }
                s = "" + _;
              }
              null == s && (s = "");
            }
            r = n({}, r, {
              value: void 0,
              children: "" + s
            });
          } else if ("select" === a) this.currentSelectValue = null != r.value ? r.value : r.defaultValue, r = n({}, r, {
            value: void 0
          });else if ("option" === a) {
            _ = this.currentSelectValue;
            var l = function Ua(e) {
              if (void 0 === e || null === e) return e;
              var i = "";
              return o.Children.forEach(e, function (e) {
                null != e && (i += e);
              }), i;
            }(r.children);
            if (null != _) {
              var g = null != r.value ? r.value + "" : l;
              if (s = !1, Array.isArray(_)) {
                for (var f = 0; f < _.length; f++) {
                  if ("" + _[f] === g) {
                    s = !0;
                    break;
                  }
                }
              } else s = "" + _ === g;
              r = n({
                selected: void 0,
                children: void 0
              }, r, {
                selected: s,
                children: l
              });
            }
          }
          if (s = r) {
            if (Z[a] && (null != s.children || null != s.dangerouslySetInnerHTML)) throw Error(q(137, a, ""));
            if (null != s.dangerouslySetInnerHTML) {
              if (null != s.children) throw Error(q(60));
              if (!("object" === typeof s.dangerouslySetInnerHTML && "__html" in s.dangerouslySetInnerHTML)) throw Error(q(61));
            }
            if (null != s.style && "object" !== typeof s.style) throw Error(q(62, ""));
          }
          for (b in s = r, _ = this.makeStaticMarkup, l = 1 === this.stack.length, g = "<" + e.type, s) {
            if (le.call(s, b)) {
              var h = s[b];
              if (null != h) {
                if ("style" === b) {
                  f = void 0;
                  var d = "",
                    m = "";
                  for (f in h) {
                    if (h.hasOwnProperty(f)) {
                      var u = 0 === f.indexOf("--"),
                        c = h[f];
                      if (null != c) {
                        if (u) var F = f;else if (F = f, _e.hasOwnProperty(F)) F = _e[F];else {
                          var p = F.replace(ie, "-$1").toLowerCase().replace(te, "-ms-");
                          F = _e[F] = p;
                        }
                        d += m + F + ":", m = f, d += u = null == c || "boolean" === typeof c || "" === c ? "" : u || "number" !== typeof c || 0 === c || Q.hasOwnProperty(m) && Q[m] ? ("" + c).trim() : c + "px", m = ";";
                      }
                    }
                  }
                  h = d || null;
                }
                f = null;
                e: if (u = a, c = s, -1 === u.indexOf("-")) u = "string" === typeof c.is;else switch (u) {
                  case "annotation-xml":
                  case "color-profile":
                  case "font-face":
                  case "font-face-src":
                  case "font-face-uri":
                  case "font-face-format":
                  case "font-face-name":
                  case "missing-glyph":
                    u = !1;
                    break e;
                  default:
                    u = !0;
                }
                u ? ge.hasOwnProperty(b) || (f = ta(f = b) && null != h ? f + '="' + N(h) + '"' : "") : f = xa(b, h), f && (g += " " + f);
              }
            }
          }
          _ || l && (g += ' data-reactroot=""');
          var b = g;
          s = "", X.hasOwnProperty(a) ? b += "/>" : (b += ">", s = "</" + e.type + ">");
          e: {
            if (null != (_ = r.dangerouslySetInnerHTML)) {
              if (null != _.__html) {
                _ = _.__html;
                break e;
              }
            } else if ("string" === typeof (_ = r.children) || "number" === typeof _) {
              _ = N(_);
              break e;
            }
            _ = null;
          }
          return null != _ ? (r = [], oe[a] && "\n" === _.charAt(0) && (b += "\n"), b += _) : r = ae(r.children), e = e.type, t = null == t || "http://www.w3.org/1999/xhtml" === t ? Ja(e) : "http://www.w3.org/2000/svg" === t && "foreignObject" === e ? "http://www.w3.org/1999/xhtml" : t, this.stack.push({
            domNamespace: t,
            type: a,
            children: r,
            childIndex: 0,
            context: i,
            footer: s
          }), this.previousWasTextNode = !1, b;
        }, a;
      }(),
      he = {
        renderToString: function renderToString(e) {
          e = new fe(e, !1);
          try {
            return e.read(1 / 0);
          } finally {
            e.destroy();
          }
        },
        renderToStaticMarkup: function renderToStaticMarkup(e) {
          e = new fe(e, !0);
          try {
            return e.read(1 / 0);
          } finally {
            e.destroy();
          }
        },
        renderToNodeStream: function renderToNodeStream() {
          throw Error(q(207));
        },
        renderToStaticNodeStream: function renderToStaticNodeStream() {
          throw Error(q(208));
        },
        version: "16.12.0"
      },
      de = {
        default: he
      },
      me = de && he || de;
    e.exports = me.default || me;
  }, function (e, i, t) {
    "use strict";

    var a = Object.getOwnPropertySymbols,
      n = Object.prototype.hasOwnProperty,
      o = Object.prototype.propertyIsEnumerable;
    e.exports = function shouldUseNative() {
      try {
        if (!Object.assign) return !1;
        var e = new String("abc");
        if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;
        for (var i = {}, t = 0; t < 10; t++) {
          i["_" + String.fromCharCode(t)] = t;
        }
        if ("0123456789" !== Object.getOwnPropertyNames(i).map(function (e) {
          return i[e];
        }).join("")) return !1;
        var a = {};
        return "abcdefghijklmnopqrst".split("").forEach(function (e) {
          a[e] = e;
        }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, a)).join("");
      } catch (n) {
        return !1;
      }
    }() ? Object.assign : function (e, i) {
      for (var t, r, s = function toObject(e) {
          if (null === e || void 0 === e) throw new TypeError("Object.assign cannot be called with null or undefined");
          return Object(e);
        }(e), _ = 1; _ < arguments.length; _++) {
        for (var l in t = Object(arguments[_])) {
          n.call(t, l) && (s[l] = t[l]);
        }
        if (a) {
          r = a(t);
          for (var g = 0; g < r.length; g++) {
            o.call(t, r[g]) && (s[r[g]] = t[r[g]]);
          }
        }
      }
      return s;
    };
  }, function (e, i, t) {
    var a = t(236);
    "string" === typeof (a = a.__esModule ? a.default : a) && (a = [[e.i, a, ""]]);
    var n = {
      insert: "head",
      singleton: !1
    };
    t(22)(a, n);
    a.locals && (e.exports = a.locals);
  }, function (e, i, t) {
    (e.exports = t(21)(!0)).push([e.i, ".header-select-wrapper .tide-select.email-mode-header-select__control {\n  border-width: 0;\n  border-radius: 0;\n  background-color: transparent;\n}\n\n.email-mode-header-wrapper .email-mode-header-input input {\n  border-width: 0 0 0 0;\n  border-radius: 3px 3px 0px 0px;\n  padding: 10px 16px 10px 4px;\n}\n\n.email-mode-header-wrapper {\n  display: flex;\n  background-color: var(--color-p1-2);\n  align-items: center;\n  border-bottom: 1px solid var(--color-p1-5);\n  border-radius: 3px 3px 0 0;\n}\n\n.email-mode-header-wrapper.header-select-wrapper {\n  height: 40px;\n}\n\n.email-mode-header-wrapper:hover .email-mode-header-label,\n.email-mode-header-input input:hover {\n  cursor: pointer;\n}\n\n.email-mode-header-wrapper.header-select-wrapper:hover,\n.email-mode-header-wrapper:hover .email-mode-header-input input,\n.email-mode-header-input input.tide-input:hover {\n  border-color: var(--color-p1-5);\n  background: var(--color-p1-3);\n}\n\n.email-mode-header-input input.tide-input:disabled {\n  color: var(--color-p1-5-5);\n  border-width: 0px;\n  background-color: transparent;\n}\n\n.email-mode-header-label {\n  padding: 0px 4px 0px 16px;\n  min-width: -webkit-max-content;\n  min-width: -moz-max-content;\n  min-width: max-content;\n  font-size: var(--font-size-subtle);\n  line-height: var(--main-spacing-paragraph-2);\n  font-family: var(--main-font-family--semibold);\n}\n\n.email-mode-header-input {\n  width: 100%;\n}\n\n.email-mode-header-label.disabled:hover {\n  cursor: not-allowed;\n}\n\n.email-mode-header-multi-string-compact .multi-string-compact-bottom-bar {\n  display: none;\n}\n\n.email-mode-header-multi-string-compact .multi-string-compact-container {\n  border: none;\n  min-height: unset;\n  padding-left: 0px;\n  max-height: 40px;\n  overflow-y: auto;\n  width: 100%;\n}\n\n.email-mode-header-multi-string-compact {\n  width: 100%;\n}\n\n.email-mode-header-multi-string-compact .multi-string-compact-input {\n  max-width: calc(100% - 5px);\n  min-width: unset;\n}\n\n.email-mode-header-multi-string-compact.no-values .multi-string-compact-input {\n  min-width: 304px;\n}\n\n.email-mode-header-wrapper .email-mode-header-input.fallback-label input {\n  padding-left: 4px;\n}\n", "", {
      version: 3,
      sources: ["styles.css"],
      names: [],
      mappings: "AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;;EAGE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,8BAAsB;EAAtB,2BAAsB;EAAtB,sBAAsB;EACtB,kCAAkC;EAClC,4CAA4C;EAC5C,8CAA8C;AAChD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB",
      file: "styles.css",
      sourcesContent: [".header-select-wrapper .tide-select.email-mode-header-select__control {\n  border-width: 0;\n  border-radius: 0;\n  background-color: transparent;\n}\n\n.email-mode-header-wrapper .email-mode-header-input input {\n  border-width: 0 0 0 0;\n  border-radius: 3px 3px 0px 0px;\n  padding: 10px 16px 10px 4px;\n}\n\n.email-mode-header-wrapper {\n  display: flex;\n  background-color: var(--color-p1-2);\n  align-items: center;\n  border-bottom: 1px solid var(--color-p1-5);\n  border-radius: 3px 3px 0 0;\n}\n\n.email-mode-header-wrapper.header-select-wrapper {\n  height: 40px;\n}\n\n.email-mode-header-wrapper:hover .email-mode-header-label,\n.email-mode-header-input input:hover {\n  cursor: pointer;\n}\n\n.email-mode-header-wrapper.header-select-wrapper:hover,\n.email-mode-header-wrapper:hover .email-mode-header-input input,\n.email-mode-header-input input.tide-input:hover {\n  border-color: var(--color-p1-5);\n  background: var(--color-p1-3);\n}\n\n.email-mode-header-input input.tide-input:disabled {\n  color: var(--color-p1-5-5);\n  border-width: 0px;\n  background-color: transparent;\n}\n\n.email-mode-header-label {\n  padding: 0px 4px 0px 16px;\n  min-width: max-content;\n  font-size: var(--font-size-subtle);\n  line-height: var(--main-spacing-paragraph-2);\n  font-family: var(--main-font-family--semibold);\n}\n\n.email-mode-header-input {\n  width: 100%;\n}\n\n.email-mode-header-label.disabled:hover {\n  cursor: not-allowed;\n}\n\n.email-mode-header-multi-string-compact .multi-string-compact-bottom-bar {\n  display: none;\n}\n\n.email-mode-header-multi-string-compact .multi-string-compact-container {\n  border: none;\n  min-height: unset;\n  padding-left: 0px;\n  max-height: 40px;\n  overflow-y: auto;\n  width: 100%;\n}\n\n.email-mode-header-multi-string-compact {\n  width: 100%;\n}\n\n.email-mode-header-multi-string-compact .multi-string-compact-input {\n  max-width: calc(100% - 5px);\n  min-width: unset;\n}\n\n.email-mode-header-multi-string-compact.no-values .multi-string-compact-input {\n  min-width: 304px;\n}\n\n.email-mode-header-wrapper .email-mode-header-input.fallback-label input {\n  padding-left: 4px;\n}\n"]
    }]);
  }, function (e, i, t) {
    var a = t(238);
    "string" === typeof (a = a.__esModule ? a.default : a) && (a = [[e.i, a, ""]]);
    var n = {
      insert: "head",
      singleton: !1
    };
    t(22)(a, n);
    a.locals && (e.exports = a.locals);
  }, function (e, i, t) {
    (e.exports = t(21)(!0)).push([e.i, ".driftiwyg-toolbar--default-value-creator {\n  padding: 16px;\n}\n\n.driftiwyg-toolbar--default-value-header {\n  height: 30px;\n  border-bottom: 1px solid var(--main-navy-light);\n  padding: 5px 10px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: var(--font-size-subtle);\n}\n\n.driftiwyg-toolbar--default-value-header a {\n  color: var(--main-blue);\n  cursor: pointer;\n}\n\n.driftiwyg-toolbar--default-value-subheader {\n  margin-bottom: 16px;\n}\n\n.driftiwyg-toolbar--default-value-body {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.driftiwyg-toolbar--default-value-body h3 {\n  color: var(--main-navy-extra-dark);\n  font-family: var(--main-font-family--bold);\n}\n\n.driftiwyg-toolbar--default-value-body p {\n  color: var(--main-navy-dark);\n  line-height: 1.3;\n  margin-bottom: 5px;\n}\n\n.driftiwyg-toolbar--default-value-body input {\n  width: 100%;\n}\n\n.driftiwyg-toolbar--default-value-buttons {\n  margin-top: 16px;\n}\n\n.driftiwyg-toolbar--insert-button {\n  margin-right: 8px;\n}\n\n.driftiwyg-toolbar--default-value-no-fallback-text {\n  color: var(--color-p1-6);\n  margin-bottom: 13px;\n}\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,+CAA+C;EAC/C,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB",
      file: "style.css",
      sourcesContent: [".driftiwyg-toolbar--default-value-creator {\n  padding: 16px;\n}\n\n.driftiwyg-toolbar--default-value-header {\n  height: 30px;\n  border-bottom: 1px solid var(--main-navy-light);\n  padding: 5px 10px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: var(--font-size-subtle);\n}\n\n.driftiwyg-toolbar--default-value-header a {\n  color: var(--main-blue);\n  cursor: pointer;\n}\n\n.driftiwyg-toolbar--default-value-subheader {\n  margin-bottom: 16px;\n}\n\n.driftiwyg-toolbar--default-value-body {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.driftiwyg-toolbar--default-value-body h3 {\n  color: var(--main-navy-extra-dark);\n  font-family: var(--main-font-family--bold);\n}\n\n.driftiwyg-toolbar--default-value-body p {\n  color: var(--main-navy-dark);\n  line-height: 1.3;\n  margin-bottom: 5px;\n}\n\n.driftiwyg-toolbar--default-value-body input {\n  width: 100%;\n}\n\n.driftiwyg-toolbar--default-value-buttons {\n  margin-top: 16px;\n}\n\n.driftiwyg-toolbar--insert-button {\n  margin-right: 8px;\n}\n\n.driftiwyg-toolbar--default-value-no-fallback-text {\n  color: var(--color-p1-6);\n  margin-bottom: 13px;\n}\n"]
    }]);
  }, function (e, i, t) {
    var a = t(240);
    "string" === typeof (a = a.__esModule ? a.default : a) && (a = [[e.i, a, ""]]);
    var n = {
      insert: "head",
      singleton: !1
    };
    t(22)(a, n);
    a.locals && (e.exports = a.locals);
  }, function (e, i, t) {
    (e.exports = t(21)(!0)).push([e.i, ".driftiwyg-toolbar-property {\n  position: relative;\n  margin-bottom: 6px;\n}\n\n.driftiwyg-toolbar-property svg {\n  display: block;\n}\n\n.driftiwyg-toolbar-property .custom-toolbar-option.toolbar-option {\n  padding: 6px 8px 4px 1px;\n  border-radius: 3px;\n}\n\n.driftiwyg-toolbar-property-dropdown {\n  position: absolute;\n  top: 35px;\n  right: 10px;\n  border: 1px solid var(--main-navy);\n  border-radius: 3px;\n  background: var(--main-white);\n  width: 275px;\n  display: block;\n  height: 250px;\n  overflow-y: hidden;\n  z-index: 100;\n  box-shadow: var(--bot-paper-depth-2);\n}\n\n.toolbar-menu-popover--container .property-list-container {\n  max-height: 242px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.toolbar-menu-popover--container .property-list-section-header {\n  font-size: var(--font-size-subtle);\n  font-family: var(--main-font-family--semibold);\n  margin: 0;\n  padding: 6px 15px;\n  background-color: var(--main-navy-extra-light);\n  color: var(--main-navy-extra-dark);\n  text-transform: capitalize;\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n}\n\n.toolbar-menu-popover--container .property-list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.toolbar-menu-popover--container .property-list li {\n  padding: 5px 15px;\n  margin: 13px 0;\n  font-size: var(--font-size-copy);\n  color: var(--main-navy-extra-dark);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.toolbar-menu-popover--container .property-list li:hover {\n  background: var(--main-navy-extra-light);\n}\n\n.toolbar-menu-popover--container .property-list-filter input {\n  width: 100%;\n  cursor: text;\n  padding-left: 12px;\n  border-radius: 0px !important; /* overriding tide */\n  border: 1px solid var(--main-white) !important; /* overriding tide */\n  transition: all 0.2s ease;\n}\n\n.toolbar-menu-popover--container .property-list-filter input:focus {\n  border-color: var(--color-p3-6) !important; /* overriding tide */\n}\n\n.toolbar-menu-popover--container .empty-state-container {\n  padding: 32px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n  align-items: center;\n  border-top: 1px solid var(--color-p1-4);\n}\n\n.toolbar-menu-popover--container .empty-state-container p {\n  text-align: center;\n}\n\n.property-list-filter svg {\n  left: 15px !important; /* overriding tide */\n}\n\n.property-list-filter path {\n  fill: var(--main-navy) !important; /* overriding tide */\n}\n\n.toolbar-menu-popover--container .tide-text-loader {\n  margin-top: 87px;\n  margin-left: -10px;\n}\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,kCAAkC;EAClC,kBAAkB;EAClB,6BAA6B;EAC7B,YAAY;EACZ,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,8CAA8C;EAC9C,SAAS;EACT,iBAAiB;EACjB,8CAA8C;EAC9C,kCAAkC;EAClC,0BAA0B;EAC1B,wBAAgB;EAAhB,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gCAAgC;EAChC,kCAAkC;EAClC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B,EAAE,oBAAoB;EACnD,8CAA8C,EAAE,oBAAoB;EACpE,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C,EAAE,oBAAoB;AAClE;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB,EAAE,oBAAoB;AAC7C;;AAEA;EACE,iCAAiC,EAAE,oBAAoB;AACzD;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB",
      file: "style.css",
      sourcesContent: [".driftiwyg-toolbar-property {\n  position: relative;\n  margin-bottom: 6px;\n}\n\n.driftiwyg-toolbar-property svg {\n  display: block;\n}\n\n.driftiwyg-toolbar-property .custom-toolbar-option.toolbar-option {\n  padding: 6px 8px 4px 1px;\n  border-radius: 3px;\n}\n\n.driftiwyg-toolbar-property-dropdown {\n  position: absolute;\n  top: 35px;\n  right: 10px;\n  border: 1px solid var(--main-navy);\n  border-radius: 3px;\n  background: var(--main-white);\n  width: 275px;\n  display: block;\n  height: 250px;\n  overflow-y: hidden;\n  z-index: 100;\n  box-shadow: var(--bot-paper-depth-2);\n}\n\n.toolbar-menu-popover--container .property-list-container {\n  max-height: 242px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.toolbar-menu-popover--container .property-list-section-header {\n  font-size: var(--font-size-subtle);\n  font-family: var(--main-font-family--semibold);\n  margin: 0;\n  padding: 6px 15px;\n  background-color: var(--main-navy-extra-light);\n  color: var(--main-navy-extra-dark);\n  text-transform: capitalize;\n  position: sticky;\n  top: 0;\n}\n\n.toolbar-menu-popover--container .property-list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.toolbar-menu-popover--container .property-list li {\n  padding: 5px 15px;\n  margin: 13px 0;\n  font-size: var(--font-size-copy);\n  color: var(--main-navy-extra-dark);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.toolbar-menu-popover--container .property-list li:hover {\n  background: var(--main-navy-extra-light);\n}\n\n.toolbar-menu-popover--container .property-list-filter input {\n  width: 100%;\n  cursor: text;\n  padding-left: 12px;\n  border-radius: 0px !important; /* overriding tide */\n  border: 1px solid var(--main-white) !important; /* overriding tide */\n  transition: all 0.2s ease;\n}\n\n.toolbar-menu-popover--container .property-list-filter input:focus {\n  border-color: var(--color-p3-6) !important; /* overriding tide */\n}\n\n.toolbar-menu-popover--container .empty-state-container {\n  padding: 32px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n  align-items: center;\n  border-top: 1px solid var(--color-p1-4);\n}\n\n.toolbar-menu-popover--container .empty-state-container p {\n  text-align: center;\n}\n\n.property-list-filter svg {\n  left: 15px !important; /* overriding tide */\n}\n\n.property-list-filter path {\n  fill: var(--main-navy) !important; /* overriding tide */\n}\n\n.toolbar-menu-popover--container .tide-text-loader {\n  margin-top: 87px;\n  margin-left: -10px;\n}\n"]
    }]);
  }, function (e, i, t) {
    var a = function (e) {
      "use strict";

      var i,
        t = Object.prototype,
        a = t.hasOwnProperty,
        n = "function" === typeof Symbol ? Symbol : {},
        o = n.iterator || "@@iterator",
        r = n.asyncIterator || "@@asyncIterator",
        s = n.toStringTag || "@@toStringTag";
      function wrap(e, i, t, a) {
        var n = i && i.prototype instanceof Generator ? i : Generator,
          o = Object.create(n.prototype),
          r = new Context(a || []);
        return o._invoke = function makeInvokeMethod(e, i, t) {
          var a = _;
          return function invoke(n, o) {
            if (a === g) throw new Error("Generator is already running");
            if (a === f) {
              if ("throw" === n) throw o;
              return doneResult();
            }
            for (t.method = n, t.arg = o;;) {
              var r = t.delegate;
              if (r) {
                var s = maybeInvokeDelegate(r, t);
                if (s) {
                  if (s === h) continue;
                  return s;
                }
              }
              if ("next" === t.method) t.sent = t._sent = t.arg;else if ("throw" === t.method) {
                if (a === _) throw a = f, t.arg;
                t.dispatchException(t.arg);
              } else "return" === t.method && t.abrupt("return", t.arg);
              a = g;
              var d = tryCatch(e, i, t);
              if ("normal" === d.type) {
                if (a = t.done ? f : l, d.arg === h) continue;
                return {
                  value: d.arg,
                  done: t.done
                };
              }
              "throw" === d.type && (a = f, t.method = "throw", t.arg = d.arg);
            }
          };
        }(e, t, r), o;
      }
      function tryCatch(e, i, t) {
        try {
          return {
            type: "normal",
            arg: e.call(i, t)
          };
        } catch (a) {
          return {
            type: "throw",
            arg: a
          };
        }
      }
      e.wrap = wrap;
      var _ = "suspendedStart",
        l = "suspendedYield",
        g = "executing",
        f = "completed",
        h = {};
      function Generator() {}
      function GeneratorFunction() {}
      function GeneratorFunctionPrototype() {}
      var d = {};
      d[o] = function () {
        return this;
      };
      var m = Object.getPrototypeOf,
        u = m && m(m(values([])));
      u && u !== t && a.call(u, o) && (d = u);
      var c = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(d);
      function defineIteratorMethods(e) {
        ["next", "throw", "return"].forEach(function (i) {
          e[i] = function (e) {
            return this._invoke(i, e);
          };
        });
      }
      function AsyncIterator(e, i) {
        var t;
        this._invoke = function enqueue(n, o) {
          function callInvokeWithMethodAndArg() {
            return new i(function (t, r) {
              !function invoke(t, n, o, r) {
                var s = tryCatch(e[t], e, n);
                if ("throw" !== s.type) {
                  var _ = s.arg,
                    l = _.value;
                  return l && "object" === typeof l && a.call(l, "__await") ? i.resolve(l.__await).then(function (e) {
                    invoke("next", e, o, r);
                  }, function (e) {
                    invoke("throw", e, o, r);
                  }) : i.resolve(l).then(function (e) {
                    _.value = e, o(_);
                  }, function (e) {
                    return invoke("throw", e, o, r);
                  });
                }
                r(s.arg);
              }(n, o, t, r);
            });
          }
          return t = t ? t.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        };
      }
      function maybeInvokeDelegate(e, t) {
        var a = e.iterator[t.method];
        if (a === i) {
          if (t.delegate = null, "throw" === t.method) {
            if (e.iterator.return && (t.method = "return", t.arg = i, maybeInvokeDelegate(e, t), "throw" === t.method)) return h;
            t.method = "throw", t.arg = new TypeError("The iterator does not provide a 'throw' method");
          }
          return h;
        }
        var n = tryCatch(a, e.iterator, t.arg);
        if ("throw" === n.type) return t.method = "throw", t.arg = n.arg, t.delegate = null, h;
        var o = n.arg;
        return o ? o.done ? (t[e.resultName] = o.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = i), t.delegate = null, h) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, h);
      }
      function pushTryEntry(e) {
        var i = {
          tryLoc: e[0]
        };
        1 in e && (i.catchLoc = e[1]), 2 in e && (i.finallyLoc = e[2], i.afterLoc = e[3]), this.tryEntries.push(i);
      }
      function resetTryEntry(e) {
        var i = e.completion || {};
        i.type = "normal", delete i.arg, e.completion = i;
      }
      function Context(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(pushTryEntry, this), this.reset(!0);
      }
      function values(e) {
        if (e) {
          var t = e[o];
          if (t) return t.call(e);
          if ("function" === typeof e.next) return e;
          if (!isNaN(e.length)) {
            var n = -1,
              r = function next() {
                for (; ++n < e.length;) {
                  if (a.call(e, n)) return next.value = e[n], next.done = !1, next;
                }
                return next.value = i, next.done = !0, next;
              };
            return r.next = r;
          }
        }
        return {
          next: doneResult
        };
      }
      function doneResult() {
        return {
          value: i,
          done: !0
        };
      }
      return GeneratorFunction.prototype = c.constructor = GeneratorFunctionPrototype, GeneratorFunctionPrototype.constructor = GeneratorFunction, GeneratorFunctionPrototype[s] = GeneratorFunction.displayName = "GeneratorFunction", e.isGeneratorFunction = function (e) {
        var i = "function" === typeof e && e.constructor;
        return !!i && (i === GeneratorFunction || "GeneratorFunction" === (i.displayName || i.name));
      }, e.mark = function (e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, s in e || (e[s] = "GeneratorFunction")), e.prototype = Object.create(c), e;
      }, e.awrap = function (e) {
        return {
          __await: e
        };
      }, defineIteratorMethods(AsyncIterator.prototype), AsyncIterator.prototype[r] = function () {
        return this;
      }, e.AsyncIterator = AsyncIterator, e.async = function (i, t, a, n, o) {
        void 0 === o && (o = Promise);
        var r = new AsyncIterator(wrap(i, t, a, n), o);
        return e.isGeneratorFunction(t) ? r : r.next().then(function (e) {
          return e.done ? e.value : r.next();
        });
      }, defineIteratorMethods(c), c[s] = "Generator", c[o] = function () {
        return this;
      }, c.toString = function () {
        return "[object Generator]";
      }, e.keys = function (e) {
        var i = [];
        for (var t in e) {
          i.push(t);
        }
        return i.reverse(), function next() {
          for (; i.length;) {
            var t = i.pop();
            if (t in e) return next.value = t, next.done = !1, next;
          }
          return next.done = !0, next;
        };
      }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = i, this.done = !1, this.delegate = null, this.method = "next", this.arg = i, this.tryEntries.forEach(resetTryEntry), !e) for (var t in this) {
            "t" === t.charAt(0) && a.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = i);
          }
        },
        stop: function stop() {
          this.done = !0;
          var e = this.tryEntries[0].completion;
          if ("throw" === e.type) throw e.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(e) {
          if (this.done) throw e;
          var t = this;
          function handle(a, n) {
            return r.type = "throw", r.arg = e, t.next = a, n && (t.method = "next", t.arg = i), !!n;
          }
          for (var n = this.tryEntries.length - 1; n >= 0; --n) {
            var o = this.tryEntries[n],
              r = o.completion;
            if ("root" === o.tryLoc) return handle("end");
            if (o.tryLoc <= this.prev) {
              var s = a.call(o, "catchLoc"),
                _ = a.call(o, "finallyLoc");
              if (s && _) {
                if (this.prev < o.catchLoc) return handle(o.catchLoc, !0);
                if (this.prev < o.finallyLoc) return handle(o.finallyLoc);
              } else if (s) {
                if (this.prev < o.catchLoc) return handle(o.catchLoc, !0);
              } else {
                if (!_) throw new Error("try statement without catch or finally");
                if (this.prev < o.finallyLoc) return handle(o.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(e, i) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var n = this.tryEntries[t];
            if (n.tryLoc <= this.prev && a.call(n, "finallyLoc") && this.prev < n.finallyLoc) {
              var o = n;
              break;
            }
          }
          o && ("break" === e || "continue" === e) && o.tryLoc <= i && i <= o.finallyLoc && (o = null);
          var r = o ? o.completion : {};
          return r.type = e, r.arg = i, o ? (this.method = "next", this.next = o.finallyLoc, h) : this.complete(r);
        },
        complete: function complete(e, i) {
          if ("throw" === e.type) throw e.arg;
          return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && i && (this.next = i), h;
        },
        finish: function finish(e) {
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var t = this.tryEntries[i];
            if (t.finallyLoc === e) return this.complete(t.completion, t.afterLoc), resetTryEntry(t), h;
          }
        },
        catch: function _catch(e) {
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var t = this.tryEntries[i];
            if (t.tryLoc === e) {
              var a = t.completion;
              if ("throw" === a.type) {
                var n = a.arg;
                resetTryEntry(t);
              }
              return n;
            }
          }
          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, t, a) {
          return this.delegate = {
            iterator: values(e),
            resultName: t,
            nextLoc: a
          }, "next" === this.method && (this.arg = i), h;
        }
      }, e;
    }(e.exports);
    try {
      regeneratorRuntime = a;
    } catch (n) {
      Function("r", "regeneratorRuntime = r")(a);
    }
  }, function (e, i, t) {
    "use strict";

    var a = t(8),
      n = t(99),
      o = t(244),
      r = t(65);
    function createInstance(e) {
      var i = new o(e),
        t = n(o.prototype.request, i);
      return a.extend(t, o.prototype, i), a.extend(t, i), t;
    }
    var s = createInstance(r);
    s.Axios = o, s.create = function create(e) {
      return createInstance(a.merge(r, e));
    }, s.Cancel = t(103), s.CancelToken = t(258), s.isCancel = t(102), s.all = function all(e) {
      return Promise.all(e);
    }, s.spread = t(259), e.exports = s, e.exports.default = s;
  }, function (e, i) {
    function isBuffer(e) {
      return !!e.constructor && "function" === typeof e.constructor.isBuffer && e.constructor.isBuffer(e);
    }
    e.exports = function (e) {
      return null != e && (isBuffer(e) || function isSlowBuffer(e) {
        return "function" === typeof e.readFloatLE && "function" === typeof e.slice && isBuffer(e.slice(0, 0));
      }(e) || !!e._isBuffer);
    };
  }, function (e, i, t) {
    "use strict";

    var a = t(65),
      n = t(8),
      o = t(253),
      r = t(254);
    function Axios(e) {
      this.defaults = e, this.interceptors = {
        request: new o(),
        response: new o()
      };
    }
    Axios.prototype.request = function request(e) {
      "string" === typeof e && (e = n.merge({
        url: arguments[0]
      }, arguments[1])), (e = n.merge(a, this.defaults, {
        method: "get"
      }, e)).method = e.method.toLowerCase();
      var i = [r, void 0],
        t = Promise.resolve(e);
      for (this.interceptors.request.forEach(function unshiftRequestInterceptors(e) {
        i.unshift(e.fulfilled, e.rejected);
      }), this.interceptors.response.forEach(function pushResponseInterceptors(e) {
        i.push(e.fulfilled, e.rejected);
      }); i.length;) {
        t = t.then(i.shift(), i.shift());
      }
      return t;
    }, n.forEach(["delete", "get", "head", "options"], function forEachMethodNoData(e) {
      Axios.prototype[e] = function (i, t) {
        return this.request(n.merge(t || {}, {
          method: e,
          url: i
        }));
      };
    }), n.forEach(["post", "put", "patch"], function forEachMethodWithData(e) {
      Axios.prototype[e] = function (i, t, a) {
        return this.request(n.merge(a || {}, {
          method: e,
          url: i,
          data: t
        }));
      };
    }), e.exports = Axios;
  }, function (e, i, t) {
    "use strict";

    var a = t(8);
    e.exports = function normalizeHeaderName(e, i) {
      a.forEach(e, function processHeader(t, a) {
        a !== i && a.toUpperCase() === i.toUpperCase() && (e[i] = t, delete e[a]);
      });
    };
  }, function (e, i, t) {
    "use strict";

    var a = t(101);
    e.exports = function settle(e, i, t) {
      var n = t.config.validateStatus;
      t.status && n && !n(t.status) ? i(a("Request failed with status code " + t.status, t.config, null, t.request, t)) : e(t);
    };
  }, function (e, i, t) {
    "use strict";

    e.exports = function enhanceError(e, i, t, a, n) {
      return e.config = i, t && (e.code = t), e.request = a, e.response = n, e;
    };
  }, function (e, i, t) {
    "use strict";

    var a = t(8);
    function encode(e) {
      return encodeURIComponent(e).replace(/%40/gi, "@").replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    }
    e.exports = function buildURL(e, i, t) {
      if (!i) return e;
      var n;
      if (t) n = t(i);else if (a.isURLSearchParams(i)) n = i.toString();else {
        var o = [];
        a.forEach(i, function serialize(e, i) {
          null !== e && "undefined" !== typeof e && (a.isArray(e) && (i += "[]"), a.isArray(e) || (e = [e]), a.forEach(e, function parseValue(e) {
            a.isDate(e) ? e = e.toISOString() : a.isObject(e) && (e = JSON.stringify(e)), o.push(encode(i) + "=" + encode(e));
          }));
        }), n = o.join("&");
      }
      return n && (e += (-1 === e.indexOf("?") ? "?" : "&") + n), e;
    };
  }, function (e, i, t) {
    "use strict";

    var a = t(8),
      n = ["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"];
    e.exports = function parseHeaders(e) {
      var i,
        t,
        o,
        r = {};
      return e ? (a.forEach(e.split("\n"), function parser(e) {
        if (o = e.indexOf(":"), i = a.trim(e.substr(0, o)).toLowerCase(), t = a.trim(e.substr(o + 1)), i) {
          if (r[i] && n.indexOf(i) >= 0) return;
          r[i] = "set-cookie" === i ? (r[i] ? r[i] : []).concat([t]) : r[i] ? r[i] + ", " + t : t;
        }
      }), r) : r;
    };
  }, function (e, i, t) {
    "use strict";

    var a = t(8);
    e.exports = a.isStandardBrowserEnv() ? function standardBrowserEnv() {
      var e,
        i = /(msie|trident)/i.test(navigator.userAgent),
        t = document.createElement("a");
      function resolveURL(e) {
        var a = e;
        return i && (t.setAttribute("href", a), a = t.href), t.setAttribute("href", a), {
          href: t.href,
          protocol: t.protocol ? t.protocol.replace(/:$/, "") : "",
          host: t.host,
          search: t.search ? t.search.replace(/^\?/, "") : "",
          hash: t.hash ? t.hash.replace(/^#/, "") : "",
          hostname: t.hostname,
          port: t.port,
          pathname: "/" === t.pathname.charAt(0) ? t.pathname : "/" + t.pathname
        };
      }
      return e = resolveURL(window.location.href), function isURLSameOrigin(i) {
        var t = a.isString(i) ? resolveURL(i) : i;
        return t.protocol === e.protocol && t.host === e.host;
      };
    }() : function isURLSameOrigin() {
      return !0;
    };
  }, function (e, i, t) {
    "use strict";

    var a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    function E() {
      this.message = "String contains an invalid character";
    }
    E.prototype = new Error(), E.prototype.code = 5, E.prototype.name = "InvalidCharacterError", e.exports = function btoa(e) {
      for (var i, t, n = String(e), o = "", r = 0, s = a; n.charAt(0 | r) || (s = "=", r % 1); o += s.charAt(63 & i >> 8 - r % 1 * 8)) {
        if ((t = n.charCodeAt(r += .75)) > 255) throw new E();
        i = i << 8 | t;
      }
      return o;
    };
  }, function (e, i, t) {
    "use strict";

    var a = t(8);
    e.exports = a.isStandardBrowserEnv() ? function standardBrowserEnv() {
      return {
        write: function write(e, i, t, n, o, r) {
          var s = [];
          s.push(e + "=" + encodeURIComponent(i)), a.isNumber(t) && s.push("expires=" + new Date(t).toGMTString()), a.isString(n) && s.push("path=" + n), a.isString(o) && s.push("domain=" + o), !0 === r && s.push("secure"), document.cookie = s.join("; ");
        },
        read: function read(e) {
          var i = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
          return i ? decodeURIComponent(i[3]) : null;
        },
        remove: function remove(e) {
          this.write(e, "", Date.now() - 864e5);
        }
      };
    }() : {
      write: function write() {},
      read: function read() {
        return null;
      },
      remove: function remove() {}
    };
  }, function (e, i, t) {
    "use strict";

    var a = t(8);
    function InterceptorManager() {
      this.handlers = [];
    }
    InterceptorManager.prototype.use = function use(e, i) {
      return this.handlers.push({
        fulfilled: e,
        rejected: i
      }), this.handlers.length - 1;
    }, InterceptorManager.prototype.eject = function eject(e) {
      this.handlers[e] && (this.handlers[e] = null);
    }, InterceptorManager.prototype.forEach = function forEach(e) {
      a.forEach(this.handlers, function forEachHandler(i) {
        null !== i && e(i);
      });
    }, e.exports = InterceptorManager;
  }, function (e, i, t) {
    "use strict";

    var a = t(8),
      n = t(255),
      o = t(102),
      r = t(65),
      s = t(256),
      _ = t(257);
    function throwIfCancellationRequested(e) {
      e.cancelToken && e.cancelToken.throwIfRequested();
    }
    e.exports = function dispatchRequest(e) {
      return throwIfCancellationRequested(e), e.baseURL && !s(e.url) && (e.url = _(e.baseURL, e.url)), e.headers = e.headers || {}, e.data = n(e.data, e.headers, e.transformRequest), e.headers = a.merge(e.headers.common || {}, e.headers[e.method] || {}, e.headers || {}), a.forEach(["delete", "get", "head", "post", "put", "patch", "common"], function cleanHeaderConfig(i) {
        delete e.headers[i];
      }), (e.adapter || r.adapter)(e).then(function onAdapterResolution(i) {
        return throwIfCancellationRequested(e), i.data = n(i.data, i.headers, e.transformResponse), i;
      }, function onAdapterRejection(i) {
        return o(i) || (throwIfCancellationRequested(e), i && i.response && (i.response.data = n(i.response.data, i.response.headers, e.transformResponse))), Promise.reject(i);
      });
    };
  }, function (e, i, t) {
    "use strict";

    var a = t(8);
    e.exports = function transformData(e, i, t) {
      return a.forEach(t, function transform(t) {
        e = t(e, i);
      }), e;
    };
  }, function (e, i, t) {
    "use strict";

    e.exports = function isAbsoluteURL(e) {
      return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(e);
    };
  }, function (e, i, t) {
    "use strict";

    e.exports = function combineURLs(e, i) {
      return i ? e.replace(/\/+$/, "") + "/" + i.replace(/^\/+/, "") : e;
    };
  }, function (e, i, t) {
    "use strict";

    var a = t(103);
    function CancelToken(e) {
      if ("function" !== typeof e) throw new TypeError("executor must be a function.");
      var i;
      this.promise = new Promise(function promiseExecutor(e) {
        i = e;
      });
      var t = this;
      e(function cancel(e) {
        t.reason || (t.reason = new a(e), i(t.reason));
      });
    }
    CancelToken.prototype.throwIfRequested = function throwIfRequested() {
      if (this.reason) throw this.reason;
    }, CancelToken.source = function source() {
      var e;
      return {
        token: new CancelToken(function executor(i) {
          e = i;
        }),
        cancel: e
      };
    }, e.exports = CancelToken;
  }, function (e, i, t) {
    "use strict";

    e.exports = function spread(e) {
      return function wrap(i) {
        return e.apply(null, i);
      };
    };
  }, function (e, i, t) {
    "use strict";

    var a = t(104),
      n = t(105),
      o = {
        brackets: function brackets(e) {
          return e + "[]";
        },
        indices: function indices(e, i) {
          return e + "[" + i + "]";
        },
        repeat: function repeat(e) {
          return e;
        }
      },
      r = Date.prototype.toISOString,
      s = {
        delimiter: "&",
        encode: !0,
        encoder: a.encode,
        encodeValuesOnly: !1,
        serializeDate: function serializeDate(e) {
          return r.call(e);
        },
        skipNulls: !1,
        strictNullHandling: !1
      },
      _ = function stringify(e, i, t, n, o, r, _, l, g, f, h, d) {
        var m = e;
        if ("function" === typeof _) m = _(i, m);else if (m instanceof Date) m = f(m);else if (null === m) {
          if (n) return r && !d ? r(i, s.encoder) : i;
          m = "";
        }
        if ("string" === typeof m || "number" === typeof m || "boolean" === typeof m || a.isBuffer(m)) return r ? [h(d ? i : r(i, s.encoder)) + "=" + h(r(m, s.encoder))] : [h(i) + "=" + h(String(m))];
        var u,
          c = [];
        if ("undefined" === typeof m) return c;
        if (Array.isArray(_)) u = _;else {
          var F = Object.keys(m);
          u = l ? F.sort(l) : F;
        }
        for (var p = 0; p < u.length; ++p) {
          var b = u[p];
          o && null === m[b] || (c = Array.isArray(m) ? c.concat(stringify(m[b], t(i, b), t, n, o, r, _, l, g, f, h, d)) : c.concat(stringify(m[b], i + (g ? "." + b : "[" + b + "]"), t, n, o, r, _, l, g, f, h, d)));
        }
        return c;
      };
    e.exports = function (e, i) {
      var t = e,
        r = i ? a.assign({}, i) : {};
      if (null !== r.encoder && void 0 !== r.encoder && "function" !== typeof r.encoder) throw new TypeError("Encoder has to be a function.");
      var l = "undefined" === typeof r.delimiter ? s.delimiter : r.delimiter,
        g = "boolean" === typeof r.strictNullHandling ? r.strictNullHandling : s.strictNullHandling,
        f = "boolean" === typeof r.skipNulls ? r.skipNulls : s.skipNulls,
        h = "boolean" === typeof r.encode ? r.encode : s.encode,
        d = "function" === typeof r.encoder ? r.encoder : s.encoder,
        m = "function" === typeof r.sort ? r.sort : null,
        u = "undefined" !== typeof r.allowDots && r.allowDots,
        c = "function" === typeof r.serializeDate ? r.serializeDate : s.serializeDate,
        F = "boolean" === typeof r.encodeValuesOnly ? r.encodeValuesOnly : s.encodeValuesOnly;
      if ("undefined" === typeof r.format) r.format = n.default;else if (!Object.prototype.hasOwnProperty.call(n.formatters, r.format)) throw new TypeError("Unknown format option provided.");
      var p,
        b,
        y = n.formatters[r.format];
      "function" === typeof r.filter ? t = (b = r.filter)("", t) : Array.isArray(r.filter) && (p = b = r.filter);
      var k,
        v = [];
      if ("object" !== typeof t || null === t) return "";
      k = r.arrayFormat in o ? r.arrayFormat : "indices" in r ? r.indices ? "indices" : "repeat" : "indices";
      var w = o[k];
      p || (p = Object.keys(t)), m && p.sort(m);
      for (var E = 0; E < p.length; ++E) {
        var A = p[E];
        f && null === t[A] || (v = v.concat(_(t[A], A, w, g, f, h ? d : null, b, m, u, c, y, F)));
      }
      var j = v.join(l),
        x = !0 === r.addQueryPrefix ? "?" : "";
      return j.length > 0 ? x + j : "";
    };
  }, function (e, i, t) {
    "use strict";

    var a = t(104),
      n = Object.prototype.hasOwnProperty,
      o = {
        allowDots: !1,
        allowPrototypes: !1,
        arrayLimit: 20,
        decoder: a.decode,
        delimiter: "&",
        depth: 5,
        parameterLimit: 1e3,
        plainObjects: !1,
        strictNullHandling: !1
      },
      r = function parseQueryStringKeys(e, i, t) {
        if (e) {
          var a = t.allowDots ? e.replace(/\.([^.[]+)/g, "[$1]") : e,
            o = /(\[[^[\]]*])/g,
            r = /(\[[^[\]]*])/.exec(a),
            s = r ? a.slice(0, r.index) : a,
            _ = [];
          if (s) {
            if (!t.plainObjects && n.call(Object.prototype, s) && !t.allowPrototypes) return;
            _.push(s);
          }
          for (var l = 0; null !== (r = o.exec(a)) && l < t.depth;) {
            if (l += 1, !t.plainObjects && n.call(Object.prototype, r[1].slice(1, -1)) && !t.allowPrototypes) return;
            _.push(r[1]);
          }
          return r && _.push("[" + a.slice(r.index) + "]"), function parseObject(e, i, t) {
            for (var a = i, n = e.length - 1; n >= 0; --n) {
              var o,
                r = e[n];
              if ("[]" === r) o = (o = []).concat(a);else {
                o = t.plainObjects ? Object.create(null) : {};
                var s = "[" === r.charAt(0) && "]" === r.charAt(r.length - 1) ? r.slice(1, -1) : r,
                  _ = parseInt(s, 10);
                !isNaN(_) && r !== s && String(_) === s && _ >= 0 && t.parseArrays && _ <= t.arrayLimit ? (o = [])[_] = a : o[s] = a;
              }
              a = o;
            }
            return a;
          }(_, i, t);
        }
      };
    e.exports = function (e, i) {
      var t = i ? a.assign({}, i) : {};
      if (null !== t.decoder && void 0 !== t.decoder && "function" !== typeof t.decoder) throw new TypeError("Decoder has to be a function.");
      if (t.ignoreQueryPrefix = !0 === t.ignoreQueryPrefix, t.delimiter = "string" === typeof t.delimiter || a.isRegExp(t.delimiter) ? t.delimiter : o.delimiter, t.depth = "number" === typeof t.depth ? t.depth : o.depth, t.arrayLimit = "number" === typeof t.arrayLimit ? t.arrayLimit : o.arrayLimit, t.parseArrays = !1 !== t.parseArrays, t.decoder = "function" === typeof t.decoder ? t.decoder : o.decoder, t.allowDots = "boolean" === typeof t.allowDots ? t.allowDots : o.allowDots, t.plainObjects = "boolean" === typeof t.plainObjects ? t.plainObjects : o.plainObjects, t.allowPrototypes = "boolean" === typeof t.allowPrototypes ? t.allowPrototypes : o.allowPrototypes, t.parameterLimit = "number" === typeof t.parameterLimit ? t.parameterLimit : o.parameterLimit, t.strictNullHandling = "boolean" === typeof t.strictNullHandling ? t.strictNullHandling : o.strictNullHandling, "" === e || null === e || "undefined" === typeof e) return t.plainObjects ? Object.create(null) : {};
      for (var s = "string" === typeof e ? function parseQueryStringValues(e, i) {
          for (var t = {}, a = i.ignoreQueryPrefix ? e.replace(/^\?/, "") : e, r = i.parameterLimit === 1 / 0 ? void 0 : i.parameterLimit, s = a.split(i.delimiter, r), _ = 0; _ < s.length; ++_) {
            var l,
              g,
              f = s[_],
              h = f.indexOf("]="),
              d = -1 === h ? f.indexOf("=") : h + 1;
            -1 === d ? (l = i.decoder(f, o.decoder), g = i.strictNullHandling ? null : "") : (l = i.decoder(f.slice(0, d), o.decoder), g = i.decoder(f.slice(d + 1), o.decoder)), n.call(t, l) ? t[l] = [].concat(t[l]).concat(g) : t[l] = g;
          }
          return t;
        }(e, t) : e, _ = t.plainObjects ? Object.create(null) : {}, l = Object.keys(s), g = 0; g < l.length; ++g) {
        var f = l[g],
          h = r(f, s[f], t);
        _ = a.merge(_, h, t);
      }
      return a.compact(_);
    };
  }, function (e, i, t) {
    var a = t(23),
      n = a.JSON || (a.JSON = {
        stringify: JSON.stringify
      });
    e.exports = function stringify(e) {
      return n.stringify.apply(n, arguments);
    };
  }, function (e, i, t) {
    t(264), e.exports = t(23).Object.values;
  }, function (e, i, t) {
    var a = t(66),
      n = t(268)(!1);
    a(a.S, "Object", {
      values: function values(e) {
        return n(e);
      }
    });
  }, function (e, i) {
    e.exports = function (e) {
      if ("function" != typeof e) throw TypeError(e + " is not a function!");
      return e;
    };
  }, function (e, i, t) {
    e.exports = !t(31) && !t(107)(function () {
      return 7 != Object.defineProperty(t(108)("div"), "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, function (e, i, t) {
    var a = t(67);
    e.exports = function (e, i) {
      if (!a(e)) return e;
      var t, n;
      if (i && "function" == typeof (t = e.toString) && !a(n = t.call(e))) return n;
      if ("function" == typeof (t = e.valueOf) && !a(n = t.call(e))) return n;
      if (!i && "function" == typeof (t = e.toString) && !a(n = t.call(e))) return n;
      throw TypeError("Can't convert object to primitive value");
    };
  }, function (e, i, t) {
    var a = t(31),
      n = t(109),
      o = t(69),
      r = t(273).f;
    e.exports = function (e) {
      return function (i) {
        for (var t, s = o(i), _ = n(s), l = _.length, g = 0, f = []; l > g;) {
          t = _[g++], a && !r.call(s, t) || f.push(e ? [t, s[t]] : s[t]);
        }
        return f;
      };
    };
  }, function (e, i, t) {
    var a = t(44),
      n = t(69),
      o = t(271)(!1),
      r = t(72)("IE_PROTO");
    e.exports = function (e, i) {
      var t,
        s = n(e),
        _ = 0,
        l = [];
      for (t in s) {
        t != r && a(s, t) && l.push(t);
      }
      for (; i.length > _;) {
        a(s, t = i[_++]) && (~o(l, t) || l.push(t));
      }
      return l;
    };
  }, function (e, i, t) {
    var a = t(110);
    e.exports = Object("z").propertyIsEnumerable(0) ? Object : function (e) {
      return "String" == a(e) ? e.split("") : Object(e);
    };
  }, function (e, i, t) {
    var a = t(69),
      n = t(111),
      o = t(272);
    e.exports = function (e) {
      return function (i, t, r) {
        var s,
          _ = a(i),
          l = n(_.length),
          g = o(r, l);
        if (e && t != t) {
          for (; l > g;) {
            if ((s = _[g++]) != s) return !0;
          }
        } else for (; l > g; g++) {
          if ((e || g in _) && _[g] === t) return e || g || 0;
        }
        return !e && -1;
      };
    };
  }, function (e, i, t) {
    var a = t(71),
      n = Math.max,
      o = Math.min;
    e.exports = function (e, i) {
      return (e = a(e)) < 0 ? n(e + i, 0) : o(e, i);
    };
  }, function (e, i) {
    i.f = {}.propertyIsEnumerable;
  }, function (e, i, t) {
    e.exports = {
      default: t(275),
      __esModule: !0
    };
  }, function (e, i, t) {
    t(276), t(285), e.exports = t(23).Array.from;
  }, function (e, i, t) {
    "use strict";

    var a = t(277)(!0);
    t(278)(String, "String", function (e) {
      this._t = String(e), this._i = 0;
    }, function () {
      var e,
        i = this._t,
        t = this._i;
      return t >= i.length ? {
        value: void 0,
        done: !0
      } : (e = a(i, t), this._i += e.length, {
        value: e,
        done: !1
      });
    });
  }, function (e, i, t) {
    var a = t(71),
      n = t(70);
    e.exports = function (e) {
      return function (i, t) {
        var o,
          r,
          s = String(n(i)),
          _ = a(t),
          l = s.length;
        return _ < 0 || _ >= l ? e ? "" : void 0 : (o = s.charCodeAt(_)) < 55296 || o > 56319 || _ + 1 === l || (r = s.charCodeAt(_ + 1)) < 56320 || r > 57343 ? e ? s.charAt(_) : o : e ? s.slice(_, _ + 2) : r - 56320 + (o - 55296 << 10) + 65536;
      };
    };
  }, function (e, i, t) {
    "use strict";

    var a = t(113),
      n = t(66),
      o = t(279),
      r = t(41),
      s = t(73),
      _ = t(280),
      l = t(116),
      g = t(284),
      f = t(17)("iterator"),
      h = !([].keys && "next" in [].keys()),
      d = function returnThis() {
        return this;
      };
    e.exports = function (e, i, t, m, u, c, F) {
      _(t, i, m);
      var p,
        b,
        y,
        k = function getMethod(e) {
          if (!h && e in A) return A[e];
          switch (e) {
            case "keys":
              return function keys() {
                return new t(this, e);
              };
            case "values":
              return function values() {
                return new t(this, e);
              };
          }
          return function entries() {
            return new t(this, e);
          };
        },
        v = i + " Iterator",
        w = "values" == u,
        E = !1,
        A = e.prototype,
        j = A[f] || A["@@iterator"] || u && A[u],
        x = j || k(u),
        C = u ? w ? k("entries") : x : void 0,
        D = "Array" == i && A.entries || j;
      if (D && (y = g(D.call(new e()))) !== Object.prototype && y.next && (l(y, v, !0), a || "function" == typeof y[f] || r(y, f, d)), w && j && "values" !== j.name && (E = !0, x = function values() {
        return j.call(this);
      }), a && !F || !h && !E && A[f] || r(A, f, x), s[i] = x, s[v] = d, u) if (p = {
        values: w ? x : k("values"),
        keys: c ? x : k("keys"),
        entries: C
      }, F) for (b in p) {
        b in A || o(A, b, p[b]);
      } else n(n.P + n.F * (h || E), i, p);
      return p;
    };
  }, function (e, i, t) {
    e.exports = t(41);
  }, function (e, i, t) {
    "use strict";

    var a = t(281),
      n = t(68),
      o = t(116),
      r = {};
    t(41)(r, t(17)("iterator"), function () {
      return this;
    }), e.exports = function (e, i, t) {
      e.prototype = a(r, {
        next: n(1, t)
      }), o(e, i + " Iterator");
    };
  }, function (e, i, t) {
    var a = t(43),
      n = t(282),
      o = t(115),
      r = t(72)("IE_PROTO"),
      s = function Empty() {},
      _ = function createDict() {
        var e,
          i = t(108)("iframe"),
          a = o.length;
        for (i.style.display = "none", t(283).appendChild(i), i.src = "javascript:", (e = i.contentWindow.document).open(), e.write("<script>document.F=Object<\/script>"), e.close(), _ = e.F; a--;) {
          delete _.prototype[o[a]];
        }
        return _();
      };
    e.exports = Object.create || function create(e, i) {
      var t;
      return null !== e ? (s.prototype = a(e), t = new s(), s.prototype = null, t[r] = e) : t = _(), void 0 === i ? t : n(t, i);
    };
  }, function (e, i, t) {
    var a = t(42),
      n = t(43),
      o = t(109);
    e.exports = t(31) ? Object.defineProperties : function defineProperties(e, i) {
      n(e);
      for (var t, r = o(i), s = r.length, _ = 0; s > _;) {
        a.f(e, t = r[_++], i[t]);
      }
      return e;
    };
  }, function (e, i, t) {
    var a = t(30).document;
    e.exports = a && a.documentElement;
  }, function (e, i, t) {
    var a = t(44),
      n = t(117),
      o = t(72)("IE_PROTO"),
      r = Object.prototype;
    e.exports = Object.getPrototypeOf || function (e) {
      return e = n(e), a(e, o) ? e[o] : "function" == typeof e.constructor && e instanceof e.constructor ? e.constructor.prototype : e instanceof Object ? r : null;
    };
  }, function (e, i, t) {
    "use strict";

    var a = t(106),
      n = t(66),
      o = t(117),
      r = t(286),
      s = t(287),
      _ = t(111),
      l = t(288),
      g = t(289);
    n(n.S + n.F * !t(291)(function (e) {
      Array.from(e);
    }), "Array", {
      from: function from(e) {
        var i,
          t,
          n,
          f,
          h = o(e),
          d = "function" == typeof this ? this : Array,
          m = arguments.length,
          u = m > 1 ? arguments[1] : void 0,
          c = void 0 !== u,
          F = 0,
          p = g(h);
        if (c && (u = a(u, m > 2 ? arguments[2] : void 0, 2)), void 0 == p || d == Array && s(p)) for (t = new d(i = _(h.length)); i > F; F++) {
          l(t, F, c ? u(h[F], F) : h[F]);
        } else for (f = p.call(h), t = new d(); !(n = f.next()).done; F++) {
          l(t, F, c ? r(f, u, [n.value, F], !0) : n.value);
        }
        return t.length = F, t;
      }
    });
  }, function (e, i, t) {
    var a = t(43);
    e.exports = function (e, i, t, n) {
      try {
        return n ? i(a(t)[0], t[1]) : i(t);
      } catch (r) {
        var o = e.return;
        throw void 0 !== o && a(o.call(e)), r;
      }
    };
  }, function (e, i, t) {
    var a = t(73),
      n = t(17)("iterator"),
      o = Array.prototype;
    e.exports = function (e) {
      return void 0 !== e && (a.Array === e || o[n] === e);
    };
  }, function (e, i, t) {
    "use strict";

    var a = t(42),
      n = t(68);
    e.exports = function (e, i, t) {
      i in e ? a.f(e, i, n(0, t)) : e[i] = t;
    };
  }, function (e, i, t) {
    var a = t(290),
      n = t(17)("iterator"),
      o = t(73);
    e.exports = t(23).getIteratorMethod = function (e) {
      if (void 0 != e) return e[n] || e["@@iterator"] || o[a(e)];
    };
  }, function (e, i, t) {
    var a = t(110),
      n = t(17)("toStringTag"),
      o = "Arguments" == a(function () {
        return arguments;
      }());
    e.exports = function (e) {
      var i, t, r;
      return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (t = function tryGet(e, i) {
        try {
          return e[i];
        } catch (t) {}
      }(i = Object(e), n)) ? t : o ? a(i) : "Object" == (r = a(i)) && "function" == typeof i.callee ? "Arguments" : r;
    };
  }, function (e, i, t) {
    var a = t(17)("iterator"),
      n = !1;
    try {
      var o = [7][a]();
      o.return = function () {
        n = !0;
      }, Array.from(o, function () {
        throw 2;
      });
    } catch (r) {}
    e.exports = function (e, i) {
      if (!i && !n) return !1;
      var t = !1;
      try {
        var o = [7],
          s = o[a]();
        s.next = function () {
          return {
            done: t = !0
          };
        }, o[a] = function () {
          return s;
        }, e(o);
      } catch (r) {}
      return t;
    };
  }, function (e, i) {
    "undefined" !== typeof window && function () {
      for (var e = 0, i = ["ms", "moz", "webkit", "o"], t = 0; t < i.length && !window.requestAnimationFrame; ++t) {
        window.requestAnimationFrame = window[i[t] + "RequestAnimationFrame"], window.cancelAnimationFrame = window[i[t] + "CancelAnimationFrame"] || window[i[t] + "CancelRequestAnimationFrame"];
      }
      window.requestAnimationFrame || (window.requestAnimationFrame = function (i, t) {
        var a = new Date().getTime(),
          n = Math.max(0, 16 - (a - e)),
          o = window.setTimeout(function () {
            i(a + n);
          }, n);
        return e = a + n, o;
      }), window.cancelAnimationFrame || (window.cancelAnimationFrame = function (e) {
        clearTimeout(e);
      });
    }();
  }, function (e, i, t) {
    var a = t(294);
    "string" === typeof (a = a.__esModule ? a.default : a) && (a = [[e.i, a, ""]]);
    var n = {
      insert: "head",
      singleton: !1
    };
    t(22)(a, n);
    a.locals && (e.exports = a.locals);
  }, function (e, i, t) {
    (e.exports = t(21)(!0)).push([e.i, '.emoji-mart,\n.emoji-mart * {\n  box-sizing: border-box;\n  line-height: 1.15;\n}\n\n.emoji-mart {\n  font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", sans-serif;\n  font-size: 16px;\n  display: inline-block;\n  color: #222427;\n  border: 1px solid #d9d9d9;\n  border-radius: 5px;\n  background: #fff;\n}\n\n.emoji-mart .emoji-mart-emoji {\n  padding: 6px;\n}\n\n.emoji-mart-bar {\n  border: 0 solid #d9d9d9;\n}\n.emoji-mart-bar:first-child {\n  border-bottom-width: 1px;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n}\n.emoji-mart-bar:last-child {\n  border-top-width: 1px;\n  border-bottom-left-radius: 5px;\n  border-bottom-right-radius: 5px;\n}\n\n.emoji-mart-anchors {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 0 6px;\n  line-height: 0;\n}\n\n.emoji-mart-anchor {\n  position: relative;\n  display: block;\n  flex: 1 1 auto;\n  color: #858585;\n  text-align: center;\n  padding: 12px 4px;\n  overflow: hidden;\n  transition: color .1s ease-out;\n  margin: 0;\n  box-shadow: none;\n  background: none;\n  border: none;\n}\n.emoji-mart-anchor:focus { outline: 0 }\n.emoji-mart-anchor:hover,\n.emoji-mart-anchor:focus,\n.emoji-mart-anchor-selected {\n  color: #464646;\n}\n\n.emoji-mart-anchor-selected .emoji-mart-anchor-bar {\n  bottom: 0;\n}\n\n.emoji-mart-anchor-bar {\n  position: absolute;\n  bottom: -3px; left: 0;\n  width: 100%; height: 3px;\n  background-color: #464646;\n}\n\n.emoji-mart-anchors i {\n  display: inline-block;\n  width: 100%;\n  max-width: 22px;\n}\n\n.emoji-mart-anchors svg,\n.emoji-mart-anchors img {\n  fill: currentColor;\n  height: 18px;\n  width: 18px;\n}\n\n.emoji-mart-scroll {\n  overflow-y: scroll;\n  height: 270px;\n  padding: 0 6px 6px 6px;\n  will-change: transform; /* avoids "repaints on scroll" in mobile Chrome */\n}\n\n.emoji-mart-search {\n  margin-top: 6px;\n  padding: 0 6px;\n  position: relative;\n}\n\n.emoji-mart-search input {\n  font-size: 16px;\n  display: block;\n  width: 100%;\n  padding: 5px 25px 6px 10px;\n  border-radius: 5px;\n  border: 1px solid #d9d9d9;\n  outline: 0;\n}\n\n.emoji-mart-search input,\n.emoji-mart-search input::-webkit-search-decoration,\n.emoji-mart-search input::-webkit-search-cancel-button,\n.emoji-mart-search input::-webkit-search-results-button,\n.emoji-mart-search input::-webkit-search-results-decoration {\n  /* remove webkit/blink styles for <input type="search">\n   * via https://stackoverflow.com/a/9422689 */\n  -webkit-appearance: none;\n}\n\n.emoji-mart-search-icon {\n  position: absolute;\n  top: 7px;\n  right: 11px;\n  z-index: 2;\n  padding: 2px 5px 1px;\n  border: none;\n  background: none;\n}\n\n.emoji-mart-category .emoji-mart-emoji span {\n  z-index: 1;\n  position: relative;\n  text-align: center;\n  cursor: default;\n}\n\n.emoji-mart-category .emoji-mart-emoji:hover:before {\n  z-index: 0;\n  content: "";\n  position: absolute;\n  top: 0; left: 0;\n  width: 100%; height: 100%;\n  background-color: #f4f4f4;\n  border-radius: 100%;\n}\n\n.emoji-mart-category-label {\n  z-index: 2;\n  position: relative;\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n}\n\n.emoji-mart-category-label span {\n  display: block;\n  width: 100%;\n  font-weight: 500;\n  padding: 5px 6px;\n  background-color: #fff;\n  background-color: rgba(255, 255, 255, .95);\n}\n\n.emoji-mart-category-list {\n  margin: 0;\n  padding: 0;\n}\n\n.emoji-mart-category-list li {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: inline-block;\n}\n\n.emoji-mart-emoji {\n  position: relative;\n  display: inline-block;\n  font-size: 0;\n  margin: 0;\n  padding: 0;\n  border: none;\n  background: none;\n  box-shadow: none;\n}\n\n.emoji-mart-emoji-native {\n  font-family: "Segoe UI Emoji", "Segoe UI Symbol", "Segoe UI", "Apple Color Emoji", "Twemoji Mozilla", "Noto Color Emoji", "EmojiOne Color", "Android Emoji";\n}\n\n.emoji-mart-no-results {\n  font-size: 14px;\n  text-align: center;\n  padding-top: 70px;\n  color: #858585;\n}\n.emoji-mart-no-results-img {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  width: 50%;\n}\n.emoji-mart-no-results .emoji-mart-category-label {\n  display: none;\n}\n.emoji-mart-no-results .emoji-mart-no-results-label {\n  margin-top: .2em;\n}\n.emoji-mart-no-results .emoji-mart-emoji:hover:before {\n  content: none;\n}\n\n.emoji-mart-preview {\n  position: relative;\n  height: 70px;\n}\n\n.emoji-mart-preview-emoji,\n.emoji-mart-preview-data,\n.emoji-mart-preview-skins {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.emoji-mart-preview-emoji {\n  left: 12px;\n}\n\n.emoji-mart-preview-data {\n  left: 68px; right: 12px;\n  word-break: break-all;\n}\n\n.emoji-mart-preview-skins {\n  right: 30px;\n  text-align: right;\n}\n\n.emoji-mart-preview-skins.custom {\n  right: 10px;\n  text-align: right;\n}\n\n.emoji-mart-preview-name {\n  font-size: 14px;\n}\n\n.emoji-mart-preview-shortname {\n  font-size: 12px;\n  color: #888;\n}\n.emoji-mart-preview-shortname + .emoji-mart-preview-shortname,\n.emoji-mart-preview-shortname + .emoji-mart-preview-emoticon,\n.emoji-mart-preview-emoticon + .emoji-mart-preview-emoticon {\n  margin-left: .5em;\n}\n\n.emoji-mart-preview-emoticon {\n  font-size: 11px;\n  color: #bbb;\n}\n\n.emoji-mart-title span {\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.emoji-mart-title .emoji-mart-emoji {\n  padding: 0;\n}\n\n.emoji-mart-title-label {\n  color: #999A9C;\n  font-size: 26px;\n  font-weight: 300;\n}\n\n.emoji-mart-skin-swatches {\n  font-size: 0;\n  padding: 2px 0;\n  border: 1px solid #d9d9d9;\n  border-radius: 12px;\n  background-color: #fff;\n}\n\n.emoji-mart-skin-swatches.custom {\n  font-size: 0;\n  border: none;\n  background-color: #fff;\n}\n\n.emoji-mart-skin-swatches.opened .emoji-mart-skin-swatch {\n  width: 16px;\n  padding: 0 2px;\n}\n\n.emoji-mart-skin-swatches.opened .emoji-mart-skin-swatch.selected:after {\n  opacity: .75;\n}\n\n.emoji-mart-skin-swatch {\n  display: inline-block;\n  width: 0;\n  vertical-align: middle;\n  transition-property: width, padding;\n  transition-duration: .125s;\n  transition-timing-function: ease-out;\n}\n\n.emoji-mart-skin-swatch:nth-child(1) { transition-delay: 0s }\n.emoji-mart-skin-swatch:nth-child(2) { transition-delay: .03s }\n.emoji-mart-skin-swatch:nth-child(3) { transition-delay: .06s }\n.emoji-mart-skin-swatch:nth-child(4) { transition-delay: .09s }\n.emoji-mart-skin-swatch:nth-child(5) { transition-delay: .12s }\n.emoji-mart-skin-swatch:nth-child(6) { transition-delay: .15s }\n\n.emoji-mart-skin-swatch.selected {\n  position: relative;\n  width: 16px;\n  padding: 0 2px;\n}\n\n.emoji-mart-skin-swatch.selected:after {\n  content: "";\n  position: absolute;\n  top: 50%; left: 50%;\n  width: 4px; height: 4px;\n  margin: -2px 0 0 -2px;\n  background-color: #fff;\n  border-radius: 100%;\n  pointer-events: none;\n  opacity: 0;\n  transition: opacity .2s ease-out;\n}\n\n.emoji-mart-skin-swatch.custom {\n  display: inline-block;\n  width: 0;\n  height: 38px;\n  overflow: hidden;\n  vertical-align: middle;\n  transition-property: width, height;\n  transition-duration: .125s;\n  transition-timing-function: ease-out;\n  cursor: default;\n}\n\n.emoji-mart-skin-swatch.custom.selected {\n  position: relative;\n  width: 36px;\n  height: 38px;\n  padding: 0 2px 0 0;\n}\n\n.emoji-mart-skin-swatch.custom.selected:after {\n  content: "";\n  width: 0;\n  height: 0;\n}\n\n.emoji-mart-skin-swatches.custom .emoji-mart-skin-swatch.custom:hover {\n  background-color: #f4f4f4;\n  border-radius: 10%;\n}\n\n.emoji-mart-skin-swatches.custom.opened .emoji-mart-skin-swatch.custom {\n  width: 36px;\n  height: 38px;\n  padding: 0 2px 0 0;\n}\n\n.emoji-mart-skin-swatches.custom.opened .emoji-mart-skin-swatch.custom.selected:after {\n  opacity: .75;\n}\n\n.emoji-mart-skin-text.opened {\n  display: inline-block;\n  vertical-align: middle;\n  text-align: left;\n  color: #888;\n  font-size: 11px;\n  padding: 5px 2px;\n  width: 95px;\n  height: 40px;\n  border-radius: 10%;\n  background-color: #fff;\n}\n\n.emoji-mart-skin {\n  display: inline-block;\n  width: 100%;\n  padding-top: 100%;\n  max-width: 12px;\n  border-radius: 100%;\n}\n\n.emoji-mart-skin-tone-1 { background-color: #ffc93a }\n.emoji-mart-skin-tone-2 { background-color: #fadcbc }\n.emoji-mart-skin-tone-3 { background-color: #e0bb95 }\n.emoji-mart-skin-tone-4 { background-color: #bf8f68 }\n.emoji-mart-skin-tone-5 { background-color: #9b643d }\n.emoji-mart-skin-tone-6 { background-color: #594539 }\n\n/* For screenreaders only, via https://stackoverflow.com/a/19758620 */\n.emoji-mart-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n\n/*\n * Dark mode styles\n */\n\n.emoji-mart-dark {\n  color: #fff;\n  border-color: #555453;\n  background-color: #222;\n}\n\n.emoji-mart-dark .emoji-mart-bar {\n  border-color: #555453;\n}\n\n.emoji-mart-dark .emoji-mart-search input {\n  color: #fff;\n  border-color: #555453;\n  background-color: #2f2f2f;\n}\n\n.emoji-mart-dark .emoji-mart-search-icon svg {\n  fill: #fff;\n}\n\n.emoji-mart-dark .emoji-mart-category .emoji-mart-emoji:hover:before {\n  background-color: #444;\n}\n\n.emoji-mart-dark .emoji-mart-category-label span {\n  background-color: #222;\n  color: #fff;\n}\n\n.emoji-mart-dark .emoji-mart-skin-swatches {\n  border-color: #555453;\n  background-color: #222;\n}\n\n.emoji-mart-dark .emoji-mart-anchor:hover,\n.emoji-mart-dark .emoji-mart-anchor:focus,\n.emoji-mart-dark .emoji-mart-anchor-selected {\n  color: #bfbfbf;\n}\n', "", {
      version: 3,
      sources: ["emoji-mart.css"],
      names: [],
      mappings: "AAAA;;EAEE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,4EAA4E;EAC5E,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;AACA,2BAA2B,WAAW;AACtC;;;EAGE,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY,EAAE,OAAO;EACrB,WAAW,EAAE,WAAW;EACxB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,sBAAsB,EAAE,iDAAiD;AAC3E;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;;;;;EAKE;8CAC4C;EAC5C,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,UAAU;EACV,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,MAAM,EAAE,OAAO;EACf,WAAW,EAAE,YAAY;EACzB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,SAAS;EACT,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,2JAA2J;AAC7J;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;;;EAGE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU,EAAE,WAAW;EACvB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;AACA;;;EAGE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,QAAQ;EACR,sBAAsB;EACtB,mCAAmC;EACnC,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA,uCAAuC,qBAAqB;AAC5D,uCAAuC,uBAAuB;AAC9D,uCAAuC,uBAAuB;AAC9D,uCAAuC,uBAAuB;AAC9D,uCAAuC,uBAAuB;AAC9D,uCAAuC,uBAAuB;;AAE9D;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ,EAAE,SAAS;EACnB,UAAU,EAAE,WAAW;EACvB,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,kCAAkC;EAClC,0BAA0B;EAC1B,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA,0BAA0B,0BAA0B;AACpD,0BAA0B,0BAA0B;AACpD,0BAA0B,0BAA0B;AACpD,0BAA0B,0BAA0B;AACpD,0BAA0B,0BAA0B;AACpD,0BAA0B,0BAA0B;;AAEpD,qEAAqE;AACrE;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE;;AAEF;EACE,WAAW;EACX,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;;EAGE,cAAc;AAChB",
      file: "emoji-mart.css",
      sourcesContent: ['.emoji-mart,\n.emoji-mart * {\n  box-sizing: border-box;\n  line-height: 1.15;\n}\n\n.emoji-mart {\n  font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", sans-serif;\n  font-size: 16px;\n  display: inline-block;\n  color: #222427;\n  border: 1px solid #d9d9d9;\n  border-radius: 5px;\n  background: #fff;\n}\n\n.emoji-mart .emoji-mart-emoji {\n  padding: 6px;\n}\n\n.emoji-mart-bar {\n  border: 0 solid #d9d9d9;\n}\n.emoji-mart-bar:first-child {\n  border-bottom-width: 1px;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n}\n.emoji-mart-bar:last-child {\n  border-top-width: 1px;\n  border-bottom-left-radius: 5px;\n  border-bottom-right-radius: 5px;\n}\n\n.emoji-mart-anchors {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 0 6px;\n  line-height: 0;\n}\n\n.emoji-mart-anchor {\n  position: relative;\n  display: block;\n  flex: 1 1 auto;\n  color: #858585;\n  text-align: center;\n  padding: 12px 4px;\n  overflow: hidden;\n  transition: color .1s ease-out;\n  margin: 0;\n  box-shadow: none;\n  background: none;\n  border: none;\n}\n.emoji-mart-anchor:focus { outline: 0 }\n.emoji-mart-anchor:hover,\n.emoji-mart-anchor:focus,\n.emoji-mart-anchor-selected {\n  color: #464646;\n}\n\n.emoji-mart-anchor-selected .emoji-mart-anchor-bar {\n  bottom: 0;\n}\n\n.emoji-mart-anchor-bar {\n  position: absolute;\n  bottom: -3px; left: 0;\n  width: 100%; height: 3px;\n  background-color: #464646;\n}\n\n.emoji-mart-anchors i {\n  display: inline-block;\n  width: 100%;\n  max-width: 22px;\n}\n\n.emoji-mart-anchors svg,\n.emoji-mart-anchors img {\n  fill: currentColor;\n  height: 18px;\n  width: 18px;\n}\n\n.emoji-mart-scroll {\n  overflow-y: scroll;\n  height: 270px;\n  padding: 0 6px 6px 6px;\n  will-change: transform; /* avoids "repaints on scroll" in mobile Chrome */\n}\n\n.emoji-mart-search {\n  margin-top: 6px;\n  padding: 0 6px;\n  position: relative;\n}\n\n.emoji-mart-search input {\n  font-size: 16px;\n  display: block;\n  width: 100%;\n  padding: 5px 25px 6px 10px;\n  border-radius: 5px;\n  border: 1px solid #d9d9d9;\n  outline: 0;\n}\n\n.emoji-mart-search input,\n.emoji-mart-search input::-webkit-search-decoration,\n.emoji-mart-search input::-webkit-search-cancel-button,\n.emoji-mart-search input::-webkit-search-results-button,\n.emoji-mart-search input::-webkit-search-results-decoration {\n  /* remove webkit/blink styles for <input type="search">\n   * via https://stackoverflow.com/a/9422689 */\n  -webkit-appearance: none;\n}\n\n.emoji-mart-search-icon {\n  position: absolute;\n  top: 7px;\n  right: 11px;\n  z-index: 2;\n  padding: 2px 5px 1px;\n  border: none;\n  background: none;\n}\n\n.emoji-mart-category .emoji-mart-emoji span {\n  z-index: 1;\n  position: relative;\n  text-align: center;\n  cursor: default;\n}\n\n.emoji-mart-category .emoji-mart-emoji:hover:before {\n  z-index: 0;\n  content: "";\n  position: absolute;\n  top: 0; left: 0;\n  width: 100%; height: 100%;\n  background-color: #f4f4f4;\n  border-radius: 100%;\n}\n\n.emoji-mart-category-label {\n  z-index: 2;\n  position: relative;\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n}\n\n.emoji-mart-category-label span {\n  display: block;\n  width: 100%;\n  font-weight: 500;\n  padding: 5px 6px;\n  background-color: #fff;\n  background-color: rgba(255, 255, 255, .95);\n}\n\n.emoji-mart-category-list {\n  margin: 0;\n  padding: 0;\n}\n\n.emoji-mart-category-list li {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: inline-block;\n}\n\n.emoji-mart-emoji {\n  position: relative;\n  display: inline-block;\n  font-size: 0;\n  margin: 0;\n  padding: 0;\n  border: none;\n  background: none;\n  box-shadow: none;\n}\n\n.emoji-mart-emoji-native {\n  font-family: "Segoe UI Emoji", "Segoe UI Symbol", "Segoe UI", "Apple Color Emoji", "Twemoji Mozilla", "Noto Color Emoji", "EmojiOne Color", "Android Emoji";\n}\n\n.emoji-mart-no-results {\n  font-size: 14px;\n  text-align: center;\n  padding-top: 70px;\n  color: #858585;\n}\n.emoji-mart-no-results-img {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  width: 50%;\n}\n.emoji-mart-no-results .emoji-mart-category-label {\n  display: none;\n}\n.emoji-mart-no-results .emoji-mart-no-results-label {\n  margin-top: .2em;\n}\n.emoji-mart-no-results .emoji-mart-emoji:hover:before {\n  content: none;\n}\n\n.emoji-mart-preview {\n  position: relative;\n  height: 70px;\n}\n\n.emoji-mart-preview-emoji,\n.emoji-mart-preview-data,\n.emoji-mart-preview-skins {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.emoji-mart-preview-emoji {\n  left: 12px;\n}\n\n.emoji-mart-preview-data {\n  left: 68px; right: 12px;\n  word-break: break-all;\n}\n\n.emoji-mart-preview-skins {\n  right: 30px;\n  text-align: right;\n}\n\n.emoji-mart-preview-skins.custom {\n  right: 10px;\n  text-align: right;\n}\n\n.emoji-mart-preview-name {\n  font-size: 14px;\n}\n\n.emoji-mart-preview-shortname {\n  font-size: 12px;\n  color: #888;\n}\n.emoji-mart-preview-shortname + .emoji-mart-preview-shortname,\n.emoji-mart-preview-shortname + .emoji-mart-preview-emoticon,\n.emoji-mart-preview-emoticon + .emoji-mart-preview-emoticon {\n  margin-left: .5em;\n}\n\n.emoji-mart-preview-emoticon {\n  font-size: 11px;\n  color: #bbb;\n}\n\n.emoji-mart-title span {\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.emoji-mart-title .emoji-mart-emoji {\n  padding: 0;\n}\n\n.emoji-mart-title-label {\n  color: #999A9C;\n  font-size: 26px;\n  font-weight: 300;\n}\n\n.emoji-mart-skin-swatches {\n  font-size: 0;\n  padding: 2px 0;\n  border: 1px solid #d9d9d9;\n  border-radius: 12px;\n  background-color: #fff;\n}\n\n.emoji-mart-skin-swatches.custom {\n  font-size: 0;\n  border: none;\n  background-color: #fff;\n}\n\n.emoji-mart-skin-swatches.opened .emoji-mart-skin-swatch {\n  width: 16px;\n  padding: 0 2px;\n}\n\n.emoji-mart-skin-swatches.opened .emoji-mart-skin-swatch.selected:after {\n  opacity: .75;\n}\n\n.emoji-mart-skin-swatch {\n  display: inline-block;\n  width: 0;\n  vertical-align: middle;\n  transition-property: width, padding;\n  transition-duration: .125s;\n  transition-timing-function: ease-out;\n}\n\n.emoji-mart-skin-swatch:nth-child(1) { transition-delay: 0s }\n.emoji-mart-skin-swatch:nth-child(2) { transition-delay: .03s }\n.emoji-mart-skin-swatch:nth-child(3) { transition-delay: .06s }\n.emoji-mart-skin-swatch:nth-child(4) { transition-delay: .09s }\n.emoji-mart-skin-swatch:nth-child(5) { transition-delay: .12s }\n.emoji-mart-skin-swatch:nth-child(6) { transition-delay: .15s }\n\n.emoji-mart-skin-swatch.selected {\n  position: relative;\n  width: 16px;\n  padding: 0 2px;\n}\n\n.emoji-mart-skin-swatch.selected:after {\n  content: "";\n  position: absolute;\n  top: 50%; left: 50%;\n  width: 4px; height: 4px;\n  margin: -2px 0 0 -2px;\n  background-color: #fff;\n  border-radius: 100%;\n  pointer-events: none;\n  opacity: 0;\n  transition: opacity .2s ease-out;\n}\n\n.emoji-mart-skin-swatch.custom {\n  display: inline-block;\n  width: 0;\n  height: 38px;\n  overflow: hidden;\n  vertical-align: middle;\n  transition-property: width, height;\n  transition-duration: .125s;\n  transition-timing-function: ease-out;\n  cursor: default;\n}\n\n.emoji-mart-skin-swatch.custom.selected {\n  position: relative;\n  width: 36px;\n  height: 38px;\n  padding: 0 2px 0 0;\n}\n\n.emoji-mart-skin-swatch.custom.selected:after {\n  content: "";\n  width: 0;\n  height: 0;\n}\n\n.emoji-mart-skin-swatches.custom .emoji-mart-skin-swatch.custom:hover {\n  background-color: #f4f4f4;\n  border-radius: 10%;\n}\n\n.emoji-mart-skin-swatches.custom.opened .emoji-mart-skin-swatch.custom {\n  width: 36px;\n  height: 38px;\n  padding: 0 2px 0 0;\n}\n\n.emoji-mart-skin-swatches.custom.opened .emoji-mart-skin-swatch.custom.selected:after {\n  opacity: .75;\n}\n\n.emoji-mart-skin-text.opened {\n  display: inline-block;\n  vertical-align: middle;\n  text-align: left;\n  color: #888;\n  font-size: 11px;\n  padding: 5px 2px;\n  width: 95px;\n  height: 40px;\n  border-radius: 10%;\n  background-color: #fff;\n}\n\n.emoji-mart-skin {\n  display: inline-block;\n  width: 100%;\n  padding-top: 100%;\n  max-width: 12px;\n  border-radius: 100%;\n}\n\n.emoji-mart-skin-tone-1 { background-color: #ffc93a }\n.emoji-mart-skin-tone-2 { background-color: #fadcbc }\n.emoji-mart-skin-tone-3 { background-color: #e0bb95 }\n.emoji-mart-skin-tone-4 { background-color: #bf8f68 }\n.emoji-mart-skin-tone-5 { background-color: #9b643d }\n.emoji-mart-skin-tone-6 { background-color: #594539 }\n\n/* For screenreaders only, via https://stackoverflow.com/a/19758620 */\n.emoji-mart-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n\n/*\n * Dark mode styles\n */\n\n.emoji-mart-dark {\n  color: #fff;\n  border-color: #555453;\n  background-color: #222;\n}\n\n.emoji-mart-dark .emoji-mart-bar {\n  border-color: #555453;\n}\n\n.emoji-mart-dark .emoji-mart-search input {\n  color: #fff;\n  border-color: #555453;\n  background-color: #2f2f2f;\n}\n\n.emoji-mart-dark .emoji-mart-search-icon svg {\n  fill: #fff;\n}\n\n.emoji-mart-dark .emoji-mart-category .emoji-mart-emoji:hover:before {\n  background-color: #444;\n}\n\n.emoji-mart-dark .emoji-mart-category-label span {\n  background-color: #222;\n  color: #fff;\n}\n\n.emoji-mart-dark .emoji-mart-skin-swatches {\n  border-color: #555453;\n  background-color: #222;\n}\n\n.emoji-mart-dark .emoji-mart-anchor:hover,\n.emoji-mart-dark .emoji-mart-anchor:focus,\n.emoji-mart-dark .emoji-mart-anchor-selected {\n  color: #bfbfbf;\n}\n']
    }]);
  }, function (e, i, t) {
    var a = t(296);
    "string" === typeof (a = a.__esModule ? a.default : a) && (a = [[e.i, a, ""]]);
    var n = {
      insert: "head",
      singleton: !1
    };
    t(22)(a, n);
    a.locals && (e.exports = a.locals);
  }, function (e, i, t) {
    (e.exports = t(21)(!0)).push([e.i, ":root {\n  --driftiwyg-secondary: rgb(230, 236, 239);\n  --driftiwyg-tag-purple: #5767e4;\n}\n\n.driftiwyg-slate-editor {\n  border: 1px solid rgb(230, 236, 239);\n  border: 1px solid var(--driftiwyg-secondary);\n  border-radius: 3px;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n  padding: 16px;\n  width: calc(100% - 32px);\n  margin-bottom: 20px;\n  overflow-y: scroll;\n}\n\n.driftiwyg-slate-editor.read-only {\n  background: var(--color-p1-3);\n  color: var(--color-p1-5-5);\n}\n\n.driftiwyg-slate-editor p {\n  margin: 0;\n  line-height: 1.4;\n}\n\n.driftiwyg-slate-editor ol {\n  list-style: decimal;\n}\n\n.driftiwyg-slate-editor ul {\n  list-style: disc;\n}\n\n.driftiwyg-slate-editor-menu {\n  padding: 5px;\n  display: flex;\n  flex-wrap: wrap;\n  background: rgb(230, 236, 239);\n  background: var(--driftiwyg-secondary);\n  border-top-left-radius: 3px;\n  border-top-right-radius: 3px;\n  width: calc(100% - 8px);\n  position: relative;\n}\n\n.driftiwyg-slate-editor img {\n  max-width: 100%;\n}\n\n.driftiwyg-toolbar-button-group-container {\n  display: flex;\n}\n\n/* toolbar button dividers */\n.driftiwyg-toolbar-button-group-container:not(:last-of-type):not(:empty) {\n  border-right: 1px solid var(--main-navy-light);\n}\n\n.driftiwyg-toolbar-popover-button-container {\n  display: flex;\n  max-height: 35px;\n}\n\n.driftiwyg-toolbar-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px;\n  cursor: pointer;\n  background: var(--color-p1-2);\n  transition: background-color 0.3s ease;\n}\n\n.driftiwyg-toolbar-button:hover,\n.driftiwyg-toolbar-button--active {\n  background: var(--main-navy-extra-light);\n}\n\n.toolbar-menu-popover {\n  position: absolute;\n  left: 10px;\n  top: 38px;\n  z-index: 20000;\n  max-width: 304px;\n  min-width: 200px;\n  height: 340px;\n}\n\n.toolbar-menu-popover--emoji .emoji-mart {\n  border: none;\n  box-shadow: 0px 0px 35px rgba(var(--main-navy-dark-a), 0.3);\n}\n\n.toolbar-menu-popover--emoji .emoji-mart-scroll {\n  height: 200px;\n}\n\n.toolbar-menu-popover--emoji .emoji-mart-category-label {\n  font-family: var(--main-font-family--semibold);\n}\n\n.toolbar-menu-popover--emoji .emoji-mart-search-icon {\n  top: 7px;\n}\n\n.toolbar-menu-popover--emoji .emoji-mart-search input {\n  font-size: var(--font-size-subtle);\n  transition: all 0.3s ease;\n}\n\n.toolbar-menu-popover--emoji .emoji-mart-search input:focus {\n  border-color: var(--main-green);\n}\n\n.toolbar-menu-popover--link {\n  bottom: -250px;\n  right: 20px;\n  width: 100%;\n}\n\n.toolbar-menu-popover--link button {\n  margin-top: 10px;\n}\n\n.toolbar-menu-popover-container--link {\n  padding: 16px;\n  width: calc(100% - 32px);\n}\n\n.toolbar-menu-popover-container--link .tide-input,\n.toolbar-menu-popover-container--link .tide-label {\n  width: 100%;\n}\n\n.toolbar-menu-popover--calendar {\n  bottom: -288px;\n  right: 20px;\n  width: 100%;\n}\n\n.toolbar-menu-popover--tag-properties {\n  bottom: -282px;\n  right: 20px;\n  width: 100%;\n  cursor: default;\n}\n\n.toolbar-menu-popover--image {\n  bottom: -257px;\n  right: 20px;\n  width: 100%;\n}\n\n.toolbar-menu-popover--container .toolbar-menu-popover-container--link .link-popover-text-input {\n  margin-bottom: 16px;\n}\n\n.toolbar-menu-popover--container .toolbar-menu-popover-container--link .link-popover-link-input {\n  margin-bottom: 8px;\n}\n\n.toolbar-menu-popover--image .toolbar-menu-popover--container h3 {\n  margin: 10px;\n  color: var(--main-navy-extra-dark);\n}\n\n.toolbar-menu-popover--image .toolbar-menu-popover--container .toolbar-menu-popover--image-container {\n  display: block;\n  padding: 16px;\n}\n\n.toolbar-menu-popover--image .image-uploader {\n  width: calc(100% - 34px);\n}\n\n.toolbar-menu-popover--image .toolbar-menu-popover--image-container .image-popover-alt-text-input {\n  margin-top: 16px;\n  margin-bottom: 16px;\n}\n\n.toolbar-menu-popover--image .image-popover-alt-text-input input {\n  width: 272px;\n}\n\n.toolbar-menu-popover--container {\n  background: var(--color-p1-2);\n  width: 100%;\n  max-width: 304px;\n  border-radius: 3px;\n  border-top: 8px solid var(--color-p1-10);\n  box-shadow: var(--box-shadow-1);\n}\n\n.toolbar-menu-popover--container h3 {\n  margin: 0;\n}\n\n.toolbar-menu-popover--header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px;\n  border-bottom: 1px solid var(--color-p1-4);\n}\n\n.toolbar-menu-popover--header h4 {\n  margin-top: 2px;\n  transition: all 0.3s ease;\n}\n\n.toolbar-menu-popover--header--offset {\n  margin-left: 25px !important;\n}\n\n.toolbar-menu-popover--header a {\n  color: var(--color-p3-6);\n  margin: 0;\n  text-decoration: none;\n}\n\n.toolbar-menu-popover--back-button-container {\n  cursor: pointer;\n  position: absolute;\n  left: 15px;\n}\n\n.toolbar-menu-popover--back-button path {\n  fill: var(--main-navy);\n}\n\n/* need different class names because slate wraps things in two span elements */\n.driftiwyg-tag-property,\n.driftiwyg-tag-property--editor span span {\n  background: var(--color-s4-3);\n  color: var(--color-s4-10);\n  border-radius: 3px;\n  font-size: var(--font-size-subtle);\n}\n\n.driftiwyg-tag-property {\n  padding: 5px 7px;\n}\n\n.driftiwyg-tag-property--editor span span {\n  padding: 3px 7px;\n  margin: 0 2px;\n}\n\n.toolbar-menu-popover--drop-zone {\n  height: 300px;\n  border: 1px dotted var(--main-navy-dark);\n  margin: 10px 0;\n  background: rgb(230, 236, 239);\n  background: var(--driftiwyg-secondary);\n}\n\n.driftiwyg-slate-editor-menu {\n  background: var(--color-p1-2);\n  border: 1px solid var(--main-navy-light);\n  border-bottom: none;\n  box-shadow: 0px 5px 13px -10px;\n  padding: 0px;\n  width: 100%;\n}\n\n.driftiwyg-slate-editor-menu.read-only {\n  background: var(--color-p1-3);\n}\n.driftiwyg-slate-editor-menu.read-only .driftiwyg-toolbar-button {\n  background: var(--color-p1-3);\n}\n\n.driftiwyg-button-type-seperator {\n  border-left: 1px solid var(--main-navy-light);\n}\n\n[contenteditable='true'] {\n  user-select: text;\n  -moz-user-select: text;\n  -ms-user-select: text;\n  -webkit-user-select: text;\n}\n\n.resizable-image {\n  border: 2px solid transparent;\n}\n\n.resizable-image.focused {\n  border-color: var(--color-p3-6);\n}\n\n.driftiwyg-image-upload-error {\n  color: var(--color-s3-6);\n  margin-top: 8px;\n}\n\n.email-body-mode .driftiwyg-slate-editor-menu {\n  border: none;\n  box-shadow: none;\n  border-bottom: 1px solid var(--color-p1-5);\n}\n\n.email-body-mode .driftiwyg-slate-editor {\n  border: none;\n  margin: 0;\n}\n\n.email-body-mode {\n  border: 1px solid var(--color-p1-5);\n  border-radius: 3px;\n}\n", "", {
      version: 3,
      sources: ["styles.css"],
      names: [],
      mappings: "AAAA;EACE,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;EACE,oCAA4C;EAA5C,4CAA4C;EAC5C,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;EAC1B,aAAa;EACb,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,8BAAsC;EAAtC,sCAAsC;EACtC,2BAA2B;EAC3B,4BAA4B;EAC5B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA,4BAA4B;AAC5B;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,2DAA2D;AAC7D;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,wBAAwB;AAC1B;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA,+EAA+E;AAC/E;;EAEE,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,cAAc;EACd,8BAAsC;EAAtC,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;EAC7B,wCAAwC;EACxC,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;AACpB",
      file: "styles.css",
      sourcesContent: [":root {\n  --driftiwyg-secondary: rgb(230, 236, 239);\n  --driftiwyg-tag-purple: #5767e4;\n}\n\n.driftiwyg-slate-editor {\n  border: 1px solid var(--driftiwyg-secondary);\n  border-radius: 3px;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n  padding: 16px;\n  width: calc(100% - 32px);\n  margin-bottom: 20px;\n  overflow-y: scroll;\n}\n\n.driftiwyg-slate-editor.read-only {\n  background: var(--color-p1-3);\n  color: var(--color-p1-5-5);\n}\n\n.driftiwyg-slate-editor p {\n  margin: 0;\n  line-height: 1.4;\n}\n\n.driftiwyg-slate-editor ol {\n  list-style: decimal;\n}\n\n.driftiwyg-slate-editor ul {\n  list-style: disc;\n}\n\n.driftiwyg-slate-editor-menu {\n  padding: 5px;\n  display: flex;\n  flex-wrap: wrap;\n  background: var(--driftiwyg-secondary);\n  border-top-left-radius: 3px;\n  border-top-right-radius: 3px;\n  width: calc(100% - 8px);\n  position: relative;\n}\n\n.driftiwyg-slate-editor img {\n  max-width: 100%;\n}\n\n.driftiwyg-toolbar-button-group-container {\n  display: flex;\n}\n\n/* toolbar button dividers */\n.driftiwyg-toolbar-button-group-container:not(:last-of-type):not(:empty) {\n  border-right: 1px solid var(--main-navy-light);\n}\n\n.driftiwyg-toolbar-popover-button-container {\n  display: flex;\n  max-height: 35px;\n}\n\n.driftiwyg-toolbar-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px;\n  cursor: pointer;\n  background: var(--color-p1-2);\n  transition: background-color 0.3s ease;\n}\n\n.driftiwyg-toolbar-button:hover,\n.driftiwyg-toolbar-button--active {\n  background: var(--main-navy-extra-light);\n}\n\n.toolbar-menu-popover {\n  position: absolute;\n  left: 10px;\n  top: 38px;\n  z-index: 20000;\n  max-width: 304px;\n  min-width: 200px;\n  height: 340px;\n}\n\n.toolbar-menu-popover--emoji .emoji-mart {\n  border: none;\n  box-shadow: 0px 0px 35px rgba(var(--main-navy-dark-a), 0.3);\n}\n\n.toolbar-menu-popover--emoji .emoji-mart-scroll {\n  height: 200px;\n}\n\n.toolbar-menu-popover--emoji .emoji-mart-category-label {\n  font-family: var(--main-font-family--semibold);\n}\n\n.toolbar-menu-popover--emoji .emoji-mart-search-icon {\n  top: 7px;\n}\n\n.toolbar-menu-popover--emoji .emoji-mart-search input {\n  font-size: var(--font-size-subtle);\n  transition: all 0.3s ease;\n}\n\n.toolbar-menu-popover--emoji .emoji-mart-search input:focus {\n  border-color: var(--main-green);\n}\n\n.toolbar-menu-popover--link {\n  bottom: -250px;\n  right: 20px;\n  width: 100%;\n}\n\n.toolbar-menu-popover--link button {\n  margin-top: 10px;\n}\n\n.toolbar-menu-popover-container--link {\n  padding: 16px;\n  width: calc(100% - 32px);\n}\n\n.toolbar-menu-popover-container--link .tide-input,\n.toolbar-menu-popover-container--link .tide-label {\n  width: 100%;\n}\n\n.toolbar-menu-popover--calendar {\n  bottom: -288px;\n  right: 20px;\n  width: 100%;\n}\n\n.toolbar-menu-popover--tag-properties {\n  bottom: -282px;\n  right: 20px;\n  width: 100%;\n  cursor: default;\n}\n\n.toolbar-menu-popover--image {\n  bottom: -257px;\n  right: 20px;\n  width: 100%;\n}\n\n.toolbar-menu-popover--container .toolbar-menu-popover-container--link .link-popover-text-input {\n  margin-bottom: 16px;\n}\n\n.toolbar-menu-popover--container .toolbar-menu-popover-container--link .link-popover-link-input {\n  margin-bottom: 8px;\n}\n\n.toolbar-menu-popover--image .toolbar-menu-popover--container h3 {\n  margin: 10px;\n  color: var(--main-navy-extra-dark);\n}\n\n.toolbar-menu-popover--image .toolbar-menu-popover--container .toolbar-menu-popover--image-container {\n  display: block;\n  padding: 16px;\n}\n\n.toolbar-menu-popover--image .image-uploader {\n  width: calc(100% - 34px);\n}\n\n.toolbar-menu-popover--image .toolbar-menu-popover--image-container .image-popover-alt-text-input {\n  margin-top: 16px;\n  margin-bottom: 16px;\n}\n\n.toolbar-menu-popover--image .image-popover-alt-text-input input {\n  width: 272px;\n}\n\n.toolbar-menu-popover--container {\n  background: var(--color-p1-2);\n  width: 100%;\n  max-width: 304px;\n  border-radius: 3px;\n  border-top: 8px solid var(--color-p1-10);\n  box-shadow: var(--box-shadow-1);\n}\n\n.toolbar-menu-popover--container h3 {\n  margin: 0;\n}\n\n.toolbar-menu-popover--header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px;\n  border-bottom: 1px solid var(--color-p1-4);\n}\n\n.toolbar-menu-popover--header h4 {\n  margin-top: 2px;\n  transition: all 0.3s ease;\n}\n\n.toolbar-menu-popover--header--offset {\n  margin-left: 25px !important;\n}\n\n.toolbar-menu-popover--header a {\n  color: var(--color-p3-6);\n  margin: 0;\n  text-decoration: none;\n}\n\n.toolbar-menu-popover--back-button-container {\n  cursor: pointer;\n  position: absolute;\n  left: 15px;\n}\n\n.toolbar-menu-popover--back-button path {\n  fill: var(--main-navy);\n}\n\n/* need different class names because slate wraps things in two span elements */\n.driftiwyg-tag-property,\n.driftiwyg-tag-property--editor span span {\n  background: var(--color-s4-3);\n  color: var(--color-s4-10);\n  border-radius: 3px;\n  font-size: var(--font-size-subtle);\n}\n\n.driftiwyg-tag-property {\n  padding: 5px 7px;\n}\n\n.driftiwyg-tag-property--editor span span {\n  padding: 3px 7px;\n  margin: 0 2px;\n}\n\n.toolbar-menu-popover--drop-zone {\n  height: 300px;\n  border: 1px dotted var(--main-navy-dark);\n  margin: 10px 0;\n  background: var(--driftiwyg-secondary);\n}\n\n.driftiwyg-slate-editor-menu {\n  background: var(--color-p1-2);\n  border: 1px solid var(--main-navy-light);\n  border-bottom: none;\n  box-shadow: 0px 5px 13px -10px;\n  padding: 0px;\n  width: 100%;\n}\n\n.driftiwyg-slate-editor-menu.read-only {\n  background: var(--color-p1-3);\n}\n.driftiwyg-slate-editor-menu.read-only .driftiwyg-toolbar-button {\n  background: var(--color-p1-3);\n}\n\n.driftiwyg-button-type-seperator {\n  border-left: 1px solid var(--main-navy-light);\n}\n\n[contenteditable='true'] {\n  user-select: text;\n  -moz-user-select: text;\n  -ms-user-select: text;\n  -webkit-user-select: text;\n}\n\n.resizable-image {\n  border: 2px solid transparent;\n}\n\n.resizable-image.focused {\n  border-color: var(--color-p3-6);\n}\n\n.driftiwyg-image-upload-error {\n  color: var(--color-s3-6);\n  margin-top: 8px;\n}\n\n.email-body-mode .driftiwyg-slate-editor-menu {\n  border: none;\n  box-shadow: none;\n  border-bottom: 1px solid var(--color-p1-5);\n}\n\n.email-body-mode .driftiwyg-slate-editor {\n  border: none;\n  margin: 0;\n}\n\n.email-body-mode {\n  border: 1px solid var(--color-p1-5);\n  border-radius: 3px;\n}\n"]
    }]);
  }, function (e, i, t) {
    var a = t(298);
    "string" === typeof (a = a.__esModule ? a.default : a) && (a = [[e.i, a, ""]]);
    var n = {
      insert: "head",
      singleton: !1
    };
    t(22)(a, n);
    a.locals && (e.exports = a.locals);
  }, function (e, i, t) {
    (e.exports = t(21)(!0)).push([e.i, ".image-resize-input input {\n  width: 60px;\n  margin: 0 4px;\n}\n\n.width-input-unit {\n  margin-right: 16px;\n}\n\n.image-resize-input {\n  position: relative;\n  top: 0px;\n}\n\n.alt-text-input input {\n  width: 272px;\n}\n\n.alt-text-input p {\n  margin: 0px;\n}\n\n.alt-text-input {\n  margin-top: 16px;\n}\n\n.resizable-inputs-wrapper {\n  position: fixed;\n  padding: 16px 16px 8px 16px;\n  background: var(--color-p1-2);\n  box-shadow: var(--box-shadow-1);\n  border-radius: 3px;\n  width: 272px;\n  margin-top: 4px;\n  z-index: 3;\n}\n\n.resizable-inputs-wrapper-row {\n  display: flex;\n  align-items: baseline;\n}\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,6BAA6B;EAC7B,+BAA+B;EAC/B,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB",
      file: "style.css",
      sourcesContent: [".image-resize-input input {\n  width: 60px;\n  margin: 0 4px;\n}\n\n.width-input-unit {\n  margin-right: 16px;\n}\n\n.image-resize-input {\n  position: relative;\n  top: 0px;\n}\n\n.alt-text-input input {\n  width: 272px;\n}\n\n.alt-text-input p {\n  margin: 0px;\n}\n\n.alt-text-input {\n  margin-top: 16px;\n}\n\n.resizable-inputs-wrapper {\n  position: fixed;\n  padding: 16px 16px 8px 16px;\n  background: var(--color-p1-2);\n  box-shadow: var(--box-shadow-1);\n  border-radius: 3px;\n  width: 272px;\n  margin-top: 4px;\n  z-index: 3;\n}\n\n.resizable-inputs-wrapper-row {\n  display: flex;\n  align-items: baseline;\n}\n"]
    }]);
  }, function (e, i, t) {
    "use strict";

    var _Zo;
    t.r(i);
    var a = {};
    t.r(a), t.d(a, "categories", function () {
      return _o;
    }), t.d(a, "search", function () {
      return lo;
    });
    var n = t(0),
      o = t.n(n),
      r = t(7),
      s = t.n(r),
      _ = t(11),
      l = t.n(_),
      g = t(1),
      f = t.n(g),
      h = t(4),
      d = t.n(h),
      m = t(2);
    var u = function warning(e) {
        var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
        if (!e) {
          var t = console.warn || console.log;
          t("Warning: " + i);
        }
      },
      c = t(74),
      F = t(75),
      p = t.n(F),
      b = t(26),
      y = t.n(b),
      k = t(27),
      v = t.n(k),
      w = t(118),
      E = t.n(w),
      A = void 0,
      j = void 0;
    function resetGenerator() {
      A = 0, j = function generate() {
        return "" + A++;
      };
    }
    resetGenerator();
    var x = {
        create: function slate_es_create(e) {
          if (null == e) return j();
          if ("string" === typeof e) return e;
          throw new Error("Keys must be strings, but you passed: " + e);
        },
        setGenerator: function setGenerator(e) {
          j = e;
        },
        resetGenerator: resetGenerator
      },
      C = "function" === typeof Symbol && "symbol" === typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" === typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      },
      D = function classCallCheck(e, i) {
        if (!(e instanceof i)) throw new TypeError("Cannot call a class as a function");
      },
      B = function () {
        function defineProperties(e, i) {
          for (var t = 0; t < i.length; t++) {
            var a = i[t];
            a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
          }
        }
        return function (e, i, t) {
          return i && defineProperties(e.prototype, i), t && defineProperties(e, t), e;
        };
      }(),
      S = Object.assign || function (e) {
        for (var i = 1; i < arguments.length; i++) {
          var t = arguments[i];
          for (var a in t) {
            Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
          }
        }
        return e;
      },
      q = function inherits(e, i) {
        if ("function" !== typeof i && null !== i) throw new TypeError("Super expression must either be null or a function, not " + typeof i);
        e.prototype = Object.create(i && i.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), i && (Object.setPrototypeOf ? Object.setPrototypeOf(e, i) : e.__proto__ = i);
      },
      O = function objectWithoutProperties(e, i) {
        var t = {};
        for (var a in e) {
          i.indexOf(a) >= 0 || Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
        }
        return t;
      },
      T = function possibleConstructorReturn(e, i) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !i || "object" !== typeof i && "function" !== typeof i ? e : i;
      },
      N = function () {
        return function (e, i) {
          if (Array.isArray(e)) return e;
          if (Symbol.iterator in Object(e)) return function sliceIterator(e, i) {
            var t = [],
              a = !0,
              n = !1,
              o = void 0;
            try {
              for (var r, s = e[Symbol.iterator](); !(a = (r = s.next()).done) && (t.push(r.value), !i || t.length !== i); a = !0) {
                ;
              }
            } catch (_) {
              n = !0, o = _;
            } finally {
              try {
                !a && s.return && s.return();
              } finally {
                if (n) throw o;
              }
            }
            return t;
          }(e, i);
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
      }(),
      I = function toConsumableArray(e) {
        if (Array.isArray(e)) {
          for (var i = 0, t = Array(e.length); i < e.length; i++) {
            t[i] = e[i];
          }
          return t;
        }
        return Array.from(e);
      },
      P = function () {
        function Data() {
          D(this, Data);
        }
        return B(Data, null, [{
          key: "create",
          value: function create() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            if (m.Map.isMap(e)) return e;
            if (d()(e)) return Data.fromJSON(e);
            throw new Error("`Data.create` only accepts objects or maps, but you passed it: " + e);
          }
        }, {
          key: "fromJSON",
          value: function fromJSON(e) {
            return new m.Map(e);
          }
        }]), Data;
      }();
    P.fromJS = P.fromJSON;
    var M = {
        data: void 0,
        key: void 0,
        nodes: void 0
      },
      R = function (e) {
        function Document() {
          return D(this, Document), T(this, (Document.__proto__ || Object.getPrototypeOf(Document)).apply(this, arguments));
        }
        return q(Document, e), B(Document, [{
          key: "toJSON",
          value: function toJSON() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              i = {
                object: this.object,
                data: this.data.toJSON(),
                nodes: this.nodes.toArray().map(function (i) {
                  return i.toJSON(e);
                })
              };
            return e.preserveKeys && (i.key = this.key), i;
          }
        }], [{
          key: "create",
          value: function create() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            if (Document.isDocument(e)) return e;
            if ((m.List.isList(e) || Array.isArray(e)) && (e = {
              nodes: e
            }), d()(e)) return Document.fromJSON(e);
            throw new Error("`Document.create` only accepts objects, arrays, lists or documents, but you passed it: " + e);
          }
        }, {
          key: "fromJSON",
          value: function fromJSON(e) {
            if (Document.isDocument(e)) return e;
            var i = e.data,
              t = void 0 === i ? {} : i,
              a = e.key,
              n = void 0 === a ? x.create() : a,
              o = e.nodes,
              r = void 0 === o ? [] : o;
            return new Document({
              key: n,
              data: new m.Map(t),
              nodes: Q.createList(r)
            });
          }
        }]), Document;
      }(Object(m.Record)(M)),
      z = {
        data: void 0,
        key: void 0,
        nodes: void 0,
        type: void 0
      },
      L = function (e) {
        function Inline() {
          return D(this, Inline), T(this, (Inline.__proto__ || Object.getPrototypeOf(Inline)).apply(this, arguments));
        }
        return q(Inline, e), B(Inline, [{
          key: "toJSON",
          value: function toJSON() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              i = {
                object: this.object,
                type: this.type,
                data: this.data.toJSON(),
                nodes: this.nodes.toArray().map(function (i) {
                  return i.toJSON(e);
                })
              };
            return e.preserveKeys && (i.key = this.key), i;
          }
        }], [{
          key: "create",
          value: function create() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            if (Inline.isInline(e)) return e;
            if ("string" == typeof e && (e = {
              type: e
            }), d()(e)) return Inline.fromJSON(e);
            throw new Error("`Inline.create` only accepts objects, strings or inlines, but you passed it: " + e);
          }
        }, {
          key: "createList",
          value: function createList() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
            if (m.List.isList(e) || Array.isArray(e)) return new m.List(e.map(Inline.create));
            throw new Error("`Inline.createList` only accepts arrays or lists, but you passed it: " + e);
          }
        }, {
          key: "fromJSON",
          value: function fromJSON(e) {
            if (Inline.isInline(e)) return e;
            var i = e.data,
              t = void 0 === i ? {} : i,
              a = e.key,
              n = void 0 === a ? x.create() : a,
              o = e.nodes,
              r = void 0 === o ? [] : o,
              s = e.type;
            if ("string" != typeof s) throw new Error("`Inline.fromJS` requires a `type` string.");
            return new Inline({
              key: n,
              type: s,
              data: new m.Map(t),
              nodes: Q.createList(r)
            });
          }
        }, {
          key: "isInlineList",
          value: function isInlineList(e) {
            return m.List.isList(e) && e.every(function (e) {
              return Inline.isInline(e);
            });
          }
        }]), Inline;
      }(Object(m.Record)(z)),
      W = {
        data: void 0,
        type: void 0
      },
      U = function (e) {
        function Mark() {
          return D(this, Mark), T(this, (Mark.__proto__ || Object.getPrototypeOf(Mark)).apply(this, arguments));
        }
        return q(Mark, e), B(Mark, [{
          key: "toJSON",
          value: function toJSON() {
            return {
              object: this.object,
              type: this.type,
              data: this.data.toJSON()
            };
          }
        }], [{
          key: "create",
          value: function create() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            if (Mark.isMark(e)) return e;
            if ("string" == typeof e && (e = {
              type: e
            }), d()(e)) return Mark.fromJSON(e);
            throw new Error("`Mark.create` only accepts objects, strings or marks, but you passed it: " + e);
          }
        }, {
          key: "createSet",
          value: function createSet(e) {
            if (m.Set.isSet(e) || Array.isArray(e)) return new m.Set(e.map(Mark.create));
            if (null == e) return Object(m.Set)();
            throw new Error("`Mark.createSet` only accepts sets, arrays or null, but you passed it: " + e);
          }
        }, {
          key: "createProperties",
          value: function createProperties() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            if (Mark.isMark(e)) return {
              data: e.data,
              type: e.type
            };
            if ("string" == typeof e) return {
              type: e
            };
            if (d()(e)) {
              var i = {};
              return "type" in e && (i.type = e.type), "data" in e && (i.data = P.create(e.data)), i;
            }
            throw new Error("`Mark.createProperties` only accepts objects, strings or marks, but you passed it: " + e);
          }
        }, {
          key: "fromJSON",
          value: function fromJSON(e) {
            var i = e.data,
              t = void 0 === i ? {} : i,
              a = e.type;
            if ("string" != typeof a) throw new Error("`Mark.fromJS` requires a `type` string.");
            return new Mark({
              type: a,
              data: new m.Map(t)
            });
          }
        }, {
          key: "isMarkSet",
          value: function isMarkSet(e) {
            return m.Set.isSet(e) && e.every(function (e) {
              return Mark.isMark(e);
            });
          }
        }]), Mark;
      }(Object(m.Record)(W)),
      K = {
        marks: void 0,
        text: void 0
      },
      H = function (e) {
        function Leaf() {
          return D(this, Leaf), T(this, (Leaf.__proto__ || Object.getPrototypeOf(Leaf)).apply(this, arguments));
        }
        return q(Leaf, e), B(Leaf, [{
          key: "updateMark",
          value: function updateMark(e, i) {
            var t = this.marks;
            if (i.equals(e)) return this;
            if (!t.has(e)) return this;
            var a = t.withMutations(function (t) {
              t.remove(e).add(i);
            });
            return this.set("marks", a);
          }
        }, {
          key: "addMark",
          value: function addMark(e) {
            var i = this.marks;
            return this.set("marks", i.add(e));
          }
        }, {
          key: "addMarks",
          value: function addMarks(e) {
            var i = this.marks;
            return this.set("marks", i.union(e));
          }
        }, {
          key: "removeMark",
          value: function removeMark(e) {
            var i = this.marks;
            return this.set("marks", i.remove(e));
          }
        }, {
          key: "toJSON",
          value: function toJSON() {
            return {
              object: this.object,
              text: this.text,
              marks: this.marks.toArray().map(function (e) {
                return e.toJSON();
              })
            };
          }
        }], [{
          key: "create",
          value: function create() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            if (Leaf.isLeaf(e)) return e;
            if ("string" == typeof e && (e = {
              text: e
            }), d()(e)) return Leaf.fromJSON(e);
            throw new Error("`Leaf.create` only accepts objects, strings or leaves, but you passed it: " + e);
          }
        }, {
          key: "createLeaves",
          value: function createLeaves(e) {
            if (e.size <= 1) return e;
            var i = !1,
              t = Object(m.List)().withMutations(function (t) {
                e.findLast(function (e, a) {
                  var n = t.first();
                  if (n) {
                    if (n.marks.equals(e.marks)) return i = !0, void t.set(0, n.set("text", "" + e.text + n.text));
                    if ("" === n.text) return i = !0, void t.set(0, e);
                    if ("" === e.text) return void (i = !0);
                  }
                  t.unshift(e);
                });
              });
            return i ? t : e;
          }
        }, {
          key: "splitLeaves",
          value: function splitLeaves(e, i) {
            if (i < 0) return [Object(m.List)(), e];
            if (0 === e.size) return [Object(m.List)(), Object(m.List)()];
            var t = 0,
              a = -1,
              n = void 0,
              o = void 0;
            return e.find(function (e) {
              a++;
              var r = t,
                s = e.text;
              if ((t += s.length) < i) return !1;
              if (r > i) return !1;
              var _ = i - r;
              return n = e.set("text", s.slice(0, _)), o = e.set("text", s.slice(_)), !0;
            }), n ? "" === n.text ? 0 === a ? [m.List.of(n), e] : [e.take(a), e.skip(a)] : "" === o.text ? a === e.size - 1 ? [e, m.List.of(o)] : [e.take(a + 1), e.skip(a + 1)] : [e.take(a).push(n), e.skip(a + 1).unshift(o)] : [e, Object(m.List)()];
          }
        }, {
          key: "createList",
          value: function createList() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
            if (m.List.isList(e) || Array.isArray(e)) return new m.List(e.map(Leaf.create));
            throw new Error("`Leaf.createList` only accepts arrays or lists, but you passed it: " + e);
          }
        }, {
          key: "fromJSON",
          value: function fromJSON(e) {
            var i = e.text,
              t = void 0 === i ? "" : i,
              a = e.marks,
              n = void 0 === a ? [] : a;
            return new Leaf({
              text: t,
              marks: Object(m.Set)(n.map(U.fromJSON))
            });
          }
        }, {
          key: "isLeafList",
          value: function isLeafList(e) {
            return m.List.isList(e) && e.every(function (e) {
              return Leaf.isLeaf(e);
            });
          }
        }]), Leaf;
      }(Object(m.Record)(K)),
      V = !0,
      J = 0,
      $ = {},
      G = {},
      Y = void 0;
    function memoize(e, i) {
      var t = function _loop(i) {
          var t = e[i];
          if (!t) throw new Error('Object does not have a property named "' + i + '".');
          e[i] = function () {
            for (var e = arguments.length, a = Array(e), n = 0; n < e; n++) {
              a[n] = arguments[n];
            }
            if (!V) return t.apply(this, a);
            J !== this.__cache_key && (this.__cache_key = J, this.__cache = new Map(), this.__cache_no_args = {}), this.__cache || (this.__cache = new Map()), this.__cache_no_args || (this.__cache_no_args = {});
            var o = 0 !== a.length,
              r = void 0,
              s = void 0;
            if (o ? (s = [i].concat(a), r = function getIn(e, i) {
              var t = !0,
                a = !1,
                n = void 0;
              try {
                for (var o, r = i[Symbol.iterator](); !(t = (o = r.next()).done); t = !0) {
                  var s = o.value;
                  if ((e = e.get(s)) === Y) return Y;
                }
              } catch (_) {
                a = !0, n = _;
              } finally {
                try {
                  !t && r.return && r.return();
                } finally {
                  if (a) throw n;
                }
              }
              return e.get($);
            }(this.__cache, s)) : r = this.__cache_no_args[i], r !== Y) return r === G ? void 0 : r;
            var _ = t.apply(this, a),
              l = void 0 === _ ? G : _;
            return o ? this.__cache = function setIn(e, i, t) {
              var a = e,
                n = void 0,
                o = !0,
                r = !1,
                s = void 0;
              try {
                for (var _, l = i[Symbol.iterator](); !(o = (_ = l.next()).done); o = !0) {
                  var g = _.value;
                  (n = a.get(g)) === Y && (n = new Map(), a.set(g, n)), a = n;
                }
              } catch (f) {
                r = !0, s = f;
              } finally {
                try {
                  !o && l.return && l.return();
                } finally {
                  if (r) throw s;
                }
              }
              return n.set($, t), e;
            }(this.__cache, s, l) : this.__cache_no_args[i] = l, _;
          };
        },
        a = !0,
        n = !1,
        o = void 0;
      try {
        for (var r, s = i[Symbol.iterator](); !(a = (r = s.next()).done); a = !0) {
          t(r.value);
        }
      } catch (_) {
        n = !0, o = _;
      } finally {
        try {
          !a && s.return && s.return();
        } finally {
          if (n) throw o;
        }
      }
    }
    var X = {
        leaves: void 0,
        key: void 0
      },
      Z = function (e) {
        function Text() {
          return D(this, Text), T(this, (Text.__proto__ || Object.getPrototypeOf(Text)).apply(this, arguments));
        }
        return q(Text, e), B(Text, [{
          key: "searchLeafAtOffset",
          value: function searchLeafAtOffset(e) {
            var i = 0,
              t = 0,
              a = -1;
            return {
              leaf: this.leaves.find(function (n) {
                return a++, (i = (t = i) + n.text.length) >= e;
              }),
              endOffset: i,
              index: a,
              startOffset: t
            };
          }
        }, {
          key: "addMark",
          value: function addMark(e, i, t) {
            var a = m.Set.of(t);
            return this.addMarks(e, i, a);
          }
        }, {
          key: "addMarks",
          value: function addMarks(e, i, t) {
            if ("" === this.text && 0 === i && 0 === e) {
              var a = this.leaves.first();
              if (!a) return this.set("leaves", m.List.of(H.fromJSON({
                text: "",
                marks: t
              })));
              var n = a.addMarks(t);
              return n === a ? this : this.set("leaves", m.List.of(n));
            }
            if ("" === this.text) return this;
            if (0 === i) return this;
            if (e >= this.text.length) return this;
            var o = H.splitLeaves(this.leaves, e),
              r = N(o, 2),
              s = r[0],
              _ = r[1],
              l = H.splitLeaves(_, i),
              g = N(l, 2),
              f = g[0],
              h = g[1],
              d = s.concat(f.map(function (e) {
                return e.addMarks(t);
              }), h);
            return this.setLeaves(d);
          }
        }, {
          key: "getLeaves",
          value: function getLeaves() {
            var e = this,
              i = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
              t = this.leaves;
            if (0 === t.size) return m.List.of(H.create({}));
            if (!i || 0 === i.length) return t;
            if (0 === this.text.length) return t;
            var a = this.key;
            return i.forEach(function (i) {
              var n = i.start,
                o = i.end,
                r = i.mark,
                s = n.key == a,
                _ = o.key == a;
              if (s && _) {
                var l = s ? n.offset : 0,
                  g = _ ? o.offset - l : e.text.length - l;
                if (g < 1) return;
                if (l >= e.text.length) return;
                if (0 !== l || g < e.text.length) {
                  var f = H.splitLeaves(t, l),
                    h = N(f, 2),
                    d = h[0],
                    m = h[1],
                    u = H.splitLeaves(m, g),
                    c = N(u, 2),
                    F = c[0],
                    p = c[1];
                  return void (t = d.concat(F.map(function (e) {
                    return e.addMark(r);
                  }), p));
                }
              }
              t = t.map(function (e) {
                return e.addMark(r);
              });
            }), t === this.leaves ? t : H.createLeaves(t);
          }
        }, {
          key: "getActiveMarksBetweenOffsets",
          value: function getActiveMarksBetweenOffsets(e, i) {
            if (e <= 0 && i >= this.text.length) return this.getActiveMarks();
            if (e >= i) return Object(m.Set)();
            if ("" === this.text) return this.getActiveMarks();
            var t = null,
              a = 0;
            return this.leaves.forEach(function (n) {
              var o = a;
              if (!((a = o + n.text.length) <= e)) {
                if (o >= i) return !1;
                if (t) return (t = t.intersect(n.marks)) && t.size, !1;
                t = n.marks;
              }
            }), t || Object(m.Set)();
          }
        }, {
          key: "getActiveMarks",
          value: function getActiveMarks() {
            var e = this;
            if (0 === this.leaves.size) return Object(m.Set)();
            var i = this.leaves.first().marks;
            return 0 === i.size ? i : i.toOrderedSet().withMutations(function (i) {
              e.leaves.forEach(function (e) {
                if (i.intersect(e.marks), 0 === i.size) return !1;
              });
            });
          }
        }, {
          key: "getMarksBetweenOffsets",
          value: function getMarksBetweenOffsets(e, i) {
            if (e <= 0 && i >= this.text.length) return this.getMarks();
            if (e >= i) return Object(m.Set)();
            if ("" === this.text) return this.getActiveMarks();
            var t = null,
              a = 0;
            return this.leaves.forEach(function (n) {
              var o = a;
              if (!((a = o + n.text.length) <= e)) return !(o >= i) && void (t = t ? t.union(n.marks) : n.marks);
            }), t || Object(m.Set)();
          }
        }, {
          key: "getMarks",
          value: function getMarks() {
            var e = this.getMarksAsArray();
            return new m.OrderedSet(e);
          }
        }, {
          key: "getMarksAsArray",
          value: function getMarksAsArray() {
            if (0 === this.leaves.size) return [];
            var e = this.leaves.first().marks;
            if (1 === this.leaves.size) return e.toArray();
            var i = [];
            return this.leaves.forEach(function (e) {
              i.push(e.marks.toArray());
            }), Array.prototype.concat.apply(e.toArray(), i);
          }
        }, {
          key: "getMarksAtIndex",
          value: function getMarksAtIndex(e) {
            var i = this.searchLeafAtOffset(e).leaf;
            return i ? i.marks : Object(m.Set)();
          }
        }, {
          key: "insertText",
          value: function insertText(e, i, t) {
            if ("" === this.text) return this.set("leaves", m.List.of(H.create({
              text: i,
              marks: t
            })));
            if (0 === i.length) return this;
            t || (t = Object(m.Set)());
            var a = this.searchLeafAtOffset(e),
              n = a.startOffset,
              o = a.leaf,
              r = a.index,
              s = e - n,
              _ = o.text.slice(0, s),
              l = o.text.slice(s),
              g = this.leaves;
            if (o.marks.equals(t)) return this.set("leaves", g.set(r, o.set("text", _ + i + l)));
            var f = g.splice(r, 1, o.set("text", _), H.create({
              text: i,
              marks: t
            }), o.set("text", l));
            return this.setLeaves(f);
          }
        }, {
          key: "removeMark",
          value: function removeMark(e, i, t) {
            if ("" === this.text && 0 === e && 0 === i) {
              var a = this.leaves.first();
              if (!a) return this;
              var n = a.removeMark(t);
              return n === a ? this : this.set("leaves", m.List.of(n));
            }
            if (i <= 0) return this;
            if (e >= this.text.length) return this;
            var o = H.splitLeaves(this.leaves, e),
              r = N(o, 2),
              s = r[0],
              _ = r[1],
              l = H.splitLeaves(_, i),
              g = N(l, 2),
              f = g[0],
              h = g[1],
              d = s.concat(f.map(function (e) {
                return e.removeMark(t);
              }), h);
            return this.setLeaves(d);
          }
        }, {
          key: "removeText",
          value: function removeText(e, i) {
            if (i <= 0) return this;
            if (e >= this.text.length) return this;
            if (1 === i) {
              var t = this.searchLeafAtOffset(e + 1),
                a = t.leaf,
                n = t.index,
                o = e - t.startOffset;
              if (a) {
                if (1 === a.text.length) {
                  var r = this.leaves.remove(n);
                  return this.setLeaves(r);
                }
                var s = a.text.slice(0, o) + a.text.slice(o + i);
                if (s.length > 0) return this.set("leaves", this.leaves.set(n, a.set("text", s)));
              }
            }
            var _ = H.splitLeaves(this.leaves, e),
              l = N(_, 2),
              g = l[0],
              f = l[1],
              h = H.splitLeaves(f, i)[1],
              d = H.createLeaves(g.concat(h));
            if (1 === d.size) {
              var u = d.first();
              if ("" === u.text) return this.set("leaves", m.List.of(u.set("marks", this.getActiveMarks())));
            }
            return this.set("leaves", d);
          }
        }, {
          key: "toJSON",
          value: function toJSON() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              i = {
                object: this.object,
                leaves: this.getLeaves().toArray().map(function (e) {
                  return e.toJSON();
                })
              };
            return e.preserveKeys && (i.key = this.key), i;
          }
        }, {
          key: "updateMark",
          value: function updateMark(e, i, t, a) {
            var n = t.merge(a);
            if ("" === this.text && 0 === i && 0 === e) {
              var o = this.leaves.first();
              if (!o) return this;
              var r = o.updateMark(t, n);
              return r === o ? this : this.set("leaves", m.List.of(r));
            }
            if (i <= 0) return this;
            if (e >= this.text.length) return this;
            var s = H.splitLeaves(this.leaves, e),
              _ = N(s, 2),
              l = _[0],
              g = _[1],
              f = H.splitLeaves(g, i),
              h = N(f, 2),
              d = h[0],
              u = h[1],
              c = l.concat(d.map(function (e) {
                return e.updateMark(t, n);
              }), u);
            return this.setLeaves(c);
          }
        }, {
          key: "splitText",
          value: function splitText(e) {
            var i = H.splitLeaves(this.leaves, e);
            return [this.set("leaves", i[0]), this.set("leaves", i[1]).regenerateKey()];
          }
        }, {
          key: "mergeText",
          value: function mergeText(e) {
            var i = this.leaves.concat(e.leaves);
            return this.setLeaves(i);
          }
        }, {
          key: "setLeaves",
          value: function setLeaves(e) {
            var i = H.createLeaves(e);
            if (1 === i.size) {
              var t = i.first();
              if ((!t.marks || 0 === t.marks.size) && "" === t.text) return this.set("leaves", Object(m.List)());
            }
            return this.set("leaves", H.createLeaves(e));
          }
        }], [{
          key: "create",
          value: function create() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
            if (Text.isText(e)) return e;
            if ("string" == typeof e && (e = {
              leaves: [{
                text: e
              }]
            }), d()(e)) {
              if (e.text) {
                var i = e,
                  t = i.text,
                  a = i.marks;
                e = {
                  key: i.key,
                  leaves: [{
                    text: t,
                    marks: a
                  }]
                };
              }
              return Text.fromJSON(e);
            }
            throw new Error("`Text.create` only accepts objects, arrays, strings or texts, but you passed it: " + e);
          }
        }, {
          key: "createList",
          value: function createList() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
            if (m.List.isList(e) || Array.isArray(e)) return new m.List(e.map(Text.create));
            throw new Error("`Text.createList` only accepts arrays or lists, but you passed it: " + e);
          }
        }, {
          key: "fromJSON",
          value: function fromJSON(e) {
            if (Text.isText(e)) return e;
            var i = e.key,
              t = void 0 === i ? x.create() : i,
              a = e.leaves;
            if (a || (e.ranges ? (u(!1, "As of slate@0.27.0, the `ranges` property of Slate objects has been renamed to `leaves`."), a = e.ranges) : a = Object(m.List)()), Array.isArray(a)) a = Object(m.List)(a.map(function (e) {
              return H.create(e);
            }));else {
              if (!m.List.isList(a)) throw new Error("leaves must be either Array or Immutable.List");
              a = a.map(function (e) {
                return H.create(e);
              });
            }
            return new Text({
              leaves: H.createLeaves(a),
              key: t
            });
          }
        }, {
          key: "isTextList",
          value: function isTextList(e) {
            return m.List.isList(e) && e.every(function (e) {
              return Text.isText(e);
            });
          }
        }]), Text;
      }(Object(m.Record)(X));
    memoize(Z.prototype, ["getActiveMarks", "getMarks", "getMarksAsArray"]);
    var Q = function () {
        function Node() {
          D(this, Node);
        }
        return B(Node, null, [{
          key: "create",
          value: function create() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            if (Node.isNode(e)) return e;
            if (d()(e)) {
              var i = e.object;
              switch (!i && e.kind && (u(!1, "As of slate@0.32.0, the `kind` property of Slate objects has been renamed to `object`."), i = e.kind), i) {
                case "block":
                  return ie.create(e);
                case "document":
                  return R.create(e);
                case "inline":
                  return L.create(e);
                case "text":
                  return Z.create(e);
                default:
                  throw new Error("`Node.create` requires a `object` string.");
              }
            }
            throw new Error("`Node.create` only accepts objects or nodes but you passed it: " + e);
          }
        }, {
          key: "createList",
          value: function createList() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
            if (m.List.isList(e) || Array.isArray(e)) return Object(m.List)(e.map(Node.create));
            throw new Error("`Node.createList` only accepts lists or arrays, but you passed it: " + e);
          }
        }, {
          key: "createProperties",
          value: function createProperties() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            if (ie.isBlock(e) || L.isInline(e)) return {
              data: e.data,
              type: e.type
            };
            if ("string" == typeof e) return {
              type: e
            };
            if (d()(e)) {
              var i = {};
              return "type" in e && (i.type = e.type), "data" in e && (i.data = P.create(e.data)), i;
            }
            throw new Error("`Node.createProperties` only accepts objects, strings, blocks or inlines, but you passed it: " + e);
          }
        }, {
          key: "fromJSON",
          value: function fromJSON(e) {
            var i = e.object;
            switch (!i && e.kind && (u(!1, "As of slate@0.32.0, the `kind` property of Slate objects has been renamed to `object`."), i = e.kind), i) {
              case "block":
                return ie.fromJSON(e);
              case "document":
                return R.fromJSON(e);
              case "inline":
                return L.fromJSON(e);
              case "text":
                return Z.fromJSON(e);
              default:
                throw new Error("`Node.fromJSON` requires an `object` of either 'block', 'document', 'inline' or 'text', but you passed: " + e);
            }
          }
        }, {
          key: "isNode",
          value: function isNode(e) {
            return ie.isBlock(e) || R.isDocument(e) || L.isInline(e) || Z.isText(e);
          }
        }, {
          key: "isNodeList",
          value: function isNodeList(e) {
            return m.List.isList(e) && e.every(function (e) {
              return Node.isNode(e);
            });
          }
        }]), Node;
      }(),
      ee = {
        data: void 0,
        key: void 0,
        nodes: void 0,
        type: void 0
      },
      ie = function (e) {
        function Block() {
          return D(this, Block), T(this, (Block.__proto__ || Object.getPrototypeOf(Block)).apply(this, arguments));
        }
        return q(Block, e), B(Block, [{
          key: "toJSON",
          value: function toJSON() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              i = {
                object: this.object,
                type: this.type,
                data: this.data.toJSON(),
                nodes: this.nodes.toArray().map(function (i) {
                  return i.toJSON(e);
                })
              };
            return e.preserveKeys && (i.key = this.key), i;
          }
        }], [{
          key: "create",
          value: function create() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            if (Block.isBlock(e)) return e;
            if ("string" == typeof e && (e = {
              type: e
            }), d()(e)) return Block.fromJSON(e);
            throw new Error("`Block.create` only accepts objects, strings or blocks, but you passed it: " + e);
          }
        }, {
          key: "createList",
          value: function createList() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
            if (m.List.isList(e) || Array.isArray(e)) return new m.List(e.map(Block.create));
            throw new Error("`Block.createList` only accepts arrays or lists, but you passed it: " + e);
          }
        }, {
          key: "fromJSON",
          value: function fromJSON(e) {
            if (Block.isBlock(e)) return e;
            var i = e.data,
              t = void 0 === i ? {} : i,
              a = e.key,
              n = void 0 === a ? x.create() : a,
              o = e.nodes,
              r = void 0 === o ? [] : o,
              s = e.type;
            if ("string" != typeof s) throw new Error("`Block.fromJSON` requires a `type` string.");
            return new Block({
              key: n,
              type: s,
              data: Object(m.Map)(t),
              nodes: Q.createList(r)
            });
          }
        }, {
          key: "isBlockList",
          value: function isBlockList(e) {
            return m.List.isList(e) && e.every(function (e) {
              return Block.isBlock(e);
            });
          }
        }]), Block;
      }(Object(m.Record)(ee)),
      te = {};
    ["deleteBackward", "deleteCharBackward", "deleteLineBackward", "deleteWordBackward", "deleteForward", "deleteCharForward", "deleteWordForward", "deleteLineForward", "setBlocks", "setInlines", "splitInline", "unwrapBlock", "unwrapInline", "wrapBlock", "wrapInline"].forEach(function (e) {
      te[e] = function (i) {
        for (var t = arguments.length, a = Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) {
          a[n - 1] = arguments[n];
        }
        var o = i.value.selection;
        i[e + "AtRange"].apply(i, [o].concat(a)), e.match(/Backward$/) ? i.moveToStart() : e.match(/Forward$/) && i.moveToEnd();
      };
    }), te.addMark = function (e, i) {
      i = U.create(i);
      var t = e.value,
        a = t.document,
        n = t.selection;
      if (n.isExpanded) e.addMarkAtRange(n, i);else if (n.marks) {
        var o = n.marks.add(i),
          r = n.set("marks", o);
        e.select(r);
      } else {
        var s = a.getActiveMarksAtRange(n).add(i),
          _ = n.set("marks", s);
        e.select(_);
      }
    }, te.addMarks = function (e, i) {
      i.forEach(function (i) {
        return e.addMark(i);
      });
    }, te.delete = function (e) {
      var i = e.value.selection;
      e.deleteAtRange(i), e.moveToStart();
    }, te.insertBlock = function (e, i) {
      i = ie.create(i);
      var t = e.value.selection;
      e.insertBlockAtRange(t, i);
      var a = e.value.document.getNode(i.key);
      a && e.moveToEndOfNode(a);
    }, te.insertFragment = function (e, i) {
      if (i.nodes.size) {
        var t = e.value,
          a = t,
          n = a.document,
          o = a.selection,
          r = o.start,
          s = o.end,
          _ = t,
          l = _.startText,
          g = _.endText,
          f = _.startInline,
          h = i.getLastText(),
          d = i.getClosestInline(h.key),
          m = i.nodes.first(),
          u = i.nodes.last(),
          c = n.getTexts().map(function (e) {
            return e.key;
          }),
          F = !f || r.isAtStartOfNode(l) || s.isAtStartOfNode(l) || r.isAtEndOfNode(g) || s.isAtEndOfNode(g),
          p = m.hasBlockChildren() || u.hasBlockChildren();
        e.insertFragmentAtRange(o, i);
        var b = (n = (t = e.value).document).getTexts().filter(function (e) {
            return !c.includes(e.key);
          }),
          y = F ? b.last() : b.takeLast(2).first();
        y && (d || p) ? e.select(o.moveToEndOfNode(y)) : y ? e.select(o.moveToStartOfNode(y).moveForward(h.text.length)) : e.select(o.moveToStart().moveForward(h.text.length));
      }
    }, te.insertInline = function (e, i) {
      i = L.create(i);
      var t = e.value.selection;
      e.insertInlineAtRange(t, i);
      var a = e.value.document.getNode(i.key);
      a && e.moveToEndOfNode(a);
    }, te.insertText = function (e, i, t) {
      var a = e.value,
        n = a.document,
        o = a.selection;
      t = t || o.marks || n.getInsertMarksAtRange(o), e.insertTextAtRange(o, i, t), o.marks && n != e.value.document && e.select({
        marks: null
      });
    }, te.removeMark = function (e, i) {
      i = U.create(i);
      var t = e.value,
        a = t.document,
        n = t.selection;
      if (n.isExpanded) e.removeMarkAtRange(n, i);else if (n.marks) {
        var o = n.marks.remove(i),
          r = n.set("marks", o);
        e.select(r);
      } else {
        var s = a.getActiveMarksAtRange(n).remove(i),
          _ = n.set("marks", s);
        e.select(_);
      }
    }, te.replaceMark = function (e, i, t) {
      e.removeMark(i), e.addMark(t);
    }, te.splitBlock = function (e) {
      var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
        t = e.value,
        a = t.selection,
        n = t.document,
        o = a.marks || n.getInsertMarksAtRange(a);
      e.splitBlockAtRange(a, i).moveToEnd(), o && 0 !== o.size && e.select({
        marks: o
      });
    }, te.toggleMark = function (e, i) {
      i = U.create(i), e.value.activeMarks.has(i) ? e.removeMark(i) : e.addMark(i);
    }, te.wrapText = function (e, i) {
      var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : i,
        a = e.value.selection;
      e.wrapTextAtRange(a, i, t), a.isCollapsed && e.moveStartBackward(i.length), e.moveEndBackward(t.length), a.isForward != e.value.selection.isForward && e.flip();
    };
    var ae = 55296,
      ne = 57343,
      oe = /\s/,
      re = /['\u2018\u2019]/,
      se = /[\u0021-\u0023\u0025-\u002A\u002C-\u002F\u003A\u003B\u003F\u0040\u005B-\u005D\u005F\u007B\u007D\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E3B\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/;
    function isSurrogate(e) {
      return ae <= e && e <= ne;
    }
    function isWord(e, i) {
      if (oe.test(e)) return !1;
      if (re.test(e)) {
        var t = i.charAt(0),
          a = getCharLength(t);
        if (isWord(t = i.slice(0, a), i.slice(a))) return !0;
      }
      return !se.test(e);
    }
    function getCharLength(e) {
      return isSurrogate(e.charCodeAt(0)) ? 2 : 1;
    }
    function getCharOffset(e) {
      return getCharLength(e.charAt(0));
    }
    function getWordOffset(e) {
      for (var i = 0, t = 0, a = !1, n = void 0; n = e.charAt(t);) {
        var o = getCharLength(n);
        if (isWord(n = e.slice(t, t + o), e.slice(t + o))) a = !0, i += o;else {
          if (a) break;
          i += o;
        }
        t += o;
      }
      return i;
    }
    var _e = {
        getCharLength: getCharLength,
        getCharOffset: getCharOffset,
        getCharOffsetBackward: function getCharOffsetBackward(e, i) {
          return e = e.slice(0, i), getCharOffset(e = Object(c.reverse)(e));
        },
        getCharOffsetForward: function getCharOffsetForward(e, i) {
          return getCharOffset(e = e.slice(i));
        },
        getWordOffset: getWordOffset,
        getWordOffsetBackward: function getWordOffsetBackward(e, i) {
          return e = e.slice(0, i), getWordOffset(e = Object(c.reverse)(e));
        },
        getWordOffsetForward: function getWordOffsetForward(e, i) {
          return getWordOffset(e = e.slice(i));
        },
        isSurrogate: isSurrogate,
        isWord: isWord
      },
      le = {};
    function compare(e, i) {
      if (e.size !== i.size) return null;
      for (var t = 0; t < e.size; t++) {
        var a = e.get(t),
          n = i.get(t);
        if (a < n) return -1;
        if (a > n) return 1;
      }
      return 0;
    }
    function create$1(e) {
      if (null == e) return null;
      if (m.List.isList(e)) return e;
      if (Array.isArray(e)) return Object(m.List)(e);
      throw new Error("Paths can only be created from arrays or lists, but you passed: " + e);
    }
    function crop(e, i) {
      var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : min(e, i);
      return [e.slice(0, t), i.slice(0, t)];
    }
    function decrement(e) {
      return increment(e, 0 - (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1), arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : e.size - 1);
    }
    function increment(e) {
      var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
        t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : e.size - 1,
        a = e.get(t) + i;
      return e.set(t, a);
    }
    function isAbove(e, i) {
      var t = crop(e, i),
        a = N(t, 2),
        n = a[0],
        o = a[1];
      return e.size < i.size && 0 === compare(n, o);
    }
    function isEqual(e, i) {
      return e.equals(i);
    }
    function isYounger(e, i) {
      var t = e.size - 1,
        a = crop(e, i, t),
        n = N(a, 2),
        o = n[0],
        r = n[1],
        s = e.get(t),
        _ = i.get(t);
      return isEqual(o, r) && s < _;
    }
    function min(e, i) {
      return Math.min(e.size, i.size);
    }
    le.addMarkAtRange = function (e, i, t) {
      if (!i.isCollapsed) {
        var a = e.value.document,
          n = i.start,
          o = i.end,
          r = a.getTextsAtRange(i);
        e.withoutNormalizing(function () {
          r.forEach(function (i) {
            var a = i.key,
              r = 0,
              s = i.text.length;
            a == n.key && (r = n.offset), a == o.key && (s = o.offset), a == n.key && a == o.key && (s = o.offset - n.offset), e.addMarkByKey(a, r, s, t);
          });
        });
      }
    }, le.addMarksAtRange = function (e, i, t) {
      t.forEach(function (t) {
        return e.addMarkAtRange(i, t);
      });
    }, le.deleteAtRange = function (e, i) {
      e.snapshotSelection();
      var t = e.value,
        a = i.start,
        n = i.end,
        o = a.key,
        r = a.offset,
        s = n.key,
        _ = n.offset,
        l = t.document,
        g = t.schema,
        f = l.hasVoidParent(o, g),
        h = l.hasVoidParent(s, g),
        d = l.getClosestBlock(o, g),
        m = l.getClosestBlock(s, g),
        u = 0 == r && 0 == _ && 0 == f && o == d.getFirstText().key && s == m.getFirstText().key;
      if (u && h) {
        var c = l.getPreviousText(s);
        s = c.key, _ = c.text.length, h = l.hasVoidParent(s, g);
      }
      e.withoutNormalizing(function () {
        for (; f;) {
          var i = l.getClosestVoid(o, g),
            t = l.getNextText(o);
          if (e.removeNodeByKey(i.key), o == s) return;
          if (!t) return;
          l = e.value.document, o = t.key, r = 0, f = l.hasVoidParent(o, g);
        }
        for (; h;) {
          var a = l.getClosestVoid(s, g),
            n = l.getPreviousText(s);
          e.removeNodeByKey(a.key), l = e.value.document, s = n.key, _ = n.text.length, h = l.hasVoidParent(s, g);
        }
        if (o == s && u) e.removeNodeByKey(d.key);else if (o != s) {
          d = l.getClosestBlock(o), m = l.getClosestBlock(s);
          var c = l.getNode(o),
            F = l.getNode(s),
            p = c.text.length - r,
            b = _,
            y = l.getCommonAncestor(o, s),
            k = y.getFurthestAncestor(o),
            v = y.getFurthestAncestor(s),
            w = l.getParent(d.key),
            E = w.nodes.indexOf(d),
            A = w.nodes.indexOf(m),
            j = void 0;
          for (j = c; j.key != k.key;) {
            var x = l.getParent(j.key),
              C = x.nodes.indexOf(j);
            x.nodes.slice(C + 1).reverse().forEach(function (i) {
              e.removeNodeByKey(i.key);
            }), j = x;
          }
          var D = y.nodes.indexOf(k),
            B = y.nodes.indexOf(v);
          for (y.nodes.slice(D + 1, B).reverse().forEach(function (i) {
            e.removeNodeByKey(i.key);
          }), j = F; j.key != v.key;) {
            var S = l.getParent(j.key),
              q = S.nodes.indexOf(j);
            S.nodes.slice(0, q).reverse().forEach(function (i) {
              e.removeNodeByKey(i.key);
            }), j = S;
          }
          if (0 != p && e.removeTextByKey(o, r, p), 0 != b && e.removeTextByKey(s, 0, _), d.key != m.key) {
            var O = (l = e.value.document).getFurthestOnlyChildAncestor(m.key);
            A != E + 1 && e.moveNodeByKey(m.key, w.key, E + 1), u ? e.removeNodeByKey(d.key) : e.mergeNodeByKey(m.key), O && e.removeNodeByKey(O.key);
          }
        } else {
          var T = r,
            N = _ - r;
          e.removeTextByKey(o, T, N);
        }
      });
    }, le.deleteCharBackwardAtRange = function (e, i) {
      var t = e.value.document,
        a = i.start,
        n = t.getClosestBlock(a.key),
        o = n.getOffset(a.key) + a.offset,
        r = n.text,
        s = _e.getCharOffsetBackward(r, o);
      e.deleteBackwardAtRange(i, s);
    }, le.deleteLineBackwardAtRange = function (e, i) {
      var t = e.value.document,
        a = i.start,
        n = t.getClosestBlock(a.key).getOffset(a.key) + a.offset;
      e.deleteBackwardAtRange(i, n);
    }, le.deleteWordBackwardAtRange = function (e, i) {
      var t = e.value.document,
        a = i.start,
        n = t.getClosestBlock(a.key),
        o = n.getOffset(a.key) + a.offset,
        r = n.text,
        s = 0 === o ? 1 : _e.getWordOffsetBackward(r, o);
      e.deleteBackwardAtRange(i, s);
    }, le.deleteBackwardAtRange = function (e, i) {
      var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
      if (0 !== t) {
        var a = e.value,
          n = a.document,
          o = a.schema,
          r = i,
          s = r.start,
          _ = r.focus;
        if (i.isExpanded) e.deleteAtRange(i);else {
          var l = n.getClosestVoid(s.key, o);
          if (l) e.removeNodeByKey(l.key);else {
            var g = n.getClosestBlock(s.key);
            if (!g || o.isVoid(g) || "" !== g.text || 1 === n.nodes.size) {
              if (!s.isAtStartOfNode(n)) {
                var f = n.getDescendant(s.key);
                if (s.isAtStartOfNode(f)) {
                  var h = n.getPreviousText(f.key),
                    d = n.getClosestBlock(h.key),
                    m = n.getClosestVoid(h.key, o);
                  if (m) return void e.removeNodeByKey(m.key);
                  if (1 == t && d != g) return i = i.moveAnchorTo(h.key, h.text.length), void e.deleteAtRange(i);
                }
                if (t < _.offset) return i = i.moveFocusBackward(t), void e.deleteAtRange(i);
                for (var u = f, c = 0, F = _.offset; t > F;) {
                  var p = F + (u = n.getPreviousText(u.key)).text.length;
                  if (t <= p) {
                    c = p - t;
                    break;
                  }
                  F = p;
                }
                i = i.moveAnchorTo(u.key, c), e.deleteAtRange(i);
              }
            } else e.removeNodeByKey(g.key);
          }
        }
      }
    }, le.deleteCharForwardAtRange = function (e, i) {
      var t = e.value.document,
        a = i.start,
        n = t.getClosestBlock(a.key),
        o = n.getOffset(a.key) + a.offset,
        r = n.text,
        s = _e.getCharOffsetForward(r, o);
      e.deleteForwardAtRange(i, s);
    }, le.deleteLineForwardAtRange = function (e, i) {
      var t = e.value.document,
        a = i.start,
        n = t.getClosestBlock(a.key),
        o = n.getOffset(a.key) + a.offset;
      e.deleteForwardAtRange(i, n.text.length - o);
    }, le.deleteWordForwardAtRange = function (e, i) {
      var t = e.value.document,
        a = i.start,
        n = t.getClosestBlock(a.key),
        o = n.getOffset(a.key) + a.offset,
        r = n.text,
        s = _e.getWordOffsetForward(r, o);
      e.deleteForwardAtRange(i, s);
    }, le.deleteForwardAtRange = function (e, i) {
      var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
      if (0 !== t) {
        var a = e.value,
          n = a.document,
          o = a.schema,
          r = i,
          s = r.start,
          _ = r.focus;
        if (i.isExpanded) e.deleteAtRange(i);else {
          var l = n.getClosestVoid(s.key, o);
          if (l) e.removeNodeByKey(l.key);else {
            var g = n.getClosestBlock(s.key);
            if (g && !o.isVoid(g) && "" === g.text && 1 !== n.nodes.size) {
              var f = n.getNextBlock(g.key);
              return e.removeNodeByKey(g.key), void (f && f.key && e.moveToStartOfNode(f));
            }
            if (!s.isAtEndOfNode(n)) {
              var h = n.getDescendant(s.key);
              if (s.isAtEndOfNode(h)) {
                var d = n.getNextText(h.key),
                  m = n.getClosestBlock(d.key),
                  u = n.getClosestVoid(d.key, o);
                if (u) return void e.removeNodeByKey(u.key);
                if (1 == t && m != g) return i = i.moveFocusTo(d.key, 0), void e.deleteAtRange(i);
              }
              if (t <= h.text.length - _.offset) return i = i.moveFocusForward(t), void e.deleteAtRange(i);
              for (var c = h, F = _.offset, p = h.text.length - _.offset; t > p;) {
                var b = p + (c = n.getNextText(c.key)).text.length;
                if (t <= b) {
                  F = t - p;
                  break;
                }
                p = b;
              }
              i = i.moveFocusTo(c.key, F), e.deleteAtRange(i);
            }
          }
        }
      }
    }, le.insertBlockAtRange = function (e, i, t) {
      t = ie.create(t), i.isExpanded && (e.deleteAtRange(i), i = i.moveToStart());
      var a = e.value,
        n = a.document,
        o = a.schema,
        r = i.start,
        s = r.key,
        _ = r.offset,
        l = n.getClosestBlock(s),
        g = n.getClosestInline(s),
        f = n.getParent(l.key),
        h = f.nodes.indexOf(l);
      if (o.isVoid(l)) {
        var d = r.isAtEndOfNode(l) ? 1 : 0;
        e.insertNodeByKey(f.key, h + d, t);
      } else if (g || "" !== l.text) {
        if (r.isAtStartOfNode(l)) e.insertNodeByKey(f.key, h, t);else if (r.isAtEndOfNode(l)) e.insertNodeByKey(f.key, h + 1, t);else {
          if (g && o.isVoid(g)) {
            var m = r.isAtEndOfNode(g),
              u = m ? n.getNextText(s) : n.getPreviousText(s),
              c = m ? i.moveToStartOfNode(u) : i.moveToEndOfNode(u);
            s = c.start.key, _ = c.start.offset;
          }
          e.withoutNormalizing(function () {
            e.splitDescendantsByKey(l.key, s, _), e.insertNodeByKey(f.key, h + 1, t);
          });
        }
      } else e.insertNodeByKey(f.key, h + 1, t);
    }, le.insertFragmentAtRange = function (e, i, t) {
      e.withoutNormalizing(function () {
        if (i.isExpanded && (e.deleteAtRange(i), i = e.value.document.getDescendant(i.start.key) ? i.moveToStart() : i.moveTo(i.end.key, 0).normalize(e.value.document)), t.nodes.size) {
          t = t.mapDescendants(function (e) {
            return e.regenerateKey();
          });
          var a = i.start,
            n = e.value,
            o = n.schema,
            r = n.document,
            s = r.getDescendant(a.key),
            _ = r.getClosestBlock(s.key),
            l = _.getFurthestAncestor(s.key),
            g = a.isAtStartOfNode(_),
            f = r.getParent(_.key),
            h = f.nodes.indexOf(_),
            d = t.getBlocks(),
            u = t.nodes.first(),
            c = t.nodes.last(),
            F = d.first(),
            p = d.last();
          if (F === p && o.isVoid(F)) e.insertBlockAtRange(i, F);else if (u.hasBlockChildren() || c.hasBlockChildren()) t.nodes.reverse().forEach(function (t) {
            e.insertBlockAtRange(i, t);
          });else {
            if (F != p) {
              var b = t.getFurthest(F.key, function (e) {
                  return 1 == e.nodes.size;
                }) || F,
                y = f.nodes.indexOf(_);
              (t = t.removeNode(b.key)).nodes.forEach(function (i, t) {
                var a = y + t + 1;
                e.insertNodeByKey(f.key, a, i);
              });
            }
            if (0 != a.offset && e.splitDescendantsByKey(l.key, a.key, a.offset), s = (r = e.value.document).getDescendant(a.key), l = (_ = r.getClosestBlock(a.key)).getFurthestAncestor(s.key), F != p) {
              var k = g ? l : _.getNextSibling(l.key),
                v = k ? _.nodes.skipUntil(function (e) {
                  return e.key == k.key;
                }) : Object(m.List)(),
                w = p.nodes.size;
              v.forEach(function (i, t) {
                var a = w + t;
                e.moveNodeByKey(i.key, p.key, a);
              });
            }
            if (o.isVoid(_) || "" !== _.text) {
              var E = _.getFurthestAncestor(s.key),
                A = _.nodes.indexOf(E);
              F.nodes.forEach(function (i, t) {
                var n = 0 == a.offset ? 0 : 1,
                  o = A + t + n;
                e.insertNodeByKey(_.key, o, i);
              });
            } else e.removeNodeByKey(_.key), e.insertNodeByKey(f.key, h, F);
          }
        }
      });
    }, le.insertInlineAtRange = function (e, i, t) {
      t = L.create(t), e.withoutNormalizing(function () {
        i.isExpanded && (e.deleteAtRange(i), i = i.moveToStart());
        var a = e.value,
          n = a.document,
          o = a.schema,
          r = i.start,
          s = n.getParent(r.key),
          _ = n.assertDescendant(r.key),
          l = s.nodes.indexOf(_);
        o.isVoid(s) || (e.splitNodeByKey(r.key, r.offset), e.insertNodeByKey(s.key, l + 1, t));
      });
    }, le.insertTextAtRange = function (e, i, t, a) {
      var n = e.value,
        o = n.document,
        r = n.schema,
        s = i.start,
        _ = s.key,
        l = s.offset,
        g = o.getParent(s.key);
      r.isVoid(g) || e.withoutNormalizing(function () {
        i.isExpanded && (e.deleteAtRange(i), e.value.selection.start.key !== _ && (_ = e.value.selection.start.key, l = e.value.selection.start.offset)), e.insertTextByKey(_, l, t, a);
      });
    }, le.removeMarkAtRange = function (e, i, t) {
      if (!i.isCollapsed) {
        var a = e.value.document.getTextsAtRange(i),
          n = i.start,
          o = i.end;
        e.withoutNormalizing(function () {
          a.forEach(function (i) {
            var a = i.key,
              r = 0,
              s = i.text.length;
            a == n.key && (r = n.offset), a == o.key && (s = o.offset), a == n.key && a == o.key && (s = o.offset - n.offset), e.removeMarkByKey(a, r, s, t);
          });
        });
      }
    }, le.setBlocksAtRange = function (e, i, t) {
      var a = e.value,
        n = a.document,
        o = a.schema,
        r = n.getBlocksAtRange(i),
        s = i.start,
        _ = i.end,
        l = i.isCollapsed,
        g = n.hasVoidParent(s.key, o),
        f = n.getClosestBlock(s.key),
        h = n.getClosestBlock(_.key),
        d = 0 == l && 0 == s.offset && 0 == _.offset && 0 == g && s.key == f.getFirstText().key && _.key == h.getFirstText().key ? r.slice(0, -1) : r;
      e.withoutNormalizing(function () {
        d.forEach(function (i) {
          e.setNodeByKey(i.key, t);
        });
      });
    }, le.setInlinesAtRange = function (e, i, t) {
      var a = e.value.document.getInlinesAtRange(i);
      e.withoutNormalizing(function () {
        a.forEach(function (i) {
          e.setNodeByKey(i.key, t);
        });
      });
    }, le.splitBlockAtRange = function (e, i) {
      for (var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1, a = i, n = a.start, o = a.end, r = e.value, s = r.document, _ = s.assertDescendant(n.key), l = s.getClosestBlock(_.key), g = 0; l && "block" == l.object && g < t;) {
        _ = l, l = s.getClosestBlock(l.key), g++;
      }
      e.withoutNormalizing(function () {
        if (e.splitDescendantsByKey(_.key, n.key, n.offset), r = e.value, s = r.document, i.isExpanded) {
          i.isBackward && (i = i.flip());
          var t = s.getNextBlock(_.key);
          i = (i = i.moveAnchorToStartOfNode(t)).setFocus(i.focus.setPath(null)), n.key === o.key && (i = i.moveFocusTo(i.anchor.key, o.offset - n.offset)), i = s.resolveRange(i), e.deleteAtRange(i);
        }
      });
    }, le.splitInlineAtRange = function (e, i) {
      var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1 / 0;
      i.isExpanded && (e.deleteAtRange(i), i = i.moveToStart());
      for (var a = i.start, n = e.value.document, o = n.assertDescendant(a.key), r = n.getClosestInline(o.key), s = 0; r && "inline" == r.object && s < t;) {
        o = r, r = n.getClosestInline(r.key), s++;
      }
      e.splitDescendantsByKey(o.key, a.key, a.offset);
    }, le.toggleMarkAtRange = function (e, i, t) {
      i.isCollapsed || (t = U.create(t), e.value.document.getActiveMarksAtRange(i).some(function (e) {
        return e.equals(t);
      }) ? e.removeMarkAtRange(i, t) : e.addMarkAtRange(i, t));
    }, le.unwrapBlockAtRange = function (e, i, t) {
      t = Q.createProperties(t);
      var a = e.value.document,
        n = a.getBlocksAtRange(i),
        o = n.map(function (e) {
          return a.getClosest(e.key, function (e) {
            return "block" == e.object && (null == t.type || e.type == t.type) && !(null != t.data && !e.data.isSuperset(t.data));
          });
        }).filter(function (e) {
          return e;
        }).toOrderedSet().toList();
      e.withoutNormalizing(function () {
        o.forEach(function (i) {
          var t = i.nodes.first(),
            o = i.nodes.last(),
            r = a.getParent(i.key),
            s = r.nodes.indexOf(i),
            _ = i.nodes.filter(function (e) {
              return n.some(function (i) {
                return e == i || e.hasDescendant(i.key);
              });
            }),
            l = _.first(),
            g = _.last();
          if (t == l && o == g) i.nodes.forEach(function (i, t) {
            e.moveNodeByKey(i.key, r.key, s + t);
          }), e.removeNodeByKey(i.key);else if (o == g) i.nodes.skipUntil(function (e) {
            return e == l;
          }).forEach(function (i, t) {
            e.moveNodeByKey(i.key, r.key, s + 1 + t);
          });else if (t == l) i.nodes.takeUntil(function (e) {
            return e == g;
          }).push(g).forEach(function (i, t) {
            e.moveNodeByKey(i.key, r.key, s + t);
          });else {
            var f = l.getFirstText();
            e.splitDescendantsByKey(i.key, f.key, 0), a = e.value.document, _.forEach(function (i, t) {
              if (0 == t) {
                var n = i;
                i = a.getNextBlock(i.key), e.removeNodeByKey(n.key);
              }
              e.moveNodeByKey(i.key, r.key, s + 1 + t);
            });
          }
        });
      });
    }, le.unwrapInlineAtRange = function (e, i, t) {
      t = Q.createProperties(t);
      var a = e.value.document,
        n = a.getTextsAtRange(i).map(function (e) {
          return a.getClosest(e.key, function (e) {
            return "inline" == e.object && (null == t.type || e.type == t.type) && !(null != t.data && !e.data.isSuperset(t.data));
          });
        }).filter(function (e) {
          return e;
        }).toOrderedSet().toList();
      e.withoutNormalizing(function () {
        n.forEach(function (i) {
          var t = e.value.document.getParent(i.key),
            a = t.nodes.indexOf(i);
          i.nodes.forEach(function (i, n) {
            e.moveNodeByKey(i.key, t.key, a + n);
          }), e.removeNodeByKey(i.key);
        });
      });
    }, le.wrapBlockAtRange = function (e, i, t) {
      t = (t = ie.create(t)).set("nodes", t.nodes.clear());
      var a = e.value.document,
        n = a.getBlocksAtRange(i),
        o = n.first(),
        r = n.last(),
        s = void 0,
        _ = void 0,
        l = void 0;
      if (1 === n.length ? (s = a.getParent(o.key), _ = n) : s = a.getClosest(o.key, function (e) {
        return !!a.getClosest(r.key, function (i) {
          return e == i;
        });
      }), null == s && (s = a), null == _) {
        var g = s.nodes.reduce(function (e, i, t) {
          return (i == o || i.hasDescendant(o.key)) && (e[0] = t), (i == r || i.hasDescendant(r.key)) && (e[1] = t), e;
        }, []);
        l = g[0], _ = s.nodes.slice(g[0], g[1] + 1);
      }
      null == l && (l = s.nodes.indexOf(_.first())), e.withoutNormalizing(function () {
        e.insertNodeByKey(s.key, l, t), _.forEach(function (i, a) {
          e.moveNodeByKey(i.key, t.key, a);
        });
      });
    }, le.wrapInlineAtRange = function (e, i, t) {
      var a = e.value,
        n = a.document,
        o = a.schema,
        r = i.start,
        s = i.end;
      if (i.isCollapsed) {
        var _ = n.getClosestInline(r.key);
        if (!o.isVoid(_)) return;
        return e.wrapInlineByKey(_.key, t);
      }
      t = (t = L.create(t)).set("nodes", t.nodes.clear());
      var l = n.getBlocksAtRange(i),
        g = n.getClosestBlock(r.key),
        f = n.getClosestBlock(s.key),
        h = n.getClosestInline(r.key),
        d = n.getClosestInline(s.key),
        u = g.getFurthestAncestor(r.key),
        c = f.getFurthestAncestor(s.key);
      e.withoutNormalizing(function () {
        h && h == d || (e.splitDescendantsByKey(c.key, s.key, s.offset), e.splitDescendantsByKey(u.key, r.key, r.offset)), n = e.value.document, g = n.getDescendant(g.key), f = n.getDescendant(f.key), u = g.getFurthestAncestor(r.key), c = f.getFurthestAncestor(s.key);
        var a = g.nodes.indexOf(u),
          o = f.nodes.indexOf(c);
        if (h && h == d) {
          var _ = g.getTextsAtRange(i).get(0).splitText(r.offset)[1].splitText(s.offset - r.offset)[0];
          t = t.set("nodes", Object(m.List)([_])), e.insertInlineAtRange(i, t);
          var F = t.getFirstText().key,
            p = {
              anchor: {
                key: F,
                offset: 0
              },
              focus: {
                key: F,
                offset: s.offset - r.offset
              },
              isFocused: !0
            };
          e.select(p);
        } else if (g == f) {
          n = e.value.document, g = n.getClosestBlock(r.key), u = g.getFurthestAncestor(r.key);
          var b = n.getNextSibling(u.key),
            y = g.nodes.indexOf(b),
            k = r.key == s.key ? b : g.getFurthestAncestor(s.key),
            v = g.nodes.skipUntil(function (e) {
              return e == b;
            }).takeUntil(function (e) {
              return e == k;
            }).push(k),
            w = t.regenerateKey();
          e.insertNodeByKey(g.key, y, w), v.forEach(function (i, t) {
            e.moveNodeByKey(i.key, w.key, t);
          });
        } else {
          var E = g.nodes.slice(a + 1),
            A = f.nodes.slice(0, o + 1),
            j = t.regenerateKey(),
            x = t.regenerateKey();
          e.insertNodeByKey(g.key, a + 1, j), e.insertNodeByKey(f.key, o, x), E.forEach(function (i, t) {
            e.moveNodeByKey(i.key, j.key, t);
          }), A.forEach(function (i, t) {
            e.moveNodeByKey(i.key, x.key, t);
          }), l.slice(1, -1).forEach(function (i) {
            var a = t.regenerateKey();
            e.insertNodeByKey(i.key, 0, a), i.nodes.forEach(function (i, t) {
              e.moveNodeByKey(i.key, a.key, t);
            });
          });
        }
      });
    }, le.wrapTextAtRange = function (e, i, t) {
      var a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : t,
        n = i.start,
        o = i.end,
        r = i.moveToStart(),
        s = i.moveToEnd();
      n.key == o.key && (s = s.moveForward(t.length)), e.withoutNormalizing(function () {
        e.insertTextAtRange(r, t, []), e.insertTextAtRange(s, a, []);
      });
    };
    var ge = {
        compare: compare,
        create: create$1,
        crop: crop,
        decrement: decrement,
        increment: increment,
        isAbove: isAbove,
        isAfter: function isAfter(e, i) {
          var t = crop(e, i),
            a = N(t, 2);
          return 1 === compare(a[0], a[1]);
        },
        isBefore: function isBefore(e, i) {
          var t = crop(e, i),
            a = N(t, 2);
          return -1 === compare(a[0], a[1]);
        },
        isEqual: isEqual,
        isOlder: function isOlder(e, i) {
          var t = e.size - 1,
            a = crop(e, i, t),
            n = N(a, 2),
            o = n[0],
            r = n[1],
            s = e.get(t),
            _ = i.get(t);
          return isEqual(o, r) && s > _;
        },
        isSibling: function isSibling(e, i) {
          if (e.size !== i.size) return !1;
          var t = e.butLast(),
            a = i.butLast();
          return t.equals(a);
        },
        isYounger: isYounger,
        lift: function lift(e) {
          return e.slice(0, -1);
        },
        max: function max(e, i) {
          return Math.max(e.size, i.size);
        },
        min: min,
        relate: function relate(e, i) {
          for (var t = [], a = 0; a < e.size && a < i.size; a++) {
            var n = e.get(a);
            if (n !== i.get(a)) break;
            t.push(n);
          }
          return create$1(t);
        },
        transform: function transform(e, i) {
          var t = i.type,
            a = i.position,
            n = i.path;
          if ("add_mark" === t || "insert_text" === t || "remove_mark" === t || "remove_text" === t || "set_mark" === t || "set_node" === t || "set_selection" === t || "set_value" === t || 0 === e.size) return Object(m.List)([e]);
          var o = n.size - 1,
            r = isEqual(n, e),
            s = isYounger(n, e),
            _ = isAbove(n, e);
          if ("insert_node" === t && (r || s || _) && (e = increment(e, 1, o)), "remove_node" === t && (s ? e = decrement(e, 1, o) : (r || _) && (e = [])), "merge_node" === t && (r || s ? e = decrement(e, 1, o) : _ && (e = increment(e = decrement(e, 1, o), a, o + 1))), "split_node" === t && (r ? e = [e, increment(e)] : s ? e = increment(e, 1, o) : _ && e.get(o + 1) >= a && (e = decrement(e = increment(e, 1, o), a, o + 1))), "move_node" === t) {
            var l = i.newPath,
              g = l.size - 1,
              f = isEqual(l, e),
              h = isYounger(l, e),
              d = isAbove(l, e);
            _ ? e = l.concat(e.slice(n.size)) : (r ? e = l : s && (e = decrement(e, 1, o)), (f || h || d) && (e = increment(e, 1, g)));
          }
          var u = Array.isArray(e) ? e : [e];
          return Object(m.List)(u);
        }
      },
      fe = {
        addMarkByPath: function addMarkByPath(e, i, t, a, n) {
          n = U.create(n);
          var o = e.value,
            r = o.document.assertNode(i).getLeaves(),
            s = [],
            _ = t,
            l = t + a,
            g = 0;
          r.forEach(function (e) {
            var t = g,
              a = t + e.text.length;
            if (g += e.text.length, !(a < _ || l < t) && !e.marks.has(n)) {
              var r = Math.max(t, _),
                f = Math.min(a, l);
              s.push({
                type: "add_mark",
                value: o,
                path: i,
                offset: r,
                length: f - r,
                mark: n
              });
            }
          }), e.applyOperations(s);
        },
        insertFragmentByPath: function insertFragmentByPath(e, i, t, a) {
          a.nodes.forEach(function (a, n) {
            e.insertNodeByPath(i, t + n, a);
          });
        },
        insertNodeByPath: function insertNodeByPath(e, i, t, a) {
          var n = e.value;
          e.applyOperation({
            type: "insert_node",
            value: n,
            path: i.concat(t),
            node: a
          });
        },
        insertTextByPath: function insertTextByPath(e, i, t, a, n) {
          var o = e.value,
            r = o.document.assertNode(i);
          n = n || r.getMarksAtIndex(t), e.applyOperation({
            type: "insert_text",
            value: o,
            path: i,
            offset: t,
            text: a,
            marks: n
          });
        },
        mergeNodeByPath: function mergeNodeByPath(e, i) {
          var t = e.value,
            a = t.document,
            n = a.getDescendant(i),
            o = a.getPreviousSibling(i);
          if (!o) throw new Error('Unable to merge node with path "' + i + '", because it has no previous sibling.');
          var r = "text" == o.object ? o.text.length : o.nodes.size;
          e.applyOperation({
            type: "merge_node",
            value: t,
            path: i,
            position: r,
            properties: {
              type: n.type,
              data: n.data
            },
            target: null
          });
        },
        moveNodeByPath: function moveNodeByPath(e, i, t, a) {
          var n = e.value;
          e.applyOperation({
            type: "move_node",
            value: n,
            path: i,
            newPath: t.concat(a)
          });
        },
        removeMarkByPath: function removeMarkByPath(e, i, t, a, n) {
          n = U.create(n);
          var o = e.value,
            r = o.document.assertNode(i).getLeaves(),
            s = [],
            _ = t,
            l = t + a,
            g = 0;
          r.forEach(function (e) {
            var t = g,
              a = t + e.text.length;
            if (g += e.text.length, !(a < _ || l < t) && e.marks.has(n)) {
              var r = Math.max(t, _),
                f = Math.min(a, l);
              s.push({
                type: "remove_mark",
                value: o,
                path: i,
                offset: r,
                length: f - r,
                mark: n
              });
            }
          }), e.applyOperations(s);
        },
        removeAllMarksByPath: function removeAllMarksByPath(e, i) {
          var t = e.state.document.assertNode(i);
          ("text" === t.object ? [t] : t.getTextsAsArray()).forEach(function (i) {
            i.getMarksAsArray().forEach(function (t) {
              e.removeMarkByKey(i.key, 0, i.text.length, t);
            });
          });
        },
        removeNodeByPath: function removeNodeByPath(e, i) {
          var t = e.value,
            a = t.document.assertNode(i);
          e.applyOperation({
            type: "remove_node",
            value: t,
            path: i,
            node: a
          });
        },
        removeTextByPath: function removeTextByPath(e, i, t, a) {
          var n = e.value,
            o = n.document.assertNode(i),
            r = o.getLeaves(),
            s = o.text,
            _ = [],
            l = t,
            g = t + a,
            f = 0;
          r.forEach(function (e) {
            var t = f,
              a = t + e.text.length;
            if (f += e.text.length, !(a < l || g < t)) {
              var o = Math.max(t, l),
                r = Math.min(a, g),
                h = s.slice(o, r);
              _.push({
                type: "remove_text",
                value: n,
                path: i,
                offset: o,
                text: h,
                marks: e.marks
              });
            }
          }), e.applyOperations(_.reverse());
        },
        replaceNodeByPath: function replaceNodeByPath(e, i, t) {
          t = Q.create(t);
          var a = i.last(),
            n = ge.lift(i);
          e.withoutNormalizing(function () {
            e.removeNodeByPath(i), e.insertNodeByPath(n, a, t);
          });
        },
        replaceTextByPath: function replaceTextByPath(e, i, t, a, n, o) {
          var r = e.value.document,
            s = r.assertNode(i);
          a + t > s.text.length && (a = s.text.length - t);
          var _ = r.createRange({
              anchor: {
                path: i,
                offset: t
              },
              focus: {
                path: i,
                offset: t + a
              }
            }),
            l = r.getActiveMarksAtRange(_);
          e.withoutNormalizing(function () {
            e.removeTextByPath(i, t, a), o ? l && (l = l.filter(function (e) {
              return !o.find(function (i) {
                return e.type === i.type;
              });
            }), o = l.merge(o)) : o = l || [], e.insertTextByPath(i, t, n, o);
          });
        },
        setMarkByPath: function setMarkByPath(e, i, t, a, n, o) {
          n = U.create(n), o = U.createProperties(o);
          var r = e.value;
          e.applyOperation({
            type: "set_mark",
            value: r,
            path: i,
            offset: t,
            length: a,
            mark: n,
            properties: o
          });
        },
        setNodeByPath: function setNodeByPath(e, i, t) {
          t = Q.createProperties(t);
          var a = e.value,
            n = a.document.assertNode(i);
          e.applyOperation({
            type: "set_node",
            value: a,
            path: i,
            node: n,
            properties: t
          });
        },
        setTextByPath: function setTextByPath(e, i, t, a) {
          var n = e.value.document.assertNode(i).text.length;
          e.replaceTextByPath(i, 0, n, t, a);
        },
        splitNodeByPath: function splitNodeByPath(e, i, t) {
          var a = (arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {}).target,
            n = void 0 === a ? null : a,
            o = e.value,
            r = o.document.getDescendant(i);
          e.applyOperation({
            type: "split_node",
            value: o,
            path: i,
            position: t,
            target: n,
            properties: {
              type: r.type,
              data: r.data
            }
          });
        },
        splitDescendantsByPath: function splitDescendantsByPath(e, i, t, a) {
          if (i.equals(t)) e.splitNodeByPath(t, a);else {
            var n = e.value.document,
              o = n.assertNode(i),
              r = n.assertNode(t),
              s = n.getAncestors(t).skipUntil(function (e) {
                return e.key == o.key;
              }).reverse().unshift(r),
              _ = void 0,
              l = void 0;
            e.withoutNormalizing(function () {
              s.forEach(function (i) {
                var t = null == l ? null : l;
                l = _ ? i.nodes.indexOf(_) + 1 : a, _ = i, e.splitNodeByKey(i.key, l, {
                  target: t
                });
              });
            });
          }
        },
        unwrapInlineByPath: function unwrapInlineByPath(e, i, t) {
          var a = e.value,
            n = a.document,
            o = a.selection,
            r = n.assertNode(i),
            s = r.getFirstText(),
            _ = r.getLastText(),
            l = o.moveToRangeOfNode(s, _);
          e.unwrapInlineAtRange(l, t);
        },
        unwrapBlockByPath: function unwrapBlockByPath(e, i, t) {
          var a = e.value,
            n = a.document,
            o = a.selection,
            r = n.assertNode(i),
            s = r.getFirstText(),
            _ = r.getLastText(),
            l = o.moveToRangeOfNode(s, _);
          e.unwrapBlockAtRange(l, t);
        },
        unwrapNodeByPath: function unwrapNodeByPath(e, i) {
          var t = e.value.document;
          t.assertNode(i);
          var a = ge.lift(i),
            n = t.assertNode(a),
            o = i.last(),
            r = a.last(),
            s = ge.lift(a),
            _ = 0 === o,
            l = o === n.nodes.size - 1;
          e.withoutNormalizing(function () {
            if (1 === n.nodes.size) e.moveNodeByPath(i, s, r + 1), e.removeNodeByPath(a);else if (_) e.moveNodeByPath(i, s, r);else if (l) e.moveNodeByPath(i, s, r + 1);else {
              var t = ge.increment(i, 1, a.size - 1);
              t = t.set(t.size - 1, 0), e.splitNodeByPath(a, o), e.moveNodeByPath(t, s, r + 1);
            }
          });
        },
        wrapBlockByPath: function wrapBlockByPath(e, i, t) {
          t = (t = ie.create(t)).set("nodes", t.nodes.clear());
          var a = ge.lift(i),
            n = i.last(),
            o = ge.increment(i);
          e.withoutNormalizing(function () {
            e.insertNodeByPath(a, n, t), e.moveNodeByPath(o, i, 0);
          });
        },
        wrapInlineByPath: function wrapInlineByPath(e, i, t) {
          t = (t = L.create(t)).set("nodes", t.nodes.clear());
          var a = ge.lift(i),
            n = i.last(),
            o = ge.increment(i);
          e.withoutNormalizing(function () {
            e.insertNodeByPath(a, n, t), e.moveNodeByPath(o, i, 0);
          });
        },
        wrapNodeByPath: function wrapNodeByPath(e, i, t) {
          "block" === (t = Q.create(t)).object ? e.wrapBlockByPath(i, t) : "inline" === t.object && e.wrapInlineByPath(i, t);
        }
      },
      he = function _loop(e) {
        fe[e + "ByKey"] = function (i, t) {
          for (var a = arguments.length, n = Array(a > 2 ? a - 2 : 0), o = 2; o < a; o++) {
            n[o - 2] = arguments[o];
          }
          var r = i.value.document.assertPath(t);
          i[e + "ByPath"].apply(i, [r].concat(n));
        };
      },
      de = !0,
      me = !1,
      ue = void 0;
    try {
      for (var ce, Fe = ["addMark", "insertFragment", "insertNode", "insertText", "mergeNode", "removeMark", "removeAllMarks", "removeNode", "setText", "replaceText", "removeText", "replaceNode", "setMark", "setNode", "splitNode", "unwrapInline", "unwrapBlock", "unwrapNode", "wrapBlock", "wrapInline", "wrapNode"][Symbol.iterator](); !(de = (ce = Fe.next()).done); de = !0) {
        he(ce.value);
      }
    } catch (sr) {
      me = !0, ue = sr;
    } finally {
      try {
        !de && Fe.return && Fe.return();
      } finally {
        if (me) throw ue;
      }
    }
    fe.moveNodeByKey = function (e, i, t) {
      for (var a = arguments.length, n = Array(a > 3 ? a - 3 : 0), o = 3; o < a; o++) {
        n[o - 3] = arguments[o];
      }
      var r = e.value.document,
        s = r.assertPath(i),
        _ = r.assertPath(t);
      e.moveNodeByPath.apply(e, [s, _].concat(n));
    }, fe.splitDescendantsByKey = function (e, i, t) {
      for (var a = arguments.length, n = Array(a > 3 ? a - 3 : 0), o = 3; o < a; o++) {
        n[o - 3] = arguments[o];
      }
      var r = e.value.document,
        s = r.assertPath(i),
        _ = r.assertPath(t);
      e.splitDescendantsByPath.apply(e, [s, _].concat(n));
    };
    var pe = {
        redo: function redo(e) {
          var i = e.value,
            t = i.history;
          if (t) {
            var a = t,
              n = a.undos,
              o = a.redos,
              r = o.peek();
            r && (o = o.pop(), n = n.push(r), r.forEach(function (i) {
              var t = i,
                a = t.type,
                n = t.properties;
              "set_selection" == a && (i = i.set("properties", p()(n, "isFocused"))), e.withoutSaving(function () {
                e.applyOperation(i);
              });
            }), i = e.value, t = t.set("undos", n).set("redos", o), i = i.set("history", t), e.value = i);
          }
        },
        undo: function undo(e) {
          var i = e.value,
            t = i.history;
          if (t) {
            var a = t,
              n = a.undos,
              o = a.redos,
              r = n.peek();
            r && (n = n.pop(), o = o.push(r), r.slice().reverse().map(function (e) {
              return e.invert();
            }).forEach(function (i) {
              var t = i,
                a = t.type,
                n = t.properties;
              "set_selection" == a && (i = i.set("properties", p()(n, "isFocused"))), e.withoutSaving(function () {
                e.applyOperation(i);
              });
            }), i = e.value, t = t.set("undos", n).set("redos", o), i = i.set("history", t), e.value = i);
          }
        }
      },
      be = {
        key: void 0,
        offset: void 0,
        path: void 0
      },
      ye = function (e) {
        function Point() {
          return D(this, Point), T(this, (Point.__proto__ || Object.getPrototypeOf(Point)).apply(this, arguments));
        }
        return q(Point, e), B(Point, [{
          key: "isAtEndOfNode",
          value: function isAtEndOfNode(e) {
            if (this.isUnset) return !1;
            var i = e.getLastText();
            return this.key === i.key && this.offset === i.text.length;
          }
        }, {
          key: "isAtStartOfNode",
          value: function isAtStartOfNode(e) {
            if (this.isUnset) return !1;
            if (0 != this.offset) return !1;
            var i = e.getFirstText();
            return this.key === i.key;
          }
        }, {
          key: "isInNode",
          value: function isInNode(e) {
            return !this.isUnset && ("text" === e.object && e.key === this.key || !!e.hasNode(this.key));
          }
        }, {
          key: "moveBackward",
          value: function moveBackward() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1;
            return 0 === e ? this : e < 0 ? this.moveForward(-e) : this.setOffset(this.offset - e);
          }
        }, {
          key: "moveForward",
          value: function moveForward() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1;
            return 0 === e ? this : e < 0 ? this.moveBackward(-e) : this.setOffset(this.offset + e);
          }
        }, {
          key: "moveTo",
          value: function moveTo(e) {
            var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
              t = this.key;
            return "number" === typeof e ? (i = e, e = this.path) : "string" === typeof e ? e = (t = e) === this.key ? this.path : null : t = e.equals(this.path) ? this.key : null, this.merge({
              key: t,
              path: e,
              offset: i
            });
          }
        }, {
          key: "moveToStartOfNode",
          value: function moveToStartOfNode(e) {
            var i = e.getFirstText();
            return this.moveTo(i.key, 0);
          }
        }, {
          key: "moveToEndOfNode",
          value: function moveToEndOfNode(e) {
            var i = e.getLastText();
            return this.moveTo(i.key, i.text.length);
          }
        }, {
          key: "normalize",
          value: function normalize(e) {
            if (null == this.key && null == this.path) return this.setOffset(null);
            var i = this.key,
              t = this.offset,
              a = this.path,
              n = e.getNode(i || a);
            if (!n) {
              u(!1, "A point's `path` or `key` invalid and was reset!");
              var o = e.getFirstText();
              return o ? this.merge({
                key: o.key,
                offset: 0,
                path: e.getPath(o.key)
              }) : Point.create();
            }
            if ("text" !== n.object) {
              u(!1, "A point should not reference a non-text node!");
              var r = n.getTextAtOffset(t),
                s = n.getOffset(r.key);
              return this.merge({
                offset: t - s,
                key: r.key,
                path: e.getPath(r.key)
              });
            }
            return n && a && i && i !== n.key && u(!1, "A point's `key` did not match its `path`!"), this.merge({
              key: n.key,
              path: null == a ? e.getPath(n.key) : a,
              offset: null == t ? 0 : Math.min(t, n.text.length)
            });
          }
        }, {
          key: "setKey",
          value: function setKey(e) {
            return null !== e && (e = x.create(e)), this.set("key", e);
          }
        }, {
          key: "setOffset",
          value: function setOffset(e) {
            return this.set("offset", e);
          }
        }, {
          key: "setPath",
          value: function setPath(e) {
            return null !== e && (e = ge.create(e)), this.set("path", e);
          }
        }, {
          key: "toJSON",
          value: function toJSON() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              i = {
                object: this.object,
                key: this.key,
                offset: this.offset,
                path: this.path && this.path.toArray()
              };
            return e.preserveKeys || delete i.key, i;
          }
        }, {
          key: "unset",
          value: function unset() {
            return this.merge({
              key: null,
              offset: null,
              path: null
            });
          }
        }, {
          key: "isSet",
          get: function get$$1() {
            return null != this.key && null != this.offset && null != this.path;
          }
        }, {
          key: "isUnset",
          get: function get$$1() {
            return !this.isSet;
          }
        }], [{
          key: "create",
          value: function create() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            if (Point.isPoint(e)) return e;
            if (d()(e)) return Point.fromJSON(e);
            throw new Error("`Point.create` only accepts objects or points, but you passed it: " + e);
          }
        }, {
          key: "createProperties",
          value: function createProperties() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            if (Point.isPoint(e)) return {
              key: e.key,
              offset: e.offset,
              path: e.path
            };
            if (d()(e)) {
              var i = {};
              return "key" in e && (i.key = e.key), "offset" in e && (i.offset = e.offset), "path" in e && (i.path = ge.create(e.path)), "path" in e && !("key" in e) && (i.key = null), "key" in e && !("path" in e) && (i.path = null), i;
            }
            throw new Error("`Point.createProperties` only accepts objects or points, but you passed it: " + e);
          }
        }, {
          key: "fromJSON",
          value: function fromJSON(e) {
            var i = e.key,
              t = void 0 === i ? null : i,
              a = e.offset,
              n = void 0 === a ? null : a,
              o = e.path,
              r = void 0 === o ? null : o;
            return new Point({
              key: t,
              offset: n,
              path: ge.create(r)
            });
          }
        }]), Point;
      }(Object(m.Record)(be)),
      ke = {
        anchor: void 0,
        focus: void 0,
        mark: void 0
      },
      ve = function (e) {
        function Decoration() {
          return D(this, Decoration), T(this, (Decoration.__proto__ || Object.getPrototypeOf(Decoration)).apply(this, arguments));
        }
        return q(Decoration, e), B(Decoration, [{
          key: "setProperties",
          value: function setProperties(e) {
            var i = e = Decoration.createProperties(e),
              t = i.anchor,
              a = i.focus,
              n = i.mark,
              o = {};
            return t && (o.anchor = ye.create(t)), a && (o.focus = ye.create(a)), n && (o.mark = U.create(n)), this.merge(o);
          }
        }, {
          key: "toJSON",
          value: function toJSON() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return {
              object: this.object,
              anchor: this.anchor.toJSON(e),
              focus: this.focus.toJSON(e),
              mark: this.mark.toJSON(e)
            };
          }
        }], [{
          key: "create",
          value: function create() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            if (Decoration.isDecoration(e)) return e;
            if (Ae.isRange(e)) return Decoration.fromJSON(Ae.createProperties(e));
            if (d()(e)) return Decoration.fromJSON(e);
            throw new Error("`Decoration.create` only accepts objects or decorations, but you passed it: " + e);
          }
        }, {
          key: "createList",
          value: function createList() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
            if (m.List.isList(e) || Array.isArray(e)) return new m.List(e.map(Decoration.create));
            throw new Error("`Decoration.createList` only accepts arrays or lists, but you passed it: " + e);
          }
        }, {
          key: "createProperties",
          value: function createProperties() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            if (Decoration.isDecoration(e)) return {
              anchor: ye.createProperties(e.anchor),
              focus: ye.createProperties(e.focus),
              mark: U.create(e.mark)
            };
            if (d()(e)) {
              var i = {};
              return "anchor" in e && (i.anchor = ye.create(e.anchor)), "focus" in e && (i.focus = ye.create(e.focus)), "mark" in e && (i.mark = U.create(e.mark)), i;
            }
            throw new Error("`Decoration.createProperties` only accepts objects or decorations, but you passed it: " + e);
          }
        }, {
          key: "fromJSON",
          value: function fromJSON(e) {
            var i = e.anchor,
              t = e.focus,
              a = e.mark;
            if (!a) throw new Error("Decorations must be created with a `mark`, but you passed: " + JSON.stringify(e));
            return new Decoration({
              anchor: ye.fromJSON(i || {}),
              focus: ye.fromJSON(t || {}),
              mark: U.fromJSON(a)
            });
          }
        }]), Decoration;
      }(Object(m.Record)(ke)),
      we = {
        block: "@@__SLATE_BLOCK__@@",
        change: "@@__SLATE_CHANGE__@@",
        decoration: "@@__SLATE_DECORATION__@@",
        document: "@@__SLATE_DOCUMENT__@@",
        history: "@@__SLATE_HISTORY__@@",
        inline: "@@__SLATE_INLINE__@@",
        leaf: "@@__SLATE_LEAF__@@",
        mark: "@@__SLATE_MARK__@@",
        operation: "@@__SLATE_OPERATION__@@",
        point: "@@__SLATE_POINT__@@",
        range: "@@__SLATE_RANGE__@@",
        schema: "@@__SLATE_SCHEMA__@@",
        selection: "@@__SLATE_SELECTION__@@",
        stack: "@@__SLATE_STACK__@@",
        text: "@@__SLATE_TEXT__@@",
        value: "@@__SLATE_VALUE__@@"
      };
    function isObject(e, i) {
      return !(!i || !i[we[e]]);
    }
    var Ee = {
        anchor: void 0,
        focus: void 0
      },
      Ae = function (e) {
        function Range() {
          return D(this, Range), T(this, (Range.__proto__ || Object.getPrototypeOf(Range)).apply(this, arguments));
        }
        return q(Range, e), B(Range, [{
          key: "toJSON",
          value: function toJSON() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return {
              object: this.object,
              anchor: this.anchor.toJSON(e),
              focus: this.focus.toJSON(e)
            };
          }
        }], [{
          key: "create",
          value: function create() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            if (Range.isRange(e)) return "range" === e.object ? e : Range.fromJSON(Range.createProperties(e));
            if (d()(e)) return Range.fromJSON(e);
            throw new Error("`Range.create` only accepts objects or ranges, but you passed it: " + e);
          }
        }, {
          key: "createList",
          value: function createList() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
            if (m.List.isList(e) || Array.isArray(e)) return new m.List(e.map(Range.create));
            throw new Error("`Range.createList` only accepts arrays or lists, but you passed it: " + e);
          }
        }, {
          key: "createProperties",
          value: function createProperties() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            if (Range.isRange(e)) return {
              anchor: ye.createProperties(e.anchor),
              focus: ye.createProperties(e.focus)
            };
            if (d()(e)) {
              var i = {};
              return "anchor" in e && (i.anchor = ye.create(e.anchor)), "focus" in e && (i.focus = ye.create(e.focus)), i;
            }
            throw new Error("`Range.createProperties` only accepts objects, decorations, ranges or selections, but you passed it: " + e);
          }
        }, {
          key: "fromJSON",
          value: function fromJSON(e) {
            var i = e.anchor,
              t = e.focus;
            return new Range({
              anchor: ye.fromJSON(i || {}),
              focus: ye.fromJSON(t || {})
            });
          }
        }, {
          key: "isRange",
          value: function isRange(e) {
            return isObject("range", e) || ve.isDecoration(e) || xe.isSelection(e);
          }
        }]), Range;
      }(Object(m.Record)(Ee)),
      je = {
        anchor: void 0,
        focus: void 0,
        isFocused: void 0,
        marks: void 0
      },
      xe = function (e) {
        function Selection() {
          return D(this, Selection), T(this, (Selection.__proto__ || Object.getPrototypeOf(Selection)).apply(this, arguments));
        }
        return q(Selection, e), B(Selection, [{
          key: "setIsFocused",
          value: function setIsFocused(e) {
            return this.set("isFocused", e);
          }
        }, {
          key: "setMarks",
          value: function setMarks(e) {
            return this.set("marks", e);
          }
        }, {
          key: "setProperties",
          value: function setProperties(e) {
            var i = e = Selection.createProperties(e),
              t = i.anchor,
              a = i.focus,
              n = O(i, ["anchor", "focus"]);
            return t && (n.anchor = ye.create(t)), a && (n.focus = ye.create(a)), this.merge(n);
          }
        }, {
          key: "toJSON",
          value: function toJSON() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return {
              object: this.object,
              anchor: this.anchor.toJSON(e),
              focus: this.focus.toJSON(e),
              isFocused: this.isFocused,
              marks: null == this.marks ? null : this.marks.toArray().map(function (e) {
                return e.toJSON();
              })
            };
          }
        }, {
          key: "isBlurred",
          get: function get$$1() {
            return !this.isFocused;
          }
        }], [{
          key: "create",
          value: function create() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            if (Selection.isSelection(e)) return e;
            if (Ae.isRange(e)) return Selection.fromJSON(Ae.createProperties(e));
            if (d()(e)) return Selection.fromJSON(e);
            throw new Error("`Selection.create` only accepts objects, ranges or selections, but you passed it: " + e);
          }
        }, {
          key: "createProperties",
          value: function createProperties() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            if (Selection.isSelection(e)) return {
              anchor: ye.createProperties(e.anchor),
              focus: ye.createProperties(e.focus),
              isFocused: e.isFocused,
              marks: e.marks
            };
            if (Ae.isRange(e)) return {
              anchor: ye.createProperties(e.anchor),
              focus: ye.createProperties(e.focus)
            };
            if (d()(e)) {
              var i = {};
              return "anchor" in e && (i.anchor = ye.create(e.anchor)), "focus" in e && (i.focus = ye.create(e.focus)), "isFocused" in e && (i.isFocused = e.isFocused), "marks" in e && (i.marks = null == e.marks ? null : U.createSet(e.marks)), i;
            }
            throw new Error("`Selection.createProperties` only accepts objects, ranges or selections, but you passed it: " + e);
          }
        }, {
          key: "fromJSON",
          value: function fromJSON(e) {
            var i = e.anchor,
              t = e.focus,
              a = e.isFocused,
              n = void 0 !== a && a,
              o = e.marks,
              r = void 0 === o ? null : o;
            return new Selection({
              anchor: ye.fromJSON(i || {}),
              focus: ye.fromJSON(t || {}),
              isFocused: n,
              marks: null == r ? null : new m.Set(r.map(U.fromJSON))
            });
          }
        }]), Selection;
      }(Object(m.Record)(je)),
      Ce = {};
    function proxy(e, i) {
      for (var t, a = arguments.length, n = Array(a > 2 ? a - 2 : 0), o = 2; o < a; o++) {
        n[o - 2] = arguments[o];
      }
      var r = (t = e.value.selection)[i].apply(t, n);
      e.select(r);
    }
    function pointEdgeObject(e, i, t, a) {
      var n = i.slice(0, 1).toUpperCase() + i.slice(1),
        o = t.slice(0, 1).toUpperCase() + t.slice(1),
        r = a.slice(0, 1).toUpperCase() + a.slice(1),
        s = "move" + n + "To" + o + "OfNode",
        _ = "text" == a ? "getNode" : "getClosest" + r,
        l = e.value,
        g = l.document,
        f = l.selection[i],
        h = g[_](f.key);
      h && e[s](h);
    }
    function pointEdgeSideObject(e, i, t, a, n) {
      var o = i.slice(0, 1).toUpperCase() + i.slice(1),
        r = t.slice(0, 1).toUpperCase() + t.slice(1),
        s = a.slice(0, 1).toUpperCase() + a.slice(1),
        _ = n.slice(0, 1).toUpperCase() + n.slice(1),
        l = "move" + o + "To" + r + "OfNode",
        g = "text" == n ? "getNode" : "getClosest" + _,
        f = "get" + s + _,
        h = e.value,
        d = h.document,
        m = h.selection[i],
        u = d[g](m.key);
      if (u) {
        var c = d[f](u.key);
        c && e[l](c);
      }
    }
    function pointBackward(e, i) {
      var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
      if (0 !== t) {
        if (t < 0) return pointForward(e, i, -t);
        var a = i.slice(0, 1).toUpperCase() + i.slice(1),
          n = e.value,
          o = n.document,
          r = n.selection,
          s = n.schema,
          _ = r[i],
          l = o.hasVoidParent(_.path, s);
        if (!l && _.offset - t >= 0) {
          var g = r["move" + a + "Backward"](t);
          e.select(g);
        } else {
          var f = o.getPreviousText(_.path);
          if (f) {
            var h = o.getClosestBlock(_.path).hasNode(f.key),
              d = f && o.hasVoidParent(f.key, s);
            if (e["move" + a + "ToEndOfNode"](f), !l && !d && h) {
              var m = e.value.selection["move" + a + "Backward"](t);
              e.select(m);
            }
          }
        }
      }
    }
    function pointForward(e, i) {
      var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
      if (0 !== t) {
        if (t < 0) return pointBackward(e, i, -t);
        var a = i.slice(0, 1).toUpperCase() + i.slice(1),
          n = e.value,
          o = n.document,
          r = n.selection,
          s = n.schema,
          _ = r[i],
          l = o.getNode(_.path),
          g = o.hasVoidParent(_.path, s);
        if (!g && _.offset + t <= l.text.length) {
          var f = r["move" + a + "Forward"](t);
          e.select(f);
        } else {
          var h = o.getNextText(_.path);
          if (h) {
            var d = o.getClosestBlock(_.path).hasNode(h.key),
              m = o.hasVoidParent(h.key, s);
            if (e["move" + a + "ToStartOfNode"](h), !g && !m && d) {
              var u = e.value.selection["move" + a + "Forward"](t);
              e.select(u);
            }
          }
        }
      }
    }
    Ce.blur = function (e) {
      e.select({
        isFocused: !1
      });
    }, Ce.deselect = function (e) {
      var i = xe.create();
      e.select(i);
    }, Ce.focus = function (e) {
      e.select({
        isFocused: !0
      });
    }, Ce.flip = function (e) {
      e.call(proxy, "flip");
    }, Ce.moveAnchorBackward = function (e) {
      for (var i = arguments.length, t = Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++) {
        t[a - 1] = arguments[a];
      }
      e.call.apply(e, [pointBackward, "anchor"].concat(t));
    }, Ce.moveAnchorForward = function (e) {
      for (var i = arguments.length, t = Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++) {
        t[a - 1] = arguments[a];
      }
      e.call.apply(e, [pointForward, "anchor"].concat(t));
    }, Ce.moveAnchorTo = function (e) {
      for (var i = arguments.length, t = Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++) {
        t[a - 1] = arguments[a];
      }
      e.call.apply(e, [proxy, "moveAnchorTo"].concat(t));
    }, Ce.moveAnchorToEndOfBlock = function (e) {
      e.call(pointEdgeObject, "anchor", "end", "block");
    }, Ce.moveAnchorToEndOfInline = function (e) {
      e.call(pointEdgeObject, "anchor", "end", "inline");
    }, Ce.moveAnchorToEndOfDocument = function (e) {
      e.moveAnchorToEndOfNode(e.value.document).moveToAnchor();
    }, Ce.moveAnchorToEndOfNextBlock = function (e) {
      e.call(pointEdgeSideObject, "anchor", "end", "next", "block");
    }, Ce.moveAnchorToEndOfNextInline = function (e) {
      e.call(pointEdgeSideObject, "anchor", "end", "next", "inline");
    }, Ce.moveAnchorToEndOfNextText = function (e) {
      e.call(pointEdgeSideObject, "anchor", "end", "next", "text");
    }, Ce.moveAnchorToEndOfNode = function (e) {
      for (var i = arguments.length, t = Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++) {
        t[a - 1] = arguments[a];
      }
      e.call.apply(e, [proxy, "moveAnchorToEndOfNode"].concat(t));
    }, Ce.moveAnchorToEndOfPreviousBlock = function (e) {
      e.call(pointEdgeSideObject, "anchor", "end", "previous", "block");
    }, Ce.moveAnchorToEndOfPreviousInline = function (e) {
      e.call(pointEdgeSideObject, "anchor", "end", "previous", "inline");
    }, Ce.moveAnchorToEndOfPreviousText = function (e) {
      e.call(pointEdgeSideObject, "anchor", "end", "previous", "text");
    }, Ce.moveAnchorToEndOfText = function (e) {
      e.call(pointEdgeObject, "anchor", "end", "text");
    }, Ce.moveAnchorToStartOfBlock = function (e) {
      e.call(pointEdgeObject, "anchor", "start", "block");
    }, Ce.moveAnchorToStartOfDocument = function (e) {
      e.moveAnchorToStartOfNode(e.value.document).moveToAnchor();
    }, Ce.moveAnchorToStartOfInline = function (e) {
      e.call(pointEdgeObject, "anchor", "start", "inline");
    }, Ce.moveAnchorToStartOfNextBlock = function (e) {
      e.call(pointEdgeSideObject, "anchor", "start", "next", "block");
    }, Ce.moveAnchorToStartOfNextInline = function (e) {
      e.call(pointEdgeSideObject, "anchor", "start", "next", "inline");
    }, Ce.moveAnchorToStartOfNextText = function (e) {
      e.call(pointEdgeSideObject, "anchor", "start", "next", "text");
    }, Ce.moveAnchorToStartOfNode = function (e) {
      for (var i = arguments.length, t = Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++) {
        t[a - 1] = arguments[a];
      }
      e.call.apply(e, [proxy, "moveAnchorToStartOfNode"].concat(t));
    }, Ce.moveAnchorToStartOfPreviousBlock = function (e) {
      e.call(pointEdgeSideObject, "anchor", "start", "previous", "block");
    }, Ce.moveAnchorToStartOfPreviousInline = function (e) {
      e.call(pointEdgeSideObject, "anchor", "start", "previous", "inline");
    }, Ce.moveAnchorToStartOfPreviousText = function (e) {
      e.call(pointEdgeSideObject, "anchor", "start", "previous", "text");
    }, Ce.moveAnchorToStartOfText = function (e) {
      e.call(pointEdgeObject, "anchor", "start", "text");
    }, Ce.moveBackward = function (e) {
      for (var i, t = arguments.length, a = Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) {
        a[n - 1] = arguments[n];
      }
      (i = e.moveAnchorBackward.apply(e, a)).moveFocusBackward.apply(i, a);
    }, Ce.moveEndBackward = function (e) {
      for (var i = arguments.length, t = Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++) {
        t[a - 1] = arguments[a];
      }
      e.call.apply(e, [pointBackward, "end"].concat(t));
    }, Ce.moveEndForward = function (e) {
      for (var i = arguments.length, t = Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++) {
        t[a - 1] = arguments[a];
      }
      e.call.apply(e, [pointForward, "end"].concat(t));
    }, Ce.moveEndTo = function (e) {
      for (var i = arguments.length, t = Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++) {
        t[a - 1] = arguments[a];
      }
      e.call.apply(e, [proxy, "moveEndTo"].concat(t));
    }, Ce.moveEndToEndOfBlock = function (e) {
      e.call(pointEdgeObject, "end", "end", "block");
    }, Ce.moveEndToEndOfDocument = function (e) {
      e.moveEndToEndOfNode(e.value.document).moveToEnd();
    }, Ce.moveEndToEndOfInline = function (e) {
      e.call(pointEdgeObject, "end", "end", "inline");
    }, Ce.moveEndToEndOfNextBlock = function (e) {
      e.call(pointEdgeSideObject, "end", "end", "next", "block");
    }, Ce.moveEndToEndOfNextInline = function (e) {
      e.call(pointEdgeSideObject, "end", "end", "next", "inline");
    }, Ce.moveEndToEndOfNextText = function (e) {
      e.call(pointEdgeSideObject, "end", "end", "next", "text");
    }, Ce.moveEndToEndOfNode = function (e) {
      for (var i = arguments.length, t = Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++) {
        t[a - 1] = arguments[a];
      }
      e.call.apply(e, [proxy, "moveEndToEndOfNode"].concat(t));
    }, Ce.moveEndToEndOfPreviousBlock = function (e) {
      e.call(pointEdgeSideObject, "end", "end", "previous", "block");
    }, Ce.moveEndToEndOfPreviousInline = function (e) {
      e.call(pointEdgeSideObject, "end", "end", "previous", "inline");
    }, Ce.moveEndToEndOfPreviousText = function (e) {
      e.call(pointEdgeSideObject, "end", "end", "previous", "text");
    }, Ce.moveEndToEndOfText = function (e) {
      e.call(pointEdgeObject, "end", "end", "text");
    }, Ce.moveEndToStartOfBlock = function (e) {
      e.call(pointEdgeObject, "end", "start", "block");
    }, Ce.moveEndToStartOfDocument = function (e) {
      e.moveEndToStartOfNode(e.value.document).moveToEnd();
    }, Ce.moveEndToStartOfInline = function (e) {
      e.call(pointEdgeObject, "end", "start", "inline");
    }, Ce.moveEndToStartOfNextBlock = function (e) {
      e.call(pointEdgeSideObject, "end", "start", "next", "block");
    }, Ce.moveEndToStartOfNextInline = function (e) {
      e.call(pointEdgeSideObject, "end", "start", "next", "inline");
    }, Ce.moveEndToStartOfNextText = function (e) {
      e.call(pointEdgeSideObject, "end", "start", "next", "text");
    }, Ce.moveEndToStartOfNode = function (e) {
      for (var i = arguments.length, t = Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++) {
        t[a - 1] = arguments[a];
      }
      e.call.apply(e, [proxy, "moveEndToStartOfNode"].concat(t));
    }, Ce.moveEndToStartOfPreviousBlock = function (e) {
      e.call(pointEdgeSideObject, "end", "start", "previous", "block");
    }, Ce.moveEndToStartOfPreviousInline = function (e) {
      e.call(pointEdgeSideObject, "end", "start", "previous", "inline");
    }, Ce.moveEndToStartOfPreviousText = function (e) {
      e.call(pointEdgeSideObject, "end", "start", "previous", "text");
    }, Ce.moveEndToStartOfText = function (e) {
      e.call(pointEdgeObject, "end", "start", "text");
    }, Ce.moveFocusBackward = function (e) {
      for (var i = arguments.length, t = Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++) {
        t[a - 1] = arguments[a];
      }
      e.call.apply(e, [pointBackward, "focus"].concat(t));
    }, Ce.moveFocusForward = function (e) {
      for (var i = arguments.length, t = Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++) {
        t[a - 1] = arguments[a];
      }
      e.call.apply(e, [pointForward, "focus"].concat(t));
    }, Ce.moveFocusTo = function (e) {
      for (var i = arguments.length, t = Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++) {
        t[a - 1] = arguments[a];
      }
      e.call.apply(e, [proxy, "moveFocusTo"].concat(t));
    }, Ce.moveFocusToEndOfBlock = function (e) {
      e.call(pointEdgeObject, "focus", "end", "block");
    }, Ce.moveFocusToEndOfDocument = function (e) {
      e.moveFocusToEndOfNode(e.value.document).moveToFocus();
    }, Ce.moveFocusToEndOfInline = function (e) {
      e.call(pointEdgeObject, "focus", "end", "inline");
    }, Ce.moveFocusToEndOfNextBlock = function (e) {
      e.call(pointEdgeSideObject, "focus", "end", "next", "block");
    }, Ce.moveFocusToEndOfNextInline = function (e) {
      e.call(pointEdgeSideObject, "focus", "end", "next", "inline");
    }, Ce.moveFocusToEndOfNextText = function (e) {
      e.call(pointEdgeSideObject, "focus", "end", "next", "text");
    }, Ce.moveFocusToEndOfNode = function (e) {
      for (var i = arguments.length, t = Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++) {
        t[a - 1] = arguments[a];
      }
      e.call.apply(e, [proxy, "moveFocusToEndOfNode"].concat(t));
    }, Ce.moveFocusToEndOfPreviousBlock = function (e) {
      e.call(pointEdgeSideObject, "focus", "end", "previous", "block");
    }, Ce.moveFocusToEndOfPreviousInline = function (e) {
      e.call(pointEdgeSideObject, "focus", "end", "previous", "inline");
    }, Ce.moveFocusToEndOfPreviousText = function (e) {
      e.call(pointEdgeSideObject, "focus", "end", "previous", "text");
    }, Ce.moveFocusToEndOfText = function (e) {
      e.call(pointEdgeObject, "focus", "end", "text");
    }, Ce.moveFocusToStartOfBlock = function (e) {
      e.call(pointEdgeObject, "focus", "start", "block");
    }, Ce.moveFocusToStartOfDocument = function (e) {
      e.moveFocusToStartOfNode(e.value.document).moveToFocus();
    }, Ce.moveFocusToStartOfInline = function (e) {
      e.call(pointEdgeObject, "focus", "start", "inline");
    }, Ce.moveFocusToStartOfNextBlock = function (e) {
      e.call(pointEdgeSideObject, "focus", "start", "next", "block");
    }, Ce.moveFocusToStartOfNextInline = function (e) {
      e.call(pointEdgeSideObject, "focus", "start", "next", "inline");
    }, Ce.moveFocusToStartOfNextText = function (e) {
      e.call(pointEdgeSideObject, "focus", "start", "next", "text");
    }, Ce.moveFocusToStartOfNode = function (e) {
      for (var i = arguments.length, t = Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++) {
        t[a - 1] = arguments[a];
      }
      e.call.apply(e, [proxy, "moveFocusToStartOfNode"].concat(t));
    }, Ce.moveFocusToStartOfPreviousBlock = function (e) {
      e.call(pointEdgeSideObject, "focus", "start", "previous", "block");
    }, Ce.moveFocusToStartOfPreviousInline = function (e) {
      e.call(pointEdgeSideObject, "focus", "start", "previous", "inline");
    }, Ce.moveFocusToStartOfPreviousText = function (e) {
      e.call(pointEdgeSideObject, "focus", "start", "previous", "text");
    }, Ce.moveFocusToStartOfText = function (e) {
      e.call(pointEdgeObject, "focus", "start", "text");
    }, Ce.moveForward = function (e) {
      for (var i, t = arguments.length, a = Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) {
        a[n - 1] = arguments[n];
      }
      (i = e.moveAnchorForward.apply(e, a)).moveFocusForward.apply(i, a);
    }, Ce.moveStartBackward = function (e) {
      for (var i = arguments.length, t = Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++) {
        t[a - 1] = arguments[a];
      }
      e.call.apply(e, [pointBackward, "start"].concat(t));
    }, Ce.moveStartForward = function (e) {
      for (var i = arguments.length, t = Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++) {
        t[a - 1] = arguments[a];
      }
      e.call.apply(e, [pointForward, "start"].concat(t));
    }, Ce.moveStartTo = function (e) {
      for (var i = arguments.length, t = Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++) {
        t[a - 1] = arguments[a];
      }
      e.call.apply(e, [proxy, "moveStartTo"].concat(t));
    }, Ce.moveStartToEndOfBlock = function (e) {
      e.call(pointEdgeObject, "start", "end", "block");
    }, Ce.moveStartToEndOfDocument = function (e) {
      e.moveStartToEndOfNode(e.value.document).moveToStart();
    }, Ce.moveStartToEndOfInline = function (e) {
      e.call(pointEdgeObject, "start", "end", "inline");
    }, Ce.moveStartToEndOfNextBlock = function (e) {
      e.call(pointEdgeSideObject, "start", "end", "next", "block");
    }, Ce.moveStartToEndOfNextInline = function (e) {
      e.call(pointEdgeSideObject, "start", "end", "next", "inline");
    }, Ce.moveStartToEndOfNextText = function (e) {
      e.call(pointEdgeSideObject, "start", "end", "next", "text");
    }, Ce.moveStartToEndOfNode = function (e) {
      for (var i = arguments.length, t = Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++) {
        t[a - 1] = arguments[a];
      }
      e.call.apply(e, [proxy, "moveStartToEndOfNode"].concat(t));
    }, Ce.moveStartToEndOfPreviousBlock = function (e) {
      e.call(pointEdgeSideObject, "start", "end", "previous", "block");
    }, Ce.moveStartToEndOfPreviousInline = function (e) {
      e.call(pointEdgeSideObject, "start", "end", "previous", "inline");
    }, Ce.moveStartToEndOfPreviousText = function (e) {
      e.call(pointEdgeSideObject, "start", "end", "previous", "text");
    }, Ce.moveStartToEndOfText = function (e) {
      e.call(pointEdgeObject, "start", "end", "text");
    }, Ce.moveStartToStartOfBlock = function (e) {
      e.call(pointEdgeObject, "start", "start", "block");
    }, Ce.moveStartToStartOfDocument = function (e) {
      e.moveStartToStartOfNode(e.value.document).moveToStart();
    }, Ce.moveStartToStartOfInline = function (e) {
      e.call(pointEdgeObject, "start", "start", "inline");
    }, Ce.moveStartToStartOfNextBlock = function (e) {
      e.call(pointEdgeSideObject, "start", "start", "next", "block");
    }, Ce.moveStartToStartOfNextInline = function (e) {
      e.call(pointEdgeSideObject, "start", "start", "next", "inline");
    }, Ce.moveStartToStartOfNextText = function (e) {
      e.call(pointEdgeSideObject, "start", "start", "next", "text");
    }, Ce.moveStartToStartOfNode = function (e) {
      for (var i = arguments.length, t = Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++) {
        t[a - 1] = arguments[a];
      }
      e.call.apply(e, [proxy, "moveStartToStartOfNode"].concat(t));
    }, Ce.moveStartToStartOfPreviousBlock = function (e) {
      e.call(pointEdgeSideObject, "start", "start", "previous", "block");
    }, Ce.moveStartToStartOfPreviousInline = function (e) {
      e.call(pointEdgeSideObject, "start", "start", "previous", "inline");
    }, Ce.moveStartToStartOfPreviousText = function (e) {
      e.call(pointEdgeSideObject, "start", "start", "previous", "text");
    }, Ce.moveStartToStartOfText = function (e) {
      e.call(pointEdgeObject, "start", "start", "text");
    }, Ce.moveTo = function (e) {
      for (var i = arguments.length, t = Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++) {
        t[a - 1] = arguments[a];
      }
      e.call.apply(e, [proxy, "moveTo"].concat(t));
    }, Ce.moveToAnchor = function (e) {
      e.call(proxy, "moveToAnchor");
    }, Ce.moveToEnd = function (e) {
      e.call(proxy, "moveToEnd");
    }, Ce.moveToEndOfBlock = function (e) {
      e.moveEndToEndOfBlock().moveToEnd();
    }, Ce.moveToEndOfDocument = function (e) {
      e.moveEndToEndOfNode(e.value.document).moveToEnd();
    }, Ce.moveToEndOfInline = function (e) {
      e.moveEndToEndOfInline().moveToEnd();
    }, Ce.moveToEndOfNextBlock = function (e) {
      e.moveEndToEndOfNextBlock().moveToEnd();
    }, Ce.moveToEndOfNextInline = function (e) {
      e.moveEndToEndOfNextInline().moveToEnd();
    }, Ce.moveToEndOfNextText = function (e) {
      e.moveEndToEndOfNextText().moveToEnd();
    }, Ce.moveToEndOfNode = function (e) {
      for (var i = arguments.length, t = Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++) {
        t[a - 1] = arguments[a];
      }
      e.call.apply(e, [proxy, "moveToEndOfNode"].concat(t));
    }, Ce.moveToEndOfPreviousBlock = function (e) {
      e.moveStartToEndOfPreviousBlock().moveToStart();
    }, Ce.moveToEndOfPreviousInline = function (e) {
      e.moveStartToEndOfPreviousInline().moveToStart();
    }, Ce.moveToEndOfPreviousText = function (e) {
      e.moveStartToEndOfPreviousText().moveToStart();
    }, Ce.moveToEndOfText = function (e) {
      e.moveEndToEndOfText().moveToEnd();
    }, Ce.moveToFocus = function (e) {
      e.call(proxy, "moveToFocus");
    }, Ce.moveToRangeOfDocument = function (e) {
      e.moveToRangeOfNode(e.value.document);
    }, Ce.moveToRangeOfNode = function (e) {
      for (var i = arguments.length, t = Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++) {
        t[a - 1] = arguments[a];
      }
      e.call.apply(e, [proxy, "moveToRangeOfNode"].concat(t));
    }, Ce.moveToStart = function (e) {
      e.call(proxy, "moveToStart");
    }, Ce.moveToStartOfBlock = function (e) {
      e.moveStartToStartOfBlock().moveToStart();
    }, Ce.moveToStartOfDocument = function (e) {
      e.moveStartToStartOfNode(e.value.document).moveToStart();
    }, Ce.moveToStartOfInline = function (e) {
      e.moveStartToStartOfInline().moveToStart();
    }, Ce.moveToStartOfNextBlock = function (e) {
      e.moveEndToStartOfNextBlock().moveToEnd();
    }, Ce.moveToStartOfNextInline = function (e) {
      e.moveEndToStartOfNextInline().moveToEnd();
    }, Ce.moveToStartOfNextText = function (e) {
      e.moveEndToStartOfNextText().moveToEnd();
    }, Ce.moveToStartOfNode = function (e) {
      for (var i = arguments.length, t = Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++) {
        t[a - 1] = arguments[a];
      }
      e.call.apply(e, [proxy, "moveToStartOfNode"].concat(t));
    }, Ce.moveToStartOfPreviousBlock = function (e) {
      e.moveStartToStartOfPreviousBlock().moveToStart();
    }, Ce.moveToStartOfPreviousInline = function (e) {
      e.moveStartToStartOfPreviousInline().moveToStart();
    }, Ce.moveToStartOfPreviousText = function (e) {
      e.moveStartToStartOfPreviousText().moveToStart();
    }, Ce.moveToStartOfText = function (e) {
      e.moveStartToStartOfText().moveToStart();
    }, Ce.select = function (e, i) {
      var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
      i = xe.createProperties(i);
      var a = t.snapshot,
        n = void 0 !== a && a,
        o = e.value,
        r = o.document,
        s = o.selection,
        _ = {},
        l = s.setProperties(i);
      for (var g in l = r.resolveSelection(l), i = y()(l, Object.keys(i))) {
        !0 !== n && Object(m.is)(i[g], s[g]) || (_[g] = i[g]);
      }
      s.marks && !_.marks && (_.anchor || _.focus) && (_.marks = null), 0 !== Object.keys(_).length && e.applyOperation({
        type: "set_selection",
        value: o,
        properties: _,
        selection: s.toJSON()
      }, n ? {
        skip: !1,
        merge: !1
      } : {});
    }, Ce.setAnchor = function (e) {
      for (var i = arguments.length, t = Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++) {
        t[a - 1] = arguments[a];
      }
      e.call.apply(e, [proxy, "setAnchor"].concat(t));
    }, Ce.setEnd = function (e) {
      for (var i = arguments.length, t = Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++) {
        t[a - 1] = arguments[a];
      }
      e.call.apply(e, [proxy, "setEnd"].concat(t));
    }, Ce.setFocus = function (e) {
      for (var i = arguments.length, t = Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++) {
        t[a - 1] = arguments[a];
      }
      e.call.apply(e, [proxy, "setFocus"].concat(t));
    }, Ce.setStart = function (e) {
      for (var i = arguments.length, t = Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++) {
        t[a - 1] = arguments[a];
      }
      e.call.apply(e, [proxy, "setStart"].concat(t));
    }, Ce.snapshotSelection = function (e) {
      e.withoutMerging(function (i) {
        return i.select(e.value.selection, {
          snapshot: !0
        });
      });
    };
    var De = v()("slate:history"),
      Be = {
        redos: void 0,
        undos: void 0
      },
      Se = function (e) {
        function History() {
          return D(this, History), T(this, (History.__proto__ || Object.getPrototypeOf(History)).apply(this, arguments));
        }
        return q(History, e), B(History, [{
          key: "save",
          value: function save(e) {
            var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              t = this,
              a = t,
              n = a.undos,
              o = a.redos,
              r = i.merge;
            if (i.skip) return t;
            var s = n.peek(),
              _ = s && s.last();
            if (null == r && (r = function shouldMerge(e, i) {
              return !!i && ("set_selection" == e.type && "set_selection" == i.type || "insert_text" == e.type && "insert_text" == i.type && e.offset == i.offset + i.text.length && e.path.equals(i.path) || "remove_text" == e.type && "remove_text" == i.type && e.offset + e.text.length == i.offset && e.path.equals(i.path));
            }(e, _)), De("save", {
              operation: e,
              merge: r
            }), r && s) {
              var l = s.push(e);
              n = (n = n.pop()).push(l);
            } else {
              var g = new m.List([e]);
              n = n.push(g);
            }
            return n.size > 100 && (n = n.take(100)), o = o.clear(), t = t.set("undos", n).set("redos", o);
          }
        }, {
          key: "toJSON",
          value: function toJSON() {
            return {
              object: this.object,
              redos: this.redos.toJSON(),
              undos: this.undos.toJSON()
            };
          }
        }], [{
          key: "create",
          value: function create() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            if (History.isHistory(e)) return e;
            if (d()(e)) return History.fromJSON(e);
            throw new Error("`History.create` only accepts objects or histories, but you passed it: " + e);
          }
        }, {
          key: "createOperationsList",
          value: function createOperationsList() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
            if (m.List.isList(e)) return e;
            if (Array.isArray(e)) return new m.List(e);
            throw new Error("`History.createList` only accepts arrays or lists, but you passed it: " + e);
          }
        }, {
          key: "fromJSON",
          value: function fromJSON(e) {
            var i = e.redos,
              t = void 0 === i ? [] : i,
              a = e.undos,
              n = void 0 === a ? [] : a;
            return new History({
              redos: new m.Stack(t.map(this.createOperationsList)),
              undos: new m.Stack(n.map(this.createOperationsList))
            });
          }
        }]), History;
      }(Object(m.Record)(Be));
    var qe = {
        plugins: void 0
      },
      Oe = function (e) {
        function Stack$$1() {
          return D(this, Stack$$1), T(this, (Stack$$1.__proto__ || Object.getPrototypeOf(Stack$$1)).apply(this, arguments));
        }
        return q(Stack$$1, e), B(Stack$$1, [{
          key: "getPluginsWith",
          value: function getPluginsWith(e) {
            return this.plugins.filter(function (i) {
              return null != i[e];
            });
          }
        }, {
          key: "find",
          value: function find(e) {
            for (var i = this.getPluginsWith(e), t = arguments.length, a = Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) {
              a[n - 1] = arguments[n];
            }
            var o = !0,
              r = !1,
              s = void 0;
            try {
              for (var _, l = i[Symbol.iterator](); !(o = (_ = l.next()).done); o = !0) {
                var g = _.value,
                  f = g[e].apply(g, a);
                if (null != f) return f;
              }
            } catch (sr) {
              r = !0, s = sr;
            } finally {
              try {
                !o && l.return && l.return();
              } finally {
                if (r) throw s;
              }
            }
          }
        }, {
          key: "map",
          value: function map(e) {
            for (var i = this.getPluginsWith(e), t = [], a = arguments.length, n = Array(a > 1 ? a - 1 : 0), o = 1; o < a; o++) {
              n[o - 1] = arguments[o];
            }
            var r = !0,
              s = !1,
              _ = void 0;
            try {
              for (var l, g = i[Symbol.iterator](); !(r = (l = g.next()).done); r = !0) {
                var f = l.value,
                  h = f[e].apply(f, n);
                null != h && t.push(h);
              }
            } catch (sr) {
              s = !0, _ = sr;
            } finally {
              try {
                !r && g.return && g.return();
              } finally {
                if (s) throw _;
              }
            }
            return t;
          }
        }, {
          key: "run",
          value: function run(e) {
            for (var i = this.getPluginsWith(e), t = arguments.length, a = Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) {
              a[n - 1] = arguments[n];
            }
            var o = !0,
              r = !1,
              s = void 0;
            try {
              for (var _, l = i[Symbol.iterator](); !(o = (_ = l.next()).done); o = !0) {
                var g = _.value;
                if (null != g[e].apply(g, a)) return;
              }
            } catch (sr) {
              r = !0, s = sr;
            } finally {
              try {
                !o && l.return && l.return();
              } finally {
                if (r) throw s;
              }
            }
          }
        }, {
          key: "render",
          value: function render(e, i) {
            for (var t = arguments.length, a = Array(t > 2 ? t - 2 : 0), n = 2; n < t; n++) {
              a[n - 2] = arguments[n];
            }
            return this.getPluginsWith(e).reduceRight(function (t, n) {
              if (!n[e]) return t;
              var o = n[e].apply(n, [i].concat(a));
              return null == o ? t : (i.children = o, o);
            }, void 0 === i.children ? null : i.children);
          }
        }], [{
          key: "create",
          value: function create() {
            var e = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).plugins;
            return new Stack$$1({
              plugins: void 0 === e ? [] : e
            });
          }
        }]), Stack$$1;
      }(Object(m.Record)(qe));
    memoize(Oe.prototype, ["getPluginsWith"]);
    var Te = function (e) {
        function SlateError(e) {
          var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          D(this, SlateError);
          var t = T(this, (SlateError.__proto__ || Object.getPrototypeOf(SlateError)).call(this, e));
          for (var a in t.code = e, i) {
            t[a] = i[a];
          }
          return Error.captureStackTrace ? Error.captureStackTrace(t, t.constructor) : t.stack = new Error().stack, t;
        }
        return q(SlateError, e), SlateError;
      }(Error),
      Ne = v()("slate:schema"),
      Ie = [{
        match: {
          object: "document"
        },
        nodes: [{
          match: {
            object: "block"
          }
        }]
      }, {
        match: {
          object: "block",
          first: {
            object: "block"
          }
        },
        nodes: [{
          match: {
            object: "block"
          }
        }]
      }, {
        match: {
          object: "block",
          first: [{
            object: "inline"
          }, {
            object: "text"
          }]
        },
        nodes: [{
          match: [{
            object: "inline"
          }, {
            object: "text"
          }]
        }]
      }, {
        match: {
          object: "inline"
        },
        nodes: [{
          match: [{
            object: "inline"
          }, {
            object: "text"
          }]
        }]
      }, {
        match: [{
          object: "block"
        }, {
          object: "inline"
        }],
        nodes: [{
          min: 1
        }],
        normalize: function normalize(e, i) {
          var t = i.code,
            a = i.node;
          "child_required" === t && e.insertNodeByKey(a.key, 0, Z.create(), {
            normalize: !1
          });
        }
      }, {
        match: {
          object: "block"
        },
        first: [{
          object: "block"
        }, {
          object: "text"
        }],
        last: [{
          object: "block"
        }, {
          object: "text"
        }],
        normalize: function normalize(e, i) {
          var t = i.code,
            a = i.node,
            n = Z.create(),
            o = void 0;
          if ("first_child_object_invalid" === t) o = 0;else {
            if ("last_child_object_invalid" !== t) return;
            o = a.nodes.size;
          }
          e.insertNodeByKey(a.key, o, n, {
            normalize: !1
          });
        }
      }, {
        match: {
          object: "inline"
        },
        first: [{
          object: "block"
        }, {
          object: "text"
        }],
        last: [{
          object: "block"
        }, {
          object: "text"
        }],
        previous: [{
          object: "block"
        }, {
          object: "text"
        }],
        next: [{
          object: "block"
        }, {
          object: "text"
        }],
        normalize: function normalize(e, i) {
          var t = i.code,
            a = i.node,
            n = i.index,
            o = Z.create(),
            r = void 0;
          if ("first_child_object_invalid" === t) r = 0;else if ("last_child_object_invalid" === t) r = a.nodes.size;else if ("previous_sibling_object_invalid" === t) r = n;else {
            if ("next_sibling_object_invalid" !== t) return;
            r = n + 1;
          }
          e.insertNodeByKey(a.key, r, o, {
            normalize: !1
          });
        }
      }, {
        match: {
          object: "text"
        },
        next: [{
          object: "block"
        }, {
          object: "inline"
        }],
        normalize: function normalize(e, i) {
          var t = i.code,
            a = i.next;
          "next_sibling_object_invalid" === t && e.mergeNodeByKey(a.key, {
            normalize: !1
          });
        }
      }],
      Pe = {
        stack: void 0,
        rules: void 0
      },
      Me = function (e) {
        function Schema() {
          return D(this, Schema), T(this, (Schema.__proto__ || Object.getPrototypeOf(Schema)).apply(this, arguments));
        }
        return q(Schema, e), B(Schema, [{
          key: "getNodeRules",
          value: function getNodeRules(e) {
            return this.rules.filter(function (i) {
              return testRules(e, i.match);
            });
          }
        }, {
          key: "validateNode",
          value: function validateNode(e) {
            var i = validateRules(e, this.getNodeRules(e), this.rules, {
              every: !0
            });
            if (i) return new Te(i.code, i);
          }
        }, {
          key: "testNode",
          value: function testNode(e) {
            return !this.validateNode(e);
          }
        }, {
          key: "assertNode",
          value: function assertNode(e) {
            var i = this.validateNode(e);
            if (i) throw i;
          }
        }, {
          key: "normalizeNode",
          value: function normalizeNode(e) {
            var i = this.stack.find("normalizeNode", e);
            if (i) return i;
            if ("text" != e.object) {
              var t = this.validateNode(e);
              if (t) return function (e) {
                Ne("normalizing", {
                  error: t
                });
                var i = t.rule,
                  a = e.operations.size;
                i.normalize && i.normalize(e, t), e.operations.size === a && function defaultNormalize(e, i) {
                  var t = i.code,
                    a = i.node,
                    n = i.child,
                    o = i.next,
                    r = i.previous,
                    s = i.key,
                    _ = i.mark;
                  switch (t) {
                    case "child_object_invalid":
                    case "child_type_invalid":
                    case "child_unknown":
                    case "first_child_object_invalid":
                    case "first_child_type_invalid":
                    case "last_child_object_invalid":
                    case "last_child_type_invalid":
                      return "text" === n.object && "block" === a.object && 1 === a.nodes.size ? e.removeNodeByKey(a.key, {
                        normalize: !1
                      }) : e.removeNodeByKey(n.key, {
                        normalize: !1
                      });
                    case "previous_sibling_object_invalid":
                    case "previous_sibling_type_invalid":
                      return "text" === r.object && "block" === a.object && 1 === a.nodes.size ? e.removeNodeByKey(a.key, {
                        normalize: !1
                      }) : e.removeNodeByKey(r.key, {
                        normalize: !1
                      });
                    case "next_sibling_object_invalid":
                    case "next_sibling_type_invalid":
                      return "text" === o.object && "block" === a.object && 1 === a.nodes.size ? e.removeNodeByKey(a.key, {
                        normalize: !1
                      }) : e.removeNodeByKey(o.key, {
                        normalize: !1
                      });
                    case "child_required":
                    case "node_text_invalid":
                    case "parent_object_invalid":
                    case "parent_type_invalid":
                      return "document" === a.object ? a.nodes.forEach(function (i) {
                        return e.removeNodeByKey(i.key, {
                          normalize: !1
                        });
                      }) : e.removeNodeByKey(a.key, {
                        normalize: !1
                      });
                    case "node_data_invalid":
                      return void 0 === a.data.get(s) && "document" !== a.object ? e.removeNodeByKey(a.key, {
                        normalize: !1
                      }) : e.setNodeByKey(a.key, {
                        data: a.data.delete(s)
                      }, {
                        normalize: !1
                      });
                    case "node_mark_invalid":
                      return a.getTexts().forEach(function (i) {
                        return e.removeMarkByKey(i.key, 0, i.text.length, _, {
                          normalize: !1
                        });
                      });
                    default:
                      return e.removeNodeByKey(a.key, {
                        normalize: !1
                      });
                  }
                }(e, t);
              };
            }
          }
        }, {
          key: "isAtomic",
          value: function isAtomic(e) {
            var i = this.rules.find(function (i) {
              return "isAtomic" in i && testRules(e, i.match);
            });
            return !!i && i.isAtomic;
          }
        }, {
          key: "isVoid",
          value: function isVoid(e) {
            var i = this.rules.find(function (i) {
              return "isVoid" in i && testRules(e, i.match);
            });
            return !!i && i.isVoid;
          }
        }, {
          key: "toJSON",
          value: function toJSON() {
            return {
              object: this.object,
              rules: this.rules
            };
          }
        }], [{
          key: "create",
          value: function create() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            if (Schema.isSchema(e)) return e;
            if (d()(e)) return Schema.fromJSON(e);
            throw new Error("`Schema.create` only accepts objects or schemas, but you passed it: " + e);
          }
        }, {
          key: "fromJSON",
          value: function fromJSON(e) {
            if (Schema.isSchema(e)) return e;
            var i = e.plugins ? e.plugins : [{
                schema: e
              }],
              t = [].concat(Ie),
              a = !0,
              n = !1,
              o = void 0;
            try {
              for (var r, s = i[Symbol.iterator](); !(a = (r = s.next()).done); a = !0) {
                var _ = r.value.schema,
                  l = void 0 === _ ? {} : _,
                  g = l.blocks,
                  f = void 0 === g ? {} : g,
                  h = l.inlines,
                  d = void 0 === h ? {} : h,
                  m = l.marks,
                  u = void 0 === m ? {} : m;
                for (var c in l.rules && (t = t.concat(l.rules)), l.document && t.push(S({
                  match: [{
                    object: "document"
                  }]
                }, l.document)), f) {
                  t.push(S({
                    match: [{
                      object: "block",
                      type: c
                    }]
                  }, f[c]));
                }
                for (var F in d) {
                  t.push(S({
                    match: [{
                      object: "inline",
                      type: F
                    }]
                  }, d[F]));
                }
                for (var p in u) {
                  t.push(S({
                    match: [{
                      object: "mark",
                      type: p
                    }]
                  }, u[p]));
                }
              }
            } catch (sr) {
              n = !0, o = sr;
            } finally {
              try {
                !a && s.return && s.return();
              } finally {
                if (n) throw o;
              }
            }
            return new Schema({
              stack: Oe.create({
                plugins: i
              }),
              rules: t
            });
          }
        }]), Schema;
      }(Object(m.Record)(Pe));
    function testRules(e, i) {
      return !validateRules(e, i);
    }
    function validateRules(e, i, t) {
      var a = (arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {}).every,
        n = void 0 !== a && a;
      if (Array.isArray(i)) {
        var o = i.length ? i : [{}],
          r = void 0,
          s = !0,
          _ = !1,
          l = void 0;
        try {
          for (var g, f = o[Symbol.iterator](); !(s = (g = f.next()).done); s = !0) {
            var h = validateRules(e, g.value, t);
            if (r = r || h, n && h) return h;
            if (!n && !h) return;
          }
        } catch (sr) {
          _ = !0, l = sr;
        } finally {
          try {
            !s && f.return && f.return();
          } finally {
            if (_) throw l;
          }
        }
        return r;
      }
      return function validateObject(e, i) {
        if (null == i.object) return;
        if (i.object === e.object) return;
        if ("function" === typeof i.object && i.object(e.object)) return;
        return fail("node_object_invalid", {
          rule: i,
          node: e
        });
      }(e, i) || function validateType(e, i) {
        if (null == i.type) return;
        if (i.type === e.type) return;
        if ("function" === typeof i.type && i.type(e.type)) return;
        return fail("node_type_invalid", {
          rule: i,
          node: e
        });
      }(e, i) || function validateData(e, i) {
        if (null == i.data) return;
        if (null == e.data) return;
        if ("function" === typeof i.data) {
          if (i.data(e.data)) return;
          return fail("node_data_invalid", {
            rule: i,
            node: e
          });
        }
        for (var t in i.data) {
          var a = i.data[t],
            n = e.data && e.data.get(t),
            o = "function" === typeof a ? a(n) : a === n;
          if (!o) return fail("node_data_invalid", {
            rule: i,
            node: e,
            key: t,
            value: n
          });
        }
      }(e, i) || function validateMarks(e, i) {
        if (null == i.marks) return;
        var t = e.getMarks().toArray(),
          a = function _loop(t) {
            var a = i.marks.some(function (e) {
              return "function" === typeof e.type ? e.type(t.type) : e.type === t.type;
            });
            return a ? "continue" : {
              v: fail("node_mark_invalid", {
                rule: i,
                node: e,
                mark: t
              })
            };
          },
          n = !0,
          o = !1,
          r = void 0;
        try {
          for (var s, _ = t[Symbol.iterator](); !(n = (s = _.next()).done); n = !0) {
            var l = s.value,
              g = a(l);
            switch (g) {
              case "continue":
                continue;
              default:
                if ("object" === ("undefined" === typeof g ? "undefined" : C(g))) return g.v;
            }
          }
        } catch (sr) {
          o = !0, r = sr;
        } finally {
          try {
            !n && _.return && _.return();
          } finally {
            if (o) throw r;
          }
        }
      }(e, i) || function validateText(e, i) {
        if (null == i.text) return;
        var t = e.text;
        if ("function" === typeof i.text ? i.text(t) : i.text.test(t)) return;
        return fail("node_text_invalid", {
          rule: i,
          node: e,
          text: t
        });
      }(e, i) || function validateFirst(e, i) {
        if (null == i.first) return;
        var t = e.nodes.first();
        if (!t) return;
        var a = validateRules(t, i.first);
        if (!a) return;
        return a.rule = i, a.node = e, a.child = t, a.code = a.code.replace("node_", "first_child_"), a;
      }(e, i) || function validateLast(e, i) {
        if (null == i.last) return;
        var t = e.nodes.last();
        if (!t) return;
        var a = validateRules(t, i.last);
        if (!a) return;
        return a.rule = i, a.node = e, a.child = t, a.code = a.code.replace("node_", "last_child_"), a;
      }(e, i) || function validateNodes(e, i) {
        var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [];
        if (null == e.nodes) return;
        var a = e.nodes.toArray(),
          n = null != i.nodes ? i.nodes.slice() : [],
          o = void 0,
          r = void 0,
          s = void 0,
          _ = void 0,
          l = void 0,
          g = void 0,
          f = void 0,
          h = void 0;
        function nextDef() {
          return o = null == o ? null : 0, _ = n.shift(), r = _ && _.min, l = _ && _.max, !!_;
        }
        function nextChild() {
          return o = null == o ? 0 : o + 1, f = g, g = a[s = null == s ? 0 : s + 1], h = a[s + 1], null != l && o == l && nextDef(), !!g;
        }
        function rewind() {
          o -= 1, s -= 1;
        }
        null != i.nodes && nextDef();
        for (; nextChild();) {
          var d = validateParent(e, g, t) || validatePrevious(e, g, f, s, t) || validateNext(e, g, h, s, t);
          if (d) return d;
          if (null != i.nodes) {
            if (!_) return fail("child_unknown", {
              rule: i,
              node: e,
              child: g,
              index: s
            });
            if (_.match) {
              var m = validateRules(g, _.match);
              if (m && o >= r && nextDef()) {
                rewind();
                continue;
              }
              if (m) return m.rule = i, m.node = e, m.child = g, m.index = s, m.code = m.code.replace("node_", "child_"), m;
            }
          }
        }
        if (null != i.nodes) for (; null != r;) {
          if (o < r) return fail("child_required", {
            rule: i,
            node: e,
            index: s
          });
          nextDef();
        }
      }(e, i, t);
    }
    function validateParent(e, i, t) {
      var a = !0,
        n = !1,
        o = void 0;
      try {
        for (var r, s = t[Symbol.iterator](); !(a = (r = s.next()).done); a = !0) {
          var _ = r.value;
          if (null != _.parent && testRules(i, _.match)) {
            var l = validateRules(e, _.parent);
            if (l) return l.rule = _, l.parent = e, l.node = i, l.code = l.code.replace("node_", "parent_"), l;
          }
        }
      } catch (sr) {
        n = !0, o = sr;
      } finally {
        try {
          !a && s.return && s.return();
        } finally {
          if (n) throw o;
        }
      }
    }
    function validatePrevious(e, i, t, a, n) {
      if (t) {
        var o = !0,
          r = !1,
          s = void 0;
        try {
          for (var _, l = n[Symbol.iterator](); !(o = (_ = l.next()).done); o = !0) {
            var g = _.value;
            if (null != g.previous && testRules(i, g.match)) {
              var f = validateRules(t, g.previous);
              if (f) return f.rule = g, f.node = e, f.child = i, f.index = a, f.previous = t, f.code = f.code.replace("node_", "previous_sibling_"), f;
            }
          }
        } catch (sr) {
          r = !0, s = sr;
        } finally {
          try {
            !o && l.return && l.return();
          } finally {
            if (r) throw s;
          }
        }
      }
    }
    function validateNext(e, i, t, a, n) {
      if (t) {
        var o = !0,
          r = !1,
          s = void 0;
        try {
          for (var _, l = n[Symbol.iterator](); !(o = (_ = l.next()).done); o = !0) {
            var g = _.value;
            if (null != g.next && testRules(i, g.match)) {
              var f = validateRules(t, g.next);
              if (f) return f.rule = g, f.node = e, f.child = i, f.index = a, f.next = t, f.code = f.code.replace("node_", "next_sibling_"), f;
            }
          }
        } catch (sr) {
          r = !0, s = sr;
        } finally {
          try {
            !o && l.return && l.return();
          } finally {
            if (r) throw s;
          }
        }
      }
    }
    function fail(e, i) {
      return S({
        code: e
      }, i);
    }
    var Re = {
        data: void 0,
        decorations: void 0,
        document: void 0,
        history: void 0,
        schema: void 0,
        selection: void 0
      },
      ze = function (e) {
        function Value() {
          return D(this, Value), T(this, (Value.__proto__ || Object.getPrototypeOf(Value)).apply(this, arguments));
        }
        return q(Value, e), B(Value, [{
          key: "change",
          value: function change() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return new Ge(S({}, e, {
              value: this
            }));
          }
        }, {
          key: "addMark",
          value: function addMark(e, i, t, a) {
            var n = this,
              o = n.document;
            return o = o.addMark(e, i, t, a), n = this.set("document", o);
          }
        }, {
          key: "insertNode",
          value: function insertNode(e, i) {
            var t = this,
              a = t.document;
            return a = a.insertNode(e, i), t = (t = t.set("document", a)).mapRanges(function (e) {
              return e.updatePoints(function (e) {
                return e.setPath(null);
              });
            });
          }
        }, {
          key: "insertText",
          value: function insertText(e, i, t, a) {
            var n = this,
              o = n,
              r = o.document,
              s = o.schema;
            r = r.insertText(e, i, t, a), n = n.set("document", r);
            var _ = r.assertNode(e);
            return n = (n = n.mapRanges(function (e) {
              var a = e,
                n = a.anchor,
                o = a.focus,
                r = a.isBackward,
                l = ve.isDecoration(e) && s.isAtomic(e.mark);
              return n.key !== _.key || !(n.offset > i) && (n.offset !== i || l && r) || (e = e.moveAnchorForward(t.length)), o.key === _.key && (o.offset > i || o.offset == i && (!l || r)) && (e = e.moveFocusForward(t.length)), e;
            })).clearAtomicRanges(_.key, i);
          }
        }, {
          key: "mergeNode",
          value: function mergeNode(e) {
            var i = this,
              t = i.document,
              a = t.mergeNode(e);
            e = t.resolvePath(e);
            var n = ge.decrement(e),
              o = t.getNode(n),
              r = t.getNode(e);
            return i = (i = i.set("document", a)).mapRanges(function (e) {
              if ("text" === r.object) {
                var i = o.text.length;
                e.anchor.key === r.key && (e = e.moveAnchorTo(o.key, i + e.anchor.offset)), e.focus.key === r.key && (e = e.moveFocusTo(o.key, i + e.focus.offset));
              }
              return e = e.updatePoints(function (e) {
                return e.setPath(null);
              });
            });
          }
        }, {
          key: "moveNode",
          value: function moveNode(e, i) {
            var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
              a = this,
              n = a.document;
            return n = n.moveNode(e, i, t), a = (a = a.set("document", n)).mapRanges(function (e) {
              return e.updatePoints(function (e) {
                return e.setPath(null);
              });
            });
          }
        }, {
          key: "removeMark",
          value: function removeMark(e, i, t, a) {
            var n = this,
              o = n.document;
            return o = o.removeMark(e, i, t, a), n = this.set("document", o);
          }
        }, {
          key: "removeNode",
          value: function removeNode(e) {
            var i = this,
              t = i.document,
              a = t.assertNode(e),
              n = "text" == a.object ? a : a.getFirstText() || a,
              o = "text" == a.object ? a : a.getLastText() || a,
              r = t.getPreviousText(n.key),
              s = t.getNextText(o.key);
            return t = t.removeNode(e), i = (i = i.set("document", t)).mapRanges(function (e) {
              var i = e,
                t = i.start,
                n = i.end;
              return a.hasNode(t.key) && (e = r ? e.moveStartTo(r.key, r.text.length) : s ? e.moveStartTo(s.key, 0) : e.unset()), a.hasNode(n.key) && (e = r ? e.moveEndTo(r.key, r.text.length) : s ? e.moveEndTo(s.key, 0) : e.unset()), e = e.updatePoints(function (e) {
                return e.setPath(null);
              });
            });
          }
        }, {
          key: "removeText",
          value: function removeText(e, i, t) {
            var a = this,
              n = a.document;
            n = n.removeText(e, i, t), a = a.set("document", n);
            var o = n.assertNode(e),
              r = t.length,
              s = i + r;
            return a = (a = a.clearAtomicRanges(o.key, i, i + r)).mapRanges(function (e) {
              var t = e,
                a = t.anchor,
                n = t.focus;
              return a.key === o.key && (e = a.offset >= s ? e.moveAnchorBackward(r) : a.offset > i ? e.moveAnchorTo(a.key, i) : e), n.key === o.key && (e = n.offset >= s ? e.moveFocusBackward(r) : n.offset > i ? e.moveFocusTo(n.key, i) : e), e;
            });
          }
        }, {
          key: "setNode",
          value: function setNode(e, i) {
            var t = this,
              a = t.document;
            return a = a.setNode(e, i), t = t.set("document", a);
          }
        }, {
          key: "setMark",
          value: function setMark(e, i, t, a, n) {
            var o = this,
              r = o.document;
            return r = r.setMark(e, i, t, a, n), o = o.set("document", r);
          }
        }, {
          key: "setProperties",
          value: function setProperties(e) {
            var i = this,
              t = i.document,
              a = e.data,
              n = e.decorations,
              o = e.history,
              r = e.schema,
              s = {};
            return a && (s.data = a), o && (s.history = o), r && (s.schema = r), n && (s.decorations = n.map(function (e) {
              return e.isSet ? e : t.resolveDecoration(e);
            })), i = i.merge(s);
          }
        }, {
          key: "setSelection",
          value: function setSelection(e) {
            var i = this,
              t = i,
              a = t.document,
              n = t.selection,
              o = n.setProperties(e);
            return n = a.resolveSelection(o), i = i.set("selection", n);
          }
        }, {
          key: "splitNode",
          value: function splitNode(e, i, t) {
            var a = this,
              n = a.document,
              o = n.splitNode(e, i, t),
              r = n.assertNode(e);
            return a = (a = a.set("document", o)).mapRanges(function (e) {
              var t = o.getNextText(r.key),
                a = e,
                n = a.start,
                s = a.end;
              return r.key === n.key && i <= n.offset && (e = e.moveStartTo(t.key, n.offset - i)), r.key === s.key && i <= s.offset && (e = e.moveEndTo(t.key, s.offset - i)), e = e.updatePoints(function (e) {
                return e.setPath(null);
              });
            });
          }
        }, {
          key: "mapRanges",
          value: function mapRanges(e) {
            var i = this,
              t = i,
              a = t.document,
              n = t.selection,
              o = t.decorations,
              r = n.isSet ? e(n) : n;
            r || (r = n.unset()), r !== n && (r = a.createSelection(r)), i = i.set("selection", r);
            var s = o.map(function (i) {
              var t = i.isSet ? e(i) : i;
              return t && t !== i && (t = a.createDecoration(t)), t;
            });
            return s = s.filter(function (e) {
              return !!e;
            }), i = i.set("decorations", s);
          }
        }, {
          key: "clearAtomicRanges",
          value: function clearAtomicRanges(e, i) {
            var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
              a = this,
              n = a.schema;
            return a = this.mapRanges(function (a) {
              if (!ve.isDecoration(a)) return a;
              var o = a.start,
                r = a.end,
                s = a.mark;
              return n.isAtomic(s) ? o.key !== e ? a : o.offset < i && (r.key !== e || r.offset > i) ? null : null != t && o.offset < t && (r.key !== e || r.offset > t) ? null : a : a;
            });
          }
        }, {
          key: "toJSON",
          value: function toJSON() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              i = {
                object: this.object,
                document: this.document.toJSON(e)
              };
            return e.preserveData && (i.data = this.data.toJSON(e)), e.preserveDecorations && (i.decorations = this.decorations.toArray().map(function (i) {
              return i.toJSON(e);
            })), e.preserveHistory && (i.history = this.history.toJSON(e)), e.preserveSelection && (i.selection = this.selection.toJSON(e)), e.preserveSchema && (i.schema = this.schema.toJSON(e)), i;
          }
        }, {
          key: "startBlock",
          get: function get$$1() {
            return this.selection.start.key && this.document.getClosestBlock(this.selection.start.key);
          }
        }, {
          key: "endBlock",
          get: function get$$1() {
            return this.selection.end.key && this.document.getClosestBlock(this.selection.end.key);
          }
        }, {
          key: "anchorBlock",
          get: function get$$1() {
            return this.selection.anchor.key && this.document.getClosestBlock(this.selection.anchor.key);
          }
        }, {
          key: "focusBlock",
          get: function get$$1() {
            return this.selection.focus.key && this.document.getClosestBlock(this.selection.focus.key);
          }
        }, {
          key: "startInline",
          get: function get$$1() {
            return this.selection.start.key && this.document.getClosestInline(this.selection.start.key);
          }
        }, {
          key: "endInline",
          get: function get$$1() {
            return this.selection.end.key && this.document.getClosestInline(this.selection.end.key);
          }
        }, {
          key: "anchorInline",
          get: function get$$1() {
            return this.selection.anchor.key && this.document.getClosestInline(this.selection.anchor.key);
          }
        }, {
          key: "focusInline",
          get: function get$$1() {
            return this.selection.focus.key && this.document.getClosestInline(this.selection.focus.key);
          }
        }, {
          key: "startText",
          get: function get$$1() {
            return this.selection.start.key && this.document.getDescendant(this.selection.start.key);
          }
        }, {
          key: "endText",
          get: function get$$1() {
            return this.selection.end.key && this.document.getDescendant(this.selection.end.key);
          }
        }, {
          key: "anchorText",
          get: function get$$1() {
            return this.selection.anchor.key && this.document.getDescendant(this.selection.anchor.key);
          }
        }, {
          key: "focusText",
          get: function get$$1() {
            return this.selection.focus.key && this.document.getDescendant(this.selection.focus.key);
          }
        }, {
          key: "nextBlock",
          get: function get$$1() {
            return this.selection.end.key && this.document.getNextBlock(this.selection.end.key);
          }
        }, {
          key: "previousBlock",
          get: function get$$1() {
            return this.selection.start.key && this.document.getPreviousBlock(this.selection.start.key);
          }
        }, {
          key: "nextInline",
          get: function get$$1() {
            return this.selection.end.key && this.document.getNextInline(this.selection.end.key);
          }
        }, {
          key: "previousInline",
          get: function get$$1() {
            return this.selection.start.key && this.document.getPreviousInline(this.selection.start.key);
          }
        }, {
          key: "nextText",
          get: function get$$1() {
            return this.selection.end.key && this.document.getNextText(this.selection.end.key);
          }
        }, {
          key: "previousText",
          get: function get$$1() {
            return this.selection.start.key && this.document.getPreviousText(this.selection.start.key);
          }
        }, {
          key: "marks",
          get: function get$$1() {
            return this.selection.isUnset ? new m.Set() : this.selection.marks || this.document.getMarksAtRange(this.selection);
          }
        }, {
          key: "activeMarks",
          get: function get$$1() {
            return this.selection.isUnset ? new m.Set() : this.selection.marks || this.document.getActiveMarksAtRange(this.selection);
          }
        }, {
          key: "blocks",
          get: function get$$1() {
            return this.selection.isUnset ? new m.List() : this.document.getBlocksAtRange(this.selection);
          }
        }, {
          key: "fragment",
          get: function get$$1() {
            return this.selection.isUnset ? R.create() : this.document.getFragmentAtRange(this.selection);
          }
        }, {
          key: "inlines",
          get: function get$$1() {
            return this.selection.isUnset ? new m.List() : this.document.getInlinesAtRange(this.selection);
          }
        }, {
          key: "texts",
          get: function get$$1() {
            return this.selection.isUnset ? new m.List() : this.document.getTextsAtRange(this.selection);
          }
        }], [{
          key: "create",
          value: function create() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            if (Value.isValue(e)) return e;
            if (d()(e)) return Value.fromJSON(e, i);
            throw new Error("`Value.create` only accepts objects or values, but you passed it: " + e);
          }
        }, {
          key: "createProperties",
          value: function createProperties() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            if (Value.isValue(e)) return {
              data: e.data,
              decorations: e.decorations,
              schema: e.schema
            };
            if (d()(e)) {
              var i = {};
              return "data" in e && (i.data = P.create(e.data)), "decorations" in e && (i.decorations = ve.createList(e.decorations)), "schema" in e && (i.schema = Me.create(e.schema)), i;
            }
            throw new Error("`Value.createProperties` only accepts objects or values, but you passed it: " + e);
          }
        }, {
          key: "fromJSON",
          value: function fromJSON(e) {
            var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              t = e.data,
              a = void 0 === t ? {} : t,
              n = e.decorations,
              o = void 0 === n ? [] : n,
              r = e.document,
              s = void 0 === r ? {} : r,
              _ = e.selection,
              l = void 0 === _ ? {} : _,
              g = e.schema,
              f = void 0 === g ? {} : g,
              h = e.history,
              d = void 0 === h ? {} : h;
            if (a = P.fromJSON(a), f = Me.fromJSON(f), d = Se.fromJSON(d), l = (s = R.fromJSON(s)).createSelection(l), o = Object(m.List)(o.map(function (e) {
              return ve.fromJSON(e);
            })), l.isUnset) {
              var u = s.getFirstText();
              u && (l = l.moveToStartOfNode(u)), l = s.createSelection(l);
            }
            var c = new Value({
              data: a,
              decorations: o,
              document: s,
              selection: l,
              schema: f,
              history: d
            });
            if (!1 !== i.normalize) {
              var F = c.change();
              F.withoutSaving(function () {
                return F.normalize();
              }), c = F.value;
            }
            return c;
          }
        }]), Value;
      }(Object(m.Record)(Re)),
      Le = {
        setValue: function setValue(e, i) {
          i = ze.createProperties(i);
          var t = e.value;
          e.applyOperation({
            type: "set_value",
            properties: i,
            value: t
          });
        }
      },
      We = S({}, te, le, fe, pe, Ce, Le),
      Ue = v()("slate:operation:apply");
    function slate_es_applyOperation(e, i) {
      var t = (i = Je.create(i)).type;
      switch (Ue(t, i), t) {
        case "add_mark":
          var a = i,
            n = a.path,
            o = a.offset,
            r = a.length,
            s = a.mark;
          return e.addMark(n, o, r, s);
        case "insert_node":
          var _ = i,
            l = _.path,
            g = _.node;
          return e.insertNode(l, g);
        case "insert_text":
          var f = i,
            h = f.path,
            d = f.offset,
            m = f.text,
            u = f.marks;
          return e.insertText(h, d, m, u);
        case "merge_node":
          var c = i.path;
          return e.mergeNode(c);
        case "move_node":
          var F = i,
            p = F.path,
            b = F.newPath;
          return e.moveNode(p, b);
        case "remove_mark":
          var y = i,
            k = y.path,
            v = y.offset,
            w = y.length,
            E = y.mark;
          return e.removeMark(k, v, w, E);
        case "remove_node":
          var A = i.path;
          return e.removeNode(A);
        case "remove_text":
          var j = i,
            x = j.path,
            C = j.offset,
            D = j.text;
          return e.removeText(x, C, D);
        case "set_mark":
          var B = i,
            S = B.path,
            q = B.offset,
            O = B.length,
            T = B.mark,
            N = B.properties;
          return e.setMark(S, q, O, T, N);
        case "set_node":
          var I = i,
            P = I.path,
            M = I.properties;
          return e.setNode(P, M);
        case "set_selection":
          var R = i.properties;
          return e.setSelection(R);
        case "set_value":
          var z = i.properties;
          return e.setProperties(z);
        case "split_node":
          var L = i,
            W = L.path,
            U = L.position,
            K = L.properties;
          return e.splitNode(W, U, K);
        default:
          throw new Error('Unknown operation type: "' + t + '".');
      }
    }
    var Ke = v()("slate:operation:invert");
    function invertOperation(e) {
      var i = (e = Je.create(e)).type;
      switch (Ke(i, e), i) {
        case "insert_node":
          return e.set("type", "remove_node");
        case "remove_node":
          return e.set("type", "insert_node");
        case "move_node":
          var t = e,
            a = t.newPath,
            n = t.path,
            o = a,
            r = n,
            s = n.size - 1,
            _ = a.size - 1;
          return n.size < o.size && n.slice(0, s).every(function (e, i) {
            return e == o.get(i);
          }) && n.last() < o.get(s) && (o = o.slice(0, s).concat(o.get(s) - 1).concat(o.slice(s + 1, o.size))), a.size < r.size && a.slice(0, _).every(function (e, i) {
            return e == r.get(i);
          }) && a.last() <= r.get(_) && (r = r.slice(0, _).concat(r.get(_) + 1).concat(r.slice(_ + 1, r.size))), e.set("path", o).set("newPath", r);
        case "merge_node":
          var l = e.path,
            g = ge.decrement(l);
          return e.set("type", "split_node").set("path", g);
        case "split_node":
          var f = e.path,
            h = ge.increment(f);
          return e.set("type", "merge_node").set("path", h);
        case "set_node":
          var d = e,
            m = d.properties,
            u = d.node,
            c = u.merge(m),
            F = y()(u, Object.keys(m));
          return e.set("node", c).set("properties", F);
        case "insert_text":
          return e.set("type", "remove_text");
        case "remove_text":
          return e.set("type", "insert_text");
        case "add_mark":
          return e.set("type", "remove_mark");
        case "remove_mark":
          return e.set("type", "add_mark");
        case "set_mark":
          var p = e,
            b = p.properties,
            k = p.mark,
            v = k.merge(b),
            w = y()(k, Object.keys(b));
          return e.set("mark", v).set("properties", w);
        case "set_selection":
          var E = e,
            A = E.properties,
            j = E.selection,
            x = j.merge(A),
            C = y()(j, Object.keys(A));
          return e.set("selection", x).set("properties", C);
        case "set_value":
          var D = e,
            B = D.properties,
            S = D.value,
            q = S.merge(B),
            O = y()(S, Object.keys(B));
          return e.set("value", q).set("properties", O);
        default:
          throw new Error('Unknown operation type: "' + i + '".');
      }
    }
    var He = {
        add_mark: ["value", "path", "offset", "length", "mark"],
        insert_node: ["value", "path", "node"],
        insert_text: ["value", "path", "offset", "text", "marks"],
        merge_node: ["value", "path", "position", "properties", "target"],
        move_node: ["value", "path", "newPath"],
        remove_mark: ["value", "path", "offset", "length", "mark"],
        remove_node: ["value", "path", "node"],
        remove_text: ["value", "path", "offset", "text", "marks"],
        set_mark: ["value", "path", "offset", "length", "mark", "properties"],
        set_node: ["value", "path", "node", "properties"],
        set_selection: ["value", "selection", "properties"],
        set_value: ["value", "properties"],
        split_node: ["value", "path", "position", "properties", "target"]
      },
      Ve = {
        length: void 0,
        mark: void 0,
        marks: void 0,
        newPath: void 0,
        node: void 0,
        offset: void 0,
        path: void 0,
        position: void 0,
        properties: void 0,
        selection: void 0,
        target: void 0,
        text: void 0,
        type: void 0,
        value: void 0
      },
      Je = function (e) {
        function Operation() {
          return D(this, Operation), T(this, (Operation.__proto__ || Object.getPrototypeOf(Operation)).apply(this, arguments));
        }
        return q(Operation, e), B(Operation, [{
          key: "apply",
          value: function apply(e) {
            return slate_es_applyOperation(e, this);
          }
        }, {
          key: "invert",
          value: function invert() {
            return invertOperation(this);
          }
        }, {
          key: "toJSON",
          value: function toJSON() {
            var e = this.object,
              i = this.type,
              t = {
                object: e,
                type: i
              },
              a = He[i],
              n = !0,
              o = !1,
              r = void 0;
            try {
              for (var s, _ = a[Symbol.iterator](); !(n = (s = _.next()).done); n = !0) {
                var l = s.value,
                  g = this[l];
                if ("document" != l && "selection" != l && "value" != l && ("node" != l || "insert_node" == i)) {
                  if ("mark" != l && "marks" != l && "node" != l && "path" != l && "newPath" != l || (g = g.toJSON()), "properties" == l && "merge_node" == i) {
                    var f = {};
                    "data" in g && (f.data = g.data.toJS()), "type" in g && (f.type = g.type), g = f;
                  }
                  if ("properties" == l && "set_mark" == i) {
                    var h = {};
                    "data" in g && (h.data = g.data.toJS()), "type" in g && (h.type = g.type), g = h;
                  }
                  if ("properties" == l && "set_node" == i) {
                    var d = {};
                    "data" in g && (d.data = g.data.toJS()), "type" in g && (d.type = g.type), g = d;
                  }
                  if ("properties" == l && "set_selection" == i) {
                    var m = {};
                    "anchor" in g && (m.anchor = g.anchor.toJSON()), "focus" in g && (m.focus = g.focus.toJSON()), "isFocused" in g && (m.isFocused = g.isFocused), "marks" in g && (m.marks = g.marks && g.marks.toJSON()), g = m;
                  }
                  if ("properties" == l && "set_value" == i) {
                    var u = {};
                    "data" in g && (u.data = g.data.toJS()), "decorations" in g && (u.decorations = g.decorations.toJS()), "schema" in g && (u.schema = g.schema.toJS()), g = u;
                  }
                  if ("properties" == l && "split_node" == i) {
                    var c = {};
                    "data" in g && (c.data = g.data.toJS()), "type" in g && (c.type = g.type), g = c;
                  }
                  t[l] = g;
                }
              }
            } catch (sr) {
              o = !0, r = sr;
            } finally {
              try {
                !n && _.return && _.return();
              } finally {
                if (o) throw r;
              }
            }
            return t;
          }
        }], [{
          key: "create",
          value: function create() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            if (Operation.isOperation(e)) return e;
            if (d()(e)) return Operation.fromJSON(e);
            throw new Error("`Operation.create` only accepts objects or operations, but you passed it: " + e);
          }
        }, {
          key: "createList",
          value: function createList() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
            if (m.List.isList(e) || Array.isArray(e)) return new m.List(e.map(Operation.create));
            throw new Error("`Operation.createList` only accepts arrays or lists, but you passed it: " + e);
          }
        }, {
          key: "fromJSON",
          value: function fromJSON(e) {
            if (Operation.isOperation(e)) return e;
            var i = e.type,
              t = He[i],
              a = {
                type: i
              };
            if (!t) throw new Error('`Operation.fromJSON` was passed an unrecognized operation type: "' + i + '"');
            var n = !0,
              o = !1,
              r = void 0;
            try {
              for (var s, _ = t[Symbol.iterator](); !(n = (s = _.next()).done); n = !0) {
                var l = s.value,
                  g = e[l];
                if (void 0 === g) {
                  if ("document" == l) continue;
                  if ("selection" == l) continue;
                  if ("value" == l) continue;
                  if ("node" == l && "insert_node" != i) continue;
                  throw new Error('`Operation.fromJSON` was passed a "' + i + '" operation without the required "' + l + '" attribute.');
                }
                "path" !== l && "newPath" !== l || (g = ge.create(g)), "mark" === l && (g = U.create(g)), "marks" === l && null != g && (g = U.createSet(g)), "node" === l && (g = Q.create(g)), "selection" === l && (g = xe.create(g)), "value" === l && (g = ze.create(g)), "properties" === l && "merge_node" === i && (g = Q.createProperties(g)), "properties" === l && "set_mark" === i && (g = U.createProperties(g)), "properties" === l && "set_node" === i && (g = Q.createProperties(g)), "properties" === l && "set_selection" === i && (g = xe.createProperties(g)), "properties" === l && "set_value" === i && (g = ze.createProperties(g)), "properties" === l && "split_node" === i && (g = Q.createProperties(g)), a[l] = g;
              }
            } catch (sr) {
              o = !0, r = sr;
            } finally {
              try {
                !n && _.return && _.return();
              } finally {
                if (o) throw r;
              }
            }
            return new Operation(a);
          }
        }, {
          key: "isOperationList",
          value: function isOperationList(e) {
            return m.List.isList(e) && e.every(function (e) {
              return Operation.isOperation(e);
            });
          }
        }]), Operation;
      }(Object(m.Record)(Ve)),
      $e = v()("slate:change"),
      Ge = function () {
        function Change(e) {
          D(this, Change);
          var i = e.value;
          this.value = i, this.operations = new m.List(), this.tmp = {
            dirty: [],
            merge: null,
            normalize: !0,
            save: !0
          };
        }
        return B(Change, [{
          key: "applyOperation",
          value: function applyOperation(e) {
            var i = this.operations,
              t = this.value,
              a = t.history;
            d()(e) && (e = S({}, e, {
              value: t
            })), e = Je.create(e);
            var n = this.tmp,
              o = n.merge,
              r = n.save;
            null == o && 0 !== i.size && (o = !0), $e("apply", {
              operation: e,
              save: r,
              merge: o
            }), t = e.apply(t), a && r && (a = a.save(e, {
              merge: o
            }), t = t.set("history", a));
            var s = function getDirtyPaths(e) {
                var i = e.type,
                  t = e.node,
                  a = e.path,
                  n = e.newPath;
                switch (i) {
                  case "add_mark":
                  case "insert_text":
                  case "remove_mark":
                  case "remove_text":
                  case "set_mark":
                  case "set_node":
                    return [a];
                  case "insert_node":
                    var o = t.getKeysToPathsTable(),
                      r = Object.values(o).map(function (e) {
                        return a.concat(e);
                      }),
                      s = ge.lift(a);
                    return [s, a].concat(I(r));
                  case "split_node":
                    var _ = ge.lift(a),
                      l = ge.increment(a);
                    return [_, a, l];
                  case "merge_node":
                    var g = ge.lift(a),
                      f = ge.decrement(a);
                    return [g, f];
                  case "move_node":
                    var h = ge.lift(a),
                      d = ge.lift(n);
                    return ge.isSibling(a, n) || (d.size && ge.isYounger(a, n) && (d = ge.decrement(d, 1, a.size - 1)), h.size && ge.isYounger(n, a) && (h = ge.increment(h, 1, n.size - 1))), [h, d];
                  case "remove_node":
                    var m = ge.lift(a);
                    return [m];
                  default:
                    return [];
                }
              }(e),
              _ = this.tmp.dirty.reduce(function (i, t) {
                t = ge.create(t);
                var a = ge.transform(t, e);
                return i = i.concat(a.toArray());
              }, s);
            return this.tmp.dirty = _, this.value = t, this.operations = i.push(e), this;
          }
        }, {
          key: "applyOperations",
          value: function applyOperations(e, i) {
            var t = this;
            return e.forEach(function (e) {
              return t.applyOperation(e, i);
            }), this;
          }
        }, {
          key: "call",
          value: function call(e) {
            for (var i = arguments.length, t = Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++) {
              t[a - 1] = arguments[a];
            }
            return e.apply(void 0, [this].concat(t)), this.normalizeDirtyPaths(), this;
          }
        }, {
          key: "normalize",
          value: function normalize() {
            var e = this.value.document.getKeysToPathsTable(),
              i = Object.values(e).map(ge.create);
            return this.tmp.dirty = this.tmp.dirty.concat(i), this.normalizeDirtyPaths(), this;
          }
        }, {
          key: "normalizeDirtyPaths",
          value: function normalizeDirtyPaths() {
            if (!this.tmp.normalize) return this;
            for (; this.tmp.dirty.length;) {
              var e = this.tmp.dirty.pop();
              this.normalizeNodeByPath(e);
            }
            return this;
          }
        }, {
          key: "normalizeNodeByPath",
          value: function normalizeNodeByPath(e) {
            var i = this,
              t = this.value,
              a = t.document,
              n = t.schema,
              o = a.assertNode(e),
              r = 0,
              s = n.stack.plugins.length + n.rules.length + ("text" === o.object ? 1 : o.nodes.size);
            return this.withoutNormalizing(function () {
              !function iterate() {
                var t = o.normalize(n);
                if (t) {
                  t(i), a = i.value.document;
                  var _ = o.key,
                    l = a.getDescendant(e);
                  if (l && l.key === _) o = l;else {
                    if (!(l = a.getDescendant(_))) return;
                    o = l, e = a.getPath(_);
                  }
                  if (++r > s) throw new Error("A schema rule could not be normalized after sufficient iterations. This is usually due to a `rule.normalize` or `plugin.normalizeNode` function of a schema being incorrectly written, causing an infinite loop.");
                  iterate();
                }
              }();
            }), this;
          }
        }, {
          key: "withoutNormalizing",
          value: function withoutNormalizing(e) {
            var i = this.tmp.normalize;
            return this.tmp.normalize = !1, e(this), this.tmp.normalize = i, this.normalizeDirtyPaths(), this;
          }
        }, {
          key: "withoutMerging",
          value: function withoutMerging(e) {
            var i = this.tmp.merge;
            return this.tmp.merge = !1, e(this), this.tmp.merge = i, this;
          }
        }, {
          key: "withoutSaving",
          value: function withoutSaving(e) {
            var i = this.tmp.save;
            return this.tmp.save = !1, e(this), this.tmp.save = i, this;
          }
        }, {
          key: "setOperationFlag",
          value: function setOperationFlag(e, i) {
            return u(!1, "As of slate@0.41.0 the `change.setOperationFlag` method has been deprecated."), this.tmp[e] = i, this;
          }
        }, {
          key: "getFlag",
          value: function getFlag(e) {
            var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return u(!1, "As of slate@0.41.0 the `change.getFlag` method has been deprecated."), void 0 !== i[e] ? i[e] : this.tmp[e];
          }
        }, {
          key: "unsetOperationFlag",
          value: function unsetOperationFlag(e) {
            return u(!1, "As of slate@0.41.0 the `change.unsetOperationFlag` method has been deprecated."), delete this.tmp[e], this;
          }
        }, {
          key: "withoutNormalization",
          value: function withoutNormalization(e) {
            return u(!1, "As of slate@0.41.0 the `change.withoutNormalization` helper has been renamed to `change.withoutNormalizing`."), this.withoutNormalizing(e);
          }
        }]), Change;
      }();
    function mixin(e, i) {
      var t = !0,
        a = !1,
        n = void 0;
      try {
        for (var o, r = i[Symbol.iterator](); !(t = (o = r.next()).done); t = !0) {
          var s = o.value,
            _ = !0,
            l = !1,
            g = void 0;
          try {
            for (var f, h = Object.getOwnPropertyNames(e)[Symbol.iterator](); !(_ = (f = h.next()).done); _ = !0) {
              var d = f.value;
              if (!s.hasOwnProperty(d)) {
                var m = Object.getOwnPropertyDescriptor(e, d);
                Object.defineProperty(s, d, m);
              }
            }
          } catch (sr) {
            l = !0, g = sr;
          } finally {
            try {
              !_ && h.return && h.return();
            } finally {
              if (l) throw g;
            }
          }
          var u = !0,
            c = !1,
            F = void 0;
          try {
            for (var p, b = Object.getOwnPropertyNames(e.prototype)[Symbol.iterator](); !(u = (p = b.next()).done); u = !0) {
              var y = p.value;
              if (!s.prototype.hasOwnProperty(y)) {
                m = Object.getOwnPropertyDescriptor(e.prototype, y);
                Object.defineProperty(s.prototype, y, m);
              }
            }
          } catch (sr) {
            c = !0, F = sr;
          } finally {
            try {
              !u && b.return && b.return();
            } finally {
              if (c) throw F;
            }
          }
        }
      } catch (sr) {
        a = !0, n = sr;
      } finally {
        try {
          !t && r.return && r.return();
        } finally {
          if (a) throw n;
        }
      }
    }
    function create$2(e) {
      var i = we[e],
        t = "is" + ("" + e.charAt(0).toUpperCase() + e.slice(1)),
        a = function () {
          function ObjectInterface() {
            D(this, ObjectInterface);
          }
          return B(ObjectInterface, [{
            key: "object",
            get: function get$$1() {
              return e;
            }
          }]), ObjectInterface;
        }();
      return a[t] = isObject.bind(null, e), a.prototype[i] = !0, a;
    }
    Object.keys(We).forEach(function (e) {
      Ge.prototype[e] = function () {
        for (var i = arguments.length, t = Array(i), a = 0; a < i; a++) {
          t[a] = arguments[a];
        }
        return $e(e, {
          args: t
        }), this.call.apply(this, [We[e]].concat(t)), this;
      };
    }), mixin(create$2("block"), [ie]), mixin(create$2("change"), [Ge]), mixin(create$2("decoration"), [ve]), mixin(create$2("document"), [R]), mixin(create$2("history"), [Se]), mixin(create$2("inline"), [L]), mixin(create$2("leaf"), [H]), mixin(create$2("mark"), [U]), mixin(create$2("node"), [Q]), mixin(create$2("operation"), [Je]), mixin(create$2("point"), [ye]), mixin(create$2("range"), [Ae]), mixin(create$2("schema"), [Me]), mixin(create$2("selection"), [xe]), mixin(create$2("stack"), [Oe]), mixin(create$2("text"), [Z]), mixin(create$2("value"), [ze]), mixin(function () {
      function ModelInterface() {
        D(this, ModelInterface);
      }
      return B(ModelInterface, [{
        key: "toJS",
        value: function toJS() {
          return this.toJSON.apply(this, arguments);
        }
      }], [{
        key: "fromJS",
        value: function fromJS() {
          return this.fromJSON.apply(this, arguments);
        }
      }]), ModelInterface;
    }(), [ie, Ge, ve, R, Se, L, H, U, Q, Je, ye, Ae, Me, xe, Oe, Z, ze]);
    var Ye = function () {
      function NodeInterface() {
        D(this, NodeInterface);
      }
      return B(NodeInterface, [{
        key: "getFirstInvalidNode",
        value: function getFirstInvalidNode(e) {
          if ("text" === this.object) return this.validate(e) ? this : null;
          var i = null;
          return this.nodes.find(function (t) {
            return i = t.validate(e) ? t : t.getFirstInvalidNode(e);
          }), i;
        }
      }, {
        key: "getFirstText",
        value: function getFirstText() {
          if ("text" === this.object) return this;
          var e = null,
            i = this.nodes.find(function (i) {
              return "text" === i.object || !!(e = i.getFirstText());
            });
          return e || i;
        }
      }, {
        key: "getKeysToPathsTable",
        value: function getKeysToPathsTable() {
          var e = function defineProperty(e, i, t) {
            return i in e ? Object.defineProperty(e, i, {
              value: t,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : e[i] = t, e;
          }({}, this.key, []);
          return this.nodes && this.nodes.forEach(function (i, t) {
            var a = i.getKeysToPathsTable();
            for (var n in a) {
              var o = a[n];
              u(!(n in e), 'A node with a duplicate key of "' + n + '" was found! Duplicate keys are not allowed, you should use `node.regenerateKey` before inserting if you are reusing an existing node.'), e[n] = [t].concat(I(o));
            }
          }), e;
        }
      }, {
        key: "getLastText",
        value: function getLastText() {
          if ("text" === this.object) return this;
          var e = null,
            i = this.nodes.findLast(function (i) {
              return "text" == i.object || (e = i.getLastText());
            });
          return e || i;
        }
      }, {
        key: "getNode",
        value: function getNode(e) {
          return (e = this.resolvePath(e)) ? "text" === this.object && e.size ? null : e.size ? this.getDescendant(e) : this : null;
        }
      }, {
        key: "getPath",
        value: function getPath(e) {
          if (m.List.isList(e)) return e;
          var i = this.getKeysToPathsTable()[e];
          return i ? Object(m.List)(i) : null;
        }
      }, {
        key: "getText",
        value: function getText() {
          return ("text" === this.object ? this.leaves : this.nodes).reduce(function (e, i) {
            return e + i.text;
          }, "");
        }
      }, {
        key: "hasNode",
        value: function hasNode(e) {
          return !!this.getNode(e);
        }
      }, {
        key: "normalize",
        value: function normalize(e) {
          return e.normalizeNode(this);
        }
      }, {
        key: "regenerateKey",
        value: function regenerateKey() {
          var e = x.create();
          return this.set("key", e);
        }
      }, {
        key: "resolvePath",
        value: function resolvePath(e, i) {
          return "string" === typeof e ? (e = this.getPath(e), null != i && (e = e.concat(i))) : e = ge.create(e), e;
        }
      }, {
        key: "validate",
        value: function validate(e) {
          return e.validateNode(this);
        }
      }, {
        key: "text",
        get: function get$$1() {
          return this.getText();
        }
      }]), NodeInterface;
    }();
    memoize(Ye.prototype, ["getFirstInvalidNode", "getFirstText", "getKeysToPathsTable", "getLastText", "getText", "normalize", "validate"]), mixin(Ye, [ie, R, L, Z]);
    var Xe = function () {
        function ElementInterface() {
          D(this, ElementInterface);
        }
        return B(ElementInterface, [{
          key: "addMark",
          value: function addMark(e, i, t, a) {
            var n = this.assertDescendant(e);
            return e = this.resolvePath(e), n = n.addMark(i, t, a), this.replaceNode(e, n);
          }
        }, {
          key: "createDecoration",
          value: function createDecoration(e) {
            return e = ve.createProperties(e), this.resolveDecoration(e);
          }
        }, {
          key: "createPoint",
          value: function createPoint(e) {
            return e = ye.createProperties(e), this.resolvePoint(e);
          }
        }, {
          key: "createRange",
          value: function createRange(e) {
            return e = Ae.createProperties(e), this.resolveRange(e);
          }
        }, {
          key: "createSelection",
          value: function createSelection(e) {
            return e = xe.createProperties(e), this.resolveSelection(e);
          }
        }, {
          key: "filterDescendants",
          value: function filterDescendants(e) {
            var i = [];
            return this.forEachDescendant(function (t, a, n) {
              e(t, a, n) && i.push(t);
            }), Object(m.List)(i);
          }
        }, {
          key: "findDescendant",
          value: function findDescendant(e) {
            var i = null;
            return this.forEachDescendant(function (t, a, n) {
              if (e(t, a, n)) return i = t, !1;
            }), i;
          }
        }, {
          key: "forEachDescendant",
          value: function forEachDescendant(e) {
            var i = void 0;
            return this.nodes.forEach(function (t, a, n) {
              return !1 === e(t, a, n) ? (i = !1, !1) : "text" != t.object ? i = t.forEachDescendant(e) : void 0;
            }), i;
          }
        }, {
          key: "getActiveMarksAtRange",
          value: function getActiveMarksAtRange(e) {
            if ((e = this.resolveRange(e)).isUnset) return Object(m.Set)();
            if (e.isCollapsed) {
              var i = e.start;
              return this.getMarksAtPosition(i.key, i.offset).toSet();
            }
            var t = e,
              a = t.start,
              n = t.end,
              o = a.key,
              r = a.offset,
              s = n.key,
              _ = n.offset,
              l = this.getDescendant(o);
            if (o !== s) {
              for (; o !== s && 0 === _;) {
                var g = this.getPreviousText(s);
                s = g.key, _ = g.text.length;
              }
              for (; o !== s && r === l.text.length;) {
                o = (l = this.getNextText(o)).key, r = 0;
              }
            }
            if (o === s) return l.getActiveMarksBetweenOffsets(r, _);
            var f = l.getActiveMarksBetweenOffsets(r, l.text.length);
            if (0 === f.size) return Object(m.Set)();
            var h = this.getDescendant(s).getActiveMarksBetweenOffsets(0, _),
              d = f.intersect(h);
            if (0 === d.size) return d;
            for (var u = this.getNextText(o); u.key !== s;) {
              if (0 !== u.text.length && 0 === (d = d.intersect(u.getActiveMarks())).size) return Object(m.Set)();
              u = this.getNextText(u.key);
            }
            return d;
          }
        }, {
          key: "getAncestors",
          value: function getAncestors(e) {
            var i = this;
            if (!(e = this.resolvePath(e))) return null;
            var t = [];
            return e.forEach(function (a, n) {
              var o = e.slice(0, n),
                r = i.getNode(o);
              t.push(r);
            }), Object(m.List)(t);
          }
        }, {
          key: "getBlocks",
          value: function getBlocks() {
            var e = this.getBlocksAsArray();
            return Object(m.List)(e);
          }
        }, {
          key: "getBlocksAsArray",
          value: function getBlocksAsArray() {
            return this.nodes.reduce(function (e, i) {
              return "block" != i.object ? e : i.isLeafBlock() ? (e.push(i), e) : e.concat(i.getBlocksAsArray());
            }, []);
          }
        }, {
          key: "getBlocksAtRange",
          value: function getBlocksAtRange(e) {
            var i = this.getBlocksAtRangeAsArray(e);
            return Object(m.List)(Object(m.OrderedSet)(i));
          }
        }, {
          key: "getBlocksAtRangeAsArray",
          value: function getBlocksAtRangeAsArray(e) {
            if ((e = this.resolveRange(e)).isUnset) return [];
            var i = e,
              t = i.start,
              a = i.end,
              n = this.getClosestBlock(t.key);
            if (t.key === a.key) return [n];
            var o = this.getClosestBlock(a.key),
              r = this.getBlocksAsArray(),
              s = r.indexOf(n),
              _ = r.indexOf(o);
            return r.slice(s, _ + 1);
          }
        }, {
          key: "getBlocksByType",
          value: function getBlocksByType(e) {
            var i = this.getBlocksByTypeAsArray(e);
            return Object(m.List)(i);
          }
        }, {
          key: "getBlocksByTypeAsArray",
          value: function getBlocksByTypeAsArray(e) {
            return this.nodes.reduce(function (i, t) {
              return "block" != t.object ? i : t.isLeafBlock() && t.type == e ? (i.push(t), i) : i.concat(t.getBlocksByTypeAsArray(e));
            }, []);
          }
        }, {
          key: "getChild",
          value: function getChild(e) {
            return (e = this.resolvePath(e)) && 1 === e.size ? this.nodes.get(e.first()) : null;
          }
        }, {
          key: "getClosest",
          value: function getClosest(e, i) {
            var t = this,
              a = this.getAncestors(e);
            return a && a.findLast(function (e) {
              for (var a = arguments.length, n = Array(a > 1 ? a - 1 : 0), o = 1; o < a; o++) {
                n[o - 1] = arguments[o];
              }
              return e !== t && i.apply(void 0, [e].concat(n));
            }) || null;
          }
        }, {
          key: "getClosestBlock",
          value: function getClosestBlock(e) {
            return this.getClosest(e, function (e) {
              return "block" === e.object;
            });
          }
        }, {
          key: "getClosestInline",
          value: function getClosestInline(e) {
            return this.getClosest(e, function (e) {
              return "inline" === e.object;
            });
          }
        }, {
          key: "getClosestVoid",
          value: function getClosestVoid(e, i) {
            var t = this.getAncestors(e);
            return t ? t.findLast(function (e) {
              return i.isVoid(e);
            }) : null;
          }
        }, {
          key: "getCommonAncestor",
          value: function getCommonAncestor(e, i) {
            if (e = this.resolvePath(e), i = this.resolvePath(i), !e || !i) return null;
            var t = ge.relate(e, i);
            return this.getNode(t);
          }
        }, {
          key: "getDecorations",
          value: function getDecorations(e) {
            var i = e.map("decorateNode", this).map(function (e) {
              return ve.createList(e);
            });
            return Object(m.List)(i).flatten(!0);
          }
        }, {
          key: "getDepth",
          value: function getDepth(e) {
            var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
            return (e = this.resolvePath(e)) && this.getNode(e) ? e.size - 1 + i : null;
          }
        }, {
          key: "getDescendant",
          value: function getDescendant(e) {
            if (!(e = this.resolvePath(e))) return null;
            var i = e.flatMap(function (e) {
              return ["nodes", e];
            });
            return this.getIn(i);
          }
        }, {
          key: "getFragmentAtRange",
          value: function getFragmentAtRange(e) {
            if ((e = this.resolveRange(e)).isUnset) return R.create();
            for (var i = e, t = i.start, a = i.end, n = this, o = a.path, r = a.offset, s = "end"; o.size;) {
              var _ = o.last();
              n = n.splitNode(o, r), r = _ + 1, (o = ge.lift(o)).size || "end" !== s || (o = t.path, r = t.offset, s = "start");
            }
            var l = t.path.first() + 1,
              g = a.path.first() + 2,
              f = n.nodes.slice(l, g);
            return R.create({
              nodes: f
            });
          }
        }, {
          key: "getFurthest",
          value: function getFurthest(e, i) {
            var t = this,
              a = this.getAncestors(e);
            return a && a.find(function (e) {
              for (var a = arguments.length, n = Array(a > 1 ? a - 1 : 0), o = 1; o < a; o++) {
                n[o - 1] = arguments[o];
              }
              return e !== t && i.apply(void 0, [e].concat(n));
            }) || null;
          }
        }, {
          key: "getFurthestAncestor",
          value: function getFurthestAncestor(e) {
            return (e = this.resolvePath(e)) && e.size ? this.nodes.get(e.first()) : null;
          }
        }, {
          key: "getFurthestBlock",
          value: function getFurthestBlock(e) {
            return this.getFurthest(e, function (e) {
              return "block" === e.object;
            });
          }
        }, {
          key: "getFurthestInline",
          value: function getFurthestInline(e) {
            return this.getFurthest(e, function (e) {
              return "inline" === e.object;
            });
          }
        }, {
          key: "getFurthestOnlyChildAncestor",
          value: function getFurthestOnlyChildAncestor(e) {
            var i = this.getAncestors(e);
            return i && i.rest().reverse().takeUntil(function (e) {
              return e.nodes.size > 1;
            }).last() || null;
          }
        }, {
          key: "getInlines",
          value: function getInlines() {
            var e = this.getInlinesAsArray();
            return Object(m.List)(e);
          }
        }, {
          key: "getInlinesAsArray",
          value: function getInlinesAsArray() {
            var e = [];
            return this.nodes.forEach(function (i) {
              "text" != i.object && (i.isLeafInline() ? e.push(i) : e = e.concat(i.getInlinesAsArray()));
            }), e;
          }
        }, {
          key: "getInlinesAtRange",
          value: function getInlinesAtRange(e) {
            var i = this.getInlinesAtRangeAsArray(e);
            return Object(m.List)(Object(m.OrderedSet)(i));
          }
        }, {
          key: "getInlinesAtRangeAsArray",
          value: function getInlinesAtRangeAsArray(e) {
            var i = this;
            return (e = this.resolveRange(e)).isUnset ? [] : this.getTextsAtRangeAsArray(e).map(function (e) {
              return i.getClosestInline(e.key);
            }).filter(function (e) {
              return e;
            });
          }
        }, {
          key: "getInlinesByType",
          value: function getInlinesByType(e) {
            var i = this.getInlinesByTypeAsArray(e);
            return Object(m.List)(i);
          }
        }, {
          key: "getInlinesByTypeAsArray",
          value: function getInlinesByTypeAsArray(e) {
            return this.nodes.reduce(function (i, t) {
              return "text" == t.object ? i : t.isLeafInline() && t.type == e ? (i.push(t), i) : i.concat(t.getInlinesByTypeAsArray(e));
            }, []);
          }
        }, {
          key: "getInsertMarksAtRange",
          value: function getInsertMarksAtRange(e) {
            var i = (e = this.resolveRange(e)).start;
            return e.isUnset ? Object(m.Set)() : e.isCollapsed ? this.getMarksAtPosition(i.key, i.offset) : this.getDescendant(i.key).getMarksAtIndex(i.offset + 1);
          }
        }, {
          key: "getMarks",
          value: function getMarks() {
            var e = this.getMarksAsArray();
            return Object(m.Set)(e);
          }
        }, {
          key: "getMarksAsArray",
          value: function getMarksAsArray() {
            var e,
              i = [];
            return this.nodes.forEach(function (e) {
              i.push(e.getMarksAsArray());
            }), (e = []).concat.apply(e, i);
          }
        }, {
          key: "getMarksAtPosition",
          value: function getMarksAtPosition(e, i) {
            var t = this.getDescendant(e).getMarksAtIndex(i);
            if (0 !== i) return t;
            var a = this.getClosestBlock(e);
            if ("" === a.text) return t;
            var n = this.getPreviousText(e);
            return n ? a.hasDescendant(n.key) ? n.getMarksAtIndex(n.text.length) : t : Object(m.Set)();
          }
        }, {
          key: "getMarksAtRange",
          value: function getMarksAtRange(e) {
            return Object(m.Set)(this.getOrderedMarksAtRange(e));
          }
        }, {
          key: "getMarksByType",
          value: function getMarksByType(e) {
            var i = this.getMarksByTypeAsArray(e);
            return Object(m.Set)(i);
          }
        }, {
          key: "getMarksByTypeAsArray",
          value: function getMarksByTypeAsArray(e) {
            return this.nodes.reduce(function (i, t) {
              return "text" == t.object ? i.concat(t.getMarksAsArray().filter(function (i) {
                return i.type == e;
              })) : i.concat(t.getMarksByTypeAsArray(e));
            }, []);
          }
        }, {
          key: "getNextBlock",
          value: function getNextBlock(e) {
            var i = this.assertDescendant(e),
              t = void 0;
            "block" == i.object ? t = i.getLastText() : t = this.getClosestBlock(e).getLastText();
            var a = this.getNextText(t.key);
            return a ? this.getClosestBlock(a.key) : null;
          }
        }, {
          key: "getNextNode",
          value: function getNextNode(e) {
            if (!(e = this.resolvePath(e))) return null;
            if (!e.size) return null;
            for (var i = e.size; i > 0; i--) {
              var t = e.slice(0, i),
                a = ge.increment(t),
                n = this.getNode(a);
              if (n) return n;
            }
            return null;
          }
        }, {
          key: "getNextSibling",
          value: function getNextSibling(e) {
            if (!(e = this.resolvePath(e))) return null;
            if (!e.size) return null;
            var i = ge.increment(e);
            return this.getNode(i);
          }
        }, {
          key: "getNextText",
          value: function getNextText(e) {
            if (!(e = this.resolvePath(e))) return null;
            if (!e.size) return null;
            var i = this.getNextNode(e);
            return i ? i.getFirstText() : null;
          }
        }, {
          key: "getOffset",
          value: function getOffset(e) {
            this.assertDescendant(e);
            var i = this.getFurthestAncestor(e),
              t = this.nodes.takeUntil(function (e) {
                return e == i;
              }).reduce(function (e, i) {
                return e + i.text.length;
              }, 0);
            return this.hasChild(e) ? t : t + i.getOffset(e);
          }
        }, {
          key: "getOffsetAtRange",
          value: function getOffsetAtRange(e) {
            if ((e = this.resolveRange(e)).isUnset) throw new Error("The range cannot be unset to calculcate its offset.");
            if (e.isExpanded) throw new Error("The range must be collapsed to calculcate its offset.");
            var i = e.start;
            return this.getOffset(i.key) + i.offset;
          }
        }, {
          key: "getOrderedMarks",
          value: function getOrderedMarks() {
            var e = this.getMarksAsArray();
            return Object(m.OrderedSet)(e);
          }
        }, {
          key: "getOrderedMarksAtRange",
          value: function getOrderedMarksAtRange(e) {
            var i = e = this.resolveRange(e),
              t = i.start,
              a = i.end;
            return e.isUnset ? Object(m.OrderedSet)() : e.isCollapsed ? this.getMarksAtPosition(t.key, t.offset) : this.getOrderedMarksBetweenPositions(t.key, t.offset, a.key, a.offset);
          }
        }, {
          key: "getOrderedMarksBetweenPositions",
          value: function getOrderedMarksBetweenPositions(e, i, t, a) {
            if (e === t) return this.getDescendant(e).getMarksBetweenOffsets(i, a);
            var n = this.getTextsBetweenPositionsAsArray(e, t);
            return Object(m.OrderedSet)().withMutations(function (o) {
              n.forEach(function (n) {
                n.key === e ? o.union(n.getMarksBetweenOffsets(i, n.text.length)) : n.key === t ? o.union(n.getMarksBetweenOffsets(0, a)) : o.union(n.getMarks());
              });
            });
          }
        }, {
          key: "getOrderedMarksByType",
          value: function getOrderedMarksByType(e) {
            var i = this.getMarksByTypeAsArray(e);
            return Object(m.OrderedSet)(i);
          }
        }, {
          key: "getParent",
          value: function getParent(e) {
            if (!(e = this.resolvePath(e))) return null;
            if (!e.size) return null;
            var i = ge.lift(e);
            return this.getNode(i);
          }
        }, {
          key: "getPreviousBlock",
          value: function getPreviousBlock(e) {
            var i = this.assertDescendant(e),
              t = void 0;
            "block" == i.object ? t = i.getFirstText() : t = this.getClosestBlock(e).getFirstText();
            var a = this.getPreviousText(t.key);
            return a ? this.getClosestBlock(a.key) : null;
          }
        }, {
          key: "getPreviousNode",
          value: function getPreviousNode(e) {
            if (!(e = this.resolvePath(e))) return null;
            if (!e.size) return null;
            for (var i = e.size; i > 0; i--) {
              var t = e.slice(0, i);
              if (0 !== t.last()) {
                var a = ge.decrement(t),
                  n = this.getNode(a);
                if (n) return n;
              }
            }
            return null;
          }
        }, {
          key: "getPreviousSibling",
          value: function getPreviousSibling(e) {
            if (!(e = this.resolvePath(e))) return null;
            if (!e.size) return null;
            if (0 === e.last()) return null;
            var i = ge.decrement(e);
            return this.getNode(i);
          }
        }, {
          key: "getPreviousText",
          value: function getPreviousText(e) {
            if (!(e = this.resolvePath(e))) return null;
            if (!e.size) return null;
            var i = this.getPreviousNode(e);
            return i ? i.getLastText() : null;
          }
        }, {
          key: "getSelectionIndexes",
          value: function getSelectionIndexes(e) {
            var i = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
              t = e.start,
              a = e.end;
            if (!i) return null;
            if (e.isUnset) return null;
            if (t.key == a.key) {
              var n = this.getFurthestAncestor(t.key),
                o = n ? this.nodes.indexOf(n) : null;
              return {
                start: o,
                end: o + 1
              };
            }
            var r = null,
              s = null;
            return this.nodes.forEach(function (e, i) {
              return "text" == e.object ? (null == r && e.key == t.key && (r = i), null == s && e.key == a.key && (s = i + 1)) : (null == r && e.hasDescendant(t.key) && (r = i), null == s && e.hasDescendant(a.key) && (s = i + 1)), null == r || null == s;
            }), i && null == r && (r = 0), i && null == s && (s = this.nodes.size), null == r ? null : {
              start: r,
              end: s
            };
          }
        }, {
          key: "getTextAtOffset",
          value: function getTextAtOffset(e) {
            if (0 === e) return this.getFirstText();
            if (e === this.text.length) return this.getLastText();
            if (e < 0 || e > this.text.length) return null;
            var i = 0;
            return this.getTexts().find(function (t, a, n) {
              return (i += t.text.length) > e;
            });
          }
        }, {
          key: "getTextDirection",
          value: function getTextDirection() {
            var e = E()(this.text);
            return "neutral" === e ? null : e;
          }
        }, {
          key: "getTexts",
          value: function getTexts() {
            var e = this.getTextsAsArray();
            return Object(m.List)(e);
          }
        }, {
          key: "getTextsAsArray",
          value: function getTextsAsArray() {
            var e = [];
            return this.nodes.forEach(function (i) {
              "text" == i.object ? e.push(i) : e = e.concat(i.getTextsAsArray());
            }), e;
          }
        }, {
          key: "getTextsAtRange",
          value: function getTextsAtRange(e) {
            if ((e = this.resolveRange(e)).isUnset) return Object(m.List)();
            var i = e,
              t = i.start,
              a = i.end;
            return Object(m.List)(this.getTextsBetweenPositionsAsArray(t.key, a.key));
          }
        }, {
          key: "getTextsAtRangeAsArray",
          value: function getTextsAtRangeAsArray(e) {
            if ((e = this.resolveRange(e)).isUnset) return [];
            var i = e,
              t = i.start,
              a = i.end;
            return this.getTextsBetweenPositionsAsArray(t.key, a.key);
          }
        }, {
          key: "getTextsBetweenPositionsAsArray",
          value: function getTextsBetweenPositionsAsArray(e, i) {
            var t = this.getDescendant(e);
            if (e == i) return [t];
            var a = this.getDescendant(i),
              n = this.getTextsAsArray(),
              o = n.indexOf(t),
              r = n.indexOf(a, o);
            return n.slice(o, r + 1);
          }
        }, {
          key: "hasBlockChildren",
          value: function hasBlockChildren() {
            return !(!this.nodes || !this.nodes.find(function (e) {
              return "block" === e.object;
            }));
          }
        }, {
          key: "hasChild",
          value: function hasChild(e) {
            return !!this.getChild(e);
          }
        }, {
          key: "hasInlineChildren",
          value: function hasInlineChildren() {
            return !(!this.nodes || !this.nodes.find(function (e) {
              return "inline" === e.object || "text" === e.object;
            }));
          }
        }, {
          key: "hasDescendant",
          value: function hasDescendant(e) {
            return !!this.getDescendant(e);
          }
        }, {
          key: "hasVoidParent",
          value: function hasVoidParent(e, i) {
            return !!this.getClosestVoid(e, i);
          }
        }, {
          key: "insertNode",
          value: function insertNode(e, i) {
            var t = (e = this.resolvePath(e)).last(),
              a = ge.lift(e),
              n = this.assertNode(a),
              o = n.nodes.splice(t, 0, i);
            return n = n.set("nodes", o), this.replaceNode(a, n);
          }
        }, {
          key: "insertText",
          value: function insertText(e, i, t, a) {
            var n = this.assertDescendant(e);
            return e = this.resolvePath(e), n = n.insertText(i, t, a), this.replaceNode(e, n);
          }
        }, {
          key: "isLeafBlock",
          value: function isLeafBlock() {
            var e = this.object,
              i = this.nodes.first();
            return "block" === e && "block" !== i.object;
          }
        }, {
          key: "isLeafInline",
          value: function isLeafInline() {
            var e = this.object,
              i = this.nodes.first();
            return "inline" === e && "inline" !== i.object;
          }
        }, {
          key: "mapChildren",
          value: function mapChildren(e) {
            var i = this,
              t = this.nodes;
            return t.forEach(function (a, n) {
              var o = e(a, n, i.nodes);
              o !== a && (t = t.set(o.key, o));
            }), this.set("nodes", t);
          }
        }, {
          key: "mapDescendants",
          value: function mapDescendants(e) {
            var i = this,
              t = this.nodes;
            return t.forEach(function (a, n) {
              var o = a;
              "text" !== o.object && (o = o.mapDescendants(e)), (o = e(o, n, i.nodes)) !== a && (t = t.set(n, o));
            }), this.set("nodes", t);
          }
        }, {
          key: "mergeNode",
          value: function mergeNode(e) {
            var i = this.assertNode(e);
            if (0 === (e = this.resolvePath(e)).last()) throw new Error("Unable to merge node because it has no previous sibling: " + i);
            var t = ge.decrement(e),
              a = this.assertNode(t);
            if (a.object !== i.object) throw new Error("Unable to merge two different kinds of nodes: " + a + " and " + i);
            var n = "text" === a.object ? a.mergeText(i) : a.set("nodes", a.nodes.concat(i.nodes)),
              o = this;
            return o = (o = (o = o.removeNode(e)).removeNode(t)).insertNode(t, n);
          }
        }, {
          key: "moveNode",
          value: function moveNode(e, i) {
            var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
              a = this.assertNode(e);
            e = this.resolvePath(e), i = this.resolvePath(i, t);
            var n = ge.lift(i);
            this.assertNode(n);
            var o = ge.crop(e, i),
              r = N(o, 2),
              s = r[0],
              _ = r[1],
              l = ge.compare(s, _);
            e.size < i.size && -1 === l && (i = ge.decrement(i, 1, s.size - 1));
            var g = this;
            return g = (g = g.removeNode(e)).insertNode(i, a);
          }
        }, {
          key: "removeMark",
          value: function removeMark(e, i, t, a) {
            var n = this.assertDescendant(e);
            return e = this.resolvePath(e), n = n.removeMark(i, t, a), this.replaceNode(e, n);
          }
        }, {
          key: "removeNode",
          value: function removeNode(e) {
            this.assertDescendant(e);
            var i = (e = this.resolvePath(e)).flatMap(function (e) {
              return ["nodes", e];
            });
            return this.deleteIn(i);
          }
        }, {
          key: "removeText",
          value: function removeText(e, i, t) {
            var a = this.assertDescendant(e);
            return a = a.removeText(i, t.length), this.replaceNode(e, a);
          }
        }, {
          key: "replaceNode",
          value: function replaceNode(e, i) {
            if (!(e = this.resolvePath(e))) throw new Error("Unable to replace a node because it could not be found in the first place: " + e);
            if (!e.size) return i;
            this.assertNode(e);
            var t = e.flatMap(function (e) {
              return ["nodes", e];
            });
            return this.setIn(t, i);
          }
        }, {
          key: "resolveDecoration",
          value: function resolveDecoration(e) {
            return e = (e = ve.create(e)).normalize(this);
          }
        }, {
          key: "resolvePoint",
          value: function resolvePoint(e) {
            return e = (e = ye.create(e)).normalize(this);
          }
        }, {
          key: "resolveRange",
          value: function resolveRange(e) {
            return e = (e = Ae.create(e)).normalize(this);
          }
        }, {
          key: "resolveSelection",
          value: function resolveSelection(e) {
            return e = (e = xe.create(e)).normalize(this);
          }
        }, {
          key: "setNode",
          value: function setNode(e, i) {
            var t = this.assertNode(e);
            return t = t.merge(i), this.replaceNode(e, t);
          }
        }, {
          key: "setMark",
          value: function setMark(e, i, t, a, n) {
            var o = this.assertNode(e);
            return o = o.updateMark(i, t, a, n), this.replaceNode(e, o);
          }
        }, {
          key: "splitNode",
          value: function splitNode(e, i, t) {
            var a = this.assertNode(e);
            e = this.resolvePath(e);
            var n = void 0,
              o = void 0;
            if ("text" === a.object) {
              var r = a.splitText(i),
                s = N(r, 2);
              n = s[0], o = s[1];
            } else {
              var _ = a.nodes.take(i),
                l = a.nodes.skip(i);
              n = a.set("nodes", _), o = a.set("nodes", l).regenerateKey();
            }
            t && "text" !== a.object && (o = o.merge(t));
            var g = this;
            return g = (g = (g = g.removeNode(e)).insertNode(e, o)).insertNode(e, n);
          }
        }]), ElementInterface;
      }(),
      Ze = function _loop(e) {
        Xe.prototype["assert" + e] = function (i) {
          for (var t = arguments.length, a = Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) {
            a[n - 1] = arguments[n];
          }
          var o = this["get" + e].apply(this, [i].concat(a));
          if (null == o) throw new Error("`Node.assert" + e + "` could not find node with path or key: " + i);
          return o;
        };
      },
      Qe = !0,
      ei = !1,
      ii = void 0;
    try {
      for (var ti, ai = ["Child", "Depth", "Descendant", "Node", "Parent", "Path"][Symbol.iterator](); !(Qe = (ti = ai.next()).done); Qe = !0) {
        Ze(ti.value);
      }
    } catch (sr) {
      ei = !0, ii = sr;
    } finally {
      try {
        !Qe && ai.return && ai.return();
      } finally {
        if (ei) throw ii;
      }
    }
    memoize(Xe.prototype, ["getBlocksAsArray", "getBlocksAtRangeAsArray", "getBlocksByTypeAsArray", "getDecorations", "getFragmentAtRange", "getInlinesAsArray", "getInlinesAtRangeAsArray", "getInlinesByTypeAsArray", "getMarksAsArray", "getMarksAtPosition", "getOrderedMarksBetweenPositions", "getInsertMarksAtRange", "getMarksByTypeAsArray", "getNextBlock", "getOffset", "getOffsetAtRange", "getPreviousBlock", "getTextAtOffset", "getTextDirection", "getTextsAsArray", "getTextsBetweenPositionsAsArray"]), mixin(Xe, [ie, R, L]), mixin(function () {
      function RangeInterface() {
        D(this, RangeInterface);
      }
      return B(RangeInterface, [{
        key: "flip",
        value: function flip() {
          return this.setPoints([this.focus, this.anchor]);
        }
      }, {
        key: "moveForward",
        value: function moveForward(e) {
          return this.updatePoints(function (i) {
            return i.moveForward(e);
          });
        }
      }, {
        key: "moveBackward",
        value: function moveBackward(e) {
          return this.updatePoints(function (i) {
            return i.moveBackward(e);
          });
        }
      }, {
        key: "moveAnchorBackward",
        value: function moveAnchorBackward(e) {
          return this.setAnchor(this.anchor.moveBackward(e));
        }
      }, {
        key: "moveAnchorForward",
        value: function moveAnchorForward(e) {
          return this.setAnchor(this.anchor.moveForward(e));
        }
      }, {
        key: "moveAnchorTo",
        value: function moveAnchorTo(e, i) {
          return this.setAnchor(this.anchor.moveTo(e, i));
        }
      }, {
        key: "moveAnchorToStartOfNode",
        value: function moveAnchorToStartOfNode(e) {
          return this.setAnchor(this.anchor.moveToStartOfNode(e));
        }
      }, {
        key: "moveAnchorToEndOfNode",
        value: function moveAnchorToEndOfNode(e) {
          return this.setAnchor(this.anchor.moveToEndOfNode(e));
        }
      }, {
        key: "moveEndBackward",
        value: function moveEndBackward(e) {
          return this.setEnd(this.end.moveBackward(e));
        }
      }, {
        key: "moveEndForward",
        value: function moveEndForward(e) {
          return this.setEnd(this.end.moveForward(e));
        }
      }, {
        key: "moveEndTo",
        value: function moveEndTo(e, i) {
          return this.setEnd(this.end.moveTo(e, i));
        }
      }, {
        key: "moveEndToStartOfNode",
        value: function moveEndToStartOfNode(e) {
          return this.setEnd(this.end.moveToStartOfNode(e));
        }
      }, {
        key: "moveEndToEndOfNode",
        value: function moveEndToEndOfNode(e) {
          return this.setEnd(this.end.moveToEndOfNode(e));
        }
      }, {
        key: "moveFocusBackward",
        value: function moveFocusBackward(e) {
          return this.setFocus(this.focus.moveBackward(e));
        }
      }, {
        key: "moveFocusForward",
        value: function moveFocusForward(e) {
          return this.setFocus(this.focus.moveForward(e));
        }
      }, {
        key: "moveFocusTo",
        value: function moveFocusTo(e, i) {
          return this.setFocus(this.focus.moveTo(e, i));
        }
      }, {
        key: "moveFocusToStartOfNode",
        value: function moveFocusToStartOfNode(e) {
          return this.setFocus(this.focus.moveToStartOfNode(e));
        }
      }, {
        key: "moveFocusToEndOfNode",
        value: function moveFocusToEndOfNode(e) {
          return this.setFocus(this.focus.moveToEndOfNode(e));
        }
      }, {
        key: "moveStartBackward",
        value: function moveStartBackward(e) {
          return this.setStart(this.start.moveBackward(e));
        }
      }, {
        key: "moveStartForward",
        value: function moveStartForward(e) {
          return this.setStart(this.start.moveForward(e));
        }
      }, {
        key: "moveStartTo",
        value: function moveStartTo(e, i) {
          return this.setStart(this.start.moveTo(e, i));
        }
      }, {
        key: "moveStartToStartOfNode",
        value: function moveStartToStartOfNode(e) {
          return this.setStart(this.start.moveToStartOfNode(e));
        }
      }, {
        key: "moveStartToEndOfNode",
        value: function moveStartToEndOfNode(e) {
          return this.setStart(this.start.moveToEndOfNode(e));
        }
      }, {
        key: "moveTo",
        value: function moveTo(e, i) {
          return this.updatePoints(function (t) {
            return t.moveTo(e, i);
          });
        }
      }, {
        key: "moveToAnchor",
        value: function moveToAnchor() {
          return this.setFocus(this.anchor);
        }
      }, {
        key: "moveToEnd",
        value: function moveToEnd() {
          return this.setStart(this.end);
        }
      }, {
        key: "moveToEndOfNode",
        value: function moveToEndOfNode(e) {
          return this.updatePoints(function (i) {
            return i.moveToEndOfNode(e);
          });
        }
      }, {
        key: "moveToFocus",
        value: function moveToFocus() {
          return this.setAnchor(this.focus);
        }
      }, {
        key: "moveToRangeOfNode",
        value: function moveToRangeOfNode(e) {
          var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e;
          return this.setPoints([this.anchor.moveToStartOfNode(e), this.focus.moveToEndOfNode(i)]);
        }
      }, {
        key: "moveToStart",
        value: function moveToStart() {
          return this.setEnd(this.start);
        }
      }, {
        key: "moveToStartOfNode",
        value: function moveToStartOfNode(e) {
          return this.updatePoints(function (i) {
            return i.moveToStartOfNode(e);
          });
        }
      }, {
        key: "normalize",
        value: function normalize(e) {
          return this.updatePoints(function (i) {
            return i.normalize(e);
          });
        }
      }, {
        key: "setAnchor",
        value: function setAnchor(e) {
          return this.set("anchor", e);
        }
      }, {
        key: "setEnd",
        value: function setEnd(e) {
          return this.isBackward ? this.setAnchor(e) : this.setFocus(e);
        }
      }, {
        key: "setFocus",
        value: function setFocus(e) {
          return this.set("focus", e);
        }
      }, {
        key: "setPoints",
        value: function setPoints(e) {
          var i = N(e, 2),
            t = i[0],
            a = i[1];
          return this.set("anchor", t).set("focus", a);
        }
      }, {
        key: "updatePoints",
        value: function updatePoints(e) {
          var i = this.anchor,
            t = this.focus;
          return i = e(i), t = e(t), this.merge({
            anchor: i,
            focus: t
          });
        }
      }, {
        key: "setStart",
        value: function setStart(e) {
          return this.isBackward ? this.setFocus(e) : this.setAnchor(e);
        }
      }, {
        key: "setProperties",
        value: function setProperties(e) {
          var i = e = Ae.createProperties(e),
            t = i.anchor,
            a = i.focus,
            n = O(i, ["anchor", "focus"]);
          return t && (n.anchor = ye.create(t)), a && (n.focus = ye.create(a)), this.merge(n);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return {
            object: this.object,
            anchor: this.anchor.toJSON(e),
            focus: this.focus.toJSON(e)
          };
        }
      }, {
        key: "toRange",
        value: function toRange() {
          var e = Ae.createProperties(this);
          return Ae.create(e);
        }
      }, {
        key: "unset",
        value: function unset() {
          return this.updatePoints(function (e) {
            return e.unset();
          });
        }
      }, {
        key: "isCollapsed",
        get: function get$$1() {
          return this.anchor === this.focus || this.anchor.key === this.focus.key && this.anchor.offset === this.focus.offset;
        }
      }, {
        key: "isExpanded",
        get: function get$$1() {
          return !this.isCollapsed;
        }
      }, {
        key: "isBackward",
        get: function get$$1() {
          var e = this.isUnset,
            i = this.anchor,
            t = this.focus;
          return e ? null : i.key === t.key ? i.offset > t.offset : ge.isBefore(t.path, i.path);
        }
      }, {
        key: "isForward",
        get: function get$$1() {
          var e = this.isBackward;
          return null == e ? null : !e;
        }
      }, {
        key: "isUnset",
        get: function get$$1() {
          var e = this.anchor,
            i = this.focus;
          return e.isUnset || i.isUnset;
        }
      }, {
        key: "isSet",
        get: function get$$1() {
          return !this.isUnset;
        }
      }, {
        key: "start",
        get: function get$$1() {
          return this.isBackward ? this.focus : this.anchor;
        }
      }, {
        key: "end",
        get: function get$$1() {
          return this.isBackward ? this.anchor : this.focus;
        }
      }]), RangeInterface;
    }(), [ve, Ae, xe]);
    function slate_prop_types_es_create(e, i) {
      function check(t, a, n, o, r) {
        var s = a[n];
        return null != s || t ? null == s && t ? new Error("The " + r + " `" + n + "` is marked as required in `" + o + "`, but it was not supplied.") : i(s) ? null : new Error("Invalid " + r + " `" + n + "` supplied to `" + o + "`, expected a Slate `" + e + "` but received: " + s) : null;
      }
      function propType() {
        for (var e = arguments.length, i = Array(e), t = 0; t < e; t++) {
          i[t] = arguments[t];
        }
        return check.apply(void 0, [!1].concat(i));
      }
      return propType.isRequired = function () {
        for (var e = arguments.length, i = Array(e), t = 0; t < e; t++) {
          i[t] = arguments[t];
        }
        return check.apply(void 0, [!0].concat(i));
      }, propType;
    }
    var ni = {
        block: slate_prop_types_es_create("Block", function (e) {
          return ie.isBlock(e);
        }),
        blocks: slate_prop_types_es_create("List<Block>", function (e) {
          return ie.isBlockList(e);
        }),
        change: slate_prop_types_es_create("Change", function (e) {
          return Ge.isChange(e);
        }),
        data: slate_prop_types_es_create("Data", function (e) {
          return P.isData(e);
        }),
        document: slate_prop_types_es_create("Document", function (e) {
          return R.isDocument(e);
        }),
        history: slate_prop_types_es_create("History", function (e) {
          return Se.isHistory(e);
        }),
        inline: slate_prop_types_es_create("Inline", function (e) {
          return L.isInline(e);
        }),
        inlines: slate_prop_types_es_create("Inline", function (e) {
          return L.isInlineList(e);
        }),
        leaf: slate_prop_types_es_create("Leaf", function (e) {
          return H.isLeaf(e);
        }),
        leaves: slate_prop_types_es_create("List<Leaf>", function (e) {
          return H.isLeafList(e);
        }),
        mark: slate_prop_types_es_create("Mark", function (e) {
          return U.isMark(e);
        }),
        marks: slate_prop_types_es_create("Set<Mark>", function (e) {
          return U.isMarkSet(e);
        }),
        node: slate_prop_types_es_create("Node", function (e) {
          return Q.isNode(e);
        }),
        nodes: slate_prop_types_es_create("List<Node>", function (e) {
          return Q.isNodeList(e);
        }),
        range: slate_prop_types_es_create("Range", function (e) {
          return Ae.isRange(e);
        }),
        ranges: slate_prop_types_es_create("List<Range>", function (e) {
          return Ae.isRangeList(e);
        }),
        schema: slate_prop_types_es_create("Schema", function (e) {
          return Me.isSchema(e);
        }),
        stack: slate_prop_types_es_create("Stack", function (e) {
          return Oe.isStack(e);
        }),
        value: slate_prop_types_es_create("Value", function (e) {
          return ze.isValue(e);
        }),
        text: slate_prop_types_es_create("Text", function (e) {
          return Z.isText(e);
        }),
        texts: slate_prop_types_es_create("List<Text>", function (e) {
          return Z.isTextList(e);
        })
      },
      oi = t(76),
      ri = t.n(oi),
      si = t(5),
      _i = t.n(si),
      li = "function" === typeof Symbol && "symbol" === typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" === typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      },
      gi = "object" === ("undefined" === typeof window ? "undefined" : li(window)) && "object" === ("undefined" === typeof document ? "undefined" : li(document)) && 9 === document.nodeType,
      fi = function () {
        return function (e, i) {
          if (Array.isArray(e)) return e;
          if (Symbol.iterator in Object(e)) return function sliceIterator(e, i) {
            var t = [],
              a = !0,
              n = !1,
              o = void 0;
            try {
              for (var r, s = e[Symbol.iterator](); !(a = (r = s.next()).done) && (t.push(r.value), !i || t.length !== i); a = !0) {
                ;
              }
            } catch (sr) {
              n = !0, o = sr;
            } finally {
              try {
                !a && s.return && s.return();
              } finally {
                if (n) throw o;
              }
            }
            return t;
          }(e, i);
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
      }(),
      hi = void 0;
    if (gi) {
      var di = !0,
        mi = !1,
        ui = void 0;
      try {
        for (var ci, Fi = [["edge", /Edge\/([0-9\._]+)/], ["chrome", /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/], ["firefox", /Firefox\/([0-9\.]+)(?:\s|$)/], ["opera", /Opera\/([0-9\.]+)(?:\s|$)/], ["opera", /OPR\/([0-9\.]+)(:?\s|$)$/], ["ie", /Trident\/7\.0.*rv\:([0-9\.]+)\).*Gecko$/], ["ie", /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/], ["ie", /MSIE\s(7\.0)/], ["android", /Android\s([0-9\.]+)/], ["safari", /Version\/([0-9\._]+).*Safari/]][Symbol.iterator](); !(di = (ci = Fi.next()).done); di = !0) {
          var pi = ci.value,
            bi = fi(pi, 2),
            yi = bi[0];
          if (bi[1].test(window.navigator.userAgent)) {
            hi = yi;
            break;
          }
        }
      } catch (sr) {
        mi = !0, ui = sr;
      } finally {
        try {
          !di && Fi.return && Fi.return();
        } finally {
          if (mi) throw ui;
        }
      }
    }
    var ki = void 0;
    if (gi) {
      var vi = !0,
        wi = !1,
        Ei = void 0;
      try {
        for (var Ai, ji = [["ios", /os ([\.\_\d]+) like mac os/i], ["macos", /mac os x/i], ["android", /android/i], ["firefoxos", /mozilla\/[a-z\.\_\d]+ \((?:mobile)|(?:tablet)/i], ["windows", /windows\s*(?:nt)?\s*([\.\_\d]+)/i]][Symbol.iterator](); !(vi = (Ai = ji.next()).done); vi = !0) {
          var xi = Ai.value,
            Ci = fi(xi, 2),
            Di = Ci[0];
          if (Ci[1].test(window.navigator.userAgent)) {
            ki = Di;
            break;
          }
        }
      } catch (sr) {
        wi = !0, Ei = sr;
      } finally {
        try {
          !vi && ji.return && ji.return();
        } finally {
          if (wi) throw Ei;
        }
      }
    }
    var Bi = [];
    if (gi) {
      var Si = !0,
        qi = !1,
        Oi = void 0;
      try {
        for (var Ti, Ni = [["inputeventslevel1", function (e) {
            return ("inputType" in (e.InputEvent ? new e.InputEvent("input") : {}));
          }], ["inputeventslevel2", function (e) {
            var i = e.document.createElement("div");
            return i.contentEditable = !0, ("onbeforeinput" in i);
          }]][Symbol.iterator](); !(Si = (Ti = Ni.next()).done); Si = !0) {
          var Ii = Ti.value,
            Pi = fi(Ii, 2),
            Mi = Pi[0];
          (0, Pi[1])(window) && Bi.push(Mi);
        }
      } catch (sr) {
        qi = !0, Oi = sr;
      } finally {
        try {
          !Si && Ni.return && Ni.return();
        } finally {
          if (qi) throw Oi;
        }
      }
    }
    var Ri = [[/^9([.]0|)/, 28], [/^8[.]1/, 27], [/^8([.]0|)/, 26], [/^7[.]1/, 25], [/^7([.]0|)/, 24], [/^6([.]0|)/, 23], [/^5[.]1/, 22], [/^5([.]0|)/, 21], [/^4[.]4/, 20]];
    var zi = "firefox" === hi,
      Li = "safari" === hi,
      Wi = "ie" === hi,
      Ui = "edge" === hi,
      Ki = "android" === ki,
      Hi = "ios" === ki,
      Vi = "macos" === ki,
      Ji = function getAndroidApiVersion() {
        if ("android" !== ki) return null;
        var e = window.navigator.userAgent.match(/Android\s([0-9\.]+)/);
        if (null == e) return null;
        var i = e[1],
          t = !0,
          a = !1,
          n = void 0;
        try {
          for (var o, r = Ri[Symbol.iterator](); !(t = (o = r.next()).done); t = !0) {
            var s = o.value,
              _ = fi(s, 2),
              l = _[0],
              g = _[1];
            if (i.match(l)) return g;
          }
        } catch (sr) {
          a = !0, n = sr;
        } finally {
          try {
            !t && r.return && r.return();
          } finally {
            if (a) throw n;
          }
        }
        return null;
      }(),
      $i = (Bi.includes("inputeventslevel1"), Bi.includes("inputeventslevel2") || Ki && (28 === Ji || null === Ji)),
      Gi = t(119),
      Yi = t.n(Gi),
      Xi = t(120),
      Zi = t.n(Xi),
      Qi = t(77);
    function encode(e) {
      var i = JSON.stringify(e);
      return Object(Qi.btoa)(encodeURIComponent(i));
    }
    function decode(e) {
      var i = decodeURIComponent(Object(Qi.atob)(e));
      return JSON.parse(i);
    }
    var et = {
        deserialize: function deserialize(e, i) {
          var t = decode(e);
          return ze.fromJSON(t, i);
        },
        deserializeNode: function deserializeNode(e, i) {
          var t = decode(e);
          return Q.fromJSON(t, i);
        },
        serialize: function slate_base64_serializer_es_serialize(e, i) {
          return encode(e.toJSON(i));
        },
        serializeNode: function serializeNode(e, i) {
          return encode(e.toJSON(i));
        }
      },
      it = Object.assign || function (e) {
        for (var i = 1; i < arguments.length; i++) {
          var t = arguments[i];
          for (var a in t) {
            Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
          }
        }
        return e;
      };
    function slate_plain_serializer_es_serializeNode(e) {
      var i = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}).delimiter,
        t = void 0 === i ? "\n" : i;
      return "document" === e.object || "block" === e.object && ie.isBlockList(e.nodes) ? e.nodes.map(slate_plain_serializer_es_serializeNode).join(t) : e.text;
    }
    var tt = {
        deserialize: function slate_plain_serializer_es_deserialize(e) {
          var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            t = i.defaultBlock,
            a = void 0 === t ? "line" : t,
            n = i.defaultMarks,
            o = void 0 === n ? [] : n,
            r = i.delimiter,
            s = void 0 === r ? "\n" : r,
            _ = i.toJSON,
            l = void 0 !== _ && _;
          m.Set.isSet(o) && (o = o.toArray()), a = Q.createProperties(a), o = o.map(U.createProperties);
          var g = {
            object: "value",
            document: {
              object: "document",
              data: {},
              nodes: e.split(s).map(function (e) {
                return it({}, a, {
                  object: "block",
                  data: {},
                  nodes: [{
                    object: "text",
                    leaves: [{
                      object: "leaf",
                      text: e,
                      marks: o
                    }]
                  }]
                });
              })
            }
          };
          return l ? g : ze.fromJSON(g);
        },
        serialize: function slate_plain_serializer_es_serialize(e) {
          var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return slate_plain_serializer_es_serializeNode(e.document, i);
        }
      },
      at = t(47),
      nt = {
        bold: "mod+b",
        compose: ["down", "left", "right", "up", "backspace", "enter"],
        moveBackward: "left",
        moveForward: "right",
        moveWordBackward: "ctrl+left",
        moveWordForward: "ctrl+right",
        deleteBackward: "shift?+backspace",
        deleteForward: "shift?+delete",
        extendBackward: "shift+left",
        extendForward: "shift+right",
        italic: "mod+i",
        splitBlock: "shift?+enter",
        undo: "mod+z"
      },
      ot = {
        moveLineBackward: "opt+up",
        moveLineForward: "opt+down",
        moveWordBackward: "opt+left",
        moveWordForward: "opt+right",
        deleteBackward: ["ctrl+backspace", "ctrl+h"],
        deleteForward: ["ctrl+delete", "ctrl+d"],
        deleteLineBackward: "cmd+shift?+backspace",
        deleteLineForward: ["cmd+shift?+delete", "ctrl+k"],
        deleteWordBackward: "opt+shift?+backspace",
        deleteWordForward: "opt+shift?+delete",
        extendLineBackward: "opt+shift+up",
        extendLineForward: "opt+shift+down",
        redo: "cmd+shift+z",
        transposeCharacter: "ctrl+t"
      },
      rt = {
        deleteWordBackward: "ctrl+shift?+backspace",
        deleteWordForward: "ctrl+shift?+delete",
        redo: "ctrl+y"
      },
      st = {},
      _t = Hi || Vi,
      lt = !_t;
    [].concat(Object.keys(nt)).concat(Object.keys(ot)).concat(Object.keys(rt)).forEach(function (e) {
      var i = "is" + e[0].toUpperCase() + e.slice(1);
      if (!st[i]) {
        var t = nt[e],
          a = ot[e],
          n = rt[e],
          o = t && Object(at.isKeyHotkey)(t),
          r = a && Object(at.isKeyHotkey)(a),
          s = n && Object(at.isKeyHotkey)(n);
        st[i] = function (e) {
          return !(!o || !o(e)) || !!(_t && r && r(e)) || !!(lt && s && s(e));
        };
      }
    });
    var gt = st,
      ft = t(46),
      ht = function simpleIsEqual(e, i) {
        return e === i;
      };
    var dt = function memoize_one_esm_index(e, i) {
        var t;
        void 0 === i && (i = ht);
        var a,
          n = [],
          o = !1,
          r = function isNewArgEqualToLast(e, t) {
            return i(e, n[t], t);
          };
        return function result() {
          for (var i = arguments.length, s = new Array(i), _ = 0; _ < i; _++) {
            s[_] = arguments[_];
          }
          return o && t === this && s.length === n.length && s.every(r) ? a : (a = e.apply(this, s), o = !0, t = this, n = s, a);
        };
      },
      mt = ["onBeforeInput", "onBlur", "onClick", "onContextMenu", "onCompositionEnd", "onCompositionStart", "onCopy", "onCut", "onDragEnd", "onDragEnter", "onDragExit", "onDragLeave", "onDragOver", "onDragStart", "onDrop", "onInput", "onFocus", "onKeyDown", "onKeyUp", "onPaste", "onSelect"],
      ut = function classCallCheck(e, i) {
        if (!(e instanceof i)) throw new TypeError("Cannot call a class as a function");
      },
      ct = function () {
        function defineProperties(e, i) {
          for (var t = 0; t < i.length; t++) {
            var a = i[t];
            a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
          }
        }
        return function (e, i, t) {
          return i && defineProperties(e.prototype, i), t && defineProperties(e, t), e;
        };
      }(),
      Ft = function defineProperty(e, i, t) {
        return i in e ? Object.defineProperty(e, i, {
          value: t,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[i] = t, e;
      },
      pt = Object.assign || function (e) {
        for (var i = 1; i < arguments.length; i++) {
          var t = arguments[i];
          for (var a in t) {
            Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
          }
        }
        return e;
      },
      bt = function inherits(e, i) {
        if ("function" !== typeof i && null !== i) throw new TypeError("Super expression must either be null or a function, not " + typeof i);
        e.prototype = Object.create(i && i.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), i && (Object.setPrototypeOf ? Object.setPrototypeOf(e, i) : e.__proto__ = i);
      },
      yt = function possibleConstructorReturn(e, i) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !i || "object" !== typeof i && "function" !== typeof i ? e : i;
      },
      kt = function () {
        return function (e, i) {
          if (Array.isArray(e)) return e;
          if (Symbol.iterator in Object(e)) return function sliceIterator(e, i) {
            var t = [],
              a = !0,
              n = !1,
              o = void 0;
            try {
              for (var r, s = e[Symbol.iterator](); !(a = (r = s.next()).done) && (t.push(r.value), !i || t.length !== i); a = !0) {
                ;
              }
            } catch (sr) {
              n = !0, o = sr;
            } finally {
              try {
                !a && s.return && s.return();
              } finally {
                if (n) throw o;
              }
            }
            return t;
          }(e, i);
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
      }(),
      vt = function toConsumableArray(e) {
        if (Array.isArray(e)) {
          for (var i = 0, t = Array(e.length); i < e.length; i++) {
            t[i] = e[i];
          }
          return t;
        }
        return Array.from(e);
      },
      wt = [].concat(vt(mt), ["decorateNode", "onChange", "renderEditor", "renderMark", "renderNode", "renderPlaceholder", "renderPortal", "schema", "validateNode"]),
      Et = /^([\w-]+)(?::(\d+))?$/;
    var At = {
        parse: function parse(e) {
          var i = Et.exec(e);
          if (!i) throw new Error('Invalid offset key string "' + e + '".');
          var t = kt(i, 3),
            a = (t[0], t[1]),
            n = t[2];
          return {
            key: a,
            index: parseInt(n, 10)
          };
        },
        stringify: function stringify(e) {
          return e.key + ":" + e.index;
        }
      },
      jt = l()("slate:leaves"),
      xt = function (e) {
        function Leaf() {
          var e, i, t;
          ut(this, Leaf);
          for (var a = arguments.length, n = Array(a), o = 0; o < a; o++) {
            n[o] = arguments[o];
          }
          return i = t = yt(this, (e = Leaf.__proto__ || Object.getPrototypeOf(Leaf)).call.apply(e, [this].concat(n))), Ct.call(t), yt(t, i);
        }
        return bt(Leaf, e), ct(Leaf, [{
          key: "shouldComponentUpdate",
          value: function shouldComponentUpdate(e) {
            return e.index != this.props.index || e.marks != this.props.marks || e.text != this.props.text || e.parent != this.props.parent;
          }
        }, {
          key: "render",
          value: function render() {
            this.debug("render", this);
            var e = this.props,
              i = e.node,
              t = e.index,
              a = At.stringify({
                key: i.key,
                index: t
              });
            return o.a.createElement("span", {
              "data-offset-key": a
            }, this.renderMarks());
          }
        }, {
          key: "renderMarks",
          value: function renderMarks() {
            var e = this.props,
              i = e.marks,
              t = e.node,
              a = e.offset,
              n = e.text,
              o = e.editor,
              r = o.stack,
              s = this.renderText(),
              _ = {
                "data-slate-leaf": !0
              };
            return i.reduce(function (e, s) {
              var l = {
                editor: o,
                mark: s,
                marks: i,
                node: t,
                offset: a,
                text: n,
                children: e,
                attributes: _
              };
              return r.find("renderMark", l) || e;
            }, s);
          }
        }, {
          key: "renderText",
          value: function renderText() {
            var e = this.props,
              i = e.block,
              t = e.node,
              a = e.editor,
              n = e.parent,
              r = e.text,
              s = e.index,
              _ = e.leaves;
            if (a.value.schema.isVoid(n)) return o.a.createElement("span", {
              "data-slate-zero-width": "z"
            }, "\uFEFF");
            if ("" === r && "block" === n.object && "" === n.text && n.nodes.last() === t) return o.a.createElement("span", {
              "data-slate-zero-width": "n"
            }, "\uFEFF");
            if ("" === r) return o.a.createElement("span", {
              "data-slate-zero-width": "z"
            }, "\uFEFF");
            var l = i.getLastText(),
              g = r.charAt(r.length - 1),
              f = t === l,
              h = s === _.size - 1;
            return f && h && "\n" === g ? r + "\n" : r;
          }
        }]), Leaf;
      }(o.a.Component);
    xt.propTypes = {
      block: ni.block.isRequired,
      editor: f.a.object.isRequired,
      index: f.a.number.isRequired,
      leaves: ni.leaves.isRequired,
      marks: ni.marks.isRequired,
      node: ni.node.isRequired,
      offset: f.a.number.isRequired,
      parent: ni.node.isRequired,
      text: f.a.string.isRequired
    };
    var Ct = function _initialiseProps() {
        var e = this;
        this.debug = function (i) {
          for (var t = arguments.length, a = Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) {
            a[n - 1] = arguments[n];
          }
          jt.apply(void 0, [i, e.props.node.key + "-" + e.props.index].concat(a));
        };
      },
      Dt = l()("slate:node"),
      Bt = function (e) {
        function Text$$1() {
          var e, i, t;
          ut(this, Text$$1);
          for (var a = arguments.length, n = Array(a), o = 0; o < a; o++) {
            n[o] = arguments[o];
          }
          return i = t = yt(this, (e = Text$$1.__proto__ || Object.getPrototypeOf(Text$$1)).call.apply(e, [this].concat(n))), St.call(t), yt(t, i);
        }
        return bt(Text$$1, e), ct(Text$$1, [{
          key: "render",
          value: function render() {
            var e = this;
            this.debug("render", this);
            var i = this.props,
              t = i.decorations,
              a = i.editor,
              n = i.node,
              r = i.style,
              s = a.value.document,
              _ = n.key,
              l = t.filter(function (e) {
                var i = e.start,
                  t = e.end;
                if (i.key === _ || t.key === _) return !0;
                if (i.key === t.key) return !1;
                var a = s.assertPath(_);
                return -1 !== ge.compare(a, i.path) && 1 !== ge.compare(a, t.path);
              }),
              g = 0 === l.size ? n.getLeaves() : n.getLeaves(l),
              f = 0,
              h = g.map(function (i, t) {
                var a = e.renderLeaf(g, i, t, f);
                return f += i.text.length, a;
              });
            return o.a.createElement("span", {
              "data-key": _,
              style: r
            }, h);
          }
        }]), Text$$1;
      }(o.a.Component);
    Bt.propTypes = {
      block: ni.block,
      decorations: ri.a.list.isRequired,
      editor: f.a.object.isRequired,
      node: ni.node.isRequired,
      parent: ni.node.isRequired,
      style: f.a.object
    }, Bt.defaultProps = {
      style: null
    };
    var St = function _initialiseProps() {
        var e = this;
        this.debug = function (i) {
          for (var t = arguments.length, a = Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) {
            a[n - 1] = arguments[n];
          }
          var o = e.props.node.key;
          Dt.apply(void 0, [i, o + " (text)"].concat(a));
        }, this.shouldComponentUpdate = function (i) {
          var t = i,
            a = e.props;
          if (t.node != a.node) return !0;
          if ("block" == t.parent.object) {
            var n = a.parent.nodes.last(),
              o = t.parent.nodes.last();
            if (a.node == n && t.node != o) return !0;
          }
          return !t.decorations.equals(a.decorations);
        }, this.renderLeaf = function (i, t, a, n) {
          var r = e.props,
            s = r.block,
            _ = r.node,
            l = r.parent,
            g = r.editor,
            f = t.text,
            h = t.marks;
          return o.a.createElement(xt, {
            key: _.key + "-" + a,
            block: s,
            editor: g,
            index: a,
            marks: h,
            node: _,
            offset: n,
            parent: l,
            leaves: i,
            text: f
          });
        };
      },
      qt = l()("slate:void"),
      Ot = function (e) {
        function Void() {
          var e, i, t;
          ut(this, Void);
          for (var a = arguments.length, n = Array(a), o = 0; o < a; o++) {
            n[o] = arguments[o];
          }
          return i = t = yt(this, (e = Void.__proto__ || Object.getPrototypeOf(Void)).call.apply(e, [this].concat(n))), Tt.call(t), yt(t, i);
        }
        return bt(Void, e), ct(Void, [{
          key: "render",
          value: function render() {
            var e = this.props,
              i = e.children,
              t = e.node,
              a = e.readOnly,
              n = "block" == t.object ? "div" : "span",
              r = o.a.createElement(n, {
                "data-slate-spacer": !0,
                style: {
                  height: "0",
                  color: "transparent",
                  outline: "none",
                  position: "absolute"
                }
              }, this.renderText()),
              s = o.a.createElement(n, {
                contentEditable: !!a && null
              }, i);
            return this.debug("render", {
              props: e
            }), o.a.createElement(n, {
              "data-slate-void": !0,
              "data-key": t.key,
              contentEditable: !(!a && "block" != t.object) && null
            }, a ? null : r, s);
          }
        }]), Void;
      }(o.a.Component);
    Ot.propTypes = {
      block: ni.block,
      children: f.a.any.isRequired,
      editor: f.a.object.isRequired,
      node: ni.node.isRequired,
      parent: ni.node.isRequired,
      readOnly: f.a.bool.isRequired
    };
    var Tt = function _initialiseProps() {
      var e = this;
      this.debug = function (i) {
        for (var t = arguments.length, a = Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) {
          a[n - 1] = arguments[n];
        }
        var o = e.props.node,
          r = o.key + " (" + o.type + ")";
        qt.apply(void 0, [i, "" + r].concat(a));
      }, this.renderText = function () {
        var i = e.props,
          t = i.block,
          a = i.decorations,
          n = i.node,
          r = i.readOnly,
          s = i.editor,
          _ = n.getFirstText();
        return o.a.createElement(Bt, {
          block: "block" == n.object ? n : t,
          decorations: a,
          editor: s,
          key: _.key,
          node: _,
          parent: n,
          readOnly: r
        });
      };
    };
    function getChildrenDecorations(e, i) {
      var t = Object(m.Set)().asMutable(),
        a = [];
      return function orderChildDecorations(e, i) {
        if (i.isEmpty()) return e.nodes.toArray().map(function (e, i) {
          return {
            child: e,
            index: i
          };
        });
        var t = Ft({}, e.key, 0),
          a = 1;
        e.forEachDescendant(function (e) {
          t[e.key] = a, a += 1;
        });
        var n = e.nodes.toArray(),
          o = n.map(function (e, i) {
            return {
              child: e,
              index: i,
              order: t[e.key]
            };
          });
        return i.forEach(function (e) {
          var i = t[e.start.key],
            r = void 0 === i ? 0 : function getContainingChildOrder(e, i, t) {
              var a = e.findIndex(function (e) {
                return t < i[e.key];
              });
              if (a <= 0) return 0;
              var n = e[a - 1];
              return i[n.key];
            }(n, t, i);
          o.push({
            isRangeStart: !0,
            order: r - .5,
            decoration: e
          });
          var s = (t[e.end.key] || a) + .5;
          o.push({
            isRangeEnd: !0,
            order: s,
            decoration: e
          });
        }), o.sort(function (e, i) {
          return e.order > i.order ? 1 : -1;
        });
      }(e, i).forEach(function (e) {
        e.isRangeStart ? t.add(e.decoration) : e.isRangeEnd ? t.remove(e.decoration) : a.push(t.toList());
      }), a;
    }
    var Nt = l()("slate:node"),
      It = function (e) {
        function Node$$1() {
          var e, i, t;
          ut(this, Node$$1);
          for (var a = arguments.length, n = Array(a), o = 0; o < a; o++) {
            n[o] = arguments[o];
          }
          return i = t = yt(this, (e = Node$$1.__proto__ || Object.getPrototypeOf(Node$$1)).call.apply(e, [this].concat(n))), Pt.call(t), yt(t, i);
        }
        return bt(Node$$1, e), ct(Node$$1, [{
          key: "shouldComponentUpdate",
          value: function shouldComponentUpdate(e) {
            var i = this.props,
              t = i.editor.stack.find("shouldNodeComponentUpdate", i, e),
              a = e,
              n = i;
            if (null != t) {
              if (t) return !0;
              u(!1 !== t, "Returning false in `shouldNodeComponentUpdate` does not disable Slate's internal `shouldComponentUpdate` logic. If you want to prevent updates, use React's `shouldComponentUpdate` instead.");
            }
            return a.readOnly != n.readOnly || a.node != n.node || !(!a.isSelected && !n.isSelected) || !(!a.isFocused && !n.isFocused) || !a.decorations.equals(n.decorations);
          }
        }, {
          key: "render",
          value: function render() {
            var e = this;
            this.debug("render", this);
            var i = this.props,
              t = i.editor,
              a = i.isSelected,
              n = i.isFocused,
              r = i.node,
              s = i.decorations,
              _ = i.parent,
              l = i.readOnly,
              g = t.value,
              f = g.selection,
              h = g.schema,
              d = t.stack,
              m = r.getSelectionIndexes(f, a),
              u = s.concat(r.getDecorations(d)),
              c = getChildrenDecorations(r, u),
              F = [];
            r.nodes.forEach(function (i, t) {
              var a = !!m && m.start <= t && t < m.end;
              F.push(e.renderNode(i, a, c[t]));
            });
            var p = {
              "data-key": r.key
            };
            "block" == r.object && "block" != r.nodes.first().object && "rtl" == r.getTextDirection() && (p.dir = "rtl");
            var b = {
                key: r.key,
                editor: t,
                isFocused: n,
                isSelected: a,
                node: r,
                parent: _,
                readOnly: l
              },
              y = d.find("renderPlaceholder", b);
            y && (y = o.a.cloneElement(y, {
              key: r.key + "-placeholder"
            }), F = [y].concat(vt(F)));
            var k = d.find("renderNode", pt({}, b, {
              attributes: p,
              children: F
            }));
            return h.isVoid(r) ? o.a.createElement(Ot, this.props, k) : k;
          }
        }]), Node$$1;
      }(o.a.Component);
    It.propTypes = {
      block: ni.block,
      decorations: ri.a.list.isRequired,
      editor: f.a.object.isRequired,
      isFocused: f.a.bool.isRequired,
      isSelected: f.a.bool.isRequired,
      node: ni.node.isRequired,
      parent: ni.node.isRequired,
      readOnly: f.a.bool.isRequired
    };
    var Pt = function _initialiseProps() {
      var e = this;
      this.debug = function (i) {
        for (var t = arguments.length, a = Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) {
          a[n - 1] = arguments[n];
        }
        var o = e.props.node,
          r = o.key,
          s = o.type;
        Nt.apply(void 0, [i, r + " (" + s + ")"].concat(a));
      }, this.renderNode = function (i, t, a) {
        var n = e.props,
          r = n.block,
          s = n.editor,
          _ = n.node,
          l = n.readOnly,
          g = n.isFocused,
          f = "text" == i.object ? Bt : It;
        return o.a.createElement(f, {
          block: "block" == _.object ? _ : r,
          decorations: a,
          editor: s,
          isSelected: t,
          isFocused: g && t,
          key: i.key,
          node: i,
          parent: _,
          readOnly: l
        });
      };
    };
    function findDOMNode$1(e) {
      var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : window;
      Q.isNode(e) && (e = e.key);
      var t = i.document.querySelector('[data-key="' + e + '"]');
      if (!t) throw new Error('Unable to find a DOM node for "' + e + '". This is often because of forgetting to add `props.attributes` to a custom component.');
      return t;
    }
    function findDOMPoint(e) {
      for (var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : window, t = findDOMNode$1(e.key, i), a = 0, n = void 0, o = i.document.createNodeIterator(t, NodeFilter.SHOW_TEXT, function () {
          return NodeFilter.FILTER_ACCEPT;
        }, !1); n = o.nextNode();) {
        var r = a + n.textContent.length;
        if (e.offset <= r) {
          var s = e.offset - a;
          return {
            node: n,
            offset: s >= 0 ? s : 0
          };
        }
        a = r;
      }
      return null;
    }
    function findDOMRange(e) {
      var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : window,
        t = e.anchor,
        a = e.focus,
        n = e.isBackward,
        o = e.isCollapsed,
        r = findDOMPoint(t, i),
        s = o ? r : findDOMPoint(a, i);
      if (!r || !s) return null;
      var _ = i.document.createRange(),
        l = n ? s : r,
        g = n ? r : s;
      return _.setStart(l.node, l.offset), _.setEnd(g.node, g.offset), _;
    }
    var Mt = "data-slate-zero-width",
      Rt = "[" + Mt + "]",
      zt = "data-offset-key",
      Lt = "[" + zt + "]",
      Wt = "[data-key]",
      Ut = "[data-slate-void]";
    function findPoint(e, i, t) {
      var a = function normalizeNodeAndOffset(e, i) {
          if (1 == e.nodeType && e.childNodes.length) {
            var t = i == e.childNodes.length,
              a = t ? "backward" : "forward",
              n = t ? i - 1 : i;
            for (e = getEditableChild(e, n, a); 1 == e.nodeType && e.childNodes.length;) {
              var o = t ? e.childNodes.length - 1 : 0;
              e = getEditableChild(e, o, a);
            }
            i = t ? e.textContent.length : 0;
          }
          return {
            node: e,
            offset: i
          };
        }(e, i),
        n = a.node,
        o = a.offset,
        r = _i()(e),
        s = n.parentNode,
        _ = s.closest(Lt),
        l = void 0,
        g = void 0;
      if (_) {
        var f = r.document.createRange(),
          h = _.closest(Wt);
        f.setStart(h, 0), f.setEnd(n, o), g = h, l = f.toString().length;
      } else {
        var d = s.closest(Ut);
        if (!d) return null;
        if (!(_ = d.querySelector(Lt))) return null;
        l = (g = _).textContent.length;
      }
      l == g.textContent.length && s.hasAttribute(Mt) && l--;
      var m = _.getAttribute(zt);
      if (!m) return null;
      var u = At.parse(m).key;
      return t.document.hasDescendant(u) ? t.document.createPoint({
        key: u,
        offset: l
      }) : null;
    }
    function getEditableChild(e, i, t) {
      for (var a = e.childNodes, n = a[i], o = i, r = !1, s = !1; (8 == n.nodeType || 1 == n.nodeType && 0 == n.childNodes.length || 1 == n.nodeType && "false" == n.getAttribute("contenteditable")) && (!r || !s);) {
        o >= a.length ? (r = !0, o = i - 1, t = "backward") : o < 0 ? (s = !0, o = i + 1, t = "forward") : (n = a[o], "forward" == t && o++, "backward" == t && o--);
      }
      return n || null;
    }
    function findRange(e, i) {
      var t = e.anchorNode || e.startContainer;
      if (!t) return null;
      var a = _i()(t);
      (e instanceof a.Range || a.StaticRange && e instanceof a.StaticRange) && (e = {
        anchorNode: e.startContainer,
        anchorOffset: e.startOffset,
        focusNode: e.endContainer,
        focusOffset: e.endOffset
      });
      var n = e,
        o = n.anchorNode,
        r = n.anchorOffset,
        s = n.focusNode,
        _ = n.focusOffset,
        l = n.isCollapsed,
        g = findPoint(o, r, i),
        f = l ? g : findPoint(s, _, i);
      if (!g || !f) return null;
      if (Wi || Ui) {
        var h = findDOMPoint(g),
          d = findDOMPoint(f);
        e = {
          anchorNode: h.node,
          anchorOffset: h.offset,
          focusNode: d.node,
          focusOffset: d.offset
        };
      }
      return i.document.createRange({
        anchor: g,
        focus: f
      });
    }
    var Kt = ["auto", "overlay", "scroll"],
      Ht = Hi && !!window.navigator.userAgent.match(/os 11_/i);
    function scrollToSelection(e) {
      if (!Ht && e.anchorNode) {
        var i = _i()(e.anchorNode),
          t = function findScrollContainer(e, i) {
            for (var t = e.parentNode, a = void 0; !a && t.parentNode;) {
              var n = i.getComputedStyle(t).overflowY;
              if (Kt.includes(n)) {
                a = t;
                break;
              }
              t = t.parentNode;
            }
            return a || i.document.body;
          }(e.anchorNode, i),
          a = t == i.document.body || t == i.document.documentElement,
          n = Yi()(e),
          o = e.getRangeAt(0).cloneRange();
        o.collapse(n);
        var r = o.getBoundingClientRect();
        Li && o.collapsed && 0 == r.top && 0 == r.height && (0 == o.startOffset ? o.setEnd(o.endContainer, 1) : o.setStart(o.startContainer, o.startOffset - 1), 0 == (r = o.getBoundingClientRect()).top && 0 == r.height && o.getClientRects().length && (r = o.getClientRects()[0]));
        var s = void 0,
          _ = void 0,
          l = void 0,
          g = void 0,
          f = 0,
          h = 0,
          d = 0,
          m = 0,
          u = 0,
          c = 0,
          F = 0,
          p = 0;
        if (a) {
          s = i.innerWidth, _ = i.innerHeight, l = i.pageYOffset, g = i.pageXOffset;
        } else {
          var b = t.offsetWidth,
            y = t.offsetHeight,
            k = t.scrollTop,
            v = t.scrollLeft,
            w = i.getComputedStyle(t),
            E = w.borderTopWidth,
            A = w.borderBottomWidth,
            j = w.borderLeftWidth,
            x = w.borderRightWidth,
            C = w.paddingTop,
            D = w.paddingBottom,
            B = w.paddingLeft,
            S = w.paddingRight,
            q = t.getBoundingClientRect();
          s = b, _ = y, f = q.top + parseInt(E, 10), h = q.left + parseInt(j, 10), d = parseInt(E, 10) + parseInt(A, 10), m = parseInt(j, 10) + parseInt(x, 10), u = parseInt(C, 10), c = parseInt(D, 10), F = parseInt(B, 10), p = parseInt(S, 10), l = k, g = v;
        }
        var O = r.top + l - f,
          T = r.left + g - h,
          N = g,
          I = l;
        T < g ? N = T - F : T + r.width + m > g + s && (N = T + m + p - s), O < l ? I = O - u : O + r.height + d > l + _ && (I = O + d + c + r.height - _), a ? i.scrollTo(N, I) : (t.scrollTop = I, t.scrollLeft = N);
      }
    }
    function removeAllRanges(e) {
      var i = window.document;
      if (i && i.body.createTextRange) {
        var t = i.body.createTextRange();
        t.collapse(), t.select();
      } else e.removeAllRanges();
    }
    var Vt = /Permission denied to access property "nodeType"/,
      Jt = l()("slate:content"),
      $t = function (e) {
        function Content() {
          var e, i, t;
          ut(this, Content);
          for (var a = arguments.length, n = Array(a), r = 0; r < a; r++) {
            n[r] = arguments[r];
          }
          return i = t = yt(this, (e = Content.__proto__ || Object.getPrototypeOf(Content)).call.apply(e, [this].concat(n))), t.tmp = {
            isUpdatingSelection: !1
          }, t.handlers = mt.reduce(function (e, i) {
            return e[i] = function (e) {
              return t.onEvent(i, e);
            }, e;
          }, {}), t.updateSelection = function () {
            var e = t.props.editor.value.selection,
              i = e.isBackward,
              a = _i()(t.element),
              n = a.getSelection();
            if (n) {
              var o = n.rangeCount,
                r = n.anchorNode;
              if (o || !e.isBlurred) {
                if (e.isBlurred) {
                  if (!t.isInEditor(r)) return;
                  return removeAllRanges(n), t.element.blur(), void Jt("updateSelection", {
                    selection: e,
                    native: n
                  });
                }
                if (!e.isUnset) {
                  var s = !!o && n.getRangeAt(0),
                    _ = findDOMRange(e, a);
                  if (_) {
                    var l = _.startContainer,
                      g = _.startOffset,
                      f = _.endContainer,
                      h = _.endOffset;
                    s && (l == s.startContainer && g == s.startOffset && f == s.endContainer && h == s.endOffset || l == s.endContainer && g == s.endOffset && f == s.startContainer && h == s.startOffset) || (t.tmp.isUpdatingSelection = !0, removeAllRanges(n), n.setBaseAndExtent ? i ? n.setBaseAndExtent(_.endContainer, _.endOffset, _.startContainer, _.startOffset) : n.setBaseAndExtent(_.startContainer, _.startOffset, _.endContainer, _.endOffset) : n.addRange(_), scrollToSelection(n), setTimeout(function () {
                      zi && t.element && t.element.focus(), t.tmp.isUpdatingSelection = !1;
                    }), Jt("updateSelection", {
                      selection: e,
                      native: n
                    }));
                  } else u(!1, "Unable to find a native DOM range from the current selection.");
                }
              }
            }
          }, t.ref = function (e) {
            t.element = e;
          }, t.isInEditor = function (e) {
            var i = t.element,
              a = void 0;
            try {
              if (8 === e.nodeType) return !1;
              a = 3 === e.nodeType ? e.parentNode : e;
            } catch (sr) {
              if (zi && Vt.test(sr.message)) return !1;
              throw sr;
            }
            return (a.isContentEditable || a.closest("[data-slate-void]")) && (a === i || a.closest("[data-slate-editor]") === i);
          }, t.onNativeSelectionChange = Zi()(function (e) {
            t.props.readOnly || _i()(e.target).document.activeElement === t.element && t.props.onSelect(e);
          }, 100), t.renderNode = function (e, i, a) {
            var n = t.props,
              r = n.editor,
              s = n.readOnly,
              _ = r.value,
              l = _.document,
              g = _.selection.isFocused;
            return o.a.createElement(It, {
              block: null,
              editor: r,
              decorations: a,
              isSelected: i,
              isFocused: g && i,
              key: e.key,
              node: e,
              parent: l,
              readOnly: s
            });
          }, yt(t, i);
        }
        return bt(Content, e), ct(Content, [{
          key: "componentDidMount",
          value: function componentDidMount() {
            _i()(this.element).document.addEventListener("selectionchange", this.onNativeSelectionChange), $i && this.element.addEventListener("beforeinput", this.handlers.onBeforeInput), this.updateSelection();
          }
        }, {
          key: "componentWillUnmount",
          value: function componentWillUnmount() {
            var e = _i()(this.element);
            e && e.document.removeEventListener("selectionchange", this.onNativeSelectionChange), $i && this.element.removeEventListener("beforeinput", this.handlers.onBeforeInput);
          }
        }, {
          key: "componentDidUpdate",
          value: function componentDidUpdate() {
            this.updateSelection();
          }
        }, {
          key: "onEvent",
          value: function onEvent(e, i) {
            if (Jt("onEvent", e), !this.tmp.isUpdatingSelection || "onSelect" != e && "onBlur" != e && "onFocus" != e) {
              if ("onSelect" == e) {
                var t = this.props.editor.value,
                  a = t.selection,
                  n = findRange(_i()(i.target).getSelection(), t);
                if (n && n.equals(a.toRange())) return void this.updateSelection();
              }
              if ("onDragEnd" == e || "onDragEnter" == e || "onDragExit" == e || "onDragLeave" == e || "onDragOver" == e || "onDragStart" == e || "onDrop" == e) if (i.target.closest("[data-slate-editor]") !== this.element) return;
              ("onBeforeInput" != e && "onBlur" != e && "onCompositionEnd" != e && "onCompositionStart" != e && "onCopy" != e && "onCut" != e && "onFocus" != e && "onInput" != e && "onKeyDown" != e && "onKeyUp" != e && "onPaste" != e && "onSelect" != e || this.isInEditor(i.target)) && this.props[e](i);
            }
          }
        }, {
          key: "render",
          value: function render() {
            var e = this,
              i = this.props,
              t = this.handlers,
              a = i.className,
              n = i.readOnly,
              r = i.editor,
              s = i.tabIndex,
              _ = i.role,
              l = i.tagName,
              g = i.spellCheck,
              f = r.value,
              h = r.stack,
              d = l,
              m = f.document,
              u = f.selection,
              c = f.decorations,
              F = m.getSelectionIndexes(u),
              p = m.getDecorations(h).concat(c),
              b = getChildrenDecorations(m, p),
              y = m.nodes.toArray().map(function (i, t) {
                var a = !!F && F.start <= t && t < F.end;
                return e.renderNode(i, a, b[t]);
              }),
              k = pt({
                outline: "none",
                whiteSpace: "pre-wrap",
                wordWrap: "break-word"
              }, n ? {} : {
                WebkitUserModify: "read-write-plaintext-only"
              }, i.style);
            return Jt("render", {
              props: i
            }), o.a.createElement(d, pt({}, t, {
              "data-slate-editor": !0,
              ref: this.ref,
              "data-key": m.key,
              contentEditable: !n || null,
              suppressContentEditableWarning: !0,
              className: a,
              autoCorrect: i.autoCorrect ? "on" : "off",
              spellCheck: g,
              style: k,
              role: n ? null : _ || "textbox",
              tabIndex: s,
              "data-gramm": !1
            }), y);
          }
        }]), Content;
      }(o.a.Component);
    $t.propTypes = {
      autoCorrect: f.a.bool.isRequired,
      className: f.a.string,
      editor: f.a.object.isRequired,
      readOnly: f.a.bool.isRequired,
      role: f.a.string,
      spellCheck: f.a.bool.isRequired,
      style: f.a.object,
      tabIndex: f.a.number,
      tagName: f.a.string
    }, $t.defaultProps = {
      style: {},
      tagName: "div"
    }, mt.forEach(function (e) {
      $t.propTypes[e] = f.a.func.isRequired;
    });
    var Gt = {
        FRAGMENT: "application/x-slate-fragment",
        HTML: "text/html",
        NODE: "application/x-slate-node",
        RICH: "text/rtf",
        TEXT: "text/plain"
      },
      Yt = Gt.FRAGMENT,
      Xt = Gt.HTML,
      Zt = Gt.TEXT;
    function cloneFragment(e, i) {
      var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : i.fragment,
        a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : function () {},
        n = _i()(e.target),
        o = n.getSelection(),
        r = i.schema,
        s = i.selection,
        _ = s.start,
        l = s.end,
        g = i.document.getClosestVoid(_.key, r),
        f = i.document.getClosestVoid(l.key, r);
      if (!o.isCollapsed || g) {
        var h = et.serializeNode(t),
          d = o.getRangeAt(0),
          m = d.cloneContents(),
          u = m.childNodes[0];
        if (m.childNodes.forEach(function (e) {
          e.textContent && "" !== e.textContent.trim() && (u = e);
        }), f) {
          var c = d.cloneRange(),
            F = findDOMNode$1(f, n);
          c.setEndAfter(F), m = c.cloneContents();
        }
        if (g && (u = m.childNodes[0].childNodes[1].firstChild), [].slice.call(m.querySelectorAll(Rt)).forEach(function (e) {
          var i = "n" === e.getAttribute(Mt);
          e.textContent = i ? "\n" : "";
        }), 3 == u.nodeType) {
          var p = n.document.createElement("span");
          p.style.whiteSpace = "pre", p.appendChild(u), m.appendChild(p), u = p;
        }
        u.setAttribute("data-slate-fragment", h);
        var b = ze.create({
            document: t
          }),
          y = tt.serialize(b),
          k = n.document.createElement("div");
        k.appendChild(m), e.clipboardData && e.clipboardData.setData && !Wi && (e.preventDefault(), e.clipboardData.setData(Zt, y), e.clipboardData.setData(Yt, h), e.clipboardData.setData(Xt, k.innerHTML), a());
        var v = e.target.closest("[data-slate-editor]");
        k.setAttribute("contenteditable", !0), k.style.position = "absolute", k.style.left = "-9999px", v.appendChild(k), o.selectAllChildren(k), n.requestAnimationFrame(function () {
          v.removeChild(k), removeAllRanges(o), o.addRange(d), a();
        });
      }
    }
    function findNode(e, i) {
      var t = e.closest("[data-key]");
      if (!t) return null;
      var a = t.getAttribute("data-key");
      return a && i.document.getNode(a) || null;
    }
    function getEventRange(e, i) {
      e.nativeEvent && (e = e.nativeEvent);
      var t = e,
        a = t.x,
        n = t.y,
        o = t.target;
      if (null == a || null == n) return null;
      var r = i.document,
        s = i.schema,
        _ = findNode(o, i);
      if (!_) return null;
      if (s.isVoid(_)) {
        var l = o.getBoundingClientRect(),
          g = "inline" == _.object ? a - l.left < l.left + l.width - a : n - l.top < l.top + l.height - n,
          f = _.getFirstText(),
          h = r.createRange();
        if (g) {
          var d = r.getPreviousText(f.key);
          if (d) return h.moveToEndOfNode(d);
        }
        var m = r.getNextText(f.key);
        return m ? h.moveToStartOfNode(m) : null;
      }
      var u = _i()(o),
        c = void 0;
      if (u.document.caretRangeFromPoint) c = u.document.caretRangeFromPoint(a, n);else if (u.document.caretPositionFromPoint) {
        var F = u.document.caretPositionFromPoint(a, n);
        (c = u.document.createRange()).setStart(F.offsetNode, F.offset), c.setEnd(F.offsetNode, F.offset);
      } else if (u.document.body.createTextRange) {
        c = u.document.body.createTextRange();
        try {
          c.moveToPoint(a, n);
        } catch (b) {
          return null;
        }
      }
      var p = findRange(c, i);
      return p || null;
    }
    var Qt = Gt.FRAGMENT,
      ea = Gt.HTML,
      ia = Gt.NODE,
      ta = Gt.RICH,
      aa = Gt.TEXT,
      na = / data-slate-fragment="([^\s"]+)"/;
    function getEventTransfer(e) {
      !Wi && e.nativeEvent && (e = e.nativeEvent);
      var i = e.dataTransfer || e.clipboardData,
        t = getType(i, Qt),
        a = getType(i, ia),
        n = getType(i, ea),
        o = getType(i, ta),
        r = getType(i, aa),
        s = void 0;
      if (!t && n && ~n.indexOf(' data-slate-fragment="')) {
        var _ = na.exec(n),
          l = kt(_, 2),
          g = (l[0], l[1]);
        g && (t = g);
      }
      if (r) {
        var f = function getEmbeddedTypes(e) {
          var i = "SLATE-DATA-EMBED::";
          if (e.substring(0, i.length) != i) return {
            TEXT: e
          };
          try {
            return JSON.parse(e.substring(i.length));
          } catch (sr) {
            throw new Error("Unable to parse custom Slate drag event data.");
          }
        }(r);
        f[Qt] && (t = f[Qt]), f[ia] && (a = f[ia]), f[aa] && (r = f[aa]);
      }
      t && (t = et.deserializeNode(t)), a && (a = et.deserializeNode(a));
      try {
        i.items && i.items.length ? s = Array.from(i.items).map(function (e) {
          return "file" == e.kind ? e.getAsFile() : null;
        }).filter(function (e) {
          return e;
        }) : i.files && i.files.length && (s = Array.from(i.files));
      } catch (sr) {
        i.files && i.files.length && (s = Array.from(i.files));
      }
      var h = {
        files: s,
        fragment: t,
        html: n,
        node: a,
        rich: o,
        text: r
      };
      return h.type = function getTransferType(e) {
        return e.fragment ? "fragment" : e.node ? "node" : e.rich && e.html ? "html" : e.rich && e.text ? "text" : e.files && e.files.length ? "files" : e.html ? "html" : e.text ? "text" : "unknown";
      }(h), h;
    }
    function getType(e, i) {
      return e.types && e.types.length ? -1 !== Array.from(e.types).indexOf(i) && e.getData(i) || null : i == aa && e.getData("Text") || null;
    }
    var oa = Gt.TEXT;
    function setEventTransfer(e, i, t) {
      var a = Gt[i.toUpperCase()];
      if (!a) throw new Error('Cannot set unknown transfer type "' + a + '".');
      e.nativeEvent && (e = e.nativeEvent);
      var n = e.dataTransfer || e.clipboardData;
      try {
        n.setData(a, t), n.setData("text", n.getData("text"));
      } catch (sr) {
        var o = "SLATE-DATA-EMBED::",
          r = n.getData(oa),
          s = {};
        if (r.substring(0, o.length) === o) try {
          s = JSON.parse(r.substring(o.length));
        } catch (l) {
          throw new Error("Failed to parse Slate data from `DataTransfer` object.");
        } else s[oa] = r;
        s[a] = t;
        var _ = "" + o + JSON.stringify(s);
        n.setData(oa, _);
      }
    }
    var ra = l()("slate:after");
    function AfterPlugin() {
      var e = null;
      return {
        onBeforeInput: function onBeforeInput(e, i, t) {
          if (ra("onBeforeInput", {
            event: e
          }), e.nativeEvent) return e.preventDefault(), void i.insertText(e.data);
          var a = e.getTargetRanges(),
            n = kt(a, 1)[0];
          if (n) {
            e.preventDefault();
            var o = i.value,
              r = o.document,
              s = o.selection,
              _ = o.schema,
              l = findRange(n, o);
            switch (e.inputType) {
              case "deleteByDrag":
              case "deleteByCut":
              case "deleteContent":
              case "deleteContentBackward":
              case "deleteContentForward":
                return void i.deleteAtRange(l);
              case "deleteWordBackward":
                return void i.deleteWordBackwardAtRange(l);
              case "deleteWordForward":
                return void i.deleteWordForwardAtRange(l);
              case "deleteSoftLineBackward":
              case "deleteHardLineBackward":
                return void i.deleteLineBackwardAtRange(l);
              case "deleteSoftLineForward":
              case "deleteHardLineForward":
                return void i.deleteLineForwardAtRange(l);
              case "insertLineBreak":
              case "insertParagraph":
                return void (r.hasVoidParent(s.start.path, _) ? i.moveToStartOfNextText() : i.splitBlockAtRange(l));
              case "insertFromYank":
              case "insertReplacementText":
              case "insertText":
                var g = null == e.data ? e.dataTransfer.getData("text/plain") : e.data;
                if (null == g) return;
                return i.insertTextAtRange(l, g, s.marks), void (s.marks && o.document != i.value.document && i.select({
                  marks: null
                }));
            }
          }
        },
        onBlur: function onBlur(e, i, t) {
          ra("onBlur", {
            event: e
          }), i.blur();
        },
        onClick: function onClick(e, i, t) {
          if (t.props.readOnly) return !0;
          var a = i.value,
            n = a.document,
            o = a.schema,
            r = findNode(e.target, a);
          if (r) {
            var s = n.getAncestors(r.key);
            r && (o.isVoid(r) || s.some(function (e) {
              return o.isVoid(e);
            })) && i.focus().moveToEndOfNode(r), ra("onClick", {
              event: e
            });
          }
        },
        onCopy: function onCopy(e, i, t) {
          ra("onCopy", {
            event: e
          }), cloneFragment(e, i.value);
        },
        onCut: function onCut(e, i, t) {
          ra("onCut", {
            event: e
          }), cloneFragment(e, i.value, i.value.fragment, function () {
            var e = i.value,
              a = e.endBlock,
              n = e.endInline,
              o = e.selection,
              r = e.schema,
              s = o.isCollapsed,
              _ = a && r.isVoid(a) && s,
              l = n && r.isVoid(n) && s;
            _ ? t.change(function (e) {
              return e.removeNodeByKey(a.key);
            }) : l ? t.change(function (e) {
              return e.removeNodeByKey(n.key);
            }) : t.change(function (e) {
              return e.delete();
            });
          });
        },
        onDragEnd: function onDragEnd(i, t, a) {
          ra("onDragEnd", {
            event: i
          }), e = null;
        },
        onDragOver: function onDragOver(e, i, t) {
          ra("onDragOver", {
            event: e
          });
        },
        onDragStart: function onDragStart(i, t, a) {
          ra("onDragStart", {
            event: i
          }), e = !0;
          var n = t.value,
            o = n.document,
            r = n.schema,
            s = findNode(i.target, n),
            _ = o.getAncestors(s.key),
            l = s && (r.isVoid(s) || _.some(function (e) {
              return r.isVoid(e);
            })),
            g = n.blocks.some(function (e) {
              return e.key === s.key;
            });
          l && !g && t.moveToRangeOfNode(s);
          var f = t.value.fragment;
          setEventTransfer(i, "fragment", et.serializeNode(f));
        },
        onDrop: function onDrop(i, t, a) {
          ra("onDrop", {
            event: i
          });
          var n = t.value,
            o = n.document,
            r = n.selection,
            s = n.schema,
            _ = _i()(i.target),
            l = getEventRange(i, n);
          if (l) {
            var g = getEventTransfer(i),
              f = g.type,
              h = g.fragment,
              d = g.text;
            if (t.focus(), e && r.end.key == l.end.key && r.end.offset < l.end.offset && (l = l.moveForward(r.start.key == r.end.key ? 0 - r.end.offset + r.start.offset : 0 - r.end.offset)), e && t.delete(), t.select(l), "text" == f || "html" == f) {
              var m = l.anchor,
                u = o.hasVoidParent(m.key, s);
              if (u) {
                for (var c = o.getNode(m.key); u && (c = o.getNextText(c.key));) {
                  u = o.hasVoidParent(c.key, s);
                }
                c && t.moveToStartOfNode(c);
              }
              d && d.split("\n").forEach(function (e, i) {
                i > 0 && t.splitBlock(), t.insertText(e);
              });
            }
            "fragment" == f && t.insertFragment(h);
            var F = findDOMNode$1(o.getNode(l.focus.key), _);
            F && F.dispatchEvent(new MouseEvent("mouseup", {
              view: _,
              bubbles: !0,
              cancelable: !0
            }));
          }
        },
        onInput: function onInput(e, i, t) {
          ra("onInput", {
            event: e
          });
          var a = _i()(e.target),
            n = i.value,
            o = a.getSelection().anchorNode,
            r = findPoint(o, 0, n);
          if (r) {
            var s = n.document,
              _ = n.selection,
              l = s.getDescendant(r.key),
              g = s.getClosestBlock(l.key),
              f = l.getLeaves(),
              h = g.getLastText(),
              d = f.last(),
              m = 0,
              u = 0,
              c = f.find(function (e) {
                if (m = u, (u += e.text.length) > r.offset) return !0;
              }) || d,
              F = c.text,
              p = o.textContent,
              b = l == h,
              y = c == d,
              k = p.charAt(p.length - 1);
            if (b && y && "\n" == k && (p = p.slice(0, -1)), p != F) {
              var v = p.length - F.length,
                w = _.moveToEnd().moveForward(v),
                E = _.moveAnchorTo(r.key, m).moveFocusTo(r.key, u);
              E = s.resolveRange(E), i.insertTextAtRange(E, p, c.marks).select(w);
            }
          }
        },
        onKeyDown: function onKeyDown(e, i, t) {
          ra("onKeyDown", {
            event: e
          });
          var a = i.value,
            n = a.document,
            o = a.selection,
            r = a.schema,
            s = n.hasVoidParent(o.start.path, r);
          if (gt.isSplitBlock(e) && !Hi) return s ? i.moveToStartOfNextText() : i.splitBlock();
          if (gt.isDeleteBackward(e) && !Hi) return i.deleteCharBackward();
          if (gt.isDeleteForward(e) && !Hi) return i.deleteCharForward();
          if (gt.isDeleteLineBackward(e)) return i.deleteLineBackward();
          if (gt.isDeleteLineForward(e)) return i.deleteLineForward();
          if (gt.isDeleteWordBackward(e)) return i.deleteWordBackward();
          if (gt.isDeleteWordForward(e)) return i.deleteWordForward();
          if (gt.isRedo(e)) return i.redo();
          if (gt.isUndo(e)) return i.undo();
          if (gt.isMoveLineBackward(e)) return e.preventDefault(), i.moveToStartOfBlock();
          if (gt.isMoveLineForward(e)) return e.preventDefault(), i.moveToEndOfBlock();
          if (gt.isExtendLineBackward(e)) return e.preventDefault(), i.moveFocusToStartOfBlock();
          if (gt.isExtendLineForward(e)) return e.preventDefault(), i.moveFocusToEndOfBlock();
          if (gt.isMoveBackward(e)) {
            var _ = a.previousText,
              l = a.startText,
              g = _ && n.hasVoidParent(_.key, r);
            if (s || g || "" == l.text) return e.preventDefault(), i.moveBackward();
          }
          if (gt.isMoveForward(e)) {
            var f = a.nextText,
              h = a.startText,
              d = f && n.hasVoidParent(f.key, r);
            if (s || d || "" == h.text) return e.preventDefault(), i.moveForward();
          }
          if (gt.isExtendBackward(e)) {
            var m = a.previousText,
              u = a.startText,
              c = m && n.hasVoidParent(m.key, r);
            if (s || c || "" == u.text) return e.preventDefault(), i.moveFocusBackward();
          }
          if (gt.isExtendForward(e)) {
            var F = a.nextText,
              p = a.startText,
              b = F && n.hasVoidParent(F.key, r);
            if (s || b || "" == p.text) return e.preventDefault(), i.moveFocusForward();
          }
        },
        onPaste: function onPaste(e, i, t) {
          ra("onPaste", {
            event: e
          });
          var a = getEventTransfer(e),
            n = a.type,
            o = a.fragment,
            r = a.text;
          if ("fragment" == n && i.insertFragment(o), "text" == n || "html" == n) {
            if (!r) return;
            var s = i.value,
              _ = s.document,
              l = s.selection,
              g = s.startBlock;
            if (s.schema.isVoid(g)) return;
            var f = g,
              h = _.getInsertMarksAtRange(l),
              d = tt.deserialize(r, {
                defaultBlock: f,
                defaultMarks: h
              }).document;
            i.insertFragment(d);
          }
        },
        onSelect: function onSelect(e, i, t) {
          ra("onSelect", {
            event: e
          });
          var a = _i()(e.target),
            n = i.value,
            o = n.document,
            r = n.schema,
            s = a.getSelection();
          if (s.rangeCount) {
            var _ = findRange(s, n);
            if (_) {
              var l = _,
                g = l.anchor,
                f = l.focus,
                h = o.getNode(g.key),
                d = o.getNode(f.key),
                m = o.getClosestInline(g.key),
                u = o.getClosestInline(f.key),
                c = o.getClosestBlock(f.key),
                F = o.getClosestBlock(g.key);
              if (F && !r.isVoid(F) && 0 == g.offset && c && r.isVoid(c) && 0 != f.offset && (_ = _.setFocus(f.setOffset(0))), m && !r.isVoid(m) && g.offset == h.text.length) {
                var p = o.getClosestBlock(g.key).getNextText(g.key);
                p && (_ = _.moveAnchorTo(p.key, 0));
              }
              if (u && !r.isVoid(u) && f.offset == d.text.length) {
                var b = o.getClosestBlock(f.key).getNextText(f.key);
                b && (_ = _.moveFocusTo(b.key, 0));
              }
              var y = o.createSelection(_);
              y = (y = y.setIsFocused(!0)).set("marks", n.selection.marks), i.select(y);
            }
          } else i.blur();
        },
        renderEditor: function renderEditor(e, i) {
          var t = i.handlers;
          return o.a.createElement($t, pt({}, t, {
            autoCorrect: e.autoCorrect,
            className: e.className,
            editor: i,
            readOnly: e.readOnly,
            role: e.role,
            spellCheck: e.spellCheck,
            style: e.style,
            tabIndex: e.tabIndex,
            tagName: e.tagName
          }));
        },
        renderNode: function renderNode(e) {
          var i = e.attributes,
            t = e.children,
            a = e.node;
          if ("block" == a.object || "inline" == a.object) {
            var n = "block" == a.object ? "div" : "span";
            return o.a.createElement(n, pt({}, i, {
              style: {
                position: "relative"
              }
            }), t);
          }
        },
        renderPlaceholder: function renderPlaceholder(e) {
          var i = e.editor,
            t = e.node;
          if (i.props.placeholder && !i.state.isComposing && "block" == t.object && Z.isTextList(t.nodes) && "" == t.text && !(i.value.document.getBlocks().size > 1)) return o.a.createElement("span", {
            contentEditable: !1,
            style: {
              pointerEvents: "none",
              display: "inline-block",
              width: "0",
              maxWidth: "100%",
              whiteSpace: "nowrap",
              opacity: "0.333"
            }
          }, i.props.placeholder);
        }
      };
    }
    var sa = l()("slate:before");
    function BeforePlugin() {
      var e = null,
        i = 0,
        t = !1,
        a = !1,
        n = !1;
      return {
        onBeforeInput: function onBeforeInput(e, i, t) {
          return !!t.props.readOnly || !(!e.nativeEvent || !$i) || void sa("onBeforeInput", {
            event: e
          });
        },
        onBlur: function onBlur(i, t, n) {
          if (a) return !0;
          if (n.props.readOnly) return !0;
          var o = t.value,
            r = o.schema,
            s = i.relatedTarget,
            _ = i.target,
            l = _i()(_);
          if (e == l.document.activeElement) return !0;
          if (s) {
            var g = Object(ft.findDOMNode)(n);
            if (s == g) return !0;
            if (s.hasAttribute("data-slate-spacer")) return !0;
            var f = findNode(s, o);
            if (g.contains(s) && f && !r.isVoid(f)) return !0;
          }
          sa("onBlur", {
            event: i
          });
        },
        onChange: function onChange(e, i) {
          e.value.schema != i.schema && e.withoutSaving(function () {
            e.setValue({
              schema: i.schema
            }).normalize();
          }), sa("onChange");
        },
        onCompositionEnd: function onCompositionEnd(e, a, n) {
          var o = i;
          window.requestAnimationFrame(function () {
            i > o || (t = !1, n.state.isComposing && n.setState({
              isComposing: !1
            }));
          }), sa("onCompositionEnd", {
            event: e
          });
        },
        onCompositionStart: function onCompositionStart(e, a, n) {
          t = !0, i++, n.state.isComposing || n.setState({
            isComposing: !0
          }), sa("onCompositionStart", {
            event: e
          });
        },
        onCopy: function onCopy(e, i, t) {
          var n = _i()(e.target);
          a = !0, n.requestAnimationFrame(function () {
            return a = !1;
          }), sa("onCopy", {
            event: e
          });
        },
        onCut: function onCut(e, i, t) {
          if (t.props.readOnly) return !0;
          var n = _i()(e.target);
          a = !0, n.requestAnimationFrame(function () {
            return a = !1;
          }), sa("onCut", {
            event: e
          });
        },
        onDragEnd: function onDragEnd(e, i, t) {
          n = !1, sa("onDragEnd", {
            event: e
          });
        },
        onDragEnter: function onDragEnter(e, i, t) {
          sa("onDragEnter", {
            event: e
          });
        },
        onDragExit: function onDragExit(e, i, t) {
          sa("onDragExit", {
            event: e
          });
        },
        onDragLeave: function onDragLeave(e, i, t) {
          sa("onDragLeave", {
            event: e
          });
        },
        onDragOver: function onDragOver(e, i, t) {
          var a = t.value.schema,
            o = findNode(e.target, t.value);
          a.isVoid(o) && e.preventDefault(), Wi && e.preventDefault(), n || (n = !0, Wi || (e.nativeEvent.dataTransfer.dropEffect = "move")), sa("onDragOver", {
            event: e
          });
        },
        onDragStart: function onDragStart(e, i, t) {
          n = !0, sa("onDragStart", {
            event: e
          });
        },
        onDrop: function onDrop(e, i, t) {
          if (t.props.readOnly) return !0;
          e.preventDefault(), sa("onDrop", {
            event: e
          });
        },
        onFocus: function onFocus(i, t, n) {
          if (a) return !0;
          if (n.props.readOnly) return !0;
          var o = Object(ft.findDOMNode)(n),
            r = _i()(i.target);
          if (e = r.document.activeElement, zi && i.target != o) return o.focus(), !0;
          sa("onFocus", {
            event: i
          });
        },
        onInput: function onInput(e, i, a) {
          return !!t || !!i.value.selection.isBlurred || void sa("onInput", {
            event: e
          });
        },
        onKeyDown: function onKeyDown(e, i, a) {
          return !!a.props.readOnly || (t ? (gt.isCompose(e) && e.preventDefault(), !0) : (!Hi && (gt.isBold(e) || gt.isDeleteBackward(e) || gt.isDeleteForward(e) || gt.isDeleteLineBackward(e) || gt.isDeleteLineForward(e) || gt.isDeleteWordBackward(e) || gt.isDeleteWordForward(e) || gt.isItalic(e) || gt.isRedo(e) || gt.isSplitBlock(e) || gt.isTransposeCharacter(e) || gt.isUndo(e)) && e.preventDefault(), void sa("onKeyDown", {
            event: e
          })));
        },
        onPaste: function onPaste(e, i, t) {
          if (t.props.readOnly) return !0;
          e.preventDefault(), sa("onPaste", {
            event: e
          });
        },
        onSelect: function onSelect(i, n, o) {
          if (a) return !0;
          if (t) return !0;
          if (o.props.readOnly) return !0;
          var r = _i()(i.target);
          e = r.document.activeElement, sa("onSelect", {
            event: i
          });
        }
      };
    }
    var _a = l()("slate:editor"),
      la = function (e) {
        function Editor() {
          var e, i, t;
          ut(this, Editor);
          for (var a = arguments.length, n = Array(a), o = 0; o < a; o++) {
            n[o] = arguments[o];
          }
          return i = t = yt(this, (e = Editor.__proto__ || Object.getPrototypeOf(Editor)).call.apply(e, [this].concat(n))), ga.call(t), yt(t, i);
        }
        return bt(Editor, e), ct(Editor, [{
          key: "componentDidMount",
          value: function componentDidMount() {
            this.tmp.updates++;
            var e = this.props.autoFocus,
              i = this.tmp.change;
            e && (i ? i.focus() : this.focus()), i && this.onChange(i);
          }
        }, {
          key: "componentDidUpdate",
          value: function componentDidUpdate(e) {
            this.tmp.updates++;
            var i = this.tmp,
              t = i.change,
              a = i.resolves,
              n = i.updates;
            u(a < 5 || a !== n, "A Slate <Editor> component is re-resolving `props.plugins` or `props.schema` on each update, which leads to poor performance. This is often due to passing in a new `schema` or `plugins` prop with each render by declaring them inline in your render function. Do not do this!"), t && this.onChange(t);
          }
        }, {
          key: "render",
          value: function render() {
            _a("render", this);
            var e = pt({}, this.props);
            return this.stack.render("renderEditor", e, this);
          }
        }, {
          key: "plugins",
          get: function get$$1() {
            return this.resolvePlugins(this.props.plugins, this.props.schema);
          }
        }, {
          key: "schema",
          get: function get$$1() {
            return this.resolveSchema(this.plugins);
          }
        }, {
          key: "stack",
          get: function get$$1() {
            return this.resolveStack(this.plugins);
          }
        }, {
          key: "value",
          get: function get$$1() {
            return this.plugins === this.tmp.plugins && this.props.value === this.tmp.value ? this.tmp.value : this.resolveValue(this.plugins, this.props.value);
          }
        }]), Editor;
      }(o.a.Component);
    la.propTypes = {
      autoCorrect: f.a.bool,
      autoFocus: f.a.bool,
      className: f.a.string,
      onChange: f.a.func,
      placeholder: f.a.any,
      plugins: f.a.array,
      readOnly: f.a.bool,
      role: f.a.string,
      schema: f.a.object,
      spellCheck: f.a.bool,
      style: f.a.object,
      tabIndex: f.a.number,
      value: ni.value.isRequired
    }, la.defaultProps = {
      autoFocus: !1,
      autoCorrect: !0,
      onChange: function noop() {},
      plugins: [],
      readOnly: !1,
      schema: {},
      spellCheck: !0
    };
    var ga = function _initialiseProps() {
        var e = this;
        this.state = {}, this.tmp = {
          change: null,
          isChanging: !1,
          operationsSize: null,
          plugins: null,
          resolves: 0,
          updates: 0,
          value: null
        }, this.handlers = mt.reduce(function (i, t) {
          return i[t] = function (i) {
            return e.onEvent(t, i);
          }, i;
        }, {}), this.change = function () {
          if (e.tmp.isChanging) u(!1, "The `editor.change` method was called from within an existing `editor.change` callback. This is not allowed, and often due to calling `editor.change` directly from a plugin's event handler which is unnecessary.");else {
            var i = e.value.change();
            try {
              e.tmp.isChanging = !0, i.call.apply(i, arguments);
            } catch (t) {
              throw t;
            } finally {
              e.tmp.isChanging = !1;
            }
            e.onChange(i);
          }
        }, this.blur = function () {
          e.change(function (e) {
            return e.blur();
          });
        }, this.focus = function () {
          e.change(function (e) {
            return e.focus();
          });
        }, this.onChange = function (i) {
          0 !== i.operations.size && (_a("onChange", {
            change: i
          }), i = e.resolveChange(e.plugins, i, i.operations.size), e.tmp.value = i.value, e.tmp.plugins = e.plugins, delete e.tmp.change, delete e.tmp.operationsSize, e.props.onChange(i));
        }, this.onEvent = function (i, t) {
          e.change(function (a) {
            e.stack.run(i, t, a, e);
          });
        }, this.resolveChange = dt(function (i, t, a) {
          return e.resolveStack(i).run("onChange", t, e), t;
        }), this.resolvePlugins = dt(function () {
          var i = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
            t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          _a("resolvePlugins", {
            plugins: i,
            schema: t
          }), e.tmp.resolves++;
          var a = BeforePlugin(),
            n = AfterPlugin(),
            o = {
              schema: t
            },
            r = function _loop(i) {
              return "onChange" == i ? "continue" : "schema" == i ? "continue" : void (o[i] = function () {
                var t;
                return e.props[i] && (t = e.props)[i].apply(t, arguments);
              });
            },
            s = !0,
            _ = !1,
            l = void 0;
          try {
            for (var g, f = wt[Symbol.iterator](); !(s = (g = f.next()).done); s = !0) {
              r(g.value);
            }
          } catch (sr) {
            _ = !0, l = sr;
          } finally {
            try {
              !s && f.return && f.return();
            } finally {
              if (_) throw l;
            }
          }
          return [a, o].concat(vt(i), [n]);
        }), this.resolveSchema = dt(function (e) {
          return _a("resolveSchema", {
            plugins: e
          }), Me.create({
            plugins: e
          });
        }), this.resolveStack = dt(function (e) {
          return _a("resolveStack", {
            plugins: e
          }), Oe.create({
            plugins: e
          });
        }), this.resolveValue = dt(function (i, t) {
          _a("resolveValue", {
            plugins: i,
            value: t
          });
          var a = t.change();
          return a = e.resolveChange(i, a, a.operations.size), e.tmp.change = a, e.tmp.operationsSize = a.operations.size, a.value;
        });
      },
      fa = !0,
      ha = !1,
      da = void 0;
    try {
      for (var ma, ua = mt[Symbol.iterator](); !(fa = (ma = ua.next()).done); fa = !0) {
        var ca = ma.value;
        la.propTypes[ca] = f.a.func;
      }
    } catch (sr) {
      ha = !0, da = sr;
    } finally {
      try {
        !fa && ua.return && ua.return();
      } finally {
        if (ha) throw da;
      }
    }
    var Fa = t(6),
      pa = t(3),
      ba = t(25),
      ya = t(121),
      ka = t(48),
      va = t.n(ka),
      wa = Object.assign || function (e) {
        for (var i = 1; i < arguments.length; i++) {
          var t = arguments[i];
          for (var a in t) {
            Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
          }
        }
        return e;
      },
      Ea = new m.Record({
        object: "string",
        text: ""
      }),
      Aa = {
        deserialize: function deserialize(e) {
          if (e.tagName && "br" === e.tagName.toLowerCase()) return {
            object: "text",
            leaves: [{
              object: "leaf",
              text: "\n"
            }]
          };
          if ("#text" === e.nodeName) {
            if (e.nodeValue && e.nodeValue.match(/<!--.*?-->/)) return;
            return {
              object: "text",
              leaves: [{
                object: "leaf",
                text: e.nodeValue
              }]
            };
          }
        },
        serialize: function serialize(e, i) {
          if ("string" === e.object) return i.split("\n").reduce(function (e, i, t) {
            return 0 !== t && e.push(o.a.createElement("br", {
              key: t
            })), e.push(i), e;
          }, []);
        }
      };
    function defaultParseHtml(e) {
      if ("undefined" == typeof DOMParser) throw new Error("The native `DOMParser` global which the `Html` serializer uses by default is not present in this environment. You must supply the `options.parseHtml` function instead.");
      return new DOMParser().parseFromString(e, "text/html").body || window.document.createElement("body");
    }
    var ja = function _initialiseProps() {
        var e = this;
        this.deserialize = function (i) {
          var t = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}).toJSON,
            a = void 0 !== t && t,
            n = e.defaultBlock,
            o = (0, e.parseHtml)(i),
            r = Array.from(o.childNodes),
            s = e.deserializeElements(r);
          0 === (s = s.reduce(function (e, i, t, a) {
            if ("block" === i.object) return e.push(i), e;
            if (t > 0 && "block" !== a[t - 1].object) return e[e.length - 1].nodes.push(i), e;
            var o = wa({
              object: "block",
              data: {}
            }, n, {
              nodes: [i]
            });
            return e.push(o), e;
          }, [])).length && (s = [wa({
            object: "block",
            data: {}
          }, n, {
            nodes: [{
              object: "text",
              leaves: [{
                object: "leaf",
                text: "",
                marks: []
              }]
            }]
          })]);
          var _ = {
            object: "value",
            document: {
              object: "document",
              data: {},
              nodes: s
            }
          };
          return a ? _ : ze.fromJSON(_);
        }, this.deserializeElements = function () {
          var i = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
            t = [];
          return i.filter(e.cruftNewline).forEach(function (i) {
            var a = e.deserializeElement(i);
            switch (va()(a)) {
              case "array":
                t = t.concat(a);
                break;
              case "object":
                t.push(a);
            }
          }), t;
        }, this.deserializeElement = function (i) {
          var t = void 0;
          i.tagName || (i.tagName = "");
          var a = function next(i) {
              switch ("[object NodeList]" === Object.prototype.toString.call(i) && (i = Array.from(i)), va()(i)) {
                case "array":
                  return e.deserializeElements(i);
                case "object":
                  return e.deserializeElement(i);
                case "null":
                case "undefined":
                  return;
                default:
                  throw new Error('The `next` argument was called with invalid children: "' + i + '".');
              }
            },
            n = !0,
            o = !1,
            r = void 0;
          try {
            for (var s, _ = e.rules[Symbol.iterator](); !(n = (s = _.next()).done); n = !0) {
              var l = s.value;
              if (l.deserialize) {
                var g = l.deserialize(i, a),
                  f = va()(g);
                if ("array" !== f && "object" !== f && "null" !== f && "undefined" !== f) throw new Error('A rule returned an invalid deserialized representation: "' + t + '".');
                if (void 0 !== g) {
                  if (null === g) return null;
                  t = "mark" === g.object ? e.deserializeMark(g) : g;
                  break;
                }
              }
            }
          } catch (sr) {
            o = !0, r = sr;
          } finally {
            try {
              !n && _.return && _.return();
            } finally {
              if (o) throw r;
            }
          }
          return t || a(i.childNodes);
        }, this.deserializeMark = function (i) {
          var t = i.type,
            a = i.data;
          return i.nodes.reduce(function (i, n) {
            var o = function applyMark(i) {
              return "mark" === i.object ? e.deserializeMark(i) : ("text" === i.object ? i.leaves = i.leaves.map(function (e) {
                return e.marks = e.marks || [], e.marks.push({
                  type: t,
                  data: a
                }), e;
              }) : i.nodes && (i.nodes = i.nodes.map(applyMark)), i);
            }(n);
            return Array.isArray(o) ? i.concat(o) : (i.push(o), i);
          }, []);
        }, this.serialize = function (i) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            a = i.document.nodes.map(e.serializeNode).filter(function (e) {
              return e;
            });
          return !1 === t.render ? a : Object(ya.renderToStaticMarkup)(o.a.createElement("body", null, a)).slice(6, -7);
        }, this.serializeNode = function (i) {
          if ("text" === i.object) return i.getLeaves().map(e.serializeLeaf);
          var t = i.nodes.map(e.serializeNode),
            a = !0,
            n = !1,
            o = void 0;
          try {
            for (var r, s = e.rules[Symbol.iterator](); !(a = (r = s.next()).done); a = !0) {
              var _ = r.value;
              if (_.serialize) {
                var l = _.serialize(i, t);
                if (null === l) return;
                if (l) return addKey(l);
              }
            }
          } catch (sr) {
            n = !0, o = sr;
          } finally {
            try {
              !a && s.return && s.return();
            } finally {
              if (n) throw o;
            }
          }
          throw new Error('No serializer defined for node of type "' + i.type + '".');
        }, this.serializeLeaf = function (i) {
          var t = new Ea({
              text: i.text
            }),
            a = e.serializeString(t);
          return i.marks.reduce(function (i, t) {
            var a = !0,
              n = !1,
              o = void 0;
            try {
              for (var r, s = e.rules[Symbol.iterator](); !(a = (r = s.next()).done); a = !0) {
                var _ = r.value;
                if (_.serialize) {
                  var l = _.serialize(t, i);
                  if (null === l) return;
                  if (l) return addKey(l);
                }
              }
            } catch (sr) {
              n = !0, o = sr;
            } finally {
              try {
                !a && s.return && s.return();
              } finally {
                if (n) throw o;
              }
            }
            throw new Error('No serializer defined for mark of type "' + t.type + '".');
          }, a);
        }, this.serializeString = function (i) {
          var t = !0,
            a = !1,
            n = void 0;
          try {
            for (var o, r = e.rules[Symbol.iterator](); !(t = (o = r.next()).done); t = !0) {
              var s = o.value;
              if (s.serialize) {
                var _ = s.serialize(i, i.text);
                if (_) return _;
              }
            }
          } catch (sr) {
            a = !0, n = sr;
          } finally {
            try {
              !t && r.return && r.return();
            } finally {
              if (a) throw n;
            }
          }
        }, this.cruftNewline = function (e) {
          return !("#text" === e.nodeName && "\n" === e.nodeValue);
        };
      },
      xa = 0;
    function addKey(e) {
      return o.a.cloneElement(e, {
        key: xa++
      });
    }
    var Ca = function Html() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        !function classCallCheck(e, i) {
          if (!(e instanceof i)) throw new TypeError("Cannot call a class as a function");
        }(this, Html), ja.call(this);
        var i = e.defaultBlock,
          t = void 0 === i ? "paragraph" : i,
          a = e.parseHtml,
          n = void 0 === a ? defaultParseHtml : a,
          o = e.rules,
          r = void 0 === o ? [] : o;
        t = Q.createProperties(t), this.rules = [].concat(function toConsumableArray(e) {
          if (Array.isArray(e)) {
            for (var i = 0, t = Array(e.length); i < e.length; i++) {
              t[i] = e[i];
            }
            return t;
          }
          return Array.from(e);
        }(r), [Aa]), this.defaultBlock = t, this.parseHtml = n;
      },
      Da = t(18),
      Ba = t.n(Da),
      Sa = t(122);
    t(235);
    var qa = {
        CC: "CC (optional)",
        THREAD: "Type",
        FIELD: "Field (optional)"
      },
      Oa = {
        TEAMMATE: "teammate",
        LEAD_OWNER: "leadOwner",
        ROUND_ROBIN: "round_robin"
      },
      Ta = "A specific teammate",
      Na = "Lead owner",
      Ia = "Round robin using global routing rules",
      Pa = {
        SUBJECT: "Subject",
        FALLBACK: "Fallback"
      },
      Ma = function Ma(_ref) {
        var e = _ref.label,
          i = _ref.value,
          t = _ref.options,
          a = _ref.onChange,
          _ref$placeholder = _ref.placeholder,
          n = _ref$placeholder === void 0 ? "" : _ref$placeholder,
          _ref$isClearable = _ref.isClearable,
          r = _ref$isClearable === void 0 ? !1 : _ref$isClearable;
        return o.a.createElement(pa.Div, {
          className: "email-mode-header-wrapper header-select-wrapper"
        }, o.a.createElement(pa.Div, {
          className: "email-mode-header-label"
        }, e, ":"), o.a.createElement(Sa.Select, {
          size: "large",
          inline: !0,
          inlineWidth: "100%",
          className: "email-mode-header-select",
          placeholder: n,
          value: i,
          isClearable: r,
          onChange: a,
          options: t,
          isSearchable: !1,
          selectStyles: {
            indicatorSeparator: function indicatorSeparator() {}
          }
        }));
      },
      Ra = function Ra(_ref2) {
        var e = _ref2.label,
          _ref2$value = _ref2.value,
          i = _ref2$value === void 0 ? "" : _ref2$value,
          t = _ref2.onChange,
          _ref2$placeholder = _ref2.placeholder,
          a = _ref2$placeholder === void 0 ? "" : _ref2$placeholder,
          n = _ref2.disabled;
        return o.a.createElement(pa.Div, {
          className: "email-mode-header-wrapper"
        }, o.a.createElement(pa.Div, {
          className: s()("email-mode-header-label", {
            disabled: n
          })
        }, e, ":"), o.a.createElement(pa.Input, {
          className: s()("email-mode-header-input", {
            "fallback-label": e === Pa.FALLBACK
          }),
          value: i,
          onChange: t,
          placeholder: a,
          disabled: n
        }));
      },
      za = function za(_ref3) {
        var e = _ref3.label,
          i = _ref3.values,
          t = _ref3.placeholder,
          a = _ref3.onChange;
        return o.a.createElement(pa.Div, {
          className: "email-mode-header-wrapper"
        }, o.a.createElement(pa.Div, {
          className: "email-mode-header-label"
        }, e, ":"), o.a.createElement(pa.MultiStringCompact, {
          className: s()("email-mode-header-multi-string-compact", {
            "no-values": !i || 0 === i.length
          }),
          values: i,
          onChange: a,
          hideCount: !0,
          placeholder: t
        }));
      },
      La = {
        document: {
          last: {
            type: "paragraph"
          },
          normalize: function normalize(e, _ref4) {
            var i = _ref4.code,
              t = _ref4.node;
            switch (i) {
              case "last_child_type_invalid":
                {
                  var _i2 = ie.create("paragraph");
                  return e.insertNodeByKey(t.key, t.nodes.size, _i2);
                }
              default:
                return;
            }
          }
        },
        blocks: {
          image: {
            isVoid: !0
          }
        }
      },
      Wa = {
        document: {
          last: {
            type: "division"
          },
          normalize: function normalize(e, _ref5) {
            var i = _ref5.code,
              t = _ref5.node;
            switch (i) {
              case "last_child_type_invalid":
                {
                  var _i3 = ie.create("division");
                  return e.insertNodeByKey(t.key, t.nodes.size, _i3);
                }
              default:
                return;
            }
          }
        },
        blocks: {
          image: {
            isVoid: !0
          }
        }
      };
    function _defineProperty(e, i, t) {
      return i in e ? Object.defineProperty(e, i, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[i] = t, e;
    }
    function ownKeys(e, i) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);
        i && (a = a.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })), t.push.apply(t, a);
      }
      return t;
    }
    function _objectSpread2(e) {
      for (var i = 1; i < arguments.length; i++) {
        var t = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(t), !0).forEach(function (i) {
          _defineProperty(e, i, t[i]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (i) {
          Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(t, i));
        });
      }
      return e;
    }
    var Ua = {
        p: "paragraph",
        img: "image",
        div: "division",
        li: "list-item",
        ul: "bulleted-list",
        ol: "numbered-list",
        emoji: "emoji",
        a: "link"
      },
      Ka = Object(Fa.clone)(Ua);
    Ka.br = "br";
    var Ha = {
        a: "link",
        span: "text-span"
      },
      Va = {
        em: "italic",
        strong: "bold",
        u: "underlined",
        s: "strikethrough"
      },
      Ja = Object(Fa.invertObj)(Ua),
      $a = Object(Fa.invertObj)(Ka),
      Ga = Object(Fa.invertObj)(Va),
      Ya = function Ya(e) {
        return e && e.type && !!Ga[e.type.toLowerCase()];
      },
      Xa = function Xa(e) {
        return e && e.tagName && !!Va[e.tagName.toLowerCase()];
      },
      Za = function Za(e, i) {
        switch (e.type) {
          case "link":
            return o.a.createElement("a", e.data.toJSON(), i);
          case "text-span":
          default:
            return o.a.createElement("span", e.data.toJSON(), i);
        }
      },
      Qa = function Qa(_ref6) {
        var e = _ref6.currentElement,
          i = _ref6.type,
          t = _ref6.next;
        return {
          object: "inline",
          type: i,
          nodes: t(e.childNodes),
          data: _objectSpread2(_objectSpread2(_objectSpread2({}, e.target ? {
            target: e.target
          } : {}), e.href ? {
            href: e.getAttribute("href")
          } : {}), e.className ? {
            className: e.className
          } : {})
        };
      },
      en = function en(e, i) {
        switch (e.type) {
          case "bold":
            return o.a.createElement("strong", null, i);
          case "italic":
            return o.a.createElement("em", null, i);
          case "underlined":
            return o.a.createElement("u", null, i);
          default:
            return o.a.createElement("span", e.data.toJSON(), i);
        }
      },
      tn = function tn(_ref7) {
        var e = _ref7.currentElement,
          i = _ref7.type,
          t = _ref7.next;
        return {
          object: "mark",
          type: i,
          nodes: t(e.childNodes)
        };
      },
      an = function an(_ref8) {
        var e = _ref8.currentElement,
          i = _ref8.type,
          t = _ref8.next;
        return {
          object: "block",
          type: i,
          nodes: t(e.childNodes),
          data: _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, e.src ? {
            src: e.src
          } : {}), e.alt ? {
            alt: e.alt
          } : {}), e.className ? {
            className: e.className
          } : {}), e.height ? {
            height: e.height
          } : {}), e.width ? {
            width: e.width
          } : {}), e.href ? {
            href: e.href
          } : {}), e.target ? {
            target: e.target
          } : {})
        };
      },
      nn = [{
        deserialize: function deserialize(e, i) {
          if ((t = e) && t.tagName && Ua[t.tagName.toLowerCase()]) {
            var _t2 = Ua[e.tagName.toLowerCase()];
            if (_t2) return "link" === _t2 && "IMG" !== Object(Fa.pathOr)(null, ["firstElementChild", "tagName"], e) ? Qa({
              currentElement: e,
              type: _t2,
              next: i
            }) : an({
              currentElement: e,
              type: _t2,
              next: i
            });
          }
          var t;
        },
        serialize: function serialize(e, i) {
          if ("block" === e.object && (t = e) && t.type && Ja[t.type.toLowerCase()]) switch (e.type) {
            case "paragraph":
              return o.a.createElement("p", null, i);
            case "image":
              return o.a.createElement("img", e.data.toJSON());
            case "division":
              return o.a.createElement("div", e.data.toJSON(), i);
            case "emoji":
              return o.a.createElement("span", null, i);
            case "bulleted-list":
              return o.a.createElement("ul", null, i);
            case "list-item":
              return o.a.createElement("li", null, i);
            case "numbered-list":
              return o.a.createElement("ol", null, i);
            case "link":
              return o.a.createElement("a", e.data.toJSON(), i);
            default:
              return o.a.createElement("p", null, i);
          }
          var t;
        }
      }, {
        deserialize: function deserialize(e, i) {
          var t = Va[e.tagName.toLowerCase()];
          if (t && Xa(e)) return tn({
            currentElement: e,
            type: t,
            next: i
          });
        },
        serialize: function serialize(e, i) {
          if ("mark" === e.object && Ya(e)) return en(e, i);
        }
      }, {
        deserialize: function deserialize(e, i) {
          var t = Ha[e.tagName.toLowerCase()];
          if (t) return Qa({
            currentElement: e,
            type: t,
            next: i
          });
        },
        serialize: function serialize(e, i) {
          if ("inline" === e.object) return Za(e, i);
        }
      }],
      on = [{
        deserialize: function deserialize(e, i) {
          if ((t = e) && t.tagName && Ka[t.tagName.toLowerCase()]) {
            var _t3 = Ka[e.tagName.toLowerCase()];
            if (_t3) return "link" === _t3 && "IMG" !== Object(Fa.pathOr)(null, ["firstElementChild", "tagName"], e) ? Qa({
              currentElement: e,
              type: _t3,
              next: i
            }) : an({
              currentElement: e,
              type: _t3,
              next: i
            });
          }
          var t;
        },
        serialize: function serialize(e, i) {
          if ("block" === e.object && (t = e) && t.type && $a[t.type.toLowerCase()]) switch (e.type) {
            case "paragraph":
              return o.a.createElement("div", null, i);
            case "image":
              return o.a.createElement("img", e.data.toJSON());
            case "division":
              return o.a.createElement("div", e.data.toJSON(), i);
            case "emoji":
              return o.a.createElement("span", null, i);
            case "bulleted-list":
              return o.a.createElement("ul", null, i);
            case "list-item":
              return o.a.createElement("li", null, i);
            case "numbered-list":
              return o.a.createElement("ol", null, i);
            case "link":
              return o.a.createElement("a", e.data.toJSON(), i);
            default:
              return o.a.createElement("div", null, i);
          }
          var t;
        }
      }, {
        deserialize: function deserialize(e, i) {
          var t = Va[e.tagName.toLowerCase()];
          if (t && Xa(e)) return tn({
            currentElement: e,
            type: t,
            next: i
          });
        },
        serialize: function serialize(e, i) {
          if ("mark" === e.object && Ya(e)) return en(e, i);
        }
      }, {
        deserialize: function deserialize(e, i) {
          var t = Ha[e.tagName.toLowerCase()];
          if (t) return Qa({
            currentElement: e,
            type: t,
            next: i
          });
        },
        serialize: function serialize(e, i) {
          if ("inline" === e.object) return Za(e, i);
        }
      }];
    var rn = t(33);
    t(237);
    var sn = /*#__PURE__*/function (_n$Component) {
      _inherits2(DefaultCreator_DefaultCreator, _n$Component);
      var _super = _createSuper(DefaultCreator_DefaultCreator);
      function DefaultCreator_DefaultCreator(e) {
        var _this;
        _classCallCheck2(this, DefaultCreator_DefaultCreator);
        _this = _super.call(this, e), _this.saveTag = function () {
          var e = _this.props,
            i = e.onSave,
            t = e.value,
            a = e.hasNoFallback,
            n = _this.state.defaultToSet;
          i(a ? t : "".concat(t, ' or "').concat(n, '"'));
        }, _this.setDefault = function (e) {
          var i = e.target.value;
          _this.setState({
            defaultToSet: i
          });
        }, _this.state = {
          defaultToSet: ""
        };
        return _this;
      }
      _createClass(DefaultCreator_DefaultCreator, [{
        key: "render",
        value: function render() {
          var e = this.state.defaultToSet,
            i = this.props,
            t = i.value,
            a = i.dismiss,
            n = i.hasNoFallback ? o.a.createElement(pa.Div, {
              className: "driftiwyg-toolbar--default-value-no-fallback-text"
            }, "We\u2019got your back! We\u2019ll always have a value for this type of property token") : o.a.createElement(pa.Div, null, o.a.createElement(pa.Input, {
              value: e,
              label: "Fallback text",
              onChange: this.setDefault,
              placeholder: "Default text...",
              autoFocus: !0,
              description: "If we can\u2019t find a name for this variable, we\u2019ll display this instead"
            }));
          return o.a.createElement(pa.Div, {
            className: "driftiwyg-toolbar--default-value-creator"
          }, o.a.createElement(pa.Div, {
            className: "driftiwyg-toolbar--default-value-body"
          }, o.a.createElement(pa.Div, {
            className: "driftiwyg-toolbar--default-value-subheader"
          }, o.a.createElement("span", {
            className: "driftiwyg-tag-property"
          }, "{{".concat(t, "}}"))), n, o.a.createElement(pa.Div, {
            className: "driftiwyg-toolbar--default-value-buttons"
          }, o.a.createElement(pa.Button, {
            className: "driftiwyg-toolbar--insert-button",
            type: "primary",
            onClick: this.saveTag
          }, "Insert"), o.a.createElement(pa.Button, {
            type: "tertiary",
            onClick: a
          }, "Cancel"))));
        }
      }]);
      return DefaultCreator_DefaultCreator;
    }(n.Component);
    var _n = Object.freeze([{
        label: "Company Name",
        value: "name",
        source: "clearbit"
      }, {
        label: "Legal Name",
        value: "legalName",
        source: "clearbit"
      }, {
        label: "Domain",
        value: "domain",
        source: "clearbit"
      }, {
        label: "Domain Aliases",
        value: "domainAliases",
        source: "clearbit"
      }, {
        label: "Phone Numbers",
        value: "site.phoneNumbers",
        source: "clearbit"
      }, {
        label: "Email Addresses",
        value: "site.emailAddresses",
        source: "clearbit"
      }, {
        label: "Sector",
        value: "category.sector",
        source: "clearbit"
      }, {
        label: "Industry Group",
        value: "category.industryGroup",
        source: "clearbit"
      }, {
        label: "Industry",
        value: "category.industry",
        source: "clearbit"
      }, {
        label: "Sub Industry",
        value: "category.subIndustry",
        source: "clearbit"
      }, {
        label: "Tags",
        value: "tags",
        source: "clearbit"
      }, {
        label: "Description",
        value: "description",
        source: "clearbit"
      }, {
        label: "Founded Year",
        value: "foundedYear",
        source: "clearbit"
      }, {
        label: "Location",
        value: "location",
        source: "clearbit"
      }, {
        label: "Time Zone",
        value: "timeZone",
        source: "clearbit"
      }, {
        label: "Street Number",
        value: "geo.streetNumber",
        source: "clearbit"
      }, {
        label: "Street Name",
        value: "geo.streetName",
        source: "clearbit"
      }, {
        label: "City",
        value: "geo.city",
        source: "clearbit"
      }, {
        label: "Postal Code",
        value: "geo.postalCode",
        source: "clearbit"
      }, {
        label: "State",
        value: "geo.state",
        source: "clearbit"
      }, {
        label: "State Code",
        value: "geo.stateCode",
        source: "clearbit"
      }, {
        label: "Country",
        value: "geo.country",
        source: "clearbit"
      }, {
        label: "Country Code",
        value: "geo.countryCode",
        source: "clearbit"
      }, {
        label: "Logo",
        value: "logo",
        source: "clearbit"
      }, {
        label: "Facebook Handle",
        value: "facebook.handle",
        source: "clearbit"
      }, {
        label: "LinkedIn Handle",
        value: "linkedin.handle",
        source: "clearbit"
      }, {
        label: "Twitter Handle",
        value: "twitter.handle",
        source: "clearbit"
      }, {
        label: "Twitter Id",
        value: "twitter.id",
        source: "clearbit"
      }, {
        label: "Twitter Bio",
        value: "twitter.bio",
        source: "clearbit"
      }, {
        label: "Twitter Number Followers",
        value: "twitter.followers",
        source: "clearbit"
      }, {
        label: "Twitter Number Following",
        value: "twitter.following",
        source: "clearbit"
      }, {
        label: "Twitter Listed Location",
        value: "twitter.location",
        source: "clearbit"
      }, {
        label: "Twitter Listed Site",
        value: "twitter.site",
        source: "clearbit"
      }, {
        label: "Twitter Avatar",
        value: "twitter.avatar",
        source: "clearbit"
      }, {
        label: "Crunchbase Handle",
        value: "crunchbase.handle",
        source: "clearbit"
      }, {
        label: "Corporation Type",
        value: "type",
        source: "clearbit"
      }, {
        label: "Stock Ticker Symbol",
        value: "ticker",
        source: "clearbit"
      }, {
        label: "Phone",
        value: "phone",
        source: "clearbit"
      }, {
        label: "Alexa US Rank",
        value: "metrics.alexaUsRank",
        source: "clearbit"
      }, {
        label: "Alexa Global Rank",
        value: "metrics.alexaGlobalRank",
        source: "clearbit"
      }, {
        label: "Headcount",
        value: "metrics.employees",
        source: "clearbit"
      }, {
        label: "Headcount Range",
        value: "metrics.employeesRange",
        source: "clearbit"
      }, {
        label: "Market Cap",
        value: "metrics.marketCap",
        source: "clearbit"
      }, {
        label: "Capital Raised",
        value: "metrics.raised",
        source: "clearbit"
      }, {
        label: "Annual Revenue",
        value: "metrics.annualRevenue",
        source: "clearbit"
      }, {
        label: "Estimated Annual Revenue",
        value: "metrics.estimatedAnnualRevenue",
        source: "clearbit"
      }, {
        label: "Fiscal Year End",
        value: "metrics.fiscalYearEnd",
        source: "clearbit"
      }, {
        label: "Tech",
        value: "tech",
        source: "clearbit"
      }, {
        label: "Domain",
        value: "parent.domain",
        source: "clearbit"
      }]),
      ln = Object.freeze([{
        label: "Audience",
        value: "audience",
        source: "demandbase"
      }, {
        label: "Company Name",
        value: "companyName",
        source: "demandbase"
      }, {
        label: "Industry",
        value: "industry",
        source: "demandbase"
      }, {
        label: "Sub Industry",
        value: "subIndustry",
        source: "demandbase"
      }, {
        label: "Employee Count",
        value: "employeeCount",
        source: "demandbase"
      }, {
        label: "Employee Range",
        value: "employeeRange",
        source: "demandbase"
      }, {
        label: "Marketing Alias",
        value: "marketingAlias",
        source: "demandbase"
      }, {
        label: "Annual Sales",
        value: "annualSales",
        source: "demandbase"
      }, {
        label: "Revenue Range",
        value: "revenueRange",
        source: "demandbase"
      }, {
        label: "City",
        value: "city",
        source: "demandbase"
      }, {
        label: "State",
        value: "state",
        source: "demandbase"
      }, {
        label: "Country Code",
        value: "countryCode",
        source: "demandbase"
      }, {
        label: "Country Name",
        value: "countryName",
        source: "demandbase"
      }]);
    var gn = /*#__PURE__*/function (_n$Component2) {
      _inherits2(DriftPropertyPluginDropdown_DriftPropertyPluginDropdown, _n$Component2);
      var _super2 = _createSuper(DriftPropertyPluginDropdown_DriftPropertyPluginDropdown);
      function DriftPropertyPluginDropdown_DriftPropertyPluginDropdown(e) {
        var _this2;
        _classCallCheck2(this, DriftPropertyPluginDropdown_DriftPropertyPluginDropdown);
        _this2 = _super2.call(this, e), _this2.openDefaultCreator = function (e) {
          var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          _this2.setState(function (t) {
            return {
              defaultCreatorOpen: !t.defaultCreatorOpen,
              createDefaultFor: e,
              hasNoFallback: i
            };
          });
        }, _this2.dismissDefaultValueCreator = function () {
          _this2.setState(function (e) {
            return {
              defaultCreatorOpen: !e.defaultCreatorOpen,
              createDefaultFor: null,
              hasNoFallback: !1
            };
          });
        }, _this2.filterProps = function (e) {
          _this2.setState({
            filterQuery: e.target.value
          }, _this2.doFilter);
        }, _this2.doFilter = function () {
          var e = [];
          _this2.state.defaultProperties.map(function (i, t) {
            var a = i.properties.filter(function (e) {
              return e.label.toLowerCase().includes(_this2.state.filterQuery);
            });
            return 0 !== a.length && e.push({
              name: i.name,
              properties: a
            });
          }), _this2.setState({
            filteredProperties: e
          });
        }, _this2.renderDropdownList = function () {
          var e = 0 !== _this2.state.filteredProperties.length;
          return o.a.createElement("div", {
            className: "property-list-container"
          }, e ? _this2.state.filteredProperties.map(function (e, i) {
            return o.a.createElement("div", {
              key: "properties-list-".concat(e.name)
            }, o.a.createElement("p", {
              className: "property-list-section-header"
            }, e.name), o.a.createElement("ul", {
              className: "property-list"
            }, e.properties.map(function (e) {
              return o.a.createElement("li", {
                key: "plugin-properties-".concat(e.source, "-").concat(e.value),
                onClick: function onClick() {
                  return _this2.openDefaultCreator("".concat(e.source, ".").concat(e.value), e.hasNoFallback);
                }
              }, e.label);
            })));
          }) : o.a.createElement("div", {
            className: "empty-state-container"
          }, o.a.createElement(pa.Colorway, {
            type: "2"
          }, o.a.createElement(ba.Icon, {
            name: "cw-empty-search"
          })), o.a.createElement("div", null, "There are no personalization", o.a.createElement("br", null), "tokens matching your search.")));
        };
        var i = e.companyTagList,
          t = i && Object(Fa.isEmpty)(i),
          a = t ? [] : [{
            name: "company",
            properties: i || (e.hasDemandbaseEnabled ? ln : _n)
          }],
          n = t ? [] : [{
            name: "company",
            properties: i || (e.hasDemandbaseEnabled ? ln : _n)
          }];
        e.userTagList && (a.unshift({
          name: "contact",
          properties: e.userTagList
        }), n.unshift({
          name: "contact",
          properties: e.userTagList
        })), e.meetingTagList && (a.unshift({
          name: "meeting",
          properties: e.meetingTagList
        }), n.unshift({
          name: "meeting",
          properties: e.meetingTagList
        })), e.teammateTagList && (a.unshift({
          name: "teammate",
          properties: e.teammateTagList
        }), n.unshift({
          name: "teammate",
          properties: e.teammateTagList
        })), e.driftIntelTagList && (a.unshift({
          name: "drift intel",
          properties: e.driftIntelTagList
        }), n.unshift({
          name: "drift intel",
          properties: e.driftIntelTagList
        })), _this2.state = {
          defaultCreatorOpen: !1,
          createDefaultFor: null,
          defaultProperties: a,
          filteredProperties: n,
          filterQuery: ""
        };
        return _this2;
      }
      _createClass(DriftPropertyPluginDropdown_DriftPropertyPluginDropdown, [{
        key: "render",
        value: function render() {
          var e = this.state,
            i = e.defaultCreatorOpen,
            t = e.createDefaultFor,
            a = e.filterQuery,
            n = e.hasNoFallback,
            r = this.props.onClick;
          return o.a.createElement("div", {
            className: "toolbar-menu-popover toolbar-menu-popover--tag-properties"
          }, o.a.createElement("div", {
            className: "toolbar-menu-popover--container"
          }, o.a.createElement("div", {
            className: "toolbar-menu-popover--header"
          }, i && o.a.createElement("span", {
            className: "toolbar-menu-popover--back-button-container",
            onClick: this.dismissDefaultValueCreator
          }, o.a.createElement(ba.Icon, {
            name: "arrow-1-left",
            className: "toolbar-menu-popover--back-button",
            width: 14,
            height: 14
          })), o.a.createElement(pa.H4, {
            className: s()({
              "toolbar-menu-popover--header--offset": i
            })
          }, "Personalization tokens"), o.a.createElement("a", {
            href: "https://gethelp.drift.com/s/article/How-to-Use-Personalization-Tokens",
            target: "_blank",
            rel: "noopener noreferrer"
          }, "Learn more")), i ? o.a.createElement(sn, {
            onSave: r,
            value: t,
            hasNoFallback: n,
            dismiss: this.dismissDefaultValueCreator
          }) : o.a.createElement("div", null, o.a.createElement(pa.Input, {
            value: a,
            onChange: this.filterProps,
            className: "property-list-filter",
            placeholder: "Search..."
          }), this.renderDropdownList())));
        }
      }]);
      return DriftPropertyPluginDropdown_DriftPropertyPluginDropdown;
    }(n.Component);
    t(239);
    var fn = /*#__PURE__*/function (_n$Component3) {
        _inherits2(DriftPropertyPlugin_DriftPropertyPlugin, _n$Component3);
        var _super3 = _createSuper(DriftPropertyPlugin_DriftPropertyPlugin);
        function DriftPropertyPlugin_DriftPropertyPlugin() {
          var _this3;
          _classCallCheck2(this, DriftPropertyPlugin_DriftPropertyPlugin);
          for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
            e[_key] = arguments[_key];
          }
          _this3 = _super3.call.apply(_super3, [this].concat(e)), _this3.addProperty = function (e) {
            (0, _this3.props.onChange)({
              object: "inline",
              type: "text-span",
              data: {
                className: "driftiwyg-tag-property--editor"
              },
              nodes: [{
                object: "text",
                leaves: [{
                  text: "{{".concat(e, "}}")
                }]
              }]
            });
          };
          return _this3;
        }
        _createClass(DriftPropertyPlugin_DriftPropertyPlugin, [{
          key: "render",
          value: function render() {
            return o.a.createElement(gn, Object.assign({
              onClick: this.addProperty
            }, this.props));
          }
        }]);
        return DriftPropertyPlugin_DriftPropertyPlugin;
      }(n.Component),
      hn = t(123);
    t(13);
    var dn = t(14),
      mn = t.n(dn),
      un = t(124),
      cn = t.n(un),
      Fn = t(125),
      pn = t(126),
      bn = "PRODUCTION" === window.__ENV__ ? pn : Fn,
      yn = t(49),
      kn = t.n(yn);
    var vn = cn.a.get("DrifttAuth");
    mn.a.defaults.headers.post["Content-Type"] = "application/json";
    mn.a.create({
      baseURL: bn.CUSTOMER_API,
      headers: {
        Authorization: "bearer ".concat(vn)
      },
      paramsSerializer: function paramsSerializer(e) {
        return kn.a.stringify(e, {
          arrayFormat: "repeat"
        });
      }
    }), mn.a.create({
      baseURL: bn.MEETINGS_API,
      headers: {
        Authorization: "bearer ".concat(vn)
      },
      paramsSerializer: function paramsSerializer(e) {
        return kn.a.stringify(e, {
          arrayFormat: "repeat"
        });
      }
    }), mn.a.create({
      baseURL: bn.CONVERSATION_API,
      headers: {
        Authorization: "bearer ".concat(vn)
      },
      paramsSerializer: function paramsSerializer(e) {
        return kn.a.stringify(e, {
          arrayFormat: "repeat"
        });
      }
    }), mn.a.create({
      baseURL: bn.ACCOUNTS_API,
      headers: {
        Authorization: "bearer ".concat(vn)
      }
    });
    var wn = mn.a.create({
        baseURL: bn.FILE_API,
        headers: {
          Authorization: "bearer ".concat(vn),
          "Content-Type": "multipart/form-data"
        },
        transformRequest: [function (_ref9) {
          var e = _ref9.file;
          var i = new FormData();
          return i.append("file", e), i;
        }]
      }),
      En = (mn.a.create({
        baseURL: bn.WS_API
      }), function (e) {
        return wn.post("/upload", {
          file: e
        });
      });
    var An = /*#__PURE__*/function (_n$Component4) {
        _inherits2(ImagePlugin_ImagePlugin, _n$Component4);
        var _super4 = _createSuper(ImagePlugin_ImagePlugin);
        function ImagePlugin_ImagePlugin(e) {
          var _this4;
          _classCallCheck2(this, ImagePlugin_ImagePlugin);
          _this4 = _super4.call(this, e), _this4.handleUploadImage = function (e) {
            var i = _this4.props.handleImageUpload;
            return _this4.setState({
              uploadError: ""
            }), (i instanceof Function ? i : En)(e).then(function (e) {
              return e.data;
            });
          }, _this4.handleSaveImage = function (e, i) {
            _this4.setState({
              imageSrc: e,
              imageName: i
            });
          }, _this4.handleClearImage = function () {
            _this4.setState({
              imageSrc: "",
              imageName: ""
            });
          }, _this4.sendImageNode = function () {
            var e = _this4.props,
              i = e.onChange,
              t = e.height,
              a = e.width,
              n = _this4.state,
              o = n.imageAltText,
              r = {
                src: n.imageSrc,
                alt: o
              };
            t > 0 && (r.height = t), a > 0 && (r.width = a), i({
              object: "block",
              type: "image",
              data: r
            }, o);
          }, _this4.state = {
            file: null,
            imageAltText: "",
            imageSrc: "",
            imageName: "",
            uploadError: ""
          };
          return _this4;
        }
        _createClass(ImagePlugin_ImagePlugin, [{
          key: "render",
          value: function render() {
            var _this5 = this;
            var e = this.state,
              i = e.imageAltText,
              t = e.imageSrc,
              a = e.imageName,
              n = e.uploadError,
              r = this.props.onClickOutside;
            return o.a.createElement(pa.Div, {
              className: "toolbar-menu-popover toolbar-menu-popover--image"
            }, o.a.createElement(pa.Div, {
              className: "toolbar-menu-popover--container"
            }, o.a.createElement(pa.Div, {
              className: "toolbar-menu-popover--header"
            }, o.a.createElement(pa.H4, null, "Insert an image")), o.a.createElement(pa.Div, {
              className: "toolbar-menu-popover--image-container"
            }, o.a.createElement(hn.UploadArea, {
              className: "image-uploader",
              handleUploadFile: this.handleUploadImage,
              handleSaveFile: this.handleSaveImage,
              handleClearFile: this.handleClearImage,
              onReadError: function onReadError() {
                _this5.setState({
                  uploadError: "Whoops! Something went wrong. Please try again."
                });
              },
              onTypeError: function onTypeError() {
                _this5.setState({
                  uploadError: "Whoops! We only support .png, .jpg, .jpeg, and .gif files."
                });
              },
              onSizeError: function onSizeError() {
                _this5.setState({
                  uploadError: "Sorry, your image must be smaller than 25 MB."
                });
              },
              previewUrl: t,
              previewName: a
            }), n && o.a.createElement(pa.Div, {
              className: "driftiwyg-image-upload-error"
            }, n), o.a.createElement(pa.Input, {
              label: "Link",
              className: "image-popover-alt-text-input",
              onChange: function onChange(e) {
                return _this5.setState({
                  imageAltText: e.target.value
                });
              },
              type: "text",
              value: i,
              placeholder: "Type or paste a link"
            }), o.a.createElement(pa.Button, {
              className: "driftiwyg-toolbar--insert-button",
              type: "primary",
              disabled: !t,
              onClick: this.sendImageNode
            }, "Insert"), o.a.createElement(pa.Button, {
              type: "tertiary",
              onClick: r
            }, "Cancel"))));
          }
        }]);
        return ImagePlugin_ImagePlugin;
      }(n.Component),
      jn = t(24),
      xn = function xn(e, i) {
        if (!(e instanceof i)) throw new TypeError("Cannot call a class as a function");
      },
      Cn = Object,
      Dn = function createClass() {
        function defineProperties(e, i) {
          for (var t = 0; t < i.length; t++) {
            var a = i[t];
            a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Cn.defineProperty(e, a.key, a);
          }
        }
        return function (e, i, t) {
          return i && defineProperties(e.prototype, i), t && defineProperties(e, t), e;
        };
      }(),
      Bn = t(32),
      Sn = t.n(Bn),
      qn = Object.prototype.hasOwnProperty,
      On = !{
        toString: null
      }.propertyIsEnumerable("toString"),
      Tn = ["toString", "toLocaleString", "valueOf", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "constructor"],
      Nn = Tn.length,
      In = function In(e) {
        if ("function" !== typeof e && ("object" !== typeof e || null === e)) throw new TypeError("Object.keys called on non-object");
        var i,
          t,
          a = [];
        for (i in e) {
          qn.call(e, i) && a.push(i);
        }
        if (On) for (t = 0; t < Nn; t++) {
          qn.call(e, Tn[t]) && a.push(Tn[t]);
        }
        return a;
      },
      Pn = {
        name: "a",
        unified: "b",
        non_qualified: "c",
        has_img_apple: "d",
        has_img_google: "e",
        has_img_twitter: "f",
        has_img_emojione: "g",
        has_img_facebook: "h",
        has_img_messenger: "i",
        keywords: "j",
        sheet: "k",
        emoticons: "l",
        text: "m",
        short_names: "n",
        added_in: "o"
      },
      Mn = function buildSearch(e) {
        var i = [],
          t = function addToSearch(e, t) {
            e && (Array.isArray(e) ? e : [e]).forEach(function (e) {
              (t ? e.split(/[-|_|\s]+/) : [e]).forEach(function (e) {
                e = e.toLowerCase(), -1 == i.indexOf(e) && i.push(e);
              });
            });
          };
        return t(e.short_names, !0), t(e.name, !0), t(e.keywords, !1), t(e.emoticons, !1), i.join(",");
      },
      Rn = function uncompress(e) {
        for (var i in e.compressed = !1, e.emojis) {
          var t = e.emojis[i];
          for (var a in Pn) {
            t[a] = t[Pn[a]], delete t[Pn[a]];
          }
          t.short_names || (t.short_names = []), t.short_names.unshift(i), t.sheet_x = t.sheet[0], t.sheet_y = t.sheet[1], delete t.sheet, t.text || (t.text = ""), t.added_in || (t.added_in = 6), t.added_in = t.added_in.toFixed(1), t.search = Mn(t);
        }
      },
      zn = String.fromCodePoint || function stringFromCodePoint() {
        var e,
          i,
          t = [],
          a = -1,
          n = arguments.length;
        if (!n) return "";
        for (var o = ""; ++a < n;) {
          var r = Number(arguments[a]);
          if (!isFinite(r) || r < 0 || r > 1114111 || Math.floor(r) != r) throw RangeError("Invalid code point: " + r);
          r <= 65535 ? t.push(r) : (e = 55296 + ((r -= 65536) >> 10), i = r % 1024 + 56320, t.push(e, i)), (a + 1 === n || t.length > 16384) && (o += String.fromCharCode.apply(null, t), t.length = 0);
        }
        return o;
      },
      Ln = /^(?:\:([^\:]+)\:)(?:\:skin-tone-(\d)\:)?$/,
      Wn = ["1F3FA", "1F3FB", "1F3FC", "1F3FD", "1F3FE", "1F3FF"];
    function unifiedToNative(e) {
      var i = e.split("-").map(function (e) {
        return "0x" + e;
      });
      return zn.apply(null, i);
    }
    function getSanitizedData() {
      return function sanitize(e) {
        var i = e.name,
          t = e.short_names,
          a = e.skin_tone,
          n = e.skin_variations,
          o = e.emoticons,
          r = e.unified,
          s = e.custom,
          _ = e.customCategory,
          l = e.imageUrl,
          g = e.id || t[0],
          f = ":" + g + ":";
        return s ? {
          id: g,
          name: i,
          short_names: t,
          colons: f,
          emoticons: o,
          custom: s,
          customCategory: _,
          imageUrl: l
        } : (a && (f += ":skin-tone-" + a + ":"), {
          id: g,
          name: i,
          short_names: t,
          colons: f,
          emoticons: o,
          unified: r.toLowerCase(),
          skin: a || (n ? 1 : null),
          native: unifiedToNative(r)
        });
      }(getData.apply(void 0, arguments));
    }
    function getData(e, i, t, a) {
      var n = {};
      if ("string" == typeof e) {
        var o = e.match(Ln);
        if (o && (e = o[1], o[2] && (i = parseInt(o[2], 10))), a.aliases.hasOwnProperty(e) && (e = a.aliases[e]), !a.emojis.hasOwnProperty(e)) return null;
        n = a.emojis[e];
      } else e.id && (a.aliases.hasOwnProperty(e.id) && (e.id = a.aliases[e.id]), a.emojis.hasOwnProperty(e.id) && (n = a.emojis[e.id], i || (i = e.skin)));
      if (In(n).length || ((n = e).custom = !0, n.search || (n.search = Mn(e))), n.emoticons || (n.emoticons = []), n.variations || (n.variations = []), n.skin_variations && i > 1) {
        n = JSON.parse(Sn()(n));
        var r = Wn[i - 1],
          s = n.skin_variations[r];
        if (!s.variations && n.variations && delete n.variations, t && (void 0 == s["has_img_" + t] || s["has_img_" + t]) || !t) for (var _ in n.skin_tone = i, s) {
          var l = s[_];
          n[_] = l;
        }
      }
      return n.variations && n.variations.length && ((n = JSON.parse(Sn()(n))).unified = n.variations.shift()), n;
    }
    function uniq(e) {
      return e.reduce(function (e, i) {
        return -1 === e.indexOf(i) && e.push(i), e;
      }, []);
    }
    function deepMerge(e, i) {
      var t = {};
      for (var a in e) {
        var n = e[a],
          o = n;
        i.hasOwnProperty(a) && (o = i[a]), "object" === typeof o && (o = deepMerge(n, o)), t[a] = o;
      }
      return t;
    }
    var Un = "emoji-mart",
      Kn = "undefined" !== typeof window && "localStorage" in window,
      Hn = void 0,
      Vn = void 0;
    function store_set(e, i) {
      if (Vn) Vn(e, i);else {
        if (!Kn) return;
        try {
          window.localStorage[Un + "." + e] = Sn()(i);
        } catch (t) {}
      }
    }
    var Jn = {
        update: function update(e) {
          for (var i in e) {
            store_set(i, e[i]);
          }
        },
        set: store_set,
        get: function get(e) {
          if (Hn) return Hn(e);
          if (Kn) try {
            var i = window.localStorage[Un + "." + e];
            if (i) return JSON.parse(i);
          } catch (t) {
            return;
          }
        },
        setNamespace: function setNamespace(e) {
          Un = e;
        },
        setHandlers: function setHandlers(e) {
          e || (e = {}), Hn = e.getter, Vn = e.setter;
        }
      },
      $n = function () {
        function NimbleEmojiIndex(e, i) {
          xn(this, NimbleEmojiIndex), e.compressed && Rn(e), this.data = e || {}, this.set = i || null, this.originalPool = {}, this.index = {}, this.emojis = {}, this.emoticons = {}, this.customEmojisList = [], this.buildIndex();
        }
        return Dn(NimbleEmojiIndex, [{
          key: "buildIndex",
          value: function buildIndex() {
            var e = this,
              i = function _loop(i) {
                var t = e.data.emojis[i],
                  a = t.short_names,
                  n = t.emoticons,
                  o = t.skin_variations,
                  r = a[0];
                if (n && n.forEach(function (i) {
                  e.emoticons[i] || (e.emoticons[i] = r);
                }), o) {
                  e.emojis[r] = {};
                  for (var s = 1; s <= 6; s++) {
                    e.emojis[r][s] = getSanitizedData({
                      id: r,
                      skin: s
                    }, s, e.set, e.data);
                  }
                } else e.emojis[r] = getSanitizedData(r, null, e.set, e.data);
                e.originalPool[r] = t;
              };
            for (var t in this.data.emojis) {
              i(t);
            }
          }
        }, {
          key: "clearCustomEmojis",
          value: function clearCustomEmojis(e) {
            var i = this;
            this.customEmojisList.forEach(function (t) {
              var a = t.id || t.short_names[0];
              delete e[a], delete i.emojis[a];
            });
          }
        }, {
          key: "addCustomToPool",
          value: function addCustomToPool(e, i) {
            var t = this;
            this.customEmojisList.length && this.clearCustomEmojis(i), e.forEach(function (e) {
              var a = e.id || e.short_names[0];
              a && !i[a] && (i[a] = getData(e, null, null, t.data), t.emojis[a] = getSanitizedData(e, null, null, t.data));
            }), this.customEmojisList = e, this.index = {};
          }
        }, {
          key: "search",
          value: function search(e) {
            var i = this,
              t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              a = t.emojisToShowFilter,
              n = t.maxResults,
              o = t.include,
              r = t.exclude,
              s = t.custom,
              _ = void 0 === s ? [] : s;
            this.customEmojisList != _ && this.addCustomToPool(_, this.originalPool);
            var l = Jn.get("skin") || 1;
            n || (n = 75), o || (o = []), r || (r = []);
            var g = null,
              f = this.originalPool;
            if (e.length) {
              if ("-" == e || "-1" == e) return [this.emojis[-1][l]];
              var h,
                d = e.toLowerCase().split(/[\s|,|\-|_]+/);
              if (d.length > 2 && (d = [d[0], d[1]]), (o.length || r.length) && (f = {}, this.data.categories.forEach(function (e) {
                var t = !o || !o.length || o.indexOf(e.id) > -1,
                  a = !(!r || !r.length) && r.indexOf(e.id) > -1;
                t && !a && e.emojis.forEach(function (e) {
                  return f[e] = i.data.emojis[e];
                });
              }), _.length)) {
                var m = !o || !o.length || o.indexOf("custom") > -1,
                  u = !(!r || !r.length) && r.indexOf("custom") > -1;
                m && !u && this.addCustomToPool(_, f);
              }
              g = (h = d.map(function (e) {
                for (var t = f, a = i.index, n = 0, o = 0; o < e.length; o++) {
                  var r = e[o];
                  n++, a[r] || (a[r] = {}), (a = a[r]).results || function () {
                    var o = {};
                    for (var r in a.results = [], a.pool = {}, t) {
                      var s = t[r],
                        _ = s.search,
                        g = e.substr(0, n),
                        f = _.indexOf(g);
                      if (-1 != f) {
                        var h = f + 1;
                        g == r && (h = 0), i.emojis[r] && i.emojis[r][l] ? a.results.push(i.emojis[r][l]) : a.results.push(i.emojis[r]), a.pool[r] = s, o[r] = h;
                      }
                    }
                    a.results.sort(function (e, i) {
                      var t = o[e.id],
                        a = o[i.id];
                      return t == a ? e.id.localeCompare(i.id) : t - a;
                    });
                  }(), t = a.pool;
                }
                return a.results;
              }).filter(function (e) {
                return e;
              })).length > 1 ? function intersect(e, i) {
                var t = uniq(e),
                  a = uniq(i);
                return t.filter(function (e) {
                  return a.indexOf(e) >= 0;
                });
              }.apply(null, h) : h.length ? h[0] : [];
            }
            return g && (a && (g = g.filter(function (e) {
              return a(f[e.id]);
            })), g && g.length > n && (g = g.slice(0, n))), g;
          }
        }]), NimbleEmojiIndex;
      }(),
      Gn = new $n(jn);
    Gn.emojis, Gn.emoticons;
    var Yn = ["+1", "grinning", "kissing_heart", "heart_eyes", "laughing", "stuck_out_tongue_winking_eye", "sweat_smile", "joy", "scream", "disappointed", "unamused", "weary", "sob", "sunglasses", "heart", "poop"],
      Xn = void 0,
      Zn = void 0,
      Qn = {};
    function init() {
      Zn = !0, Xn = Jn.get("frequently");
    }
    var eo = {
        add: function add(e) {
          Zn || init();
          var i = e.id;
          Xn || (Xn = Qn), Xn[i] || (Xn[i] = 0), Xn[i] += 1, Jn.set("last", i), Jn.set("frequently", Xn);
        },
        get: function frequently_get(e) {
          if (Zn || init(), !Xn) {
            Qn = {};
            for (var i = [], t = 0; t < e; t++) {
              Qn[Yn[t]] = e - t, i.push(Yn[t]);
            }
            return i;
          }
          var a = 4 * e,
            n = [];
          for (var o in Xn) {
            Xn.hasOwnProperty(o) && n.push(o);
          }
          var r = n.sort(function (e, i) {
              return Xn[e] - Xn[i];
            }).reverse().slice(0, a),
            s = Jn.get("last");
          return s && -1 == r.indexOf(s) && (r.pop(), r.push(s)), r;
        }
      },
      io = Object.assign || function (e) {
        for (var i = 1; i < arguments.length; i++) {
          var t = arguments[i];
          for (var a in t) {
            Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
          }
        }
        return e;
      },
      to = Object.getPrototypeOf || function (e) {
        return "function" === typeof (e = Object(e)).constructor && e instanceof e.constructor ? e.constructor.prototype : e instanceof Object ? Object.prototype : null;
      };
    function possibleConstructorReturn_possibleConstructorReturn(e, i) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !i || "object" !== typeof i && "function" !== typeof i ? e : i;
    }
    var ao = Object;
    function inherits_inherits(e, i) {
      if ("function" !== typeof i && null !== i) throw new TypeError("Super expression must either be null or a function, not " + typeof i);
      e.prototype = ao.create(i && i.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), i && (ao.setPrototypeOf ? ao.setPrototypeOf(e, i) : e.__proto__ = i);
    }
    var no = t(127),
      oo = t.n(no),
      ro = t(128),
      so = t.n(ro),
      _o = (t(292), {
        activity: function activity() {
          return o.a.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            width: "24",
            height: "24"
          }, o.a.createElement("path", {
            d: "M12 0C5.373 0 0 5.372 0 12c0 6.627 5.373 12 12 12 6.628 0 12-5.373 12-12 0-6.628-5.372-12-12-12m9.949 11H17.05c.224-2.527 1.232-4.773 1.968-6.113A9.966 9.966 0 0 1 21.949 11M13 11V2.051a9.945 9.945 0 0 1 4.432 1.564c-.858 1.491-2.156 4.22-2.392 7.385H13zm-2 0H8.961c-.238-3.165-1.536-5.894-2.393-7.385A9.95 9.95 0 0 1 11 2.051V11zm0 2v8.949a9.937 9.937 0 0 1-4.432-1.564c.857-1.492 2.155-4.221 2.393-7.385H11zm4.04 0c.236 3.164 1.534 5.893 2.392 7.385A9.92 9.92 0 0 1 13 21.949V13h2.04zM4.982 4.887C5.718 6.227 6.726 8.473 6.951 11h-4.9a9.977 9.977 0 0 1 2.931-6.113M2.051 13h4.9c-.226 2.527-1.233 4.771-1.969 6.113A9.972 9.972 0 0 1 2.051 13m16.967 6.113c-.735-1.342-1.744-3.586-1.968-6.113h4.899a9.961 9.961 0 0 1-2.931 6.113"
          }));
        },
        custom: function custom() {
          return o.a.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            width: "24",
            height: "24"
          }, o.a.createElement("g", {
            transform: "translate(2.000000, 1.000000)"
          }, o.a.createElement("rect", {
            id: "Rectangle",
            x: "8",
            y: "0",
            width: "3",
            height: "21",
            rx: "1.5"
          }), o.a.createElement("rect", {
            id: "Rectangle",
            transform: "translate(9.843, 10.549) rotate(60) translate(-9.843, -10.549) ",
            x: "8.343",
            y: "0.049",
            width: "3",
            height: "21",
            rx: "1.5"
          }), o.a.createElement("rect", {
            id: "Rectangle",
            transform: "translate(9.843, 10.549) rotate(-60) translate(-9.843, -10.549) ",
            x: "8.343",
            y: "0.049",
            width: "3",
            height: "21",
            rx: "1.5"
          })));
        },
        flags: function flags() {
          return o.a.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            width: "24",
            height: "24"
          }, o.a.createElement("path", {
            d: "M0 0l6.084 24H8L1.916 0zM21 5h-4l-1-4H4l3 12h3l1 4h13L21 5zM6.563 3h7.875l2 8H8.563l-2-8zm8.832 10l-2.856 1.904L12.063 13h3.332zM19 13l-1.5-6h1.938l2 8H16l3-2z"
          }));
        },
        foods: function foods() {
          return o.a.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            width: "24",
            height: "24"
          }, o.a.createElement("path", {
            d: "M17 4.978c-1.838 0-2.876.396-3.68.934.513-1.172 1.768-2.934 4.68-2.934a1 1 0 0 0 0-2c-2.921 0-4.629 1.365-5.547 2.512-.064.078-.119.162-.18.244C11.73 1.838 10.798.023 9.207.023 8.579.022 7.85.306 7 .978 5.027 2.54 5.329 3.902 6.492 4.999 3.609 5.222 0 7.352 0 12.969c0 4.582 4.961 11.009 9 11.009 1.975 0 2.371-.486 3-1 .629.514 1.025 1 3 1 4.039 0 9-6.418 9-11 0-5.953-4.055-8-7-8M8.242 2.546c.641-.508.943-.523.965-.523.426.169.975 1.405 1.357 3.055-1.527-.629-2.741-1.352-2.98-1.846.059-.112.241-.356.658-.686M15 21.978c-1.08 0-1.21-.109-1.559-.402l-.176-.146c-.367-.302-.816-.452-1.266-.452s-.898.15-1.266.452l-.176.146c-.347.292-.477.402-1.557.402-2.813 0-7-5.389-7-9.009 0-5.823 4.488-5.991 5-5.991 1.939 0 2.484.471 3.387 1.251l.323.276a1.995 1.995 0 0 0 2.58 0l.323-.276c.902-.78 1.447-1.251 3.387-1.251.512 0 5 .168 5 6 0 3.617-4.187 9-7 9"
          }));
        },
        nature: function nature() {
          return o.a.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            width: "24",
            height: "24"
          }, o.a.createElement("path", {
            d: "M15.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 15.5 8M8.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 8.5 8"
          }), o.a.createElement("path", {
            d: "M18.933 0h-.027c-.97 0-2.138.787-3.018 1.497-1.274-.374-2.612-.51-3.887-.51-1.285 0-2.616.133-3.874.517C7.245.79 6.069 0 5.093 0h-.027C3.352 0 .07 2.67.002 7.026c-.039 2.479.276 4.238 1.04 5.013.254.258.882.677 1.295.882.191 3.177.922 5.238 2.536 6.38.897.637 2.187.949 3.2 1.102C8.04 20.6 8 20.795 8 21c0 1.773 2.35 3 4 3 1.648 0 4-1.227 4-3 0-.201-.038-.393-.072-.586 2.573-.385 5.435-1.877 5.925-7.587.396-.22.887-.568 1.104-.788.763-.774 1.079-2.534 1.04-5.013C23.929 2.67 20.646 0 18.933 0M3.223 9.135c-.237.281-.837 1.155-.884 1.238-.15-.41-.368-1.349-.337-3.291.051-3.281 2.478-4.972 3.091-5.031.256.015.731.27 1.265.646-1.11 1.171-2.275 2.915-2.352 5.125-.133.546-.398.858-.783 1.313M12 22c-.901 0-1.954-.693-2-1 0-.654.475-1.236 1-1.602V20a1 1 0 1 0 2 0v-.602c.524.365 1 .947 1 1.602-.046.307-1.099 1-2 1m3-3.48v.02a4.752 4.752 0 0 0-1.262-1.02c1.092-.516 2.239-1.334 2.239-2.217 0-1.842-1.781-2.195-3.977-2.195-2.196 0-3.978.354-3.978 2.195 0 .883 1.148 1.701 2.238 2.217A4.8 4.8 0 0 0 9 18.539v-.025c-1-.076-2.182-.281-2.973-.842-1.301-.92-1.838-3.045-1.853-6.478l.023-.041c.496-.826 1.49-1.45 1.804-3.102 0-2.047 1.357-3.631 2.362-4.522C9.37 3.178 10.555 3 11.948 3c1.447 0 2.685.192 3.733.57 1 .9 2.316 2.465 2.316 4.48.313 1.651 1.307 2.275 1.803 3.102.035.058.068.117.102.178-.059 5.967-1.949 7.01-4.902 7.19m6.628-8.202c-.037-.065-.074-.13-.113-.195a7.587 7.587 0 0 0-.739-.987c-.385-.455-.648-.768-.782-1.313-.076-2.209-1.241-3.954-2.353-5.124.531-.376 1.004-.63 1.261-.647.636.071 3.044 1.764 3.096 5.031.027 1.81-.347 3.218-.37 3.235"
          }));
        },
        objects: function objects() {
          return o.a.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            width: "24",
            height: "24"
          }, o.a.createElement("path", {
            d: "M12 0a9 9 0 0 0-5 16.482V21s2.035 3 5 3 5-3 5-3v-4.518A9 9 0 0 0 12 0zm0 2c3.86 0 7 3.141 7 7s-3.14 7-7 7-7-3.141-7-7 3.14-7 7-7zM9 17.477c.94.332 1.946.523 3 .523s2.06-.19 3-.523v.834c-.91.436-1.925.689-3 .689a6.924 6.924 0 0 1-3-.69v-.833zm.236 3.07A8.854 8.854 0 0 0 12 21c.965 0 1.888-.167 2.758-.451C14.155 21.173 13.153 22 12 22c-1.102 0-2.117-.789-2.764-1.453z"
          }), o.a.createElement("path", {
            d: "M14.745 12.449h-.004c-.852-.024-1.188-.858-1.577-1.824-.421-1.061-.703-1.561-1.182-1.566h-.009c-.481 0-.783.497-1.235 1.537-.436.982-.801 1.811-1.636 1.791l-.276-.043c-.565-.171-.853-.691-1.284-1.794-.125-.313-.202-.632-.27-.913-.051-.213-.127-.53-.195-.634C7.067 9.004 7.039 9 6.99 9A1 1 0 0 1 7 7h.01c1.662.017 2.015 1.373 2.198 2.134.486-.981 1.304-2.058 2.797-2.075 1.531.018 2.28 1.153 2.731 2.141l.002-.008C14.944 8.424 15.327 7 16.979 7h.032A1 1 0 1 1 17 9h-.011c-.149.076-.256.474-.319.709a6.484 6.484 0 0 1-.311.951c-.429.973-.79 1.789-1.614 1.789"
          }));
        },
        people: function people() {
          return o.a.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            width: "24",
            height: "24"
          }, o.a.createElement("path", {
            d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"
          }), o.a.createElement("path", {
            d: "M8 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 8 7M16 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 16 7M15.232 15c-.693 1.195-1.87 2-3.349 2-1.477 0-2.655-.805-3.347-2H15m3-2H6a6 6 0 1 0 12 0"
          }));
        },
        places: function places() {
          return o.a.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            width: "24",
            height: "24"
          }, o.a.createElement("path", {
            d: "M6.5 12C5.122 12 4 13.121 4 14.5S5.122 17 6.5 17 9 15.879 9 14.5 7.878 12 6.5 12m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5M17.5 12c-1.378 0-2.5 1.121-2.5 2.5s1.122 2.5 2.5 2.5 2.5-1.121 2.5-2.5-1.122-2.5-2.5-2.5m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5"
          }), o.a.createElement("path", {
            d: "M22.482 9.494l-1.039-.346L21.4 9h.6c.552 0 1-.439 1-.992 0-.006-.003-.008-.003-.008H23c0-1-.889-2-1.984-2h-.642l-.731-1.717C19.262 3.012 18.091 2 16.764 2H7.236C5.909 2 4.738 3.012 4.357 4.283L3.626 6h-.642C1.889 6 1 7 1 8h.003S1 8.002 1 8.008C1 8.561 1.448 9 2 9h.6l-.043.148-1.039.346a2.001 2.001 0 0 0-1.359 2.097l.751 7.508a1 1 0 0 0 .994.901H3v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h6v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h1.096a.999.999 0 0 0 .994-.901l.751-7.508a2.001 2.001 0 0 0-1.359-2.097M6.273 4.857C6.402 4.43 6.788 4 7.236 4h9.527c.448 0 .834.43.963.857L19.313 9H4.688l1.585-4.143zM7 21H5v-1h2v1zm12 0h-2v-1h2v1zm2.189-3H2.811l-.662-6.607L3 11h18l.852.393L21.189 18z"
          }));
        },
        recent: function recent() {
          return o.a.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            width: "24",
            height: "24"
          }, o.a.createElement("path", {
            d: "M13 4h-2l-.001 7H9v2h2v2h2v-2h4v-2h-4z"
          }), o.a.createElement("path", {
            d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"
          }));
        },
        symbols: function symbols() {
          return o.a.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            width: "24",
            height: "24"
          }, o.a.createElement("path", {
            d: "M0 0h11v2H0zM4 11h3V6h4V4H0v2h4zM15.5 17c1.381 0 2.5-1.116 2.5-2.493s-1.119-2.493-2.5-2.493S13 13.13 13 14.507 14.119 17 15.5 17m0-2.986c.276 0 .5.222.5.493 0 .272-.224.493-.5.493s-.5-.221-.5-.493.224-.493.5-.493M21.5 19.014c-1.381 0-2.5 1.116-2.5 2.493S20.119 24 21.5 24s2.5-1.116 2.5-2.493-1.119-2.493-2.5-2.493m0 2.986a.497.497 0 0 1-.5-.493c0-.271.224-.493.5-.493s.5.222.5.493a.497.497 0 0 1-.5.493M22 13l-9 9 1.513 1.5 8.99-9.009zM17 11c2.209 0 4-1.119 4-2.5V2s.985-.161 1.498.949C23.01 4.055 23 6 23 6s1-1.119 1-3.135C24-.02 21 0 21 0h-2v6.347A5.853 5.853 0 0 0 17 6c-2.209 0-4 1.119-4 2.5s1.791 2.5 4 2.5M10.297 20.482l-1.475-1.585a47.54 47.54 0 0 1-1.442 1.129c-.307-.288-.989-1.016-2.045-2.183.902-.836 1.479-1.466 1.729-1.892s.376-.871.376-1.336c0-.592-.273-1.178-.818-1.759-.546-.581-1.329-.871-2.349-.871-1.008 0-1.79.293-2.344.879-.556.587-.832 1.181-.832 1.784 0 .813.419 1.748 1.256 2.805-.847.614-1.444 1.208-1.794 1.784a3.465 3.465 0 0 0-.523 1.833c0 .857.308 1.56.924 2.107.616.549 1.423.823 2.42.823 1.173 0 2.444-.379 3.813-1.137L8.235 24h2.819l-2.09-2.383 1.333-1.135zm-6.736-6.389a1.02 1.02 0 0 1 .73-.286c.31 0 .559.085.747.254a.849.849 0 0 1 .283.659c0 .518-.419 1.112-1.257 1.784-.536-.651-.805-1.231-.805-1.742a.901.901 0 0 1 .302-.669M3.74 22c-.427 0-.778-.116-1.057-.349-.279-.232-.418-.487-.418-.766 0-.594.509-1.288 1.527-2.083.968 1.134 1.717 1.946 2.248 2.438-.921.507-1.686.76-2.3.76"
          }));
        }
      }),
      lo = {
        search: function search() {
          return o.a.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "13",
            height: "13",
            viewBox: "0 0 20 20",
            opacity: "0.5"
          }, o.a.createElement("path", {
            d: "M12.9 14.32a8 8 0 1 1 1.41-1.41l5.35 5.33-1.42 1.42-5.33-5.34zM8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12z"
          }));
        },
        delete: function _delete() {
          return o.a.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "13",
            height: "13",
            viewBox: "0 0 20 20",
            opacity: "0.5"
          }, o.a.createElement("path", {
            d: "M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414 1.414L10 11.414l7.071 7.071 1.414-1.414L11.414 10l7.071-7.071-1.414-1.414L10 8.586z"
          }));
        }
      },
      go = {
        data: f.a.object.isRequired,
        onOver: f.a.func,
        onLeave: f.a.func,
        onClick: f.a.func,
        fallback: f.a.func,
        backgroundImageFn: f.a.func,
        native: f.a.bool,
        forceSize: f.a.bool,
        tooltip: f.a.bool,
        skin: f.a.oneOf([1, 2, 3, 4, 5, 6]),
        sheetSize: f.a.oneOf([16, 20, 32, 64]),
        sheetColumns: f.a.number,
        sheetRows: f.a.number,
        set: f.a.oneOf(["apple", "google", "twitter", "emojione", "messenger", "facebook"]),
        size: f.a.number.isRequired,
        emoji: f.a.oneOfType([f.a.string, f.a.object]).isRequired
      },
      fo = {
        onClick: f.a.func,
        onSelect: f.a.func,
        onSkinChange: f.a.func,
        perLine: f.a.number,
        emojiSize: f.a.number,
        i18n: f.a.object,
        style: f.a.object,
        title: f.a.string,
        emoji: f.a.string,
        color: f.a.string,
        set: go.set,
        skin: go.skin,
        native: f.a.bool,
        backgroundImageFn: go.backgroundImageFn,
        sheetSize: go.sheetSize,
        emojisToShowFilter: f.a.func,
        showPreview: f.a.bool,
        showSkinTones: f.a.bool,
        emojiTooltip: go.tooltip,
        include: f.a.arrayOf(f.a.string),
        exclude: f.a.arrayOf(f.a.string),
        recent: f.a.arrayOf(f.a.string),
        autoFocus: f.a.bool,
        custom: f.a.arrayOf(f.a.shape({
          name: f.a.string.isRequired,
          short_names: f.a.arrayOf(f.a.string).isRequired,
          emoticons: f.a.arrayOf(f.a.string),
          keywords: f.a.arrayOf(f.a.string),
          imageUrl: f.a.string,
          spriteUrl: f.a.string,
          sheet_x: f.a.number,
          sheet_y: f.a.number,
          size: f.a.number,
          sheetColumns: f.a.number,
          sheetRows: f.a.number
        })),
        skinEmoji: f.a.string,
        notFound: f.a.func,
        notFoundEmoji: f.a.string,
        icons: f.a.object
      },
      ho = function (e) {
        function Anchors(e) {
          xn(this, Anchors);
          var i = possibleConstructorReturn_possibleConstructorReturn(this, (Anchors.__proto__ || to(Anchors)).call(this, e)),
            t = e.categories.filter(function (e) {
              return e.first;
            })[0];
          return i.state = {
            selected: t.name
          }, i.handleClick = i.handleClick.bind(i), i;
        }
        return inherits_inherits(Anchors, o.a.PureComponent), Dn(Anchors, [{
          key: "handleClick",
          value: function handleClick(e) {
            var i = e.currentTarget.getAttribute("data-index"),
              t = this.props,
              a = t.categories;
            (0, t.onAnchorClick)(a[i], i);
          }
        }, {
          key: "render",
          value: function render() {
            var e = this,
              i = this.props,
              t = i.categories,
              a = i.color,
              n = i.i18n,
              r = i.icons,
              s = this.state.selected;
            return o.a.createElement("nav", {
              className: "emoji-mart-anchors",
              "aria-label": n.categorieslabel
            }, t.map(function (i, t) {
              var _ = i.id,
                l = i.name,
                g = i.anchor,
                f = l == s;
              if (!1 === g) return null;
              var h = _.startsWith("custom-") ? "custom" : _;
              return o.a.createElement("button", {
                key: _,
                "aria-label": n.categories[_],
                title: n.categories[_],
                "data-index": t,
                type: "button",
                onClick: e.handleClick,
                className: "emoji-mart-anchor " + (f ? "emoji-mart-anchor-selected" : ""),
                style: {
                  color: f ? a : null
                }
              }, o.a.createElement("div", {
                className: "emoji-mart-anchor-icon"
              }, r.categories[h]()), o.a.createElement("span", {
                className: "emoji-mart-anchor-bar",
                style: {
                  backgroundColor: a
                }
              }));
            }));
          }
        }]), Anchors;
      }(),
      mo = ho;
    ho.propTypes = {
      categories: f.a.array,
      onAnchorClick: f.a.func,
      icons: f.a.object
    }, ho.defaultProps = {
      categories: [],
      onAnchorClick: function onAnchorClick() {},
      icons: {}
    };
    var uo = {
        skin: 1,
        set: "apple",
        sheetSize: 64,
        sheetColumns: 52,
        sheetRows: 52,
        native: !1,
        forceSize: !1,
        tooltip: !1,
        backgroundImageFn: function backgroundImageFn(e, i) {
          return "https://unpkg.com/emoji-datasource-" + e + "@4.0.4/img/" + e + "/sheets-256/" + i + ".png";
        }
      },
      co = {
        onClick: function onClick() {},
        onSelect: function onSelect() {},
        onSkinChange: function onSkinChange() {},
        emojiSize: 24,
        perLine: 9,
        i18n: {},
        style: {},
        title: "Emoji Mart\u2122",
        emoji: "department_store",
        color: "#ae65c5",
        set: uo.set,
        skin: null,
        defaultSkin: uo.skin,
        native: uo.native,
        sheetSize: uo.sheetSize,
        backgroundImageFn: uo.backgroundImageFn,
        emojisToShowFilter: null,
        showPreview: !0,
        showSkinTones: !0,
        darkMode: !("function" !== typeof matchMedia || !matchMedia("(prefers-color-scheme: dark)").matches),
        emojiTooltip: uo.tooltip,
        autoFocus: !1,
        custom: [],
        skinEmoji: "",
        notFound: function notFound() {},
        notFoundEmoji: "sleuth_or_spy",
        icons: {}
      },
      Fo = function _getData(e) {
        return getData(e.emoji, e.skin, e.set, e.data);
      },
      po = function _getPosition(e) {
        var i = Fo(e),
          t = i.sheet_x,
          a = i.sheet_y;
        return 100 / (e.sheetColumns - 1) * t + "% " + 100 / (e.sheetRows - 1) * a + "%";
      },
      bo = function _getSanitizedData(e) {
        return getSanitizedData(e.emoji, e.skin, e.set, e.data);
      },
      yo = function _isNumeric(e) {
        return !isNaN(e - parseFloat(e));
      },
      ko = function NimbleEmoji(e) {
        for (var i in e.data.compressed && Rn(e.data), NimbleEmoji.defaultProps) {
          void 0 == e[i] && void 0 != NimbleEmoji.defaultProps[i] && (e[i] = NimbleEmoji.defaultProps[i]);
        }
        var t = Fo(e);
        if (!t) return e.fallback ? e.fallback(null, e) : null;
        var a = t.unified,
          n = t.custom,
          r = t.short_names,
          s = t.imageUrl,
          _ = {},
          l = e.children,
          g = "emoji-mart-emoji",
          f = a && unifiedToNative(a),
          h = [f].concat(r).filter(Boolean).join(", "),
          d = null;
        if (!a && !n) return e.fallback ? e.fallback(t, e) : null;
        if (e.tooltip && (d = r[0]), e.native && a) g += " emoji-mart-emoji-native", _ = {
          fontSize: e.size
        }, l = f, e.forceSize && (_.display = "inline-block", _.width = e.size, _.height = e.size, _.wordBreak = "keep-all");else if (n) g += " emoji-mart-emoji-custom", _ = {
          width: e.size,
          height: e.size,
          display: "inline-block"
        }, _ = t.spriteUrl ? io({}, _, {
          backgroundImage: "url(" + t.spriteUrl + ")",
          backgroundSize: 100 * e.sheetColumns + "% " + 100 * e.sheetRows + "%",
          backgroundPosition: po(e)
        }) : io({}, _, {
          backgroundImage: "url(" + s + ")",
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center"
        });else {
          if (!(void 0 == t["has_img_" + e.set] || t["has_img_" + e.set])) return e.fallback ? e.fallback(t, e) : null;
          _ = {
            width: e.size,
            height: e.size,
            display: "inline-block",
            backgroundImage: "url(" + e.backgroundImageFn(e.set, e.sheetSize) + ")",
            backgroundSize: 100 * e.sheetColumns + "% " + 100 * e.sheetRows + "%",
            backgroundPosition: po(e)
          };
        }
        var m = {
          name: "span",
          props: {}
        };
        return e.onClick && (m.name = "button", m.props = {
          type: "button"
        }), e.html ? (_ = function _convertStyleToCSS(e) {
          var i = document.createElement("div");
          for (var t in e) {
            var a = e[t];
            yo(a) && (a += "px"), i.style[t] = a;
          }
          return i.getAttribute("style");
        }(_), "<" + m.name + " style='" + _ + "' aria-label='" + h + "' " + (d ? "title='" + d + "'" : "") + " class='" + g + "'>" + (l || "") + "</" + m.name + ">") : o.a.createElement(m.name, io({
          onClick: function onClick(i) {
            return function _handleClick(e, i) {
              i.onClick && (0, i.onClick)(bo(i), e);
            }(i, e);
          },
          onMouseEnter: function onMouseEnter(i) {
            return function _handleOver(e, i) {
              i.onOver && (0, i.onOver)(bo(i), e);
            }(i, e);
          },
          onMouseLeave: function onMouseLeave(i) {
            return function _handleLeave(e, i) {
              i.onLeave && (0, i.onLeave)(bo(i), e);
            }(i, e);
          },
          "aria-label": h,
          title: d,
          className: g
        }, m.props), o.a.createElement("span", {
          style: _
        }, l));
      };
    ko.propTypes = io({}, go, {
      data: f.a.object.isRequired
    }), ko.defaultProps = uo;
    var vo = ko,
      wo = function (e) {
        function NotFound() {
          return xn(this, NotFound), possibleConstructorReturn_possibleConstructorReturn(this, (NotFound.__proto__ || to(NotFound)).apply(this, arguments));
        }
        return inherits_inherits(NotFound, o.a.PureComponent), Dn(NotFound, [{
          key: "render",
          value: function render() {
            var e = this.props,
              i = e.data,
              t = e.emojiProps,
              a = e.i18n,
              n = e.notFound,
              r = e.notFoundEmoji;
            return n && n() || o.a.createElement("div", {
              className: "emoji-mart-no-results"
            }, vo(io({
              data: i
            }, t, {
              size: 38,
              emoji: r,
              onOver: null,
              onLeave: null,
              onClick: null
            })), o.a.createElement("div", {
              className: "emoji-mart-no-results-label"
            }, a.notfound));
          }
        }]), NotFound;
      }(),
      Eo = wo;
    wo.propTypes = {
      notFound: f.a.func.isRequired,
      emojiProps: f.a.object.isRequired
    };
    var Ao = function (e) {
        function Category(e) {
          xn(this, Category);
          var i = possibleConstructorReturn_possibleConstructorReturn(this, (Category.__proto__ || to(Category)).call(this, e));
          return i.data = e.data, i.setContainerRef = i.setContainerRef.bind(i), i.setLabelRef = i.setLabelRef.bind(i), i;
        }
        return inherits_inherits(Category, o.a.Component), Dn(Category, [{
          key: "componentDidMount",
          value: function componentDidMount() {
            this.margin = 0, this.minMargin = 0, this.memoizeSize();
          }
        }, {
          key: "shouldComponentUpdate",
          value: function shouldComponentUpdate(e, i) {
            var t = this.props,
              a = t.name,
              n = t.perLine,
              o = t.native,
              r = t.hasStickyPosition,
              s = t.emojis,
              _ = t.emojiProps,
              l = _.skin,
              g = _.size,
              f = _.set,
              h = e.perLine,
              d = e.native,
              m = e.hasStickyPosition,
              u = e.emojis,
              c = e.emojiProps,
              F = c.skin,
              p = c.size,
              b = c.set,
              y = !1;
            return "Recent" == a && n != h && (y = !0), "Search" == a && (y = !(s == u)), l == F && g == p && o == d && f == b && r == m || (y = !0), y;
          }
        }, {
          key: "memoizeSize",
          value: function memoizeSize() {
            if (!this.container) return this.top = 0, void (this.maxMargin = 0);
            var e = this.container.parentElement,
              i = this.container.getBoundingClientRect(),
              t = i.top,
              a = i.height,
              n = e.getBoundingClientRect().top,
              o = this.label.getBoundingClientRect().height;
            this.top = t - n + e.scrollTop, this.maxMargin = 0 == a ? 0 : a - o;
          }
        }, {
          key: "handleScroll",
          value: function handleScroll(e) {
            var i = e - this.top;
            if ((i = (i = i < this.minMargin ? this.minMargin : i) > this.maxMargin ? this.maxMargin : i) != this.margin) return this.props.hasStickyPosition || (this.label.style.top = i + "px"), this.margin = i, !0;
          }
        }, {
          key: "getEmojis",
          value: function getEmojis() {
            var e = this,
              i = this.props,
              t = i.name,
              a = i.emojis,
              n = i.recent,
              o = i.perLine;
            if ("Recent" == t) {
              var r = this.props.custom,
                s = n || eo.get(o);
              if (s.length && (a = s.map(function (e) {
                var i = r.filter(function (i) {
                  return i.id === e;
                })[0];
                return i || e;
              }).filter(function (i) {
                return !!getData(i, null, null, e.data);
              })), 0 === a.length && s.length > 0) return null;
            }
            return a && (a = a.slice(0)), a;
          }
        }, {
          key: "updateDisplay",
          value: function updateDisplay(e) {
            this.getEmojis() && this.container && (this.container.style.display = e);
          }
        }, {
          key: "setContainerRef",
          value: function setContainerRef(e) {
            this.container = e;
          }
        }, {
          key: "setLabelRef",
          value: function setLabelRef(e) {
            this.label = e;
          }
        }, {
          key: "render",
          value: function render() {
            var e = this,
              i = this.props,
              t = i.id,
              a = i.name,
              n = i.hasStickyPosition,
              r = i.emojiProps,
              s = i.i18n,
              _ = i.notFound,
              l = i.notFoundEmoji,
              g = this.getEmojis(),
              f = {},
              h = {},
              d = {};
            g || (d = {
              display: "none"
            }), n || (f = {
              height: 28
            }, h = {
              position: "absolute"
            });
            var m = s.categories[t] || a;
            return o.a.createElement("section", {
              ref: this.setContainerRef,
              className: "emoji-mart-category",
              "aria-label": m,
              style: d
            }, o.a.createElement("div", {
              style: f,
              "data-name": a,
              className: "emoji-mart-category-label"
            }, o.a.createElement("span", {
              style: h,
              ref: this.setLabelRef,
              "aria-hidden": !0
            }, m)), o.a.createElement("ul", {
              className: "emoji-mart-category-list"
            }, g && g.map(function (i) {
              return o.a.createElement("li", {
                key: i.short_names && i.short_names.join("_") || i
              }, vo(io({
                emoji: i,
                data: e.data
              }, r)));
            })), g && !g.length && o.a.createElement(Eo, {
              i18n: s,
              notFound: _,
              notFoundEmoji: l,
              data: this.data,
              emojiProps: r
            }));
          }
        }]), Category;
      }(),
      jo = Ao;
    Ao.propTypes = {
      emojis: f.a.array,
      hasStickyPosition: f.a.bool,
      name: f.a.string.isRequired,
      native: f.a.bool.isRequired,
      perLine: f.a.number.isRequired,
      emojiProps: f.a.object.isRequired,
      recent: f.a.arrayOf(f.a.string),
      notFound: f.a.func,
      notFoundEmoji: f.a.string.isRequired
    }, Ao.defaultProps = {
      emojis: [],
      hasStickyPosition: !0
    };
    var xo = function (e) {
        function Skins(e) {
          xn(this, Skins);
          var i = possibleConstructorReturn_possibleConstructorReturn(this, (Skins.__proto__ || to(Skins)).call(this, e));
          return i.state = {
            opened: !1
          }, i;
        }
        return inherits_inherits(Skins, o.a.PureComponent), Dn(Skins, [{
          key: "handleClick",
          value: function handleClick(e) {
            var i = parseInt(e.currentTarget.getAttribute("data-skin")),
              t = this.props.onChange;
            this.state.opened ? (this.setState({
              opened: !1
            }), i != this.props.skin && t(i)) : this.setState({
              opened: !0
            });
          }
        }, {
          key: "render",
          value: function render() {
            return null;
          }
        }]), Skins;
      }(),
      Co = xo;
    xo.propTypes = {
      onChange: f.a.func,
      skin: f.a.number.isRequired
    }, xo.defaultProps = {
      onChange: function onChange() {}
    };
    var Do = function (e) {
        function SkinsEmoji(e) {
          xn(this, SkinsEmoji);
          var i = possibleConstructorReturn_possibleConstructorReturn(this, (SkinsEmoji.__proto__ || to(SkinsEmoji)).call(this, e));
          return i.handleClick = i.handleClick.bind(i), i;
        }
        return inherits_inherits(SkinsEmoji, Co), Dn(SkinsEmoji, [{
          key: "render",
          value: function render() {
            for (var e = this.props, i = e.skin, t = e.emojiProps, a = e.data, n = e.skinEmoji, r = e.i18n, s = this.state.opened, _ = [], l = 1; l <= 6; l++) {
              var g = l === i;
              _.push(o.a.createElement("span", {
                key: "skin-tone-" + l,
                className: "emoji-mart-skin-swatch custom" + (g ? " selected" : "")
              }, o.a.createElement("span", {
                onClick: this.handleClick,
                "data-skin": l,
                className: "emoji-mart-skin-tone-" + l
              }, vo({
                emoji: n,
                data: a,
                skin: l,
                backgroundImageFn: t.backgroundImageFn,
                native: t.native,
                set: t.set,
                sheetSize: t.sheetSize,
                size: 23
              }))));
            }
            return o.a.createElement("div", {
              className: "emoji-mart-skin-swatches custom" + (s ? " opened" : "")
            }, o.a.createElement("div", {
              className: "emoji-mart-skin-text" + (s ? " opened" : "")
            }, r.skintext), _);
          }
        }]), SkinsEmoji;
      }(),
      Bo = Do;
    Do.propTypes = {
      onChange: f.a.func,
      skin: f.a.number.isRequired,
      emojiProps: f.a.object.isRequired,
      skinTone: f.a.number,
      skinEmoji: f.a.string.isRequired,
      i18n: f.a.object
    }, Do.defaultProps = {
      onChange: function onChange() {},
      skinTone: null
    };
    var So = function (e) {
        function SkinsDot(e) {
          xn(this, SkinsDot);
          var i = possibleConstructorReturn_possibleConstructorReturn(this, (SkinsDot.__proto__ || to(SkinsDot)).call(this, e));
          return i.handleClick = i.handleClick.bind(i), i.handleKeyDown = i.handleKeyDown.bind(i), i;
        }
        return inherits_inherits(SkinsDot, Co), Dn(SkinsDot, [{
          key: "handleKeyDown",
          value: function handleKeyDown(e) {
            13 !== e.keyCode && 32 !== e.keyCode || this.handleClick(e);
          }
        }, {
          key: "render",
          value: function render() {
            for (var e = this.props, i = e.skin, t = e.i18n, a = this.state.opened, n = [], r = 1; r <= 6; r++) {
              var s = r === i,
                _ = a || s;
              n.push(o.a.createElement("span", io({
                key: "skin-tone-" + r,
                className: "emoji-mart-skin-swatch" + (s ? " selected" : ""),
                "aria-label": t.skintones[r],
                "aria-hidden": !_
              }, a ? {
                role: "menuitem"
              } : {}), o.a.createElement("span", io({
                onClick: this.handleClick,
                onKeyDown: this.handleKeyDown,
                role: "button"
              }, s ? {
                "aria-haspopup": !0,
                "aria-expanded": !!a
              } : {}, a ? {
                "aria-pressed": !!s
              } : {}, {
                tabIndex: _ ? "0" : "",
                "aria-label": t.skintones[r],
                title: t.skintones[r],
                "data-skin": r,
                className: "emoji-mart-skin emoji-mart-skin-tone-" + r
              }))));
            }
            return o.a.createElement("section", {
              className: "emoji-mart-skin-swatches" + (a ? " opened" : ""),
              "aria-label": t.skintext
            }, o.a.createElement("div", a ? {
              role: "menubar"
            } : {}, n));
          }
        }]), SkinsDot;
      }(),
      qo = So;
    So.propTypes = {
      onChange: f.a.func,
      skin: f.a.number.isRequired,
      i18n: f.a.object
    }, So.defaultProps = {
      onChange: function onChange() {}
    };
    var Oo = function (e) {
        function Preview(e) {
          xn(this, Preview);
          var i = possibleConstructorReturn_possibleConstructorReturn(this, (Preview.__proto__ || to(Preview)).call(this, e));
          return i.data = e.data, i.state = {
            emoji: null
          }, i;
        }
        return inherits_inherits(Preview, o.a.PureComponent), Dn(Preview, [{
          key: "render",
          value: function render() {
            var e = this.state.emoji,
              i = this.props,
              t = i.emojiProps,
              a = i.skinsProps,
              n = i.showSkinTones,
              r = i.title,
              s = i.emoji,
              _ = i.i18n,
              l = i.showPreview;
            if (e && l) {
              var g = getData(e, null, null, this.data),
                f = g.emoticons,
                h = [],
                d = [];
              return (void 0 === f ? [] : f).forEach(function (e) {
                h.indexOf(e.toLowerCase()) >= 0 || (h.push(e.toLowerCase()), d.push(e));
              }), o.a.createElement("div", {
                className: "emoji-mart-preview"
              }, o.a.createElement("div", {
                className: "emoji-mart-preview-emoji",
                "aria-hidden": "true"
              }, vo(io({
                key: e.id,
                emoji: e,
                data: this.data
              }, t))), o.a.createElement("div", {
                className: "emoji-mart-preview-data",
                "aria-hidden": "true"
              }, o.a.createElement("div", {
                className: "emoji-mart-preview-name"
              }, e.name), o.a.createElement("div", {
                className: "emoji-mart-preview-shortnames"
              }, g.short_names.map(function (e) {
                return o.a.createElement("span", {
                  key: e,
                  className: "emoji-mart-preview-shortname"
                }, ":", e, ":");
              })), o.a.createElement("div", {
                className: "emoji-mart-preview-emoticons"
              }, d.map(function (e) {
                return o.a.createElement("span", {
                  key: e,
                  className: "emoji-mart-preview-emoticon"
                }, e);
              }))));
            }
            return o.a.createElement("div", {
              className: "emoji-mart-preview"
            }, o.a.createElement("div", {
              className: "emoji-mart-preview-emoji",
              "aria-hidden": "true"
            }, s && s.length && vo(io({
              emoji: s,
              data: this.data
            }, t))), o.a.createElement("div", {
              className: "emoji-mart-preview-data",
              "aria-hidden": "true"
            }, o.a.createElement("span", {
              className: "emoji-mart-title-label"
            }, r)), n && o.a.createElement("div", {
              className: "emoji-mart-preview-skins" + (a.skinEmoji ? " custom" : "")
            }, a.skinEmoji ? o.a.createElement(Bo, {
              skin: a.skin,
              emojiProps: t,
              data: this.data,
              skinEmoji: a.skinEmoji,
              i18n: _,
              onChange: a.onChange
            }) : o.a.createElement(qo, {
              skin: a.skin,
              i18n: _,
              onChange: a.onChange
            })));
          }
        }]), Preview;
      }(),
      To = Oo;
    Oo.propTypes = {
      showSkinTones: f.a.bool,
      title: f.a.string.isRequired,
      emoji: f.a.string.isRequired,
      emojiProps: f.a.object.isRequired,
      skinsProps: f.a.object.isRequired
    }, Oo.defaultProps = {
      showSkinTones: !0,
      onChange: function onChange() {}
    };
    var No = 0,
      Io = function (e) {
        function Search(e) {
          xn(this, Search);
          var i = possibleConstructorReturn_possibleConstructorReturn(this, (Search.__proto__ || to(Search)).call(this, e));
          return i.state = {
            icon: lo.search,
            isSearching: !1,
            id: ++No
          }, i.data = e.data, i.emojiIndex = new $n(i.data), i.setRef = i.setRef.bind(i), i.clear = i.clear.bind(i), i.handleKeyUp = i.handleKeyUp.bind(i), i.handleChange = function throttleIdleTask(e) {
            var i = "function" === typeof requestIdleCallback ? requestIdleCallback : setTimeout,
              t = !1;
            return function throttled() {
              t || (t = !0, i(function () {
                t = !1, e();
              }));
            };
          }(i.handleChange.bind(i)), i;
        }
        return inherits_inherits(Search, o.a.PureComponent), Dn(Search, [{
          key: "componentDidMount",
          value: function componentDidMount() {
            this.input && this.input.value && this.search(this.input.value);
          }
        }, {
          key: "search",
          value: function search(e) {
            "" == e ? this.setState({
              icon: lo.search,
              isSearching: !1
            }) : this.setState({
              icon: lo.delete,
              isSearching: !0
            }), this.props.onSearch(this.emojiIndex.search(e, {
              emojisToShowFilter: this.props.emojisToShowFilter,
              maxResults: this.props.maxResults,
              include: this.props.include,
              exclude: this.props.exclude,
              custom: this.props.custom
            }));
          }
        }, {
          key: "clear",
          value: function clear() {
            "" != this.input.value && (this.input.value = "", this.input.focus(), this.search(""));
          }
        }, {
          key: "handleChange",
          value: function handleChange() {
            this.search(this.input.value);
          }
        }, {
          key: "handleKeyUp",
          value: function handleKeyUp(e) {
            13 === e.keyCode && this.clear();
          }
        }, {
          key: "setRef",
          value: function setRef(e) {
            this.input = e;
          }
        }, {
          key: "render",
          value: function render() {
            var e = this.props,
              i = e.i18n,
              t = e.autoFocus,
              a = this.state,
              n = a.icon,
              r = a.isSearching,
              s = "emoji-mart-search-" + a.id;
            return o.a.createElement("section", {
              className: "emoji-mart-search",
              "aria-label": i.search
            }, o.a.createElement("input", {
              id: s,
              ref: this.setRef,
              type: "search",
              onChange: this.handleChange,
              placeholder: i.search,
              autoFocus: t
            }), o.a.createElement("label", {
              className: "emoji-mart-sr-only",
              htmlFor: s
            }, i.search), o.a.createElement("button", {
              className: "emoji-mart-search-icon",
              onClick: this.clear,
              onKeyUp: this.handleKeyUp,
              "aria-label": i.clear,
              disabled: !r
            }, n()));
          }
        }]), Search;
      }(),
      Po = Io;
    Io.propTypes = {
      onSearch: f.a.func,
      maxResults: f.a.number,
      emojisToShowFilter: f.a.func,
      autoFocus: f.a.bool
    }, Io.defaultProps = {
      onSearch: function onSearch() {},
      maxResults: 75,
      emojisToShowFilter: null,
      autoFocus: !1
    };
    var Mo = {
        search: "Search",
        clear: "Clear",
        notfound: "No Emoji Found",
        skintext: "Choose your default skin tone",
        categories: {
          search: "Search Results",
          recent: "Frequently Used",
          people: "Smileys & People",
          nature: "Animals & Nature",
          foods: "Food & Drink",
          activity: "Activity",
          places: "Travel & Places",
          objects: "Objects",
          symbols: "Symbols",
          flags: "Flags",
          custom: "Custom"
        },
        categorieslabel: "Emoji categories",
        skintones: {
          1: "Default Skin Tone",
          2: "Light Skin Tone",
          3: "Medium-Light Skin Tone",
          4: "Medium Skin Tone",
          5: "Medium-Dark Skin Tone",
          6: "Dark Skin Tone"
        }
      },
      Ro = function (e) {
        function NimblePicker(e) {
          xn(this, NimblePicker);
          var i = possibleConstructorReturn_possibleConstructorReturn(this, (NimblePicker.__proto__ || to(NimblePicker)).call(this, e));
          i.CUSTOM = [], i.RECENT_CATEGORY = {
            id: "recent",
            name: "Recent",
            emojis: null
          }, i.SEARCH_CATEGORY = {
            id: "search",
            name: "Search",
            emojis: null,
            anchor: !1
          }, e.data.compressed && Rn(e.data), i.data = e.data, i.i18n = deepMerge(Mo, e.i18n), i.icons = deepMerge(a, e.icons), i.state = {
            skin: e.skin || Jn.get("skin") || e.defaultSkin,
            firstRender: !0
          }, i.categories = [];
          var t = [].concat(i.data.categories);
          if (e.custom.length > 0) {
            var n = {},
              o = 0;
            e.custom.forEach(function (e) {
              n[e.customCategory] || (n[e.customCategory] = {
                id: e.customCategory ? "custom-" + e.customCategory : "custom",
                name: e.customCategory || "Custom",
                emojis: [],
                anchor: 0 === o
              }, o++);
              var t = n[e.customCategory],
                a = io({}, e, {
                  id: e.short_names[0],
                  custom: !0
                });
              t.emojis.push(a), i.CUSTOM.push(a);
            }), t.push.apply(t, so()(oo()(n)));
          }
          i.hideRecent = !0, void 0 != e.include && t.sort(function (i, t) {
            return e.include.indexOf(i.id) > e.include.indexOf(t.id) ? 1 : -1;
          });
          for (var r = 0; r < t.length; r++) {
            var s = t[r],
              _ = !e.include || !e.include.length || e.include.indexOf(s.id) > -1,
              l = !(!e.exclude || !e.exclude.length) && e.exclude.indexOf(s.id) > -1;
            if (_ && !l) if (e.emojisToShowFilter) {
              for (var g = [], f = s.emojis, h = 0; h < f.length; h++) {
                var d = f[h];
                e.emojisToShowFilter(i.data.emojis[d] || d) && g.push(d);
              }
              if (g.length) {
                var m = {
                  emojis: g,
                  name: s.name,
                  id: s.id
                };
                i.categories.push(m);
              }
            } else i.categories.push(s);
          }
          var u = !e.include || !e.include.length || e.include.indexOf(i.RECENT_CATEGORY.id) > -1,
            c = !(!e.exclude || !e.exclude.length) && e.exclude.indexOf(i.RECENT_CATEGORY.id) > -1;
          return u && !c && (i.hideRecent = !1, i.categories.unshift(i.RECENT_CATEGORY)), i.categories[0] && (i.categories[0].first = !0), i.categories.unshift(i.SEARCH_CATEGORY), i.setAnchorsRef = i.setAnchorsRef.bind(i), i.handleAnchorClick = i.handleAnchorClick.bind(i), i.setSearchRef = i.setSearchRef.bind(i), i.handleSearch = i.handleSearch.bind(i), i.setScrollRef = i.setScrollRef.bind(i), i.handleScroll = i.handleScroll.bind(i), i.handleScrollPaint = i.handleScrollPaint.bind(i), i.handleEmojiOver = i.handleEmojiOver.bind(i), i.handleEmojiLeave = i.handleEmojiLeave.bind(i), i.handleEmojiClick = i.handleEmojiClick.bind(i), i.handleEmojiSelect = i.handleEmojiSelect.bind(i), i.setPreviewRef = i.setPreviewRef.bind(i), i.handleSkinChange = i.handleSkinChange.bind(i), i.handleKeyDown = i.handleKeyDown.bind(i), i;
        }
        return inherits_inherits(NimblePicker, o.a.PureComponent), Dn(NimblePicker, [{
          key: "componentDidMount",
          value: function componentDidMount() {
            var e = this;
            this.state.firstRender && (this.testStickyPosition(), this.firstRenderTimeout = setTimeout(function () {
              e.setState({
                firstRender: !1
              });
            }, 60));
          }
        }, {
          key: "componentDidUpdate",
          value: function componentDidUpdate() {
            this.updateCategoriesSize(), this.handleScroll();
          }
        }, {
          key: "componentWillUnmount",
          value: function componentWillUnmount() {
            this.SEARCH_CATEGORY.emojis = null, clearTimeout(this.leaveTimeout), clearTimeout(this.firstRenderTimeout);
          }
        }, {
          key: "testStickyPosition",
          value: function testStickyPosition() {
            var e = document.createElement("div");
            ["", "-webkit-", "-ms-", "-moz-", "-o-"].forEach(function (i) {
              return e.style.position = i + "sticky";
            }), this.hasStickyPosition = !!e.style.position.length;
          }
        }, {
          key: "handleEmojiOver",
          value: function handleEmojiOver(e) {
            var i = this.preview;
            if (i) {
              var t = this.CUSTOM.filter(function (i) {
                return i.id === e.id;
              })[0];
              for (var a in t) {
                t.hasOwnProperty(a) && (e[a] = t[a]);
              }
              i.setState({
                emoji: e
              }), clearTimeout(this.leaveTimeout);
            }
          }
        }, {
          key: "handleEmojiLeave",
          value: function handleEmojiLeave(e) {
            var i = this.preview;
            i && (this.leaveTimeout = setTimeout(function () {
              i.setState({
                emoji: null
              });
            }, 16));
          }
        }, {
          key: "handleEmojiClick",
          value: function handleEmojiClick(e, i) {
            this.props.onClick(e, i), this.handleEmojiSelect(e);
          }
        }, {
          key: "handleEmojiSelect",
          value: function handleEmojiSelect(e) {
            var i = this;
            this.props.onSelect(e), this.hideRecent || this.props.recent || eo.add(e);
            var t = this.categoryRefs["category-1"];
            if (t) {
              var a = t.maxMargin;
              t.forceUpdate(), window.requestAnimationFrame(function () {
                i.scroll && (t.memoizeSize(), a != t.maxMargin && (i.updateCategoriesSize(), i.handleScrollPaint(), i.SEARCH_CATEGORY.emojis && t.updateDisplay("none")));
              });
            }
          }
        }, {
          key: "handleScroll",
          value: function handleScroll() {
            this.waitingForPaint || (this.waitingForPaint = !0, window.requestAnimationFrame(this.handleScrollPaint));
          }
        }, {
          key: "handleScrollPaint",
          value: function handleScrollPaint() {
            if (this.waitingForPaint = !1, this.scroll) {
              var e = null;
              if (this.SEARCH_CATEGORY.emojis) e = this.SEARCH_CATEGORY;else {
                for (var i = this.scroll.scrollTop, t = i > (this.scrollTop || 0), a = 0, n = 0, o = this.categories.length; n < o; n++) {
                  var r = t ? this.categories.length - 1 - n : n,
                    s = this.categories[r],
                    _ = this.categoryRefs["category-" + r];
                  if (_) {
                    var l = _.handleScroll(i);
                    (!a || _.top < a) && _.top > 0 && (a = _.top), l && !e && (e = s);
                  }
                }
                i < a ? e = this.categories.filter(function (e) {
                  return !(!1 === e.anchor);
                })[0] : i + this.clientHeight >= this.scrollHeight && (e = this.categories[this.categories.length - 1]);
              }
              if (e) {
                var g = this.anchors,
                  f = e.name;
                g.state.selected != f && g.setState({
                  selected: f
                });
              }
              this.scrollTop = i;
            }
          }
        }, {
          key: "handleSearch",
          value: function handleSearch(e) {
            this.SEARCH_CATEGORY.emojis = e;
            for (var i = 0, t = this.categories.length; i < t; i++) {
              var a = this.categoryRefs["category-" + i];
              if (a && "Search" != a.props.name) {
                var n = e ? "none" : "inherit";
                a.updateDisplay(n);
              }
            }
            this.forceUpdate(), this.scroll && (this.scroll.scrollTop = 0), this.handleScroll();
          }
        }, {
          key: "handleAnchorClick",
          value: function handleAnchorClick(e, i) {
            var t,
              a = this.categoryRefs["category-" + i],
              n = this.scroll;
            this.anchors;
            t = function scrollToComponent() {
              if (a) {
                var i = a.top;
                e.first ? i = 0 : i += 1, n.scrollTop = i;
              }
            }, this.SEARCH_CATEGORY.emojis ? (this.handleSearch(null), this.search.clear(), window.requestAnimationFrame(t)) : t();
          }
        }, {
          key: "handleSkinChange",
          value: function handleSkinChange(e) {
            var i = {
                skin: e
              },
              t = this.props.onSkinChange;
            this.setState(i), Jn.update(i), t(e);
          }
        }, {
          key: "handleKeyDown",
          value: function handleKeyDown(e) {
            var i = !1;
            switch (e.keyCode) {
              case 13:
                var t = void 0;
                this.SEARCH_CATEGORY.emojis && this.SEARCH_CATEGORY.emojis.length && (t = getSanitizedData(this.SEARCH_CATEGORY.emojis[0], this.state.skin, this.props.set, this.props.data)) && (this.handleEmojiSelect(t), i = !0);
            }
            i && e.preventDefault();
          }
        }, {
          key: "updateCategoriesSize",
          value: function updateCategoriesSize() {
            for (var e = 0, i = this.categories.length; e < i; e++) {
              var t = this.categoryRefs["category-" + e];
              t && t.memoizeSize();
            }
            if (this.scroll) {
              var a = this.scroll;
              this.scrollHeight = a.scrollHeight, this.clientHeight = a.clientHeight;
            }
          }
        }, {
          key: "getCategories",
          value: function getCategories() {
            return this.state.firstRender ? this.categories.slice(0, 3) : this.categories;
          }
        }, {
          key: "setAnchorsRef",
          value: function setAnchorsRef(e) {
            this.anchors = e;
          }
        }, {
          key: "setSearchRef",
          value: function setSearchRef(e) {
            this.search = e;
          }
        }, {
          key: "setPreviewRef",
          value: function setPreviewRef(e) {
            this.preview = e;
          }
        }, {
          key: "setScrollRef",
          value: function setScrollRef(e) {
            this.scroll = e;
          }
        }, {
          key: "setCategoryRef",
          value: function setCategoryRef(e, i) {
            this.categoryRefs || (this.categoryRefs = {}), this.categoryRefs[e] = i;
          }
        }, {
          key: "render",
          value: function render() {
            var e = this,
              i = this.props,
              t = i.perLine,
              a = i.emojiSize,
              n = i.set,
              r = i.sheetSize,
              s = i.sheetColumns,
              _ = i.sheetRows,
              l = i.style,
              g = i.title,
              f = i.emoji,
              h = i.color,
              d = i.native,
              m = i.backgroundImageFn,
              u = i.emojisToShowFilter,
              c = i.showPreview,
              F = i.showSkinTones,
              p = i.emojiTooltip,
              b = i.include,
              y = i.exclude,
              k = i.recent,
              v = i.autoFocus,
              w = i.skinEmoji,
              E = i.notFound,
              A = i.notFoundEmoji,
              j = i.darkMode,
              x = this.state.skin,
              C = t * (a + 12) + 12 + 2 + function measureScrollbar() {
                if ("undefined" == typeof document) return 0;
                var e = document.createElement("div");
                e.style.width = "100px", e.style.height = "100px", e.style.overflow = "scroll", e.style.position = "absolute", e.style.top = "-9999px", document.body.appendChild(e);
                var i = e.offsetWidth - e.clientWidth;
                return document.body.removeChild(e), i;
              }();
            return o.a.createElement("section", {
              style: io({
                width: C
              }, l),
              className: "emoji-mart " + (j ? "emoji-mart-dark" : ""),
              "aria-label": g,
              onKeyDown: this.handleKeyDown
            }, o.a.createElement("div", {
              className: "emoji-mart-bar"
            }, o.a.createElement(mo, {
              ref: this.setAnchorsRef,
              data: this.data,
              i18n: this.i18n,
              color: h,
              categories: this.categories,
              onAnchorClick: this.handleAnchorClick,
              icons: this.icons
            })), o.a.createElement(Po, {
              ref: this.setSearchRef,
              onSearch: this.handleSearch,
              data: this.data,
              i18n: this.i18n,
              emojisToShowFilter: u,
              include: b,
              exclude: y,
              custom: this.CUSTOM,
              autoFocus: v
            }), o.a.createElement("div", {
              ref: this.setScrollRef,
              className: "emoji-mart-scroll",
              onScroll: this.handleScroll
            }, this.getCategories().map(function (i, l) {
              return o.a.createElement(jo, {
                ref: e.setCategoryRef.bind(e, "category-" + l),
                key: i.name,
                id: i.id,
                name: i.name,
                emojis: i.emojis,
                perLine: t,
                native: d,
                hasStickyPosition: e.hasStickyPosition,
                data: e.data,
                i18n: e.i18n,
                recent: i.id == e.RECENT_CATEGORY.id ? k : void 0,
                custom: i.id == e.RECENT_CATEGORY.id ? e.CUSTOM : void 0,
                emojiProps: {
                  native: d,
                  skin: x,
                  size: a,
                  set: n,
                  sheetSize: r,
                  sheetColumns: s,
                  sheetRows: _,
                  forceSize: d,
                  tooltip: p,
                  backgroundImageFn: m,
                  onOver: e.handleEmojiOver,
                  onLeave: e.handleEmojiLeave,
                  onClick: e.handleEmojiClick
                },
                notFound: E,
                notFoundEmoji: A
              });
            })), (c || F) && o.a.createElement("div", {
              className: "emoji-mart-bar"
            }, o.a.createElement(To, {
              ref: this.setPreviewRef,
              data: this.data,
              title: g,
              emoji: f,
              showSkinTones: F,
              showPreview: c,
              emojiProps: {
                native: d,
                size: 38,
                skin: x,
                set: n,
                sheetSize: r,
                sheetColumns: s,
                sheetRows: _,
                backgroundImageFn: m
              },
              skinsProps: {
                skin: x,
                onChange: this.handleSkinChange,
                skinEmoji: w
              },
              i18n: this.i18n
            })));
          }
        }], [{
          key: "getDerivedStateFromProps",
          value: function getDerivedStateFromProps(e, i) {
            return e.skin ? io({}, i, {
              skin: e.skin
            }) : e.defaultSkin && !Jn.get("skin") ? io({}, i, {
              skin: e.defaultSkin
            }) : i;
          }
        }]), NimblePicker;
      }(),
      zo = Ro;
    Ro.propTypes = io({}, fo, {
      data: f.a.object.isRequired
    }), Ro.defaultProps = io({}, co);
    var Lo = function (e) {
        function Picker() {
          return xn(this, Picker), possibleConstructorReturn_possibleConstructorReturn(this, (Picker.__proto__ || to(Picker)).apply(this, arguments));
        }
        return inherits_inherits(Picker, o.a.PureComponent), Dn(Picker, [{
          key: "render",
          value: function render() {
            return o.a.createElement(zo, io({}, this.props, this.state));
          }
        }]), Picker;
      }(),
      Wo = Lo;
    Lo.propTypes = fo, Lo.defaultProps = io({}, co, {
      data: jn
    });
    var Uo = function Emoji(e) {
      for (var i in Emoji.defaultProps) {
        void 0 == e[i] && void 0 != Emoji.defaultProps[i] && (e[i] = Emoji.defaultProps[i]);
      }
      return vo(io({}, e));
    };
    Uo.propTypes = go, Uo.defaultProps = io({}, uo, {
      data: jn
    });
    t(293);
    var Ko = /*#__PURE__*/function (_n$Component5) {
      _inherits2(EmojiPlugin_EmojiPlugin, _n$Component5);
      var _super5 = _createSuper(EmojiPlugin_EmojiPlugin);
      function EmojiPlugin_EmojiPlugin(e) {
        var _this6;
        _classCallCheck2(this, EmojiPlugin_EmojiPlugin);
        _this6 = _super5.call(this, e), _this6.addEmoji = function (e) {
          _this6.setState({
            selected: e.native
          }, _this6.insertItem);
        }, _this6.onClickOutside = function () {
          (0, _this6.props.dismiss)();
        }, _this6.insertItem = function () {
          (0, _this6.props.onChange)(_this6.state.selected);
        }, _this6.state = {
          selected: null
        };
        return _this6;
      }
      _createClass(EmojiPlugin_EmojiPlugin, [{
        key: "render",
        value: function render() {
          return o.a.createElement("div", {
            className: "toolbar-menu-popover toolbar-menu-popover--emoji"
          }, o.a.createElement("div", {
            className: "toolbar-menu-popover--container"
          }, o.a.createElement(Wo, {
            onSelect: this.addEmoji,
            title: "",
            emoji: "",
            style: {
              width: "100%",
              fontFamily: "var(--main-font-family)",
              color: "var(--main-navy-extra-dark)"
            }
          })));
        }
      }]);
      return EmojiPlugin_EmojiPlugin;
    }(n.Component);
    var Ho = /*#__PURE__*/function (_n$Component6) {
      _inherits2(LinkPlugin_LinkCreator, _n$Component6);
      var _super6 = _createSuper(LinkPlugin_LinkCreator);
      function LinkPlugin_LinkCreator(e) {
        var _this7;
        _classCallCheck2(this, LinkPlugin_LinkCreator);
        _this7 = _super6.call(this, e), _this7.startsWithProtocol = function (e) {
          return ["http", "https", "tel", "tcp", "file", "mailto"].some(function (i) {
            return e && e.startsWith(i);
          });
        }, _this7.isProtocolRelative = function (e) {
          return e && e.startsWith("//");
        }, _this7.isPersonalizationTag = function (e) {
          return e && e.startsWith("{{");
        }, _this7.getNodeHref = function (e) {
          return e.getInlinesByType("link").toJS().map(function (e) {
            return e.data.href;
          })[0];
        }, _this7.getCleanPersonalizationTagLink = function (e) {
          return e.replace(/"/g, "'");
        }, _this7.ensureProtocol = function (e) {
          return _this7.startsWithProtocol(e) || _this7.isProtocolRelative(e) ? e : _this7.isPersonalizationTag(e) ? _this7.getCleanPersonalizationTagLink(e) : "http://".concat(e);
        }, _this7.insertLink = function () {
          var e = _this7.state,
            i = e.text,
            t = e.href;
          (0, _this7.props.onChange)({
            object: "inline",
            type: "link",
            data: {
              href: _this7.ensureProtocol(t),
              target: "_blank"
            },
            nodes: [{
              object: "text",
              leaves: [{
                text: i
              }]
            }]
          });
        }, _this7.state = {
          href: _this7.getNodeHref(e.documentNode),
          text: e.documentNode.text
        };
        return _this7;
      }
      _createClass(LinkPlugin_LinkCreator, [{
        key: "render",
        value: function render() {
          var _this8 = this;
          var e = this.state,
            i = e.text,
            t = e.href,
            a = this.props.onClickOutside;
          return o.a.createElement(pa.Div, {
            className: "toolbar-menu-popover toolbar-menu-popover--link"
          }, o.a.createElement(pa.Div, {
            className: "toolbar-menu-popover--container"
          }, o.a.createElement(pa.Div, {
            className: "toolbar-menu-popover--header"
          }, o.a.createElement(pa.H4, null, "Insert a link")), o.a.createElement(pa.Div, {
            className: "toolbar-menu-popover-container--link"
          }, o.a.createElement(pa.Input, {
            type: "text",
            value: i,
            label: "Text",
            className: "link-popover-text-input",
            autoFocus: !0,
            placeholder: "Enter display text",
            onChange: function onChange(e) {
              return _this8.setState({
                text: e.target.value
              });
            }
          }), o.a.createElement(pa.Input, {
            type: "text",
            value: t,
            label: "Link",
            className: "link-popover-link-input",
            placeholder: "Paste a link",
            onChange: function onChange(e) {
              return _this8.setState({
                href: e.target.value
              });
            }
          }), o.a.createElement(pa.Div, null, o.a.createElement(pa.Button, {
            type: "primary",
            className: "driftiwyg-toolbar--insert-button",
            onClick: this.insertLink,
            disabled: !(i && t)
          }, "Insert"), o.a.createElement(pa.Button, {
            type: "tertiary",
            onClick: a
          }, "Cancel")))));
        }
      }]);
      return LinkPlugin_LinkCreator;
    }(n.Component);
    t(295);
    var Vo = function Vo(e, i, t) {
      var a;
      return function () {
        for (var _len2 = arguments.length, n = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          n[_key2] = arguments[_key2];
        }
        var o = t && !a;
        clearTimeout(a), a = setTimeout(function later() {
          a = null, t || e.apply(void 0, n);
        }, i), o && e.apply(void 0, n);
      };
    };
    t(297);
    var Jo = /*#__PURE__*/function (_n$Component7) {
      _inherits2(ResizeImageMenu_ResizeImageMenu, _n$Component7);
      var _super7 = _createSuper(ResizeImageMenu_ResizeImageMenu);
      function ResizeImageMenu_ResizeImageMenu(e) {
        var _this9;
        _classCallCheck2(this, ResizeImageMenu_ResizeImageMenu);
        _this9 = _super7.call(this, e), _this9.recalculatePositions = function () {
          var e = _this9.props.getImageXPosition(),
            i = _this9.props.getImageYPosition();
          _this9.setState({
            imageXPosition: e,
            imageYPosition: i
          });
        }, _this9.insertNode = function (e) {
          var i = _this9.props,
            t = i.value,
            a = i.node,
            n = {
              object: "block",
              type: "image",
              data: e
            };
          (0, i.onChange)(t.change().setNodeByKey(a.key, n));
        }, _this9.onChangeAltText = Vo(function () {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
          var i = _this9.props,
            t = i.node,
            a = i.value,
            n = i.onChange,
            o = _this9.state,
            r = o.imageHeight,
            s = o.imageWidth,
            _ = {
              object: "block",
              type: "image",
              data: {
                src: t.data.toJSON().src,
                height: r,
                width: s,
                alt: e
              }
            },
            l = a.change().setNodeByKey(t.key, _).unwrapBlockByKey(t.key, "link"),
            g = l.unwrapBlockByKey(t.key, "division");
          e && (g.wrapBlock({
            object: "block",
            type: "division"
          }), l.wrapBlockByKey(t.key, {
            object: "block",
            type: "link",
            data: {
              href: e,
              target: "_blank"
            }
          })), n(l);
        }, 750), _this9.onChangeWidthOrHeight = function (_ref10) {
          var _ref10$newWidth = _ref10.newWidth,
            e = _ref10$newWidth === void 0 ? 0 : _ref10$newWidth,
            _ref10$newHeight = _ref10.newHeight,
            i = _ref10$newHeight === void 0 ? 0 : _ref10$newHeight;
          var t = _this9.props.node,
            a = _this9.state.heightToWidthRatio,
            n = t.data.toJSON(),
            o = {
              src: n.src,
              alt: n.alt
            };
          i > 0 ? (o.height = i, e = i / a) : e > 0 && (o.width = e, i = a * e), _this9.insertNode(o), _this9.setState({
            imageHeight: i,
            imageWidth: e
          }, _this9.recalculatePositions);
        }, _this9.state = {
          imageAltText: e.imageAltText,
          imageHeight: e.imageHeight,
          imageWidth: e.imageWidth,
          heightToWidthRatio: e.imageHeight / e.imageWidth,
          imageYPosition: e.getImageYPosition(),
          imageXPosition: e.getImageXPosition()
        };
        return _this9;
      }
      _createClass(ResizeImageMenu_ResizeImageMenu, [{
        key: "render",
        value: function render() {
          var _this10 = this;
          var e = this.state,
            i = e.imageAltText,
            t = e.imageHeight,
            a = e.imageWidth,
            n = e.imageYPosition,
            r = e.imageXPosition;
          return o.a.createElement(pa.Div, {
            className: "resizable-inputs-wrapper",
            style: {
              left: "".concat(r, "px"),
              top: "".concat(n + Number(t), "px")
            }
          }, o.a.createElement(pa.Div, {
            className: "resizable-inputs-wrapper-row"
          }, o.a.createElement(pa.Label, null, "Width"), o.a.createElement(pa.Input, {
            className: "image-resize-input",
            onChange: function onChange(e) {
              return _this10.onChangeWidthOrHeight({
                newWidth: e.target.value
              });
            },
            type: "number",
            value: a,
            inline: !0,
            placeholder: "default"
          }), o.a.createElement(pa.Div, {
            className: "width-input-unit"
          }, "px"), o.a.createElement(pa.Label, null, "Height"), o.a.createElement(pa.Input, {
            className: "image-resize-input",
            onChange: function onChange(e) {
              return _this10.onChangeWidthOrHeight({
                newHeight: e.target.value
              });
            },
            type: "number",
            value: t,
            inline: !0,
            placeholder: "default"
          }), "px"), o.a.createElement(pa.Input, {
            label: "Link",
            className: "alt-text-input",
            onChange: function onChange(e) {
              _this10.setState({
                imageAltText: e.target.value
              }), _this10.onChangeAltText(e.target.value);
            },
            type: "text",
            value: i,
            placeholder: "Type or paste a link"
          }));
        }
      }]);
      return ResizeImageMenu_ResizeImageMenu;
    }(n.Component);
    var $o = Ba()(Jo),
      Go = {
        bold: {
          name: "Bold",
          type: "mark"
        },
        underlined: {
          name: "Underline",
          type: "mark"
        },
        italic: {
          name: "Italic",
          type: "mark"
        },
        "numbered-list": {
          name: "Numbered List",
          type: "block"
        },
        "bulleted-list": {
          name: "Bulleted List",
          type: "block"
        },
        link: {
          name: "Link",
          type: "content"
        },
        emoji: {
          name: "Emoji",
          type: "content"
        },
        image: {
          name: "Image",
          type: "content"
        },
        tag: {
          name: "Personalization",
          type: "drift"
        },
        custom: {
          name: "Custom",
          type: "custom"
        }
      },
      Yo = [{
        label: "New email thread",
        value: !1
      }, {
        label: "Threaded reply",
        value: !0
      }],
      Xo = [{
        label: Ta,
        value: Oa.TEAMMATE
      }, {
        label: Ia,
        value: Oa.ROUND_ROBIN
      }, {
        label: Na,
        value: Oa.LEAD_OWNER
      }],
      Zo = (_Zo = {}, _defineProperty2(_Zo, Oa.TEAMMATE, Xo[0]), _defineProperty2(_Zo, Oa.ROUND_ROBIN, Xo[1]), _defineProperty2(_Zo, Oa.LEAD_OWNER, Xo[2]), _defineProperty2(_Zo, "null", null), _Zo),
      Qo = new Ca({
        rules: nn
      }),
      er = new Ca({
        rules: on
      }),
      ir = {
        image: Ba()(An),
        emoji: Ba()(Ko),
        tag: Ba()(fn),
        link: Ba()(Ho)
      },
      tr = Object(rn.isKeyHotkey)("mod+b"),
      ar = Object(rn.isKeyHotkey)("mod+i"),
      nr = Object(rn.isKeyHotkey)("mod+u"),
      or = Object(rn.isKeyHotkey)("mod+`");
    var rr = /*#__PURE__*/function (_n$Component8) {
      _inherits2(SlateEditor_SlateEditor, _n$Component8);
      var _super8 = _createSuper(SlateEditor_SlateEditor);
      function SlateEditor_SlateEditor(e) {
        var _this11;
        _classCallCheck2(this, SlateEditor_SlateEditor);
        _this11 = _super8.call(this, e), _this11.editorRef = Object(n.createRef)(), _this11.hasMark = function (e) {
          return _this11.state.value.activeMarks.some(function (i) {
            return i.type === e;
          });
        }, _this11.hasBlock = function (e) {
          return _this11.state.value.blocks.some(function (i) {
            return i.type === e;
          });
        }, _this11.onChange = function (_ref11) {
          var e = _ref11.value;
          _this11.setState({
            value: e
          }, _this11.updateParent);
        }, _this11.updateParent = function () {
          var e = _this11.state.value,
            i = _this11.props,
            t = i.onChange,
            a = i.editorState,
            n = i.emailBodyMode;
          var o = void 0 !== n && n ? er.serialize(e) : Qo.serialize(e);
          var r = (o = o.replace(/&quot;/g, '"').replace(/&#x27;/g, "'").replace(/&lt;/g, "<").replace(/&gt;/g, ">")).slice(0),
            s = !Object(Fa.equals)(r, a);
          "<p></p>" === o && (o = ""), o = o.replace(/<div>\s*<\/div>/g, "<br/>").replace(/<p>\s*<\/p>/g, "<br/>").replace(/<[^/>(img)\s=][^>]*><\/[^>]+>/, ""), s && t(o);
        }, _this11.onKeyDown = function (e, i) {
          var t;
          if (tr(e)) t = "bold";else if (ar(e)) t = "italic";else if (nr(e)) t = "underlined";else {
            if (!or(e)) return;
            t = "code";
          }
          return e.preventDefault(), i.toggleMark(t), !0;
        }, _this11.onClickMark = function (e, i) {
          e.preventDefault();
          var t = _this11.state.value.change().toggleMark(i);
          _this11.onChange(t);
        }, _this11.onClickBlock = function (e, i) {
          e.preventDefault();
          var t = _this11.state.value,
            a = _this11.props.emailBodyMode,
            n = t.change(),
            o = t.document,
            r = a ? "division" : "paragraph";
          if ("bulleted-list" !== i && "numbered-list" !== i) {
            var _e2 = _this11.hasBlock(i);
            _this11.hasBlock("list-item") ? n.setBlocks(_e2 ? r : i).unwrapBlock("bulleted-list").unwrapBlock("numbered-list") : n.setBlocks(_e2 ? r : i);
          } else {
            var _e3 = _this11.hasBlock("list-item"),
              _a2 = t.blocks.some(function (e) {
                return !!o.getClosest(e.key, function (e) {
                  return e.type === i;
                });
              });
            _e3 && _a2 ? n.setBlocks(r).unwrapBlock("bulleted-list").unwrapBlock("numbered-list") : _e3 ? n.unwrapBlock("bulleted-list" === i ? "numbered-list" : "bulleted-list").wrapBlock(i) : n.setBlocks("list-item").wrapBlock(i);
          }
          _this11.onChange(n);
        }, _this11.insertImageBlock = function (e, i) {
          var t = _this11.state.value.change().insertBlock(e);
          if (i) {
            var _e4 = t.wrapBlock({
              object: "block",
              type: "division"
            }).wrapBlock({
              object: "block",
              type: "link",
              data: {
                href: i,
                target: "_blank"
              }
            });
            _this11.onChange(_e4);
          } else _this11.onChange(t);
          _this11.dismissPopover();
        }, _this11.insertBlock = function (e) {
          var i = _this11.state.value.change();
          i.insertBlock(e), _this11.onChange(i), _this11.dismissPopover();
        }, _this11.insertInline = function (e) {
          var i = _this11.state.value.change();
          i.insertInline(e), _this11.onChange(i), _this11.dismissPopover();
        }, _this11.insertText = function (e) {
          var i = _this11.state.value.change();
          i.insertText(e), _this11.onChange(i), _this11.dismissPopover();
        }, _this11.openPopover = function (e) {
          var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          _this11.setState(function (t) {
            return {
              popoverOpen: !t.popoverOpen,
              popoverType: e,
              customPopoverIndex: i
            };
          });
        }, _this11.dismissPopover = function () {
          _this11.setState({
            popoverOpen: !1,
            popoverType: null,
            customPopoverIndex: null
          });
        }, _this11.renderToolbar = function () {
          var e = _this11.props,
            i = e.toolbarOptions,
            t = void 0 === i ? Object.keys(Go) : i,
            a = e.readOnly,
            n = e.customToolbarOptions;
          return o.a.createElement("div", {
            className: s()("driftiwyg-slate-editor-menu toolbar-menu", {
              "read-only": a
            })
          }, o.a.createElement("div", {
            className: "driftiwyg-toolbar-button-group-container"
          }, _this11.renderTooltipButton({
            type: "bold",
            icon: "bold",
            toolbarOptions: t
          }), _this11.renderTooltipButton({
            type: "italic",
            icon: "text-italic",
            toolbarOptions: t
          }), _this11.renderTooltipButton({
            type: "underlined",
            icon: "underline",
            toolbarOptions: t
          })), o.a.createElement("div", {
            className: "driftiwyg-toolbar-button-group-container"
          }, _this11.renderTooltipButton({
            type: "numbered-list",
            icon: "list-numbers",
            toolbarOptions: t
          }), _this11.renderTooltipButton({
            type: "bulleted-list",
            icon: "list-bullets",
            toolbarOptions: t
          })), o.a.createElement("div", {
            className: "driftiwyg-toolbar-button-group-container"
          }, _this11.renderTooltipButtonWithPopover({
            type: "link",
            icon: "link-1",
            toolbarOptions: t
          }), _this11.renderTooltipButtonWithPopover({
            type: "emoji",
            icon: "emoji-face",
            toolbarOptions: t
          }), _this11.renderTooltipButtonWithPopover({
            type: "image",
            icon: "photo",
            toolbarOptions: t
          })), o.a.createElement("div", {
            className: "driftiwyg-toolbar-button-group-container"
          }, _this11.renderTooltipButtonWithPopover({
            type: "tag",
            icon: "shopping-tag",
            toolbarOptions: t
          }), n && n.length > 0 && n.map(function (_ref12, i) {
            var e = _ref12.icon;
            return o.a.createElement("span", {
              key: i
            }, _this11.renderTooltipButtonWithPopover({
              type: "custom",
              icon: e,
              toolbarOptions: t,
              customIndex: i
            }));
          })));
        }, _this11.renderSubjectInput = function () {
          var e = _this11.props,
            i = e.onSubjectChange,
            t = e.subjectValue,
            a = e.isThreaded;
          return o.a.createElement(Ra, {
            label: "Subject",
            value: t,
            onChange: function onChange(e) {
              return i(e.target.value);
            },
            placeholder: "Add a subject line",
            disabled: a
          });
        }, _this11.renderThreadedSelect = function () {
          var e = _this11.props,
            i = e.isThreaded,
            t = e.onThreadedChange,
            a = i ? Yo[1] : Yo[0];
          return o.a.createElement(Ma, {
            label: qa.THREAD,
            onChange: t,
            value: a,
            placeholder: "",
            options: Yo
          });
        }, _this11.renderCcSelect = function () {
          var e = _this11.props,
            i = e.ccValue,
            t = e.onCcChange,
            a = e.onFallbackChange,
            r = e.fallbackValue,
            s = e.onTeammateChange,
            _ = e.teammateValues,
            l = e.onLeadOwnerFieldChange,
            g = e.leadOwnerField,
            f = e.leadOwnerFieldOptions;
          return o.a.createElement(n.Fragment, null, o.a.createElement(Ma, {
            placeholder: "Select a cc source",
            label: qa.CC,
            isClearable: !0,
            onChange: t,
            value: Zo[i],
            options: Xo
          }), i === Oa.LEAD_OWNER && l && o.a.createElement(Ma, {
            placeholder: "Select a field",
            label: qa.FIELD,
            isClearable: !0,
            onChange: l,
            value: g,
            options: f
          }), i === Oa.LEAD_OWNER && a && o.a.createElement(Ra, {
            label: Pa.FALLBACK,
            value: r,
            onChange: function onChange(e) {
              return a(e.target.value);
            },
            placeholder: "Add an email"
          }), i === Oa.TEAMMATE && s && o.a.createElement(za, {
            label: "Teammate",
            values: _,
            onChange: function onChange(_ref13) {
              var e = _ref13.values;
              return s(e);
            },
            placeholder: "Add one or more emails, separated by commas"
          }));
        }, _this11.renderResizeImageMenu = function () {
          var e = _this11.state,
            i = e.value,
            t = e.focusedImageNode,
            a = _this11.editorRef.current.querySelector('img[data-key="'.concat(t.key, '"]'));
          if (a) return a.className = "resizable-image focused", o.a.createElement($o, {
            value: i,
            onClickOutside: function onClickOutside() {
              _this11.setState({
                focusedImageNode: null
              }), a.className = "resizable-image";
            },
            node: t,
            onChange: _this11.onChange,
            imageAltText: a.alt,
            imageHeight: a.offsetHeight - 4,
            imageWidth: a.offsetWidth - 4,
            getImageXPosition: function getImageXPosition() {
              return a.x;
            },
            getImageYPosition: function getImageYPosition() {
              return a.y + 4;
            }
          });
        }, _this11.renderTooltipButton = function (_ref14) {
          var e = _ref14.type,
            i = _ref14.icon,
            t = _ref14.toolbarOptions;
          if (!t.includes(e)) return;
          var a = Go[e],
            n = "block" === a.type,
            r = n ? _this11.hasBlock(e) : _this11.hasMark(e),
            _ = n ? function (i) {
              return _this11.onClickBlock(i, e);
            } : function (i) {
              return _this11.onClickMark(i, e);
            },
            l = _this11.props.readOnly ? function () {} : _;
          return o.a.createElement(pa.ToolTip, {
            component: o.a.createElement("div", null, a.name),
            flow: "up",
            className: s()("driftiwyg-toolbar-button-container", "driftiwyg-toolbar-button-container--".concat(a.type))
          }, o.a.createElement("div", {
            className: s()("driftiwyg-toolbar-button", {
              "driftiwyg-toolbar-button--active": r
            }),
            onMouseDown: l instanceof Function ? l : void 0,
            "data-active": r
          }, o.a.createElement(ba.Icon, {
            name: i,
            width: 15,
            height: 15
          })));
        }, _this11.renderTooltipButtonWithPopover = function (_ref15) {
          var e = _ref15.type,
            i = _ref15.icon,
            t = _ref15.toolbarOptions,
            a = _ref15.customIndex;
          var n = _this11.props.customToolbarOptions,
            r = _this11.state.customPopoverIndex,
            _ = Object(Fa.pathOr)(null, [a, "name"], n),
            l = Object(Fa.pathOr)(null, [a, "component"], n);
          if (!t.includes(e)) return;
          var g = Go[e];
          "custom" === e && _ && (g.name = _);
          var f = _this11.state,
            h = f.popoverOpen,
            d = f.popoverType,
            m = f.value,
            u = _this11.props,
            c = u.hasDemandbaseEnabled,
            F = void 0 !== c && c,
            p = u.meetingTagList,
            b = u.userTagList,
            y = u.companyTagList,
            k = u.teammateTagList,
            v = u.driftIntelTagList,
            w = u.handleImageUpload,
            E = "custom" === e && l ? Ba()(l) : ir[e],
            A = "tag" === e ? {
              hasDemandbaseEnabled: F,
              meetingTagList: p,
              userTagList: b,
              companyTagList: y,
              teammateTagList: k,
              driftIntelTagList: v
            } : {},
            j = "image" === e ? {
              handleImageUpload: w
            } : {},
            x = h && d === e && ("custom" === e && a === r || "custom" !== e);
          return o.a.createElement("span", {
            className: s()("driftiwyg-toolbar-popover-button-container")
          }, o.a.createElement(pa.ToolTip, {
            component: o.a.createElement("div", null, g.name),
            flow: "up",
            className: "driftiwyg-toolbar-popover-button-container"
          }, o.a.createElement("div", {
            className: "driftiwyg-toolbar-button",
            onClick: function onClick() {
              return _this11.openPopover(e, a);
            }
          }, o.a.createElement(ba.Icon, {
            name: i,
            width: 15,
            height: 15
          }))), o.a.createElement("div", {
            id: "popover-container-".concat(e),
            className: "popover-position"
          }, !_this11.props.readOnly && x && o.a.createElement(E, Object.assign({
            documentNode: m.fragment,
            onClickOutside: _this11.dismissPopover,
            onChange: _this11[{
              emoji: "insertText",
              image: "insertImageBlock",
              link: "insertInline",
              tag: "insertInline",
              custom: "insertBlock"
            }[e]],
            options: {
              type: e
            }
          }, A, j))));
        }, _this11.renderEditor = function () {
          var e = _this11.props,
            i = e.autoFocus,
            t = void 0 === i || i,
            a = e.placeholder,
            n = e.emailBodyMode,
            r = e.readOnly;
          return o.a.createElement("div", {
            className: s()("driftiwyg-slate-editor", {
              "read-only": r
            }),
            ref: _this11.editorRef
          }, o.a.createElement(la, {
            placeholder: a,
            value: _this11.state.value,
            onChange: _this11.onChange,
            onKeyDown: _this11.onKeyDown,
            renderNode: _this11.renderNode,
            renderMark: _this11.renderMark,
            spellCheck: !0,
            schema: n ? Wa : La,
            autoFocus: t,
            readOnly: r
          }));
        }, _this11.setFocusedImage = function (e) {
          _this11.setState({
            focusedImageNode: e
          });
        }, _this11.renderNode = function (e) {
          var i = e.attributes,
            t = e.children,
            a = e.node,
            n = _this11.props.emailBodyMode;
          switch (a.type) {
            case "bulleted-list":
              return o.a.createElement("ul", i, t);
            case "list-item":
              return o.a.createElement("li", i, t);
            case "numbered-list":
              return o.a.createElement("ol", i, t);
            case "paragraph":
              return n ? o.a.createElement("div", i, t) : o.a.createElement("p", i, t);
            case "text-span":
              return o.a.createElement("span", Object.assign({}, a.data.toJSON(), i), t);
            case "link":
              return o.a.createElement(pa.ToolTip, {
                flow: "auto",
                tethered: !0,
                render: function render() {
                  return a.get("data").get("href") && o.a.createElement("div", null, a.get("data").get("href"));
                }
              }, o.a.createElement("a", Object.assign({}, a.data.toJSON(), i), t));
            case "image":
              return o.a.createElement("img", Object.assign({
                className: "resizable-image",
                alt: "",
                onClick: function onClick() {
                  return _this11.setFocusedImage(a);
                }
              }, a.data.toJSON(), i));
            default:
              return n ? o.a.createElement("div", null, t) : o.a.createElement("p", null, t);
          }
        }, _this11.renderMark = function (e) {
          var i = e.children,
            t = e.mark,
            a = e.attributes;
          switch (t.type) {
            case "bold":
              return o.a.createElement("strong", a, i);
            case "code":
              return o.a.createElement("code", a, i);
            case "italic":
              return o.a.createElement("em", a, i);
            case "underlined":
              return o.a.createElement("u", a, i);
            default:
              return o.a.createElement("span", null, i);
          }
        }, _this11.state = {
          value: e.emailBodyMode ? er.deserialize(e.editorState) : Qo.deserialize(e.editorState),
          rawValue: e.editorState,
          popoverOpen: !1,
          popoverType: null,
          customPopoverIndex: null,
          focusedImageNode: null
        };
        return _this11;
      }
      _createClass(SlateEditor_SlateEditor, [{
        key: "componentDidUpdate",
        value: function componentDidUpdate(e) {
          var i = this.props,
            t = i.editorState,
            a = i.emailBodyMode;
          Object(Fa.equals)(e.editorState, t) || this.setState({
            value: a ? er.deserialize(t) : Qo.deserialize(t),
            rawValue: t,
            popoverOpen: !1,
            popoverType: null
          });
        }
      }, {
        key: "render",
        value: function render() {
          var _s;
          var e = this.props,
            i = e.className,
            t = e.emailBodyMode,
            a = e.onSubjectChange,
            n = e.onThreadedChange,
            r = e.onCcChange,
            _ = this.state.focusedImageNode;
          return o.a.createElement("div", {
            className: s()((_s = {}, _defineProperty2(_s, i, !!i), _defineProperty2(_s, "email-body-mode", t), _s))
          }, t && n && this.renderThreadedSelect(), t && r && this.renderCcSelect(), t && a && this.renderSubjectInput(), this.renderToolbar(), this.renderEditor(), _ && this.renderResizeImageMenu());
        }
      }]);
      return SlateEditor_SlateEditor;
    }(n.Component);
    t.d(i, "Driftiwyg", function () {
      return rr;
    });
  }]);
});